const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Fundo do Tsukuyomi",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Falha ao publicar devido ao excesso de objetos de cenário. Apague alguns objetos e tente novamente.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Sem permissão para acessar recursos da assinatura no momento.",
  T_12_I_GIFT_SENDER_BELL: "Sino",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Agora você o vê, agora você vê mais. [FFB300] (esconde o capacete) [-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Barba do Velho",
  T_12_L_COS_PINKMAN: "Dino Rosa",
  T_12_L_COS_POLAR: "Urso Polar",
  T_12_L_COS_RENDER: "Dino Arco-íris",
  T_12_L_COS_TIGER: "Dino Tigre",
  T_12_L_MALE_BOTTOM_COS_ELF: "Elfo Nevado (Pernas)",
  T_12_L_MALE_COS_SANTA: "Velho Rabugento",
  T_12_L_MALE_HAIR_COS_ELF: "Elfo Nevado (Cabeça)",
  T_12_L_MALE_SHOE_COS_ELF: "Elfo Nevado (Calçado)",
  T_12_L_MALE_TOP_COS_ELF: "Elfo Nevado (Torso)",
  T_12_O_CAT_NAME: "Gatinho",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - Natalina",
  T_12_O_MACHETE_GOLD_NAME: "Machete - Lâmina Dourada",
  T_12_O_PET_TITLE: "PET",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Calçados de pulo",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Sapatos feitos com tecnologia moderna. Permite que os humanos realizem saltos duplos.",
  T_12_Q_ITEM_FLYSHOE: "Jet Pack Tênis",
  T_12_Q_ITEM_FLYSHOE_DESC: "Sapatos que permitem ao usuário voar. Tente não ficar sem combustível no ar.",
  T_12_Q_ITEM_STOCK1: "Coronha Nv. 1",
  T_12_Q_ITEM_STOCK2: "Coronha Nv. 2",
  T_12_Q_ITEM_STOCK3: "Coronha Nv. 3",
  T_12_Q_ITEM_TREATMENTGUN: "Pistola de Cura",
  T_12_Q_ITEM_VEST4: "Colete Nv. 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Dança do Tiro",
  T_12_R_EMOTE_WAVE_NAME: "Onda no Braço",
  T_12_R_SKILL_NAME_GANGLEADER: "Espírito dos gângsteres",
  T_12_R_SKILL_NAME_MONKEYGOD: "Ilusão",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Anfíbio",
  T_13_I_COLLECTION_V_JEEP: "Jipe",
  T_13_I_COLLECTION_V_MONSTER: "Caminhão Monstro",
  T_13_I_COLLECTION_V_MOTOBIKE: "Moto",
  T_13_I_COLLECTION_V_ROADSTER: "Carro Esportivo",
  T_13_I_COLLECTION_V_SUV: "Picape",
  T_13_I_COLLECTION_V_TUTU: "Tuc Tuc",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Azul Ártico",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Amor no Ar (Pernas)",
  T_13_L_MALE_HAIR_COS_BJD: "Azul Ártico",
  T_13_L_MALE_TOP_COS_VALENTINE: "Amor no Ar (Torso)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Arma",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Traje de Pet: Detetive Gatinho",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Cupido",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Tubarão Bebê",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Flexão",
  T_13_R_EMOTE_EGYPT_NAME: "Dança da Múmia",
  T_13_R_PVE_WEAPON_SLOT: "Espaço de arma",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Distância Efetiva",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Taxa de Tiro",
  T_13_R_SKILL_DESC_HACKERGIRL: "Marca os oponentes acertados por [FFB300]{0}s[-]. A informação é compartilhada com a equipe.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Olho Hacker",
  T_13_Z_KICKOFF_BAN: "BAN",
  T_13_Z_ROOM_MORNING: "Dia",
  T_13_Z_ROOM_NIGHT: "Noite",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "Avatar SPLASH!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Coelho Quadrado",
  T_14_L_COS_EASTER: "Observador 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Dama do Fogo (Calçado)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Coelho Guerreiro (máscara)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - Balão d'Água",
  T_14_O_DOG_NAME: "Cachorro Mecânico",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Traje de Pet: Cachorro de Aço",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Traje do Pet: Cachorro Relâmpago",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Traje de Pet: Cachorro Magnético",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Traje de Pet: Gato Noturno",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Lua Sangrenta",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Ataque do Tubarão",
  T_14_Q_ITEM_RGS50: "RGS-50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Para cada perda de [FFB300]{0}%[-] de vida, a penetração de armadura aumenta em [FFB300]{1}%[-]",
  T_14_R_SKILL_NAME_SAMURAI: "Bushido",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Miséria (máscara)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Toque Mortal (máscara)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Miséria (Pernas)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Toque Mortal (Pernas)",
  T_15_L_MALE_SHOE_COS_FAIM: "Miséria (Calçado)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Toque Mortal (Calçado)",
  T_15_L_MALE_TOP_COS_FAIM: "Miséria (Torso)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Toque Mortal (Torso)",
  T_15_L_TOP_COS_MOTHERSDAY: "Melhor Mãe",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Cataclismo",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Bastão - O Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Cataclismo",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Cataclismo",
  T_15_O_PANTHER_NAME: "Pantera Noturna",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Traje de Pet: Capitão",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Traje de Pet: Leopardo Dourado",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Traje de Pet: Ameaça Roxa",
  T_15_O_SKS_DEATH_NAME: "SKS - Desejo Mortal",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Cataclismo",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "METRALHADORA",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Agite comigo",
  T_15_R_SKILL_DESC_AGENT: "Aumenta em [FFB300]{0}%[-] a precisão ao mirar.",
  T_15_R_SKILL_NAME_AGENT: "Atiradora Afiada",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Mochila - Asas Roxas",
  T_16_B_ITEM_GRAPPLINGHOOK: "Gancho",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Lança Gancho",
  T_16_L_MALE_COS_LEGO: "Tijolinho",
  T_16_L_MALE_SHOE_COS_SUMMER: "Garoto em Luau (Calçado)",
  T_16_P_MANUAL_MONSTER: "Caminhão Monstro",
  T_16_P_MANUAL_MUSHROOM1: "Cogumelo Nv. 1",
  T_16_P_MANUAL_MUSHROOM2: "Cogumelo Nv. 2",
  T_16_P_MANUAL_MUSHROOM3: "Cogumelo Nv. 3",
  T_16_P_MANUAL_MUSHROOM4: "Cogumelo Nv. 4",
  T_16_P_MANUAL_ROADSTER_DESC: "Carro esportivo elegante. Baixa Armadura, mas bastante veloz. Pode transportar até 2 sobreviventes.",
  T_16_P_MANUAL_STROP: "Tirolesa",
  T_16_P_MANUAL_SUV: "Picape",
  T_16_P_MANUAL_SUV_DESC: "Veículo padrão do Free Fire. Armadura média e velocidade máxima. Pode transportar até 2 sobreviventes.",
  T_16_P_MANUAL_TUTU_DESC: "Um veículo com baixo Armadura e movimento lento. Pode transportar até 3 sobreviventes.",
  T_16_P_MANUAL_WEAPON_AR: "Rifle",
  T_16_P_MANUAL_WEAPON_BOMB: "Granadas",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistola",
  T_16_P_MANUAL_WEAPON_SG: "Espingarda",
  T_16_P_MANUAL_WEAPON_SMG: "Submetralhadora",
  T_16_P_MANUAL_WEAPON_SR: "Fuzil de Precisão",
  T_16_Q_MINISENTRY: "Mini Torreta",
  T_16_Q_MINISENTRY_DESC: "Torre automática feita de tecnologia moderna. Ele fará uma varredura e atacará os oponentes próximos.",
  T_16_R_EMOTE_DESERT_NAME: "Batida Furiosa",
  T_16_R_EMOTE_EPHUNTER_NAME: "Batalha de Dança",
  T_16_R_EMOTE_EPHUNTER2_NAME: "Bate ai",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Chute a Lua",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Mexa o Pé",
  T_16_W_AK_FIRE_NAME: "AK47 - Chama Vermelha",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Comandante Rosa",
  T_16_W_SCAR_WATER_NAME: "SCAR - Elemental da Água",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Traje de Pet: Panda Selvagem",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Traje de Pet: Panda Caveira",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Traje de Pet: Panda Relâmpago",
  T_17_B_CS_MODE_NAME: "Contra Squad",
  T_17_C_SKILL_NAME_PLAYBOY: "Movimento Nutty",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Palhaço Royal",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Lady Drakas",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Lady Drakas",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Raposa Mágica",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Lady Drakas",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Lady Drakas",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vingança do Vampiro",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Gangster da Rua",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vingança do Vampiro",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Sombra Roxa",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "Cavalheiro",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vingança do Vampiro",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vingança do Vampiro",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Sombra Dourada",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Traje de Pet: Princesa Miau",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Traje de Pet: Conto Dourado",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Traje de Pet: Azul Escuro",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Traje de Pet: Duende Verde",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Planador",
  T_17_Q_FOLDWINGS_DESC: "Permite plainar de terrenos elevados.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Dança na Festa",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - Vampiro",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Fantasma",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - Antiquada",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Nome",
  T_17_Z_ROOM_JUMP_SWITCH: "Altura do pulo",
  T_17_Z_ROOM_SPEED_SWITCH: "Veloc. de Mov.",
  T_18_B_THROWINGKNIFE_NAME: "Faca FF",
  T_18_C_DUMMY_NAME: "Granada Camuflada",
  T_18_C_SKILL_DESC_DJMALE: "Cria uma aura de [FFB300]{1}m[-] que aumenta a velocidade de movimento em [FFB300]{3}%[-] e recupera [FFB300]{2} de vida por segundo[-] durante [FFB300]{0}s[-]. O efeito não acumula. Tempo de recarga: [FFB300]{4}s[-].",
  T_18_C_SKILL_NAME_DJMALE: "Som na Caixa",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Reciclagem de armadura",
  T_18_L_COS_INDIANEWYEAR: "Dino das Luzes",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Carranca",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Vermelho Flamejante",
  T_18_O_FOX_NAME: "Raposa Prateada",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Traje de Pet: Raposa de Batalha",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Traje de Pet: Raposa Azul",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Traje de Pet: Abóbora de Lava",
  T_18_O_PETSKIN_PINKFOX_NAME: "Traje de Pet: Raposa Rubra",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Traje de Pet: Espíritos",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Caveira Flamejante",
  T_18_W_UMP_GEISHA_N: "UMP - A arte da Guerra",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Prancha elétrica",
  T_19_C_ICE_GUN_NAME: "Arma de Gel",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "O dano de armas explosivas aumenta em [FFB300]{0}%[-] e o alcance aumenta em [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "Quando estiver dirigindo, recupera [FFB300]{1}de vida[-] a cada [FFB300]{0} segundos[-] para todos no veículo, até o máximo de [FFB300]{2}[-] de vida.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Arte da Demolição",
  T_19_C_SKILL_NAME_TOMBOY: "Cura Veloz",
  T_19_I_EVENT_INFI_ITEM: "Ilimitado",
  T_19_L_A_ICEFESTIVAL19_B: "Quem ri por último",
  T_19_L_F_S_ICEFESTIVAL: "Uniforme de Natal",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Discoteca",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Discoteca",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Discoteca",
  T_19_O_PETSKIN_NAME: "Traje de Pet: Padrão",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Traje de Pet: MC Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Traje de Pet: Panda Polar",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Traje de Pet: Faraó Robótico",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Traje de Pet: Festival de Primavera",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Traje de Pet: Robô Nevado",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Traje de Pet: MC Shiba",
  T_19_O_ROBOT_NAME: "Robô",
  T_19_O_TDM_NAME: "Equipe Mata-Mata",
  T_19_R_EMOTE_MIGUEL_NAME: "Só no passinho",
  T_19_S_SECOND_WEAPON_TITLE: "Arma secundária",
  T_19_S_VEST_TITLE: "Colete à prova de balas",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Cartucho Duplo",
  T_19_W_GROZA_TAGGERCREW_N: "Groza - Revolta do Grafiteiro",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Escolha dos Noel",
  T_19_W_MP40_PARK_N: "MP40 - Perigo no Parquinho",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - Dragão Dourado",
  T_19_X_PVE_SAMURAINAME: "Samurai Guardião",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inalador",
  T_20_C_SKILL_DESC_PARKOURGUY: "Se estiver usando uma arma, acertar um oponente recupera um pouco de vida do usuário. Ao derrubar um oponente, [FFB300]{0}%[-] de vida são recuperados.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Abrigo de Tinta",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Velocidade Fatal",
  T_20_C_SKILL_NAME_PARKOURGUY: "Ataque Seguro",
  T_20_L_A_APRILFOOL2020: "Catiorro",
  T_20_L_F_A_METALHEAD_RED: "Guerreira Saúva (Máscara)",
  T_20_L_F_B_THAIGIRL: "Guerreira de Garuda (Pernas)",
  T_20_L_F_H_KILLERCUPID: "Psiquê Cibernética (Cabeça)",
  T_20_L_F_H_THAIGIRL: "Guerreira de Garuda (Cabeça)",
  T_20_L_F_S_THAIGIRL: "Guerreira de Garuda (Calçado)",
  T_20_L_F_T_METALHEAD_RED: "Guerreira Saúva (Torso)",
  T_20_L_F_T_THAIGIRL: "Guerreira de Garuda (Torso)",
  T_20_L_JEANDINO: "Dino Jeans",
  T_20_L_M_A_METALHEAD_RED: "Guerreiro Saúva",
  T_20_L_M_T_METALHEAD_RED: "Guerreiro Saúva",
  T_20_L_M_T_STOCKING: "Narciso",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Traje de Pet: Raposa dos Namorados",
  T_20_P_CHANNEL_G: "Guilda",
  T_20_P_WORLD_SSPEAKER: "Alto-falante",
  T_20_S_CSROOM_COIN: "Ouro padrão",
  T_20_U_SHIELD_GUN_NAME: "Arma de Escudo",
  T_20_W_AN94_METALHEAD_N: "AN94 - Vespeiro",
  T_20_W_P90_EVILBONE_N: "P90 - Vingadores",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "Ventania"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Cria uma nuvem de fumaça, perfeita para reconhecimento e contra-ataque.",
  T_21_B_SMOKEGRENADE_NAME: "Granada de Fumaça",
  T_21_C_AUTOPICKUP_AVERAGE: "Velocidade padrão",
  T_21_C_SKILL_DESC_KPOPSINGER: "Ao ajudar a levantar um aliado, dá a ele um escudo com [FFB300]{0} de vida[-] e aumenta em [FFB300]{1}%[-] a velocidade de movimento. Os efeitos de aumento diminuem dentro de [FFB300]{2}s[-] de ajudar com êxito um aliado a levantar. Reduz a velocidade de sangramento de aliados derrubados em [FFB300]{3}%[-]. O efeito não acumula.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Cada abate aumenta o máximo de vida em [FFB300]{0}[-], máximo de bônus de [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Canção de Cura",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Goleada",
  T_21_L_ANGELICAL: "Dino Angelical",
  T_21_L_S_VNSLIPPER: "Chinelo Dép Tông",
  T_21_O_OTTER_NAME: "Lontreta",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Traje de Pet: Lontreta Plutônio",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Traje de Pet: Lontreta Sakura",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Traje de Pet: Lontreta Neon",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Traje de Pet: Desalmado",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Traje de Pet: Relâmpago",
  T_21_R_EMOTE_SORROW_NAME: "Nãaaaao!",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Mochila - Ameaçadora",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Taco Desalmado",
  T_21_W_M79_RABBITKILLER_N: "M79 - Coelho Delinquente",
  T_21_W_PAN_VOLCANO_N: "Panela - Vulcânica",
  T_21_W_XM8_RAINBOW_N: "XM8 - Tuba",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Localiza oponentes dentro de [FFB300]{0}m[-] que não estejam agachados ou deitados. Dura [FFB300]{1}s[-]. A posição dos oponentes é compartilhada com os aliados. Tempo de recarga: [FFB300]{2}s[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Entregando o Ouro",
  T_22_C_SKILL_NAME_STREAMERGUY: "Centro das Atenções",
  T_22_L_F_H_COLLEGE: "Veterana Inconsequente",
  T_22_L_F_S_SUMMER20: "Topzera",
  T_22_L_M_A_GREENCOAT: "Rolezeiro (Máscara)",
  T_22_L_M_A_PINKFUR: "Pantera Cor de Rosa",
  T_22_L_M_A_PLAGUE2: "Praga Fantasma",
  T_22_L_M_B_FAIM2: "Fogo Faminto",
  T_22_L_M_B_GREENCOAT: "Rolezeiro (Pernas)",
  T_22_L_M_B_PINKFUR: "Pantera Cor de Rosa",
  T_22_L_M_B_PLAGUE2: "Praga Fantasma",
  T_22_L_M_B_REDPANTS: "Hypado",
  T_22_L_M_B_TIGERSTRIPE: "Tigrão da Balada (Pernas)",
  T_22_L_M_H_COLLEGE: "Calouro Inconsequente",
  T_22_L_M_H_FAIM2: "Fogo Faminto",
  T_22_L_M_H_GREENCOAT: "Rolezeiro (Cabeça)",
  T_22_L_M_H_PINKFUR: "Pantera Cor de Rosa",
  T_22_L_M_H_PLAGUE2: "Praga Fantasma",
  T_22_L_M_H_REDPANTS: "Hypado",
  T_22_L_M_H_TIGERSTRIPE: "Tigrão da Balada (Cabeça)",
  T_22_L_M_S_FAIM2: "Fogo Faminto",
  T_22_L_M_S_PLAGUE2: "Praga Fantasma",
  T_22_L_M_T_FAIM2: "Fogo Faminto",
  T_22_L_M_T_GREENCOAT: "Rolezeiro (Torso)",
  T_22_L_M_T_PINKFUR: "Pantera Cor de Rosa",
  T_22_L_M_T_PLAGUE2: "Praga Fantasma",
  T_22_L_M_T_REDPANTS: "Hypado",
  T_22_L_M_T_TIGERSTRIPE: "Tigrão da Balada (Torso)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K - Centro Acadêmico Rebeldia",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Panela - Melancia",
  T_22_LC_SCAR_HERMIT_N: "SCAR - Eremitas",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Pistola de Cura - Cauterização",
  T_22_O_HAWK_NAME: "Falcão",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Traje de Pet: Cavaleiro Raposa",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Traje de Pet: Fênix",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Traje de Pet: Falcão Persistente",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Traje de Pet: Shiba Solar",
  T_22_Q_BOMB_PLIERS: "Ferramenta para desarmar bombas",
  T_22_R_EMOTE_SHIMMY_NAME: "Remelexo",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Penetração de Armadura",
  T_22_U_WPNSKN_SPEED_RUN: "Velocidade de movimento",
  T_22_Y_CHARACTER_DETECTIVE_N: "Evelyn",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Novo Futuro",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Goshinjutsu",
  T_23_C_SKILL_NAME_SWATGUY: "Recarga Furiosa",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Chama Azul"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "DJ Gemadona",
  T_23_L_F_B_MIKOGIRL: "Miko das Chamas",
  T_23_L_F_B_NAVYGIRL: "Marinheira",
  T_23_L_F_H_GANGSTERRAP_GOLD: "DJ Gemadona",
  T_23_L_F_H_MIKOGIRL: "Miko das Chamas",
  T_23_L_F_H_NAVYGIRL: "Marinheira",
  T_23_L_F_S_MIKOGIRL: "Miko das Chamas",
  T_23_L_F_S_ORDERCHALLENGER: "Saqueadora",
  T_23_L_F_T_GANGSTERRAP_GOLD: "DJ Gemadona",
  T_23_L_F_T_MIKOGIRL: "Miko das Chamas",
  T_23_L_F_T_NAVYGIRL: "Marinheira",
  T_23_L_M_A_GANGSTERRAP_GOLD: "MC Gemadão",
  T_23_L_M_B_FOXGUY: "Ayakashi das Chamas",
  T_23_L_M_B_GANGSTERRAP_GOLD: "MC Gemadão",
  T_23_L_M_H_FOXGUY: "Ayakashi das Chamas",
  T_23_LC_SKS_GEMINI_N: "SKS - Maníacos",
  T_23_O_PENGUIN_NAME: "Dom Pisante",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Traje de Pet: Dom Festeiro",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Traje de Pet: Dom Cibernético",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Traje de Pet: Dom Gemado",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Contra Squad",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Personagem",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "ID",
  T_24_AD_ADSPACE_WARNING: "PERIGO!",
  T_24_C_FLAMETHROWER_NAME: "Lança-chamas",
  T_24_C_SKILL_DESC_PROFESSOR: "Máximo de energia aumenta em [FFB300]{0}[-]. Modo Jiu-jitsu: Aliados dentro de [FFB300]{2}m[-] de distância recebem um bônus de [FFB300]{1}%[-] na taxa de conversão de energia. Modo Psicólogo: Recupera [FFB300]{5}[-] de energia a cada [FFB300]{4}s[-] até [FFB300]{6}[-] de energia. Tempo de recarga para mudar de modo: [FFB300]{3}s[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "Baladeira",
  T_24_C_SKILL_NAME_PROFESSOR: "Lição do Professor",
  T_24_D_CHARACTER_PARTYGIRL_N: "Diana",
  T_24_D_CHARACTER_PROFESSOR_N: "Kamir",
  T_24_L_B_MAXPANTS: "Calças MAX",
  T_24_L_H_PUMPKIN2020_A: "Gostosuras",
  T_24_L_T_TSHIRT_COMEDIAN: "Última chance",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - Realeza Boxeadora",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - Madame Farra",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - Guerra Imperial",
  T_24_U_M21A5: "Carapina",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Pontuação total",
  T_24_V_TRAINING_BOX_ATTACH: "Acessórios",
  T_24_V_TRAINING_BOX_WEAPON: "Armas",
  T_24_W_ARMORY: "Armas",
  T_24_W_ARMOTY_MELEE: "Arma de Contato",
  T_24_W_ARMOTY_PISTOL: "Pistola",
  T_24_W_ARMOTY_RIFLE: "Fuzil",
  T_24_W_ARMOTY_SHOTGUN: "Espingarda",
  T_24_W_ARMOTY_SNIPER: "Fuzil de Precisão",
  T_24_W_ARMOTY_SPECIAL: "Outros",
  T_24_W_ARMOTY_SUBMACHINE: "Submetralhadora",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Traje de Pet: Panda Booyah!",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Traje de Pet: Eskeletin Punkin",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Traje de Pet: Cyber Punkin",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Traje de Pet: Zumbizin Punkin",
  T_24_W_RACCOON_N: "Punkin",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Escudo Tunado",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "HUD 1",
  T_25_E_HUD_02: "HUD 2",
  T_25_L_F_B_DEMONKILLER: "Caçadora Colérica",
  T_25_L_F_H_DEMONKILLER: "Caçadora Colérica",
  T_25_L_F_S_DEMONKILLER: "Caçadora Colérica",
  T_25_L_F_T_DEMONKILLER: "Caçadora Colérica",
  T_25_L_HA_FP_EVIL: "Cruel",
  T_25_L_M_H_ANIMEHAIR: "Cabelos ao Vento",
  T_25_L_S_MAXSNEAKERS: "Tênis FF MAX",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Bastão - Embaixador Cósmico",
  T_25_LC_GLOO_WINTERFEST2020_N: "Parede de Gel - Granizo",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - Granizo",
  T_25_LC_MACHETE_BOUNTY_N: "Machete - Embaixador Cósmico",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - Retumbante",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - Estrondosa",
  T_25_LC_PAN_BOUNTY_N: "Panela - Agentes Cósmicos",
  T_25_R_LEGEND_REMIND: "Lembrete",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Foice",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Brabuíno",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Traje de Pet: Brabuíno Glacial",
  T_25_W_PETSKIN_BABOON_HELL_N: "Traje de Pet: Brabuíno Flamejante",
  T_25_W_PETSKIN_BABOON_PURE_N: "Traje de Pet: Brabuíno Albino",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Traje de Pet: Pantera das Neves",
  T_25_Z_R_SIMULATOR_OFF: "Proibir",
  T_26_C_SKILL_DESC_SUPERSTAR: "Dispara uma onda sônica [FFB300]{0}m[-] à frente e causa dano a Paredes de Gel ao explodir no raio de [FFB300]{1}m[-] por [FFB300]{2}s[-]. Tempo de recarga: [FFB300]{3}s[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Quebradeira",
  T_26_D_CHARACTER_DELIVERY_N: "Shiro",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "Mini drone",
  T_26_L_A_FLAMING_PREM: "Soldado Vulcânico",
  T_26_L_A_SANTAMODE: "Boneco de Neve",
  T_26_L_B_SANTAMODE: "Boneco de Neve",
  T_26_L_F_B_WATERFEST21_A: "Brisa de Verão (Pernas)",
  T_26_L_F_H_WATERFEST21_A: "Brisa de Verão (Cabeça)",
  T_26_L_F_S_WATERFEST21_A: "Brisa de Verão (Calçado)",
  T_26_L_F_T_WATERFEST21_A: "Brisa de Verão (Torso)",
  T_26_L_M_A_EGGDAY2021: "Coelho Tech",
  T_26_L_M_B_EGGDAY2021: "Coelho Tech",
  T_26_L_M_B_PAIRING: "O Conde",
  T_26_L_M_B_WATERFEST21_A: "Onda de Verão",
  T_26_L_M_H_EGGDAY2021: "Coelho Tech",
  T_26_L_M_H_PAIRING: "O Conde",
  T_26_L_M_H_WATERFEST21_A: "Onda de Verão",
  T_26_L_M_S_EGGDAY2021: "Coelho Tech",
  T_26_L_M_S_PAIRING: "O Conde",
  T_26_L_M_S_WATERFEST21_A: "Onda de Verão",
  T_26_L_M_T_EGGDAY2021: "Coelho Tech",
  T_26_L_M_T_PAIRING: "O Conde",
  T_26_L_M_T_WATERFEST21_A: "Onda de Verão",
  T_26_L_S_SANTAMODE: "Boneco de Neve",
  T_26_L_T_SANTAMODE: "Boneco de Neve",
  T_26_LC_AWM_KOICARP_N: "AWM - Koi da Sorte",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana - Temporada do Amor",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Carro Esportivo - Iniciativa Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Delivery de Dano",
  T_26_V_TRAINING_BHH: "Martelo Estiloso",
  T_26_V_TRAINING_DICE: "Dado Gigante",
  T_26_W_DRAGON_N: "Drakinho",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Traje de Pet: Drakinho Congelante",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Traje de Pet: Drakinho Chocante",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Traje de Pet: Drakinho Galático",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Traje de Pet: Dom Chamego",
  T_26_XL_SETTING_TEAMMATE_INFO: "Informações do aliado",
  T_26_YP_HISTORY_WIN: "Vitória",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Feminino",
  T_26_YP_SOCIAL_GENDER_MALE: "Masculino",
  T_26_YP_SOCIAL_NAME: "Apelido",
  T_27_C_SKILL_DESC__RACERGIRL: "Aumenta em [FFB300]{0}%[-] a velocidade ao dirigir. As chances de ser atingido dentro do veículo são menores, e o dano recebido é reduzido em [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Cria um campo de força que bloqueia [FFB300]{0}[-] de dano dos dois lados. Todos os efeitos duram por [FFB300]{1}s[-]. Tempo de recarga [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "O dano aumenta com a distância. Máximo de [FFB300]{0}%[-]. O dano a oponentes marcados aumenta em [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Despertar: Reduz o dano frontal em [FFB300]{1}%[-] a cada [FFB300]{0}%[-] de perda de vida máxima.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Despertar: Ativa após correr por [FFB300]{0}s[-]. Os primeiros [FFB300]{2}[-] disparos após a ativação causarão [FFB300]{1}%[-] de dano. Dura [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "Ferida do Falcão",
  T_27_C_SKILL_NAME_XTREME: "Dano Radical",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "O Destemido"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xtrema",
  T_27_F_EAP_PKG3_D: "Sua batalha, seu estilo!",
  T_27_HYL_SKILLBOARD_HP: "Vida",
  T_27_L_A_CARDBOARD_MID2: "Tigre de Papel",
  T_27_L_B_CARDBOARD_REG: "Urso de Papel",
  T_27_L_M_S_KAZAKHSTAN: "Baghatur",
  T_27_L_S_CARDBOARD_REG: "Urso de Papel",
  T_27_L_T_CARDBOARD_REG: "Urso de Papel",
  T_27_LC_VECTOR_FFWS2021_N: "Vector - Mundial 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Caminhão Monstro - Mundial 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Moto - Noite de Nocaute",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Carro Esportivo - Esmeralda",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Picape - Dragão Esmeralda",
  T_27_P_SKILL_NAME_HITMAN_RE: "Morte Silenciosa",
  T_27_R_EMOTE_GREETING_NAME: "Emote Reverência",
  T_27_R_VEHICLE_ACCELERATION: "Aceleração",
  T_27_R_VEHICLE_HP: "Durabilidade",
  T_27_R_VEHICLE_SPEED: "Velocidade máxima",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Despertar: Reduz o dano da armadura em [FFB300]{0}%[-]. Redução de dano adicional de [FFB300]{1}%[-] para cada aliado dentro de [FFB300]{2}m[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Alcateia",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "ETzin",
  T_27_W_ARMOTY_DMR: "Fuzil de atirador",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Traje de Pet: ETzin Suave",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Traje de Pet: ETzin Astral",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Traje de Pet: ETzin Turista",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Traje de Pet: Cachorro Mundial 2021",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Traje de Pet: Panda Mundial 2021",
  T_27_XC_REPLAY_DIE: "Mortes.",
  T_27_XC_REPLAY_KILL: "Abates.",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Reparar",
  T_28_C_G_ICE_NAME: "Bomba Congelante",
  T_28_C_SKILL_DESC_STREETBEAT: "A velocidade de movimento aumenta em [FFB300]{0}%[-] e a precisão aumenta em [FFB300]{1}%[-] ao atirar em movimento.",
  T_28_C_SKILL_NAME_STREETBEAT: "Pé de Break",
  T_28_D_CHARACTER_STREETBEAT_N: "D-Boas",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "Bermuda N.º 23",
  T_28_L_B_BRJERSEY_B: "Bermuda N.º 10",
  T_28_L_B_BRJERSEY_C: "Bermuda N.º 24",
  T_28_L_B_BRJERSEY_D: "Bermuda N.º 30",
  T_28_L_B_BRJERSEY_E: "Bermuda N.º 1",
  T_28_L_B_BRJERSEY_F: "Bermuda N.º 20",
  T_28_L_F_B_FOURSYMBOLS_C: "Aurora, a Vulcânica",
  T_28_L_F_H_FOURSYMBOLS_C: "Aurora, a Vulcânica",
  T_28_L_F_HA_FOURSYMBOLS_C: "Aurora, a Vulcânica",
  T_28_L_F_S_FOURSYMBOLS_C: "Aurora, a Vulcânica",
  T_28_L_F_T_FOURSYMBOLS_C: "Aurora, a Vulcânica",
  T_28_L_HA_THUNDER: "Olhar Relâmpago",
  T_28_L_M_A_SPORTSUIT: "Estilo Tech",
  T_28_L_M_B_FOURSYMBOLS_D: "Cascudo, o Treme-Terra",
  T_28_L_M_B_SPORTSUIT: "Estilo Tech",
  T_28_L_M_H_FOURSYMBOLS_D: "Cascudo, o Treme-Terra",
  T_28_L_M_H_SPORTSUIT: "Estilo Tech",
  T_28_L_M_S_FOURSYMBOLS_D: "Cascudo, o Treme-Terra",
  T_28_L_M_S_SPORTSUIT: "Estilo Tech",
  T_28_L_M_T_FALLWINTER: "MC Glow",
  T_28_L_M_T_FOURSYMBOLS_D: "Cascudo, o Treme-Terra",
  T_28_L_M_T_SPORTSUIT: "Estilo Tech",
  T_28_L_T_BRJERSEY_A: "Camiseta N.º 23",
  T_28_L_T_BRJERSEY_B: "Camiseta N.º 10",
  T_28_L_T_BRJERSEY_C: "Camiseta N.º 24",
  T_28_L_T_BRJERSEY_D: "Camiseta N.º 30",
  T_28_L_T_BRJERSEY_E: "Camiseta N.º 1",
  T_28_L_T_BRJERSEY_F: "Camiseta N.º 20",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - Noiva das Rosas",
  T_28_LC_GLOO_FALLWINTER_N: "Parede de Gel - DJ Glow",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Parede de Gel - Tempestuoso",
  T_28_LC_KORD_SHINOBI_N: "Kord - Ninjas",
  T_28_LC_M21A5_FANTASYEYE_N: "Carapina - Platinados",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7- Tio Barão",
  T_28_LC_PAN_FOURSYMBOLS_N: "Panela - Treme - Terra",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jipe - Tempestuoso",
  T_28_T_WS_ITEM1: "Pacote Quadrada",
  T_28_T_WS_ITEM10: "Cabana",
  T_28_T_WS_ITEM11: "Torre guardiã",
  T_28_T_WS_ITEM12: "Posto avançado",
  T_28_T_WS_ITEM13: "Casa A",
  T_28_T_WS_ITEM14: "Casa B",
  T_28_T_WS_ITEM15: "Casa C",
  T_28_T_WS_ITEM16: "Estrutura de areia",
  T_28_T_WS_ITEM17: "Fonte",
  T_28_T_WS_ITEM18: "Flor de cerejeira",
  T_28_T_WS_ITEM19: "Bananeira",
  T_28_T_WS_ITEM2: "Pacote Grande",
  T_28_T_WS_ITEM20: "Vaso sanitário",
  T_28_T_WS_ITEM21: "Cerca",
  T_28_T_WS_ITEM3: "Arbusto",
  T_28_T_WS_ITEM4: "Flores",
  T_28_T_WS_ITEM5: "Carro",
  T_28_T_WS_ITEM6: "Ônibus",
  T_28_T_WS_ITEM7: "Recipiente A",
  T_28_T_WS_ITEM8: "Recipiente B",
  T_28_T_WS_ITEM9: "Recipiente C",
  T_28_T_WS_TYPE1: "Objetos",
  T_28_T_WS_TYPE4: "Decorações",
  T_28_W_DUCK_N: "PaTopinho",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Traje de Pet: Drakinho das Criaturas",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Traje de Pet: PaTopinho Quackzada",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Traje de Pet: PaTopinho Bonito",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Traje de Pet: PaTopinho Suave",
  T_28_YF_AR15: "Atiradeira",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Despertar: A marcação de oponentes dura mais tempo, até [FFB300]{0}s[-] a mais.",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Olho Decodificador",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Levantando na Batida",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Batida da Cura",
  T_29_D_CHARACTER_AMOCO_N: "Moco “Decodificada”",
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Bermuda Ketchup",
  T_29_L_M_A_FALCONER_C: "Chefe Extravagante",
  T_29_L_M_A_JUNGLE_GREEN: "Tartaruga Lodosa",
  T_29_L_M_B_FALCONER_C: "Chefe Extravagante",
  T_29_L_M_B_JUNGLE_GREEN: "Tartaruga Lodosa",
  T_29_L_M_H_FALCONER_C: "Chefe Extravagante",
  T_29_L_M_H_JUNGLE_GREEN: "Tartaruga Lodosa",
  T_29_L_M_S_FALCONER_C: "Chefe Extravagante",
  T_29_L_M_S_JUNGLE_GREEN: "Tartaruga Lodosa",
  T_29_L_M_T_FALCONER_C: "Chefe Extravagante",
  T_29_L_M_T_JUNGLE_GREEN: "Tartaruga Lodosa",
  T_29_L_T_TRJERSEY: "Camisa Ketchup",
  T_29_M_WS_ITEM22: "Suprimento Escarpado",
  T_29_M_WS_ITEM23: "Cerca Escarpada",
  T_29_M_WS_ITEM24: "Ponto de Surgimento A",
  T_29_M_WS_ITEM25: "Ponto de Surgimento B",
  T_29_M_WS_TYPE5: "Interativos",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Traje de Pet: Mestre Malaio",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Traje de Pet: Mestre Mumbai",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Traje de Pet: Falcão Cibernético",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Traje de Pet: Panda Festeiro",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Traje de Pet: Mestre Siberiano",
  T_29_W_TIGER_NINJA_N: "Mestre Trigo",
  T_29_YF_MACHETE_MUSICFEST_N: "Machete - Soberana das Batidas",
  T_29_YF_MAGEZINE_CHAIN_N: "Munição AR",
  T_29_YF_MUZZLE_CRASH_N: "Bocal de SMG",
  T_29_YF_MUZZLE_WIDE_N: "Bocal de Espingarda",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 - Decodificadora",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi - Paladina Biônica",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Caminhão Monstro - Roedor Furioso",
  T_30_AD_RP_ROUNDEND: "FIM DA RODADA",
  T_30_AD_TRAINING_SNOWBALL: "Guerra de Neve",
  T_30_AD_TRAINING_SNOWBALL_DES: "É tipo queimada, só que com neve!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] depois de receber um ataque, recupere [FFB300]{1} de Vida[-] por [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Lance Livre",
  T_30_C_SKILL_NAME_MUERTOGUY: "Olhar de Calavera",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Biochip Recarga Furiosa",
  T_30_L_A_BRMASCOT_ADULT: "Máscara Canarinho Brabo",
  T_30_L_A_BRMASCOT_KIDS: "Máscara Canarinho Fofinho",
  T_30_L_A_SUGARSKULL21_BANDANA: "Bandana Calavera",
  T_30_L_B_BRFOOTBALL_BLACK: "Oficial Seleção Brasileira - Preto",
  T_30_L_B_BRFOOTBALL_GREEN: "Oficial Seleção Brasileira - Verde",
  T_30_L_B_BRFOOTBALL_GREY: "Oficial Seleção Brasileira - Cinza",
  T_30_L_B_BRUNIFORM: "Bermuda do Canarinho",
  T_30_L_F_A_SUGARSKULL21: "Garbancera",
  T_30_L_F_B_SUGARSKULL21: "Garbancera",
  T_30_L_F_B_THASIAN: "Encrenqueira",
  T_30_L_F_H_CATEARS: "Orelhas de Gatinho",
  T_30_L_F_H_SUGARSKULL21: "Garbancera",
  T_30_L_F_H_THASIAN: "Encrenqueira",
  T_30_L_F_S_SUGARSKULL21: "Garbancera",
  T_30_L_F_S_THASIAN: "Encrenqueira",
  T_30_L_F_T_SUGARSKULL21: "Garbancera",
  T_30_L_F_T_THASIAN: "Encrenqueira",
  T_30_L_H_CHILDRENSDAY_BLUE: "Cabeça de Golfinho",
  T_30_L_H_CHILDRENSDAY_RED: "Cabeça de elefante",
  T_30_L_H_CLOWNHAT: "Palhaçada Amarela",
  T_30_L_H_ZASCARF: "Turbante Dourado",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Mecânico Chavoso",
  T_30_L_M_A_SUGARSKULL21: "Micli",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Mecânico Chavoso",
  T_30_L_M_B_PKCRICKET: "Lord Críquete",
  T_30_L_M_B_SUGARSKULL21: "Micli",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Capa de los muertos",
  T_30_L_M_B_THASIAN: "Encrenqueiro",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Mecânico Chavoso",
  T_30_L_M_H_SUGARSKULL21: "Micli",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Capa de los muertos",
  T_30_L_M_H_THASIAN: "Encrenqueiro",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Quebra-crânio Ouro",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Mecânico Chavoso",
  T_30_L_M_S_PKCRICKET: "Lord Críquete",
  T_30_L_M_S_SUGARSKULL21: "Micli",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Capa de los muertos",
  T_30_L_M_S_THASIAN: "Encrenqueiro",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Mecânico Chavoso",
  T_30_L_M_T_PKCRICKET: "Lord Críquete",
  T_30_L_M_T_SUGARSKULL21: "Micli",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Capa de los muertos",
  T_30_L_M_T_THASIAN: "Encrenqueiro",
  T_30_L_S_BRUNIFORM: "Tênis do Canarinho",
  T_30_L_T_BRFOOTBALL_BLACK: "Oficial Seleção Brasileira - Preto",
  T_30_L_T_BRFOOTBALL_GREEN: "Oficial Seleção Brasileira - Verde",
  T_30_L_T_BRFOOTBALL_GREY: "Oficial Seleção Brasileira - Cinza",
  T_30_L_T_BRUNIFORM: "Camiseta do Canarinho",
  T_30_M_WS_PARTY_MODE: "Às Brincas",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "SE JOGA NO ESTILO",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Emote Chega Junto",
  T_30_R_EMOTE_MAX_NAME: "Emote Swag",
  T_30_R_LEGEND_HALO_NAME: "Espiral de calor",
  T_30_T_WS_DEFAULTDESCRIPTION: "Mapas surgem dos sonhos da tropa na Oficina de Criação.",
  T_30_T_WS_ITEM26: "Pneus",
  T_30_T_WS_ITEM27: "Pneus bagunçados A",
  T_30_T_WS_ITEM28: "Pneus bagunçados B",
  T_30_T_WS_ITEM29: "Pneus bagunçados C",
  T_30_T_WS_ITEM30: "Carro Bate-bate",
  T_30_T_WS_ITEM31: "Carro Anfíbio",
  T_30_T_WS_ITEM32: "Jipe",
  T_30_T_WS_ITEM33: "Lata de lixo",
  T_30_T_WS_ITEM34: "Sombra",
  T_30_T_WS_ITEM35: "Tenda Médica",
  T_30_T_WS_ITEM36: "Garagem",
  T_30_T_WS_ITEM37: "Paredes pintadas",
  T_30_T_WS_ITEM38: "Portal Xintoísta",
  T_30_T_WS_ITEM39: "Plataforma de Ferro",
  T_30_T_WS_ITEM40: "Casa temporária",
  T_30_T_WS_ITEM41: "Trailer",
  T_30_T_WS_ITEM42: "Muro A",
  T_30_T_WS_ITEM43: "Muro B",
  T_30_T_WS_ITEM44: "Muro C",
  T_30_T_WS_ITEM45: "Muro D",
  T_30_T_WS_ITEM46: "Muro E",
  T_30_T_WS_ITEM47: "Muro F",
  T_30_U_ATTACHMENT_1: "Bônus de Escudo",
  T_30_U_ATTACHMENT_4: "Aumentador de Colete",
  T_30_U_ATTACHMENT_5: "Engrossador de Capacete",
  T_30_U_ATTACHMENT_6: "Engrossador de Colete",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Traje de Pet: Brabuíno de los Muertos",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Traje de Pet: Dom Tóxico",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Traje de Pet: Agente Sensi",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Traje de Pet: Agente Carnaval",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Traje de Pet: Agente Cibernético",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Traje de Pet: Robô Olho Grego",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Traje de Pet: Robô Iogurte",
  T_30_W_RABBIT_N: "Agente Salto",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Parede de Gel - Dia do Booyah! 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Granada - Dia do Booyah! 2021",
  T_30_YF_Healinggun_Sniper_N: "FP de Cura",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - Protetor das Areias",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL - Estudante de Moda",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - Protetor das Areias",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Día de los Muertos",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Carro Esportivo - Tóxicos",
  T_31_C_SKILL_NAME_WINTERGUY: "Gel de Aço",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Bastão - Coração Gelado",
  T_31_HQ_GLOO_EAGLE_N: "Parede de Gel - Realeza das Areias",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "FP de Cura - Coração Gelado",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana - Coração Gelado",
  T_31_HQ_PAN_WINTERFEST21_N: "Panela - Congelada",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Traje de Pet: Lontreta Gelada",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Traje de Pet: Dom Gelado",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Traje de Pet: Iéti Druida",
  T_31_HQ_PETSKIN_YETI_RED_N: "Traje de Pet: Iéti Assistente",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Foice - Coração Gelado",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Moto - Lobo das Neves",
  T_31_HQ_YETI_N: "Iéti",
  T_31_KK_WINTER_BUJIX: "Pacote de Suprimentos",
  T_31_KK_WINTER_SANJITOU: "Capacete",
  T_31_L_A_BDCRICKET: "Jogador Sah",
  T_31_L_A_WINTERFEST21: "Bandana Coração Gelado",
  T_31_L_B_BDCRICKET: "Jogador Sah",
  T_31_L_B_MEJERSEY_10: "Bermuda Vermelha N.º 10",
  T_31_L_B_MEJERSEY_11: "Bermuda Vermelha N.º 11",
  T_31_L_B_MEJERSEY_13: "Bermuda Branca N.º 13",
  T_31_L_B_MEJERSEY_18G: "Bermuda Verde N.º 18",
  T_31_L_B_MEJERSEY_18R: "Bermuda N.º 18",
  T_31_L_B_MEJERSEY_7: "Bermuda Branca N.º 7",
  T_31_L_F_B_RUMUSICIAN: "Insurreição Urbana",
  T_31_L_F_B_THAGENT: "Agente Cavernosa",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Bucket Denim",
  T_31_L_F_H_RUMUSICIAN: "Insurreição Urbana",
  T_31_L_F_H_THAGENT: "Agente Cavernosa",
  T_31_L_F_HA_RUMUSICIAN: "Insurreição Urbana",
  T_31_L_F_S_RUMUSICIAN: "Insurreição Urbana",
  T_31_L_F_S_THAGENT: "Agente Cavernosa",
  T_31_L_F_T_RUMUSICIAN: "Insurreição Urbana",
  T_31_L_F_T_THAGENT: "Agente Cavernosa",
  T_31_L_HA_RUMUSICIAN_MU: "Levante Urbano",
  T_31_L_HA_WINTERFEST21_BLUE: "Calavera Congelada",
  T_31_L_HA_WINTERFEST21_PINK: "Explosão Rosada",
  T_31_L_M_A_REGGAETON_B: "Mi Gente",
  T_31_L_M_A_REGGAETON_P: "J.Booyah",
  T_31_L_M_A_RUMUSICIAN: "Levante Urbano",
  T_31_L_M_A_THAGENT: "Cavalheiro Cavernoso",
  T_31_L_M_B_PKCOSTUME: "Traje Paquistanês",
  T_31_L_M_B_REGGAETON_B: "Mi Gente",
  T_31_L_M_B_REGGAETON_P: "J.Booyah",
  T_31_L_M_B_RUMUSICIAN: "Levante Urbano   ",
  T_31_L_M_B_THAGENT: "Cavalheiro Cavernoso",
  T_31_L_M_H_GREENCAP: "Boné Vencedor",
  T_31_L_M_H_PKCOSTUME: "Traje Paquistanês",
  T_31_L_M_H_REGGAETON_B: "Mi Gente",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Bucket Jeans",
  T_31_L_M_H_REGGAETON_P: "J.Booyah",
  T_31_L_M_H_RUMUSICIAN: "Levante Urbano",
  T_31_L_M_H_THAGENT: "Cavalheiro Cavernoso",
  T_31_L_M_S_PKCOSTUME: "Traje Paquistanês",
  T_31_L_M_S_REGGAETON_B: "Mi Gente",
  T_31_L_M_S_REGGAETON_P: "J.Booyah",
  T_31_L_M_S_RUMUSICIAN: "Levante Urbano",
  T_31_L_M_S_THAGENT: "Cavalheiro Cavernoso",
  T_31_L_M_T_PKCOSTUME: "Traje Paquistanês",
  T_31_L_M_T_REGGAETON_B: "Mi Gente",
  T_31_L_M_T_REGGAETON_P: "J.Booyah",
  T_31_L_M_T_REGGAETON_TATOO: "Tatuagem Família",
  T_31_L_M_T_RUMUSICIAN: "Levante Urbano",
  T_31_L_M_T_THAGENT: "Cavalheiro Cavernoso",
  T_31_L_S_BDCRICKET: "Jogador Sah",
  T_31_L_T_BDCRICKET: "Jogador Sah",
  T_31_L_T_BRBANK: "Moletom Santander",
  T_31_L_T_MEJERSEY_10: "Camiseta Vermelha N.º 10",
  T_31_L_T_MEJERSEY_11: "Camiseta Vermelha N.º 11",
  T_31_L_T_MEJERSEY_13: "Camiseta Branca N.º 13",
  T_31_L_T_MEJERSEY_18G: "Camiseta Verde N.º 18",
  T_31_L_T_MEJERSEY_18R: "Camiseta N.º 18",
  T_31_L_T_MEJERSEY_7: "Camiseta Branca N.º 7",
  T_31_L_T_PKMOBILE: "Camiseta Infinix",
  T_31_L_T_REGGAETON_HOOD: "Latino Gang",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Número 1!",
  T_31_RW_COMBINEMACHINE_2: "Luva Akimbo (Avançada)",
  T_31_RW_VIBRATION_EXPLOSION: "Explosões",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Armas de contato",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Outras armas",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squad",
  T_31_T_WS_5PLAYERTEAM: "x 5",
  T_31_T_WS_6PLAYERTEAM: "x 6",
  T_31_T_WS_BUFFTIME_TITLE: "Tempo de atualização (s)",
  T_31_T_WS_BUFFTYPE_AMMO: "Munição",
  T_31_T_WS_BUFFTYPE_ARMOR: "Armaduras",
  T_31_T_WS_BUFFTYPE_HP: "Vida",
  T_31_T_WS_BUFFTYPE_RANDOM: "Aleatório",
  T_31_T_WS_BUFFTYPE_TITLE: "Tipo de bônus",
  T_31_T_WS_DESC48: "Te leva para outro lugar em segundos.",
  T_31_T_WS_DESC49: "Cria o som de um piano.",
  T_31_T_WS_DESC51: "Cria o som de um tambor.",
  T_31_T_WS_DESC53: "Cria o som de um sintetizador.",
  T_31_T_WS_DESC59: "Um dispositivo que gera bônus periodicamente. Colete-o para receber a melhoria correspondente.",
  T_31_T_WS_DRUMTYPE_CLAPS: "Clap",
  T_31_T_WS_DRUMTYPE_HIHATS: "Chimbal",
  T_31_T_WS_DRUMTYPE_KICK: "Bumbo",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Prato de ataque",
  T_31_T_WS_DRUMTYPE_RIDES: "Prato de condução",
  T_31_T_WS_DRUMTYPE_SNARES: "Caixa",
  T_31_T_WS_EARLYSHRINK: "Diminuição rápida",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Tecla de Piano",
  T_31_T_WS_ITEM51: "Chave de Tambor",
  T_31_T_WS_ITEM53: "Combo de chaves A.",
  T_31_T_WS_ITEM55: "Combo de chaves B.",
  T_31_T_WS_ITEM57: "Combo de chaves C.",
  T_31_T_WS_ITEM59: "Gerador de bônus",
  T_31_T_WS_LATESHRINK: "Diminuição lenta",
  T_31_T_WS_ME_DAMAGE: "Dano causado",
  T_31_T_WS_ME_DAMAGED: "Dano recebido",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Proporção inicial de energia",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Raio da primeira zona segura",
  T_31_T_WS_ME_EPQUICKRESTORE: "Conversão rápida de energia",
  T_31_T_WS_ME_FLOW: "Modo",
  T_31_T_WS_ME_GENERALSETTING: "Geral",
  T_31_T_WS_ME_INRANDOMSPAWN: "Ponto de surgimento aleatório",
  T_31_T_WS_ME_KILLSCORE: "Bônus de Abates",
  T_31_T_WS_ME_MAXEP: "Máximo de energia",
  T_31_T_WS_ME_MAXHP: "Máximo de vida",
  T_31_T_WS_ME_NEARTEAM: "Aliados próximos",
  T_31_T_WS_ME_REBIRTH: "Tempo para ressurgir",
  T_31_T_WS_ME_REBIRTHLOCATION: "Local para ressurgir",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Tempo para diminuição da zona segura",
  T_31_T_WS_ME_WINSCORE: "Pontuação de Vitória",
  T_31_T_WS_MINIZONE: "Mini Zona",
  T_31_T_WS_MUSICTYPE_TITLE: "Tipo de música",
  T_31_T_WS_UNLIMITEDAMMO: "Munição ilimitada",
  T_31_WT_WS_DESC1: "Uma caixa de madeira que pode ser empilhada.",
  T_31_WT_WS_DESC10: "Uma cabana de madeira com escadas para escalar",
  T_31_WT_WS_DESC11: "Suas múltiplas janelas foram pensadas para permitir a troca de tiros.",
  T_31_WT_WS_DESC12: "Feito de metal, contém portas e janelas.",
  T_31_WT_WS_DESC13: "Contém portas e janelas.",
  T_31_WT_WS_DESC14: "Uma casa de dois andares com um terraço.",
  T_31_WT_WS_DESC15: "Uma casa de dois andares com o telhado vedado.",
  T_31_WT_WS_DESC16: "Decoração: Uma estátua de areia em forma de coração",
  T_31_WT_WS_DESC17: "Decoração: uma fonte de água cristalina",
  T_31_WT_WS_DESC18: "Decoração: Uma árvore de flores cor-de-rosa.",
  T_31_WT_WS_DESC19: "Decoração: Uma bananeira sem frutos.",
  T_31_WT_WS_DESC2: "Uma caixa de madeira que pode ser empilhada.",
  T_31_WT_WS_DESC20: "Mobília branca para banheiros que pode ser usada em espaços fechados.",
  T_31_WT_WS_DESC21: "Uma pequena cerca que pode ser usada para dividir áreas.",
  T_31_WT_WS_DESC22: "A lateral de madeira deste contêiner pode ser destruída com força bruta.",
  T_31_WT_WS_DESC23: "Uma pequena cerca facilmente destruível.",
  T_31_WT_WS_DESC24: "Área de ressurgimento da Equipe A (válido apenas no Contra Squad, Mata-Mata em Equipe e no Às Brincas).",
  T_31_WT_WS_DESC25: "Área de ressurgimento da Equipe B (válido apenas no Contra Squad, Mata-Mata em Equipe e no Às Brincas).",
  T_31_WT_WS_DESC26: "Lança jogadores na direção que estiverem olhando (curta distância).",
  T_31_WT_WS_DESC27: "Lança jogadores na direção selecionada (curta distância).",
  T_31_WT_WS_DESC28: "Lança jogadores na direção selecionada (média distância).",
  T_31_WT_WS_DESC29: "Lança jogadores na direção selecionada (longa distância).",
  T_31_WT_WS_DESC3: "Enfeitado em vermelho e amarelo, pode ser usado para iluminar o campo de batalha.",
  T_31_WT_WS_DESC30: "Um carro bate-bate que pode ser dirigido.",
  T_31_WT_WS_DESC31: "Um carro anfíbio que pode ser dirigido.",
  T_31_WT_WS_DESC32: "Um jipe que pode ser dirigido.",
  T_31_WT_WS_DESC33: "Lotado de lixo. É mais baixo que uma pessoa adulta, mas pode servir como proteção.",
  T_31_WT_WS_DESC34: "Este abrigo metálico foi pensado para áreas abertas.",
  T_31_WT_WS_DESC35: "Uma tenda de tamanho médio com duas portas e sem janelas.",
  T_31_WT_WS_DESC36: "Uma grande garagem de tijolos.",
  T_31_WT_WS_DESC37: "Uma grande parede de tijolos que pode ser usada para dividir áreas.",
  T_31_WT_WS_DESC38: "Uma referência útil.",
  T_31_WT_WS_DESC39: "Uma plataforma de metal que pode ser usada como ringue.",
  T_31_WT_WS_DESC4: "Sua altura o tornam uma ótima proteção.",
  T_31_WT_WS_DESC40: "Veículo de passeio com diversas portas e janelas.",
  T_31_WT_WS_DESC41: "Veículo de passeio com uma porta e diversas janelas.",
  T_31_WT_WS_DESC42: "Uma parede com uma passagem.",
  T_31_WT_WS_DESC43: "Uma parede comum.",
  T_31_WT_WS_DESC44: "Uma quina de paredes.",
  T_31_WT_WS_DESC45: "Uma quina de paredes irregular.",
  T_31_WT_WS_DESC46: "Uma quina de paredes irregular.",
  T_31_WT_WS_DESC47: "Uma quina de paredes com janelas.",
  T_31_WT_WS_DESC5: "Um carro rebaixado abandonado que pode servir como proteção.",
  T_31_WT_WS_DESC6: "Sua altura o tornam uma ótima proteção.",
  T_31_WT_WS_DESC7: "Abre para ambos os lados e pode ser usado como passagem ou divisão de áreas.",
  T_31_WT_WS_DESC8: "Abre de apenas um lado e pode ser usado para a divisão de áreas.",
  T_31_WT_WS_DESC9: "Fechado em ambos os lados e pode ser usado para a divisão de áreas.",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Veículo",
  T_31_Z_OB_UAV: "Drone",
  T_32_C_SKILL_DESC_YAKUZA: "Dê uma arrancada para frente em rápida velocidade por [FFB300]{0}s[-]. Esta habilidade pode ser acumulada para até [FFB300]{2}[-] usos consecutivos. O uso consecutivo da habilidade terá tempo de recarga de [FFB300]{3}s[-] entre usos. Tempo de recarga da arrancada: [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Disparo Rebelde",
  T_32_HQ_AUG_VNSTREET_N: "AUG - Tigres das Ruas",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Mochila - Caça aos Dragões",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B - Amantes Eternos",
  T_32_HQ_GLOO_DUNHUANG_N: "Parede de Gel - Seguidores da Luz",
  T_32_HQ_GLOO_HURRICANE_2_N: "Parede de Gel - Chapa Quente",
  T_32_HQ_GRENADE_HURRICANE_N: "Granada - Chapa Quente",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - Seguidores da Luz",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Traje de Pet: PaTopinho Rubro",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Traje de Pet: Cascudinho Pró",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Traje de Pet: Cascudinho Metaleiro",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Traje de Pet: Cascudinho Festivo",
  T_32_HQ_TORTOISE_N: "Cascudinho",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Carro Esportivo - Tropa do Cemitério",
  T_32_L_F_A_PHARAOH: "Rainha Esquecida",
  T_32_L_F_B_PHARAOH: "Rainha Esquecida",
  T_32_L_F_H_PHARAOH: "Rainha Esquecida",
  T_32_L_F_HA_PHARAOH: "Rainha Esquecida",
  T_32_L_F_S_PHARAOH: "Rainha Esquecida",
  T_32_L_F_T_PHARAOH: "Rainha Esquecida",
  T_32_L_M_A_JUNKFOOD: "Atendente da Lanchonete",
  T_32_L_M_A_PHARAOH: "Múmia do Faraó",
  T_32_L_M_B_JUNKFOOD: "Atendente da Lanchonete",
  T_32_L_M_B_PHARAOH: "Múmia do Faraó",
  T_32_L_M_H_JUNKFOOD: "Atendente da Lanchonete",
  T_32_L_M_H_PHARAOH: "Múmia do Faraó",
  T_32_L_M_S_JUNKFOOD: "Atendente da Lanchonete",
  T_32_L_M_S_PHARAOH: "Múmia do Faraó",
  T_32_L_M_T_JUNKFOOD: "Atendente da Lanchonete",
  T_32_L_M_T_PHARAOH: "Múmia do Faraó",
  T_32_L_T_WHITESWEATER: "Gola Alta - Branca",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Zona imortal",
  T_32_LO_WS_ITEM60: "Cano",
  T_32_LO_WS_ITEM60_DESC: "Praticamente um túnel de acesso.",
  T_32_LO_WS_ITEM61: "Cano T",
  T_32_LO_WS_ITEM61_DESC: "Um túnel de acesso com forma de T.",
  T_32_LO_WS_ITEM62: "Intersecção de canos",
  T_32_LO_WS_ITEM62_DESC: "Uma intersecção de túneis de acesso.",
  T_32_LO_WS_ITEM63: "Cano de canto",
  T_32_LO_WS_ITEM63_DESC: "Praticamente um túnel de acesso.",
  T_32_LO_WS_ITEM64: "Food Truck",
  T_32_LO_WS_ITEM64_DESC: "O lugar perfeito para um lanchinho.",
  T_32_LO_WS_ITEM65: "Mush Shade",
  T_32_LO_WS_ITEM65_DESC: "Um grande cogumelo capaz de carregar um ser humano.",
  T_32_LO_WS_ITEM66: "Cabide",
  T_32_LO_WS_ITEM66_DESC: "Normalmente visto em áreas residenciais.",
  T_32_LO_WS_ITEM67: "Tábua de madeira",
  T_32_LO_WS_ITEM67_DESC: "Pode ser usada para criar uma ponte simples.",
  T_32_LO_WS_ITEM68: "Tela de treliça",
  T_32_LO_WS_ITEM68_DESC: "Um toque romântico no cenário.",
  T_32_LO_WS_ITEM69: "Pilar",
  T_32_LO_WS_ITEM69_DESC: "Normalmente visto em áreas de construção.",
  T_32_LO_WS_ITEM70: "Cacto",
  T_32_LO_WS_ITEM70_DESC: "Imponente e espinhento.",
  T_32_LO_WS_ITEM71: "Árvore sem folhas",
  T_32_LO_WS_ITEM71_DESC: "Uma árvore tão antiga quanto o tempo.",
  T_32_LO_WS_ITEM72: "Lanterna de pedra",
  T_32_LO_WS_ITEM72_DESC: "Decoração de jardins imperiais.",
  T_32_LO_WS_ITEM73: "Poste de luz",
  T_32_LO_WS_ITEM73_DESC: "Presença confirmada nas calçadas.",
  T_32_LO_WS_ITEM74: "Painel Solar",
  T_32_LO_WS_ITEM74_DESC: "Armazena a energia da luz do sol.",
  T_32_LO_WS_ITEM75: "Ar-condicionado A",
  T_32_LO_WS_ITEM75_DESC: "Perfeito para dias de calor.",
  T_32_LO_WS_ITEM76: "Ventilador",
  T_32_LO_WS_ITEM77: "Frigideira",
  T_32_LO_WS_ITEM78: "Cubo",
  T_32_LO_WS_ITEM79: "Anel",
  T_32_LO_WS_ITEM80: "Martelo",
  T_32_LO_WS_ITEM81: "Tábua",
  T_32_LO_WS_ITEM82: "Alvo",
  T_32_LO_WS_ITEM83: "Parede flexível",
  T_32_LO_WS_ITEM84AMMO: "Gerador de munição",
  T_32_LO_WS_ITEM84AMMO_DESC: "Ao instalá-lo, munições específicas aparecerão na área.",
  T_32_LO_WS_ITEM84AR: "Gerador de armaduras",
  T_32_LO_WS_ITEM84AR_DESC: "Ao instalá-lo, proteções específicas aparecerão na área.",
  T_32_LO_WS_ITEM84ARLV1: "Armadura Nv. 1.",
  T_32_LO_WS_ITEM84ARLV2: "Armadura Nv. 2.",
  T_32_LO_WS_ITEM84ARLV3: "Armadura Nv. 3.",
  T_32_LO_WS_ITEM84CO: "Gerador de consumíveis",
  T_32_LO_WS_ITEM84CO_DESC: "Ao instalá-lo, consumíveis específicos aparecerão na área.",
  T_32_LO_WS_ITEM84JA: "Gerador de arremessáveis",
  T_32_LO_WS_ITEM84JA_DESC: "Ao instalá-lo, arremessáveis específicos aparecerão na área.",
  T_32_LO_WS_ITEM84TE: "Gerador de miras",
  T_32_LO_WS_ITEM84TE_DESC: "Ao instalá-lo, miras específicas aparecerão na área.",
  T_32_LO_WS_ITEM84W: "Gerador de armas",
  T_32_LO_WS_ITEM84W_DESC: "Ao instalá-lo, armas específicas aparecerão na área.",
  T_32_LO_WS_ITEM85: "Zona da Ruína/Zona Imortal",
  T_32_LO_WS_ITEM85_DESC: "Ao instalá-lo, sobreviventes que pisarem na área sofrerão um efeito específico (imortalidade ou ruína).(Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_32_LO_WS_ITEM85CP: "Ponto de Checagem",
  T_32_LO_WS_ITEM85CP_DESC: "Um item essencial para o Modo Parkour. Os jogadores devem passar por cada Ponto de Checagem. Ao serem derrubados, os jogadores reaparecerão no último Ponto de Checagem pelo qual passaram. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_32_LO_WS_ITEM85TM: "Ponto Final",
  T_32_LO_WS_ITEM85TM_DESC: "(Disponível apenas em modos personalizados) Um item essencial para o Modo Parkour. É necessário chegar até a área do item para completar a partida. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_32_LO_WS_ITEM86: "Ponto de Surgimento",
  T_32_LO_WS_ITEM86_DESC: "Nenhuma equipe específica será direcionado para este ponto. Ao ser colocado, uma equipe aleatória aparecerá. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_32_LO_WS_ITEM86L: "Ponto de Surgimento (grande)",
  T_32_LO_WS_ITEM86L_DESC: "Um grande Ponto de Surgimento do Modo Parkour! É aqui que todos os jogadores ressurgirão. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_32_LO_WS_ITEM87: "Bloco",
  T_32_LO_WS_ITEM87_DESC: "Possibilita a personalização de tamanho.",
  T_32_LO_WS_ITEM88: "Rampa",
  T_32_LO_WS_ITEM88_DESC: "Uma rampa cujo tamanho pode ser ajustado",
  T_32_LO_WS_ITEMLINE: "Mudar",
  T_32_LO_WS_ITEMMOVE: "Configurações de gatilho",
  T_32_LO_WS_ITEMROT: "Transformar",
  T_32_LO_WS_ITEMSCALE: "Escala",
  T_32_LO_WS_KILLZONE: "Zona da Ruína",
  T_32_LO_WS_LOOT_AMMOTYPE: "Munição",
  T_32_LO_WS_LOOT_ARTYPE: "Armaduras",
  T_32_LO_WS_LOOT_COTYPE: "Consumíveis",
  T_32_LO_WS_LOOT_JATYPE: "Arremessável",
  T_32_LO_WS_LOOT_RANDOM: "Aleatório",
  T_32_LO_WS_LOOT_TETYPE: "Mira",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Armas",
  T_32_LO_WS_SCALEX: "Comprimento",
  T_32_LO_WS_SCALEY: "Altura",
  T_32_LO_WS_SCALEZ: "Largura",
  T_32_LO_WS_TRIGGERH: "Esconder.",
  T_32_LO_WS_TRIGGERHORP: "Mostrar/Esconder acionadores",
  T_32_LO_WS_TRIGGERP: "Mostrar",
  T_32_LO_WS_TRIGGERTYPE: "Tipo de gatilho",
  T_32_M_WS_MODE_ANNIHILATE: "Aniquilação",
  T_32_M_WS_MODE_SCORE: "Pontuação",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Combate com várias equipes",
  T_32_M_WS_ROUNDS: "Rodadas",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Passinho do BEATz",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Zona de Perigo",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Dano",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Zona de Perigo",
  T_32_T_WS_ME_CUSTOM: "Personalizar",
  T_32_T_WS_ME_ENDTYPE1: "Aniquilação",
  T_32_T_WS_ME_ENDTYPE2: "Pontuação",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Garanta que sua tropa aguente até o fim!",
  T_32_T_WS_ME_ENDTYPEDESC2: `Um modo por pontos em que vence a equipe que alcançar a pontuação definida primeiro.
Você pode configurar as regras e ajustar os parâmetros como quiser, incluindo quantos pontos valem por eliminação.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `Um modo parkour em que a equipe cujos membros chegarem primeiro no Ponto Final vence.
Você pode configurar as regras, os obstáculos e a linha de chegada como quiser.`,
  T_32_T_WS_ME_MATCHTIME: "Tempo de partida",
  T_32_T_WS_ME_MECHANIC: "Mecanismo",
  T_32_T_WS_ME_NEARCHECKPOINT: "Ponto de checagem próximo",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Não é possível ter mais de 12 jogadores no total",
  T_32_T_WS_ME_PREGAMETIME: "Tempo de preparação",
  T_32_T_WS_ME_RESPAWN: "Ressurgimentos",
  T_32_T_WS_ME_RESPAWNSETTING: "Ressurgimentos",
  T_32_T_WS_ME_ROUNDNUM: "Número de rodadas",
  T_32_T_WS_ME_ROUNDOPEN: "Habilitar múltiplas rodadas.",
  T_32_T_WS_ME_ROUNDRESET: "Redefinir rodadas",
  T_32_T_WS_ME_ROUNDSETTING: "Rodadas",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Duração da zona segura",
  T_32_T_WS_ME_SCORESETTING: "Pontuação",
  T_32_T_WS_ME_TEAMMATENUM: "Membros por equipe",
  T_32_T_WS_ME_TEAMNUM: "Número de equipes",
  T_32_T_WS_ME_TEAMSETTING: "Equipe",
  T_32_U_ATTACHMENT_8: "Bolsinha",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Chip Evolutivo",
  T_32_WT_WS_BARRIER: "Barreiras",
  T_32_WT_WS_BDS: "Construções",
  T_32_WT_WS_MMINVALIDERROR: "Código de mapa inválido.",
  T_32_WT_WS_TRGS: "Gatilhos",
  T_32_YF_CHARGESHOT_N: "Carga Extra",
  T_32_YF_GOLD_GROZA_N: "Groza - X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Dano extra",
  T_32_YS_WEAPON_TAG_3: "Taxa de disparo",
  T_32_YS_WEAPON_TAG_36: "Penetração de armadura",
  T_32_YS_WEAPON_TAG_39: "Modo akimbo disponível",
  T_32_YS_WEAPON_TAG_42: "Arma de Gel",
  T_33_C_SKILL_DESC_GRAFFITIST: "Cria uma área de [FFB300]{0}m[-] que bloqueia arremessáveis. Aliados na área restauram [FFB300]{1}%[-] de durabilidade de armadura por segundo. O dano causado por munição será reduzido em [FFB300]{2}%[-]. Dura [FFB300]{3}s[-]. Os efeitos não acumulam. Tempo de recarga: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_HITMAN: "Disparos de fuzis de precisão e fuzis de atirador são silenciados. Oponentes derrubados sangram [FFB300]{0}%[-] mais rápido.",
  T_33_C_SKILL_DESC_KENTA: "Cria um escudo frontal de [FFB300]{0}m[-] de largura que reduz o dano frontal de armas em [FFB300]{1}%[-]. Ao disparar, a redução de dano é diminuída em [FFB300]{2}%.[-] Dura [FFB300]{3}s[-]. Tempo de recarga: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Libera uma onda eletromagnética com o diâmetro de [FFB300]{0}m[-] que impede a ativação das habilidades dos oponentes, causa [FFB300]{3} de dano[-] e interrompe o tempo de recarga da interação deles. Dura [FFB300]{1}s[-]. Tempo de recarga: [FFB300]{2}s.[-]",
  T_33_C_SKILL_NAME_BODYGUARD: "Lutadora",
  T_33_C_SKILL_NAME_KENTA: "Proteção do Samurai",
  T_33_C_SKILL_NAME_MADEMANA: "Emoção da Batalha",
  T_33_DY_AXOLOTL_N: "Samalandra",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Traje de Pet: Samalandra Melancia",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Traje de Pet: PaTopinho de Sentosa",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Traje de Pet: Falcão da Noite",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Bastão - Baguete",
  T_33_HQ_EMOTE_SONGKRAN_N: "Emote Bora Dançar",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - Cybermano",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Granada - Cybermano",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Faces Flamejantes",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - iPeoa",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Guerreiros de Sentosa",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - Guerreiros de Sentosa",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Foice - Druida da Floresta",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Adaga - Faca Guerreiros de Sentosa",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector - Cybermina",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jipe - Druida da Floresta",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Caminhão Monstro - Leão de Fogo",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Picape - Guerreiros de Sentosa",
  T_33_LO_WS_BHPARA_A: "Ativa",
  T_33_LO_WS_BHPARA_ATKMODE: "Tipo de ataque",
  T_33_LO_WS_BHPARA_GROUP: "Equipe",
  T_33_LO_WS_BHPARA_NA: "Sem ataques",
  T_33_LO_WS_BHPARA_P: "Passiva",
  T_33_LO_WS_DICE_DESC: "Use este dado para melhorar os pulos. Pode ser usado em diversos estilos de jogo.",
  T_33_LO_WS_DICEVXZ: "Velocidade horizontal",
  T_33_LO_WS_DICEVY: "Velocidade vertical",
  T_33_LO_WS_DTOWER: "Torre",
  T_33_LO_WS_DTOWER_DESC: "Ataca oponentes dentro de uma certa distância automaticamente. Função desabilidades caso a vida chegue a zero. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_33_LO_WS_FORT: "Fortaleza",
  T_33_LO_WS_FORT_DESC: "Ataca oponentes dentro de uma certa distância automaticamente. Função desabilidades caso a vida chegue a zero. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_33_LO_WS_ITEM89: "Tanque da Refinaria",
  T_33_LO_WS_ITEM89_DESC: "Uma estrutura de reservatório de água.",
  T_33_LO_WS_ITEM90: "Casa de cachorro",
  T_33_LO_WS_ITEM90_DESC: "Um lar para os filhotinhos.",
  T_33_LO_WS_ITEM91: "Ponto de ônibus",
  T_33_LO_WS_ITEM91_DESC: "Um ponto de ônibus comum.",
  T_33_LO_WS_ITEM92: "Parede Grafitada",
  T_33_LO_WS_ITEM92_DESC: "Uma parede pintada com spray.",
  T_33_LO_WS_ITEM93: "Estábulo",
  T_33_LO_WS_ITEM93_DESC: "Uma estrutura básica de palha.",
  T_33_LO_WS_ITEM94: "Banco",
  T_33_LO_WS_ITEM94_DESC: "Um banco de parque.",
  T_33_LO_WS_ITEM95: "Ponte de Pedra",
  T_33_LO_WS_ITEM95_DESC: "Uma ponte construída com pedras.",
  T_33_LO_WS_ITEM96: "Sombra",
  T_33_LO_WS_ITEM96_DESC: "Protege contra queimaduras solares.",
  T_33_LO_WS_ITEM97: "Arco da linha de chegada",
  T_33_LO_WS_ITEM97_DESC: "Indica o fim da pista.",
  T_33_LO_WS_ITEM98: "Painel de Anúncios",
  T_33_LO_WS_ITEM98_DESC: "Um painel para propagandas.",
  T_33_LO_WS_PARA_DM: "Dano",
  T_33_LO_WS_PARA_HP: "Vida",
  T_33_LO_WS_PARA_RANGE: "Distância pra detectar oponentes",
  T_33_LO_WS_PARA_SP: "Velocidade",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zumbis por onda",
  T_33_LO_WS_ZBPARA_INTERVAL: "Intervalo entre ondas (s)",
  T_33_LO_WS_ZBPARA_ROUND: "Nº de ondas",
  T_33_LO_WS_ZBSPAWNER: "Onda de Zumbis",
  T_33_LO_WS_ZBSPAWNER_DESC: "Libera zumbis automaticamente. O comportamento dos zumbis pode ser configurado. (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Subir de nível",
  T_33_RW_SKILL_DESC_GANGGIRL: "Aumenta a taxa de disparo em [FFB300]{0}%[-]. Ao acertar um oponente, um máximo de [FFB300]{1}%[-] da taxa de disparo será convertida em velocidade de movimento. A conversão reiniciará depois de sobreviver ao combate.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Capa e Tchau",
  T_33_WT_WS_BASICSET1: "Básico",
  T_33_WT_WS_QCEPRTIP: "Converte energia em vida mais rápido.",
  T_33_WT_WS_SKILLSET_TAG: "Habilidade ilimitada",
  T_33_WT_WS_SKILLSET1: "Configurações de habilidades",
  T_33_WT_WS_SKILLSET10: "Escudo Tunado (Chrono)",
  T_33_WT_WS_SKILLSET11: "Quebradeira (Skyler)",
  T_33_WT_WS_SKILLSET12: "Dano Radical (Xtrema)",
  T_33_WT_WS_SKILLSET13: "Batida da Cura (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Habilidade passivas",
  T_33_WT_WS_SKILLSET2_TIP: "Ativas/Desativar habilidades passivas",
  T_33_WT_WS_SKILLSET3: "Habilidades ativas (ative para ajustar o tempo de recarga).",
  T_33_WT_WS_SKILLSET3_TIP: "Ativar/Desativar habilidades ativas. Configure o tempo de recarga abaixo.",
  T_33_WT_WS_SKILLSET4: "Ilusão",
  T_33_WT_WS_SKILLSET5: "Emoção da Batalha (A124)",
  T_33_WT_WS_SKILLSET6: "Som na Caixa (Alok)",
  T_33_WT_WS_SKILLSET7: "Abrigo de Tinta (Steffie)",
  T_33_WT_WS_SKILLSET8: "Entregando o Ouro (Evelyn)",
  T_33_WT_WS_SKILLSET9: "Lição do Professor (Kamir)",
  T_33_WT_WS_UNIT_HPSECOND: "Vida/segundo",
  T_33_WT_WS_UNIT_METER: "Metros",
  T_33_WT_WS_UNIT_SECOND: "Segundo",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Psicopato",
  T_33_YS_H_ONIGIRI: "Um Bolinho de Arroz",
  T_33_YS_H_RAINCOAT: "Psicopato",
  T_33_YS_HA_CRYINGFACE: "Emote Chorão",
  T_33_YS_M_H_FROGKING: "Príncipe Sapo",
  T_33_YS_S_RAINCOAT: "Psicopato",
  T_33_YS_T_BLACKHOLE: "Moletom Efeito Doppler",
  T_33_YS_T_RAINCOAT: "Psicopato",
  T_33_YS_T_SOCCER_GREEN: "Booyah Futebol Clube (Verde)",
  T_33_YS_T_SOCCER_YELLOW: "Booyah Futebol Clube (Amarelo)",
  T_33_YS_T_WIFI: "Camiseta Rede do Amor",
  T_34_C_SKILL_DESC_STREAMERGUY: "Cada abate ou espectador garante um acúmulo do efeito. Cada acúmulo reduz o dano sofrido por acertos na cabeça em [FFB300]{0}%[-] (máx. [FFB300]{1}%[-]) e aumenta o dano de acerto na cabeça causado em oponentes em [FFB300]{2}%[-] (máx. [FFB300]{3}%[-]).",
  T_34_C_SKILL_DESC_TRACKER: "Solta um drone frontal dentro de [FFB300]100m[-] de distância frontal, criando uma explosão de [FFB300]{5}m de diâmetro[-] que reduz a velocidade de movimento em [FFB300]{0}%[-] e a velocidade de disparo em [FFB300]{1}%[-]. Dura [FFB300]{3}s[-]. Causa [FFB300]{2} de dano[-]. Tempo de recarga: [FFB300]{4}s[-].",
  T_34_C_SKILL_NAME_TRACKER: "Olho de Argos",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Traje de Pet: Barão Furioso",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Traje de Pet: Barão Tempestuoso",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Traje de Pet: Barão Nebuloso",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Traje de Pet: Mestre do Estilo",
  T_34_DY_SURFSHARK_N: "Barão Turbo",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Emote Maestro",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Passinho da Alegria",
  T_34_HQ_EMOTE_RIDICULE_N: "Folgando",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Picape - Engenheiro do Mal",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuc Tuc - Lobinho de Inverno",
  T_34_JL_EAGLE_RAMPAGE4_N: "Águia do Deserto - Mestre da Batalha",
  T_34_JL_G36_MADBIONIC_N: "G36 - Lutadores Biônicos",
  T_34_JL_GRENADE_BIS_N: "Granada - Estilo de Batalha",
  T_34_JL_MACHETE_RAMPAGE4_N: "Machete - Maestro das Nuvens",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Adaga - Bananada",
  T_34_JL_UMP45_BIS_N: "UMP - Estilo de Batalha",
  T_34_LY_WS_ABS_DESC: "Verifique o valor absoluto",
  T_34_LY_WS_ADD_DESC: "Adicione elementos novos no final de uma lista",
  T_34_LY_WS_AUTO_A: "Detectar oponentes automaticamente",
  T_34_LY_WS_BOT: "Regular",
  T_34_LY_WS_BOT_PATH: "Caminho",
  T_34_LY_WS_BOT_TYPE: "Tipo",
  T_34_LY_WS_BOT4: "Dilacerador",
  T_34_LY_WS_BOT5: "Repugnante",
  T_34_LY_WS_BOT6: "Bombástico",
  T_34_LY_WS_BOT8: "Blindado",
  T_34_LY_WS_COL_DESC: "Selecionar a cor",
  T_34_LY_WS_DEL_DESC: "Deletar o elemento correspondente a determinada posição em uma lista",
  T_34_LY_WS_DF_PER: "Defesa (%)",
  T_34_LY_WS_FORT_INTERVAL: "Intervalo de tempo de ataque (s)",
  T_34_LY_WS_GET: "Conseguir",
  T_34_LY_WS_GET_DESC: "Conseguir o elemento correspondente a determinada posição em uma lista",
  T_34_LY_WS_GLEN_ARR_DESC: "Conseguir o número de elementos da lista atual",
  T_34_LY_WS_GLEN_DESC: "Conseguir o comprimento deste segmento de texto",
  T_34_LY_WS_GVX: "Conseguir o componente x do vetor",
  T_34_LY_WS_GVX_DESC: "Conseguir o primeiro componente do vetor",
  T_34_LY_WS_GVY: "Conseguir o componente y do vetor",
  T_34_LY_WS_GVY_DESC: "Conseguir o segundo componente do vetor",
  T_34_LY_WS_GVZ: "Conseguir o componente z do vetor",
  T_34_LY_WS_GVZ_DESC: "Conseguir o terceiro componente do vetor",
  T_34_LY_WS_INDEX: "Índice",
  T_34_LY_WS_JOIN: "Conectar",
  T_34_LY_WS_NEG_DESC: "Conseguir o valor negativo deste número",
  T_34_LY_WS_PATH: "Definidor de caminho",
  T_34_LY_WS_PATH_DESC: "Use para determinar o caminho de itens especiais em movimento (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_34_LY_WS_POINT: "Marcador",
  T_34_LY_WS_POINT_DESC: "Use para marcar a posição atual (Inválido para os modos Contra Squad, Mata-Mata em Equipe e Às Brincas).",
  T_34_LY_WS_RANGE_F: "Longe",
  T_34_LY_WS_RANGE_M: "Mediano",
  T_34_LY_WS_RANGE_N: "Próximo",
  T_34_LY_WS_RNDF_DESC: "Gerar um decimal aleatório a partir do intervalo",
  T_34_LY_WS_RNDI_DESC: "Gerar um número inteiro aleatório a partir do intervalo",
  T_34_LY_WS_SET: "Configurar",
  T_34_LY_WS_SET_DESC: "Definir o elemento correspondente a determinada posição em uma lista",
  T_34_LY_WS_SQRT_DESC: "Conseguir a raiz quadrada deste número",
  T_34_LY_WS_STRC_DESC: "Conectar dois segmentos de texto",
  T_34_LY_WS_SVX: "Definir o componente x do vetor",
  T_34_LY_WS_SVX_DESC: "Definir o primeiro componente do vetor",
  T_34_LY_WS_SVY: "Definir o componente y do vetor",
  T_34_LY_WS_SVY_DESC: "Definir o segundo componente do vetor",
  T_34_LY_WS_SVZ: "Definir o componente z do vetor",
  T_34_LY_WS_SVZ_DESC: "Definir o terceiro componente do vetor",
  T_34_LY_WS_VADD: "Adicionar vetor",
  T_34_LY_WS_VADD_DESC: "Adicionar dois vetores",
  T_34_LY_WS_VAL_DESC: "Inserir um número inteiro ou decimal de acordo com o cenário",
  T_34_LY_WS_VANG_DESC: "Calcular o ângulo entre dois vetores",
  T_34_LY_WS_VCP: "Produto cruzado",
  T_34_LY_WS_VCP_DESC: "Calcular o produto cruzado de dois vetores",
  T_34_LY_WS_VDIS_DESC: "Calcular a distância entre dois vetores",
  T_34_LY_WS_VDP: "Produto escalar",
  T_34_LY_WS_VDP_DESC: "Calcular o produto escalar de dois vetores",
  T_34_LY_WS_VFX1: "Esférico",
  T_34_LY_WS_VFX2: "Cilíndrico",
  T_34_LY_WS_VFX3: "Anelar",
  T_34_LY_WS_VFX4: "Explosão",
  T_34_LY_WS_VFX5: "Pixelado",
  T_34_LY_WS_VFX6: "Faíscas",
  T_34_LY_WS_VMOD_DESC: "Calcular a magnitude do vetor",
  T_34_LY_WS_VMUL: "Multiplicação vetorial",
  T_34_LY_WS_VMUL_DESC: "Multiplicar dois vetores",
  T_34_LY_WS_VNOR_DESC: "Normalizar um vetor",
  T_34_LY_WS_VSUB: "Subtração vetorial",
  T_34_LY_WS_VSUB_DESC: "Subtrair dois vetores",
  T_34_M_WS_ANGLE: "Ângulo de rotação",
  T_34_M_WS_ARRAY: "Lista",
  T_34_M_WS_ATT: "Propriedade",
  T_34_M_WS_BOOL: "Booleano",
  T_34_M_WS_COLORARRAY: "Lista de cores",
  T_34_M_WS_COLOUR: "Cor",
  T_34_M_WS_CONFRONBANNER: "Bandeira de Batalha",
  T_34_M_WS_COORDINATE: "Coordenadas",
  T_34_M_WS_CUSTOMINF: "Personalizar HUD",
  T_34_M_WS_CUSTOMMODEDESC: `Um modo vazio e totalmente personalizável, sem regras pré-definidas. Você cria e joga do seu jeito.
Pode ser um pouco mais desafiador pra quem tá começando a criar mapas.`,
  T_34_M_WS_DAMAGETYPE: "Tipo de dano",
  T_34_M_WS_DAMAGETYPEDESC: "O tipo de dano definido atualmente pelo sistema",
  T_34_M_WS_DESCTEXT: "Texto descritivo",
  T_34_M_WS_DURACTION: "Duração",
  T_34_M_WS_ECAMODE: "Modo Customizado",
  T_34_M_WS_ENDPHASEDESC: "Terminar imediatamente a etapa atual e continuar para a próxima",
  T_34_M_WS_ENTITY: "Entidade",
  T_34_M_WS_FLOAT: "Decimal",
  T_34_M_WS_GAME: "Partida",
  T_34_M_WS_GAMERESULTS: "Resultado de partida",
  T_34_M_WS_GETCONTROL2: "Obtenha controle das propriedades na interface de outros jogadores (incluindo projetos, cores, conteúdos etc.)",
  T_34_M_WS_HEIGHT: "Altura",
  T_34_M_WS_HUDBUTTONWIDGET: "Controle de botão",
  T_34_M_WS_HUDEMPTYWIDGET: "Pivô vazio",
  T_34_M_WS_HUDIMAGEWIDGET: "Controle de imagem",
  T_34_M_WS_HUDINPUTWIDGET: "Controle de caixa de texto",
  T_34_M_WS_HUDLABELWIDGET: "Controle de texto",
  T_34_M_WS_ICON: "Ícone",
  T_34_M_WS_ICON_AIM: "Apontar",
  T_34_M_WS_ICON_ARROW: "Arco",
  T_34_M_WS_ICON_BLAST: "Explosão",
  T_34_M_WS_ICON_CIRCULAR: "Círculo",
  T_34_M_WS_ICON_CLOTH: "Palmeira",
  T_34_M_WS_ICON_COLLIMATION: "Mira",
  T_34_M_WS_ICON_CORPSE: "Zumbi",
  T_34_M_WS_ICON_CROSS: "Cruzamento",
  T_34_M_WS_ICON_DAY: "Sol",
  T_34_M_WS_ICON_DEFENSE: "Escudo",
  T_34_M_WS_ICON_DIALOGUE: "Diálogo",
  T_34_M_WS_ICON_DIAMONDS: "Diamante",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Ponto de exclamação",
  T_34_M_WS_ICON_FLAG: "Bandeira",
  T_34_M_WS_ICON_FOLDER: "Pasta",
  T_34_M_WS_ICON_GLASSES: "Olho",
  T_34_M_WS_ICON_GUN: "Arma",
  T_34_M_WS_ICON_HEART: "Coração",
  T_34_M_WS_ICON_HEXAGON: "Hexágono",
  T_34_M_WS_ICON_HOURGLASS: "Ampulheta",
  T_34_M_WS_ICON_HOUSE: "Casa",
  T_34_M_WS_ICON_KEY: "Chave",
  T_34_M_WS_ICON_LIGHTNING: "Raio",
  T_34_M_WS_ICON_LOCK: "Trancar",
  T_34_M_WS_ICON_LOOP: "Ciclo",
  T_34_M_WS_ICON_MAGNIFIER: "Lente de aumento",
  T_34_M_WS_ICON_MONEY: "Dinheiro",
  T_34_M_WS_ICON_MONTH: "Lua",
  T_34_M_WS_ICON_OPENFOLDER: "Abrir pasta",
  T_34_M_WS_ICON_PLUS: "Mais",
  T_34_M_WS_ICON_QUADRI: "Quadrilateral",
  T_34_M_WS_ICON_QUESTIONMARK: "Ponto de interrogação",
  T_34_M_WS_ICON_RECYCLING: "Reciclar",
  T_34_M_WS_ICON_REFRESH: "Atualizar",
  T_34_M_WS_ICON_REST: "Repouso",
  T_34_M_WS_ICON_RETURN: "Voltar",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Trapezoide direito",
  T_34_M_WS_ICON_SCISSORS: "Tesoura",
  T_34_M_WS_ICON_SETUP: "Configuração",
  T_34_M_WS_ICON_SIGN: "Marcar",
  T_34_M_WS_ICON_SIGNOUT: "Sair",
  T_34_M_WS_ICON_SQUARE: "Quadrado",
  T_34_M_WS_ICON_STAR: "Estrela",
  T_34_M_WS_ICON_STONE: "Pedra",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Lagoa",
  T_34_M_WS_ICON_TAGGING: "Marcar",
  T_34_M_WS_ICON_THESWORD: "Espada",
  T_34_M_WS_ICON_TRAPEZOID: "Trapezoide",
  T_34_M_WS_ICON_TRASHCAN: "Lata de lixo",
  T_34_M_WS_ICON_TRIANGLE: "Triângulo",
  T_34_M_WS_ICON_TROPHY: "Troféu",
  T_34_M_WS_ICON_UP: "Polegar pra cima",
  T_34_M_WS_ICON_WRONG: "Errado!",
  T_34_M_WS_ICON_YES: "Direita",
  T_34_M_WS_ICONNAME: "Nome do ícone",
  T_34_M_WS_INT: "Inteiro",
  T_34_M_WS_KILLZONE: "Zona da Ruína",
  T_34_M_WS_LEFTCOLOR: "Cor esquerda",
  T_34_M_WS_LEFTTEAMINDEX: "Índice da equipe a esquerda",
  T_34_M_WS_LEFTTEAMSCORE: "Pontuação da equipe a esquerda",
  T_34_M_WS_LOCSWITCH: "Trocar localização",
  T_34_M_WS_MAX: "Máximo",
  T_34_M_WS_MIN: "Mínimo",
  T_34_M_WS_NUMBER: "Quantidade",
  T_34_M_WS_OBJECT: "Entidade",
  T_34_M_WS_OPEN: "Ligado",
  T_34_M_WS_OPENSATUS: "Ligar estado",
  T_34_M_WS_PICTURE: "Gráficos",
  T_34_M_WS_RANKARRAY: "Lista de patente",
  T_34_M_WS_RESULTS: "Resultados",
  T_34_M_WS_RIGHTCOLOR: "Cor direita",
  T_34_M_WS_RIGHTTEAMINDEX: "Índice da equipe a direita",
  T_34_M_WS_RIGHTTEAMSCORE: "Pontuação da equipe a direita",
  T_34_M_WS_ROUNDBANNER: "Bandeira de rodada",
  T_34_M_WS_ROUNDDESC: "Descrição da rodada",
  T_34_M_WS_ROUNDHUD: "Número de rodadas",
  T_34_M_WS_ROUNDPARAMS: "Lista do número de rodadas",
  T_34_M_WS_SAME_NAME: "Nome repetido. Tente outro nome.",
  T_34_M_WS_SCOREARRAY: "Lista de pontuação",
  T_34_M_WS_SCORINGTYPE: "Tipo de pontuação",
  T_34_M_WS_SCORINGTYPEDECS: "O tipo de pontuação que os jogadores podem conseguir. Compatível com personalização de pontuação.",
  T_34_M_WS_SCUFFLESCORING: "Pontuação de múltiplas equipes",
  T_34_M_WS_SETATTRIBUTES: "Configuração de propriedades",
  T_34_M_WS_SHUT: "Desligado",
  T_34_M_WS_SOUND: "Efeitos sonoros",
  T_34_M_WS_SOUNDCLICK: "Tocar",
  T_34_M_WS_SOUNDDD: "Contagem regressiva",
  T_34_M_WS_SOUNDFEMALEA: "Ferida",
  T_34_M_WS_SOUNDM: "Armas de fogo",
  T_34_M_WS_SOUNDMALEA: "Ferido",
  T_34_M_WS_SOUNDUAV: "Explosão",
  T_34_M_WS_ST_ASSISTCOUNT: "Ajuda",
  T_34_M_WS_ST_CHECKPROGRESS: "Progresso de ponto de checagem",
  T_34_M_WS_ST_DAMAGESUM: "Dano",
  T_34_M_WS_ST_FINISHCOUNT: "Objetivos atingidos",
  T_34_M_WS_ST_FINISHORDER: "Ordem dos objetivos atingidos",
  T_34_M_WS_ST_FINISHTIME: "Momento dos objetivos atingidos",
  T_34_M_WS_ST_KILLCOUNT: "Abates",
  T_34_M_WS_ST_MAINSCORE: "Pontuação do alvo",
  T_34_M_WS_ST_RANKSCORE: "Pontuação de patente",
  T_34_M_WS_ST_SURVIVALDURACTION: "Tempo de sobrevivência",
  T_34_M_WS_ST_UNKOWN: "Desconhecido",
  T_34_M_WS_STARTBANNER: "Bandeira de início",
  T_34_M_WS_STARTTIME: "Momento do começo",
  T_34_M_WS_STRING: "Texto",
  T_34_M_WS_STUDIO: "ESTÚDIO FF",
  T_34_M_WS_TEAMARRAY: "Lista de equipe",
  T_34_M_WS_TEXTCONTENT: "Conteúdo",
  T_34_M_WS_THEMECOLOR: "Cor do tema",
  T_34_M_WS_TIME: "HUD de contagem regressiva",
  T_34_M_WS_TITLETEXT: "Título do texto",
  T_34_M_WS_TYPE: "Tipo",
  T_34_M_WS_UODATETYPE: "Atualizar tipo",
  T_34_M_WS_VARNAME: "Nome da variável",
  T_34_M_WS_VECTOR: "Vector",
  T_34_M_WS_VFX: "Efeitos visuais",
  T_34_M_WS_WIDTH: "Largura",
  T_34_MF_CHARACTER_TRACKER_N: "Homero",
  T_34_PD_FlagBattle_HYPE_1: "Fogo",
  T_34_SP_WS_BLOCK1_NAME: "Trocar fase",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Troque de fase em uma partida para ir para a fase ou rodada desejada. As rodadas também contam com índices de fase e são consideradas um tipo especial de fase.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "Indica a fase alvo",
  T_34_SP_WS_BLOCK10_NAME: "Criar efeitos visuais",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Crie um ícone usando efeitos visuais específicos. Mais propriedades dos efeitos visuais podem ser configuradas ao ajustar as propriedades da entidade efeitos visuais.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Efeitos visuais",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Os tipos de efeitos visuais que podem ser usados.",
  T_34_SP_WS_BLOCK12_NAME: "Deletar efeitos visuais",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Deletar o efeito visual selecionado",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entidade efeitos visuais",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "A entidade efeito visual a ser deletada",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Pedir para o sistema tocar o efeito visual",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Lista de jogadores",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "A lista dos jogadores que receberão a mensagem",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Caminho de recursos",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Caminho de recursos do sistema em rota. Caminho de recursos do sistema fora de rota. Vazio por padrão.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Canal RGBA - cada canal tem um valor entre 0 e 255 salvos em int32. Cor padrão é branco (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Aproximar",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Escala de aproximação; padrão é 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Posição do visor expressas em coordenadas globais. Vetor3(0) por padrão.",
  T_34_SP_WS_BLOCK14_NAME: "Tocar efeito sonoro",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Pedir para o sistema tocar o efeito sonoro",
  T_34_SP_WS_BLOCK15_NAME: "Registro de saída",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Incluir no registro da interface o conteúdo de saída",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Ative para permitir dano contra jogadores fora da zona segura",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Ponto central da zona segura",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Raio",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "O raio da zona segura",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Contagem regressiva para a zona segura começar a diminuir",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "O tempo que leva para a zona segura diminuir",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "A quantidade de dano recebido foram da zona segura",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Desative para impedir dano contra jogadores fora da zona segura",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Use para atrasar uma ação subsequente para um momento específico",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "A duração da espera medida em milissegundos",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Use para postergar uma ação subsequente para um quadro específico",
  T_34_SP_WS_BLOCK6_NAME: "Criar HUD personalizada",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Criar uma HUD personalizada",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "O nome usado para criar a entidade HUD. A variável local correspondente é a entidade do HUD sendo criado.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Jogador",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "A entidade de um jogador específico. Visível apenas para o jogador em questão.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Índice único de HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Crie um HUD padrão visível apenas para jogadores específicos",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Quando deletado, o HUD padrão não será visível (escondido ou descartado)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "Entidade HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "A entidade de HUD a ser deletada",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Quando deletada, a HUD personalizada não será visível (escondida ou descartada)",
  T_34_T_WS_BLOCK1_NAMEDESC: "O incidente começa quando a partida começar",
  T_34_T_WS_BLOCK10_NAMEDESC: "O incidente começa quando alguém é abatido",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "O jogador abatido irá iniciar o incidente",
  T_34_T_WS_BLOCK13_NAMEDESC: "O incidente começa quando alguém ajudar outro jogador",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "O jogador abatido",
  T_34_T_WS_BLOCK14_NAMEDESC: "O incidente começa quando alguém causa dano",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "O jogador que recebe o dano",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "O tipo de dano causado",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "A quantidade de dano causado",
  T_34_T_WS_BLOCK15_NAMEDESC: "O incidente começa quando alguém abater outro jogador",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "O jogador abatido",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "O tipo de dano que causa o abate",
  T_34_T_WS_BLOCK16_NAMEDESC: "O incidente começa quando alguém entra na partida",
  T_34_T_WS_BLOCK17_NAMEDESC: "O incidente começa quando alguém é revivido",
  T_34_T_WS_BLOCK18_NAMEDESC: "O incidente começa quando uma equipe é removida",
  T_34_T_WS_BLOCK19_NAMEDESC: "O incidente começa quando uma equipe é adicionada",
  T_34_T_WS_BLOCK2_NAMEDESC: "O incidente começa quando a partida acabar",
  T_34_T_WS_BLOCK20_NAMEDESC: "O incidente começa quando uma equipe é completamente abatida",
  T_34_T_WS_BLOCK3_NAMEDESC: "O incidente começa quando cada rodada começa",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "O número de rodadas começa em 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Índice de rodadas",
  T_34_T_WS_BLOCK4_NAMEDESC: "O incidente começa quando cada rodada acabar",
  T_34_T_WS_BLOCK5_NAMEDESC: "O incidente começa quando a fase acabar",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "O número de fases começa em 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Entidade de fase",
  T_34_T_WS_BLOCK6_NAMEDESC: "O incidente começa quando a fase acabar",
  T_34_T_WS_BLOCK7_NAMEDESC: "O incidente começa quando alguém sai da partida",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "O jogador que irá iniciar o incidente",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Jogador iniciador",
  T_34_T_WS_BLOCK8_NAMEDESC: "O incidente começa quando a pontuação de um jogador mudar",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "O tipo de pontuação que mudou",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "O valor da pontuação depois da mudança",
  T_34_T_WS_BLOCK9_NAMEDESC: "O incidente começa quando a pontuação de uma equipe mudar",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "A equipe que irá iniciar o incidente",
  T_34_WT_WS_BORNENTITY_PARAM1: "Ponto de Surgimento",
  T_34_WT_WS_BORNENTITY_PARAM2: "Coordenadas disponíveis",
  T_34_WT_WS_BORNENTITY_PARAM3: "Definir como ponto de surgimento padrão",
  T_34_WT_WS_BORNENTITY_PARAM4: "Fronteiras brilhantes",
  T_34_WT_WS_BORNENTITY_PARAM5: "Em uso ou não",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "HUD de ponto de checagem",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Abrir situação",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Gatilho de situação",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Gatilho de abate ou não",
  T_34_WT_WS_ENTITY_PARAM1: "Entidade de jogo",
  T_34_WT_WS_ENTITY_PARAM10: "N.º de equipes",
  T_34_WT_WS_ENTITY_PARAM11: "N.º de membros do equipe",
  T_34_WT_WS_ENTITY_PARAM12: "O equipamento é redefinido a cada rodada",
  T_34_WT_WS_ENTITY_PARAM13: "Ativar dano fora da zona segura",
  T_34_WT_WS_ENTITY_PARAM14: "Tamanho da zona",
  T_34_WT_WS_ENTITY_PARAM15: "Tempo para a zona segura começar a diminuir",
  T_34_WT_WS_ENTITY_PARAM16: "Duração da zona segura",
  T_34_WT_WS_ENTITY_PARAM17: "Dano fora da zona segura",
  T_34_WT_WS_ENTITY_PARAM18: "Pontuação do alvo",
  T_34_WT_WS_ENTITY_PARAM19: "Pontuação de abate",
  T_34_WT_WS_ENTITY_PARAM2: "Situação inválida",
  T_34_WT_WS_ENTITY_PARAM20: "Tipo de retorno",
  T_34_WT_WS_ENTITY_PARAM21: "Critério de pontuação por rodada (jogador)",
  T_34_WT_WS_ENTITY_PARAM22: "Importância dos critérios (jogador)",
  T_34_WT_WS_ENTITY_PARAM23: "Critério de pontuação por rodada (equipe)",
  T_34_WT_WS_ENTITY_PARAM24: "Importância dos critérios (equipe)",
  T_34_WT_WS_ENTITY_PARAM25: "Critério de pontuação por rodada (melhor da partida)",
  T_34_WT_WS_ENTITY_PARAM26: "Importância dos critérios (melhor da partida)",
  T_34_WT_WS_ENTITY_PARAM27: "Pontuação por rodada",
  T_34_WT_WS_ENTITY_PARAM28: "Mostrar os critérios na página de resultados",
  T_34_WT_WS_ENTITY_PARAM29: "N.º total de rodadas",
  T_34_WT_WS_ENTITY_PARAM3: "Hora da partida",
  T_34_WT_WS_ENTITY_PARAM4: "Índice de rodada atual",
  T_34_WT_WS_ENTITY_PARAM5: "Índice de fase atual",
  T_34_WT_WS_ENTITY_PARAM6: "Identificação de padrão de modo",
  T_34_WT_WS_ENTITY_PARAM7: "Ativar retorno de jogadores",
  T_34_WT_WS_ENTITY_PARAM8: "Ativar retorno de robôs",
  T_34_WT_WS_ENTITY_PARAM9: "Tempo de retorno",
  T_34_WT_WS_ENTITY1_NAME: "Entidade atual",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Voltar para a entidade atual",
  T_34_WT_WS_ENTITY10_NAME: "Remover ícone",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Remover um ícone específico",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Selecione o ícone que deseja remover",
  T_34_WT_WS_ENTITY11_NAME: "Remover texto",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Remover a entidade texto",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Selecione o texto que deseja remover",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Adicionar um item para jogadores específicos",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Jogadores que receberão o item",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "O ID do item específico a ser conseguido",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "A quantidade de itens específicos a serem dados",
  T_34_WT_WS_ENTITY12_PARAM3: "Quantidade",
  T_34_WT_WS_ENTITY13_PARAM1: "Tipo",
  T_34_WT_WS_ENTITY13_PARAM2: "Localização",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "As coordenadas do objeto gerado",
  T_34_WT_WS_ENTITY13_PARAM4: "Objeto",
  T_34_WT_WS_ENTITY14_NAME: "Remover objeto",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Remover um objeto específico",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Deletar o objeto",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Adquirir todas as entidades de jogador",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Adquirir todas as entidades de equipe",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Recupere uma quantidade de vida específica de jogadores específicos. Se a recuperação exceder a vida máxima, somente será recuperada vida até o valor máximo.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Jogador(es) cuja flutuação de vida está(ão) sendo configurada(s)",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "A quantidade específica de vida a ser recuperada.",
  T_34_WT_WS_ENTITY18_NAME: "Obter coordenadas de surgimento aleatório",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Configure o local para jogadores específicos surgirem ou ressurgirem",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Jogador(es) que irá(ão) surgir aleatoriamente neste local",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Coordenadas de para onde os jogadores serão colocados",
  T_34_WT_WS_ENTITY19_NAME: "Obter a pontuação do jogador",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Resgatar a pontuação de jogadores específicos",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Resgatar a entidade pontuação de determinado jogador",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Resgatar o tipo de pontuação",
  T_34_WT_WS_ENTITY19_RETURNDESC: "A pontuação específica a ser conseguida",
  T_34_WT_WS_ENTITY2_NAME: "Definir propriedade",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Configure o valor da propriedade aonde o tipo de propriedade já foi selecionado",
  T_34_WT_WS_ENTITY2_PARAM1: "Entidade",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "O valor da propriedade da entidade do jogo",
  T_34_WT_WS_ENTITY2_PARAM3: "Propriedade",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Uma propriedade específica desta entidade do jogo",
  T_34_WT_WS_ENTITY2_PARAM4: "Valor",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "O valor específico da propriedade. Garanta que o tipo de propriedade esteja alinhada com o tipo configurado nos blocos relacionados.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Configurar determinadas pontuações para jogadores específicos",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Configurar a entidade pontuação deste jogador",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Configurar o tipo de pontuação",
  T_34_WT_WS_ENTITY20_PARAM3: "Pontuação",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "A pontuação específica do valor sendo definido",
  T_34_WT_WS_ENTITY21_NAME: "Conseguir a pontuação total da equipe",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Resgatar certas pontuações totais de equipes específicas",
  T_34_WT_WS_ENTITY21_PARAM1: "Equipe",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Configurar a entidade pontuação desta(s) equipe(s)",
  T_34_WT_WS_ENTITY22_NAME: "Definir pontuação da rodada atual da equipe",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Configurar certas pontuações da rodada atual de equipes específicas",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Configurar a(s) pontuação(ões) desta(s) equipe(s)",
  T_34_WT_WS_ENTITY23_NAME: "Conseguir a pontuação do jogador na rodada",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Resgatar determinada pontuação de determinadas rodadas de jogadores específicos",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Resgatar a pontuação da(s) rodada(s) de determinado jogador(es)",
  T_34_WT_WS_ENTITY23_PARAM2: "Rodada",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Conseguir a pontuação desta rodada",
  T_34_WT_WS_ENTITY24_NAME: "Conseguir a pontuação da equipe na rodada",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Resgatar determinada pontuação de determinadas rodadas de equipes específicas",
  T_34_WT_WS_ENTITY25_NAME: "Teleporte",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Teleportar determinados jogadores para um local específico",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Jogador(es) que será(ão) teleportado(s)",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Coordenadas de para onde os jogadores serão teleportados",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Permitir que determinados jogadores possam causar dano para alvos específicos. Caso nenhum jogador atacante seja selecionado, o alvo designado receberá dano do sistema.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entidades que receberão o dano",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "A quantidade de dano causado",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Retornar jogadores específicos",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Entidade de jogadores que retornarão",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Configura o tipo de bloco",
  T_34_WT_WS_ENTITY3_PARAM1: "como",
  T_34_WT_WS_ENTITY4_NAME: "Conseguir propriedade",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Conseguir a propriedade específica de uma entidade",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Conseguir o valor da propriedade da entidade do jogo",
  T_34_WT_WS_ENTITY4_RETURNDESC: "O valor da propriedade específico a ser conseguido",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Configurar a habilidade de mover para todos os jogadores",
  T_34_WT_WS_ENTITY6_NAME: "Criar ícone",
  T_34_WT_WS_ENTITY6_PARAM1: "Ícone",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "Uma imagem mostrada no HUD. Selecionar vários estilos.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Selecionar o ícone no qual o estilo deve ser aplicado",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Criar o ícone do HUD para os jogadores especificados. Se nenhuma entidade de jogador for selecionada, a HUD será criada para todos os jogadores.",
  T_34_WT_WS_ENTITY7_PARAM1: "Jogador",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Criar o ícone do HUD para jogadores específicos",
  T_34_WT_WS_ENTITY8_NAME: "Adicionar texto",
  T_34_WT_WS_ENTITY8_PARAM1: "Texto",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "O conteúdo de texto específico para ser criado deste comando",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "A entidade do texto que está sendo criada",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Adicionar uma linha de texto ao HUD de jogadores específicos. Se nenhuma entidade de jogador for selecionada, o texto será criado para todos os jogadores.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Criar o ícone de texto do HUD para jogadores selecionados",
  T_34_WT_WS_ICONENTITY_PARAM1: "Entidade ícone",
  T_34_WT_WS_ICONENTITY_PARAM2: "Estilo",
  T_34_WT_WS_ICONENTITY_PARAM3: "Cor",
  T_34_WT_WS_ICONENTITY_PARAM4: "Escala",
  T_34_WT_WS_ICONENTITY_PARAM5: "Posição do visor",
  T_34_WT_WS_ICONENTITY_PARAM6: "Seguir alvo",
  T_34_WT_WS_ICONENTITY_PARAM7: "Visível através de paredes",
  T_34_WT_WS_ICONENTITY_PARAM8: "Sempre na tela",
  T_34_WT_WS_ONETEAM_TAG: "Equipe única",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Entidade de fase",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Índice de fase",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Momento do começo",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Fim da linha",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Duração",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Entidade jogador",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Ponto de Ressurgimento",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Taxa de dano",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Personagem modelo 3D",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identificar",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "Vida atual",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. Vida",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "IA",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Status do jogador",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Tempo de sobrevivência",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Invulnerável",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Equipe",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ID do ponto de checagem",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Ponto de Surgimento",
  T_34_WT_WS_PROCIRCLE_ICON: "Ícone",
  T_34_WT_WS_PVEDESC1: "Se pelo menos 1 jogador alcançar a linha de chegada antes do final do tempo, a equipe deste jogador vencerá. Caso todos os jogadores sejam abatidos ao mesmo tempo, o jogo acabou.",
  T_34_WT_WS_PVEDESC2: "Sobreviva pelo tempo indicado para vencer. Caso todos os jogadores sejam abatidos ao mesmo tempo, o jogo acabou.",
  T_34_WT_WS_PVENAME1: "Velocidade",
  T_34_WT_WS_PVENAME2: "Resistência",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "ID do ponto de checagem",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Nº do ponto de checagem do modo Parkour",
  T_34_WT_WS_SKILLSET14: "Proteção do Samurai (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Entidade equipe",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Amassou",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Todos os membros",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Gatilho regular",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Tipo de aparência",
  T_34_WT_WS_TXTENTITY_PARAM1: "Entidade texto",
  T_34_WT_WS_TXTENTITY_PARAM2: "Conteúdo",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entidade efeitos visuais",
  T_34_WZ_WS_LOGIC10_NAME: "Continue para o próximo",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Pular a atual interação de ciclo e executar a próxima.",
  T_34_WZ_WS_LOGIC11_NAME: "Voltar",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Finalizar a execução atual e retornar para o programa principal. Permitir o envio de dados de volta quando retornar.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Valor de retorno",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Os dados para enviar de volta ao programa principal",
  T_34_WZ_WS_LOGIC2_NAME: "Comparar",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Comparar 2 valores usando um operador específico",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Valor a esquerda",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "O valor a esquerda usado na comparação",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Função de comparação",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Selecione como deseja comparar os valores. Os operadores suportados são: >, ≥, ==, ≠, ≤, <, AND (apenas lógica booleana), OR (apenas lógica booleana)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Valor a direita",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "O valor a direita usado na comparação",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Resultado da comparação",
  T_34_WZ_WS_LOGIC3_NAME: "NÃO",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Fornecer o valor de lógica reverso",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "O valor que você deseja usar o operador NÃO em",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Resultado da operação NÃO",
  T_34_WZ_WS_LOGIC4_NAME: "Verificação vazia",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Verifique se alguma entidade está vazia ou nula",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entidade",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "A entidade para verificar vazio",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Se a entidade está ou não vazia",
  T_34_WZ_WS_LOGIC5_NAME: "Se",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Executar de acordo com as condições serem cumpridas. Os subprocessos são os mesmos dos ramos lógicos subsequentes.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Valor",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "A quantidade de condições e de subprocessos (ramos lógicos) devem ser as mesmas",
  T_34_WZ_WS_LOGIC6_NAME: "Ciclo do alcance",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Ciclo de x para y por um passo de z. O subprocesso é o ciclo em si.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "O nome do índice do ciclo que pode ser usado para extrair o valor do índice do ciclo da variável local",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Valor de início",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "O valor no qual o ciclo começa",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Valor de final",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "O valor no qual o ciclo termina",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Passo",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "O passo de cada ciclo. Qual o valor de início é menor que o valor de final, o passo deve ser maior que 0. Qual o valor de início é maior que o valor de final, o passo deve ser menor que 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Ciclo de todos os elementos",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Permitir a análise de um contêiner de dados de cada subelemento O subprocesso é o ciclo em si.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Elemento",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Deslocar-se para este nome extraíra o valor do subelemento variável local.",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Contêiner de dados",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "O container de dados para analisar. Tipos de lista suportados no momento.",
  T_34_WZ_WS_LOGIC8_NAME: "Ciclo condicional",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Um ciclo condicional que se repete quando a condição é cumprida. O ciclo para quando a condição é falsa.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Condição",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Repetir o ciclo se a condição for verdadeira e parar enquanto a condição for falsa.",
  T_34_WZ_WS_LOGIC9_NAME: "Quebrar ciclo",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Parar o processo de ciclo atual e pular para fora do ciclo",
  T_34_Y_B_DINOSAURS: "Montando o Dinossauro",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Puramente Angelical",
  T_34_YS_F_B_PANDACATTLE: "Vaquinha de Dormir",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Misty, Dona das Tempestades",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Misty, Dona das Tempestades",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Misty, Dona das Tempestades",
  T_34_YS_F_S_PANDACATTLE: "Vaquinha de Dormir",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Misty, Dona das Tempestades",
  T_34_YS_F_T_PANDACATTLE: "Vaquinha de Dormir",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Misty, Dona das Tempestades",
  T_34_YS_M_B_ANGEL_BW: "Angelicalmente Puro",
  T_34_YS_M_B_PANDACATTLE: "Panda de Dormir (Pernas)",
  T_34_YS_M_H_PANDACATTLE: "Panda de Dormir (Cabeça)",
  T_34_YS_M_S_PANDACATTLE: "Panda de Dormir (Calçado)",
  T_34_YS_M_T_PANDACATTLE: "Panda de Dormir (Torso)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Ganha [FFB300]{0}[-] de energia ao derrubar um oponente.",
  T_35_DY_PET_OWL_N: "Arita",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Traje de Pet: ETzin Piloto",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Traje de Pet: Samalandra Azteca",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Traje de Pet: Falcão Azteca",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Traje de Pet: Arita Exploradora",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Traje de Pet: Arita Cósmica",
  T_35_DY_PETSKIN_OWL_STORM_N: "Traje de Pet: Arita das Montanhas",
  T_35_JL_KNOCKEDDOWN: "Mais um caído",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "Em até [FFB300]{1}s[-] depois de ativar a habilidade, é possível disparar e acertar uma Parede de de Gel para marcar oponentes dentro de [FFB300]{3}m[-] dela e causar dano nestes oponentes (o dano causado é menor do que o normal). Afeta no máximo [FFB300]{0}[-] paredes de gel. Tempo de recarga: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Rastreadora",
  T_35_KY_INFECTION_MAPNAME: "Devastado",
  T_35_M_WS_BUTTONCLICKDESC: "Inicia este incidente quando tocar o botão correspondente. É possível identificar o jogador iniciador usando parâmetros",
  T_35_M_WS_GETTEAMMATEPOS: "Conseguir a localização dos aliados próximos.",
  T_35_M_WS_ROUND2: "Onda atual",
  T_35_PD_Infection_HUMANSELECT: "Selecionar arma",
  T_35_PD_INFECTION_MODENAME: "Cizânia Androide",
  T_35_QX_WS_ICONTYPE_ITEM: "Objeto",
  T_35_QX_WS_ICONTYPE_NATURE: "Natureza",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geométrico",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Símbolo",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Armas",
  T_35_R_EMOTE_TAG_MUSIC_N: "Música",
  T_35_RW_SKILL_DESC_Singers: "O usuário da habilidade e os aliados a até [FFB300]{0}m[-] de distância podem bloquear [FFB300]{1}%[-] de dano usando os pontos de energia. O usuário da habilidade receberá os pontos de energia deduzidos de seus aliados.",
  T_35_RW_SKILL_NAME_Singers: "Sentinela Silencioso",
  T_35_SP_WS_COMMENTKEY_01: "Dificuldade adequada",
  T_35_SP_WS_COMMENTKEY_02: "Criativo",
  T_35_SP_WS_COMMENTKEY_03: "Jogabilidade interessante",
  T_35_SP_WS_COMMENTKEY_04: "Pode ser jogado várias vezes",
  T_35_SP_WS_COMMENTKEY_05: "História intrigante",
  T_35_SP_WS_COMMENTKEY_06: "Bom balanceamento",
  T_35_SP_WS_COMMENTKEY_07: "Experiência agradável",
  T_35_SP_WS_COMMENTKEY_08: "Flexível",
  T_35_SP_WS_COMMENTKEY_09: "Esteticamente agradável",
  T_35_SP_WS_COMMENTKEY_10: "Difícil demais",
  T_35_SP_WS_COMMENTKEY_11: "Fácil demais",
  T_35_SP_WS_COMMENTKEY_12: "Chato",
  T_35_SP_WS_COMMENTKEY_13: "Longo demais",
  T_35_SP_WS_COMMENTKEY_14: "Mal balanceado",
  T_35_SP_WS_COMMENTKEY_15: "Experiência desagradável",
  T_35_SP_WS_IMAGE03: "Textura",
  T_35_SP_WS_IMAGE04: "Quadro",
  T_35_SY_CHARGESHOT_TEARS_N: "Carga Extra - Chamas de Tinta",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Granada - Cristal Esquelético",
  T_35_SY_GRENADE_PIRATES_N: "Granada - Piratas Futuristas",
  T_35_SY_GRENADE_RIDERS_N: "Granada - Motoqueiros Distópicos",
  T_35_SY_M24_KUN_N: "M24 - Marinheiros das Cascatas",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Maratona Urbana",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jipe - Arte Monocromática",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Curta a festa!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Moto - Universo Fragmentado",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Estrutura e Decoração",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Estruturas",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Miscelânia",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Arquitetura",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Prédios grandes",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Prédios médios",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Objetos Funcionais",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Essenciais do Modo",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Música",
  T_35_WT_WS_PVEMODE_TAG: "Modo Sobreviver",
  T_35_WZY_WS_BECRE_NAMEDESC: "Inicia quando a entidade é criada",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Inicia quando a entidade é eliminada A fonte do ataque pode ser identificada por "Entidade iniciadora" e o tipo de ataque pode ser identificado por "Tipo de Dano".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "A entidade que inicia o incidente",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Cria um tipo de item ou um conjunto de itens em um local específico. Ao criar um tipo de item, a quantidade é o número daquele item. Ao criar um conjunto de itens, a quantidade é a lista de quantidade que corresponde à lista de itens. Os itens criados dependerão da unidade do mapa.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Uma lista dos itens a serem criados. A lista também pode conter um único item.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Uma lista de quantidade que corresponde à lista de itens. Pode conter apenas um tipo de item.",
  T_35_WZY_WS_DAMTYPE_CAR: "Veículo",
  T_35_WZY_WS_DAMTYPE_FALL: "Queda",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Arma",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Granada",
  T_35_WZY_WS_DAMTYPE_MELEE: "Armas de Contato",
  T_35_WZY_WS_DAMTYPE_ZONE: "Fora da zona",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Delete uma quantidade específica de itens de determinados jogadores",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Entrar na área de início",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Inicia quando uma "Entidade iniciadora" entra em uma área de início',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "O jogador que deverá obter a entidade. Quando associado a este jogador, a informação da entidade será atualizada apenas para este jogador. Quando nenhum jogador estiver associado, todos os jogadores receberão as informações da entidade.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Entidade de Batalha",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Conseguir todos os objetos de um tipo específico. O resultado está em lista.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Tipo de Objeto",
  T_35_WZY_WS_HUDWIDGET_NAME: "Controle da interface",
  T_35_WZY_WS_HURT_NAMEDESC: 'Inicia quando esta entidade recebe dano A fonte do ataque pode ser identificada pela "Entidade iniciadora"',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Tipo de item",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Objeto da Fase",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Inicia quando esta entidade recebe dano de outra entidade. O tipo de entidade eliminada pode ser identificada por "Entidade eliminada".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "A entidade que é eliminada",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Ativa quando uma entidade causa dano",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Entidade causando dano",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Entidade alvo",
  T_35_WZY_WS_PREFABID_NAME: "ID do modelo",
  T_35_WZY_WS_PROPERTY_EPNOW: "Pontos de energia atual",
  T_35_WZY_WS_PROPERTY_JUMP: "Altura do pulo",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Sair da área de início",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Inicia quando uma "Entidade iniciadora" sai de uma área de início',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Remova determinado elemento da lista. [Lista] é a lista na qual o elemento foi colocado. [Elemento] é o elemento que será removido.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Valor do elemento",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "O valor do elemento que deve ser removido",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Entidade da Rodada",
  T_35_WZY_WS_TOWER_PARAM1: "Torre e Fortaleza",
  T_35_WZY_WS_TOWER_PARAM2: "ID da equipe",
  T_35_WZY_WS_TOWER_PARAM3: "Vida atual",
  T_35_WZY_WS_TOWER_PARAM4: "Vida máxima",
  T_35_WZY_WS_TOWER_PARAM5: "Dano",
  T_35_WZY_WS_TOWER_PARAM6: "Intervalo do ataque",
  T_35_WZY_WS_TOWER_PARAM7: "Alcance do ataque",
  T_35_WZY_WS_TOWER_PARAM8: "% da defesa",
  T_35_XYL_PDM_REVENGE: "Vingado",
  T_35_XYL_WS_BISPARTERRE: "Canteiro Estilo de Batalha",
  T_35_XYL_WS_BISPARTERRE_DESC: "Um canteiro de flores da Sua Batalha, Seu Estilo.",
  T_35_XYL_WS_BISWALL: "Parede Batalha de Estilo",
  T_35_XYL_WS_BISWALL_DESC: "Uma parede da Sua Batalha, Seu Estilo que pode ser combinada.",
  T_35_XYL_WS_BOTDROP: "Deixar itens ao ser eliminado",
  T_35_XYL_WS_CUSTOMTRIGGER: "Gatilho personalizado",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Posicionar um objeto que inicia determinado efeito especial personalizado quanto um jogador o ativa. É necessário configurar o efeito no Script.  (Aparece apenas no Modo Customizado)",
  T_35_XYL_WS_DOUBLEDOOR: "Portão",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Um portão arrebentado e aberto",
  T_35_XYL_WS_RESET: "Reinicia a cada rodada",
  T_35_XYL_WS_RESETN: "Não",
  T_35_XYL_WS_RESETY: "Sim",
  T_35_XYL_WS_ROADBLOCK: "Bloqueio no caminho A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Não permite atravessar",
  T_35_XYL_WS_STAIRS: "Escadas",
  T_35_XYL_WS_STAIRS_DESC: "Escadas que podem ser combinadas com plataformas",
  T_35_XYL_WS_STAIRSL: "Plataforma B",
  T_35_XYL_WS_STAIRSL_DESC: "Plataformas que podem ser combinadas com escadas",
  T_35_XYL_WS_STAIRSZ: "Plataforma A",
  T_35_XYL_WS_STAIRSZ_DESC: "Plataformas que podem ser combinadas com escadas",
  T_35_XYL_WS_TBOOTH: "Cabine de Telefone",
  T_35_XYL_WS_TBOOTH_DESC: "Presença confirmada nas calçadas.",
  T_35_YF_PP19_N: "Bisão",
  T_35_YS_A_CATEAM_HW: "Cabeça de Águia",
  T_35_YS_A_CUBBY: "Máscara Ursídea",
  T_35_YS_F_A_PANTOMIME: "Arte da Comédia",
  T_35_YS_F_A_RIDERS: "Motoqueira Distópica",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Harmonia Futurista",
  T_35_YS_F_B_GOLDCHAIN: "Asas da Vitória",
  T_35_YS_F_B_PANTOMIME: "Arte da Comédia",
  T_35_YS_F_B_RIDERS: "Motoqueira Distópica",
  T_35_YS_F_H_BEAR_HW: "Gorro Ursídeo",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Harmonia Futurista",
  T_35_YS_F_H_GOLDCHAIN: "Asas da Vitória",
  T_35_YS_F_H_PANTOMIME: "Arte da Comédia",
  T_35_YS_F_H_RIDERS: "Motoqueira Distópica",
  T_35_YS_F_HA_GOLDCHAIN: "Asas da Vitória",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Harmonia Futurista",
  T_35_YS_F_S_GOLDCHAIN: "Asas da Vitória",
  T_35_YS_F_S_PANTOMIME: "Arte da Comédia",
  T_35_YS_F_S_RIDERS: "Motoqueira Distópica",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Harmonia Futurista",
  T_35_YS_F_T_GOLDCHAIN: "Asas da Vitória",
  T_35_YS_F_T_PANTOMIME: "Arte da Comédia",
  T_35_YS_F_T_RIDERS: "Motoqueira Distópica",
  T_35_YS_ITEM_SUPERFAK: "Super Kit",
  T_35_YS_M_A_GOLDCHAIN: "Bússola Dourada",
  T_35_YS_M_A_RIDERS: "Motoqueiro Distópico",
  T_35_YS_M_B_GOLDCHAIN: "Bússola Dourada",
  T_35_YS_M_B_RIDERS: "Motoqueiro Distópico",
  T_35_YS_M_H_BEAR_HW: "Gorro Ursídeo",
  T_35_YS_M_H_GOLDCHAIN: "Bússola Dourada",
  T_35_YS_M_H_RIDERS: "Motoqueiro Distópico",
  T_35_YS_M_S_GOLDCHAIN: "Bússola Dourada",
  T_35_YS_M_S_RIDERS: "Motoqueiro Distópico",
  T_35_YS_M_T_GOLDCHAIN: "Bússola Dourada",
  T_35_YS_M_T_RIDERS: "Motoqueiro Distópico",
  T_35_YS_T_CHAMPION: "Camiseta Campeã",
  T_35_YS_T_PAINTING: "Camiseta Esmagamento",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Íris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Ganhe fichas no início das partidas",
  T_36_JH_WS_CESAYCLOSE: "Desabilitar fechamento manual ou não",
  T_36_JH_WS_CHOOSEEDITSHOP: "Selecione uma loja para editar",
  T_36_JH_WS_CHOOSESHOP: "Selecione uma loja",
  T_36_JH_WS_COINCOUNT: "Quantidade de moedas",
  T_36_JH_WS_COINHUD: "Mostrar total de fichas ou não",
  T_36_JH_WS_CRAFTSHOP: "Editar loja",
  T_36_JH_WS_CREATEGOLD: "Gerador de moedas",
  T_36_JH_WS_CSHOPENTITY: "Vincular a entidade da loja",
  T_36_JH_WS_CSHOPHUD: "Interface da loja",
  T_36_JH_WS_CURRENTLIMIT: "Limite de compra restante",
  T_36_JH_WS_ECONOMIC: "Economia",
  T_36_JH_WS_INGAMEECONOMI: "Economia da partida",
  T_36_JH_WS_ITEMINDEXID: "Número do produto",
  T_36_JH_WS_KILLMONEY: "Ganhe fichas por abates",
  T_36_JH_WS_KILLMONEYTIP: "A quantidade de fichas a serem ganhar ao eliminar zumbis nos modos Hora do Rush e Resistência",
  T_36_JH_WS_LISTINDEX: "Lista de tipos de produto",
  T_36_JH_WS_NULL: "Nulla",
  T_36_JH_WS_NUMBER: "Quantidade",
  T_36_JH_WS_OPTIONNAME: "Especial do Cizânia Androide",
  T_36_JH_WS_REALSHOPENTITY: "Entidade loja",
  T_36_JH_WS_SEEORHIDE: "Mostrar máquina de vendas",
  T_36_JH_WS_SHOPFRONT: "Loja",
  T_36_JH_WS_SHOPITEMLIST: "Tipo de produto",
  T_36_JH_WS_SHOPOPENCON: "Status aberto",
  T_36_JH_WS_SSHOPNAME: "Nome da loja",
  T_36_JH_WS_TOTALLIMIT: "Limite de compra",
  T_36_JH_WS_TRIGGERWIDE: "Alcance de uso",
  T_36_JH_WS_VENDMACHINE: "Máquina de Vendas",
  T_36_JH_WS_WINMONEY: "Ganhe fichas por vitórias",
  T_36_JH_WS_WORTH: "Valor",
  T_36_JL_FOREGRIP_MR_N: "Empunhadura de fuzil",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Coronha de Espingarda",
  T_36_JL_STOCK_SR_N: "Coronha de Fuzil de Precisão",
  T_36_KK_WS_MONTSTERDES: "Um veículo de 4 lugares com alta durabilidade e ideal para terrenos complicados.",
  T_36_M_WS_SETTEMPVAR: "Definir variável temporária",
  T_36_M_WS_TEMPVAR: "Variável temporária",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Ataque das Mambas",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Ataque das Mambas",
  T_36_SY_AR15_MAMBAS_N: "Atiradeira - Ataque das Mambas",
  T_36_SY_AUG_MAMBAS_N: "AUG - Ataque das Mambas",
  T_36_SY_AWM_MAMBAS_N: "AWM - Ataque das Mambas",
  T_36_SY_BLT_MAMBAS_N: "M82B - Ataque das Mambas",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Carga Extra - Ataque das Mambas",
  T_36_SY_EAGLE_MAMBAS_N: "Águia do Deserto - Ataque das Mambas",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Ataque das Mambas",
  T_36_SY_G18_MAMBAS_N: "G18 - Ataque das Mambas",
  T_36_SY_G36_MAMBAS_N: "G36 - Ataque das Mambas",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Granada - Festividades",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Ataque das Mambas",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Canhão de Mão - Ataque das Mambas",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "FP de Cura - Ataque das Mambas",
  T_36_SY_ICE_GUN_MAMBAS_N: "Arma de Gel - Ataque das Mambas",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Ataque das Mambas",
  T_36_SY_KORD_MAMBAS_N: "Kord - Ataque das Mambas",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Ataque das Mambas",
  T_36_SY_M14_MAMBAS_N: "M14 - Ataque das Mambas",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Ataque das Mambas",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Ataque das Mambas",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Ataque das Mambas",
  T_36_SY_M21A5_MAMBAS_N: "Carapina - Ataque das Mambas",
  T_36_SY_M24_MAMBAS_N: "M24 - Ataque das Mambas",
  T_36_SY_M249_MAMBAS_N: "M249 - Ataque das Mambas",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Ataque das Mambas",
  T_36_SY_M500_MAMBAS_N: "M500 - Ataque das Mambas",
  T_36_SY_M60_MAMBAS_N: "M60 - Ataque das Mambas",
  T_36_SY_M79_MAMBAS_N: "M79 - Ataque das Mambas",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Ataque das Mambas",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Ataque das Mambas",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Ataque das Mambas",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Ataque das Mambas",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Ataque das Mambas",
  T_36_SY_P90_MAMBAS_N: "P90 - Ataque das Mambas",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Ataque das Mambas",
  T_36_SY_PP19_MAMBAS_N: "Bisão - Ataque das Mambas",
  T_36_SY_PP19_POLICEMAN_N: "Bisão - Bruxaria",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Ataque das Mambas",
  T_36_SY_SKS_MAMBAS_N: "SKS - Ataque das Mambas",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Ataque das Mambas",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Ataque das Mambas",
  T_36_SY_SVD_MAMBAS_N: "SVD - Ataque das Mambas",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Ataque das Mambas",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Adaga - Ataque das Mambas",
  T_36_SY_THROWINGKNIFE_MENA_N: "Adaga - Deserto",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Pistola de Cura - Ataque das Mambas",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Ataque das Mambas",
  T_36_SY_USP45_MAMBAS_N: "USP - Ataque das Mambas",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Ataque das Mambas",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Ataque das Mambas",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Caminhão Monstro - Booyah Dourado",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Moto - Caveira Guardiã",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Carro Esportivo - Velocidade Pura",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuc Tuc - Patrulheiros",
  T_36_SY_VSS_MAMBAS_N: "VSS - Ataque das Mambas",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Ataque das Mambas",
  T_36_WZY_AFTERACCUMULATOR: "Acumulador posterior",
  T_36_WZY_AVAILAB: "Ativado",
  T_36_WZY_BACKANDFORTH: "Ida e volta",
  T_36_WZY_BASEMULTIPLIER: "Multiplicador básico",
  T_36_WZY_BASIC: "Tipo básico",
  T_36_WZY_BEFORACCUMULATOR: "Acumulador frontal",
  T_36_WZY_CYLIC: "Retornar",
  T_36_WZY_GUNPRO_PARAM1: "Dano básico",
  T_36_WZY_GUNPRO_PARAM10: "Início da dispersão de munição",
  T_36_WZY_GUNPRO_PARAM11: "Área de dispersão máx.",
  T_36_WZY_GUNPRO_PARAM12: "Estouro",
  T_36_WZY_GUNPRO_PARAM2: "Munição no cartucho",
  T_36_WZY_GUNPRO_PARAM3: "Munição inicial no cartucho",
  T_36_WZY_GUNPRO_PARAM4: "Intervalo de disparo",
  T_36_WZY_GUNPRO_PARAM7: "Distância para dano máximo",
  T_36_WZY_GUNPRO_PARAM8: "Distância para dano mínimo",
  T_36_WZY_GUNPRO_PARAM9: "Dano mínimo",
  T_36_WZY_MULTIPLIR: "Multiplicador",
  T_36_WZY_PRICE: "Preço",
  T_36_WZY_SUMMULTIPLIER: "Acumulador de multiplicador",
  T_36_WZY_WS_3DZOOM: "Aproximação 3D",
  T_36_WZY_WS_ABSRES: "Resultado do valor absoluto",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Adicionar todos os elementos de [Lista original] ao final da [Lista alvo]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "Use a lista alvo para adicionar os elementos",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "A lista original que contém todos os elementos para adicionar",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Adicionar determinada quantidade de moedas a determinada carteira.",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Carteira",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "A carteira na qual as moedas serão adicionadas",
  T_36_WZY_WS_ADDSUB: "Adicionar ou subtrair valores",
  T_36_WZY_WS_AIENTITY: "Entidade IA",
  T_36_WZY_WS_ALLSHOP_DESC: "Uma lista que corresponde às entidades loja",
  T_36_WZY_WS_ANGLE_DESC: "A medida do ângulo",
  T_36_WZY_WS_ANYTYPE: "Qualquer tipo",
  T_36_WZY_WS_ARILEFT: "O valor à esquerda da operação",
  T_36_WZY_WS_ARIRES: "Resultado da operação",
  T_36_WZY_WS_ARIRIGHT: "O valor à direita da operação",
  T_36_WZY_WS_ARITHMETIC_NAME: "As 4 operações aritméticas",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "As operações básicas com inteiros permitem adição, subtração, multiplicação, divisão e restante. As operações flutuantes aceitam adição, subtração, multiplicação e divisão.",
  T_36_WZY_WS_ARRAY_DESC: "A lista alvo",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Verifique se uma lista inclui determinado elemento. O valor retornado é Booleano.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "A lista determinada",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "O elemento a ser procurado na lista",
  T_36_WZY_WS_ARRCONELERES: "O resultado se determinado elemento existe na lista. O valor é Booleano.",
  T_36_WZY_WS_ATTACK: "Patrulhar e Atacar",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Inicia quando o jogador é derrubado",
  T_36_WZY_WS_BIGFLOAT: "Grande decimal",
  T_36_WZY_WS_BIGTOYBALL: "Dados",
  T_36_WZY_WS_BOOLLIST: "Lista Booleana",
  T_36_WZY_WS_CEIL_NAME_DESC: "Arredondar o valor para o menor inteiro maior que o valor.",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "O valor que será arredondado",
  T_36_WZY_WS_CEILRES: "Resultado do arredondamento",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "A IA selecionada caçará a entidade independente da distância. [Entidade presa] pode ser qualquer entidade. Quando a [Entidade presa] não tiver a propriedade Vida, a entidade IA não causará dano algum.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "A entidade caçadora",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "A entidade sendo caçada. Pode ser qualquer entidade.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Modelo para clonar objetos. Selecione usando o cursor. A propriedade e o script do clone serão os mesmos do objeto escolhido.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "A entidade objeto a ser clonada",
  T_36_WZY_WS_CONDITION: "Condição",
  T_36_WZY_WS_CONDITIONLIST: "Lista de condições",
  T_36_WZY_WS_CONOFHUD: "A entidade HUD que dentro da qual o controle está",
  T_36_WZY_WS_CONTROL_DESC: "O único índice de um controle",
  T_36_WZY_WS_COS_NAMEDESC: "Encontre o cosseno de um ângulo",
  T_36_WZY_WS_COSRES: "Cosseno do ângulo",
  T_36_WZY_WS_CREABLEOB: "Objeto criável",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Cria uma entidade objeto em determinado local. (Versão de teste)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "As coordenadas do objeto a ser criado",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "O tipo de objeto a ser criado",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "A entidade do objeto a ser criado",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Moeda",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Entidade produto",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Crie a entidade produto",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Criar uma entidade carteira. [Vincular jogador] é o jogador que pode ver esta carteira. [Dono] é o jogador a quem a carteira pertence. Inválido caso uma carteira já exista.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Jogador vinculado",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "O jogador cuja carteira é visível. Na ausência de configurações definidas, a carteira será visível para todos.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Dono da carteira",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Entidade carteira",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "A entidade carteira criada",
  T_36_WZY_WS_CURRAMT: "Quantidade de moedas",
  T_36_WZY_WS_DATA_TYPE1: "Parâmetro adicionado",
  T_36_WZY_WS_DATA_TYPE2: "Cálculo básico e lógico",
  T_36_WZY_WS_DATA_TYPE3: "Manipulação de lista",
  T_36_WZY_WS_DATA_TYPE4: "Cálculo de vetor",
  T_36_WZY_WS_DESTITEM_NAME: "Destruir item de jogador",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Destrua determinado tipo de item de determinado jogador",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Os itens destruíveis são armas, coletes e capacetes",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "O índice de espaços do tipo de item selecionado. O índice de arma é [1,3], o de colete e de capacete é 1 por padrão.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Perda de equipamento por eliminação",
  T_36_WZY_WS_DESTOBJ: "Objetos destruíveis",
  T_36_WZY_WS_DIRPOINT: "Ponto de direção",
  T_36_WZY_WS_DIRPOINTDESC: "O ponto de direção a ser criado",
  T_36_WZY_WS_ELEFINDRES: "Índice da primeira posição de um elemento",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Conseguir o índice da primeira posição de um elemento em uma lista. Caso o elemento alvo não exista na lista, o resultado retornará como "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "O elemento a ser procurado na lista",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Conseguir o índice da última posição de um elemento em uma lista. Caso o elemento alvo não exista na lista, o resultado retornará como "-1".',
  T_36_WZY_WS_ELELINDRES: "Índice da última posição de um elemento",
  T_36_WZY_WS_ELEMENTSNUM: "N.º de elementos na lista",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Inicia quando a [Entidade iniciadora] colide com este acionamento",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "A entidade que colide com este acionamento",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Inicia quando a [Entidade iniciadora] dirige o veículo",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "A entidade que está dirigindo o veículo",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Inicia quando o jogador ativa o iniciador",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Acionador para entrar",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Inicia quando a [Entidade iniciadora] sai do veículo",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "A entidade que está saindo do veículo",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Inicia quando a [Entidade iniciadora] entra no veículo",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "A entidade que está entrando no veículo",
  T_36_WZY_WS_ENTITY_TYPE1: "Frequentemente usado",
  T_36_WZY_WS_ENTITY_TYPE2: "Propriedades",
  T_36_WZY_WS_ENTITY_TYPE3: "Objetos e itens",
  T_36_WZY_WS_ENTITY_TYPE4: "IA",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "O valor do elemento a ser alterado",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Jogador alvo",
  T_36_WZY_WS_ENTITYLIST: "Lista de entidade",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Inicia quando a [Entidade iniciadora] salta do pneu",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "A entidade que salta do pneu",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Inicia quando a [Entidade iniciadora] entra em um portal e é transportada",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "A entidade que é transportada",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "O tipo de armadura equipada (incluindo coletes, capacetes e mochilas)",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Inicia quando um jogador equipa uma arma com sucesso. [Jogador iniciador] é o jogador que foi bem sucedido em equipar a arma. [Entidade arma] é a entidade arma equipada pelo jogador.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "A entidade arma equipada",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Tipo de arma",
  T_36_WZY_WS_EULERANGLE: "[Ângulo de Euler]",
  T_36_WZY_WS_FACECAMERA: "Sempre virado pra câmera",
  T_36_WZY_WS_FLOATLIST: "Lista flutuante",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Arredondar o valor para o maior inteiro menor que o valor.",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "O valor que será arredondado",
  T_36_WZY_WS_FLOORRES: "Resultado do arredondamento",
  T_36_WZY_WS_FORMUENT: "Entidade formulável de propriedade",
  T_36_WZY_WS_FORMUFACT: "Tipo de fator de fórmula de propriedade",
  T_36_WZY_WS_GAME_TYPE2: "Jogabilidade",
  T_36_WZY_WS_GAME_TYPE3: "Efeitos especiais",
  T_36_WZY_WS_GENENT_NAMEDESC: "Inicia quando um gerador cria unidades. [Lista de Entidade unidade] é a lista de unidades criadas pelo gerador. [Nº de ondas] é a quantidade de ondas criadas pelo gerador.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Entidade unidade",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Uma lista que consiste pelas entidades unidades criadas por um gerados",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "A quantidade de ondas criadas pelo gerador",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Conseguir todas as lojas na partida. O valor retornado é a lista de entidades lojas.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Use RGB para conseguir a cor",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Consiga a quantidade de determinada moeda em uma carteira específica",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "A carteira da qual se conseguirá a quantidade de moedas",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "O tipo de moeda da quantidade de moedas a ser conseguido",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Conseguir o tipo de entidade de uma entidade alvo",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "A entidade da qual se conseguirá o tipo",
  T_36_WZY_WS_GETENTTYPERES: "Tipo de entidade da entidade alvo",
  T_36_WZY_WS_GETFOR_NAME: "Conseguir coordenadas de direção",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Conseguir o vetor de determinado ponto de direção",
  T_36_WZY_WS_GETFORRES: "Vetor do ponto de direção",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Conseguir a entidade moeda de determinado tipo de moeda na carteira",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "A carteira na qual a entidade moeda está",
  T_36_WZY_WS_GETPOS_NAME: "Conseguir coordenadas",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Conseguir coordenadas de determinado ponto de direção",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "O ponto de direção determinado",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Tipo de equipamento",
  T_36_WZY_WS_GETWALLET_NAME: "Conseguir carteira",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Conseguir a carteira de determinado dono",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Se uma carteira vinculada existe",
  T_36_WZY_WS_GETWALLETRES: "Entidade dono da carteira",
  T_36_WZY_WS_HUDCONTROL_DESC: "A entidade controle de um HUD",
  T_36_WZY_WS_HUDTYPE: "Tipo de HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Incidente global",
  T_36_WZY_WS_INCIDENT_TYPE2: "Incidente da entidade",
  T_36_WZY_WS_INDEX_DESC: "O valor índice de uma lista. Começa em 0.",
  T_36_WZY_WS_INTLIST: "Lista de inteiros",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Verifique se algum tipo de entidade pertence a determinada subcategoria. O resultado retornado é Booleano.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "A categoria principal a verificar se a entidade pertence a",
  T_36_WZY_WS_JENTSUBCLRES: "Resultado da verificação de categoria principal",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Verifique se alguma entidade pertence a determinado tipo de entidade. O resultado retornado é Booleano.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "A entidade a verificar",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Significa que é o mesmo tipo de entidade",
  T_36_WZY_WS_JENTTYPERES: "Resultado da verificação de entidade",
  T_36_WZY_WS_JUSTPATROL: "Patrulhar apenas",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Inicia quando o jogador desativa o iniciador",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Acionador para sair",
  T_36_WZY_WS_LEVELOBLIST: "Lista de objetos",
  T_36_WZY_WS_LEVOBJSLIST: "Uma lista de todos os objetos no mapa na partida",
  T_36_WZY_WS_LEVOBTYPE: "Tipo de Objeto",
  T_36_WZY_WS_LISTT: "Qualquer lista",
  T_36_WZY_WS_LOGCONTEXT_DESC: "O conteúdo a ser impresso",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "O segmento esquerdo a ser conectado",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "O segmento direito a ser conectado",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "O valor do elemento a ser adicionado",
  T_36_WZY_WS_LOGOPER: "Ao conduzir operações lógicas (e & ou): caso use o operador [e] e os dois valores booleanos forem VERDADEIRO, o resultado é VERDADEIRO; caso use o operador [ou] e um dos valores booleanos for VERDADEIRO o resultado é VERDADEIRO.",
  T_36_WZY_WS_LOOTPOINT: "Gerador de itens",
  T_36_WZY_WS_MAINWEAP: "Arma atual",
  T_36_WZY_WS_MAX_DESC: "O maior intervalo do inteiro gerado (intervalo aberto).",
  T_36_WZY_WS_MIN_DESC: "O menor intervalo do inteiro gerado (intervalo fechado)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Entidade arma",
  T_36_WZY_WS_MONENT: "Entidade moeda",
  T_36_WZY_WS_MONTYPE: "Tipo de moeda",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Faz a IA mover-se na direção de um ponto alvo. Use [Retornar ou não] para selecionar se deseja que a IA retorne para a posição original. Use [Atacar ou não] para selecionar se deseja que a IA busque oponentes no caminho.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "A entidade IA que vai viajar",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "O destino",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Use para determinar se a IA irá retornar ao local original depois de chegar no destino. VERDADEIRO significa retornar, FALSO significar não retornar.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Atacar ou não",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Use para determinar se a IA irá atacar oponentes próximos no caminho. VERDADEIRO significa atacar oponentes, FALSO significa não atacar oponentes.",
  T_36_WZY_WS_MULVALUE: "Escalar",
  T_36_WZY_WS_MULVEC: "Multiplicação vetorial escalar",
  T_36_WZY_WS_NEGRES: "Resultado do valor negativo",
  T_36_WZY_WS_NEUTRAL: "Indiferente",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Força o gerador a criar a próxima onda. Geradores incluem Ondas de Zumbis e geradores de itens.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Entidade geradora",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "A entidade geradora determinada, como  Ondas de Zumbis e geradores de itens.",
  T_36_WZY_WS_OBJENT: "Entidade objeto",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Inicia quanto um item é conseguido. [Tipo de item] se refere ao tipo de item conseguido.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Inicia quando uma arma é conseguida. [Entidade arma] se refere à arma conseguida.",
  T_36_WZY_WS_ONEWAY: "Via única",
  T_36_WZY_WS_OPENSTATE: "Situação",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operação",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Operações aritméticas básicas. Atualmente, as operações com inteiros incluem adição, subtração, multiplicação, divisão e restante. E as operações flutuantes incluem adição, subtração, multiplicação e divisão. ",
  T_36_WZY_WS_OWNERENT_DESC: "Entidade cuja carteira será obtida",
  T_36_WZY_WS_PERCENTAGE: "Ajustes de porcentagem",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Quando um jogador colide com o acionamento",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Inicia quando a [Jogador iniciador] colide com este acionamento",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "O jogador que colide com a armadilha",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "A entidade objeto com a qual o jogador colide",
  T_36_WZY_WS_PLADRIVEH_NAME: "Quando o jogador dirige um veículo",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Inicia quando a [Jogador iniciador] dirige um veículo",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "O jogador que está dirigindo o veículo",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "A entidade veículo que o jogador está dirigindo",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Quando o jogador sai do veículo",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Inicia quando a [Jogador iniciador] sai do veículo",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "O jogador que está saindo do veículo",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "A entidade veículo da qual o jogador está saindo",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Quando o jogador entra no veículo",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Inicia quando a [Jogador iniciador] entra no veículo",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "A entidade veículo na qual o jogador está entrando",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Quando o jogador salta fora do pneu",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Inicia quando a [Jogador iniciador] salta no pneu",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "O jogador que salta no pneu",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "A entidade objeto na qual o jogador salta",
  T_36_WZY_WS_PLATP_NAME: "Depois do jogador ser transportado",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "O jogador que usa o portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "A entidade portal que o jogador usou",
  T_36_WZY_WS_PLAYERLIST_DESC: "Uma lista de todos os jogadores na partida",
  T_36_WZY_WS_POINTPICKER: "Pivô do caminho",
  T_36_WZY_WS_PORTALENT: "Entidade portal",
  T_36_WZY_WS_PREFAB: "Modelo",
  T_36_WZY_WS_PRODLIST: "Lista de produtos",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Ordem organizacional",
  T_36_WZY_WS_PROPMOD: "Método de mudança de propriedade",
  T_36_WZY_WS_RANKABLEE: "Entidade ranqueável",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consumir uma determinada quantidade de determinada moeda em uma carteira específica.",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "A carteira da qual a moeda será consumida",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "O tipo de moeda a ser consumida",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "A quantidade de moeda a ser consumida",
  T_36_WZY_WS_RNDFRES: "Flutuação gerada aleatória",
  T_36_WZY_WS_RNDIRES: "Resultado da comparação de inteiros aleatórios",
  T_36_WZY_WS_ROUND_NAME_DESC: "Arredondar o valor para o inteiro mais próximo",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "O valor que será arredondado",
  T_36_WZY_WS_ROUNDRES: "Resultado do arredondamento",
  T_36_WZY_WS_RUNAI_NAMEDESC: "A lógica comportamental que será executada pela IA",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "A entidade unidade que inicia/para o comportamento padrão da lógica",
  T_36_WZY_WS_SCOREABLEE: "Entidade pontuável",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Gatilhos quanto a pontuação muda. [Tipo de pontuação] é o tipo de pontuação que mudou. [Pontuação] é a nova pontuação.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Criar ponto de direção",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Conseguir um ponto de direção novo. Use [Localização] para determinar as coordenadas do ponto de direção e [Direção] para determinar o vetor da direção.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "As coordenadas do ponto de direção",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Direção",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "O vetor do ponto de direção",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Entidade IA viajarão de acordo com a ordem definida aqui. Os trajetos de viagem disponíveis são: retornar, via única, ida e volta. Também é possível selecionar se a IA deve atacar oponentes no caminho.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Uma lista que corresponde aos pontos para os quais a IA deve viajar",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Tipo de viagem",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Estes são todos os tipos de viagem. Via única é o tipo de viagem no qual a IA para de viajar ao alcançar o destino. Retornar é o tipo de viagem no qual a IA busca um caminho de volta ao alcançar o destino. Ida e volta é o tipo de viagem no qual a IA retorna para a localização original de acordo com a ordem reversa da lista do trajeto.",
  T_36_WZY_WS_SHOPECON: "Loja e economia",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Utilize para mostrar notificações que flutuam na tela. Configure o conteúdo usando [Texto], a cor do texto usando [Cor] e a duração da visualização usando [Duração] (a unidade de medida é milissegundo).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "O conteúdo da notificação flutuante",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "A cor da notificação flutuante",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "A duração da notificação flutuante em milissegundos",
  T_36_WZY_WS_SIN_NAMEDESC: "Encontre o seno de um ângulo",
  T_36_WZY_WS_SINRES: "Seno do ângulo",
  T_36_WZY_WS_SKIPKNODOWN: "Se abatido ao ser derrubado",
  T_36_WZY_WS_SQRTRES: "Resultado da raiz quadrada",
  T_36_WZY_WS_STRCONRES: "Resultado da conexão de sentenças",
  T_36_WZY_WS_STRINGLIST: "Lista de sentenças",
  T_36_WZY_WS_STRLEN: "Comprimento da sentença",
  T_36_WZY_WS_STRVAL: "Resultado da sentença",
  T_36_WZY_WS_TAN_NAMEDESC: "Encontre a tangente de um ângulo",
  T_36_WZY_WS_TANRES: "Tangente do ângulo",
  T_36_WZY_WS_TEAMLIST: "Lista de equipe",
  T_36_WZY_WS_TEAMLIST_DESC: "Uma lista de todas as equipes na partida",
  T_36_WZY_WS_TIMETWEENTIPS: "Entidade notificação de contagem regressiva",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Converter o valor alvo para uma sentença",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "O valor alvo a ser convertido em uma sentença",
  T_36_WZY_WS_TOSTRINGRES: "Resultado da conversão de sentenças",
  T_36_WZY_WS_TOWERCAMP_DESC: "O número lateral e o número de equipe são o mesmo. Torres e fortalezas neutras atacam todos os jogadores e IAs dentro do alcance.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Transferir determinada quantidade de determinada moeda em uma carteira específica para outra.",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "A carteira da qual a moeda será transferida",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "O tipo de moeda que será transferida",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "A quantidade da moeda que será transferida",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "A carteira que receberá a quantidade transferida",
  T_36_WZY_WS_TWEENTIPS: "Entidade notificação flutuante",
  T_36_WZY_WS_TYPEENUM: "Tipo de enum",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Inicia quando um jogador equipa usa um item. [Jogador iniciador] é o jogador que usa o item. [Tipo de item] é o item usado pelo jogador.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "O tipo de item usado pelo jogador",
  T_36_WZY_WS_VECADDLEFT: "Valor à esquerda na soma vetorial",
  T_36_WZY_WS_VECADDRES: "Resultado da soma vetorial",
  T_36_WZY_WS_VECADDRIGHT: "Valor à direita na soma vetorial",
  T_36_WZY_WS_VECANGLEFT: "Valor à esquerda do ângulo vetorial",
  T_36_WZY_WS_VECANGRES: "Ângulo entre 2 vetores",
  T_36_WZY_WS_VECANGRIGHT: "Valor à direita do ângulo vetorial",
  T_36_WZY_WS_VECCROLEFT: "Valor à esquerda do produto cruzado",
  T_36_WZY_WS_VECCRORES: "Resultado do produto cruzado",
  T_36_WZY_WS_VECCRORIGHT: "Valor à direita do produto cruzado",
  T_36_WZY_WS_VECDISLEFT: "Valor à esquerda da distância dos vetores",
  T_36_WZY_WS_VECDISRES: "Distância entre 2 vetores",
  T_36_WZY_WS_VECDISRIGHT: "Valor à direita da distância dos vetores",
  T_36_WZY_WS_VECDOCLEFT: "Valor à esquerda do produto escalar",
  T_36_WZY_WS_VECDOCRES: "Resultado do produto escalar",
  T_36_WZY_WS_VECDOCRIGHT: "Valor à direita do produto escalar",
  T_36_WZY_WS_VECMULRES: "Resultado da multiplicação escalar",
  T_36_WZY_WS_VECNORRES: "Vetor normalizado",
  T_36_WZY_WS_VECSIZERES: "Magnitude do vetor",
  T_36_WZY_WS_VECSUBLEFT: "Valor à esquerda da subtração vetorial",
  T_36_WZY_WS_VECSUBRES: "Resultado da subtração vetorial",
  T_36_WZY_WS_VECSUBRIGHT: "Valor à direita na subtração vetorial",
  T_36_WZY_WS_VECTORLIST: "Lista de vetor",
  T_36_WZY_WS_VECX: "Componente X",
  T_36_WZY_WS_VECY: "Componente Y",
  T_36_WZY_WS_VECZ: "Componente Z",
  T_36_WZY_WS_VEHENT: "Entidade veículo",
  T_36_WZY_WS_WALLCONT: "Conteúdo da carteira",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Surgimento contínuo",
  T_36_XYL_WS_AIBOT: "Unidade",
  T_36_XYL_WS_AIGENERATOR: "Gerador de unidades",
  T_36_XYL_WS_AIGENERATOR_DESC: "Um gerador que consegue gerar unidades específica continuamente (ex.: zumbis)",
  T_36_XYL_WS_AIWAVE: "Nº de un. geradas p/ onda",
  T_36_XYL_WS_ARROW: "Sinal de Direção",
  T_36_XYL_WS_ARROW_DESC: "Um sinal que aponta a direção",
  T_36_XYL_WS_BREAKBOX: "Caixa Quebrável",
  T_36_XYL_WS_BREAKBOX_DESC: "Uma caixa de madeira que pode ser quebrada quando atacada",
  T_36_XYL_WS_FENCE: "Cerca de Ferro",
  T_36_XYL_WS_FENCE_DESC: "Uma cerca que deixa balas voarem através",
  T_36_XYL_WS_STAIRI: "Plataforma C",
  T_36_XYL_WS_STAIRI_DESC: "Plataformas que podem ser combinadas com escadas",
  T_36_XYL_WS_ZOMBIEAI: "Zumbi",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Um zumbi que pode ser personalizado, assim como obtido e duplicado no Gerador de unidades.",
  T_36_YF_CORRODE_GRENADE_N: "Quebra-Gel",
  T_36_YF_SETTING_TYPE3: "HUD 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Azul 2022",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Amarelo 2022",
  T_36_YS_F_A_GHOSTHUNTER: "Guria Felina",
  T_36_YS_F_B_GHOSTHUNTER: "Guria Felina",
  T_36_YS_F_H_GHOSTHUNTER: "Guria Felina",
  T_36_YS_F_S_GHOSTHUNTER: "Guria Felina",
  T_36_YS_SETTING_GRENADE: "Arremessáveis",
  T_36_YS_SETTING_MOVE: "Movimento",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Azul 2022",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Amarelo 2022",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Lupino",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Traje de Pet: Samalandra Cósmica",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Traje de Pet: Falcão do Booyah!",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Traje de Pet: Lupino-Guará",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Traje de Pet: Lupino Gótico",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Traje de Pet: Lupino Ártico",
  T_37_B_WS_HIDE: "Esconde-esconde",
  T_37_HZ_WS_CATMODEDESC1: "Esconde-esconde",
  T_37_JH_WS_CREATEGOLD_DESC: "Uma Máquina de Vendas disponível para jogadores comprarem itens. (Inválida nos seguintes modos: Contra Squad, Mata-Mata em equipe, Às Brincas e Cizânia Androide)",
  T_37_JH_WS_NAME1: "Faca FF (Cizânia Androide)",
  T_37_JH_WS_NAME10: "M1887 - X (Cizânia Androide)",
  T_37_JH_WS_NAME11: "SPAS12 (Cizânia Androide)",
  T_37_JH_WS_NAME12: "M1014 (Cizânia Androide)",
  T_37_JH_WS_NAME13: "MP40 (Cizânia Androide)",
  T_37_JH_WS_NAME14: "MP5 - III (Cizânia Androide)",
  T_37_JH_WS_NAME15: "P90 (Cizânia Androide)",
  T_37_JH_WS_NAME16: "M60 - III (Cizânia Androide)",
  T_37_JH_WS_NAME17: "Thompson (Cizânia Androide)",
  T_37_JH_WS_NAME18: "UMP (Cizânia Androide)",
  T_37_JH_WS_NAME19: "SVD (Cizânia Androide)",
  T_37_JH_WS_NAME2: "Groza (Cizânia Androide)",
  T_37_JH_WS_NAME20: "AWM (Cizânia Androide)",
  T_37_JH_WS_NAME21: "M82B (Cizânia Androide)",
  T_37_JH_WS_NAME22: "M249 - X (Cizânia Androide)",
  T_37_JH_WS_NAME23: "Kar98k - III (Cizânia Androide)",
  T_37_JH_WS_NAME3: "AK47 (Cizânia Androide)",
  T_37_JH_WS_NAME4: "M4A1 - III (Cizânia Androide)",
  T_37_JH_WS_NAME5: "SCAR (Cizânia Androide)",
  T_37_JH_WS_NAME6: "M14 - III (Cizânia Androide)",
  T_37_JH_WS_NAME7: "PARAFAL (Cizânia Androide)",
  T_37_JH_WS_NAME8: "XM8 (Cizânia Androide)",
  T_37_JH_WS_NAME9: "MAG-7 (Cizânia Androide)",
  T_37_JH_WS_VENDMACHINE_DESC: "É possível coletar ouro no mapa. (Inválida nos seguintes modos: Contra Squad, Mata-Mata em equipe, Às Brincas e Cizânia Androide)",
  T_37_JH_WS_X: "Eixo X",
  T_37_JH_WS_Y: "Eixo Y",
  T_37_JH_WS_Z: "Eixo Z",
  T_37_JL_FOOTBALL_TIE: "Empate",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Dom Nevado",
  T_37_LC_BP_ENTRANCE_GIFT: "Presente!",
  T_37_M_WS_MISSING: "Fonte inexistente",
  T_37_M_WS_NAMEERROR: "Contém caracteres sensíveis, remova-os.",
  T_37_PD_HuntingGround_BOSSTITLE: "O Açougueiro",
  T_37_QL_JUMPPAD_DES: "Cria um trampolim no chão. Ele pode ser usado para pular mais alto e abrir fogo ainda no ar.",
  T_37_QL_JUMPPAD_NAME: "Trampolim",
  T_37_R_TAILOR_LIMIT: "Tempo Limitado",
  T_37_RW_LOADOUT_BORNFIRETAG: "Receba 2 Fogueiras ao início da partida. A Fogueira [FFBA00]regenera 5 de vida e 20 de energia por segundo[-] (por até 10s) para você e seus aliados dentro da área. Efeito não acumulativo.",
  T_37_RW_PROPCATAPULT_DESC: "Pode ser usado para lançar um jogador no ar quando inflado. Mas não vai voar pra fora da Zona Segura!",
  T_37_RW_PROPCATAPULT_NAME: "Lançador",
  T_37_SP_WS_COLOR_02: "Cor",
  T_37_SP_WS_COLOR_03: "Aparência",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "A entidade é nula ao obter ou determinar a propriedade.",
  T_37_SP_WS_LOG_PHASE_END: "O estágio {0} acabou.",
  T_37_SP_WS_LOG_PHASE_START: "Estágio {0} começou",
  T_37_SP_WS_LOG_ROUND_END: "A rodada {0} acabou.",
  T_37_SP_WS_LOG_ROUND_START: "A rodada {0} começou.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Incompatibilidade de tipos ao determinar um valor à variável. Tipo necessário: {0} Tipo atual: {1}",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Variável local indefinida ou fora de escopo {0}",
  T_37_SP_WS_MAPACCESS_08: "Editar",
  T_37_SP_WS_RACEMODE_01: "Modo de contagem regressiva",
  T_37_SP_WS_RACEMODE_02: "Contagem regressiva",
  T_37_SP_WS_RACEMODE_04: "Quando ativado, a contagem regressiva iniciará quando uma equipe inteira alcançar a linha de chegada. A partida acaba quando a contagem regressiva termina.",
  T_37_SY_AR15_KABUKI_N: "Atiradeira - Caçadora de Onis",
  T_37_SY_BACKPACK_STRAW_N: "Mochila - Chapeuzinho",
  T_37_SY_GRENADE_FFWS2022_01_N: "Granada - Conquistador",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Animação Portal do Dragão",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Ataque das Mambas",
  T_37_SY_PET_FLYINGCREATURE_N: "Mandrako",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Traje de Pet: Patopinho Congelado",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Traje de Pet: Rei Mandrako",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Traje de Pet: Mandrako das Galáxias",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Traje de Pet: Mandrako Em Chamas",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Traje de Pet: Camisa 10",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Traje de Pet: Iéti Zero Grau",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jipe - Festival de Rock",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Picape - Dracônica",
  T_37_WT_WS_PVE2DESC: `Um modo de zumbis em que os jogadores devem eliminar um certo número zumbis dentro do limite de tempo ou sobreviver até o final.
Você pode configurar as regras e ajustar os zumbis como quiser, inclusive o número de zumbis que devem ser eliminados.`,
  T_37_WT_WS_RULEDESC: "Abata o número alvo de zumbis para vencer.",
  T_37_WT_WS_RULETITLE: "Gol",
  T_37_WT_WS_TXT1: "Abater zumbis",
  T_37_WT_WS_TXT1DESC: "Quando ativado, os jogadores vencem ao eliminar determinada quantidade de zumbis. Quando desativado, os jogadores vencem sobrevivendo até o final.",
  T_37_WT_WS_TXT2: "Número de abates",
  T_37_WZY_FRIDPLA: "Jogador parceiro",
  T_37_WZY_FRIDSIDE: "Grupo parceiro",
  T_37_WZY_FRIDTEAM: "Equipe parceira",
  T_37_WZY_HOSTPLA: "Jogador oponente",
  T_37_WZY_HOSTSIDE: "Grupo oponente",
  T_37_WZY_WS_ACCFRAMES: "Quadros acumulados",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Adicionar itens a um produto É possível adicionar um item unitário ou um grupo de itens. A quantidade pode ser o número de itens unitários ou de uma lista que contém o número de itens.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "A entidade produto para adicionar itens",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Os itens para adicionar. É possível adicionar um item unitário ou um grupo de itens.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "A quantidade de itens individuais para adicionar ou a lista que consiste nesta quantidade de itens.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Adicionar etiqueta à entidade selecionada",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "Entidade a qual a etiqueta será adicionada",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "O conteúdo de texto a ser adicionado",
  T_37_WZY_WS_AIMABLEENT: "Entidade mirável",
  T_37_WZY_WS_AIMASSISTTYPE: "Tipo de assistência de mira",
  T_37_WZY_WS_ALLOWDROP_NAME: "Habilitar/desabilitar soltar itens",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Se um jogador pode soltar/largar itens.",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "A entidade jogador que será configurada em relação a soltar itens",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Se um jogador pode soltar/largar itens. Este é um valor booleano.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Habilitar/desabilitar coletar itens",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Se um jogador pode coletar itens.",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "A entidade jogador que será configurada em relação a coletar itens",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Se um jogador pode coletar itens. Este é um valor booleano.",
  T_37_WZY_WS_AMBIENTCOLOR: "Cor da luz ambiente",
  T_37_WZY_WS_AMRORTOOL: "Reparar armaduras",
  T_37_WZY_WS_ATTACK: "Atacar",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Cancela o disfarce do jogador e faz com que ele retorne à aparência normal",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "Entidade jogador cujo disfarce será cancelado",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Aumenta a velocidade da bola de futebol!",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "A bola de futebol que receberá o bônus de velocidade",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "O vetor de velocidade do bônus",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Inicia quando a bola de futebol é atingida pela Arma Tijolada. [Entidade jogador] é a entidade de quem está com a Arma Tijolada. [Bônus de velocidade] é a velocidade adicionada à bola de futebol de ser atingida.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "O jogador com a Arma Tijolada",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "O vetor de velocidade da bola de futebol depois de ser atingida",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Inicia quando a bola de futebol colide com uma entidade e a velocidade da bola aumenta. [Entidade de colisão] é a entidade que colide com a bola de futebol. [Bônus de velocidade] é a velocidade adicionada à bola de futebol depois da colisão.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "A entidade que colide com a bola de futebol",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "O vetor de velocidade que é adicionado à bola de futebol ao colidir",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Ativa quando a entidade está sendo mirada por um jogador",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "O jogador mirando na entidade",
  T_37_WZY_WS_BEHAVIORSTAT: "Situação do comportamento do jogador",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "A entidade arma que acerta esta entidade",
  T_37_WZY_WS_BLOODBARENT: "Entidade barra de vida",
  T_37_WZY_WS_BOMBEND: "Antes da explosão",
  T_37_WZY_WS_BOMBSTART: "Indicador de bomba",
  T_37_WZY_WS_CHANENT: "Entidade canal",
  T_37_WZY_WS_CHEER: "Elogiar",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Verificar se uma entidade selecionada tem etiquetas atribuídas",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "Entidade a verificar se há etiquetas",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "Etiqueta a ser verificada",
  T_37_WZY_WS_CHELABELRES: "Resultado da verificação de etiqueta. Este é um valor Booleano.",
  T_37_WZY_WS_CJERSEY_NAME: "Mudar traje",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "Jogador cujo traje será alterado",
  T_37_WZY_WS_CJERSEY_PARAM2: "Estilo do traje",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "Estilo da camisa a substituir o antigo",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "Cor da parte 1 do traje",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "Cor da parte 2 do traje",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "Cor da parte 3 do traje",
  T_37_WZY_WS_CJERSEYTYPE1: "Visual 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Visual 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Visual 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Limpar todos os elementos da lista",
  T_37_WZY_WS_CREABLEOB_DESC: "O tipo de objeto que pode ser criado usando os blocos",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Criar produto personalizável e retornar uma entidade produto. O conteúdo de produtos podem ser configurado nas configurações de propriedade.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Criar lista de produto personalizável e retornar uma entidade lista de produto. O conteúdo desta lista pode ser alterado nas configurações de propriedade.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "A entidade lista de produtos a ser criada",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Criar entidade gangue",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "A entidade gangue a ser criada",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Criar loja personalizável e retornar uma entidade loja. O conteúdo da loja pode ser alterado nas configurações de propriedade.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "A entidade loja criada",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Alterar o ambiente do céu do jogo. As opções incluem dia, entardecer e noite.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "Tipo de céu a substituir o antigo As opções incluem dia, entardecer e noite.",
  T_37_WZY_WS_DARKNESS: "Escuridão geral",
  T_37_WZY_WS_DELENT_NAMEDESC: "Remover uma entidade específica. Atualmente oferece suporte a entidade ícone, entidade texto, entidade HUD, entidade efeitos visuais, entidade arma e outras entidades objeto.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "Entidade a ser removida",
  T_37_WZY_WS_DROP: "Engano",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Ativa quando o jogador larga um item. [Tipo de item] é o ID do item que foi largado.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "O ID do tipo de item que foi largado",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Ativa quando o jogador larga uma arma. [Entidade arma] é a arma que foi largada.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "A arma que foi largada",
  T_37_WZY_WS_DUMMYLEOBJ: "Objeto de estágio normal",
  T_37_WZY_WS_DUST: "Entardecer",
  T_37_WZY_WS_EMPTYCH: "Canal padrão vazio",
  T_37_WZY_WS_EMPTYCH1: "Canal vazio 1",
  T_37_WZY_WS_EMPTYCH2: "Canal vazio 2",
  T_37_WZY_WS_EMPTYCH3: "Canal vazio 3",
  T_37_WZY_WS_EMPTYCH4: "Canal vazio 4",
  T_37_WZY_WS_EMPTYCH5: "Canal vazio 5",
  T_37_WZY_WS_EMPTYCH6: "Canal vazio 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: "Obter lista com todas as entidades dentro das 3 condicionantes. O conteúdo inserido em “Inclui todos”, “Exclui” e “Inclui” é um tipo de componente único ou uma lista de tipos de componente. O resultado retornado é uma lista de entidades que satisfazem essas condicionantes.",
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "As entidades filtradas devem conter todos os componentes desta lista atribuídos.",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "As entidades filtradas não podem conter componentes desta lista atribuídos.",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "As entidades filtradas devem conter pelo menos um componente desta lista atribuído.",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "O tipo de propriedade a ser mudada na entidade",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "O valor da propriedade a ser mudado",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Deixa o jogador sair do canal atual para que ele não esteja em nenhum canal",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "Jogador a sair do canal",
  T_37_WZY_WS_FAKEENT: "Entidade disfarce",
  T_37_WZY_WS_FIND_STR_DESC: "Encontrar o local de determinado texto em uma sentença",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "O personagem a ser encontrado",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Encontrar uma sentença a partir de determinado local, começando com 0.",
  T_37_WZY_WS_FINDSTRRES: "A primeira localização da sentença. Começa em 0.",
  T_37_WZY_WS_FOGCOLOR: "Cor da fumaça",
  T_37_WZY_WS_FRICTIONCON: "Multiplicador comum de fricção",
  T_37_WZY_WS_FRICTIONIMP: "Multiplicador de fricção de colisão",
  T_37_WZY_WS_FROMDEATH: "Ressurgimento",
  T_37_WZY_WS_FROMKNODOWN: "Cura",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Obter canal onde o jogador específico está",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "A entidade jogador cujo canal será obtido",
  T_37_WZY_WS_GETCHANRES: "Canal onde aquele jogador está",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "De acordo com o ID do canal de 1 a 8, obter o canal vazio que foi criado por padrão no início do jogo",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID do canal padrão vazio",
  T_37_WZY_WS_GETEMPTYCH_RES: "Entidade canal obtida",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obter a entidade disfarce de um jogador",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "O objeto cuja entidade disfarce será obtida",
  T_37_WZY_WS_GETGAMEENT_NAME: "Tornar global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Obter entidade partida desta partida",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Obter jogador atacável",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Entidade gangue",
  T_37_WZY_WS_GOAL_NAMEDESC: "É ativado quando uma bola de futebol entra no gol. [Gol] é o gol onde a bola de futebol entra. [Atacante] é o último jogador que teve contato com a bola. [Assistente] é o penúltimo jogador a ter contato com a bola.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "O gol onde a bola entra",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "O último jogador que teve contato com a bola",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "O penúltimo jogador que teve contato com a bola",
  T_37_WZY_WS_HEARTBEAT: "Pulso",
  T_37_WZY_WS_HEAVYWEAPON: "Arma pesada",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Menor ângulo de saraivadas",
  T_37_WZY_WS_HOSTPLA: "Lista de jogadores atacáveis",
  T_37_WZY_WS_HOSTSIDE: "Lista de gangues atacáveis",
  T_37_WZY_WS_HOSTTEAM: "Lista de equipes atacáveis",
  T_37_WZY_WS_ICON_CLOCK: "Contagem regressiva",
  T_37_WZY_WS_ICON_CLOTHES: "Trajes",
  T_37_WZY_WS_ICON_QUIT: "Sair",
  T_37_WZY_WS_INSERT_ARR_DESC: "Adicionar novo elemento a um local atribuído na lista",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extrair uma sentença de determinado tamanho, começando no local do índice. Se o comprimento da extração exceder o comprimento da sentença, todo o conteúdo da sentença será extraído.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Comprimento da extração",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "A sentença que foi extraída",
  T_37_WZY_WS_INTORINTL: "Inteiros ou lista de inteiros",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Permitir que um jogador se junte a uma gangue específica",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "A gangue para o jogador se juntar",
  T_37_WZY_WS_JUMP: "Saltar",
  T_37_WZY_WS_LABEL: "Etiqueta",
  T_37_WZY_WS_LENSFLARE: "Reflexo da lente",
  T_37_WZY_WS_LENTH: "Comprimento",
  T_37_WZY_WS_LIGHTATTACK: "Acerto bem sucedido",
  T_37_WZY_WS_LIGHTCOLOR: "Cor da fonte de luz",
  T_37_WZY_WS_LIGHTINTENSITY: "Brilho da fonte de luz",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Carregar novo cenário",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "O nome do cenário para carregar.",
  T_37_WZY_WS_MOROBJECT: "Objeto de disfarce",
  T_37_WZY_WS_MOVEAXISX: "Mover no eixo x",
  T_37_WZY_WS_MOVEAXISY: "Mover no eixo y",
  T_37_WZY_WS_MOVEAXISZ: "Mover no eixo z",
  T_37_WZY_WS_MOVEDISTITLE: "Distância de movimento",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Mensagem rápidas ligadas-desligadas",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Ative ou desative as mensagens rápidas. Quando desativadas, não será possível enviar ou receber mensagens rápidas.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "O jogador para o qual as mensagens rápidas serão ativadas/desativadas",
  T_37_WZY_WS_MUTEVOICE_NAME: "Chat de voz ativado-desativado",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Ative ou desative o chat de voz. Quando desativado, não será possível enviar ou receber mensagens de voz.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "O jogador para ativar/desativar o chat de voz por",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Booleano. Verdadeiro significa desativado; Falso significa ativado.",
  T_37_WZY_WS_NIGHTMODE: "Modo noturno",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Ativa quando o jogador mirar em uma entidade mirável. [Entidade alvo] é a entidade sendo mirada. Quando não há entidade sob mira, o valor de retorno é nulo.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Entidade mirada",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "A entidade que foi acertada pela arma",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Inicia quando o cenário carrega com sucesso.",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "O nome do cenário para carregar. Esta é uma sentença.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Inicia quando o cenário troca com sucesso",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "O nome do novo cenário. Esta é uma sentença.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restaurar o traje do jogador para visual padrão",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "Jogador cujo traje será restaurado",
  T_37_WZY_WS_PETSET: "Configuração de pets",
  T_37_WZY_WS_PETSKILL: "Habilidades de pet",
  T_37_WZY_WS_PETSWITCH2: "Habilidades de pet podem ser usadas ou não",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Habilitar movimento de jogador ou não. Este é um valor Booleano.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Tipo de comportamento do jogador",
  T_37_WZY_WS_PRESS: "Toque suave",
  T_37_WZY_WS_PROGRESS: "Progresso atual",
  T_37_WZY_WS_PROGRESSBAR: "Entidade HUD de progresso",
  T_37_WZY_WS_RANKDOWN: "Patente rebaixada",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Remover etiqueta da entidade selecionada",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "O conteúdo de texto a ser removido",
  T_37_WZY_WS_REPLACE_STR_DESC: "Substituir conteúdo de um segmento de conteúdo específico",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "O personagem a ser substituído",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "O personagem irá substituir",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Reverte todos os elementos nesta lista",
  T_37_WZY_WS_REVIVEHERE: "O jogador revivendo colegas de equipe neste ponto de ressurgimento",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Ativa quando um jogador revive colegas de equipe neste ponto de ressurgimento",
  T_37_WZY_WS_REVIVEWAYDESC: "Método pelo qual um jogador é revivido ou levantado ao ser abatido ou derrubado",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configura status de diferentes comportamentos de jogadores. Ao desabilitar, os botões correspondentes no HUD não podem ser utilizados, e movimentos manuais ou automáticos não são permitidos. Ao esconder, os botões correspondentes não serão mostrados no HUD, e movimentos manuais não são permitidos enquanto movimentos automáticos são permitidos. Quando habilitados, os botões correspondentes serão mostrados no HUD, e movimentos manuais e automáticos são permitidos.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "O jogador cujo status de comportamento será estabelecido",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "O comportamento do jogador, incluindo movimentação, ataque, pulo e corrida",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Status incluem desabilitado, escondido ou habilitado. Ao esconder, os botões correspondentes não serão mostrados no HUD, e movimentos manuais não são permitidos enquanto movimentos automáticos são permitidos. Quando habilitados, os botões correspondentes serão mostrados no HUD, e movimentos manuais e automáticos são permitidos.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "As coordenadas da bola de futebol",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Se a bola de futebol deve manter a velocidade pré-estabelecida ou não. Este é um valor Booleano.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Configuração do ataque de jogador",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configurar se [Jogador configurado] pode atacar [Jogador alvo]. As configurações padrão dependem se o jogador alvo pertence a uma equipe ou gangue que podem ser atacadas. Essa configuração é de prioridade mais alta em comparação à configuração de equipe/gangue.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "Jogador para o qual os oponentes serão configurados",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "O jogador que é o oponente",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Atacável ou não",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: "“Sim” significa atacável; “Não”, significa não atacável. As configurações padrão dependem se o jogador alvo pertence a uma equipe ou gangue que podem ser atacadas.",
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: "“Sim” significa atacável; “Não”, significa não atacável.",
  T_37_WZY_WS_SHADOWSTRENGTH: "Calça Negra",
  T_37_WZY_WS_SHOOTANGLE: "Menor ângulo de disparo",
  T_37_WZY_WS_SKYBOX: "Céu",
  T_37_WZY_WS_SKYBOXENT: "Entidade céu",
  T_37_WZY_WS_SKYBOXTYPE: "Tipos básicos de céu",
  T_37_WZY_WS_STEPPED: "Pisar no gatilho/iniciador",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Trocar canal de chat de voz do jogador",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "O jogador cujos canais serão trocados",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "Canal para o qual será mudado",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Trocar para um cenário específico",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "O nome do cenário para o qual irá trocar",
  T_37_WZY_WS_TARGETSTR_DESC: "Sentença alvo",
  T_37_WZY_WS_TEAMASIDE: "Equipe e Grupo",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automático",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Teleportável ou não",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "Não",
  T_37_WZY_WS_TELEPORTN_TITLE: "Método de Teleporte",
  T_37_WZY_WS_TELEPORTN_YES: "Sim",
  T_37_WZY_WS_TERRAINWET: "Umidade do terreno",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Substituir a aparência de uma [Entidade jogador] com a aparência de um [Objeto do cenário]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "A entidade jogador cuja aparência será alterada",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "Jogador cuja entidade disfarce será obtida",
  T_37_WZY_WS_TRANSP: "Transparência",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Desinstalar um cenário específico",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "O nome do cenário para desinstalar",
  T_37_WZY_WS_VFX1: "Simbólico",
  T_37_WZY_WS_VFX2: "Esfumaçado",
  T_37_WZY_WS_VFX3: "Explosão do Mal",
  T_37_WZY_WS_VFX5: "Congelado",
  T_37_WZY_WS_VFX6: "Holofote",
  T_37_WZY_WS_VFX7: "Turbulência nas Alturas",
  T_37_WZY_WS_VFX8: "Explosão Atmosférica",
  T_37_WZY_WS_VISABLE: "Visibilidade",
  T_37_WZY_WS_WEAOPEN: "Mostrar ou não",
  T_37_WZY_WS_WEAPONENT: "Entidade arma",
  T_37_WZY_WS_WEATARGETED: "Pode ser mirada com assistência de mira",
  T_37_XYL_CUSTOMJERSEY: "Fábrica de Trajes",
  T_37_XYL_CUSTOMJERSEY_DESC: "Use a Fábrica de Trajes para criar seu traje dos sonhos",
  T_37_XYL_FOOTGUN: "Arma Tijolada",
  T_37_XYL_SOCCER: "Futebol",
  "T_37_XYL_SOCCER_ RADIUS": "Raio",
  T_37_XYL_SOCCER_DESC: "Uma bola de futebol que pode ter suas propriedades personalizadas",
  T_37_XYL_SOCCER_HIGHT1: "Ãngulo normal",
  T_37_XYL_SOCCER_HIGHT2: "Ângulo de saraivada",
  T_37_XYL_SOCCER_RESET: "Reinicia o tempo depois de um gol (s)",
  T_37_XYL_SOCCER_RESIST1: "Fricção (Modo Chute)",
  T_37_XYL_SOCCER_RESIST2: "Fricção (Modo Arma)",
  T_37_XYL_SOCCERGOAL: "Gol",
  T_37_XYL_SOCCERGOAL_DESC: "Este é o gol. Atire a bola para dentro do gol para marcar pontos (Válido apenas para pontuação)",
  T_37_XYL_SOCCERITEM: "Gerador de itens",
  T_37_XYL_SOCCERITEM_DESC: "Ao ser colocado, irá gerar o item selecionado",
  T_37_XYL_SPAWN_PEOPLE: "N.º de jogadores",
  T_37_XYL_WS_AIRCONDITIONER001: "Ar condicionado B",
  T_37_XYL_WS_AMMUCHEST: "Baú de Batalha A",
  T_37_XYL_WS_BAFFLE001: "Barreira A",
  T_37_XYL_WS_BARREL001: "Barris",
  T_37_XYL_WS_BARREL001_DES: "Barris de madeira redondos vistos normalmente",
  T_37_XYL_WS_BOARD001: "Painel de Anúncios B",
  T_37_XYL_WS_BOOK001: "Pilha de Livros A",
  T_37_XYL_WS_BOOK002: "Tabuleiro A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decoração - aquele toque especial no lugar!",
  T_37_XYL_WS_BOX001: "Pilha de Caixas A",
  T_37_XYL_WS_BOX002: "Pacote Pequeno",
  T_37_XYL_WS_BUSHCOVER: "Moita",
  T_37_XYL_WS_BUSHCOVER_DES: "Uma moita que pode ser usada como esconderijo",
  T_37_XYL_WS_CABINET001: "Gavetas A",
  T_37_XYL_WS_CHAIR001: "Cadeira A",
  T_37_XYL_WS_COCONUTTREE: "Coqueiro",
  T_37_XYL_WS_COCONUTTREE_DES: "Decoração - para uma vibe praiana!",
  T_37_XYL_WS_COMPUTER001: "Computador A",
  T_37_XYL_WS_DAMAGERATIO: "Proporção de dano",
  T_37_XYL_WS_FIREEX: "Extintor de incêndio",
  T_37_XYL_WS_GUIDEPOSE: "Poste direcional",
  T_37_XYL_WS_HUGEHOUSE001: "Casa de 3 andares B",
  T_37_XYL_WS_HUGEHOUSE002: "Casa de 2 andares B",
  T_37_XYL_WS_JACKSTRAW: "Espantalho",
  T_37_XYL_WS_LADDER001: "Escada A",
  T_37_XYL_WS_OILDRUM: "Galão",
  T_37_XYL_WS_ORNAMENT001: "Vaso A",
  T_37_XYL_WS_PACKBOX: "Guarda-suprimentos",
  T_37_XYL_WS_PILLA001: "Pilar de concreto",
  T_37_XYL_WS_PRESENT: "Pacote Presente",
  T_37_XYL_WS_PRESENT_DES: "Contém presentes",
  T_37_XYL_WS_PUMPKIN: "Lanterna de abóbora quadrada",
  T_37_XYL_WS_PUMPKINCUT: "Lanterna de abóbora",
  T_37_XYL_WS_PUMPKINCUT_DES: "Decoração clássica do Dia das Bruxas",
  T_37_XYL_WS_ROADBLOCK001: "Bloqueio no caminho B",
  T_37_XYL_WS_SHELF001: "Livreiro A",
  T_37_XYL_WS_SOFA001: "Sofá A",
  T_37_XYL_WS_SPAWNTEAM: "Todas as equipes",
  T_37_XYL_WS_SUPPLYBOX: "Pacote Munição",
  T_37_XYL_WS_TABLE001: "Mesa A",
  T_37_XYL_WS_TABLE002: "Mesa B",
  T_37_XYL_WS_TARGET001: "Alvo",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal de Ponto Final",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Um portal que pode levar o jogador diretamente para o ponto final do portal",
  T_37_XYL_WS_TIRES001: "Pneu A",
  T_37_XYL_WS_TOOLRACK: "Prateleira de Ferramentas",
  T_37_XYL_WS_WALL001: "Parede",
  T_37_XYL_WS_WOOD001: "Pedaços de madeira",
  T_37_XYL_WS_YELLOWDUCK001: "Patinho amarelo",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Boia em formato de pato",
  T_37_YM_BOMBSQUAD_DEFUSER: "Desarmador",
  T_37_YS_B_BRFOOTBALL_WHITE: "Bermuda CBF Branca",
  T_37_YS_F_B_VN_STREET: "Estilo Moleca",
  T_37_YS_F_H_VN_STREET: "Estilo Moleca",
  T_37_YS_F_S_VN_STREET: "Estilo Moleca",
  T_37_YS_F_T_VN_STREET: "Estilo Moleca",
  T_37_YS_M_A_CRICKET_BLACK: "Críquete Preto",
  T_37_YS_M_A_THKOL: "Tamo Junto",
  T_37_YS_M_B_CRICKET_BLACK: "Críquete Preto",
  T_37_YS_M_B_SILVERERA: "Mercúrio Retrógrado",
  T_37_YS_M_B_THKOL: "Tamo Junto",
  T_37_YS_M_H_SILVERERA: "Mercúrio Retrógrado",
  T_37_YS_M_H_THKOL: "Tamo Junto",
  T_37_YS_M_S_CRICKET_BLACK: "Críquete Preto",
  T_37_YS_M_S_SILVERERA: "Mercúrio Retrógrado",
  T_37_YS_M_S_THKOL: "Tamo Junto",
  T_37_YS_M_T_CRICKET_BLACK: "Críquete Preto",
  T_37_YS_M_T_SILVERERA: "Mercúrio Retrógrado",
  T_37_YS_M_T_THKOL: "Tamo Junto",
  T_37_YS_T_BRFOOTBALL_WHITE: "Camisa CBF Branca",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Nº mínimo de jogadores",
  T_38_BQ_SKILL_NAME_DUMMY1: "Manequim Dublê",
  T_38_BQ_SKILL_NAME_DUMMY2: "Manequim de Transporte",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Gata (Pernas)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Gata (Cabeça)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Gata (Calçado)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Gata (Torso)",
  T_38_JH_WS_CM1: "Regras claras",
  T_38_JH_WS_CM2: "Regras confusas",
  T_38_JH_WS_CM3: "Desistências frequentes",
  T_38_JL_M79_AMMO_N: "Munição M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "Biochip Sentinela Silencioso",
  T_38_M_WS_VECTOR2: "Vetor 2D",
  T_38_R_TACTICS_N: "Opção rápida",
  T_38_RW_NIW_NIWNAME: "Máquina de Gel",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "A quantidade de camadas de blocos supera o máximo permitido. Atual: {0}; Máx.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "O número de itens criados supera o máximo permitido. Atual: {0}; Máx.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "O número de incidentes criados no mesmo quadro supera o máximo permitido. Atual: {0}; Máx.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Limite de criação de entidades dinâmicas por quadro atingido ({0}); {1} tentativas de criação foram recusadas.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "O comprimento da lista iniciada  ({0}) supera o máximo permitido ({1}). Cria uma lista de capacidade máxima automaticamente.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "O número de ciclos supera o máximo permitido. Atual: {0}; Máx.: {1}. Ciclo interrompido",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "O número de rotinas simultâneas supera o máximo permitido. Atual: {0}; Máx.: {1}.",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Falha ao adicionar elemento na lista. A lista {0} esta vazia.",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Desencontro de tipos de valores ao realizar operações aritméticas básicas. O tipo de valor da esquerda é {0} e o tipo de valor da direita é {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Definição variável temporária repetida. Nome da variável: {0}.",
  T_38_SP_WS_REVIEW_01: "Tóxico",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Ofensivo",
  T_38_SP_WS_REVIEW_04: "Muito tóxico",
  T_38_SP_WS_REVIEW_05: "Ameaçador",
  T_38_SP_WS_REVIEW_06: "Desrespeitoso",
  T_38_SP_WS_REVIEW_07: "Em análise",
  T_38_SP_WS_REVIEW_08: "{0} o nome {1} não respeita as regras. {2}.",
  T_38_SP_WS_REVIEW_09: "Sentença",
  T_38_SP_WS_REVIEW_10: "Loja",
  T_38_SP_WS_REVIEW_11: "Variável",
  T_38_SP_WS_REVIEW_12: "Função",
  T_38_SP_WS_REVIEW_13: "Objeto",
  T_38_SP_WS_REVIEW_14: "Ir para as definições.",
  T_38_SP_WS_REVIEW_15: "Ir para gerencia objetos.",
  T_38_SP_WS_REVIEW_16: "Não redirecionar.",
  T_38_SP_WS_REVIEW_17: "Nome do mapa",
  T_38_SP_WS_REVIEW_18: "Descrição",
  T_38_SP_WS_REVIEW_19: "Imagem de capa",
  T_38_SP_WS_REVIEW_20: "O texto contém palavras proibidas.",
  T_38_SP_WS_REVIEW_21: "Falha ao salvar. Não é possível analisar agora.",
  T_38_SP_WS_REVIEW_22: "Análise em espera.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bastão - Felina Gemada",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Mandacaru",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Traje de Pet: Mandacaru de Cordel",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Traje de Pet: Mandacaru de Cordel",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Traje de Pet: Mandacaru Cajuína",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Traje Pet: Mandrako Baladeiro",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Traje de Pet: Estilo Punkin",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Deus do Fogo",
  T_38_SY_SICKLE_ES_N: "Foice - Confronto",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Picape - Jantar Sobre Rodas",
  T_38_WT_WS_MUITLEVEL: "Multinível",
  T_38_WT_WS_SKILLSET15: "Emoção da Batalha (A124)",
  T_38_WT_WS_SKILLSET16: "Olho de Argos (Homero)",
  T_38_WT_WS_SKILLSET17: "Rastreadora (Íris)",
  T_38_WT_WS_SKILLSET18: "Disparo Rebelde (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Usável ou não no cenário",
  T_38_WZY_WS_ACTIVEB: "Ative ou não a lógica de atualizar",
  T_38_WZY_WS_ACTIVEVALUE: "Situação da atividade",
  T_38_WZY_WS_AIR: "Ar",
  T_38_WZY_WS_ALLOWMOVE: "Movível ou não",
  T_38_WZY_WS_AMMOAMOUNT: "Quantidade de munição",
  T_38_WZY_WS_AMMONAME: "Entidade munição",
  T_38_WZY_WS_ARMOR_DAMRED: "Redução do multiplicador de dano.",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Redução do multiplicador de dano de explosões.",
  T_38_WZY_WS_ARMOR_DURABILITY: "Durabilidade atual",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Durabilidade máxima",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Danificável ou não",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destruível ou não",
  T_38_WZY_WS_ARMOR_LEVEL: "Nível",
  T_38_WZY_WS_ASSCONZOM: "Assistência abatendo zumbis.",
  T_38_WZY_WS_BAGNAME: "Entidade Mochila",
  T_38_WZY_WS_BAGSPACEEX: "Espaço adicional na mochila",
  T_38_WZY_WS_BRIDGING: "Compondente de renderização de ponte",
  T_38_WZY_WS_BUBBLE: "Bolha",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Apague todos os itens na mochila da [entidade jogador]",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Apague todos os itens indesejados no mapa, como espólios e resíduos de arremessáveis.",
  T_38_WZY_WS_CLEARPRO: "Limpar fator de propriedade único",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clone uma entidade [objeto cenário] no local de uma [entidade jogador] e retorne a [entidade disfarce]",
  T_38_WZY_WS_COMPONENT: "Componente",
  T_38_WZY_WS_COSTAMMO: "Consome munição",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Criar a câmera e retornar a [entidade câmera] cujas propriedades podem ser modificadas nas configurações de propriedade.",
  T_38_WZY_WS_CYCLES: "Número de execuções",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Verifique se uma [entidade] está dentro do alcance de um polo circular. O [centro] é o centro do polo, o [raio] é o raio da superfície circular, a [altura] é a altura do polo, o [ângulo de Euler] são os ângulos de orientação 3D do polo.",
  T_38_WZY_WS_CYLINDERJUD_RES: "Resultado da verificação do alcance do polo circular. Este é um valor Booleano.",
  T_38_WZY_WS_DAMSUMZOM: "Dano contra zumbis",
  T_38_WZY_WS_DARKNESS: "Escuridão",
  T_38_WZY_WS_DIFCOLOR: "Cor da superfície",
  T_38_WZY_WS_DIFTEXTURE: "Textura da superfície",
  T_38_WZY_WS_DRUMMUSIC: "Tipo de componente: tambor",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "O jogador que foi desconectado",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "O jogador que esta reconectando",
  T_38_WZY_WS_EUIANCHOR: "Enumeração de ancoragem de HUD",
  T_38_WZY_WS_FEATHER: "Plumas",
  T_38_WZY_WS_FLAMEAMMO: "Munição de Lança-chamas",
  T_38_WZY_WS_FLOWER: "Flor",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Determina que a [entidade] sempre siga a [entidade seguida]. As [coordenadas de deslocamento] são definidas pela distância entre as duas entidades.",
  T_38_WZY_WS_FOLLOWENT: "Entidade seguida",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Conseguir a entidade câmera usada no momento pela [entidade jogador]",
  T_38_WZY_WS_GETCURCAMDESC: "A câmera que está sendo usada pelo jogador",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Consiga a quantidade de um item de [determinado tipo de item] que um [jogador] possui.",
  T_38_WZY_WS_GETITEMNUM_RES: "A quantidade de determinado item  que um jogador possui.",
  T_38_WZY_WS_GETVEC_NAME: "Conseguir vetor",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Conseguir vetor usando os componentes x, y e z de determinada coordenada.",
  T_38_WZY_WS_GETVECRES: "O vetor conseguidos com os componentes x, y e z",
  T_38_WZY_WS_GHOST: "Fantasma",
  T_38_WZY_WS_GRENADEFROZENNAME: "Entidade Bomba Congelante",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Raio da área congelada",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Duração do congelamento",
  T_38_WZY_WS_GRENADENAME: "Entidade granada",
  T_38_WZY_WS_GRENADEPARAM1: "Dano mín.",
  T_38_WZY_WS_GRENADEPARAM2: "Dano máx.",
  T_38_WZY_WS_GRENADEPARAM4: "Área da explosão",
  T_38_WZY_WS_GRENADEPARAM5: "Velocidade de lançamento",
  T_38_WZY_WS_GRENADEPARAM6: "Atraso da explosão",
  T_38_WZY_WS_GRENADEPARAM7: "Multiplicador de dano próprio",
  T_38_WZY_WS_GRENADEPARAM8: "Multiplicador de dano aliado",
  T_38_WZY_WS_GRENADEPARAM9: "Multiplicador de dano de veículo",
  T_38_WZY_WS_GUNFIRE: "Armas de fogo",
  T_38_WZY_WS_GUNPRO_PARAM2: "Velocidade de Recarga",
  T_38_WZY_WS_GUNPRO_PARAM3: "Raio do dano de disparos no corpo",
  T_38_WZY_WS_GUNPRO_PARAM4: "Raio do dano de disparos na cabeça",
  T_38_WZY_WS_GUNPRO_PARAM5: "Raio do dano de disparos nos membros",
  T_38_WZY_WS_GUNPRO_PARAM7: "Dano extra",
  T_38_WZY_WS_HELMET_NAME: "Entidade capacete",
  T_38_WZY_WS_ICON1: "Coroa",
  T_38_WZY_WS_ICON2: "Duelo",
  T_38_WZY_WS_INITPOS: "Local inicial",
  T_38_WZY_WS_ISRESET: "Movimento de resposta",
  T_38_WZY_WS_KILLCONZOM: "Nº. de zumbis eliminados",
  T_38_WZY_WS_KILLENT_NAMEDESC: "A [entidade] escolhida para eliminar deve ser de um tipo de batalha. Ignorar estatísticas invulneráveis.",
  T_38_WZY_WS_LABELPARAM: "Lista de parâmetro de conteúdo textual",
  T_38_WZY_WS_LEADMUSICA: "Tipo de componente: Piano (agudos)",
  T_38_WZY_WS_LEADMUSICB: "Tipo de componente: Piano (grave)",
  T_38_WZY_WS_LEADMUSICC: "Tipo de componente: Piano (baixo)",
  T_38_WZY_WS_LINE: "Linha",
  T_38_WZY_WS_LIQUID: "Líquido",
  T_38_WZY_WS_LOCALKEY: "Sentença localizada",
  T_38_WZY_WS_LOCALPOS: "Localização relativa",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Defina uma [entidade] para sempre apontar para a [entidade mirada]. As [coordenadas de deslocamento] são a diferença entre as coordenadas do local mirado e a posição da entidade.",
  T_38_WZY_WS_MAINWEAPONA: "Arma principal 1",
  T_38_WZY_WS_MAINWEAPONB: "Arma principal 2",
  T_38_WZY_WS_MOTIONTIME: "Duração do movimento",
  T_38_WZY_WS_MOTIONTYPE: "Método do movimento",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Energia modificada",
  T_38_WZY_WS_MUSHROOMNAME: "Entidade cogumelo",
  T_38_WZY_WS_OBFACTION: "Assistir gangue",
  T_38_WZY_WS_OBGLOBAL: "Assistir todos",
  T_38_WZY_WS_OBSERVER: "Opções para assistir",
  T_38_WZY_WS_OBTEAM: "Assistir equipe",
  T_38_WZY_WS_OFFSETVEC: "Coordenadas de deslocamento",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Inicia quando um jogador compra itens desta Máquina de Vendas. A [entidade jogador] é o jogador que realiza a compra. A [entidade produto] é o item comprado.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Inicia quando equipado por uma [entidade jogador]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Inicia quando o jogador completa a ação de saltar",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Inicia quando o jogador completa a ação de agachar",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Inicia quando a arma é recarregada",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Inicia quando o jogador completa a ação de correr",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Inicia quando o jogador completa a ação de deitar",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Inicia quando uma arma elimina uma unidade. A [entidade eliminada] é a unidade que foi eliminada.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Inicia quando uma arma infligi dano a uma entidade de batalha. [Acertar alvo] é a entidade de batalha que recebeu o dano. [Dano] é o dano infligido.",
  T_38_WZY_WS_OWNER: "Dono",
  T_38_WZY_WS_PARAMLIST: "Lista de parâmetros",
  T_38_WZY_WS_PARTICALMAP: "Mapeamento de partículas",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pausar ou continuar o emote atual para a [entidade jogador]. [Pausar ou não] é um valor booleano. "Sim" significa pausar; "Não" significa continuar.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Ativado quando um jogador entra no iniciador.",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Ativado quando um jogador sai do iniciador.",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Force a [entidade jogador] a reproduzir determinado [emote] uma vez e retornar a posição inicial ao finalizar.",
  T_38_WZY_WS_PLAYSPEED: "Porcentagem da velocidade de reprodução",
  T_38_WZY_WS_PREHUD_NAME: "Ícone predefinido",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Deixe a [entidade jogador] abandonar o grupo atual",
  T_38_WZY_WS_RESETENT: "Atualizar componentes a cada rodada",
  T_38_WZY_WS_RESUUID: "Recurso UUID",
  T_38_WZY_WS_RIMCOLOR: "Cor das bordas",
  T_38_WZY_WS_RIMTEXTURE: "Textura das bordas",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Verificar se uma [entidade] está dentro do cone. O [centro] e o [raio] são valores referentes ao cone. O [raio extraído] é o raio do menor setor dentro do cone. A [altura] se refere a estrutura 3D. O [ângulo] refere-se ao ângulo central do cone. O [ângulo de direção] é o vetor de direção do eixo central.",
  T_38_WZY_WS_SECTORJUD_RES: "Resultado da verificação de alcance em formato de ventilador. Este é um valor Booleano.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Definir o estado da atividade da [entidade alvo]. O [estado da atividade] é o valor booleano e afeta as seguintes características da entidade: disponibilidade, visibilidade e se é colidível.",
  T_38_WZY_WS_SETROUNDSCORE: "Placar da rodada do jogador",
  T_38_WZY_WS_SHOOTANGMAX: "Ângulo máximo de disparo",
  T_38_WZY_WS_SHOWMAPINFO: "Mostrar a informação do mapa para o mesmo grupo",
  T_38_WZY_WS_SHOWNAMEHUD: "Mostrar o nome da HUD para o mesmo grupo",
  T_38_WZY_WS_SOUND1: "Aceleração",
  T_38_WZY_WS_SOUND10: "Estágio inicial",
  T_38_WZY_WS_SOUND11: "Zumbis",
  T_38_WZY_WS_SOUND12: "Terror",
  T_38_WZY_WS_SOUND13: "Transformação",
  T_38_WZY_WS_SOUND14: "Coração acelerado",
  T_38_WZY_WS_SOUND15: "Pulso médio",
  T_38_WZY_WS_SOUND16: "Pulso lento",
  T_38_WZY_WS_SOUND17: "Correria",
  T_38_WZY_WS_SOUND18: "Clique",
  T_38_WZY_WS_SOUND19: "Recuperação de habilidade",
  T_38_WZY_WS_SOUND2: "Notificação de desaparecimento",
  T_38_WZY_WS_SOUND20: "Começar uma partida",
  T_38_WZY_WS_SOUND3: "Efeitos visuais",
  T_38_WZY_WS_SOUND4: "Pássaros noturnos",
  T_38_WZY_WS_SOUND5: "Acerto (Cego)",
  T_38_WZY_WS_SOUND6: "Reação",
  T_38_WZY_WS_SOUND7: "Encontro surpresa",
  T_38_WZY_WS_SOUND8: "Aparição",
  T_38_WZY_WS_SOUNDENT: "Entidade música",
  T_38_WZY_WS_SPAWNPOS: "Ponto de surgimento antigo",
  T_38_WZY_WS_SPHERENAME: "Esfera básica",
  T_38_WZY_WS_SPHERERADIUS: "Raio da esfera",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Verifica se determinada [entidade] está dentro do [alcance esférico]. O [centro] e o [raio] são valores referentes à estrutura esférica.",
  T_38_WZY_WS_SPHERICALJUD_RES: "Resultado da verificação de alcance esférico. Este é um valor Booleano.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Verifique se uma [entidade] está dentro do alcance de um cubo. O [centro], o [comprimento], a [largura] e a [altura] referem-se ao cubo. Os [ângulos Euler] são os ângulo da orientação 3D do cubo.",
  T_38_WZY_WS_SQUAREJUD_RES: "Resultado da verificação de alcance cúbico. Este é um valor Booleano.",
  T_38_WZY_WS_STARTGENTIME: "Tempo inicial de ressurgimento",
  T_38_WZY_WS_STAYTIME: "Duração da pausa",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Troque a câmera do jogador usando a [entidade câmera]. A opção [trocar modo] pode acontecer sem a animação ou com movimento progressivo. A opção [troca tempo] refere-se ao tempo de troca no modo progressivo.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Trocar o modo da câmera. É possível selecionar as opções: Sem Animação ou Movimento Progressivo.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'O tempo de troca durante o modo de movimento progressivo. Ao selecionar a opção "Sem Animação" esta configuração ficará vazia.',
  T_38_WZY_WS_TEXTHUD: "Componente de texto do HUD",
  T_38_WZY_WS_TEXTTYPE: "Tamanho da fonte",
  T_38_WZY_WS_TEXTUREID: "Tipo de textura",
  T_38_WZY_WS_TRANDIST: "Distância máx.",
  T_38_WZY_WS_TWEENERENABLED: "Ativar ou não script UITweener",
  T_38_WZY_WS_TYPELIST: "Lista de tipos",
  T_38_WZY_WS_TYPELISTORLIST: "Tipo ou lista de tipos",
  T_38_WZY_WS_VEST_NAME: "Entidade colete",
  T_38_WZY_WS_VFX1: "Eliminação escondida",
  T_38_WZY_WS_VFX10: "Combustão cíclica",
  T_38_WZY_WS_VFX11: "Gás tóxico",
  T_38_WZY_WS_VFX13: "Coração",
  T_38_WZY_WS_VFX15: "Porta",
  T_38_WZY_WS_VFX2: "Redenção",
  T_38_WZY_WS_VFX3: "Clonar a eliminação",
  T_38_WZY_WS_VFX4: "Relatório de acerto",
  T_38_WZY_WS_VFX5: "Clonar",
  T_38_WZY_WS_VFX6: "Disfarçar",
  T_38_WZY_WS_VFX7: "Flashes de luz",
  T_38_WZY_WS_VFX8: "Movimento de trilho",
  T_38_WZY_WS_VFX9: "Carregar disparo",
  T_38_WZY_WS_VFXENT: "Instância de efeito visual",
  T_38_WZY_WS_VFXTYPEA_NAME: "Mapeamento de customização de efeito visual",
  T_38_WZY_WS_VFXTYPEB_NAME: "Mapeamento não-customizável de efeito visual",
  T_38_WZY_WS_VISIBILITY: "Tipo de visibilidade",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Gerador de Arma",
  T_38_WZY_WS_WHECYCLE: "Repetir",
  T_38_XXJ_WS_BLOCKMODE: "Modo Bloqueado",
  T_38_XXJ_WS_CUSTOMCAMARA: "Personalizar câmera",
  T_38_XXJ_WS_FFCLASSIC: "FF Clássico (Tiros)",
  T_38_XXJ_WS_FOV: "Campo de visão",
  T_38_XXJ_WS_FOVDESC: "O campo de visão refere-se ao alcance da câmera.",
  T_38_XXJ_WS_FPS: "1ª Pessoa (Tiros)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Ângulo horizontal",
  T_38_XXJ_WS_INVISICAM: "Quase transparente",
  T_38_XXJ_WS_OFFSET: "Deslocamento",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Ortografia",
  T_38_XXJ_WS_PERSPECTIVE: "Perspectiva",
  T_38_XXJ_WS_PROJECTIONMODE: "Modo Projeção",
  T_38_XXJ_WS_STABLE: "Fixo",
  T_38_XXJ_WS_STARTCAMERA: "Câmera padrão",
  T_38_XXJ_WS_STARTCAMERAMODE: "Modo de câmera padrão",
  T_38_XXJ_WS_THIRD: "Seguir câmera",
  T_38_XXJ_WS_TOPVIEW: "Ângulo alto",
  T_38_XXJ_WS_TPS: "Terceira pessoa",
  T_38_XXJ_WS_TRANSVERSE: "Movimento horizontal",
  T_38_XXJ_WS_VERTICALANGLE: "Ângulo vertical",
  T_38_XXJ_WS_ZOOM: "Aproximar",
  T_38_XYL_WS_AISTARTTIME: "Hora de início (s)",
  T_38_XYL_WS_ARMORDESTROY: "Multiplicador de dano de armadura",
  T_38_XYL_WS_BONFIRE: "Fogueira",
  T_38_XYL_WS_CANDLE01: "Vela A",
  T_38_XYL_WS_CANNON01: "Canhão mecânico",
  T_38_XYL_WS_CLIPAMMOSIZE: "Armazenamento de cartucho",
  T_38_XYL_WS_DAMAGEDTRUCK: "Caminhão danificado",
  T_38_XYL_WS_DOLL01: "Boneca macabra",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Casa de tijolos A",
  T_38_XYL_WS_FENCE002: "Cerca de Ferro B",
  T_38_XYL_WS_FIREWORK01: "Fogos de artifício A",
  T_38_XYL_WS_GENERATOR: "Gerador",
  T_38_XYL_WS_GRAVITY: "Aceleração gravitacional",
  T_38_XYL_WS_GRAVITYAREA: "Zona de gravidade alterada",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Um local no qual jogador consegue alterar a gravudade",
  T_38_XYL_WS_HOLDWEAPON: "Segurar arma",
  T_38_XYL_WS_INDOORFURNITURE: "Mobília de casa",
  T_38_XYL_WS_LIGHTTUBE001: "Tubo de luz A",
  T_38_XYL_WS_LOVEBALLOON01: "Balão de coração A",
  T_38_XYL_WS_LOVELAMP01: "Luzes de rua em coração",
  T_38_XYL_WS_LOVESIGN01: "Luzes de neon",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Raio do dano do barril de óleo",
  T_38_XYL_WS_OUTDOORPROPS: "Mobília de jardim",
  T_38_XYL_WS_PIPEANDBOX: "Canos e contêineres",
  T_38_XYL_WS_PLANT: "Plantas",
  T_38_XYL_WS_ROSE01: "Rosa",
  T_38_XYL_WS_ROSEN: "Buquê de rosas",
  T_38_XYL_WS_SMALLBUILDING: "Prédios pequenos",
  T_38_XYL_WS_SOFA002: "Sofá B",
  T_38_XYL_WS_TOWNHOUSE01: "Sobrado velho",
  T_38_XYL_WS_TV001: "TV velha",
  T_38_ZP_CC_EXCHANGESTATUS: "Situação",
  T_39_BQ_SKILL_NAME_VILLAIN: "Onda Escarlate",
  T_39_CJ_A_BURN: "Máscara da Vitória",
  T_39_HJ_WS_Arrow002: "Flecha 2",
  T_39_HJ_WS_LIKERATE2: "{0} min.",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min.",
  T_39_HJ_WS_SOUND10: "Passo",
  T_39_HJ_WS_SOUND11: "Missão completa 1",
  T_39_HJ_WS_SOUND13: "Alerta de perigo 1",
  T_39_HJ_WS_SOUND14: "Alerta de perigo 2",
  T_39_HJ_WS_SOUND15: "Contagem regressiva 3",
  T_39_HJ_WS_SOUND16: "Som de dica",
  T_39_HJ_WS_SOUND17: "Barulho de corvo",
  T_39_HJ_WS_SOUND18: "Som de teleporte para a região errada",
  T_39_HJ_WS_SOUND19: "Som de teleporte para a região correta",
  T_39_HJ_WS_SOUND2: "Contagem regressiva 1",
  T_39_HJ_WS_SOUND20: "Teleporte",
  T_39_HJ_WS_SOUND21: "Choque elétrico",
  T_39_HJ_WS_SOUND23: "Pegar item",
  T_39_HJ_WS_SOUND24: "Música de fundo eletrônico fofo",
  T_39_HJ_WS_SOUND25: "Música de fundo de jogo casual",
  T_39_HJ_WS_SOUND4: "Eco de dispositivo mecânico",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Equipamento acionado",
  T_39_HJ_WS_SOUND9: "Carregar 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Paredes de Gel ilimitadas",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Arremessáveis ilimitados",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Som de disparo especial",
  T_39_HQ_UGC_CUSTOMRES: "Recursos personalizados",
  T_39_M_ACCOUNTID: "Conta",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Executar após toque duplo",
  T_39_MF_SKILLTAG_4: "Movimentação",
  T_39_PD_HuntingGroundSnow_MYNAME: "Sr. V",
  T_39_QL_SKILL_OTHO_DES: "Após derrubar um oponente, marca oponentes dentro de [FFB300]{0}m[-] do oponente derrubado e diminui a velocidade de movimento em [FFB300]{1}%[-]. Dura [FFB300]{2}s[-]. Ao ser derrubado por oponente próximo, marca e diminui a velocidade do jogador que fez o ataque e seus aliados.",
  T_39_QL_SKILL_WOLFRAHH_DES: "Ao derrubar um oponente, entra no modo Destaque, que aumenta a taxa de disparo em [FFB300]{0}%[-] e a velocidade de movimento em [FFB300]{1}%[-]. Esses valores voltam a diminuir rapidamente. Dura [FFB300]{2}s[-]. Durante o modo Destaque, derrubar oponentes consecutivamente reinicia a contagem regressiva e aumenta a taxa de disparo em [FFB300]{3}%[-] e a velocidade de movimento em [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Modo Xtremo: Obtém [FFB300]{0} de vida[-] temporária por [FFB300]{1}s[-]. Neste período, os efeitos de cura aumentam em [FFB300]{2}%[-]. Tempo de recarga: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Incompletas",
  T_39_RW_SKILL_DESC_FORD: "Ao receber dano, recupera [FFB300]{1} de vida por {0}s[-]. Esta habilidade passiva é reiniciada após o uso da habilidade ativa. Tempo de recarga: [FFB300]{2}[-].",
  T_39_SP_WS_ITEMENTITY_01: "Entidade item",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Explosão de Nervos"',
  T_39_SY_CHARACTER_VILLAIN_N: "Órion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - Vitória Esmeralda",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Traje de Pet: Mandrako Esmeralda",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Traje de Pet: Mestre da Realeza",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Traje de Pet: Lupino Escarlate",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Caminhão Monstro - Gigante Esmeralda",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuc Tuc - Namastreta",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Ativação: [FFB300]{0}s[-] antes de detonar, a granada produz [FFB300]{1}[-] granada(s) extra que causam [FFB300]{2}%[-] do dano da granada original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Explosão múltipla",
  T_39_WT_WS_EMPTYMAP_TAG: "Espaço vazio",
  T_39_WT_WS_FEMAPMODE: "Título do modo",
  T_39_WT_WS_FEMAPTAG: "Etiqueta de mapa",
  T_39_WT_WS_MAPPLAYER: "Número de sobreviventes",
  T_39_WT_WS_MEDENTERNUM: "Limite para novos jogadores durante a partida",
  T_39_WT_WS_MIDENTER: "Novos jogadores durante a partida",
  T_39_WT_WS_MIDENTERCOUNT: "Parcela de novos jogadores durante a partida",
  T_39_WT_WS_MIDENTERTIME1: "Limite de tempo para novos jogadores durante a partida",
  T_39_WT_WS_MIDENTERTIME2: "Duração para novos jogadores durante a partida",
  T_39_WT_WS_MIDENTERTIMETIP: "Quando o número alvo de jogadores não for atingido, permita que novos jogadores entre no jogo depois e N segundos desde o início da partida. Novos jogadores não podem entrar depois de N segundos.",
  T_39_WT_WS_MIDENTERTIP: "Ao ativar, jogadores poderão entrar neste mapa durante a partida.",
  T_39_WT_WS_PLAYERCOUNT: "Número inicial de jogadores",
  T_39_WT_WS_PLAYERCOUNTTIP: "O número de jogadores no início da partida. Novos jogadores podem entrar na partida até o número limite ser atingido.",
  T_39_WT_WS_TAG1: "Tá Liberado",
  T_39_WT_WS_TAG10: "Fácil",
  T_39_WT_WS_TAG11: "Médio",
  T_39_WT_WS_TAG12: "Difícil",
  T_39_WT_WS_TAG13: "Desafiador",
  T_39_WT_WS_TAG14: "Fuga",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Recursos personalizados",
  T_39_WT_WS_TAG18: "Quebra-cabeças",
  T_39_WT_WS_TAG19: "Corrida",
  T_39_WT_WS_TAG2: "Combate armado",
  T_39_WT_WS_TAG20: "Música",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Aventura",
  T_39_WT_WS_TAG23: "Caça aos Zumbis",
  T_39_WT_WS_TAG24: "JxJ",
  T_39_WT_WS_TAG25: "Jogos de grupo",
  T_39_WT_WS_TAG26: "Equipe Mata-Mata",
  T_39_WT_WS_TAG27: "Defesa de torreta",
  T_39_WT_WS_TAG28: "Treinamento",
  T_39_WT_WS_TAG3: "Tiro Perfeito",
  T_39_WT_WS_TAG4: "Ressurgir",
  T_39_WT_WS_TAG5: "Fuzil de Precisão",
  T_39_WT_WS_TAG6: "Sobrevivência",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Terror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Selecionar até {0} etiquetas",
  T_39_WT_WS_TAGTYPE1: "Tipo de jogabilidade",
  T_39_WT_WS_TAGTYPE2: "Tipo de mapa",
  T_39_WT_WS_TAGTYPE3: "Tipo de modo",
  T_39_WT_WS_TAGTYPE4: "Tamanho da equipe",
  T_39_WZY_WS_ACCSPEED: "Aceleração",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Inserir script [Nome do script] em [Entidade]",
  T_39_WZY_WS_ASC: "Ascendente",
  T_39_WZY_WS_ASCIGZERO: "Ignorar zero ao usar ascendente",
  T_39_WZY_WS_BALLISTMOVENT: "Entidade movimento balístico",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Ativa o incidente quando o item é usado pela [Entidade jogador]",
  T_39_WZY_WS_BODYSCALE: "Escala do corpo",
  T_39_WZY_WS_BRAKETORQUE: "Potência do freio",
  T_39_WZY_WS_CAMTRANTYPE: "Tipo de transição de câmera",
  T_39_WZY_WS_CARVEHICLE: "4-Rodas",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Verificar se um script específico [Nome do script] existe em [Entidade]. (O valor de retorno deve ser Booleano)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Verificar se a entidade tem um resultado do script especificado (Booleano)",
  T_39_WZY_WS_COMBINEALL: "Arma de empunhadura dupla (armas diferentes)",
  T_39_WZY_WS_COMBINESELF: "Arma de empunhadura dupla (armas iguais)",
  T_39_WZY_WS_CONENAME: "Cone básico",
  T_39_WZY_WS_COORSYS: "Sistema de coordenada",
  T_39_WZY_WS_CRASHMAXD: "Dano máximo do impacto",
  T_39_WZY_WS_CRASHMIND: "Dano mínimo do impacto",
  T_39_WZY_WS_CRAWLSPEED: "Porcentagem da velocidade de movimento (deitado)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Criar movimento balístico para [Entidade alvo] É possível editar [Velocidade inicial], [Aceleração] e [Distância máxima] acumulados na direção da velocidade inicial para a entidade algo, e retornar [Entidade movimento balístico]",
  T_39_WZY_WS_CRETWEEN_NAME: "Criar movimento de interpolação",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Criar um Movimento de Interpolação para [Entidade], com [Atributos] da entidade se movimentando de [Valor inicial] a [Valor alvo] dentro do [Tempo]. [Método] representa o percurso do movimento, incluindo [Via única], [Quicando], [Círculo]. [Curva] é a curva do movimento. E a [Entidade movimento de interpolação] será retornada após criar o movimento.",
  T_39_WZY_WS_CURVE: "Curva",
  T_39_WZY_WS_CUSTRESULT: "Resultado de partida personalizada",
  T_39_WZY_WS_CYLINDERNAME: "Cilíndro básico",
  T_39_WZY_WS_DEFAULT: "Sem animação (Padrão)",
  T_39_WZY_WS_DESC: "Descendente",
  T_39_WZY_WS_DIFFUSEALPHA: "Transparência da superfície",
  T_39_WZY_WS_DISCONNECT: "Desconectar",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Recuperação de energia por segundo",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consumir energia",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Altura máxima do segundo pulo",
  T_39_WZY_WS_ENABLEJOIN: "Permitir entrada no meio",
  T_39_WZY_WS_ENDPOS: "Coordenadas finais",
  T_39_WZY_WS_ENGINETORQUE: "Potência do do motor",
  T_39_WZY_WS_EXPLODED: "Dano da explosão",
  T_39_WZY_WS_FEELDSPEED: "Porcentagem da velocidade de movimento (derrubado)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Tempo da luz central",
  T_39_WZY_WS_FLASH_CRANGE: "Alcance central",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Tempo da luz lateral",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Efeito de acerto da bomba de luz",
  T_39_WZY_WS_FLASH_RANGE: "Alcance da explosão",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Velocidade descendente",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Altitude máxima",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Velocidade de deslizamento horizontal",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Velocidade de deslizamento vertical",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Altura final mínima",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Altura de decolagem mínima",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Velocidade descendente após alcançar altitude",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Velocidade de curva",
  T_39_WZY_WS_FOLMOVENT: "Entidade movimento de seguir até posição",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Obter lista de [Entidade jogador]",
  T_39_WZY_WS_HB_BOOSTCD: "Tempo de recarga da corrida",
  T_39_WZY_WS_HB_BOOSTDURATION: "Duração da corrida",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Tempo de recarga da corrida na prancha",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Tempo de recarga da corrida na prancha",
  T_39_WZY_WS_HB_BOOSTSPEED: "Velocidade de corrida",
  T_39_WZY_WS_HB_HOVERBCD: "Tempo de recarga da prancha",
  T_39_WZY_WS_HB_JUMPCD: "Tempo de recarga do pulo",
  T_39_WZY_WS_HB_JUMPH: "Altura do pulo com prancha",
  T_39_WZY_WS_HEADSCALE: "Escala da cabeça",
  T_39_WZY_WS_HEADSHOTDESCALE: "Redução de dano de acerto na cabeça",
  T_39_WZY_WS_INTITALSPEED: "Velocidade inicial ",
  T_39_WZY_WS_INVENTORYBASE: "Tipos de itens básicos",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Custo de energia por segundo",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Velocidade básica horizontal",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Velocidade básica vertical",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Custo de energia da corrida por segundo",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Velocidade de corrida horizontal",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Distância de corrida",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Custo de energia da precipitação por segundo",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Velocidade de corrida vertical",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Custo de energia para cima por segundo",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Atacável",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Auto-ativado",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Pode ser ativado por aliados ou não",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Ativado por veículo",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duração",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Tempo de ativação",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Raio da ativação",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Tempo da ativação",
  T_39_WZY_WS_LEAVE: "Sair",
  T_39_WZY_WS_LIMBSCALE: "Escala dos membros",
  T_39_WZY_WS_LISTLOCSTR: "Lista de texto localizado",
  T_39_WZY_WS_LOADRESULT_NAME: "Enviar resultado de batalha",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Enviar resultado de batalha do [Jogador], incluindo [Patente], [Resultado], [Nome no placar], [Pontuação]. O tipo de resultado é 1 para vitória, 2 para derrota, 3 para Booyah e 4 para desistência.",
  T_39_WZY_WS_LOOKMOVENT: "Entidade movimento para seguir com o olhar",
  T_39_WZY_WS_MAXCOUNT: "Quantidade máxima",
  T_39_WZY_WS_MAXDISTANCE: "Distância máxima",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Ângulo da depressão da torreta",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Velocidade angular da torreta",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Ângulo da elevação da torreta",
  T_39_WZY_WS_MINISENTRY_DAM: "Dano da torreta",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Taxa de redução de dano",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Ângulo de disparo",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Taxa de acerto da torreta",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Intervalo de ataque da torreta",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Número máximo de torretas",
  T_39_WZY_WS_MINISENTRY_RANGE: "Alcance de ataque da torreta",
  T_39_WZY_WS_MOVEENT: "Entidade movimento",
  T_39_WZY_WS_NOCOMBINE: "Não empunhado nas duas mãos",
  T_39_WZY_WS_ONCE: "Uma vez",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Ativa o incidente quando o item é descartado pela [Entidade jogador]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Ativa o incidente quando o item é equipado pela [Entidade jogador]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Ativa incidente quando o Lança Gancho é disparado",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Ativa o incidente quando a mina terrestre é ativada",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Ativa o incidente quando a mina terrestre é ativada pela [Entidade jogador]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Ativa quando o movimento da entidade pausa",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Ativa quando o movimento da entidade é reiniciado",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Ativa quando a entidade começa a se mover",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Ativa o incidente quando o item é coletado pela [Entidade jogador]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Ativa um incidente quando o arremessável acerta o alvo",
  T_39_WZY_WS_OPENATTACK: "Se permite o ataque",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Lista de entidade pausar movimento ou entidade movimento",
  T_39_WZY_WS_PAUSESOUND_NAME: "Efeito sonoro de pausa",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Lista de entidade efeito sonoro de pausa ou entidade efeito sonoro",
  T_39_WZY_WS_PIANOTYPE: "Tipo de componente de música",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Lista da entidade movimento",
  T_39_WZY_WS_PLAYINGSTATUE: "Situação",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Recuperar a lista de entidade pausar movimento ou entidade movimento Possível escolher entre continuar ou reiniciar.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Tocar efeito sonoro",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Recuperar a lista de entidade efeito sonoro de pausa ou entidade efeito sonoro Possível escolher entre continuar ou reiniciar",
  T_39_WZY_WS_PROCIRCLE_NAME: "Círculo de progresso",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emite um raio até [Direção] de [Coordenadas iniciais], detecta o primeiro acerto de entidade dentro de [Distância] e retorna [Lista de entidades acerto] e [Lista de acertos de coordenadas]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emite um raio até [Direção] de [Coordenadas iniciais], detecta o primeiro acerto de entidade dentro de [Distância] e retorna [Lista de entidades acerto] e [Lista de acertos de coordenadas]",
  T_39_WZY_WS_REAHEALHP: "Valor de recuperação de armadura",
  T_39_WZY_WS_REAHEALTIME: "Intervalo de tempo de efeito",
  T_39_WZY_WS_RELATCOORSYS: "Sistema de coordenada relativa",
  T_39_WZY_WS_REPAIRARM: "Kit de Reparo",
  T_39_WZY_WS_REVERSE: "Inverso",
  T_39_WZY_WS_RIMALPHA: "Transparência da borda",
  T_39_WZY_WS_SCORENAME: "Nome do placar",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Enviar sinal à Entidade Alvo, os parâmetros enviados são definidos por parâmetros de sinal predefinidos. A seleção dos tipos de entidade no momento da definição gerará o sinal correspondente para aceitar o evento.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Cria um movimento de seguir para a [Entidade alvo]. A [Entidade alvo] segue a [Entidade referência]. [Coordenadas de deslocamento] são as coordenadas de deslocamento entre a [Entidade alvo] e a [Entidade referência]. O [Sistema de coordenadas] consegue selecionar o Sistema de Coordenadas Globais e o Sistema de Coordenadas Relativas com base na orientação da Entidade referência. A [Entidade movimento de seguir até posição] será retornada após criar o movimento.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Cria um movimento para seguir com o olhar para a [Entidade alvo]. A [Entidade alvo] segue a [Entidade referência]. [Coordenadas de deslocamento] são as coordenadas de deslocamento entre a [Entidade alvo] e a [Entidade referência]. O [Sistema de coordenadas] consegue selecionar o Sistema de Coordenadas Globais e o Sistema de Coordenadas Relativas com base na orientação da Entidade referência. A [Entidade movimento para seguir com o olhar] será retornada após criar o movimento.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Porcentagem de dano de queda",
  T_39_WZY_WS_SHOE_MAXENERGY: "Energia máxima",
  T_39_WZY_WS_SKILLLIST: "Lista de habilidade",
  T_39_WZY_WS_SKILLTYPE: "Habilidade de personagem",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Duração do efeito de fumaça",
  T_39_WZY_WS_SMOOTH: "Trocar câmera",
  T_39_WZY_WS_SOUNDENTL: "Lista de entidade efeito sonoro",
  T_39_WZY_WS_SOUNDENTLORSENT: "Lista ou entidade efeito sonoro",
  T_39_WZY_WS_SPRINTSPEED: "Porcentagem da velocidade de corrida",
  T_39_WZY_WS_SQUATSPEED: "Porcentagem da velocidade de corrida (agachado)",
  T_39_WZY_WS_STARTCOO: "Coordenadas iniciais ",
  T_39_WZY_WS_STATE: "Status da exibição",
  T_39_WZY_WS_TARGETVAL: "Valor alvo",
  T_39_WZY_WS_THROWSPEED: "Velocidade ao lançar o gancho",
  T_39_WZY_WS_TOWER_PARAM10: "Ângulo de rotação",
  T_39_WZY_WS_TOWER_PARAM11: "Situação da torreta",
  T_39_WZY_WS_TOWER_PARAM12: "ID da entidade",
  T_39_WZY_WS_TOWER_PARAM9: "Alvo de ataque",
  T_39_WZY_WS_TOWSPEED: "Velocidade de locomoção do jogador",
  T_39_WZY_WS_TWEENCURVE_NAME: "Curva personalizada",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "A curva personalizada pode ser utilizada para movimento de interpolação",
  T_39_WZY_WS_TWEENENT: "Entidade movimento de interpolação",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Métodos de movimento",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Métodos de movimento de interpolação",
  T_39_WZY_WS_TWEENSTYLE: "Método",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Apagar script [Nome do script] em [Entidade]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Organizar aleatoriamente os elementos listados ",
  T_39_WZY_WS_VISIBLEONBACK: "Visível no verso",
  T_39_WZY_WS_WEAPCOMBINET: "Arma de empunhadura dupla",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Dano adicional a jogador derrubado",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Número de bala de tiro único",
  T_39_WZY_WS_WEAREPLAY: "Reiniciar movimento?",
  T_39_WZY_WS_WORLDCOORSYS: "Sistema de coordenada global",
  T_39_XXJ_WS_ADDFRIEND: "Adicionar amigo",
  T_39_XXJ_WS_ALLOWZ: "Habilitar o movimento de Eixo X do jogador",
  T_39_XXJ_WS_BLOCKMODEDESC: "Movimento da câmera quando há um objeto entre a câmera e o alvo",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance do alvo",
  T_39_XXJ_WS_CAMERATYPEDESC: "Vezes que a câmera personalizada ou predefinida foi acionada",
  T_39_XXJ_WS_CAMERAUSER: "Usuário da câmera",
  T_39_XXJ_WS_CURENTCAMERA: "Câmera utilizada",
  T_39_XXJ_WS_DETAILS: "Detalhes de partida",
  T_39_XXJ_WS_FFECONOMY: "Economia",
  T_39_XXJ_WS_FOCUSTARGET: "Alvo observado",
  T_39_XXJ_WS_FOLLOWTARGET: "Alvo referência",
  T_39_XXJ_WS_GAMERESULT: "Resultado de partida",
  T_39_XXJ_WS_GAMETITLE1: "Partida 1",
  T_39_XXJ_WS_GAMETITLE2: "Partida 2",
  T_39_XXJ_WS_GIFT: "Presente",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Ângulo de rotação horizontal da câmera",
  T_39_XXJ_WS_INVISICAM: "Transparente",
  T_39_XXJ_WS_INVISICAMDESC: "O objeto entre a câmera e o alvo fica transparente",
  T_39_XXJ_WS_LEFTSCORE: "Pontuação da equipe da esquerda",
  T_39_XXJ_WS_LIKE: "Gostei",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Nome do placar total",
  T_39_XXJ_WS_MAINSCORENUM: "Número do placar total",
  T_39_XXJ_WS_MAPEVALUATE: "Classificação do mapa",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Resultado de diversas equipes",
  T_39_XXJ_WS_MVP1: "Melhor da partida 1",
  T_39_XXJ_WS_MVP2: "Melhor da partida 2",
  T_39_XXJ_WS_OFFSET2: "Locomoção do ponto de observação",
  T_39_XXJ_WS_OFFSET2DESC: "Geralmente, refere-se à locomoção do ponto de foco da câmera em relação à posição original do jogador. (Ou seja, varia de acordo com o tipo de câmera)",
  T_39_XXJ_WS_OFFSETDESC: "Geralmente, refere-se à locomoção da posição da câmera em relação à posição original do jogador. (Ou seja, varia de acordo com o tipo de câmera)",
  T_39_XXJ_WS_ORTHOGONAL: "Ortogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "A câmera mostra os alvos distantes e próximos do mesmo tamanho",
  T_39_XXJ_WS_PERSPECTIVE: "Perspectiva",
  T_39_XXJ_WS_PERSPECTIVEDESC: "A câmera usa projeção de perspectiva para observar o alvo",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Formação da imagem da câmera durante renderização",
  T_39_XXJ_WS_RANK1: "Classificação da equipe",
  T_39_XXJ_WS_RANK2: "Classificação do jogador",
  T_39_XXJ_WS_REPORT: "Reportar",
  T_39_XXJ_WS_REVIEW: "Reproduzir",
  T_39_XXJ_WS_RIGHTSCORE: "Pontuação da equipe da direita",
  T_39_XXJ_WS_SCORENUM1: "Pontuação 1",
  T_39_XXJ_WS_SCORENUM2: "Pontuação 2",
  T_39_XXJ_WS_SCORENUM3: "Pontuação 3",
  T_39_XXJ_WS_SCORENUM4: "Pontuação 4",
  T_39_XXJ_WS_SCORENUM5: "Pontuação 5",
  T_39_XXJ_WS_SCORETITLELIST: "Lista do nome do placar",
  T_39_XXJ_WS_SHARE: "Compartilhar",
  T_39_XXJ_WS_SPECTATORSWITCH: "Espectador",
  T_39_XXJ_WS_STABLE: "Estável",
  T_39_XXJ_WS_STABLEDESC: "A câmera se mantém estável se houver um objeto entre a câmera e a entidade referência",
  T_39_XXJ_WS_TEAMNAME1: "Nome da equipe da esquerda",
  T_39_XXJ_WS_TEAMNAME2: "Nome da equipe da direita",
  T_39_XXJ_WS_TEAMRANK: "Classificação da equipe",
  T_39_XXJ_WS_TRANSITIONTIME: "Tempo de transição de câmera",
  T_39_XXJ_WS_TRANSITIONTYPE: "Tipo de transição de câmera",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Resultado das 2 equipes",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Ângulo de rotação vertical da câmera",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "A câmera usa zoom se houver um objeto entre a câmera e a entidade referência",
  T_39_XYL_WS_LIGHTINTENSITY: "Luz intensa",
  T_39_XYL_WS_LIGHTRANGE: "Alcance da luz",
  T_39_XYL_WS_POINTLIGHT: "Ponto de luz",
  T_39_XYL_WS_WATERZONE: "Personalizar a área de água",
  T_40_B_DISABLE_RECONNECT: "Desativar reconexão automática",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Camisa Preta",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Camisa Vermelha",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Camisa Rubro-Negra",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Camisa Amarela",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Camisa em Chamas",
  T_40_DYEING_CLEAR: "Estado da coloração clara",
  T_40_HJ_WS_EFFECT32: "Tênis",
  T_40_HJ_WS_EFFECT33: "Explosão",
  T_40_HJ_WS_EFFECT34: "Ponto de surgimento",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Munição",
  T_40_HJ_WS_EFFECT37: "Efeito ao acertar",
  T_40_HJ_WS_EFFECT38: "Efeito ao disparar",
  T_40_HJ_WS_EFFECT43: "Pacote Teia",
  T_40_HJ_WS_EFFECT44: "Usar uma habilidade",
  T_40_HJ_WS_SOUND69: "Abrir um pacote",
  T_40_HJ_WS_SOUND70: "Subir nível",
  T_40_HJ_WS_SOUND71: "Nível máximo",
  T_40_HJ_WS_SOUND72: "Pressionar um botão",
  T_40_HJ_WS_SOUND73: "Contagem regressiva 1",
  T_40_HJ_WS_SOUND74: "Apito",
  T_40_HJ_WS_SOUND75: "Fim de jogo",
  T_40_HJ_WS_SOUND76: "Avançar",
  T_40_HJ_WS_SOUND77: "Booyah!",
  T_40_HJ_WS_SOUND78: "Ponto de Checagem",
  T_40_HJ_WS_SOUND79: "Contagem regressiva 2",
  T_40_HJ_WS_SOUND80: "Início da partida",
  T_40_HJ_WS_SOUND81: "Conseguiu muitas moedas",
  T_40_HJ_WS_SOUND82: "Conseguiu moedas",
  T_40_HJ_WS_SOUND83: "Conseguiu algumas moedas",
  T_40_HJ_WS_SOUND84: "Juntou-se à batalha.",
  T_40_HJ_WS_SOUND85: "Abrindo Suprimentos de Guilda",
  T_40_HJ_WS_SOUND86: "Buzina",
  T_40_HJ_WS_SOUND87: "Eliminou um Chefão",
  T_40_HJ_WS_SOUND88: "Abrindo Baú de Batalha",
  T_40_HJ_WS_SOUND89: "Habilidade de tinta explosiva",
  T_40_HJ_WS_SOUND90: "Acerto do projétil",
  T_40_HJ_WS_SOUND91: "Habilidade de escudo de tinta",
  T_40_HJ_WS_SOUND92: "Tocando um botão desabilitado",
  T_40_HJ_WS_SOUND93: "Recarga de habilidade completa",
  T_40_HJ_WS_SOUND95: "Habilidade laser",
  T_40_HJ_WS_SOUND96: "Coletar Item 2",
  T_40_HJ_WS_SOUND97: "Fim de partida 2",
  T_40_HJ_WS_SOUND98: "Notificação de abate",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Música de fundo",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Efeito sonoro de partida",
  T_40_HJ_WS_SOUNDTYPE_UI: "Efeito sonoro do dispositivo de interface de usuário",
  T_40_JH_WS_MAPTAG1: "Jogo de cores",
  T_40_JH_WS_MAPTAG10: "Esconde colorido",
  T_40_JH_WS_MAPTAG11: "Jogo Aniversário",
  T_40_JH_WS_MAPTAG12: "Atuação (RPG)",
  T_40_JH_WS_MAPTAG13: "Simulação",
  T_40_JH_WS_MAPTAG14: "Assimetria",
  T_40_JH_WS_MAPTAG15: "Luta por recurso",
  T_40_JH_WS_MAPTAG16: "Escolta veículos",
  T_40_JH_WS_MAPTAG17: "Mapa oficial",
  T_40_JH_WS_MAPTAG18: "Minijogo",
  T_40_JH_WS_MAPTAG19: "Desafio do tempo",
  T_40_JH_WS_MAPTAG2: "Spray colorido",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Batalha de cores",
  T_40_JH_WS_MAPTAG4: "Combate colorido",
  T_40_JH_WS_MAPTAG5: "Parque das Cores",
  T_40_JH_WS_MAPTAG6: "Cores no parque",
  T_40_JH_WS_MAPTAG7: "Festa colorida",
  T_40_JH_WS_MAPTAG8: "Parkour colorido",
  T_40_JH_WS_MAPTAG9: 'Parkour "Aranhaverso"',
  T_40_JH_WS_TAG30: "Magnata",
  T_40_JH_WS_TAG31: "Destruição total",
  T_40_JH_WS_TAG32: "Cidade Misteriosa",
  T_40_JH_WS_TAG33: "Crise Matutina",
  T_40_JH_WS_TAG34: "Revolta Mortal",
  T_40_JH_WS_TAG35: "Combate de punho",
  T_40_JH_WS_TAG36: "Telhado Fábrica",
  T_40_JH_WS_UGCTOKENNAME: "Token da Oficina de Criação",
  T_40_L_QUICKMESSAGE_MODE2: "Contra Squad",
  T_40_M_WS_HIS: "de",
  T_40_SP_WS_DYEING: "Cor",
  T_40_SP_WS_DYEING_AREA: "Coloração da área",
  T_40_SP_WS_DYEING_COLOR: "Número da cor",
  T_40_SP_WS_DYEING_COUNT: "Contagem da coloração",
  T_40_SP_WS_DYEING_DIR: "Direção da coloração",
  T_40_SP_WS_DYEING_DIS: "Distância da coloração",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Área de coloração fixa",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Coloração da área plana",
  T_40_SP_WS_DYEING_POSITION: "Coordenadas",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Queda da taxa de coloração aleatória",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Taxa de coloração aleatória",
  T_40_SP_WS_DYEING_RANGE: "Área da coloração",
  T_40_SP_WS_DYEING_STATE: "Estado da coloração",
  T_40_SP_WS_FACTIONTIPS_11: "Roxo",
  T_40_SP_WS_SHOE_CURENERGY: "Energia corrente",
  T_40_SW_SKILL_Name_Nanoscientist: "Nanoproteção",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Edição do Dom",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok Despertado",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sônia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Edição do Dom",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Edição do Dom",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Edição do Dom",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Edição do Dom",
  T_40_SY_PET_PUG_N: "Agente 00Pet",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: "Traje de Pet: ETeia do Aranha ",
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Traje de Pet: Mandrako em Choque",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Traje de Pet: 00Pet Mordomo",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Traje de Pet: 00Pet Turista",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Traje de Pet: 00Pet Tigroso",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Edição do Dom",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Edição do Dom",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Edição do Dom",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Edição do Dom",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Edição do Dom",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Ativar conteúdo de texto",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Conteúdo de texto substituto",
  T_40_W_DJMALE_AWAKENING_D: "Despertar: Enquanto a aura estiver ativa, notas musicais que duram [FFB300]{2}s[-] serão serão deixadas a [FFB300]{1}[-]m de distância para trás do usuário da habilidade a cada [FFB300]{0}s[-]. Aliados que pegarem as notas musicais receberão o mesmo efeito da aura.",
  T_40_W_DJMALE_AWAKENING_N: "Remixando Hinos",
  T_40_W_NURSE_D: "Espalha [FFB300]{0}%[-] dos efeitos de cura (habilidade, Kit Médico, arma de cura, etc.) a um aliado específico dentro de [FFB300]{1}m[-] de distância.",
  T_40_WH_MP_BOXING_NAME: "Partida de luta",
  T_40_WH_MP_C_PACK: "Mochila Suspeita",
  T_40_WH_MP_EXCH_COIN: "Dinheiro",
  T_40_WH_MP_EXCH_TEMPCOIN: "Grana Suspeita",
  T_40_WH_MP_PAYCHECK: "Pagamentos",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "A velocidade ao ajudar aliados a levantarem aumenta em [FFB300]{0}%[-]. Tempo de recarga: [FFB300]{3}s[-]. O aliado que for ajudado recupera [FFB300]{2} de vida[-] em [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Cria uma zona de cura com raio de [FFB300]{0}m[-]. Dentro dela, o usuário e aliados recuperam [FFB300]{1} de vida por segundo[-]. A ajuda para levantar será ativada automaticamente quando necessário. A zona dura [FFB300]{2}s[-]. O efeito de ajudar a levantar aliados pode ser potencializado com outras habilidades. Tempo de recarga: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Método de visualização",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Cápsula",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Altura",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Raio",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Esfera",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Árabe Simplificado",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermercado",
  T_40_WZY_WS_ICONENTITY_COLOR: "Cor",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressivo",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Recursos de imagem",
  T_40_WZY_WS_ICONENTITY_NAME: "Objeto de ícone",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Método de visualização",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simples",
  T_40_WZY_WS_ICONENTITY_SLICED: "Dividido em 9",
  T_40_WZY_WS_ICONENTITY_TILED: "Ladrilho",
  T_40_WZY_WS_NEWMAPTAG: "Ícone de novo mapa",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curso",
  T_40_WZY_WS_NEWVFX11: "Zona livre",
  T_40_WZY_WS_NEWVFX12: "Ar gelado",
  T_40_WZY_WS_NEWVFX13: "Floco de neve",
  T_40_WZY_WS_NEWVFX14: "Chama",
  T_40_WZY_WS_NEWVFX15: "Feixe de luz",
  T_40_WZY_WS_NEWVFX16: "Propagação de gás tóxico",
  T_40_WZY_WS_NEWVFX17: "Gás tóxico",
  T_40_WZY_WS_NEWVFX18: "Chama explosiva",
  T_40_WZY_WS_NEWVFX19: "Efeito de luz",
  T_40_WZY_WS_NEWVFX2: "Bolha",
  T_40_WZY_WS_NEWVFX20: "Estrela",
  T_40_WZY_WS_NEWVFX3: "Cinzas",
  T_40_WZY_WS_NEWVFX4: "Respingo de rocha",
  T_40_WZY_WS_NEWVFX5: "Linha",
  T_40_WZY_WS_NEWVFX6: "Oscilação",
  T_40_WZY_WS_NEWVFX7: "Anel",
  T_40_WZY_WS_NEWVFX8: "Partícula crescente",
  T_40_WZY_WS_NEWVFX9: "Fumaça",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Tamanho da fonte",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Estilo da fonte",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Fonte",
  T_40_WZY_WS_TEXTENTITY_NAME: "Objeto de texto",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Componente de HUD de botão de interação",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: "Pode ser usado ou não no cenário. Somente isso é lido e depende da disponibilidade ou não da linha pai e do status de atividade.",
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Se todas as linhas pai estão ativas ou não. Isso é apenas lido, mas não visível a jogadores.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Linha pai disponível ou não",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Exibido quando o status aberto é verdadeiro, se não, é fechado",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: "Ativo ou não para uso próprio. Para usar no cenário, é necessário usar “Usável ou não no cenário”. Isso é apenas lido e configurado por meio de um API.",
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Se a cullingMask da câmera é visível a um jogador específico",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Gera tokens em um local específico",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "O item de espólio que pode ser dado ao jogador",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Orientação atual do jogador",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direção",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "IA atacando a entidade",
  T_40_XXJ_WS_AITARGET_DESCKEY: "IA atacante",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "Estilo de alinhamento",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Alinhamento horizontal",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Alinhamento vertical",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparência",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "Contagem de munição restante",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Munição restante",
  T_40_XXJ_WS_ANCHORMAX: "Âncora máxima",
  T_40_XXJ_WS_ANCHORMIN: "Âncora mínima",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Posição atual do jogador",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Posição",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "HUD de armadura",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "ID do ativo configurado",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "ID do ativo",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Alvo do ataque",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Arremessáveis de ataque",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "A entidade sendo atacada pela IA",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Alvo atacado",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Coordenadas disponíveis para pontos de ressurgimento",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Coordenadas disponíveis",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "Imagem inferior",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Fundo",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Mochila",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Transparência do fundo",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Cor de fundo",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Cor de fundo",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Preencher o fundo ou não",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Preenchimento do fundo",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Nome do fundo",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Nome do fundo",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Delta de tamanho do fundo",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Delta de tamanho do fundo",
  T_40_XXJ_WS_BLUE: "Azul",
  T_40_XXJ_WS_BODY_DESCKEY: "Tronco",
  T_40_XXJ_WS_BODY_NAMEKEY: "Tronco",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Escala do esqueleto",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Ponto de ressurgimento do jogador",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Ponto de Surgimento",
  T_40_XXJ_WS_BOTH: "Ambos",
  T_40_XXJ_WS_BUTTONNAME: "Nome do componente do botão",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Câmera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "Direção para qual a câmera do cliente está apontando",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "Localização da câmera do cliente",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detecta a linha da câmera do cliente",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Detecção de raio da câmera",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Para de arrastar ao coincidir com a janela de exibição",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Sair da opção de arrastar após encaixar",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "A distância entre o centro dos semicírculos da cápsula. Não pode ser menor que duas vezes o raio da esfera.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Tamanho da célula",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Altura da linha filho",
  T_40_XXJ_WS_CELLVALUE: "Lê o conteúdo de uma célula específica e retorna um objeto",
  T_40_XXJ_WS_CENTER_DESCKEY: "As coordenadas de mundo correspondentes na central do minimapa. 0 por padrão.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Central do minimapa",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Compensação da posição do botão",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Compensação de posição",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "O centro de massa relacionado às coordenadas locais",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Centro de massa",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Exibir linha do meio ou não",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Exibir linha do meio ou não",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Posição da linha do meio [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Posição da linha do meio",
  T_40_XXJ_WS_CHASERANGE: "Área de Perseguição",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "A entidade sendo perseguida pela IA",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Alvo seguido",
  T_40_XXJ_WS_CHILD_DESCKEY: "Entidade filho",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Filho do pai",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "Ponto atingido pela linha da câmera",
  T_40_XXJ_WS_CHOOSECARHUD: "Selecionar entidade do HUD do cartão",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Se o parâmetro estiver dentro do intervalo numérico entre os valores mínimos e máximos, a função retornará o valor do parâmetro; se o parâmetro for mais alto que o intervalo, a função retornará o valor máximo; se o argumento for menor que o intervalo, a função retornará o valor mínimo",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Suporta somente entidades que tenham o componente Transformação. Atualmente limitado a todos os objetos.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "Tamanho da área que pode ser tocada",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Tamanho do clique",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Tipo de clipping",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Tipo de clipping",
  T_40_XXJ_WS_CLONEENT_D: "Clone a entidade selecionada e seus atributos mantendo o pai original. Se o nível do objeto for selecionado, ele será baseado em Criar Nível de Objeto.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "Lista de trajes",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ID do traje",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID do traje",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "ID do traje",
  T_40_XXJ_WS_COL_DESC: "Coluna a ser lida",
  T_40_XXJ_WS_COLNAME_DESC: "Nome da coluna a ser lida.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Cor",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Valor",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Adicionar camadas de cor usando o canal de cor RGBA. O valor do canal fica entre 0 e 255 e é armazenado em um Int32. Branco (255, 255, 255, 255) por padrão.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Cor da barra de progresso",
  T_40_XXJ_WS_COLOR3_DESCKEY: "Tipo de canal de cor RGBA, que vai de 0 a 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "Cor do texto",
  T_40_XXJ_WS_COLOR5_DESCKEY: "Cor do HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "Cor da iluminação",
  T_40_XXJ_WS_COLORA_DESCKEY: "Valor da cor A",
  T_40_XXJ_WS_COLORB_DESCKEY: "Valor da cor B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Cor da barra de progresso",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Barril de cor",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Barril de cor",
  T_40_XXJ_WS_COLORG_DESCKEY: "Valor da cor G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obter a partir do canal RGBA",
  T_40_XXJ_WS_COLORGUN: "Fuzil de spray arco-íris",
  T_40_XXJ_WS_COLORGUN_01: "Fuzil de spray arco-íris (vermelha)",
  T_40_XXJ_WS_COLORGUN_02: "Fuzil de spray arco-íris (amarela)",
  T_40_XXJ_WS_COLORGUN_03: "Fuzil de spray arco-íris (azul)",
  T_40_XXJ_WS_COLORGUN_04: "Fuzil de spray arco-íris (verde)",
  T_40_XXJ_WS_COLORGUN_05: "Fuzil de spray arco-íris (roxa)",
  T_40_XXJ_WS_COLORR_DESCKEY: "Valor da cor R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Cor do texto",
  T_40_XXJ_WS_COLVALUE: "Conteúdo da coluna",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "Entidade HUD de um comando HUD geral",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Entidade HUD do comando HUD geral",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Restrição",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Restrição",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "Número de restrições",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Contagem de restrição",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Conteúdo original",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Direção padrão",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "Ponto inicial da rolagem. Canto superior esquerdo por padrão.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Gera um pixel estático de um objeto específico no mapa. O pixel não será movido com o objeto.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Criar um ícone do mapa",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Defina sentença localizada para indicação de tempo",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Cria um componente de IU personalizada na HUD personalizada designado e no componente pai",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Rastejar",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Exibido quando verdadeiro, se não, é fechado",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Agachar",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Esta é a camada renderizada da cullingMask da câmera. É possível filtrar a entidade renderizada utilizando o nível da camada visível.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "ID da peça de cima",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Camiseta/Camisa/Blusa",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ID da pintura facial",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "ID do sapato",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Sapatos",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "ID da cabeça",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Cabeça",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ID da pintura facial",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Máscara",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "ID da peça de baixo",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Calças/Shorts/Saia",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Pintura Facial",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "ID do conjunto",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Peça única",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "Tamanho do deslocamento na direção xy",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "Arrastar XY",
  T_40_XXJ_WS_DB: "Ler valor da tabela",
  T_40_XXJ_WS_DB_DESC: "Lê o valor correspondente de um identificador específico em uma tabela específica na base de dados.",
  T_40_XXJ_WS_DBDELETE_DESC: "Apaga o valor correspondente de um identificador específico em uma tabela específica na base de dados.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Nome personalizado utilizado para indentificar dados",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identificador",
  T_40_XXJ_WS_DBTABLENAME: "Nome da tabela da base de dados.",
  T_40_XXJ_WS_DBTABLENAME_DESC: "O nome de uma tabela na base de dados.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "Valor para escrever",
  T_40_XXJ_WS_DBWRITE: "Escrever valor da tabela",
  T_40_XXJ_WS_DBWRITE_DESC: "Escreve o valor correspondente de um identificador específico em uma tabela específica na base de dados.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Arremessáveis de defesa",
  T_40_XXJ_WS_DEFULT: "Padrão",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Apaga o valor correspondente de uma chave específica em um placar específico na base de dados.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Apaga o valor correspondente de uma patente específica em um placar específico na base de dados.",
  T_40_XXJ_WS_DEPTH: "Camada do HUD",
  T_40_XXJ_WS_DEPTH_D: "A camada básica do HUD",
  T_40_XXJ_WS_DICTANDLIST: "Lista e dicionário",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "Valor do dicionário alvo",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "Transparência da superfície",
  T_40_XXJ_WS_DIR_DESCKEY: "Vetor",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Ponto disponibilizado que pode ser utilizado como ponto de ressurgimento, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordenadas",
  T_40_XXJ_WS_DISABLEALL: "Desselecionar tudo",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Cor desabilitada",
  T_40_XXJ_WS_DISTANT_DESCKEY: "Distância da detecção da linha da câmera ",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Distância de projeção",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Suporta arrastar para diversas direções",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Efeito ao arrastar",
  T_40_XXJ_WS_DRIVER_DESCKEY: "Motorista do veículo",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Motorista",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modifica um valor",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Exibe efeitos especiais",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Exibir efeitos especiais",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Cor dos efeitos",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "A entidade efeitos especiais representa o efeito especial a ser exibido",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "Objeto de efeitos especiais",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "HUD de emote",
  T_40_XXJ_WS_ENABLEALL: "Selecionar tudo",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Ativar ou não a atualização de lógica Quando desativado, os blocos nesta entidade deixarão de atualizar todos os quadros.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "Ao escrever os atributos das armas, as estatísticas básicas serão afetadas pela skin da arma",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Escrever atributo de skin de arma",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Uma entidade é um recipiente que contém todos os componentes que devem ser adicionados a entidades para serem ativados",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Tipo da entidade",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "Componente básico de uma entidade. Todos os componentes combinarão este componente.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "Entidade que se transforma",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "O nome do parâmetro usado no código para representar a entidade de controle de IU personalizado adicionado recentemente. O valor de variável local correspondente da entidade de controle de IU personalizado adicionado recentemente.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "O nome da variável da entidade",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "O nome do parâmetro usado no código para representar a entidade do ícone criado. O valor de variável local correspondente da entidade do ícone criado.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "HUD da barra de energia",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Ângulos de Euler",
  T_40_XXJ_WS_FACINFECTION: "Gangue (Cizânia Androide)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Gangue do jogador. 1 = humano, 2 = Androide.",
  T_40_XXJ_WS_FEMALE: "Feminino",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Direção de preenchimento",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Ajustar direção",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Disparar",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "Valor da flutuação",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "Entidade alvo a ser seguida. Vazio por padrão.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "Tamanho do texto",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Tamanho da fonte",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "Estilo da fonte",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Parede de Gel- Futebol",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "Estilo de formatação",
  T_40_XXJ_WS_FORWARD_DESCKEY: "Direção do jogador",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "Direção para teleporte",
  T_40_XXJ_WS_FREE_DESCKEY: "Câmera controlada pelo jogador e que pode ser movida livremente",
  T_40_XXJ_WS_FREE_NAMEKEY: "Câmera livre",
  T_40_XXJ_WS_GENDER: "Gênero",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gênero",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Enum do gênero",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obter cullingMask da câmera",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Suporta somente entidades que tenham o componente Transformação. Atualmente limitado a todos os objetos.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Suporta somente entidades que tenham o componente Transformação. Atualmente limitado a todos os objetos.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Suporta somente entidades que tenham o componente Transformação. Atualmente limitado a todos os objetos.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtém o ID do traje do jogador",
  T_40_XXJ_WS_GETPLAYERRANK: "Obter classificação do jogador",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Obter classificação total do jogador",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Obter a classificação do jogador na rodada",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Obter a classificação do jogador em uma rodada específica",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Busca dados do token do jogador",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtém a skin de arma do jogador",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtém um conjunto de coordenadas que ainda não foi ocupado por pontos de ressurgimento aleatórios",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtém a caixa de céu de um cenário",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtém a região de um servidor",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtém a indicação de tempo de um servidor",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtém a localização próxima ao aliado, evitando áreas onde jogadores não podem ficar",
  T_40_XXJ_WS_GETTEAMRANK: "Obter a classificação da equipe",
  T_40_XXJ_WS_GETTEAMRANK_D: "Obter a classificação total da equipe",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Obter a classificação da equipe na rodada",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Obter a classificação da equipe em uma rodada específica",
  T_40_XXJ_WS_GREEN: "Verde",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Metade das dimensões de uma forma tridimensional",
  T_40_XXJ_WS_HEAD_DESCKEY: "Cabeça",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Cabeça",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "Entidade efeito de pulso",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Entidade efeito de pulso",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "Altura",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Botão de dica",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Botão de dicas",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "Entidade a ser exibida na localização alvo",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entidade mirada",
  T_40_XXJ_WS_HITPOS_DESCKEY: "Local atingido",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "O tipo de exibição horizontal",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Tipo de exibição horizontal",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "Entidade sendo perseguida por outra entidade",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "Entidade olhando para outra entidade",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "HUD da barra de vida",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "A entidade inserção de HUD. Este é o HUD que os jogadores modificam no editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Componente de painel de HUD vazio",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "Entidade HUD ao qual pertence",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "Entidade de inserção de HUD HUD que o jogador edita por meio do editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "Componente de grade do HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "Entidade de inserção de HUD HUD que o jogador edita por meio do editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "Componente de painel do HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "Entidade de inserção de HUD HUD que o jogador edita por meio do editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "Componente de visão de rolagem do HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID do modelo humano",
  T_40_XXJ_WS_ICON_DESCKEY: "O nome de recurso do ícone",
  T_40_XXJ_WS_ICON_NAMEKEY: "Ícone",
  T_40_XXJ_WS_ICON1_DESCKEY: "Seleciona um ícone",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "A entidade ícone representa o ícone a ser exibido",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Um caminho de recursos Recurso acoplado está dentro do caminho. Recurso acoplado está fora do caminho. Vazio por padrão.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Nome do ícone",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Nome do ícone",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "O caminho dos recursos. Vazio por padrão.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Se pode escanear gatilhos ou não",
  T_40_XXJ_WS_INDEX_DESCKEY: "O índice filho sob pai",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Valor inicial [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "Valor do inteiro",
  T_40_XXJ_WS_IS3D: "Efeito de som 3D",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Sempre virado para a câmera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Negrito",
  T_40_XXJ_WS_ISBYORDER_D: "Detecta se jogadores devem ativar objetos de nível em ordem cronológica",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Botão FirEditor",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Se a linha da câmera atingiu ou não a entidade",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Se é visível até certa camada ou não",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Itálico",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Se foi marcado pelo escaneamento ou não",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Escaneado ou não",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Se foi marcado ou não pelo botão de marcação",
  T_40_XXJ_WS_ISTRIGGER: "É gatilho",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Sublinhado",
  T_40_XXJ_WS_ITEMID_DESCKEY: "ID do item correspondente da entidade",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "ID do item",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "ID do item (disponível somente o ID de arma na versão atual)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "O ID do item da arma",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "ID do item",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Área Metrópolis",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Área Metrópolis",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Saltar",
  T_40_XXJ_WS_KEY_DESCKEY: "Valor da chave",
  T_40_XXJ_WS_KEY_NAMEKEY: "Chave",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "O nome da chave a ser analisada. Pode ser utilizado para obter o valor de uma chave em uma variável local.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Anúncio de abate",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Cor do texto",
  T_40_XXJ_WS_LANDMINEOBJ: "Entidade após a criação das minas terrestres",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "A máscara da camada de colisão. As camadas não selecionadas não serão incluídas no escaneamento. Se vazio, todas as camadas serão incluídas no escaneamento.",
  T_40_XXJ_WS_LAYERSEDIT: "Editar camadas",
  T_40_XXJ_WS_LAYERSETTING: "Ajustes de camada visível",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "Camada de colisão da detecção da linha da câmera",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Camada",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Tipo de exibição",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Tipo de exibição",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Componente de HUD do placar",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "Entidade HUD do placar. Modificar as propriedades da entidade afetará o conteúdo sendo exibido na IU correspondente.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Nome do placar",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "O nome da tabela do placar na base de dados.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "Aceleração ao balançar",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Deixar aceleração",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Braço esquerdo",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Braço esquerdo",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "Cor esquerda",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Cor esquerda",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Exibir ou não efeitos especiais na esquerda",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Exibir efeito à esquerda ou não",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Pé esquerdo",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Pé esquerdo",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Mão esquerda",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Mão esquerda",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Ícone da esquerda",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Ícone da esquerda",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Perna esquerda",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Perna esquerda",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Texto da pontuação à esquerda",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Texto da pontuação à esquerda",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Texto à esquerda",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Texto à esquerda",
  T_40_XXJ_WS_LERP_DESCKEY: "t fica entre 0 e 1. Quando t=0, o retorno é “de”. Quando t=1, o retorno é “para”. Quando t=0.5, o retorno é a média dos valores de “de” e “para”.",
  T_40_XXJ_WS_LEVELOBJECT: "Objeto de nível",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Espaçamento de linha",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compara os valores em uma lista e retorna o maior",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compara os valores em uma lista e retorna o menor",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "Lista ou dicionário",
  T_40_XXJ_WS_LOCALPOSITION: "Posição local",
  T_40_XXJ_WS_LOCALROTA: "Ângulos de Euler locais",
  T_40_XXJ_WS_LOCALROTATIONQ: "Rotação do quaternião local",
  T_40_XXJ_WS_LOCALSACLE: "Escala local",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Botão de localização",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "O container a ser analisado",
  T_40_XXJ_WS_MALE: "Masculino",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove o dicionário",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtém o comprimento do dicionário",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtém o valor da chave atribuída ao elemento do dicionário",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove o par de valor de chave atribuído no dicionário",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configura o valor da chave atribuída no dicionário",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "Tamanho do minimapa A largura e a altura são iguais.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Tamanho do mapa",
  T_40_XXJ_WS_MAPT: "Modelo de dicionário",
  T_40_XXJ_WS_MAPT_D: "O modelo de dados para o dicionário. É possível criar o tipo de conteúdo por meio de T1 e T2.",
  T_40_XXJ_WS_MAPVALUE_D: "Contêiner de dados para o dicionário. O elemento é um par que consiste em uma chave e um valor.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "Dicionário alvo",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dicionário",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "O tipo de máscara é o nome da imagem usada ao fazer a máscara",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Nome da máscara",
  T_40_XXJ_WS_MASS_DESCKEY: "Massa (kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Massa (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compara 2 valores e retorna o maior",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Comprimento máximo",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "Valor máximo",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "O maior ID de componente",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "ID do dispositivo máx.",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Itens de cura",
  T_40_XXJ_WS_MIN_DESCKEY: "Compara 2 valores e retorna o menor",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Componente do minimapa",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Pixel do minimapa",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Ícone do minimapa",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimapa",
  T_40_XXJ_WS_MINNUM_DESCKEY: "Valor mínimo",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "O fator do momento",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Fator momento",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Controle de movimento",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Resultado de partida",
  T_40_XXJ_WS_NEWENTITY_D: "A nova entidade após a criação (pode ser nulo)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Criar uma novo dicionário",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Novo dicionário",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "O normal do acerto",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "Posição do HUD [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "Posição do HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "A lista converte índices em números",
  T_40_XXJ_WS_OBJECT_DESCKEY: "O objeto que a arma de spray acerta",
  T_40_XXJ_WS_OBSOLETE: "Apagado. Por motivos de segurança, substitua este bloco.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "Posição da exibição Quando houver um alvo seguido, é a compensação entre a nova posição e a posição inicial. Quando não houver alvo seguido, são as coordenadas na tela (a padrão é Vetor3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "As coordenadas na tela (a padrão é Vetor3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "Posição da exibição. Quando houver um alvo seguido, é a compensação entre a nova posição e a posição inicial. Quando não houver alvo seguido, são as coordenadas na tela (a padrão é Vetor3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Posição de exibição (a âncora fica no canto superior direito)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Compensação horizontal",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Compensação horizontal",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "A compensação vertical",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Compensação vertical",
  T_40_XXJ_WS_OK_DESCKEY: "Conversão bem sucedida",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Ativa este evento quando a entidade entra no local de ataque",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Ativa este evento quando a entidade entra no local de perseguição",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Ativa este evento quando a entidade sai do local de ataque",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Ativa este evento quando a entidade sai do local de perseguição",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Ativa uma detecção de linha da câmera por meio do cliente",
  T_40_XXJ_WS_ONCOLLISION_D: "Apenas entidades com o componente Colisor acoplado suporta este evento",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Ativa este evento quando a arma de spray acerta uma entidade",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Quando os disparos param",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Quando um jogador troca de área no cenário",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Exibido quando o status aberto é verdadeiro, se não, é fechado",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Abrir situação",
  T_40_XXJ_WS_ORANGE: "Laranja",
  T_40_XXJ_WS_ORDER_DESC: "Classificação no placar",
  T_40_XXJ_WS_ORDER1: "Classificação inicial",
  T_40_XXJ_WS_ORDER2: "Classificação final",
  T_40_XXJ_WS_ORIGINAL: "Manter lógica padrão",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Método estouro",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "Ao ser priorizado, os atributos da arma do jogador substituirão os atributos originais da arma",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Priorizar skin de arma do jogador",
  T_40_XXJ_WS_OWNER_DESCKEY: "O jogador que possui esta entidade",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "O UID global do cenário filho ao qual ele pertence",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID do cenário filho",
  T_40_XXJ_WS_PARENT_DESCKEY: "Entidade pai",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Linha pai",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID da entidade componente pai",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "O ID do arquivo do componente pai",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Todos os passageiros no veículo",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passageiro",
  T_40_XXJ_WS_PHYSICALLAYER: "Camada física",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Matriz de camada física",
  T_40_XXJ_WS_PHYSICALTIP1: "O nome já existe",
  T_40_XXJ_WS_PHYSICALTIP2: "Remova o nome de uma camada e deixe-a invisível na Matriz de Camada Física e no Camada Enum, mas objetos de entidade dentro daquela camada não serão afetados.",
  T_40_XXJ_WS_PHYSICS: "Física",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "HUD de lista de espólio",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Uma entidade jogável",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Uma entidade que sempre está de frente para outra entidade",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Uma entidade segue outra entidade",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "A animação de rastro de bala é uma animação simulada de um rastro de bala",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "O jogador a receber a mensagem",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "O avatar utilizado pelo jogador",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "O traje equipado pelo jogador",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Traje do jogador",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "O tipo de HUD do jogador",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Tipo de HUD do jogador",
  T_40_XXJ_WS_PLAYERIDINFAC: "Número de série da gangue",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "O jogador a gravar no registro",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume o token de um jogador específico",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "A lista de habilidades do jogador",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "O status de um jogador: vivo, derrubado ou abatido",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Velocidade da execução",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Velocidade da execução",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Por exemplo, 1,25 significa 25% mais rápido que a velocidade original",
  T_40_XXJ_WS_POS_DESCKEY: "Coordenadas para onde teleportar",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "O tipo adesivos de efeitos especiais",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Cor impressa",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executa uma transversal de um recipiente para obter o par de valor chave. Inclui um processo filho, que é o ciclo.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Visita ao dicionário do ciclo",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progresso [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progresso [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "O botão para o progresso da habilidade",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Botão de progresso da habilidade",
  T_40_XXJ_WS_QUATERNION: "Rotação do quaternião",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "HUD de mensagens rápidas",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Mensagem ao lado da lista da equipe",
  T_40_XXJ_WS_RADIUS_DESCKEY: "O raio dos dois semicírculos de uma cápsula",
  T_40_XXJ_WS_READCELL: "Ler uma célula",
  T_40_XXJ_WS_READCSV: "Ler o conteúdo da tabela",
  T_40_XXJ_WS_READCSV_DESC: "Lê o conteúdo da tabela inteira Retornar para matriz 2D.",
  T_40_XXJ_WS_READCSVCELL: "Leia pelo # da coluna e pelo nome da coluna",
  T_40_XXJ_WS_READCSVCOL_DESC: "Lê o conteúdo de uma coluna específica na tabela. Retorna uma matriz.",
  T_40_XXJ_WS_READCSVROW_DESC: "Lê o conteúdo de uma linha específica na tabela. Retorna uma matriz.",
  T_40_XXJ_WS_READLEADERBOARD: "Ler valor do placar",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Lê o valor correspondente de um identificador específico em uma tabela específica do placar na base de dados.",
  T_40_XXJ_WS_READLEADERBOARD2: "Ler por faixa de classificação",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Lê o valor da diferença entre uma classificação específica e outra classificação específica no placar na base de dados.",
  T_40_XXJ_WS_RED: "Vermelho",
  T_40_XXJ_WS_RELOAD: "Recarregar",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Método de visualização",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restaura o traje original de um jogador",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restaura a skin de arma original de um jogador",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Se o deslocamente é restrito  à janela de exibição. Selecionado por padrão.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Limitar arrastar ou não",
  T_40_XXJ_WS_RESULT_DESCKEY: "Resultado da leitura",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Resultado",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Se encontra ou não o maior número na lista",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Se encontra ou não o menor número na lista",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Encontra o menor número na lista",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Encontra o maior número na lista",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "O ponto de ressurgimento de um jogador. Se não houver pontos de checagem, usa um ponto de surgimento. Se houver, usa pontos de checagem.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Ponto de ressurgimento",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Braço direito",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Braço direito",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "Cor direita",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Cor direita",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Exibir ou não efeitos especiais na direita",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Exibir efeito à direita ou não",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Pé direito",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Pé direito",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Mão direita",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Mão direita",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Ícone direito",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Ícone direito",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Perna direita",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Perna direita",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Texto da pontuação à direita",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Texto da pontuação à direita",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Texto à direita",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Texto à direita",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "O componente de corpo rígido",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Componente de corpo rígido",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "O enum do tipo de corpo rígido",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Enum do tipo de corpo rígido",
  T_40_XXJ_WS_ROW_DECS: "Linha a ser lida",
  T_40_XXJ_WS_ROWVALUE: "Conteúdo de linha",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configura a escala de zoom do objeto",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Escala",
  T_40_XXJ_WS_SCALE0_DESCKEY: "A escala de zoom da série de coordenadas no mundo",
  T_40_XXJ_WS_SCALE1_DESCKEY: "A esscala de zoom. 1 por padrão.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "O valor da escala",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "O nome da área",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Barra de pontuação",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Barra de pontuação",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Suporta rolar em diversas direções",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Direção de rolagem",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "O fator da rolagem. Quanto maior o valor, mais rápida a rolagem.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Fator de rolagem",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configura a cullingMask da câmera",
  T_40_XXJ_WS_SETGLOBAL: "Definir global",
  T_40_XXJ_WS_SETPARENT_D: "Suporta apenas entidades que tenham componente Tranformar",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configura o ID do traje do jogador",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modifica vários trajes de jogadores",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Definir direção do jogador",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configura o comando do HUD de um jogador",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configura a skin de arma de um jogador",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Se exibe ou não entidades no local alvo",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Exibir entidade no alvo",
  T_40_XXJ_WS_SHOWPLAYER: "Exibir entidade",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Entidade HUD de partida solo",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Uma entidade HUD para partidas solo. Modificar as propriedades desta entidade afetará o conteúdo a ser exibido na IU correspondente.",
  T_40_XXJ_WS_SIZEDELTA: "Delta do tamanho da caixa de âncora e do componente",
  T_40_XXJ_WS_SKELETON: "Esqueleto",
  T_40_XXJ_WS_SKELETON_D: "O pivô utilizado para acessar a máscara de esqueleto",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Parte esquelética",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Entidade HUD do botão de habilidade",
  T_40_XXJ_WS_SLOT_DESCKEY: "O espaço da arma",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Se selecionado, haverá um movimento lento ao arrastar. Se não selecionado, arrastar será igual a velocidade do cursor.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Movimento suave ou não",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Maciez",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Maciez",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Entidade de som",
  T_40_XXJ_WS_SPACE_DESCKEY: "Espaço",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Espaçamento da linha filho",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "As coordenadas do ponto de surgimento da IA",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Coordenadas do ponto de surgimento",
  T_40_XXJ_WS_SPEED_DESCKEY: "Velocidade",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Velocidade",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Correr",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "O raio da esfera",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "Cor do spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Cor do spray",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "Resultado do spray",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Resultado do spray",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "A arma de spray (fuzil de assalto)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Fuzil de spray",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Velocidade inicial",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Virar adesivo",
  T_40_XXJ_WS_SPRITEID: "ID de ativo de sprite",
  T_40_XXJ_WS_SPRITEID_D: "O ID usado para descrever o ativo de sprite",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Tipo de adesivo",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "A entidade alvo para ser gerada em um pixel estático",
  T_40_XXJ_WS_STARTPOSITION_D: "As coordenadas do centro geométrico da forma",
  T_40_XXJ_WS_STAY_D: "Reter posição de mundo, rotação e  escala atuais do filho? Isso é, geralmente, definido como verdadeiro, e os ajustes de IU não têm efeito nesta opção.",
  T_40_XXJ_WS_STRING_NAMEKEY: "Sentença",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Converte uma sentença em um flutuador",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Converte uma sentença em um inteiro",
  T_40_XXJ_WS_STYLE_DESCKEY: "O método de jogo da interpolação. Opções incluem jogar uma vez, retornar e jogar de novo.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Trocar a área do jogador",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Alterar valor",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Troca armas de acordo com o espaço do jogador",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Troca o espaço de item",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Trocar item",
  T_40_XXJ_WS_TABLENAME_DESC: "Exibido como tabela de nome mas é na verdade o UID",
  T_40_XXJ_WS_TABLEVALUE: "Conteúdo da tabela",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "Lista de etiquetas",
  T_40_XXJ_WS_TARGET_DESCKEY: "Entidade alvo a gerar pixel do mapa. Vazio por padrão.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entidade a criar pixel do mapa",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Alvo de ataque",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "A entidade alvo",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entidade",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "A entidade onde fica a função personalizada",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "A entidade atacada pela IA",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "A entidade alvo a ser seguida",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "A entidade item (pode estar vazia)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "A entidade alvo a ser olhada",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "A entidade som a ser pausada",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "A entidade som a ser executada após a pausa",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "A entidade som a ser apagada",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Informações dos aliados",
  T_40_XXJ_WS_TELEPORTA_D: "Teleporta o jogador para um local específico em uma direção definida",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Texto de dica",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Cor do texto da notificação",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "A entidade texto representa o texto a ser exibido",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "O texto a ser exibido",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Chave do texto",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "A indicação de tempo",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "O estilo de exibição de uma sentença localizada",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Estilo de exibição da indicação de tempo",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "A sentença localizada para indicação de tempo",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Indicação de tempo de sentença loc",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Dica",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Dica",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "A quantidade de item de espólio",
  T_40_XXJ_WS_TOKENID_DESCKEY: "O ID de um item de espólio",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "Velocidade de reboque de um jogador",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Tipo de tradução",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "Entidade animação de interpolação",
  T_40_XXJ_WS_TYPE_DESCKEY: "Este é o tipo de descrição. Usar “typeof” retornará a este tipo.",
  T_40_XXJ_WS_TYPE_NAMEKEY: "Tipo de corpo rígido",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Diferentes tipos de corpos rígidos têm funções diferentes",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Somente moedas básicas suportadas na versão atual",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Se habilita ou não a exibição de profundidade do minimapa",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Usar mapa de profundidade",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Se segue as leis gravitacionais ou não",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitacional ou não",
  T_40_XXJ_WS_UUID_DESCKEY: "O identificador único de um jogador",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "O valor",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Valor",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Valor [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "O primeiro valor",
  T_40_XXJ_WS_VALUE2_DESCKEY: "O segundo valor",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Valor [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "O valor inicial",
  T_40_XXJ_WS_VALUEB_DESCKEY: "O valor alvo",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "O nome do valor a ser analisada. Pode ser utilizado para obter o valor em uma variável local.",
  T_40_XXJ_WS_VALUET_DESCKEY: "O progresso de interpolação. Fica entre 0 e 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Tipo de variável",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "O tipo de exibição vertical",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Tipo de exibição vertical",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "O nível de visibilidade de um objeto",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Camada visível",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Trajes incluem conjuntos, cabeça, máscara, pintura facial, partes de cima, partes de baixo e sapatos",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Tipo de traje",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Espaço de trajes",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Armas",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "O ID da skin de arma",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID da skin de arma",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "O ID da skin de arma",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "A skin de arma do jogador",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Enum do tipo de componente",
  T_40_XXJ_WS_WIDTH_DESCKEY: "A largura",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Volta ao mundo",
  T_40_XXJ_WS_WRITELEADERBOARD: "Escrever valor do placar de líder",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Escreve o valor correspondente de uma chave específica em um placar de líder específico na base de dados.",
  T_40_XYL_WS_BUMPERFACTORY: "Fábrica de Carro Bate-bate",
  T_40_XYL_WS_BURNDAMAGE: "Dano da combustão",
  T_40_XYL_WS_BURNINTERVAL: "Intervalo do dano da combustão (s)",
  T_40_XYL_WS_BURNTIME: "Tempo de combustão após explosão",
  T_40_XYL_WS_COLORFULSKY: "Céu colorido",
  T_40_XYL_WS_CRANEMACHINE: "Guindaste com garra",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Dano máximo do impacto",
  T_40_XYL_WS_CRASHMAXSPEED: "Limite de velocidade do dano máximo do impacto",
  T_40_XYL_WS_CRASHMESS: "Parâmetro de massa durante o impacto",
  T_40_XYL_WS_CRASHMINDAMAGE: "Dano mínimo do impacto",
  T_40_XYL_WS_DISPLAYBOARD: "Anúncio",
  T_40_XYL_WS_EXPLODEDAMAGE: "Dano da explosão",
  T_40_XYL_WS_EXPLODEDELAY: "Tempo de atraso da explosão",
  T_40_XYL_WS_EXPLODERANGE: "Área de explosão",
  T_40_XYL_WS_FERRISWHEEL: "Roda gigante",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Tempo de troca de equipamento (s)",
  T_40_XYL_WS_ICAROUSEL001: "Componente A do Carrossel",
  T_40_XYL_WS_ICAROUSEL002: "Componente B do Carrossel",
  T_40_XYL_WS_ICAROUSEL003: "Carrossel",
  T_40_XYL_WS_ICEDANCEDOOL: "Boneca azul",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Proporção de potência descontrolada para estacionar",
  T_40_XYL_WS_LOLLIPOP: "Pirulito gigante",
  T_40_XYL_WS_NEWHOOKGUN: "Super Lança Gancho",
  T_40_XYL_WS_OPENSWING: "Botão de balanço",
  T_40_XYL_WS_OPENTRACTION: "Botão de reboque",
  T_40_XYL_WS_PODIUM: "Pódio",
  T_40_XYL_WS_SKYCITY: "Cidade",
  T_40_XYL_WS_SKYSCRAPER_A001: "Arranha-céu A Componente A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Arranha-céu A Componente B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Arranha-céu A Componente C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Arranha-céu B Componente A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Arranha-céu B Componente B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Arranha-céu B Componente C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Arranha-céu C Componente A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Arranha-céu C Componente B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Arranha-céu C Componente C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Arranha-céu D Componente A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Arranha-céu D Componente B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Arranha-céu D Componente C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Arranha-céu E Componente A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Arranha-céu E Componente B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Arranha-céu E Componente C",
  T_40_XYL_WS_STEERANGLE: "Raio de curva em alta velocidade",
  T_40_XYL_WS_STEERSPEED: "Velocidade máxima de curvas em alta velocidade",
  T_40_XYL_WS_SWINGSPEED: "Velocidade do balanço",
  T_40_XYL_WS_TARGETOBJECT: "Âncora do movimento",
  T_40_XYL_WS_TRACTIONSPEED: "Velocidade do reboque",
  T_40_XYL_WS_TRIGGERCAPSULE: "Gatilho de cápsula personalizada",
  T_40_XYL_WS_TRIGGERSPHERE: "Gatilho de esfera person.",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Objeto personalizado",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Um componente de objeto vazio que pode ser utilizado",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Componente de renderização personalizado",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Um componente de renderização personalizado utilizado para renderizar com recursos de modelos personalizados.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Suas marcações de oponentes têm valor de recompensa. Qualquer jogador na equipe ganhará [FFB300]{0} em grana na partida[-] por abater um oponente marcado, e você ganhará mais [FFB300]100[-] por abater um oponente. Receba [FFB300]{1} Fichas FF [-]adicionais na Máquina de Ficha em partidas de BR.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Abate é Dinheiro",
  T_41_CJ_A_ESPORTS_TH: "Destaque do FFTC (Máscara)",
  T_41_CJ_B_ESPORTS_TH: "Destaque do FFTC (Pernas)",
  T_41_CJ_H_ESPORTS_TH: "Destaque do FFTC (Cabeça)",
  T_41_CJ_S_ESPORTS_TH: "Destaque do FFTC (Calçado)",
  T_41_CJ_T_ESPORTS_TH: "Destaque do FFTC (Torso)",
  T_41_CJ_T_FFSI: "Moletom Campeão do FFSI",
  T_41_CJ_T_FOOTBALL_EU01: "Camisa Águia Solar",
  T_41_CJ_T_FOOTBALL_EU02: "Camisa Cavalo Rubro",
  T_41_CJ_T_FOOTBALL_EU03: "Camisa Galo Lusitano",
  T_41_CJ_T_FOOTBALL_EU04: "Camisa Fera Ibérica",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Diminuição da zona",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Ativar ou não este dispositivo",
  T_41_SJ_WS_SPECIALITEM_NAME: "Dispositivo",
  T_41_SW_SKILL_DESC_DELIVERY: "Quando atingido por um oponente dentro de [FFB300]{0}m[-], o jogador que fez o ataque ficará marcado por [FFB300]{1}s[-] (a informação é compartilhada com aliados). Máx. [FFB300]{2} marcações[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Receba [FFB300]{0} Pontos de Escudo adicionais [-] no começo da partida. Recupere Pontos de Escudo após sobreviver a um combate.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "Ao usar uma habilidade ativa, dá [FFB300]{1} Pontos de Escudo[-] a aliados dentro de [FFB300]{0}m[-]. Os Pontos de Escudo são reduzidos após [FFB300]{2}s[-]. Depois deste tempo, o jogador pode obter os efeitos novamente. Tempo de recarga: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Paredes de Gel em jogo recuperam [FFB300]{0}[-] de durabilidade por segundo ao serem atingidas, ao mesmo tempo em que aliados dentro de [FFB300]{1}m[-] restauraram [FFB300]{2} de vida por segundo[-]. Máx. [FFB300]{3} de vida[-] por aliado de cada Parede de Gel.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Traje de Pet: Amuleto do Cacto",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Traje de Pet: Falcão da Redenção",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Tipo",
  T_41_WT_SKILL_DESC_FIREBOY: "Cria um paredão de fogo com [FFB300]{1}m[-] de largura e duração de [FFB300]{0}s[-]. Ele se move pra frente, a [FFB300]{2}m/s[-], por até [FFB300]{3}s[-]. Durante o efeito, use a habilidade de novo para parar o paredão. [FFB300]Oponentes (ou Paredes de Gel)[-] que encostarem nele sofrem [FFB300]{4} (ou {5}) de dano[-] na hora, e continuam sofrendo [FFB300]{6} (ou {7}) de dano[-] por segundo. Duração: [FFB300]{8}s[-]. Tempo de recarga: [FFB300]{9}s[-]. Até [FFB300]{10}[-] usos da habilidade podem ser armazenados, com o intervalo de [FFB300]{11}s[-] entre cada uso.",
  T_41_WT_SKILL_NAME_FIREBOY: "Paredão de Fogo",
  T_41_WZY_WS_CHARGEMAX: "Máx. Carregamento de Máquina de Gel",
  T_41_WZY_WS_CROSSBOWNAME: "Balestra",
  T_41_WZY_WS_DECELERATIONRATIO: "% de desaceleração na água",
  T_41_WZY_WS_DEICEWALLPARAM1: "Raio da área de derretimento",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duração do derretimento",
  T_41_WZY_WS_EXPPERCHIP: "EXP do Chip de Gel",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP por causar dano",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP por cada metro percorrido",
  T_41_WZY_WS_EXPPERSECOND: "EXP por segundo",
  T_41_WZY_WS_GRENADEEXPTIME: "Atraso da explosão",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosivos",
  T_41_WZY_WS_GRENADEMAX: "Dano máximo",
  T_41_WZY_WS_GRENADEMIN: "Dano mínimo",
  T_41_WZY_WS_GRENADERANGE: "Alcance da explosão",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Coeficiente de dano em veículos",
  T_41_WZY_WS_GRENADERATIOSELF: "Coeficiente de dano em si mesmo",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Coeficiente de dano em aliados",
  T_41_WZY_WS_GRENADTHROWSPEED: "Velocidade de percurso do explosivo",
  T_41_WZY_WS_HANDCANNONNAME: "Canhão de Mão",
  T_41_XXJ_WS_ACCELERATION: "Aceleração",
  T_41_XXJ_WS_ACCELERATION_D: "Cria um efeito de aceleração específico",
  T_41_XXJ_WS_ACTION: "Nó de ação",
  T_41_XXJ_WS_ACTION_D: "Pivô de ação",
  T_41_XXJ_WS_ADDHP: "Itens de cura",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Adicionar vida máxima",
  T_41_XXJ_WS_AICASTSKILL_D: "Ativação de habilidade de IA",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Compensação do centro de assistência de mira",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Distância da assistência de mira",
  T_41_XXJ_WS_AIMASSISTENTITY: "Entidade assistência de mira",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entidade que pode receber assistência de mira",
  T_41_XXJ_WS_AISKILLTYPE: "Tipo de habilidade do zumbi",
  T_41_XXJ_WS_AISKILLTYPE_D: "Tipo de habilidade do zumbi",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Todos os itens",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Todos os itens",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modificar capacidade do cartucho",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Projéteis no cartucho",
  T_41_XXJ_WS_ANCHORPOSITION_D: "As coordenadas da âncora em relação ao pai",
  T_41_XXJ_WS_ANGLE_D: "Ângulo de rotação do eixo z",
  T_41_XXJ_WS_ANGULARDRAG: "Deslocamento angular",
  T_41_XXJ_WS_ANGULARVELOCITY: "Velocidade angular",
  T_41_XXJ_WS_ANIMATIONCLIP: "Estado da animação",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Controle de animação",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Entidade animação",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "O arquivo e o recurso utilizados para gerenciar o controle de animação",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "UUID do recurso do controle de animação",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Enum do tipo de ciclo",
  T_41_XXJ_WS_ANIMATIONSTATE: "Estado da animação",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operação na qual todos os tipos de tribuição de valor são aceitos e na qual tipos digitais aceitam auto-incrementação, auto-subtração, auto-mutiplicação e auto-divisão",
  T_41_XXJ_WS_ATTACHMENT: "Acessório",
  T_41_XXJ_WS_ATTACHMENT_D: "Acessório",
  T_41_XXJ_WS_ATTACHTARGET: "Entidade vínculada",
  T_41_XXJ_WS_BAG: "Mochila",
  T_41_XXJ_WS_BAG_D: "Componente de mochila",
  T_41_XXJ_WS_BANNERID: "ID do banner",
  T_41_XXJ_WS_BANNERID_D: "ID do banner",
  T_41_XXJ_WS_BEHAVIOURTREE: "Árvore de comportamento",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Árvore de comportamento",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Entidade árvore montável por comportamento",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A entidade de comportamento que pode ser montada",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Nó customizado de árvore de comportamento",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Pivô customizado de árvore de comportamento",
  T_41_XXJ_WS_BODY: "Corpo",
  T_41_XXJ_WS_BORDERLR: "Borda (esquerda e direita)",
  T_41_XXJ_WS_BORDERLR_D: "As bordas esquerda e direita",
  T_41_XXJ_WS_BORDERTB: "Borda (superior e inferior)",
  T_41_XXJ_WS_BORDERTB_D: "As bordas superior e inferior",
  T_41_XXJ_WS_BRPEAKRANK: "Patente BR Máxima",
  T_41_XXJ_WS_BRPEAKRANK_D: "Patente BR Máxima",
  T_41_XXJ_WS_BRRANK: "Patente BR",
  T_41_XXJ_WS_BRRANK_D: "Patente BR",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Tipo de nó de árvore de comportamento",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Tipo de pivô de árvore de comportamento",
  T_41_XXJ_WS_BTREE: "Árvore de comportamento",
  T_41_XXJ_WS_BTREENODESTATE: "Estado do nó de árvore de comportamento",
  T_41_XXJ_WS_BTREENODESTATE_D: "Status de operação do pivô de árvore de comportamento",
  T_41_XXJ_WS_BUFFABLEENTITY: "Entidade bônus ativado",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Permite adicionar e remover bônus, bem como obter listas de bônus adicionados",
  T_41_XXJ_WS_BUILDINGICEWALL: "Parede de Gel",
  T_41_XXJ_WS_CAMOUFLAGE: "Itens funcionais",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Prancha, camuflagem",
  T_41_XXJ_WS_CAPICITY_D: "Capacidade inicial",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisível ao centro",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Invisível ao centro",
  T_41_XXJ_WS_COLOR: "Cor",
  T_41_XXJ_WS_COLOR_D: "A cor",
  T_41_XXJ_WS_CONDITION: "Nó condicional",
  T_41_XXJ_WS_CONDITION_D: "Condições são um tipo Booleano especial",
  T_41_XXJ_WS_CONDITION1_D: "Pivô condicional",
  T_41_XXJ_WS_CONSTRAIN: "Restrição de RigidBody",
  T_41_XXJ_WS_CONSTRAIN_D: "Adiciona restrições ao RigidBody. Esta é uma compilação do Tipo de Restrição de RigidBody",
  T_41_XXJ_WS_COUNT_D: "Quantidade",
  T_41_XXJ_WS_CROSSBOW_D: "Balestra",
  T_41_XXJ_WS_CSPEAKRANK: "Patente CS Máxima",
  T_41_XXJ_WS_CSPEAKRANK_D: "Patente CS Máxima",
  T_41_XXJ_WS_CSRANK: "Patente CS",
  T_41_XXJ_WS_CSRANK_D: "Patente CS",
  T_41_XXJ_WS_CSVNAME_D: "O arquivo csv em SceneData que corresponde ao modo. Termina em .csv. Cabeçalhos são escritos em letras minúsculas",
  T_41_XXJ_WS_CURCAPACITY: "Capacidade usada",
  T_41_XXJ_WS_CURPROGRESS: "Progresso atual",
  T_41_XXJ_WS_CURRENTCLIP: "Clip atual",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Progresso de clip atual",
  T_41_XXJ_WS_CURRENTSTATE: "Estado atual",
  T_41_XXJ_WS_CUSTOMHUDID: "ID da HUD personalizada",
  T_41_XXJ_WS_CUSTOMHUDID_D: "O ID usado para descrever um ativo de HUD personalizada",
  T_41_XXJ_WS_DASHATTACK: "Ataque de arranque",
  T_41_XXJ_WS_DEBUG: "Iniciar resolução de problemas",
  T_41_XXJ_WS_DEBUG_D: "Consertar",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "% de desaceleração: A desaceleração sofrida por um objeto na água (variação ajustada temporariamente entre 0-100)",
  T_41_XXJ_WS_DEPTH_D: "A profundidade",
  T_41_XXJ_WS_DRAG: "Coeficiente do deslocamento",
  T_41_XXJ_WS_DRAG_D: "Quanto mais alto o coeficiente, maior será a desaceleração da velocidade de movimento",
  T_41_XXJ_WS_DUMMY: "Boneco",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Habilitar modo de qualidade baixa de gráficos",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Quando estiver com fps baixo ativado, o jogo será executado em 15 fps; se não, em 30fps",
  T_41_XXJ_WS_ENTITYLIST: "Retorna a lista de entidade criada",
  T_41_XXJ_WS_ENTITYNAME: "Nome do objeto",
  T_41_XXJ_WS_ENTITYNAME_D: "O nome do objeto personalizado pelo jogador",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Entidade lógica ou ID pré-fabricado",
  T_41_XXJ_WS_EQUIPANDBAG: "Armadura e mochila",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Enum do espaço do equipamento",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Enum do espaço do equipamento",
  T_41_XXJ_WS_EXPLODE: "Auto-explodir",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Arma de explosivo",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Velocidade da recarga automática",
  T_41_XXJ_WS_FILEID: "ID interno",
  T_41_XXJ_WS_FILEID_D: "O ID interno do controle em pré-fabricada",
  T_41_XXJ_WS_FILLAMOUNT: "Preencher valor",
  T_41_XXJ_WS_FILLAMOUNT_D: "Preencher o valor",
  T_41_XXJ_WS_FILLDIR: "Preencher direção",
  T_41_XXJ_WS_FILLDIR_D: "A direção do preenchimento",
  T_41_XXJ_WS_FILLDIR_D1: "Enum da direção do preenchimento",
  T_41_XXJ_WS_FILLTYPE: "Tipo de preenchimento",
  T_41_XXJ_WS_FILLTYPE_D: "O tipo de preenchimento",
  T_41_XXJ_WS_FILLTYPE_D1: "Enum do tipo de preenchimento",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Encontrar caminho",
  T_41_XXJ_WS_FINISH: "Completar",
  T_41_XXJ_WS_FIREINTERVAL: "Intervalo de disparo",
  T_41_XXJ_WS_FIREINTERVAL_D: "Intervalo de ataque",
  T_41_XXJ_WS_FLIP: "Método de virada",
  T_41_XXJ_WS_FLIP_D: "O método de virada",
  T_41_XXJ_WS_FLYBOMBBEE: "Zumbi Voador",
  T_41_XXJ_WS_FORCE: "Força",
  T_41_XXJ_WS_FORCE_D: "Cria uma força de intensidade específica",
  T_41_XXJ_WS_FORCETYPE: "Tipo de força",
  T_41_XXJ_WS_FORCETYPE_D: "Os diferentes tipos de força no RigidBody. Obs.: Efetivo somente em tipos dinâmicos de RigidBody.",
  T_41_XXJ_WS_FREEZEALL: "Congelar movimento e rotação",
  T_41_XXJ_WS_FREEZEPOSITION: "Congelar movimentos lineares",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Congelar eixo x",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Congelar eixo y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Congelar eixo z",
  T_41_XXJ_WS_FREEZEROTATION: "Congelar toda rotação",
  T_41_XXJ_WS_FREEZEROTATIONX: "Congelar rotação x",
  T_41_XXJ_WS_FREEZEROTATIONY: "Congelar rotação y",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Congelar rotação z",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distância para dano máx.",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "A distância para dano máx.",
  T_41_XXJ_WS_GAMEID_D: "ID da missão",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Dar um item do Lei do Frifas",
  T_41_XXJ_WS_GRADIENT: "Gradiente",
  T_41_XXJ_WS_GRADIENT_D: "O gradiente",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradiente na parte inferior",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "O gradiente na parte inferior",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparência na parte inferior",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Transparência da parte inferior",
  T_41_XXJ_WS_GRADIENTTOP: "Gradiente na parte superior",
  T_41_XXJ_WS_GRADIENTTOP_D: "O gradiente na parte superior",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparência na parte superior",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Transparência da parte superior",
  T_41_XXJ_WS_GRAPHID: "ID do script",
  T_41_XXJ_WS_GRAPHID_D: "O ID usado para descrever um ativo de script",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Componente de Quebra-Gel",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Atraso da explosão",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Arremessável",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Dano máx. ",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Dano mín.",
  T_41_XXJ_WS_GRENADERANGE_D: "Alcance de explosão",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Multiplicador de dano a si mesmo",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Multiplicador de dano a aliado",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Multiplicador de dano de veículo",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Velocidade de lançamento",
  T_41_XXJ_WS_GRENADEWEAPON: "Categoria de arremessável",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Tipos de arremessáveis básicos",
  T_41_XXJ_WS_HANDCANNON_D: "Arremessáveis",
  T_41_XXJ_WS_HEAD: "Cabeça",
  T_41_XXJ_WS_HEADID: "ID do avatar",
  T_41_XXJ_WS_HEADID_D: "ID do avatar",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Arma pesada",
  T_41_XXJ_WS_HELMET_D: "O capacete atual",
  T_41_XXJ_WS_HELMET1_D: "Capacete",
  T_41_XXJ_WS_HELMET2_D: "Entidade capacete",
  T_41_XXJ_WS_HITBODYPART_D: "A parte do corpo que foi acertada",
  T_41_XXJ_WS_HITBPDYPART: "Acertar parte do corpo",
  T_41_XXJ_WS_HITENTITY_D: "Entidade acertada",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "A entidade HUD ao qual pertence",
  T_41_XXJ_WS_HUD3DCONTAINER: "Contêiner de conteúdo 3D",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "A entidade HUD de contêiner 3D Este é o HUD que os jogadores alteram no editor.",
  T_41_XXJ_WS_HUDGRID: "Controle de exibição (painel) personalizado",
  T_41_XXJ_WS_HUDLAYOUT: "Controle de exibição",
  T_41_XXJ_WS_HUDLAYOUT_D: "Entidade de inserção de HUD Este é o HUD que os jogadores alteram no editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Controle de avatar personalizado",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "A entidade HUD de informação de perfil Este é o HUD que os jogadores alteram no editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Controle de texturas",
  T_41_XXJ_WS_HUDTEXTURE_D: "A entidade textura de HUD. Este é o HUD que os jogadores alteram no editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "Componente de controle UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "A entidade componente de controle UITransform",
  T_41_XXJ_WS_IMPULSE: "Colisão",
  T_41_XXJ_WS_IMPULSE_D: "Criar uma colisão de um tipo específico de intensidade",
  T_41_XXJ_WS_INITIALWORLDPOS: "Coordenadas de mundo iniciais",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Enum do bônus",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponde à coluna de ID em BuffData.csv. Antes de adicionar novos conteúdos, verifique a compatibilidade com GPP.",
  T_41_XXJ_WS_INVERTFILL: "Inversão de preenchimento",
  T_41_XXJ_WS_INVERTFILL_D: "Inverte o preenchimento",
  T_41_XXJ_WS_ISLOOP: "É ciclo",
  T_41_XXJ_WS_ISLOOP_D: "Se é ciclo não não. O padrão é falso.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Geração de malha de navegação estática",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Usado somente para verificar a geração de malha de navegação estática ao carregar objetos estáticos",
  T_41_XXJ_WS_ISSUCCESS_D: "Destruido ou não",
  T_41_XXJ_WS_ITEMENTITY_D: "A entidade item",
  T_41_XXJ_WS_ITEMID: "ID do item",
  T_41_XXJ_WS_ITEMID_D: "ID do item",
  T_41_XXJ_WS_ITEMID_D1: "O ID de item correspondente do acessório",
  T_41_XXJ_WS_ITEMLIST: "Lista de itens",
  T_41_XXJ_WS_ITEMTYPE_D: "O tipo de item",
  T_41_XXJ_WS_JUMPATTACK: "Ataque ao saltar",
  T_41_XXJ_WS_LANDMINE: "Mina terrestre",
  T_41_XXJ_WS_LENGTH: "Tamanho do clip",
  T_41_XXJ_WS_LENGTH_D: "O tamanho da barra de progresso. O valor padrão é o tamanho da IU pré-fabricada.",
  T_41_XXJ_WS_LIMB: "Membros",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Não foi possível adicionar o elemento porque o tamanho excedeu a capacidade",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Lista de bônus",
  T_41_XXJ_WS_LOOP: "Ciclo",
  T_41_XXJ_WS_LOOP_D: "Ciclo",
  T_41_XXJ_WS_MAXCAPACITY: "Capacidade",
  T_41_XXJ_WS_MAXCAPACITY_D: "A capacidade da mochila",
  T_41_XXJ_WS_MAXPROGRESS: "Progresso máx.",
  T_41_XXJ_WS_MELEEWEAPON_D: "Arma de contato",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "A distância para dano mín.",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "A distância para dano mín.",
  T_41_XXJ_WS_MINISENTRY: "Torreta automática",
  T_41_XXJ_WS_NAME: "Nome",
  T_41_XXJ_WS_NAME_D: "O nome do botão de habilidade. Usado para envio de parâmetro durante incidentes OnClick, então precisa ser único.",
  T_41_XXJ_WS_NAME1_D: "Nome do produto",
  T_41_XXJ_WS_NAME2_D: "Nome da lista de produto",
  T_41_XXJ_WS_NAME3_D: "Nome da máquina de vendas",
  T_41_XXJ_WS_NICKNAME: "Apelido",
  T_41_XXJ_WS_NICKNAME_D: "Nome do jogador",
  T_41_XXJ_WS_NOCHANGE: "Sem alterações",
  T_41_XXJ_WS_NONE: "Nenhuma restrição",
  T_41_XXJ_WS_NONE1: "Nenhuma",
  T_41_XXJ_WS_OFFSET: "Compensação",
  T_41_XXJ_WS_OFFSET_D: "A compensação",
  T_41_XXJ_WS_OFFSET1_D: "Valor de compensação escrito",
  T_41_XXJ_WS_ONCE: "Uma vez",
  T_41_XXJ_WS_ONCE_D: "Uma vez",
  T_41_XXJ_WS_ONHIDE: "Quando a interface está fechada",
  T_41_XXJ_WS_ONHIDE_D: "Quando a interface está fechada",
  T_41_XXJ_WS_ONNODEENTER_D: "Quando o pivô está entrando",
  T_41_XXJ_WS_ONSHOW: "Quando a interface está aberta",
  T_41_XXJ_WS_ONSHOW_D: " Quando a interface está aberta",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Ativa quando a caixa de texto é alterada",
  T_41_XXJ_WS_PERSONALUAV: "Mini drone",
  T_41_XXJ_WS_PINID: "ID da insígnia",
  T_41_XXJ_WS_PINID_D: "O ID da insígnia",
  T_41_XXJ_WS_PLAYERBAG: "Entidade mochila do jogador",
  T_41_XXJ_WS_PLAYERBAG_D: "A entidade mochila do jogador",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Mochila do jogador",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "A mochila do jogador",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Coeficiente modificado de velocidade ao mirar",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impacto da velocidade de movimento ao disparar",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "O impacto da velocidade de movimento ao disparar",
  T_41_XXJ_WS_PREFABID: "ID pré-fabricado",
  T_41_XXJ_WS_PREFABID_D: "O ID usado para descrever um ativo pré-fabricado",
  T_41_XXJ_WS_PREFABID1_D: "A entidade modelo de HUD representada por este ID",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Arma principal 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Arma principal 2",
  T_41_XXJ_WS_PROFILEINFO: "Perfil do jogador",
  T_41_XXJ_WS_PROFILEINFO_D: "Descrição do jogador",
  T_41_XXJ_WS_PROGRESSICON_D: "O ícone de progresso",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Nome do ícone de progresso",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Sair do minijogo Lei do Frifas",
  T_41_XXJ_WS_RANGE: "Alcance de disparo",
  T_41_XXJ_WS_RANGE_D: "Alcance de ataque",
  T_41_XXJ_WS_RANGE_D1: "Alcance de explosão",
  T_41_XXJ_WS_RANGE_D2: "Alcance de torreta",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Lê o conteúdo da tabela inteira Retornar para matriz 2D.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Lê o conteúdo de uma célula específica",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Lê o conteúdo de uma coluna específica. Retorna uma matriz.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Lê o conteúdo de uma linha específica. Retorna uma matriz.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Ler base de dados acumulada",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Lê o valor correspondente a uma chave em uma tabela na base de dados acumulada",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Recupera vida continuamente",
  T_41_XXJ_WS_RELOADSPEED: "Velocidade de recarga",
  T_41_XXJ_WS_RELOADSPEED_D: "Velocidade de recarga (velocidade base x multiplicador)",
  T_41_XXJ_WS_RESOURCEID: "UUID do recurso",
  T_41_XXJ_WS_RESOURCEID_D: "O UUID do recurso",
  T_41_XXJ_WS_RESUUID: "ID do recurso",
  T_41_XXJ_WS_RESUUID_D: "O UUID do rescurso designado a ser renderizado",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "Tipo de restrição do RigidBody",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Cada restrição é definida por uma marca de bit e pode ser usada como uma combinação",
  T_41_XXJ_WS_ROTATION: "Rotação",
  T_41_XXJ_WS_ROTATION_D: "O ângulo de rotação nas coordenadas de mundo. x, y, z se referem ao ângulo da rotação, ângulo de inclinação e ângulo de rolamento, respectivamente.",
  T_41_XXJ_WS_ROTATION1_D: "A rotação",
  T_41_XXJ_WS_RUNNING: "Correndo",
  T_41_XXJ_WS_SCALE: "Escala",
  T_41_XXJ_WS_SCALE_D: "Escala",
  T_41_XXJ_WS_SCALE1_D: "As escalas ao longo de um eixo específico. Pode ser uma combinação de três eixos.",
  T_41_XXJ_WS_SCATTERMAX: "Fragmentação máx. de projétil",
  T_41_XXJ_WS_SCATTERMAX_D: "O valor no qual se inicia a fragmentação do projétil",
  T_41_XXJ_WS_SCATTERMOVE1: "Tamanho da propagação em movimento",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Velocidade da recuperação da propagação",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "A velocidade da recuperação da propagação",
  T_41_XXJ_WS_SCATTERSPEED: "Velocidade do aumento da propagação",
  T_41_XXJ_WS_SCATTERSPEED_D: "Velocidade do aumento da propagação (0,1 = a mira aumenta 10% para cada aumento de rajada)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Menor propagação quando em posição deitada ou agachada",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Arma secundária",
  T_41_XXJ_WS_SHADERNAME: "Nome do sombreamento",
  T_41_XXJ_WS_SHADERNAME_D: "O nome do sombreamento",
  T_41_XXJ_WS_SHIELDBROKEN: "Ataque de quebra-escudo",
  T_41_XXJ_WS_SHIELDUP: "Ataque ao escudo",
  T_41_XXJ_WS_SHOCKWAVE: "Onda de choque",
  T_41_XXJ_WS_SHOWNAME: "Exibir apelido",
  T_41_XXJ_WS_SHOWNAME_D: "Exibe apelido",
  T_41_XXJ_WS_SHOWPIN: "Exibir insígnia",
  T_41_XXJ_WS_SHOWPIN_D: "Exibe insígnia",
  T_41_XXJ_WS_SHOWRANK: "Exibir patente",
  T_41_XXJ_WS_SHOWRANK_D: "Exibe patente",
  T_41_XXJ_WS_SHOWTYPE: "Estilo",
  T_41_XXJ_WS_SHOWTYPE_D: "Tipo",
  T_41_XXJ_WS_SHRINKSPEED: "Velocidade de encolhimento",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Habilitar assistência de mira ao mirar",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Sensibilidade da assistência de mira com distância (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coeficiente ao priorizar a distância para assistência de mira (≥1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Coeficiente máximo ao priorizar a distância para assistência de mira",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Coeficiente mínimo ao priorizar a distância para assistência de mira",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Priorizar a distância para assistência de mira",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Sensibilidade da assistência de mira (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Zoom da mira em fator",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "Zoom do campo de visão em fator",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Coeficiente da sensibilidade de rotação da mira",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Coeficiente modificado x de dano mín. ao mirar",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Zoom da IU ao disparar mirando em tempo (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Zoom da IU ao disparar mirando em fator",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Tempo para retormar (s) a IU ao disparar mirando",
  T_41_XXJ_WS_SPEED: "Velocidade da execução",
  T_41_XXJ_WS_SPEEQUIP: "Equipamento funcional",
  T_41_XXJ_WS_SPEITEM: "Dispositivos",
  T_41_XXJ_WS_STATICGRAPHID: "ID do script estático",
  T_41_XXJ_WS_STATICGRAPHID_D: "O ID usado para descrever um ativo de script estático",
  T_41_XXJ_WS_STATICWAINING: "Não foi possível modificar o tipo de Rigidbody estático",
  T_41_XXJ_WS_TARGETTREE: "Entidade árvore de comportamento",
  T_41_XXJ_WS_TARGETTREE_D: "A entidade árvore de comportamento",
  T_41_XXJ_WS_TEAMINDEX: "Número de série da equipe",
  T_41_XXJ_WS_TEAMINDEX_D: "O índice da equipe, que coincide com o índice da equipe na sala",
  T_41_XXJ_WS_TEAMINDEX_D1: "Número de equipe da gangue",
  T_41_XXJ_WS_TEMPLATEPREFABID: "ID pré-fabricado do modelo",
  T_41_XXJ_WS_TEXT_D: "Conteúdo",
  T_41_XXJ_WS_TEXTURENAME: "Nome da textura",
  T_41_XXJ_WS_TEXTURENAME_D: "O nome da textura",
  T_41_XXJ_WS_THROWATTACK: "Granada",
  T_41_XXJ_WS_TICKINTERVAL: "Intervalo de atualização",
  T_41_XXJ_WS_TICKINTERVAL_D: "O intervalo de atualização. Quanto maior o número, mais demora para acontecer a atualização",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Habilita dispositivos especiais na mochila do jogador",
  T_41_XXJ_WS_UVRECTWH: "Largura e altura de UV",
  T_41_XXJ_WS_UVRECTWH_D: "A largura e altura de UV",
  T_41_XXJ_WS_UVRECTXY: "Compensação de UV",
  T_41_XXJ_WS_UVRECTXY_D: "A compensação de UV",
  T_41_XXJ_WS_VELOCITY: "Velocidade",
  T_41_XXJ_WS_VELOCITY_D: "Evita a alteração direta da velocidade do RigidBody. É possível alterar por meio dos APIs relacionados.",
  T_41_XXJ_WS_VEST_D: "O colete atual",
  T_41_XXJ_WS_VEST1_D: "Colete",
  T_41_XXJ_WS_WIDGETID: "ID do controle",
  T_41_XXJ_WS_WIDGETID_D: "O ID usado para descrever um controle nos ativos da interface. Precisa ser combinado com uma ID de HUD personalizada para assegurar que seja correspondente a um ID de controle específico.",
  T_41_XXJ_WS_WINDATTACK: "Ataque de tornado",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Escrever compensação da base de dados acumulada",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Escreve a compensação correspondente a uma chave em uma tabela na base de dados acumulada",
  T_41_XXJ_WS_ZONEDURATION_D: "Duração do congelamento",
  T_41_XXJ_WS_ZONEDURATION1_D: "Duração do Quebra-Gel",
  T_41_XXJ_WS_ZONERADIUS_D: "Raio da zona de congelamento",
  T_41_XXJ_WS_ZONERADIUS1_D: "Raio do Quebra-Gel",
  T_41_XYL_WS_BOT12: "Perfurador de Terra",
  T_41_XYL_WS_BOT9: "Zumbi de Arremesso Mutante",
  T_41_XYL_WS_ITEM262: "Painel de Aço Congelado A",
  T_41_XYL_WS_ITEM263: "Contêiner Congelado A ",
  T_41_XYL_WS_ITEM264: "Contêiner Congelado de Suprimentos",
  T_41_XYL_WS_ITEM265: "Portão de Metal Congelado",
  T_41_XYL_WS_ITEM266: "Contêiner Congelado B ",
  T_41_XYL_WS_ITEM267: "Rocha Congelada A",
  T_41_XYL_WS_ITEM268: "Rocha Congelada B",
  T_41_XYL_WS_ITEM269: "Rocha Congelada C",
  T_41_XYL_WS_ITEM270: "Rocha Congelada D",
  T_41_XYL_WS_ITEM271: "Vagão de Trem Abandonado",
  T_41_XYL_WS_MODELMATCHNAME: "Competição de Criadores",
  T_41_XYL_WS_NAVMESH: "Malha de navegação dinâmica",
  T_41_XYL_WS_REFCUBE: "Cubo Refletor",
  T_41_XYL_WS_SNOWSKY: "Galáxia de Gelo",
  T_41_XYL_WS_TOYCUBE: "Parque de Cubos",
  T_42_CJ_F_B_VOCATIONAL: "Garota Arrojada (Pernas)",
  T_42_CJ_F_H_VOCATIONAL: "Garota Arrojada (Cabeça)",
  T_42_CJ_F_S_VOCATIONAL: "Garota Arrojada (Calçado)",
  T_42_CJ_F_T_VOCATIONAL: "Garota Arrojada (Torso)",
  T_42_CJ_HA_THUNDER_GOLD: "Pintura Facial Relâmpago",
  T_42_CJ_M_B_VOCATIONAL: "Garoto Arrojado (Pernas)",
  T_42_CJ_M_H_VOCATIONAL: "Garoto Arrojado (Cabeça)",
  T_42_CJ_M_S_VOCATIONAL: "Garoto Arrojado (Calçado)",
  T_42_CJ_M_T_VOCATIONAL: "Garoto Arrojado (Torso)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Parede de Gel - Tigrão",
  T_42_H_GRENADE_SMUDGE_N: "Granada - Luna",
  T_42_H_M1917_EMPIRE_N: "M1917 - Herdeiro da Coroa",
  T_42_HJ_WS_VFX_INK: "Tinta",
  T_42_JH_WS_BANMATCHMAKING: "Busca de partida proibida neste mapa",
  T_42_JH_WS_BANROOMCREATE: "Não é possível criar sala",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Remixando Hinos (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Parede de Fogo (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Manequim de Transporte (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nanoproteção (Sônia)",
  T_42_JH_WS_TAG1: "Confronto Nevado",
  T_42_JH_WS_TAG10: "Sempre no corre",
  T_42_JH_WS_TAG11: "Fúria na Pista",
  T_42_JH_WS_TAG12: "Corrida de carro",
  T_42_JH_WS_TAG13: "Excluir de Populares",
  T_42_JH_WS_TAG14: "Linha de Frente",
  T_42_JH_WS_TAG15: "Batalha de Zumbis",
  T_42_JH_WS_TAG16: "Lenda Memorável",
  T_42_JH_WS_TAG2: "Ilha do Rolê 1.0",
  T_42_JH_WS_TAG3: "Ilha do Rolê 2.0",
  T_42_JH_WS_TAG4: "Jogar junto",
  T_42_JH_WS_TAG5: "Resistir na Ruína",
  T_42_JH_WS_TAG6: "Festa Rapina",
  T_42_JH_WS_TAG7: "Festa Rapina",
  T_42_JH_WS_TAG8: "Luta no Forte 2.0",
  T_42_JH_WS_TAG9: "Caça-Recompensas",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Coloque um portal em qualquer lugar e se movimente rapidamente pelo mapa!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal",
  T_42_SJ_WS_ACCESSORIESITEM: "Equipar acessório",
  T_42_SJ_WS_AUTOPLAY: "Execução automática",
  T_42_SJ_WS_CLIMB: "Escalar",
  T_42_SJ_WS_CLOCK_EVENTS: "Compilação do evento",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Fazer contagem regressiva ou não",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Ciclos",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pausar evento",
  T_42_SJ_WS_CLOCK_START_EVENT: "Iniciar evento",
  T_42_SJ_WS_CLOCK_START_TIME: "Contagem regressiva para o início",
  T_42_SJ_WS_CLOCK_STATE: "Status de pausa de tempo",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Parar evento",
  T_42_SJ_WS_DAMRATIOHEAD: "Alteração do coeficiente de dano de acerto na cabeça",
  T_42_SJ_WS_DAMRATIOLIMB: "Alteração do coeficiente de dano a membros",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Coeficiente de redução de ano causado por explosão",
  T_42_SJ_WS_DRIVE: "Dirigir",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Exibir camadas",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Capacidade extra da mochila",
  T_42_SJ_WS_EXTRAHPRATIO: "Taxa de vida",
  T_42_SJ_WS_GETOFF_DRIVE: "Sair do veículo",
  T_42_SJ_WS_GETON_DRIVE: "Entrar no veículo",
  T_42_SJ_WS_KNIFEITEM: "Adaga",
  T_42_SJ_WS_KNIFEITEMPICK: "Adaga (encontrada no mapa)",
  T_42_SJ_WS_MARKBTNHUD: "O botão de marcação no HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "É possível habilitar ou desabilitar o botão de marcação",
  T_42_SJ_WS_MAXDISTANCE: "Distância máx.",
  T_42_SJ_WS_MAXDURARATIO: "Taxa máxima de durabilidade",
  T_42_SJ_WS_MICBTNHUD: "O botão de ligar e desligar o microfone no HUD",
  T_42_SJ_WS_MICBTNHUD_D: "É possível habilitar ou desabilitar o botão de microfone",
  T_42_SJ_WS_MINDISTANCE: "Distância mín.",
  T_42_SJ_WS_OPE_VEHICLE: "Operar veículo",
  T_42_SJ_WS_PLANE_DESC: "Malha básica que pode ter suas dimensões ajustadas livremente",
  T_42_SJ_WS_PLANENAME: "Plano básica",
  T_42_SJ_WS_PRIORITY: "Prioridade",
  T_42_SJ_WS_REPLACEPRIORITY: "Substituir prioridade",
  T_42_SJ_WS_SETBTNHUD: "O botão de configurações no HUD",
  T_42_SJ_WS_SETBTNHUD_D: "É possível habilitar ou desabilitar o botão de configurações",
  T_42_SJ_WS_SIGNALBTNHUD: "O botão de conexão de rede no HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "É possível habilitar ou desabilitar o botão de conexão de rede",
  T_42_SJ_WS_SPEAKERBTNHUD: "O botão de buzina no HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "É possível habilitar ou desabilitar o botão de buzina do veículo",
  T_42_SJ_WS_START_TIME: "Hora de início (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Carrega [FFB300]{0}[-] adicionais de munição, exceto Lança-granadas ([FFB300]{1}[-] Munição AR, [FFB300]{2}[-] Munição SMG, [FFB300]{3}[-] Munição de fuzil de precisão, [FFB300]{4}[-] Munição SG)",
  T_42_SW_SKILL_DESC_Bodyguard: "Aumenta a velocidade de recarga em [FFB300]{0}%[-]. Toda vez que o usuário da habilidade acertar um oponente, o alvo terá uma redução de [FFB300]{1}%[-] na cura que durará [FFB300]{3}s[-] (dedução máxima: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Torna-se imune de efeitos negativos (por exemplo, lentidão, marcação, bloqueio de habilidade) e ganha bônus de velocidade de movimento de [FFB300]{1}%[-] por [FFB300]{2}s[-]. Tempo de recarga: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "Após derrubar um oponente ou usar uma habilidade ativa, [FFB300]{0}%[-] do cartucho da arma recarrega automaticamente",
  T_42_SW_SKILL_NAME_Playboy: "Mimadinho",
  T_42_SY_BACKPACK_EMPIRE_N: "Mochila - Herdeiro da Coroa",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Traje de Pet: Agente Abaixo de Zero",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Moto - À Paisana",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Carro Esportivo - Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Carro Esportivo- Veneno Preto",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Carro Esportivo-  Veneno Vermelho",
  T_42_TYC_CST_LOSE_MONEY_1: "Quantidade de Grana do CS obtida após perder uma rodada",
  T_42_TYC_CST_LOSE_MONEY_2: "Quantidade de Grana do CS obtida após perder 2 rodadas seguidas",
  T_42_TYC_CST_LOSE_MONEY_3: "Quantidade de Grana do CS obtida após perder 3 rodadas seguidas",
  T_42_WH_ITEM_HEALUAV: "Mini drone de cura",
  T_42_WH_ITEM_HEALUAV_DESC: "Lança um mini drone que voa para frente e cura aliados dentro do raio",
  T_42_WH_ITEM_SKILLCARD: "Habilidade: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Use para ativar a habilidade ativa de [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Tipo de munição",
  T_42_XXJ_WS_AMMOTYPE_D: "Tipo de munição",
  T_42_XXJ_WS_ASSETCONFIGID: "ID do recurso",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Recurso",
  T_42_XXJ_WS_ATTACKSTATUS: "Estado do ataque",
  T_42_XXJ_WS_AUTOPLAY: "Execução automática",
  T_42_XXJ_WS_AUTOPLAY_D: "Execução automática",
  T_42_XXJ_WS_AVATARABLE: "Componente de aparência que pode ser modificado",
  T_42_XXJ_WS_AVATARABLE_D: "Alterar aparência de acordo com as partes",
  T_42_XXJ_WS_AVATARRESUUID: "UUID do recurso da aparência",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Converte a representação eixo-ângulo de uma rotação em quatérnios",
  T_42_XXJ_WS_B_D: "Valor da cor B",
  T_42_XXJ_WS_BASEVALUE_D: "Base do logaritmo",
  T_42_XXJ_WS_BEZIERCURVE: "Curva de Bézier",
  T_42_XXJ_WS_BEZIERCURVE_D: "A curva de Bézier",
  T_42_XXJ_WS_BOTDIFFICULTY: "Dificuldade do bot",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Método de combinação de elasticidade",
  T_42_XXJ_WS_BOUNCINES: "Elasticidade",
  T_42_XXJ_WS_BTREEID: "ID da árvore de comportamento",
  T_42_XXJ_WS_BTREEID_D: "O ID da árvore de comportamento",
  T_42_XXJ_WS_CANPURCHAS: "Possível de comprar ou não",
  T_42_XXJ_WS_CANPURCHAS_D: "Possível de comprar ou não",
  T_42_XXJ_WS_CLIMBSTATUS: "Comportamento de escalar",
  T_42_XXJ_WS_CLOCK: "Objeto temporizador",
  T_42_XXJ_WS_CLOCK_D: "Objeto temporizador",
  T_42_XXJ_WS_CLOCK_D1: "Temporizador",
  T_42_XXJ_WS_CONTAINER: "Contêiner",
  T_42_XXJ_WS_CONTROLPOINTS: "Pontos de controle",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Os pontos de controle",
  T_42_XXJ_WS_COROUTINEID: "Título da corrotina",
  T_42_XXJ_WS_COROUTINEID_D: "O ID da corrotina se refere ao título de uma corrotina específica. Permite que várias operações sejam feitas no título.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Cria uma relativa própria",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Cria uma relativa própria",
  T_42_XXJ_WS_CREATESOUND: "Criar efeito sonoro",
  T_42_XXJ_WS_CREATESOUND_D: "Executa o efeito sonoro designado. Se houver mais propriedades para definir, também é possível fazê-lo por meio da configuração das propriedades da respectiva entidade.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Completa missão personalizada",
  T_42_XXJ_WS_DAMAGELIST_D: "Lista de acréscimo de dano",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Proporção de dano do acerto na cabeça",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Multiplicador da redução do dano da explosão",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Material físico padrão",
  T_42_XXJ_WS_DEFAULTFIST_D: "Lista padrão",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Período de intervalo lógico",
  T_42_XXJ_WS_DELTATIME_D: "O intervalo entre as 2 atualizações de período de lógica do GS",
  T_42_XXJ_WS_DEPTH: "Camada",
  T_42_XXJ_WS_DEPTH_D: "Exibe camadas no ícone",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Lista de espólio no mapa desabilitado",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "A lista de itens que não são espólio de mapa",
  T_42_XXJ_WS_DRIVER: "Assento do motorista",
  T_42_XXJ_WS_DRIVINGSTATUS: "Dirigir",
  T_42_XXJ_WS_DURATION_D1: "A duração da contagem regressiva em segundos",
  T_42_XXJ_WS_DURATION_D2: "A duração em segundos",
  T_42_XXJ_WS_DURATION_D3: "A duração",
  T_42_XXJ_WS_DURATION_D4: "A duração da invulnerabilidade em segundos",
  T_42_XXJ_WS_DURATIONTIMES: "Duração",
  T_42_XXJ_WS_DURATIONTIMES_D: "A duração em segundos",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Fricção dinâmica",
  T_42_XXJ_WS_EASY: "Muito fácil",
  T_42_XXJ_WS_ENDTIMES: "Hora do fim",
  T_42_XXJ_WS_ENDTIMES_D: "A hora do fim no temporizador em segundos",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Limite de energia global",
  T_42_XXJ_WS_ENTITYVARNAME_D: "A entidade própria relativa",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equipar acessório",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Converte os Ângulos de Euler específicos em quatérnios",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponenciação",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Capacidade extra da mochila",
  T_42_XXJ_WS_FIST: "Punho",
  T_42_XXJ_WS_FONTTYPE: "Enum fonte",
  T_42_XXJ_WS_FONTTYPE_D: "O Enum fonte",
  T_42_XXJ_WS_FORCESYNCVALUE: "Estado da sincronização da força GS",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "O valor da sincronização da força",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "A informação de localização da sincronização da força GS",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Informação de localização da sincronização da força",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Uma entidade que pode formular propriedades",
  T_42_XXJ_WS_FORWARD_D: "Vetor de direção",
  T_42_XXJ_WS_FRICTION_COMBINE: "Método de combinação de fricção",
  T_42_XXJ_WS_FUNCPOINT: "Função indicador",
  T_42_XXJ_WS_FUNCPOINT_D: "Um indicador que aponta para uma instância de uma função. Usado para implementar funções virtuais ou delegar mecanismos.",
  T_42_XXJ_WS_GETMAPID_D: "Obtém o ID do mapa",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Sair do veículo",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Entrar no veículo (motorista)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Entrar no veículo (passageiro)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Buscar os dados de token do jogador de hoje",
  T_42_XXJ_WS_GRAVITY: "Gravidade global",
  T_42_XXJ_WS_HANDHELDITEM: "Segurado na mão atualmente",
  T_42_XXJ_WS_HANDHELDITEM_D: "Item atualmente segurado na mão",
  T_42_XXJ_WS_HARD: "Difícil",
  T_42_XXJ_WS_HASCOMPONENT_D: "Se o componente existe ou não",
  T_42_XXJ_WS_HEIGHTLIST_D: "Lista de acréscimo de altura",
  T_42_XXJ_WS_INDEXLIST_D: "Acessa a lista de índice da sentença",
  T_42_XXJ_WS_INSCENE: "No cenário",
  T_42_XXJ_WS_INSCENE_D: "No cenário",
  T_42_XXJ_WS_IS3D_D: "Se é uma música 3D ou não",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Contagem regressiva ou pausa do relógio",
  T_42_XXJ_WS_ISLOOP: "Ciclo ou não",
  T_42_XXJ_WS_ISLOOP_D: "O comando IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "Se é iniciado pelo começo ou não",
  T_42_XXJ_WS_ISSWITCH_D: "Quando verdadeiro, pode ser combinado com um movimento relativo. Quando falso, pode ser combinado com um movimento absoluto.",
  T_42_XXJ_WS_JEEP: "Jipe",
  T_42_XXJ_WS_JUMPSTATUS: "Estado de pulo",
  T_42_XXJ_WS_LEFTVALUE: "Valor à esquerda",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logaritmo",
  T_42_XXJ_WS_LOOPABLE: "Transformável em ciclo",
  T_42_XXJ_WS_LOOPABLE_D: "Transformável em ciclo",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Obtém todas as chaves do dicionário",
  T_42_XXJ_WS_MAPVALUE_D: "Dicionário alvo",
  T_42_XXJ_WS_MARKBTNHUD: "O botão de marcação no HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "A distância máxima",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "O botão de ligar e desligar o microfone no HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "A distância mínima",
  T_42_XXJ_WS_MISSIONID_D: "ID da missão",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progresso (não pode ser um número negativo)",
  T_42_XXJ_WS_MODERATE: "Moderado",
  T_42_XXJ_WS_MONSTERTRUCK: "Caminhão Monstro",
  T_42_XXJ_WS_MOTORBIKE: "Moto",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Estado de movimento",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplicação de dois quatérnios (representando sobreposição da rotação)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Descartado",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Habilitar perspectiva do jogador",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Habilitar perspectiva do jogador",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Tipo de arma",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Tipo de arma",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Priorizar a configuração do jogador",
  T_42_XXJ_WS_PARAMSARRAY: "Lista de parâmetros",
  T_42_XXJ_WS_PARAMSARRAY_D: "A lista de parâmetros é uma lista de parâmetros que fazem parte de uma saída Precisa ser correspondente ao número de %v na descrição do formato.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "A lista de parâmetros passados às funções personalizadas.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Máscara de visibilidade da parte 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Máscara de visibilidade da parte 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Máscara de visibilidade da parte 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Máscara de visibilidade da parte 4",
  T_42_XXJ_WS_PASSENGER1: "Assento do passageiro 1",
  T_42_XXJ_WS_PASSENGER2: "Assento do passageiro 2",
  T_42_XXJ_WS_PASSENGER3: "Assento do passageiro 3",
  T_42_XXJ_WS_PHYMAT: "Material físico",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entidade",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Movimento próprio relativo em cada quadro",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Movimento próprio relativo em todos os quadros",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Movimento próprio relativo",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "O movimento próprio relativo",
  T_42_XXJ_WS_PLAYER_D: "O jogador que precisa entrar no veículo",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entidade da sincronização da propriedade de comportamento de jogador",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "A entidade da sincronização da propriedade de comportamento de jogador",
  T_42_XXJ_WS_PRIORITY_D: "Prioridade",
  T_42_XXJ_WS_PROPID_D: "O ID da propriedade",
  T_42_XXJ_WS_QUATERNION: "Quaternário",
  T_42_XXJ_WS_QUATERNION_D: "Quaternário é um vetor de quadro dimensões utilizado para representar somente uma rotação",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Converte os quatérnios específicos em representação eixo-ângulo",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Converte os quatérnios específicos em Ângulos de Euler. Se os quatérnios não atenderem aos padrões, retorna (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "O número de vezes que foi executado. O padrão é 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reiniciar",
  T_42_XXJ_WS_RIGHTVALUE: "Valor à direita",
  T_42_XXJ_WS_RIGHTVALUE_D: "Poder",
  T_42_XXJ_WS_SEATTYPE: "Enum do assento do veículo",
  T_42_XXJ_WS_SEPSTR_D: "Sentença usada para separação",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Definir o dano de queda do jogador",
  T_42_XXJ_WS_SETTINGSBTNHUD: "O botão de configurações no HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Exibir localização",
  T_42_XXJ_WS_SHOWPOSITION_D: "Exibe a localização",
  T_42_XXJ_WS_SIGNALICOHUD: "O botão de conexão de rede no HUD",
  T_42_XXJ_WS_SIMPLE: "Fácil",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Interpolação de quatérnios esféricos de A a B",
  T_42_XXJ_WS_SOUNDENTITY_D: "A entidade efeito sonoro representa um efeito sonoro que está sendo executado",
  T_42_XXJ_WS_SPEAKERBTNHUD: "O botão de buzina no HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Usa uma sentença específica como delimitador para dividir a sentença em uma fatia",
  T_42_XXJ_WS_SPORTSCAR: "Carro esportivo",
  T_42_XXJ_WS_SPRINTSTATUS: "Estado de corrida",
  T_42_XXJ_WS_SRCVAL_D: "O valor fonte",
  T_42_XXJ_WS_STARTTICKCOUNT: "Momento em que o GS começa a marcar",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "Momento em que o GS começa a marcar",
  T_42_XXJ_WS_STARTTIME_D: "Hora de início",
  T_42_XXJ_WS_STARTTIME_D1: "Hora de início",
  T_42_XXJ_WS_STATE_D: "Um estado do jogador: ativo, derrubado ou abatido",
  T_42_XXJ_WS_STATE_D1: "Verificar se o efeito sonoro está sendo executado",
  T_42_XXJ_WS_STATIC_FRICTION: "Fricção estática",
  T_42_XXJ_WS_STRELEMS_D: "Sentença alvo definida",
  T_42_XXJ_WS_STRINGFINDAT_D: "Retorna a sentença combinada final de acordo com a lista de índice",
  T_42_XXJ_WS_STRINGJOIN_D: "Junta sentenças usando um identificador específico",
  T_42_XXJ_WS_STRINGLOWER_D: "Converte todos os caracteres na sentença em minúsculas",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove caracteres de espaço em branco das laterais da sentença",
  T_42_XXJ_WS_STRINGUPPER_D: "Converte todos os caracteres na sentença em maiúsculas",
  T_42_XXJ_WS_STYLE_D: "Como é executado",
  T_42_XXJ_WS_SUV: "Picape",
  T_42_XXJ_WS_SWITCH: "Trocar",
  T_42_XXJ_WS_SWITCH_D: "Quando verdadeiro, pode ser combinado com um movimento relativo. Quando falso, deve ser combinado com movimento absoluto. Caso contrário, as propriedades não terão efeito corretamente.",
  T_42_XXJ_WS_TARGETENTITY_D: "A entidade alvo",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Banner de pontuação da rodada da equipe",
  T_42_XXJ_WS_TEAMSEQ_D: "O número de série da equipe que corresponde à propriedade do número de série da entidade equipe",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Pontos de escudo temporários",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Pontos de escudo temporários",
  T_42_XXJ_WS_TEXT_D: "O texto original no qual será passado um filtro de profanidade",
  T_42_XXJ_WS_THREESTATESWITCH: "Switch de 3 fases",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Adaga (encontrada no mapa)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Adaga",
  T_42_XXJ_WS_TUKTUK: "Tuc Tuc",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Detalhes de partidas em equipe",
  T_42_XXJ_WS_UNIQUEID: "ID único",
  T_42_XXJ_WS_UNIQUEID_D: "ID único",
  T_42_XXJ_WS_VALUE_D: "O valor",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Vetor de direção aos ângulos de Euler",
  T_42_XXJ_WS_VEHICLEID: "ID do veículo",
  T_42_XXJ_WS_VEHICLESKINID: "ID da skin de veículo",
  T_42_XXJ_WS_VERYHARD: "Muito difícil",
  T_42_XXJ_WS_VOLUME_D: "O volume do som. O padrão é 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Tipo principal da arma",
  T_42_XXJ_WS_WORKSHOPCODE: "Código do mapa",
  T_42_XXJ_WS_WORKSHOPCODE_D: "O código do mapa qe corresponde a um dado na base de dados",
  T_42_XXJ_WS_WORLDPOSITION: "Coordenadas de mundo",
  T_42_XXJ_WS_WORLDPOSITION_D: "As coordenadas de mundo",
  T_42_XYL_WS_ITEM275: "Tanque de abastecimento",
  T_42_XYL_WS_ITEM276: "Saco de areia A",
  T_42_XYL_WS_ITEM277: "Saco de areia B",
  T_42_XYL_WS_ITEM278: "Saco de areia C",
  T_42_XYL_WS_ITEM279: "Saco de areia",
  T_42_XYL_WS_ITEM280: "Villa de deck duplo",
  T_42_XYL_WS_ITEM281: "Fábrica de armas",
  T_42_XYL_WS_ITEM282: "Muro de pedra A",
  T_42_XYL_WS_ITEM283: "Muro de pedra B",
  T_42_XYL_WS_ITEM284: "Muro de pedra C",
  T_42_XYL_WS_ITEM285: "Muro de pedra D",
  T_42_XYL_WS_ITEM286: "Caixote de Suprimentos Militares A",
  T_42_XYL_WS_ITEM287: "Moeda de bronze",
  T_42_XYL_WS_ITEM288: "Moeda de prata",
  T_42_XYL_WS_ITEM289: "Moeda de ouro",
  T_42_XYL_WS_ITEM290: "Diamante",
  T_42_XYL_WS_ITEM291: "Estilhaço de diamante",
  T_42_XYL_WS_ITEM292: "Rubi",
  T_42_XYL_WS_ITEM293: "Esmeralda",
  T_42_XYL_WS_ITEM294: "Safira",
  T_42_XYL_WS_ITEM295: "Placa de perigo",
  T_42_XYL_WS_ITEM297: "Ruína",
  T_42_XYL_WS_ITEM297TRUE: "Dispositivo de controle",
  T_42_XYL_WS_ITEM298: "Contêiner de suprimentos B",
  T_42_XYL_WS_ITEM299: "Pilha de neve",
  T_42_XYL_WS_ITEM300: "Parede tecnológica B",
  T_42_XYL_WS_ITEM301: "Parede tecnológica B",
  T_42_XYL_WS_ITEM302: "Rocha Congelada F",
  T_42_XYL_WS_ITEM303: "Rocha Congelada E",
  T_42_XYL_WS_ITEM304: "Plataforma tecnológica A",
  T_42_XYL_WS_ITEM305: "Escada tecnológica A",
  T_42_XYL_WS_ITEM306: "Lanterna de exploração A",
  T_42_XYL_WS_ITEM307: "Defletor de ruína A",
  T_42_XYL_WS_ITEM308: "Defletor de ruína B",
  T_42_XYL_WS_ITEM309: "Suporte de aço de ruína A",
  T_42_XYL_WS_ITEM310: "Rocha de ruína A",
  T_42_XYL_WS_ITEM311: "Rocha de ruína B",
  T_42_XYL_WS_ITEM312: "Rocha de ruína C",
  T_42_XYL_WS_ITEM313: "Lanterna A",
  T_42_XYL_WS_ITEM314: "Vergalhão de ruína A",
  T_42_XYL_WS_LOGICALOBJECT: "Lógica",
  T_42_XYL_WS_THEMEHIGHTECH: "Futurista",
  T_42_XYL_WS_THEMEICE: "Gélido",
  T_42_XYL_WS_THEMEMILITARY: "Militar",
  T_42_XYL_WS_THEMEOBJECTS: "Objetos Temáticos",
  T_42_XYL_WS_TIMERCONTINUE: "Incidente de continuar o temporizador",
  T_42_XYL_WS_TIMERCYCLE: "Contagem de ciclo",
  T_42_XYL_WS_TIMERDOWN: "Contagem regressiva",
  T_42_XYL_WS_TIMEREND: "Incidente de finalização do temporizador",
  T_42_XYL_WS_TIMEREVENT: "Incidente de temporizador personalizado",
  T_42_XYL_WS_TIMEREVENT1: "Controlar temporizador",
  T_42_XYL_WS_TIMEREVENT2: "Definir incidente de temporizador",
  T_42_XYL_WS_TIMERORDER: "Método do temporizador",
  T_42_XYL_WS_TIMERPAUSE: "Incidente de pausa do temporizador",
  T_42_XYL_WS_TIMERSTART1: "Hora de início do temporizador",
  T_42_XYL_WS_TIMERSTART2: "Incidente de início do temporizador",
  T_42_XYL_WS_TIMERUP: "Contagem progressiva",
  T_42_XYL_WS_TRIGGERTIME_MS: "Tempo de acionamento (em milissegundos)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Uma asa-delta que pode carregar vários jogadores.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Pontuação individual",
  T_42_ZZ_GUILDWAR_SCORE: "Pontuação",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforma-se em um arbusto por [FFB300]{1}s[-]. Tempo de recarga: [FFB300]{0}s[-]. A transformação acaba quando Wukong ataca ou é atacado. O tempo de recarga é zerado quando ele derruba um oponente.",
  T_43_B_SKILL_DESC_Nanoscientist: "Após receber dano letal, entra em um modo invulnerável e imóvel por [FFB300]{0}s[-]. Em seguida, recebe um [FFB300]escudo com {1} PV[-] e duração de [FFB300]{2}s[-]. O usuário da habilidade será eliminado quando o escudo desaparecer. Tempo de recarga: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Substitui PE por [FFB300]{0} de Energia Escarlate[-]. Consome [FFB300]{1} de Energia Escarlate[-] para ativar sua proteção, durante a qual você não recebe dano ou ataca oponentes. Ela absorve [FFB300]{4} PV[-] (ignorando Pontos de Escudo do oponente) de adversários no alcance de [FFB300]{3}m[-]. Duração de [FFB300]{2}s[-], durante a qual sua velocidade de movimento é reduzida em [FFB300]{6}%[-]. Tempo de recarga: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velô e Adrenalina (Rosto)",
  T_43_CJ_F_B_RACER: "Velô e Adrenalina (Pernas)",
  T_43_CJ_F_H_RACER: "Velô e Adrenalina (Cabeça)",
  T_43_CJ_F_HA_RACER: "Velô e Adrenalina (Pintura Facial)",
  T_43_CJ_F_S_RACER: "Velô e Adrenalina (Calçado)",
  T_43_CJ_F_T_RACER: "Velô e Adrenalina (Torso)",
  T_43_CJ_M_A_RACER: "Nitro e Adrenalina (Rosto)",
  T_43_CJ_M_B_MACHINERY: "TecnoTurquesa (Pernas)",
  T_43_CJ_M_B_RACER: "Nitro e Adrenalina (Pernas)",
  T_43_CJ_M_H_MACHINERY: "TecnoTurquesa (Cabeça)",
  T_43_CJ_M_H_RACER: "Nitro e Adrenalina (Cabeça)",
  T_43_CJ_M_HA_MACHINERY: "TecnoTurquesa (Pintura Facial)",
  T_43_CJ_M_S_MACHINERY: "TecnoTurquesa (Calçado)",
  T_43_CJ_M_S_RACER: "Nitro e Adrenalina (Calçado)",
  T_43_CJ_M_T_MACHINERY: "TecnoTurquesa (Torso)",
  T_43_CJ_M_T_RACER: "Nitro e Adrenalina (Torso)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Ataque das Mambas",
  T_43_HJ_WS_OPTION8: "Outras",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bambu",
  T_43_HJ_WS_TEXTURE_BEACH: "Praia",
  T_43_HJ_WS_TEXTURE_BRICK1: "Muro de Tijolos A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Muro de Tijolos B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Muro de Tijolos C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Piso de Concreto",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concreto",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Cristal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grama A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grama B",
  T_43_HJ_WS_TEXTURE_ICE: "Bloco de Gelo",
  T_43_HJ_WS_TEXTURE_IRON: "Piso de Metal",
  T_43_HJ_WS_TEXTURE_IRON2: "Contêiner",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Piso de Mármore",
  T_43_HJ_WS_TEXTURE_NONE: "Vazio",
  T_43_HJ_WS_TEXTURE_STONE: "Pedra",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Toalha de Mesa A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Toalha de Mesa B",
  T_43_HJ_WS_TEXTURE_WOOD: "Madeira",
  T_43_HJ_WS_TEXTURE_WOODEN: "Piso de Madeira A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Piso de Madeira B",
  T_43_JH_WS_MAPTAG1: "Iniciante-Amistoso",
  T_43_JH_WS_MAPTAG10: "Conteúdo novo entediante",
  T_43_JH_WS_MAPTAG11: "Sensação de recompensa fraca",
  T_43_JH_WS_MAPTAG12: "Recompensas desbalanceadas",
  T_43_JH_WS_MAPTAG13: "Sensação de progresso fraca",
  T_43_JH_WS_MAPTAG14: "Iniciante-Tóxico",
  T_43_JH_WS_MAPTAG15: "Tutorial confuso",
  T_43_JH_WS_MAPTAG16: "Ausência de tutoriais",
  T_43_JH_WS_MAPTAG17: "Jogadores desistindo demais",
  T_43_JH_WS_MAPTAG18: "Controles complicados",
  T_43_JH_WS_MAPTAG19: "Interface poluída",
  T_43_JH_WS_MAPTAG2: "Prefiro o novo conteúdo",
  T_43_JH_WS_MAPTAG20: "Design ruim de mapas",
  T_43_JH_WS_MAPTAG21: "Trocação é Emoção",
  T_43_JH_WS_MAPTAG22: "Ritmo acelerado",
  T_43_JH_WS_MAPTAG23: "Mundo aberto",
  T_43_JH_WS_MAPTAG24: "História farta",
  T_43_JH_WS_MAPTAG25: "Progresso",
  T_43_JH_WS_MAPTAG26: "Simula esportes",
  T_43_JH_WS_MAPTAG27: "Missão Coop.",
  T_43_JH_WS_MAPTAG28: "Interação social",
  T_43_JH_WS_MAPTAG29: "Várias Instâncias",
  T_43_JH_WS_MAPTAG3: "Jogadores ativos",
  T_43_JH_WS_MAPTAG30: "Exploração livre",
  T_43_JH_WS_MAPTAG31: "Desafio: Patentes",
  T_43_JH_WS_MAPTAG32: "Conquista",
  T_43_JH_WS_MAPTAG33: "Resgate dinheiro",
  T_43_JH_WS_MAPTAG4: "Mapas bem projetados",
  T_43_JH_WS_MAPTAG40: "Muitas recompensas",
  T_43_JH_WS_MAPTAG41: "Progressão satisfatória",
  T_43_JH_WS_MAPTAG42: "Ilha de Treinamento popular",
  T_43_JH_WS_MAPTAG43: "Torre Solo popular",
  T_43_JH_WS_MAPTAG44: "Zona de Guerra popular",
  T_43_JH_WS_MAPTAG5: "Travamentos",
  T_43_JH_WS_MAPTAG6: "Coop. difícil",
  T_43_JH_WS_MAPTAG7: "Bugs",
  T_43_JH_WS_MAPTAG8: "Poucas atualizações",
  T_43_JH_WS_MAPTAG9: "Eventos de partida entediantes",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Na Teia da Aranha (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Soltar itens",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Início do tempo de queda",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Soltar itens",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Reprodução Automática",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Está em posição central",
  T_43_SJ_WS_ANITRIGGER_CLIP: "ID de clip de animação",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Reprodução em Ciclo",
  T_43_SJ_WS_ANITRIGGER_NAME: "HUD de Gatilho da animação",
  T_43_SJ_WS_RESET_ROUND: "Redefinir por rodada",
  T_43_SJ_WS_START_DROPTIME: "Início do tempo de queda (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Gatilho da animação",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Traje de Pet: Samalandra Miau Miau",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Moto - Velocidade da Encarnação",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contém suprimentos essenciais de combate como munição e itens médicos",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Caixote de Suprimentos",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Cria um manequim com [FFB300]{1} de vida[-] que se move sozinho por [FFB300]{0}s[-]. Quando o manequim estiver dentro de [FFB300]{3}m[-], a habilidade deve ser utilizada para trocar a posição. É possível trocar uma vez dentro de [FFB300]{4}s[-], até [FFB300]{2}vez(es)[-] no total. O jogador que destruir o manequim ficará marcado por [FFB300]{5}s[-]. Tempo de recarga: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Dano da Habilidade Ativa",
  T_43_XXJ_WS_AIRDROP: "Dano do airdrop e dos zumbis",
  T_43_XXJ_WS_ALPHA: "Canal Alpha",
  T_43_XXJ_WS_ALPHA_D: "A transparência geral da HUG, em um intervalo de 0 a 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "ID do Controle de animação",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "O ID usado para descrever um ativo de Controle de animação",
  T_43_XXJ_WS_AUDIOID: "ID de Áudio",
  T_43_XXJ_WS_AUDIOID_D: "O ID usado para descrever um ativo de áudio",
  T_43_XXJ_WS_BACKGRCOLOR: "Cor de fundo",
  T_43_XXJ_WS_BACKGRCOLOR_D: "A cor da borda da barra de vida e do fundo desfocado",
  T_43_XXJ_WS_BURNING: "Em Chamas",
  T_43_XXJ_WS_CSVID: "ID do CSV",
  T_43_XXJ_WS_CSVID_D: "O ID usado para descrever um ativo de tabela de configuração",
  T_43_XXJ_WS_CURRENTHP: "Vida atual",
  T_43_XXJ_WS_CURRENTHP_D: "Valor atual da Vida",
  T_43_XXJ_WS_DAMAGEMAKER_D: "A entidade do jogo que causa dano",
  T_43_XXJ_WS_DAMAGEZONE: "Zona de Dano",
  T_43_XXJ_WS_DEFAULT: "Padrão",
  T_43_XXJ_WS_DEFAULT_D: "Padrão",
  T_43_XXJ_WS_EFFECTID: "ID do efeito",
  T_43_XXJ_WS_EFFECTID_D: "O ID usado para descrever um ativo de efeito especial",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Uma entidade que pode lutar (ex.: lançar ataques, ser atacada ou ser eliminada)",
  T_43_XXJ_WS_FOLLOWTARGET: "Seguir alvo",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Deve seguir uma entidade com componente de Transformação",
  T_43_XXJ_WS_GAINHPCOLOR: "Cor da Vida ganha",
  T_43_XXJ_WS_GAINHPCOLOR_D: "A porção que aumenta da Vida será exibida nesta cor por um curto período",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Não tem dano de queda",
  T_43_XXJ_WS_ISOPENTWEEN: "É um tween aberto",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Habilite isto para mostrar mudanças de Vida em cores diferentes",
  T_43_XXJ_WS_KNOCKDOWN_D1: "O jogador está em estado derrubado",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Configurações para a resposta ao estado de derrubado quando eliminado",
  T_43_XXJ_WS_KNOCKDOWN_D3: "O tipo de origem de ressurgimento. Um jogador pode ser revivido enquanto derrubado.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Estado de Derrubado",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Tipo de Estado de Derrubado",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "A resposta ao estado de derrubado: manter lógica padrão, pular o estado de derrubado ou forçar derrubada.",
  T_43_XXJ_WS_LEVEL: "Nível",
  T_43_XXJ_WS_LEVEL_D: "Nível",
  T_43_XXJ_WS_LEVEL_D1: "Nível do zumbi atual",
  T_43_XXJ_WS_LINESPACING: "Espaçamento da linha",
  T_43_XXJ_WS_LINESPACING_D: "Não é exibido quando a Vida segmentada entre dois divisores for ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Cor da Vida perdida",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "A porção que reduz da Vida será exibida nesta cor por um curto período",
  T_43_XXJ_WS_MAINCOLOR: "Cor principal",
  T_43_XXJ_WS_MAINCOLOR_D: "A cor da Vida, níveis e destaques",
  T_43_XXJ_WS_MINISENTRY: "Dano da torreta",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "O enumerador para os tipos de alvos que uma torreta pode atacar",
  T_43_XXJ_WS_MISSILEEXPLODE: "Explosão de Míssil",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Deve derrubar",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Derrubada forçada",
  T_43_XXJ_WS_OFFSET: "Compensação",
  T_43_XXJ_WS_OFFSET_D: "Compensação relativa ao alvo seguido",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Explosão de Barril de Óleo",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Acionado somente quando o controlador iniciar movimento",
  T_43_XXJ_WS_PLAYER_D: "A entidade do jogador na partida. Cada jogador tem uma.",
  T_43_XXJ_WS_PLAYERHEADHUD: "HUD da Cabeça do Jogador",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "As informações exibidas sobre a cabeça do jogador",
  T_43_XXJ_WS_PLAYERNAME: "Nome do jogador",
  T_43_XXJ_WS_PLAYERNAME_D: "Exibe o nome do dono da barra de vida atual",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Jogador ou Veículo",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "O apelido para o tipo de entidade do jogador/veículo",
  T_43_XXJ_WS_SCALE: "Escala",
  T_43_XXJ_WS_SCALE_D: "Determina o tamanho geral da HUD, com a fonte ajustada para tal",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Exibir número do dano",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "Verdadeiro por padrão. Exibe o número do dano.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Pular Derrubada",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Pula o estado de derrubado, eliminando instantaneamente",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "É pular animação escalonada",
  T_43_XXJ_WS_TEAM_D: "(Deprecado. Use o ID da equipe.)",
  T_43_XXJ_WS_TERRAIN: "Terreno",
  T_43_XXJ_WS_TERRAIN_D: "Um componente de terreno do qual atributos não podem ser modificados. Usado apenas para funções de teste.",
  T_43_XXJ_WS_TOTALHP: "Vida total",
  T_43_XXJ_WS_TOTALHP_D: "Valor da Vida total",
  T_43_XXJ_WS_TWEENENTITY: "Entidade tween",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Explosão de Veículo",
  T_43_XXJ_WS_WIDTH: "Largura",
  T_43_XXJ_WS_WIDTH_D: "A largura da barra de vida exibida",
  T_43_XXJ_WS_ZOMBIE: "Zumbi",
  T_43_XYL_WS_DROIDFIST: "Punho (Cizânia Androide)",
  T_43_XYL_WS_DROIDFLAME: "Lança-chamas (Cizânia Androide)",
  T_43_XYL_WS_JAPANESE: "Estilo Japonês",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Registros de partidas personalizadas. Usados para análise da experiência.",
  T_43_YU_WS_AIRDROPSTATE: "AirDropState",
  T_43_YU_WS_AIRDROPSTATE_D: "Estado do airdrop (1: pronto; 2: em queda; 3: aterrissou)",
  T_43_YU_WS_ANIMATIONCLIPID: "AnimationClipID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Personalizar ID de clip de animação",
  T_43_YU_WS_ASKBUYTARGET: "AskBuyTarget",
  T_43_YU_WS_ASKBUYTARGET_D: "Especifica o alvo e envia uma solicitação de compra",
  T_43_YU_WS_ASKEDLIST: "Lista de Solicitações",
  T_43_YU_WS_ASKEDLIST_D: "Lista de itens solicitados",
  T_43_YU_WS_BACKGROUNDCOLOR1: "BackgroundColor1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "Cor de fundo superior",
  T_43_YU_WS_BACKGROUNDCOLOR2: "BackgroundColor2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "Cor de fundo inferior",
  T_43_YU_WS_BATCHCOMBINERENDER: "BatchCombineRender",
  T_43_YU_WS_BINDMONEYENTITYLIST: "BindMoneyEntityList",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "Lista de entidades de moeda vinculadas",
  T_43_YU_WS_BINDWALLETENTITYID: "BindWalletEntityID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "ID da entidade de carteira vinculada",
  T_43_YU_WS_CENTEROFFSET: "CenterOffset",
  T_43_YU_WS_CENTEROFFSET_D: "O valor compensado para a capsula de colisão",
  T_43_YU_WS_COLLECTIONID: "ID da coleção",
  T_43_YU_WS_COLLECTIONID_D: "O ID da coleção usado para informação de ativos dela",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Crie um Airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Cria um número de dano",
  T_43_YU_WS_CROSSPLATFORM_D: "Quando selecionado, envia ao cliente se chamado pelo servidor e vice-versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CSRoundResultHud",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Resultados exibidos ao fim de cada partida",
  T_43_YU_WS_CURRENTEMOTECLIP: "CurrentEmoteClip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID do clip de emote atual",
  T_43_YU_WS_DAMAGE_D: "O dano de fora da zona",
  T_43_YU_WS_DICTIONARY: "Dicionário",
  T_43_YU_WS_DIRECTIONRULERHUD: "CompassHud",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "Bússola no topo",
  T_43_YU_WS_DOTWEEN_D: "Realizar ou não animações em tween",
  T_43_YU_WS_DROPITEMS_D: "Itens no Airdrop",
  T_43_YU_WS_DURATION: "Duração",
  T_43_YU_WS_ENERGY: "Energia",
  T_43_YU_WS_ENERGY_D: "Valor de modificação de PE",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Agachar",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Agachar",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Correr",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Ficar em pé",
  T_43_YU_WS_EVENTID: "EventID",
  T_43_YU_WS_EVENTID_D: "Representa um evento",
  T_43_YU_WS_FACTION: "Gangue",
  T_43_YU_WS_FACTION_D: "Entidade da gangue",
  T_43_YU_WS_FACTION_D1: "Pede ajuda de compra à gangue",
  T_43_YU_WS_FINALRADIUS_D: "O raio final da zona segura",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Kit de primeiros socorros",
  T_43_YU_WS_FIRSTPERSONMODEL: "FirstPersonModel",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "Câmera de visão em primeira pessoa",
  T_43_YU_WS_FONTCOLOR_D: "Cor da fonte",
  T_43_YU_WS_FONTSIZE_D: "Tamanho da fonte",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Proíbe solicitações de compra da interface",
  T_43_YU_WS_FREEZINGTIME: "FreezingTime",
  T_43_YU_WS_FREEZINGTIME_D: "Duração em que o alvo atingido permanece congelado",
  T_43_YU_WS_GRAVITY: "Gravidade",
  T_43_YU_WS_GRAVITY_D: "Aceleração gravitacional. Afeta apenas o controle do jogador.",
  T_43_YU_WS_HANDCATAPULT: "LaunchPad",
  T_43_YU_WS_HANDCATAPULT_D: "Lançador",
  T_43_YU_WS_HEALTH: "Vida",
  T_43_YU_WS_HEALTH_D: "Valor de recuperação da durabilidade da armadura",
  T_43_YU_WS_HEIGHT: "Altura",
  T_43_YU_WS_HELPEDPLAYER_D: "Jogador que recebeu ajuda",
  T_43_YU_WS_HELPPLAYER_D: "Jogador que ajuda com a compra",
  T_43_YU_WS_HORIZONTALMAXANGLE: "HorizontalMaxAngle",
  T_43_YU_WS_HORIZONTALMINANGLE: "HorizontalMinAngle",
  T_43_YU_WS_HUDTOGGLE: "HudToggle",
  T_43_YU_WS_HUDTOGGLE_D: "A entidade HudToggle que os jogadores podem editar no editor de HUD",
  T_43_YU_WS_INHALER: "Inalador",
  T_43_YU_WS_INHALER_D: "Inal",
  T_43_YU_WS_INITRADIUS_D: "O raio inicial da zona segura",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "Número inteiro de 64-bit com sinal",
  T_43_YU_WS_ISAPPLYSHADOW: "IsApplyShadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "IsBottomColliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "IsCurrentEmoteLoop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Ativar ou não o ciclo da animação atual do emote",
  T_43_YU_WS_ISSIDECOLLIDING: "IsSideColliding",
  T_43_YU_WS_ISSLIDING: "IsSliding",
  T_43_YU_WS_ISTOPCOLLIDING: "IsTopColliding",
  T_43_YU_WS_ITEM331: "Dispositivo Futurista A",
  T_43_YU_WS_ITEM332: "Rocha Brilhante A",
  T_43_YU_WS_ITEM333: "Tela Futurista A",
  T_43_YU_WS_ITEM334: "Contêiner Futurista A",
  T_43_YU_WS_ITEM335: "Contêiner Futurista A",
  T_43_YU_WS_ITEM336: "Sofá de Pedra A",
  T_43_YU_WS_ITEM337: "Interruptor Futurista A",
  T_43_YU_WS_ITEM338: "Cano Futurista A",
  T_43_YU_WS_ITEM339: "Plataforma de Metal A",
  T_43_YU_WS_ITEM340: "Mesa Futurista A",
  T_43_YU_WS_ITEM341: "Mesa Futurista B",
  T_43_YU_WS_ITEM342: "Mesa Futurista C",
  T_43_YU_WS_ITEM343: "Computador Futurista A",
  T_43_YU_WS_ITEM344: "Pedra A",
  T_43_YU_WS_ITEM345: "Pedra B",
  T_43_YU_WS_ITEM346: "Pedra C",
  T_43_YU_WS_ITEM347: "Pedra D",
  T_43_YU_WS_ITEM348: "Pedra E",
  T_43_YU_WS_ITEM349: "Pedra F",
  T_43_YU_WS_ITEM350: "Pedra G",
  T_43_YU_WS_ITEM351: "Cortina Estilo Japonês A",
  T_43_YU_WS_ITEM352: "Cortina Estilo Japonês B",
  T_43_YU_WS_ITEM353: "Cortina Estilo Japonês C",
  T_43_YU_WS_ITEM354: "Escadas Estilo Japonês A",
  T_43_YU_WS_ITEM355: "Cerca Estilo Japonês A",
  T_43_YU_WS_ITEM356: "Cerca Estilo Japonês B",
  T_43_YU_WS_ITEM357: "Cerca Estilo Japonês C",
  T_43_YU_WS_ITEM358: "Plataforma Estilo Japonês A",
  T_43_YU_WS_ITEM359: "Muro Estilo Japonês B",
  T_43_YU_WS_ITEM360: "Portão Estilo Japonês B",
  T_43_YU_WS_ITEM361: "Parede Futurista D",
  T_43_YU_WS_ITEM362: "Parede Futurista B",
  T_43_YU_WS_ITEM363: "Planta Base Angular Futurista",
  T_43_YU_WS_LEFTCOLOR: "LeftColor",
  T_43_YU_WS_LEFTCOLOR_D: "Cor do lado esquerdo",
  T_43_YU_WS_LEFTPLAYERARRAY: "LeftPlayerArray",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "Matriz do jogador esquerdo",
  T_43_YU_WS_LEFTSCORE: "LeftScore",
  T_43_YU_WS_LEFTSCORE_D: "Placar do lado esquerdo",
  T_43_YU_WS_LEFTSCOREAFTER: "LeftScoreAfter",
  T_43_YU_WS_LEFTSCOREAFTER_D: "Placar final do lado esquerdo. Usado em animações de transição de placar.",
  T_43_YU_WS_LEVELOBJECTID: "LevelObjectID",
  T_43_YU_WS_LEVELOBJECTID_D: "Descreve o tipo de objeto. Requer interpretação através da tabela de configuração SceneEditPrefab antes de carregar.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordenadas no sistema local de coordenadas",
  T_43_YU_WS_LOCALPOSITION_D1: "A posição relativa",
  T_43_YU_WS_LOCALPOSITION_D2: "Posição relativa à âncora inferior direita",
  T_43_YU_WS_LOCALPOSITION_D3: "Posição relativa à âncora",
  T_43_YU_WS_LOCALROTATION_D: "Ângulos de rotação no sistema de coordenadas local (X, Y e Z)",
  T_43_YU_WS_LOCALROTATIONQ_D: "O quatérnio no sistema de coordenadas local",
  T_43_YU_WS_LOCALSCALE_D: "O tamanho em escala no sistema de coordenadas do mundo",
  T_43_YU_WS_MASS: "Massa",
  T_43_YU_WS_MATERIALS: "Materiais",
  T_43_YU_WS_MATERIALS_D: "A lista de materiais usadas na renderização",
  T_43_YU_WS_MAXSPEED: "MaxSpeed",
  T_43_YU_WS_MAXSPEED_D: "Não será gerada mais potência depois que a velocidade máxima for alcançada, mas o veículo ainda pode ir além do limite (ex.: acelerando em um declive)",
  T_43_YU_WS_MESHID: "MeshID",
  T_43_YU_WS_MESHID_D: "Descreve o tipo de malha",
  T_43_YU_WS_MESHID1: "MeshID",
  T_43_YU_WS_MESHID1_D: "A malha a ser usada para renderização",
  T_43_YU_WS_MINMOVEDISTANCE: "MinMoveDistance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movimentações com distância mais curta que este valor não serão executados. Recomenda-se defini-lo em 0 a menos que haja algum requerimento especial.",
  T_43_YU_WS_MODULE_AI: "IA",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animação",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Atributos básicos",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Árvore de comportamento",
  T_43_YU_WS_MODULE_BUFF: "Efeito",
  T_43_YU_WS_MODULE_CAMERA: "Câmera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Canal de chat",
  T_43_YU_WS_MODULE_CHECKPOINT: "Ponto de Checagem",
  T_43_YU_WS_MODULE_COLLECTION: "Coleção",
  T_43_YU_WS_MODULE_COMBAT: "Combate",
  T_43_YU_WS_MODULE_COMPONENT: "Componente",
  T_43_YU_WS_MODULE_CONVERT: "Converter",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Personalizar parâmetros da sala",
  T_43_YU_WS_MODULE_DATABASE: "Armazenamento de dados",
  T_43_YU_WS_MODULE_DYEING: "Tingindo",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Malha de Navegação Dinâmica",
  T_43_YU_WS_MODULE_ECONOMY: "Economia",
  T_43_YU_WS_MODULE_FF_PLATFORM: "Plataforma FF",
  T_43_YU_WS_MODULE_FOOTBALL: "Futebol",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Modo frequência de quadros",
  T_43_YU_WS_MODULE_GAMERESULT: "Resultados da partida",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Scripts globais",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK e Trapaças",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Sistema de entrada",
  T_43_YU_WS_MODULE_ITEMS: "Itens",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Nível do objeto",
  T_43_YU_WS_MODULE_LIST: "Lista",
  T_43_YU_WS_MODULE_MAP: "Mapa",
  T_43_YU_WS_MODULE_MATCHING: "Partida",
  T_43_YU_WS_MODULE_MATH: "Matemática",
  T_43_YU_WS_MODULE_MECHANISM: "Parâmetros do Mecanismo",
  T_43_YU_WS_MODULE_MINIMAP: "MiniMapa",
  T_43_YU_WS_MODULE_MORPH: "Morfose",
  T_43_YU_WS_MODULE_OTHER: "Outras",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Física",
  T_43_YU_WS_MODULE_PLAYABLE: "Jogável",
  T_43_YU_WS_MODULE_PLAYER: "Jogador",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Scripts do jogador",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Personagem predefinido",
  T_43_YU_WS_MODULE_PROFILE: "Perfil",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Fórmula da propriedade",
  T_43_YU_WS_MODULE_SAFEZONE: "Zona Segura",
  T_43_YU_WS_MODULE_SCENE: "Cena",
  T_43_YU_WS_MODULE_SKILL: "Habilidade",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Scripts estáticos",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Denúncia",
  T_43_YU_WS_MODULE_STDLIBRARY: "Biblioteca Padrão",
  T_43_YU_WS_MODULE_STRINGS: "Textos",
  T_43_YU_WS_MODULE_TEAM: "Equipe",
  T_43_YU_WS_MODULE_WORKFLOW: "Fluxo de trabalho",
  T_43_YU_WS_MONEYICON: "MoneyIcon",
  T_43_YU_WS_MONEYICON_D: "Ícone de dinheiro",
  T_43_YU_WS_MONEYICONCOLOR: "MoneyIconColor",
  T_43_YU_WS_MONEYICONCOLOR_D: "Cor do ícone de dinheiro",
  T_43_YU_WS_MOVESAFEZONE_D: "Movimentação suave da zona segura a partir de sua posição inicial até a final. Jogadores fora da zona receberão dano.",
  T_43_YU_WS_NEWVECTOR2: "NewVector2",
  T_43_YU_WS_NEWVECTOR2_D: "Faz surgir um novo vetor 2D",
  T_43_YU_WS_OFFSET_D: "Compensação da posição do mundo relativa à entidade alvo",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Quando a solicitação de compra do jogador é atendida",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Quando um jogador pede por ajuda com uma compra na loja",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Gatilho quando Alternar Estado do Componente mudar",
  T_43_YU_WS_OPENSTATE: "OpenState",
  T_43_YU_WS_OPENSTATE_D: "É mostrado quando definido para 'true' e desaparece quando não estiver",
  T_43_YU_WS_PACEMAKER: "Novo Futuro",
  T_43_YU_WS_PACEMAKER_D: "Novo Futuro",
  T_43_YU_WS_PARAMS_D: "A lista de parâmetros",
  T_43_YU_WS_PARENT_D: "O ID da entidade gravado durante a serialização",
  T_43_YU_WS_PHYSICALCCT: "CCT Físico",
  T_43_YU_WS_PHYSICALCCT_D: "O controle do jogador com efeitos físicos",
  T_43_YU_WS_PLAYER_D: "O jogador comprador",
  T_43_YU_WS_PLAYERDATAID: "PlayerDataID",
  T_43_YU_WS_PLAYERDATAID_D: "ID de ativo do personagem personalizado",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "PlayerPhysXPoseType",
  T_43_YU_WS_POSITION: "Posição",
  T_43_YU_WS_POSITION_D: "Coordenadas no sistema de coordenadas do mundo",
  T_43_YU_WS_POSITION_D1: "Coordenadas no sistema de coordenadas do mundo. São efetivas apenas para música 3D.",
  T_43_YU_WS_PRESSEDSPRITE: "PressedSprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "O sprite pressionado",
  T_43_YU_WS_PRESSEDSPRITETYPE: "PressedSpriteType",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "O tipo do sprite pressionado",
  T_43_YU_WS_PRETIME: "Pré-tempo",
  T_43_YU_WS_RADIUS: "Raio",
  T_43_YU_WS_RANDOMRANGE_D: "Corrige a posição definida com base em um intervalo aleatório",
  T_43_YU_WS_REQUESTPURCHASETYPE: "RequestPurchaseType",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Solicitação de compra na loja",
  T_43_YU_WS_REQUESTTYPE: "RequestType",
  T_43_YU_WS_REQUESTTYPE_D: "O tipo de alvo solicitado pelo jogador atual do HUD",
  T_43_YU_WS_RESPLAYERUUID: "Tipo de jogador predefinido",
  T_43_YU_WS_RESPLAYERUUID_D: "ID de ativo do jogador",
  T_43_YU_WS_RESUUID: "ResUUID",
  T_43_YU_WS_RESUUID_D: "Especifica o UUID da remessa de ativos a ser renderizada",
  T_43_YU_WS_RIGHTCOLOR: "RightColor",
  T_43_YU_WS_RIGHTCOLOR_D: "Cor do lado direito",
  T_43_YU_WS_RIGHTPLAYERARRAY: "RightPlayerArray",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "Matriz do jogador direito",
  T_43_YU_WS_RIGHTSCORE: "RightScore",
  T_43_YU_WS_RIGHTSCORE_D: "Placar do lado direito",
  T_43_YU_WS_RIGHTSCOREAFTER: "RightScoreAfter",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "Placar final do lado direito. Usado em animações de transição de placar.",
  T_43_YU_WS_ROTATIONQ_D: "O quatérnio no sistema de coordenadas do mundo",
  T_43_YU_WS_ROUNDINFOHUD: "RoundInfoHud",
  T_43_YU_WS_ROUNDINFOHUD_D: "Informações exibidas no início de uma rodada",
  T_43_YU_WS_SELECTEDCOLOR: "Cor Selecionada",
  T_43_YU_WS_SELECTEDCOLOR_D: "A cor selecionada do sprite",
  T_43_YU_WS_SELECTEDSPRITE: "SelectedSprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "Sprite selecionado",
  T_43_YU_WS_SELECTEDTYPE: "SelectedType",
  T_43_YU_WS_SELECTEDTYPE_D: "Tipo do sprite selecionado",
  T_43_YU_WS_SHADOWCOLOR: "ShadowColor",
  T_43_YU_WS_SHADOWOFFSET: "ShadowOffset",
  T_43_YU_WS_SHOWTAG: "ShowMark",
  T_43_YU_WS_SHOWTAG_D: "Exibir marcas da equipe/gangue",
  T_43_YU_WS_SHRINKDURATION_D: "Duração do encolhimento da zona segura",
  T_43_YU_WS_SIMPLERENDER_D: "O componente de renderização acoplada usado para renderizar com modelos inclusos",
  T_43_YU_WS_SKINWIDTH: "SkinWidth",
  T_43_YU_WS_SKINWIDTH_D: "A profundidade de penetração na cápsula para impedir que o personagem fique preso ou trêmulo",
  T_43_YU_WS_SLOPELIMIT: "Limite de inclinação",
  T_43_YU_WS_SLOPELIMIT_D: "Objetos posicionados em uma inclinação com ângulo maior que este vão escorregar para baixo",
  T_43_YU_WS_SPEED: "Velocidade",
  T_43_YU_WS_STARTDROPTIME_D: "O tempo de chegada do airdrop em milissegundos",
  T_43_YU_WS_STARTPOS_D: "Posição inicial da zona segura",
  T_43_YU_WS_STATICICONCOLORS: "Cores do ícone estático",
  T_43_YU_WS_STATICICONCOLORS_D: "Cores do ícone mostrado na régua",
  T_43_YU_WS_STATICICONS: "StaticIcons",
  T_43_YU_WS_STATICICONS_D: "Ícones exibidos nas réguas",
  T_43_YU_WS_STEPOFFSET: "StepOffset",
  T_43_YU_WS_STEPOFFSET_D: "Somente obstáculos excedendo esta altura terão um efeito de bloqueio",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "Legenda",
  T_43_YU_WS_TARGET: "Alvo",
  T_43_YU_WS_TARGET_D: "Entidade alvo para o número de dano exibido",
  T_43_YU_WS_TARGETICONCOLORS: "TargetIconColors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Cores do ícone exibidas pelo alvo marcado",
  T_43_YU_WS_TARGETICONS: "TargetIcons",
  T_43_YU_WS_TARGETICONS_D: "Ícones exibidos pelos alvos marcados",
  T_43_YU_WS_TARGETPOS_D: "Posição final da zona segura",
  T_43_YU_WS_TEAM: "Equipe",
  T_43_YU_WS_TEAM_D: "Entidade equipe da partida. Cada equipe tem uma entidade.",
  T_43_YU_WS_TEAM_D1: "Peça ajuda com a compra ao seu time",
  T_43_YU_WS_TIMEOFSTAY_D: "Duração da exibição em milissegundos",
  T_43_YU_WS_TITLE: "Título",
  T_43_YU_WS_TITLE_D: "Título principal",
  T_43_YU_WS_TRANSFORM_D: "Rotação, escala e registro parente-filho",
  T_43_YU_WS_UNSELECTEDCOLOR: "Cor Não Selecionada",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "A cor não selecionada do sprite",
  T_43_YU_WS_UNSELECTEDSPRITE: "UnselectedSprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Sprite desselecionado",
  T_43_YU_WS_UNSELECTEDTYPE: "UnselectedType",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Tipo do sprite desselecionado",
  T_43_YU_WS_USEPHYSICALCCT: "Usar CCT Físico",
  T_43_YU_WS_VALUE_D: "O conteúdo exibido",
  T_43_YU_WS_VECTOR2ADD: "Vector2Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2GetX",
  T_43_YU_WS_VECTOR2GETY: "Vector2GetY",
  T_43_YU_WS_VECTOR2SCALE: "Vector2Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2SetX",
  T_43_YU_WS_VECTOR2SETY: "Vector2SetY",
  T_43_YU_WS_VECTOR2SUB: "Vector2Sub",
  T_43_YU_WS_VELOCITY: "Velocidade",
  T_43_YU_WS_VERTICALMAXANGLE: "VerticalMaxAngle",
  T_43_YU_WS_VERTICALMINANGLE: "VerticalMinAngle",
  T_43_YU_WS_VISIBILITY_D: "Indica se a visibilidade pode ser ajustada",
  T_43_YU_WS_VISIBLE_D: "O ajuste de visibilidade. Se definido como invisível, o cliente para de renderizar o alvo",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "Y",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Parede Futurista A",
  T_43_ZY_WS_ITEM320: "Parede Futurista C",
  T_43_ZY_WS_ITEM321: "Janela Futurista",
  T_43_ZY_WS_ITEM322: "Porta Futurista",
  T_43_ZY_WS_ITEM323: "Telhado Angular Futurista",
  T_43_ZY_WS_ITEM324: "Telhado Circular Futurista",
  T_43_ZY_WS_ITEM325: "Planta Base Futurista",
  T_43_ZY_WS_ITEM326: "Planta Base Circular Futurista",
  T_43_ZY_WS_ITEM327: "Escada Futurista",
  T_43_ZY_WS_ITEM328: "Decoração Futurista A",
  T_43_ZY_WS_ITEM329: "Edifício Futurista A",
  T_43_ZY_WS_ITEM330: "Edifício Futurista B",
  T_44_CJ_M_B_SPORT_TH: "Uniforme de Academia (Pernas)",
  T_44_CJ_M_H_SPORT_TH: "Uniforme de Academia (Cabeça)",
  T_44_CJ_M_S_SPORT_TH: "Uniforme de Academia (Calçado)",
  T_44_CJ_M_T_SPORT_TH: "Uniforme de Academia (Torso)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Assalto Espiritual",
  T_44_H_USP45_CARNIVORE_N: "USP - Mordida Venenosa",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Moto - Cicatrizes do Céu",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Forçar início com mínimo de jogadores",
  T_44_JH_WS_HALFWAYKEY1: "Priorizar início com equipe completa",
  T_44_PD_PVE_DRAGON_NAME: "Mecadrako",
  T_44_QL_GRENADE_DRAGON: "Dragão Congelante",
  T_44_QL_GRENADE_DRAGON_DES: "Uma versão melhorada da Bomba Congelante que detona três vezes consecutivas ao impacto",
  T_44_QL_JUMPSHOESX: "Passos do Dragão",
  T_44_QL_JUMPSHOESX_DES: "Um par de tênis especiais que permitem correr no ar durante um pulo duplo",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Tempo de Fechamento da Zona Segura",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Momento em que a Zona Segura desaparece. Se o Tempo de Fechamento da Zona Segura for menor que o seu Tempo de Início, nenhuma Zona Segura é gerada.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Cor da Zona Segura",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Intervalo de dano",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Intervalo de dano",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Valor do Dano",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "Dano causado fora da zona, numa só instância",
  T_44_SJ_WS_SAFEZONE_DESC: "Um objeto posicionável fora da zona",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Raio Final de Fora da Zona",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Raio final da área de fora da zona",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Lista de Jogadores na Zona Segura",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Obter lista de jogadores na Zona Segura",
  T_44_SJ_WS_SAFEZONE_NAME: "A área de fora da zona",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Duração do encolhimento (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Tempo que leva pra zona encolher",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Raio Inicial de Fora da Zona",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Raio inicial da área de fora da zona",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Tempo de início do encolhimento",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Tempo de início do encolhimento",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Tempo de Início da Zona Segura",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Tempo de surgimento da Zona Segura em cada rodada. O padrão é 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Alfa ativado",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Alfa ativado",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Botão de habilidade ativa HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Adiciona um componente a uma entidade. Suporta somente componentes personalizados. (Um componente não será adicionado de novo se já existir.)",
  T_44_XXJ_WS_ALLMEMBERS: "Todos os membros",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Permitir pressionamento fora",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Permite acionamento de fora da área designada",
  T_44_XXJ_WS_ARROWIMAGE: "Imagem da seta",
  T_44_XXJ_WS_ARROWIMAGE_D: "Imagem da seta",
  T_44_XXJ_WS_ARROWOFFSET: "Compensação da seta",
  T_44_XXJ_WS_ARROWOFFSET_D: "Compensação da seta",
  T_44_XXJ_WS_ARROWSIZE: "Tamanho da seta",
  T_44_XXJ_WS_ARROWSIZE_D: "Tamanho da seta",
  T_44_XXJ_WS_AUTOPLAY_D: "Reproduzir automaticamente ao criar",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Imagem de fundo",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Imagem base",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Raio de fundo",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Raio base",
  T_44_XXJ_WS_BAGSKINID: "ID da skin de Mochila",
  T_44_XXJ_WS_BAGSKINID_D: "O ID da skin da mochila",
  T_44_XXJ_WS_BONEPOSITION: "Posição do osso",
  T_44_XXJ_WS_BONEPOSITION_D: "Coordenadas de mundo do nodo de osso",
  T_44_XXJ_WS_CCTMOVE: "Mover CCT",
  T_44_XXJ_WS_COLLIDER: "Colisor",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Coleção de Colisores",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "O componente usado para descrever o formato da colisão",
  T_44_XXJ_WS_COLOR: "Cor",
  T_44_XXJ_WS_CONTENT: "Conteúdo",
  T_44_XXJ_WS_CONTENT_D: "Conteúdo da carteira é uma coleção de moedas",
  T_44_XXJ_WS_CONTEXT_D: "Conteúdo a ser impresso",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Mira na HUD",
  T_44_XXJ_WS_CURVE_D: "Curva",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Cor da textura da superfície",
  T_44_XXJ_WS_ENABLE: "Habilitar",
  T_44_XXJ_WS_ENTITY_D: "Entidade",
  T_44_XXJ_WS_GETBAGSKINID_D: "Recebe uma configuração de skin para mochila de jogador",
  T_44_XXJ_WS_GETFACTION_D: "Recebe facção",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Recebe as cenas carregadas que não foram desinstaladas",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Recebe o jogador local",
  T_44_XXJ_WS_GROUPID: "ID do grupo",
  T_44_XXJ_WS_GROUPID_D: "Para lógica interna",
  T_44_XXJ_WS_HUDJOYSTICK: "Widget de joystick no HUD",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Entidade de joystick. Jogadores podem editar a HUD através do editor de HUD.",
  T_44_XXJ_WS_HUDTOUCHPAD: "Widget de touchpad no HUD",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "O widget de touchpad no HUD que os jogadores podem editar no editor de HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "HUD ou Dispositivo da HUD personalizada",
  T_44_XXJ_WS_ICON: "Ícone",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Sempre mostrar marca",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Sempre exibir marcas na bússola",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Alfa desativado",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Alfa desativado",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "Ao chamar, o número de parâmetros verdadeiro não bate com o de parâmetros formais. O número esperado é {0} e o atual é {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "É obstáculo dinâmico",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "É um obstáculo dinâmico para NavMesh",
  T_44_XXJ_WS_ISEND: "É final",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "É comandado pelo servidor",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "Se falso, então objetos personalizados não podem ser controlado pelas APIs.",
  T_44_XXJ_WS_ISSUC_D: "Retornar resultado da execução",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Raio de ação do joystick",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Raio de ação do joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Imagem do joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Imagem do joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Raio do joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Raio do joystick",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Lista de ID de habilidades do personagem",
  T_44_XXJ_WS_LOOPTYPE_D: "Tipo de laço",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Desistir no meio da configuração",
  T_44_XXJ_WS_MOUNTABLE: "Hierárquico",
  T_44_XXJ_WS_MOUNTABLE_D: "Entidade capaz de montar nodos filhos",
  T_44_XXJ_WS_MOVEMENT: "Movimentação",
  T_44_XXJ_WS_NAME_D: "Nome",
  T_44_XXJ_WS_NATURALCONST: "Constante natural",
  T_44_XXJ_WS_NATURALCONST_D: "Enum de constantes naturais para reduzir definições redundantes",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Reproduzir animação do ícone",
  T_44_XXJ_WS_OFFSET_D: "Compensação base padrão",
  T_44_XXJ_WS_ONFIRE_D: "Aciona o evento sempre que o jogador atirar, atacar com os punhos ou armas corpo a corpo",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Aciona o evento quando o jogador se levanta ao estar deitado/agachado",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Aciona o evento quando o jogador toca no botão de disparo",
  T_44_XXJ_WS_OPTION: "Opções",
  T_44_XXJ_WS_PASSIVESKILLHUD: "HUD de habilidade passiva",
  T_44_XXJ_WS_PHYSICALMOVER: "Movedor físico",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Jogadores nesta plataforma seguem automaticamente seu movimento e rotação",
  T_44_XXJ_WS_PHYSICALOBJECT: "Objeto físico",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Pode aplicar força a ele",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "A constante matemática π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Lista de Sobreviventes",
  T_44_XXJ_WS_PLAYERS_D: "Lista de jogadores",
  T_44_XXJ_WS_PLAYERSKILLID: "ID de habilidade de personagem",
  T_44_XXJ_WS_PLAYERSKILLID_D: "A ID de habilidade do personagem em AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "A postura anterior antes do jogador se levantar",
  T_44_XXJ_WS_PRINT: "Imprimir",
  T_44_XXJ_WS_PRINTERROR: "Erro de impressão",
  T_44_XXJ_WS_PRINTERROR_D: "Imprime os dados do alvo como um erro no console",
  T_44_XXJ_WS_PRINTWARNING: "Aviso de impressão",
  T_44_XXJ_WS_PRINTWARNING_D: "Imprime os dados do alvo como um aviso no console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Priorizar a configuração de skin do jogador",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioriza a configuração de skin do jogador fora da partida",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Ler o conteúdo das células em uma linha pelo número da coluna e chave",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Limpa a configuração de skin para mochila de jogador",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove um componente de uma entidade. Suporta somente componentes personalizados.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Redefine a configuração de skin para mochila de jogador para sua configuração fora da partida",
  T_44_XXJ_WS_SETBAGSKINID_D: "Define uma configuração de skin para mochila de jogador",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entidade suportando os componentes de Transformação, Parte Esquelética, Jogador e Ponto de Montagem",
  T_44_XXJ_WS_SHOWBACKGROUND: "Mostrar fundo",
  T_44_XXJ_WS_SKINID_D: "O ID da skin da mochila e configuração da skin",
  T_44_XXJ_WS_SPEED_D: "Velocidade da reprodução",
  T_44_XXJ_WS_TARGET: "Alvo",
  T_44_XXJ_WS_TARGET_D: "Objeto alvo",
  T_44_XXJ_WS_TITLE: "Título",
  T_44_XXJ_WS_TYPEID_D: "ID do tipo de componente. Suporta apenas componentes personalizados.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Fazer upload dos resultados da partida",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Tipo incorreto. Não é possível ler o conteúdo da tabela.",
  T_44_XXJ_WS_X_D: "Coordenada do eixo X",
  T_44_XXJ_WS_Y_D: "Coordenada do eixo Y",
  T_44_XYL_WS_CTZSAFEZONE: "Zona Segura personalizada",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Gera os pontos de início e fim de uma Zona Segura com base nas posições e propriedades definidas",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Envólucro hemisférico",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarto de cilindro",
  T_44_XYL_WS_SQUAREPYRAMID: "Pirâmide quadrada",
  T_44_XYL_WS_TORUS: "Toro",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Pirâmide triangular",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "AddGameEventLogMap",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Adicionar registro de eventos do usuário",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "O registro de eventos da partida personalizada usado para análise de dados UX",
  T_44_YU_WS_ITEM366: "Muro Militar A",
  T_44_YU_WS_ITEM367: "Muro Militar B",
  T_44_YU_WS_ITEM368: "Muro Militar C",
  T_44_YU_WS_ITEM369: "Muro Militar D",
  T_44_YU_WS_ITEM370: "Janela Militar A",
  T_44_YU_WS_ITEM371: "Janela Militar B",
  T_44_YU_WS_ITEM372: "Janela Militar C",
  T_44_YU_WS_ITEM373: "Porta Militar A",
  T_44_YU_WS_ITEM374: "Porta Militar B",
  T_44_YU_WS_ITEM375: "Telhado Angulado Militar A",
  T_44_YU_WS_ITEM376: "Telhado Angulado Militar B",
  T_44_YU_WS_ITEM377: "Escadas Militar A",
  T_44_YU_WS_ITEM378: "Escadas Militar B",
  T_44_YU_WS_ITEM379: "Pilar Militar A",
  T_44_YU_WS_ITEM380: "Corrimão Militar A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Personalizar",
  T_45_CJ_TREATMENTGUN_Y_N: "Pistola de Cura-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Passinho Campeão",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspecionar",
  T_45_HL_Moderation_fail_1: "Infelizmente, o projeto que você enviou não foi aprovado na avaliação.",
  T_45_HL_Moderation_fail_2: "envolve",
  T_45_HL_Moderation_fail_3: "Dentre os motivos, estão:",
  T_45_HL_Moderation_fail_Location_1: "Conteúdo do jogo",
  T_45_HL_Moderation_fail_reason_1: "Conteúdo tóxico",
  T_45_HL_Moderation_fail_reason_10: "Violação do Guia da Comunidade",
  T_45_HL_Moderation_fail_reason_11: "Impactos negativos na economia do jogo e infração de propriedade virtual",
  T_45_HL_Moderation_fail_reason_2: "Conteúdo inapropriado",
  T_45_HL_Moderation_fail_reason_3: "Conteúdo político sensível",
  T_45_HL_Moderation_fail_reason_4: "Informação falsa",
  T_45_HL_Moderation_fail_reason_5: "Infração de direitos autorais",
  T_45_HL_Moderation_fail_reason_6: "Violação de privacidade",
  T_45_HL_Moderation_fail_reason_7: "Problemas de segurança",
  T_45_HL_Moderation_fail_reason_8: "Discurso de ódio",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Outras questões",
  T_45_JH_WS_CLEMPTYOBJECT: "Grupo de Objetos",
  T_45_JH_WS_PETSWITCH1: "Mostrar pets na partida ou não",
  T_45_QL_CSFPP_DES: "Elimine todos os oponentes em primeira pessoa (FPS) nesse modo especial do CS!",
  T_45_QL_CSFPP_NAME: "Contra Squad: FPS",
  T_45_QL_CSFPP_RANKNAME: "Primeira pessoa",
  T_45_SJ_WS_REVIEW_23: "Conteúdo do jogo",
  T_45_SJ_WS_REVIEW_24: "{0} envolve {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} envolve {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Toque para ver detalhes >>[-]",
  T_45_SJ_WS_REVIEW_27: "Desaprovado",
  T_45_SJ_WS_REVIEW_28: "Relatório da Avaliação",
  T_45_SJ_WS_REVIEW_29: "O conteúdo envolve {0} violações",
  T_45_SJ_WS_REVIEW_31: "Desaprovado",
  T_45_SJ_WS_REVIEW_32: "A avaliação falhou devido a exceções do servidor",
  T_45_SJ_WS_REVIEW_TITLE: "Informações da Violação",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Aciona o impulso (pular por obstáculos)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Distância do Impulso",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifica a distância do impulso",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Altura do Impulso",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controla a altura ao mover pra baixo ou pra cima quando dá impulso",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Ativar o Impulso",
  T_45_TYC_CL_TEMPLATE_WS: `Um modo de abate em que os jogadores eliminam todas as equipes rivais nessa batalha caótica para vencer.
Você pode configurar as regras e ajustar os parâmetros como quiser.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Frifacóptero",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = ataque automático, 1 = ataque defensivo, 2 = sem ataque",
  T_45_XXJ_WS_ADDFRIEND: "Adicionar Amigo",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Dados da Base",
  T_45_XXJ_WS_BOTH: "Ambos",
  T_45_XXJ_WS_BYHIERARCHY: "Por hierarquia",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "Por prioridade - Alta a Baixa",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "Por prioridade - Baixa a Alta",
  T_45_XXJ_WS_CAMERA: "Câmera",
  T_45_XXJ_WS_CAMERATYPE: "Tipo de Câmera",
  T_45_XXJ_WS_CENTERINVISIBLE: "Centro Invisível",
  T_45_XXJ_WS_CLIENT: "Cliente",
  T_45_XXJ_WS_COLLIDERID: "ID de colisão",
  T_45_XXJ_WS_COLLIDERID_D: "ID da colisão",
  T_45_XXJ_WS_COMPONENT: "Componente",
  T_45_XXJ_WS_CURRENTCAMERA: "Câmera Atual",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Força de Empurrão Personalizada",
  T_45_XXJ_WS_DOUBLE: "Duplo",
  T_45_XXJ_WS_DUMP: "Arremessar",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Habilitar Mover no Ar",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Habilitar rotação com gravidade",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Evento",
  T_45_XXJ_WS_FILLAMOUNT: "Preencher Quantidade",
  T_45_XXJ_WS_FILLDIR: "Preencher Direção",
  T_45_XXJ_WS_FIRETYPE: "Tipo Fogo",
  T_45_XXJ_WS_FIRETYPE_D: "O tipo fogo",
  T_45_XXJ_WS_FIXEDDELTATIME: "FixedDeltaTime",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "O intervalo de tempo fixo para atualizações de quadros em milissegundos",
  T_45_XXJ_WS_FORWARD: "Avançar",
  T_45_XXJ_WS_FORWARD_D: "A direção do eixo z no sistema de coordenadas local",
  T_45_XXJ_WS_FUNCTIONTYPE: "Tipo de Função",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "O tipo de função",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "A direção de mira do jogador local",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Pegar a Indicação de Tempo Local",
  T_45_XXJ_WS_GRADIENT: "Gradiente",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradiente de Pernas",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradiente de Pernas Alfa",
  T_45_XXJ_WS_GRADIENTTOP: "Gradiente de Torso",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradiente de Torso Alfa",
  T_45_XXJ_WS_HITPOSITION_D: "A posição no mundo do alvo que foi acertado pelas balas",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "Dispositivo de botão social - interface de usuário",
  T_45_XXJ_WS_INVERTFILL: "Inverter Preenchimento",
  T_45_XXJ_WS_ISGROUNDED: "De castigo",
  T_45_XXJ_WS_ISSILENCE: "Está Silenciado",
  T_45_XXJ_WS_ISSILENCE_D: "Se está silenciado ou não",
  T_45_XXJ_WS_ISSINGLESHOT: "É Disparo Único",
  T_45_XXJ_WS_ISSINGLESHOT_D: "Se é disparo único ou não",
  T_45_XXJ_WS_JUMPHEIGHT: "Altura do pulo",
  T_45_XXJ_WS_JUMPHEIGHT_D: "A altura do pulo",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Tipo de ordem de exibição",
  T_45_XXJ_WS_LIGHT_D: "Luzes",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Contagem de Saltos Máx.",
  T_45_XXJ_WS_MODULE: "Módulo",
  T_45_XXJ_WS_NONE: "Nenhum",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Sempre dê o comando antes que a entidade cause dano",
  T_45_XXJ_WS_ONDISABLE_D: "Executar se a entidade está desativada",
  T_45_XXJ_WS_ONEACHLOOP_D: "Executar a cada ciclo de Jogável. Efetivo apenas do lado do cliente para entidades como Efeito Sonoro e Efeito Especial",
  T_45_XXJ_WS_ONENABLE_D: "Executar se a entidade está ativada",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "Ao entrar em um quadro a uma taxa fixa de 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Aciona o evento do cliente quando o jogador adiciona ou deleta um amigo",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Aciona o evento quando o jogo está pausado devido à API chamada",
  T_45_XXJ_WS_ONGAMERESUME_D: "Aciona o evento quando o jogo volta devido à API chamada",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Quando para a arrancada do jogador",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Quando o jogador para de surfar",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Quando o jogador está surfando",
  T_45_XXJ_WS_PHYSICALLAYER_D: "A camada física personalizada dentro de uma faixa de 0 a 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Tipo de Plataforma",
  T_45_XXJ_WS_PLATFORMTYPE_D: "O tipo de plataforma",
  T_45_XXJ_WS_PLAYER: "Jogador",
  T_45_XXJ_WS_PLAYERCCT: "CCT Jogador",
  T_45_XXJ_WS_PLAYERCCT_D: "Um controle de personagem com efeitos físicos, usado apenas para personagens do Free Fire",
  T_45_XXJ_WS_PRIORITY: "Prioridade",
  T_45_XXJ_WS_REMAINMULTINUM: "Contagem de Saltos Restantes",
  T_45_XXJ_WS_REPORT: "Denunciar",
  T_45_XXJ_WS_RIGHT: "Direita",
  T_45_XXJ_WS_RIGHT_D: "A direção do eixo x no sistema de coordenadas local",
  T_45_XXJ_WS_SERVER: "Servidor",
  T_45_XXJ_WS_SINGLE: "Único",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Tipo de Estilo de Botão Social",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "O estilo de botão social",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Tipo de Botão Social",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "O Tipo de Botão Social",
  T_45_XXJ_WS_SORTTYPE_D: "Tipos de ordenação: ascendente não zero, descendente e ascendente.",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Velocidade de movimento enquanto mira para baixo",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "A velocidade de movimento enquanto mira para baixo",
  T_45_XXJ_WS_STRINGORLOCSTRING: "Sentença ou Sentença Localizada",
  T_45_XXJ_WS_TRIPLE: "Triplo",
  T_45_XXJ_WS_UP: "Cima",
  T_45_XXJ_WS_UP_D: "A direção do eixo y no sistema de coordenadas local",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Usar Força de Empurrão Personalizada",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Arremessa um sinalizador na direção da área designada pra invocar um veículo aleatório",
  T_45_ZD_VEHICLEDROP_R_NAME: "Veículo Misterioso",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Tempo de jogo",
  T_46_HJ_WS_SHAREBY: "Por {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Modo de Jogo",
  T_46_HJ_WS_SHARETEAM: "Equipe",
  T_46_HJ_WS_SHARETEAMVS: "{0} x {1}",
  T_46_HX_B_SCHOOL_VN: "Fazendo Escola (Pernas)",
  T_46_HX_H_SCHOOL_VN: "Fazendo Escola (Cabeça)",
  T_46_HX_S_SCHOOL_VN: "Fazendo Escola (Calçado)",
  T_46_HX_T_SCHOOL_VN: "Fazendo Escola (Torso)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Outros",
  T_46_XXJ_WS_ACTUALPOSITION: "Posição real",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Adicionar o objeto para monitorar com sincronização AOI além da linha de visão",
  T_46_XXJ_WS_APPEARANCE: "Aparência",
  T_46_XXJ_WS_APPEARANCERES: "Recurso de aparência",
  T_46_XXJ_WS_BECOME: "Ativar",
  T_46_XXJ_WS_BRAKETORQUE_D: "A potência fornecida ao veículo quando usa Freio/Ré",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Tipo de Restrição de Ângulo de Rotação da Câmera",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Limpar todos os objetos monitorados do alvo",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "O dano máximo de impacto usado para o cálculo de danos",
  T_46_XXJ_WS_CRASHMAXSPEED: "Velocidade máxima do impacto",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Usado para o cálculo de danos por colisão. Uma vez que essa velocidade for excedida, não serão adicionados mais danos.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Fator de massa do impacto",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Um parâmetro usado na fórmula de danos para cálculo de danos por colisão",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "O dano mínimo de impacto usado para o cálculo de danos",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "O limite de leitura e escrita do armazenamento de dados foi excedido",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Exceção de parâmetro",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Tempo limite do armazenamento de dados. Aplica-se principalmente à leitura e escrita no momento.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Editar aparência",
  T_46_XXJ_WS_ENDVALUE_D: "O valor do destino",
  T_46_XXJ_WS_ENGINETORQUE_D: "A potência fornecida ao veículo quando o acelerador é utilizado",
  T_46_XXJ_WS_ERRORCODE_D: "O código de erro enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Ângulos de Euler no Vetor3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Converter o ângulo de Euler num vetor 3D",
  T_46_XXJ_WS_EXPIRE: "Expira",
  T_46_XXJ_WS_FEMALEAVATAR: "Personagem feminina",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Obter data de validade da assinatura",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Se o observador está monitorando um objeto ou não",
  T_46_XXJ_WS_HELICOPTER: "Frifacóptero",
  T_46_XXJ_WS_HELICOPTER_D: "Um tipo de veículo voador",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Ângulo de Direção em Alta Velocidade",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "O ângulo máximo de direção enquanto em alta velocidade",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Ângulo de Direção em Alta Velocidade a Velocidade",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "O limite de velocidade para o ângulo máximo de direção em alta velocidade",
  T_46_XXJ_WS_IDLE: "Animação Ociosa",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Entrada de Freio em Marcha Lenta",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Quando não estiver dirigindo um veículo, desacelere-o por (Entrada do Freio em Marcha Lenta) x (Torque de Freio).",
  T_46_XXJ_WS_INTTOFLOAT: "Int para flutuar",
  T_46_XXJ_WS_INTTOFLOAT_D: "Converter um número inteiro para um número de ponto flutuante",
  T_46_XXJ_WS_ISPREMIUM: "É Assinatura",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "O nome da tabela de classificação no banco de dados",
  T_46_XXJ_WS_MALEAVATAR: "Personagem masculino",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "Perfil IA",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Nova Aparência UMA",
  T_46_XXJ_WS_NONE_D: "Sem erro",
  T_46_XXJ_WS_NPC: "Personagem Não Jogável (NPC)",
  T_46_XXJ_WS_NPC_D: "O objeto NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Dicas: NPCs humanoides geralmente têm um modelo de colisão com uma cápsula de 1,4m de altura e 0,25m de raio. NPCs de pets geralmente têm um modelo de colisão com uma cápsula de 1m de altura e 0,4m de raio.",
  T_46_XXJ_WS_OBSERVER_D: "O observador que está monitorando objetos",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "Ao Entrar na Oficina de Criação",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "Ao Sair da Oficina de Criação",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Abrir Assinatura da Oficina de Criação",
  T_46_XXJ_WS_PERSONA: "Perfil",
  T_46_XXJ_WS_PERSONACENTER: "Centro do perfil",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Jogador ou Transformação",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Um apelido para o Jogador ou entidade de transformação",
  T_46_XXJ_WS_PREMIUM: "Assinatura",
  T_46_XXJ_WS_PREMIUMSTATUS: "Status da assinatura",
  T_46_XXJ_WS_PROXYOBSERVER: "Observador Intermediário",
  T_46_XXJ_WS_PROXYOBSERVER_D: "O observador intermediário",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remover objeto monitorado e cancelar a sincronização AOI além da linha de visão",
  T_46_XXJ_WS_RENEWAL: "Renovar",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotacionar Vetor",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotacione um vetor baseado em quatérnios",
  T_46_XXJ_WS_SKIN: "Traje",
  T_46_XXJ_WS_STARTVALUE_D: "O valor fonte",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Trocar o observador intermediário do Usuário",
  T_46_XXJ_WS_TARGET_D: "O alvo está sendo monitorado",
  T_46_XXJ_WS_USER_D: "O usuário",
  T_46_XXJ_WS_VALUE: "Valor",
  T_46_XXJ_WS_VALUE_D: "Vetor",
  T_46_XYL_WS_CTZSAFEZONEEND: "Zona Segura final",
  T_46_XYL_WS_RESOURCETYPE1: "Estruturas básicas",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geométrico",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual e áudio",
  T_46_XYL_WS_RESOURCETYPE2: "Itens de cena",
  T_46_XYL_WS_RESOURCETYPE2_2: "Recursos de Batalha",
  T_46_XYL_WS_RESOURCETYPE3: "Natureza",
  T_46_XYL_WS_RESOURCETYPE4: "Componente modular",
  T_46_XYL_WS_TYPEOTHERPROP: "Diversos",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Contêineres e Pacotes",
  T_47_CJ_FOREGRIP_SOFT_N: "Empunhadura leve",
  T_47_CJ_MAGEZINE_FAST_N: "Cartucho rápido",
  T_47_CJ_STOCK_FAST_N: "Coronha Poderosa",
  T_47_GT_WS_USERMANUAL: "Manual do Usuário",
  T_47_HJ_WS_VFX_FOG: "Efeito visual de névoa",
  T_47_HJ_WS_VFX_LIGHTING: "Efeito visual de raio",
  T_47_HJ_WS_VFX_TRAILING: "Efeito visual de rastro",
  T_47_HL_CL_CREATOR_LABEL1: "Talento da Comunidade",
  T_47_HL_CL_MAP_LABEL1: "Trabalhos selecionados por Talentos da Comunidade",
  T_47_JH_WS_MODERATION_REASON12: "Relacionado a eventos de tentativas",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "Parceria com NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "Arquivo material",
  T_47_SD_RES_MESH: "Malha",
  T_47_SD_WS_MAPTAG_AI: "Geração de Mapa por IA",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Uma faca especial que fica presa no ponto de impacto após ser lançada, acionando uma explosão de fogo que causa dano de queimadura.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Kunai do Fogo",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Uma faca especial que fica presa no ponto de impacto após ser lançada, gerando um golpe de trovão que paralisa o alvo.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Kunai do Trovão",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Uma faca especial que fica presa no ponto de impacto após ser lançada, gerando uma tempestade de vento que desacelera o alvo e o leva para o centro.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Kunai do Vento",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Um tipo de shuriken adequado para combate de médio a longo alcance. É lançada uma por vez, causando muito dano.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Shuriken Pesada",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Um tipo de shuriken adequado para combate de curto a médio alcance, com dois modos de ataque. São lançadas três de uma vez, causando pouco dano.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Shuriken Leve",
  T_47_XXJ_WS_ACTION: "Ação",
  T_47_XXJ_WS_AOISETTING: "Configuração AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "Tipo de skin de Mochila",
  T_47_XXJ_WS_CLEARMEMORY: "Limpar memória",
  T_47_XXJ_WS_CLNPC: "NPC Avançado",
  T_47_XXJ_WS_CLOTHTYPE: "Tipo de skin de traje",
  T_47_XXJ_WS_COMMON_ERROR: "Erro comum",
  T_47_XXJ_WS_CONTENT: "Conteúdo",
  T_47_XXJ_WS_CREATERANDOMSEED: "Criar semente aleatória",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Porcentagem decorrida",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Habilitar recurso de névoa",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Habilitar recurso de rotação de luz",
  T_47_XXJ_WS_ERRORCODE: "Código de erro",
  T_47_XXJ_WS_EXPONENTIAL: "Exponencial",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponencial ao quadrado",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Falha ao criar sala: IDs de persona inválidos",
  T_47_XXJ_WS_FOG: "Névoa",
  T_47_XXJ_WS_FOGDENSITY: "Densidade de névoa",
  T_47_XXJ_WS_FOGENDDISTANCE: "Distância do fim da névoa",
  T_47_XXJ_WS_FOGMODE: "Modo da névoa",
  T_47_XXJ_WS_FOGMODETYPE: "Tipo de modo da névoa",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Distância do início da névoa",
  T_47_XXJ_WS_HEIGHTSCALE: "Escala de altura",
  T_47_XXJ_WS_ISVISIBLE: "Está Visível",
  T_47_XXJ_WS_JOINNEWTEAM: "Entrar em nova equipe",
  T_47_XXJ_WS_JOINTEAM: "Entrar na equipe",
  T_47_XXJ_WS_LIGHTROTATE: "Rotação de luz",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "Chat de Persona da Interface",
  T_47_XXJ_WS_NEWTEAM: "Nova Equipe",
  T_47_XXJ_WS_NEXT: "Próximo",
  T_47_XXJ_WS_NPC_TIP: "É possível editar a aparência e fazer a animação do NPC",
  T_47_XXJ_WS_OBSERVERS: "Observadores",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "Ao enviar mensagem pelo jogador no Chat de Persona da Interface",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "Ao alterar o status da assinatura",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Ao receber ação de persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Ao receber conteúdo de persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Ao receber finalização de persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Ao receber status de persona",
  T_47_XXJ_WS_PARTICLESID: "ID de partículas",
  T_47_XXJ_WS_PERSONAAVATAR: "Avatar de Persona",
  T_47_XXJ_WS_PERSONAID: "ID de persona",
  T_47_XXJ_WS_PERSONANICKNAME: "Apelido de persona",
  T_47_XXJ_WS_PLAYERORNPC: "Jogador ou NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Assinatura cancelada",
  T_47_XXJ_WS_RANDOM: "Aleatório",
  T_47_XXJ_WS_SEED: "Semente",
  T_47_XXJ_WS_SENDER: "Remetente",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Configurar observador de persona",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Definir configuração de jogador: Pode sair no meio da partida",
  T_47_XXJ_WS_SHOULDREPLY: "Se responder",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Mostrar resposta do sistema",
  T_47_XXJ_WS_SPOTANGLE: "Ângulo da luz",
  T_47_XXJ_WS_SPOTLIGHT: "Holofote",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Enviar mensagem do sistema para persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Transmitir mensagens do sistema para persona",
  T_47_XXJ_WS_TARGETTEAM: "Equipe alvo",
  T_47_XXJ_WS_THISENTITY: "Esta entidade",
  T_47_XXJ_WS_USERAVATAR: "Avatar do usuário",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Enviar mensagem do usuário para persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Transmitir mensagens do usuário para persona",
  T_47_XXJ_WS_USERNICKNAME: "Apelido do usuário",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Tipo de skin de veículo",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Tipo de skin de arma",
  T_47_XYL_NB_UGC_EFFECT001: "Efeito Visual de Rasengan",
  T_47_XYL_NB_UGC_EFFECT002: "Efeito Visual de Chidori",
  T_47_XYL_NB_UGC_EFFECT003: "Efeito Visual de Impacto da Flor de Cerejeira",
  T_47_XYL_NB_UGC_EFFECT004: "Efeito Visual de Estilo Fogo: Jutsu Bola de Fogo",
  T_47_XYL_NB_UGC_EFFECT005: "Efeito Visual de Estilo Água: Jutsu Dragão de Água",
  T_47_XYL_NB_UGC_EFFECT006: "Efeito Visual de Estilo Vento: Grande Destruição",
  T_47_XYL_NB_UGC_EFFECT007: "Efeito Visual de Bomba Bijuu",
  T_47_XYL_NB_UGC_EFFECT008: "Efeito Visual de Jutsu de Invocação: Reencarnação Impura",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Loja de itens",
  T_47_XYL_UGC_DONKEYCART: "Carrinho do Burro",
  T_47_XYL_UGC_SPOTLIGHT: "Holofote",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Ângulo do holofote",
  T_48_H_EMOTE_WATERFEST25_N: "Passinho",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Moto - Veículo Praiano",
  T_48_HJ_AC_STATENOTEXIST: "O estado {0} não existe no controle de animação",
  T_48_HL_CODESCRIPT: "Código de Script",
  T_48_HL_GLOBAL_VAR: "Nome da variável global",
  T_48_HL_GRAPH: "Bloco",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Placar",
  T_48_HL_LOCAL_VAR: "Nome da variável local",
  T_48_HL_LOCALIZATION: "Nome da localização",
  T_48_HL_OPEN_ATTRIBUTES: "Abrir nome de atributo",
  T_48_HX_A_WATERFEST25: "Predador Praiano (Máscara)",
  T_48_HX_B_WATERFEST25: "Predador Praiano (Pernas)",
  T_48_HX_F_B_BLACKDRESS: "Antimatéria (Pernas)",
  T_48_HX_F_H_BLACKDRESS: "Antimatéria (Cabeça)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatéria (Pintura Facial)",
  T_48_HX_F_S_BLACKDRESS: "Antimatéria (Calçado)",
  T_48_HX_F_T_BLACKDRESS: "Antimatéria (Torso)",
  T_48_HX_H_WATERFEST25: "Predador Praiano (Cabeça)",
  T_48_HX_HA_WATERFEST25: "Predador Praiano (Pintura facial)",
  T_48_HX_M_A_BLACKDRESS: "Matéria Escura (Máscara)",
  T_48_HX_M_B_BLACKDRESS: "Matéria Escura (Pernas)",
  T_48_HX_M_H_BLACKDRESS: "Matéria Escura (Cabeça)",
  T_48_HX_M_HA_BLACKDRESS: "Matéria Escura (Pintura Facial)",
  T_48_HX_M_S_BLACKDRESS: "Matéria Escura (Calçado)",
  T_48_HX_M_T_BLACKDRESS: "Matéria Escura (Torso)",
  T_48_HX_S_WATERFEST25: "Predador Praiano (Calçado)",
  T_48_HX_T_WATERFEST25: "Predador Praiano (Torso)",
  T_48_JH_WS_STRINGDESC: "Inserir um parágrafo de texto ou outras linhas. Alguns dispositivos podem exibir texto formatado. Adiciona cor ao texto com texto formatado usando o seguinte formato: [#XXXXXX] texto texto [-]. “#XXXXXX” sendo a cor que você quer usar. Observe que a cor do texto do dispositivo relacionado deve estar configurada como branco.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Buscar entidade por ID",
  T_48_META_API_10001_P0: "ID da entidade",
  T_48_META_API_1098: "Leitura de vários dos valores da planilha de banco de dados",
  T_48_META_API_1098_D: "Leia várias entradas de dados em lote a partir de uma planilha de banco de dados específica, onde cada ID único de jogador corresponde diretamente a um item da lista de chaves.",
  T_48_META_API_1098_P1: "IDs de conta",
  T_48_META_API_1098_P1_D: "A lista de IDs únicos de jogadores, que lê os dados correspondentes às chaves no mesmo índice na lista de chaves.",
  T_48_META_API_1098_P2: "Chaves",
  T_48_META_API_1098_P2_D: "A lista de chaves, que lê os dados correspondentes aos IDs únicos de jogadores no mesmo índice na lista de IDs.",
  T_48_META_API_1098_P5: "Códigos de status",
  T_48_META_API_1098_P5_D: "A lista de códigos de status.",
  T_48_META_API_1105: "Notificar Início de Enredo",
  T_48_META_API_1105_D: "Iniciar a reprodução do enredo especificado para o jogador que acionou",
  T_48_META_API_1105_P1_D: "O ID do enredo",
  T_48_META_API_1108: "Obter o Idioma Local",
  T_48_META_API_1500_P0: "Vetor",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Definir o peso da parte do corpo",
  T_48_META_API_3300_D: "Definir o peso da parte do corpo ao combiná-la com outras animações de menor prioridade",
  T_48_META_API_3300_P0_D: "O componente de controle de animação adicionável ao qual a parte do corpo pertence",
  T_48_META_API_3300_P1: "Nome da parte do corpo",
  T_48_META_API_3300_P1_D: "O nome da parte do corpo",
  T_48_META_API_3300_P2: "Peso",
  T_48_META_API_3300_P2_D: "Peso com um intervalo de valores entre [0, 1], representando o grau de combinação com animações de menor prioridade.",
  T_48_META_API_3315: "Reprodução com Substituição de Animação do Personagem",
  T_48_META_API_3315_D: "Reproduzir clipe de animação de personagem com a opção de substituir a animação padrão do jogo",
  T_48_META_API_3315_P3: "Substituição de controle de jogabilidade",
  T_48_META_API_3315_P3_D: "Indica se a animação padrão do jogo será substituída.",
  T_48_META_API_3316: "Parar Animação",
  T_48_META_API_3316_D: "Parar a reprodução da animação do alvo no status especificado",
  T_48_META_API_90_P1: "Pode desistir no meio da partida",
  T_48_META_API_93: "Criar movimento ao longo de um caminho",
  T_48_META_API_93_D: "Cria um movimento interpolado ao longo de um caminho para fazer o objeto se mover pelo caminho especificado",
  T_48_META_API_93_P1: "Caminho",
  T_48_META_API_93_P1_D: "O caminho do movimento",
  T_48_META_API_93_P3_D: "A magnitude da velocidade",
  T_48_META_API_93_P4: "Orientação Tangente",
  T_48_META_API_93_P4_D: "Indica se o objeto está orientado na direção do movimento. Essa propriedade permanece inalterada, mesmo que a orientação do objeto seja modificada à força por outros meios.",
  T_48_META_API_96: "Instanciar objeto pré-fabricado",
  T_48_META_API_96_D: "Cria uma instância de um objeto pré-fabricado com a opção de processá-la de forma assíncrona",
  T_48_META_API_96_P2: "Carregamento assíncrono",
  T_48_META_API_96_P2_D: "Indica se o carregamento é assíncrono",
  T_48_META_EVT_3140: "Ao alterar equipe",
  T_48_META_EVT_3140_D: "Aciona quando a equipe da entidade atual é alterada",
  T_48_META_EVT_3140_P0: "Equipe anterior",
  T_48_META_EVT_3140_P0_D: "A equipe à qual pertencia antes da alteração",
  T_48_META_EVT_3140_P1: "Equipe atual",
  T_48_META_EVT_3140_P1_D: "A equipe à qual pertence após a alteração",
  T_48_META_EVT_3141: "Ao começar o enredo",
  T_48_META_EVT_3141_D: "Aciona quando o enredo começa a ser reproduzido",
  T_48_META_EVT_3141_P1: "ID do Enredo",
  T_48_META_EVT_3141_P1_D: "O ID do enredo",
  T_48_META_EVT_3142: "Ao terminar o enredo",
  T_48_META_EVT_3142_D: "Aciona quando o enredo termina",
  T_48_META_EVT_3142_P0_D: "Jogador iniciador",
  T_48_META_EVT_3142_P1_D: "O ID do enredo",
  T_48_META_EVT_3143: "Ao Acionar Opção do Enredo",
  T_48_META_EVT_3143_D: "Aciona quando uma opção é selecionada no enredo",
  T_48_META_EVT_3143_P1_D: "O ID do enredo",
  T_48_META_EVT_3143_P2: "ID da Opção",
  T_48_META_EVT_3143_P2_D: "O ID da opção selecionada",
  T_48_META_TYP_409_I10: "Falha na Alteração da Equipe_Equipe Inválida",
  T_48_META_TYP_409_I11: "Falha na Alteração da Equipe_Eliminada",
  T_48_META_TYP_409_I12: "Falha na Alteração da Equipe_Dentro de veículo",
  T_48_META_TYP_409_I7: "Falha na Alteração da Equipe_Não suportado",
  T_48_META_TYP_409_I8: "Falha na Alteração da Equipe_Já está na equipe",
  T_48_META_TYP_409_I9: "Falha na Alteração da Equipe_Alvo Inválido",
  T_48_META_TYP_41_I19: "Desabilitar colisão",
  T_48_META_TYP_417: "Partículas",
  T_48_META_TYP_428: "Transformação do jogador ou Traje do NPC",
  T_48_META_TYP_431: "Movimento ao longo de um caminho",
  T_48_META_TYP_431_I1: "Caminho",
  T_48_META_TYP_432: "Ponto de Referência de Caminho Personalizado em Curva",
  T_48_META_TYP_432_I0: "Rolar",
  T_48_META_TYP_432_I1: "Tangente",
  T_48_META_TYP_433: "Tipo de Caminho Personalizado em Curva",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Suave",
  T_48_META_TYP_433_I2: "Personalizar",
  T_48_META_TYP_434: "Caminho Personalizado em Curva",
  T_48_META_TYP_434_I2: "Loop fechado",
  T_48_META_TYP_434_I3: "Pontos de referência",
  T_48_META_TYP_437_I5: "Nomes de tipos de pontuação",
  T_48_META_TYP_437_I6: "Conteúdo de pontuação à esquerda",
  T_48_META_TYP_437_I7: "Conteúdo de pontuação à direita",
  T_48_META_TYP_438_I1: "Jogadores",
  T_48_META_TYP_438_I2: "Patentes",
  T_48_META_TYP_438_I3: "Pontuação total",
  T_48_META_TYP_438_I4: "Nomes de tipos de pontuação",
  T_48_META_TYP_438_I5: "Cores",
  T_48_META_TYP_438_I6: "Pontuações",
  T_48_META_TYP_439: "Grupo",
  T_48_META_TYP_442_I1: "Pontuação à esquerda",
  T_48_META_TYP_442_I10: "Ícone de Eliminado à direita",
  T_48_META_TYP_442_I2: "Pontuação à direita",
  T_48_META_TYP_442_I3: "Número de sobreviventes à esquerda",
  T_48_META_TYP_442_I4: "Número de sobreviventes à direita",
  T_48_META_TYP_442_I5: "Número de eliminados à esquerda",
  T_48_META_TYP_442_I6: "Número de eliminados à direita",
  T_48_META_TYP_442_I7: "Ícone de sobreviventes à esquerda",
  T_48_META_TYP_442_I8: "Ícone de sobreviventes à direita",
  T_48_META_TYP_442_I9: "Ícone de Eliminado à esquerda",
  T_48_META_TYP_444: "Idioma",
  T_48_META_TYP_444_I0: "Inglês",
  T_48_META_TYP_444_I1: "Chinês simplificado",
  T_48_META_TYP_444_I10: "Francês",
  T_48_META_TYP_444_I11: "Alemão",
  T_48_META_TYP_444_I12: "Turco",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japonês",
  T_48_META_TYP_444_I15: "Romeno",
  T_48_META_TYP_444_I16: "Árabe",
  T_48_META_TYP_444_I17: "Birmanês",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Chinês tradicional",
  T_48_META_TYP_444_I3: "Tailandês",
  T_48_META_TYP_444_I4: "Vietnamita",
  T_48_META_TYP_444_I5: "Indonésio",
  T_48_META_TYP_444_I6: "Português",
  T_48_META_TYP_444_I7: "Espanhol",
  T_48_META_TYP_444_I8: "Russo",
  T_48_META_TYP_444_I9: "Coreano",
  T_48_SD_ERROR_DIVISOR: "O divisor não pode ser 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "A chave especificada não existe no mapa: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Índice da lista fora do intervalo: {0}",
  T_48_SD_SK_WARNING: "Não encontrou {1} em {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Como o atributo "IsServerDriven" do controle de personagem da Oficina de Criação {0} está desativado, a API relacionada ao servidor não terá efeito.',
  T_48_XXJ_WS_PARENTERROR: "Falha ao configurar pai",
  T_48_XXJ_WS_PERFORMANCE: "Desempenho",
  T_48_XXJ_WS_TANGENT: "Tangente",
  T_48_XXJ_WS_WAYPOINT: "Ponto de referência",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Lista de objetos",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Usar Minimapa personalizado",
  T_48_XYL_UGC_HIDEMINIMAP: "Esconder HUD do Minimapa",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Superfície Personalizada Básica",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Base cilíndrica",
  T_48_XYL_WS_BASICHEMISPHERE: "Hemisfério Básico",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "1/4 de anel",
  T_48_XYL_WS_BASICQUARTERTORUS: "1/4 de anel quadrado",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Anel",
  T_48_XYL_WS_BASICTRIANGLE: "Superfície triangular",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Jogadores da partida: Número de equipes × Número de jogadores por equipe. Quanto mais jogadores na partida, maior pode ser o tempo de busca por partida",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Um alto número de jogadores na partida pode aumentar o tempo de busca por partida.",
  T_49_HL_CL_CREATOR_LABEL2: "Talento da Comunidade da Oficina",
  T_49_HL_CL_MAPS_LABEL2: "Vencedor do Mapa",
  T_49_HL_CL_MAPS_LABEL3: "Vencedor de jogabilidade",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajetória",
  T_49_JH_WS_SKILLKASSIE: "Eletroterapia (Kassie)",
  T_49_JH_WS_SKILLKODA: "Visão Boreal (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Impacto Insano (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Gerar com IA",
  T_49_META_API_10065: "Trocar Câmera Personalizada",
  T_49_META_API_10067: "Obter Câmera Personalizada Atual",
  T_49_META_API_10069: "Criar Câmera Personalizada",
  T_49_META_API_10070: "Definir Máscara de Visibilidade da Câmera Personalizada",
  T_49_META_API_10070_D: "Definir a máscara de visibilidade da câmera alvo para controlar a visibilidade entre todas as camadas",
  T_49_META_API_10071: "Obter Máscara de Visibilidade da Câmera Personalizada",
  T_49_META_API_10071_D: "Obter a máscara de visibilidade da câmera alvo",
  T_49_META_API_10072: "Definir Camada da Máscara de Visibilidade da Câmera Personalizada",
  T_49_META_API_10072_D: "Definir a visibilidade da câmera alvo para uma camada específica",
  T_49_META_API_10073: "Captura de tela",
  T_49_META_API_10073_D: "Captura de tela (para teste interno)",
  T_49_META_API_106: "Obter indicação do tempo do servidor (ms)",
  T_49_META_API_106_D: "Obter a indicação do tempo do servidor com precisão de milissegundos",
  T_49_META_API_107: "Converter indicação de tempo para sentença localizada (ms)",
  T_49_META_API_107_D: "Converter indicações de tempo (em ms) para sentenças com base em determinados formatos",
  T_49_META_API_107_P0: "Indicação do tempo (ms)",
  T_49_META_API_107_P0_D: "Uma indicação do tempo em milissegundos",
  T_49_META_API_108: "Lerp Vetor3",
  T_49_META_API_108_D: "Executa interpolação linear do vetor 3D A até o vetor B",
  T_49_META_API_1089_P2: "Solicitar ID",
  T_49_META_API_109: "Atualizar Contexto para Persona",
  T_49_META_API_109_D: "Atualiza o contexto do modelo de uma persona específica na sala atual e substitui o contexto original após a execução. O contexto influenciará a interpretação da persona sobre o cenário, histórico ou certos parâmetros do diálogo atual.",
  T_49_META_API_109_P1: "Contexto",
  T_49_META_API_109_P1_D: "Detalhes do contexto",
  T_49_META_API_110: "Feedback sobre a resposta de persona",
  T_49_META_API_110_D: "Enviar um feedback sobre o conteúdo da resposta de uma persona, que será usado para otimizar nosso modelo.",
  T_49_META_API_110_P1: "É Curtida",
  T_49_META_API_110_P1_D: "Indica se a resposta foi curtida ou não. Verdadeiro = curtida.",
  T_49_META_API_1109: "Definir Posição Local do Jogador",
  T_49_META_API_1109_D: "Quando o jogador estiver usando personagens clássicos do jogo, esta API pode definir sua posição.",
  T_49_META_API_1109_P0_D: "Posição de destino",
  T_49_META_API_111: "Slerp Vetor3",
  T_49_META_API_111_D: "Realiza interpolação esférica do vetor 3D A para o vetor B para uma rotação suave",
  T_49_META_API_1110: "Definir Direção do Jogador Local",
  T_49_META_API_1110_D: "Quando o jogador estiver usando personagens clássicos do jogo, esta API pode definir a direção para a qual o jogador está virado.",
  T_49_META_API_1110_P0_D: "O vetor frontal",
  T_49_META_API_112: "Restaurar Memória da Persona",
  T_49_META_API_112_D: "Restaurar a memória de uma persona para antes do ID de resposta específico. Toda a memória dos diálogos, inclusive e após a resposta, será apagada.",
  T_49_META_API_113: "Tocar Som Único",
  T_49_META_API_113_D: "Toca um efeito sonoro único com volume ajustável",
  T_49_META_API_113_P0_D: "ID do recurso de efeito sonoro que será tocado",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "Volume de reprodução do efeito sonoro, entre 0 e 1.",
  T_49_META_API_97: "Criar Controle de Olhar para Parte do Esqueleto",
  T_49_META_API_97_D: "Após criar uma entidade de controle de olhar para parte do esqueleto, você pode usá-la para controlar a parte especificada do esqueleto e fazê-la sempre encarar um alvo específico.",
  T_49_META_API_97_P0_D: "A entidade do controle de olhar para parte do esqueleto. Se a entidade for destruída, a funcionalidade de olhar deixará de funcionar.",
  T_49_META_API_97_P1_D: "A parte do esqueleto que está sendo controlada",
  T_49_META_API_97_P2_D: "O alvo que está sendo observado",
  T_49_META_API_98: "Projeção",
  T_49_META_API_98_D: "Calcular a projeção do vetor A sobre o vetor B",
  T_49_META_API_99: "Obter indicação do tempo local (ms)",
  T_49_META_API_99_D: "Obter indicação do tempo local com precisão de milissegundos",
  T_49_META_EVT_16_P1_D: "A partir de 0, cada solicitação enviada consumirá um ID numérico sequencial (como para criar uma sala ou limpar a memória).",
  T_49_META_EVT_16_P2: "ID da Resposta",
  T_49_META_EVT_16_P2_D: "Cada resposta completa terá um ID único",
  T_49_META_TYP_122_I19: "Personalizar Material",
  T_49_META_TYP_122_I19_D: "Permite trocar o céu do mapa por um material personalizado",
  T_49_META_TYP_14_I78_D: "Pega ou define a entidade câmera que está exibindo a cena no cliente do jogador. Observação: A entidade câmera representa os dados de configuração que controlam a visão do jogador.",
  T_49_META_TYP_335_I9: "Tempo decorrido (ms)",
  T_49_META_TYP_335_I9_D: "A duração de reprodução do efeito sonoro, em milissegundos. Essa propriedade só pode ser acessada no lado do cliente.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "ID de Desempenho",
  T_49_META_TYP_445: "ID do Controle jogável",
  T_49_META_TYP_446: "Acessório do controle jogável",
  T_49_META_TYP_446_I0: "Controle jogável",
  T_49_META_TYP_447: "Controle de parte do esqueleto",
  T_49_META_TYP_448: "Controle de Olhar para Parte do Esqueleto",
  T_49_META_TYP_448_I0: "Alvo controlado",
  T_49_META_TYP_448_I1: "Olhar para alvo",
  T_49_META_TYP_449: "Personalizar câmera",
  T_49_META_TYP_449_I2: "Tamanho da Ortografia",
  T_49_META_TYP_449_I2_D: "Controla o tamanho da área visível pela câmera",
  T_49_META_TYP_450: "Sentença localizada da indicação de tempo (ms)",
  T_49_META_TYPE_449_D: "A câmera personalizada é controlada totalmente pelo criador e define o que o jogador vê na partida",
  T_49_META_TYPE_450_D: "Converte uma indicação de tempo em milissegundos para um formato de texto legível",
  T_49_SD_SEARCH_ICONDESC: "Associação Inteligente",
  T_49_SD_SEARCHKEY_ACTION: "Ação",
  T_49_SD_SEARCHKEY_ANICLIPID: "ID do Clipe de Animação",
  T_49_SD_SEARCHKEY_AS: "Como",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "ID do Acessório",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Tipo de Efeito Sonoro",
  T_49_SD_SEARCHKEY_BAGSKINID: "ID da skin de Mochila",
  T_49_SD_SEARCHKEY_BEZIER: "Curva de Bézier",
  T_49_SD_SEARCHKEY_BOOL: "Booleano",
  T_49_SD_SEARCHKEY_BREAK: "Encerrar",
  T_49_SD_SEARCHKEY_BTREEID: "Árvore de comportamento",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "Ao clicar o botão",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "Ao clicar duas vezes o botão",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "Ao pressionar o botão",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "Ao soltar o botão",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Tipo de traje",
  T_49_SD_SEARCHKEY_COLOR: "Cor",
  T_49_SD_SEARCHKEY_COMMENT: "Comentário",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Enum do componente",
  T_49_SD_SEARCHKEY_CONCANT: "Conectar",
  T_49_SD_SEARCHKEY_CONTINUE: "Continuar",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "HUD personalizada",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Personalizar dispositivo de HUD",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "tipo de objeto de nível criado dinamicamente",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Tipo de efeito visual",
  T_49_SD_SEARCHKEY_ENTITY: "Selecione um objeto de cena",
  T_49_SD_SEARCHKEY_FLOAT: "Número decimal",
  T_49_SD_SEARCHKEY_FOR: "Para índice",
  T_49_SD_SEARCHKEY_FOREACH: "Para cada",
  T_49_SD_SEARCHKEY_FUNCTION: "Função",
  T_49_SD_SEARCHKEY_GETCSV: "Conseguir CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Obter recurso registrado por chave",
  T_49_SD_SEARCHKEY_GETVALUE: "Obter valor de propriedade",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Obter variável global",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Definir variável global",
  T_49_SD_SEARCHKEY_IF: "Se",
  T_49_SD_SEARCHKEY_IFELSE: "Se falso",
  T_49_SD_SEARCHKEY_IMGENUM: "Tipo de imagem",
  T_49_SD_SEARCHKEY_INT: "Inteiro",
  T_49_SD_SEARCHKEY_INTERNALHUD: "Tipo de HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "Tipo de item",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Adicionar à lista",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Adicionar intervalo à lista",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Limpar lista",
  T_49_SD_SEARCHKEY_LISTCLONE: "Clonar lista",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Conteúdo da lista",
  T_49_SD_SEARCHKEY_LISTCREATE: "Criar lista",
  T_49_SD_SEARCHKEY_LISTDELETE: "Apagar lista",
  T_49_SD_SEARCHKEY_LISTGET: "Obter lista",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Índice na lista de",
  T_49_SD_SEARCHKEY_LISTINSERT: "Inserir na lista",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Último índice na lista de",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Tamanho da lista",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Inverter ordem da lista",
  T_49_SD_SEARCHKEY_LISTSET: "Definir lista",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Embaralhar lista",
  T_49_SD_SEARCHKEY_LOCALKEY: "Sentença localizada",
  T_49_SD_SEARCHKEY_LOCALVAR: "Variável local",
  T_49_SD_SEARCHKEY_LOGICAL: "E ou",
  T_49_SD_SEARCHKEY_LOGINFO: "Imprimir log de informações",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dicion tem todas as chaves mapa tem todas as chaves",
  T_49_SD_SEARCHKEY_MAPCLEAR: "limpar dicion limpar mapa",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dicion contém chave mapa contém chave",
  T_49_SD_SEARCHKEY_MAPCREATE: "criar dicion criar mapa",
  T_49_SD_SEARCHKEY_MAPGET: "obter valor do dicion ou mapa pela chave",
  T_49_SD_SEARCHKEY_MAPLENGTH: "comprimento do dicion comprimento do mapa",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remover dicion remover mapa",
  T_49_SD_SEARCHKEY_MAPSET: "definir valor no dicion definir valor no mapa",
  T_49_SD_SEARCHKEY_MATH: "somar, subtrair, multiplicar, dividir",
  T_49_SD_SEARCHKEY_NEWLIST: "Nova lista",
  T_49_SD_SEARCHKEY_NULL: "Nulo",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Número para sentença",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Propriedades de partículas",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ID de dados do jogador",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Tipo de habilidade do personagem",
  T_49_SD_SEARCHKEY_PREEFFECT: "Tipo de adesivo especial",
  T_49_SD_SEARCHKEY_PREFAB: "Pré-fab.",
  T_49_SD_SEARCHKEY_RAWID: "ID bruto",
  T_49_SD_SEARCHKEY_READSTATIS: "Ler dados acumulados",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "UUID do recurso",
  T_49_SD_SEARCHKEY_RETURN: "Voltar",
  T_49_SD_SEARCHKEY_SCENEENUM: "Arquivo de cena",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Definir valor de propriedade",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Tipo de ID de item especial",
  T_49_SD_SEARCHKEY_TEXT: "Texto",
  T_49_SD_SEARCHKEY_TEXTUREID: "Tipo de textura",
  T_49_SD_SEARCHKEY_THISENTITY: "Esta entidade",
  T_49_SD_SEARCHKEY_TIMELINE: "Cronologia",
  T_49_SD_SEARCHKEY_TYPEENUM: "Qualquer tipo",
  T_49_SD_SEARCHKEY_V2VCREATE: "Criar Vetor2",
  T_49_SD_SEARCHKEY_V2VGET: "Conseguir componentes do Vetor2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Operações com Vetor2: somar, subtrair, multiplicar, produto escalar, distância, ângulo",
  T_49_SD_SEARCHKEY_V2VSET: "Definir componentes do Vetor2",
  T_49_SD_SEARCHKEY_V3VCREATE: "Criar Vetor3",
  T_49_SD_SEARCHKEY_V3VGET: "Obter componentes do Vetor3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Operações com Vetor3: somar, subtrair, multiplicar, produto escalar, produto vetorial, distância, ângulo",
  T_49_SD_SEARCHKEY_V3VSET: "Definir componentes do Vetor3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ID da skin de veículo",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Tipo de skin de arma",
  T_49_SD_SEARCHKEY_WHILE: "Enquanto",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Escrever compensação da base de dados acumulada",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Escrever compensação da base de dados acumulada por código de mapa",
  T_49_XXJ_WS_DURATIONS: "Duração (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Editar desempenho",
  T_49_XXJ_WS_PERFORMANCE: "Desempenho",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Apagar desempenho",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Se apagado, o desempenho não pode ser restaurado. Continuar?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editando {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Este nome já está em uso. Altere e tente novamente.",
  T_49_XXJ_WS_PERFORMANCENAME: "Nome do desempenho",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Adicionar marcação",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Adicionar subcamada",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Adicionar camada",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Excluir camada",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Camada principal",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Camada do Evento",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Marcação já existe",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "A camada principal correspondente já existe",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Conteúdo",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Nomes de camadas duplicadas detectados. Altere e tente novamente.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Comece a gravar ou selecione uma marcação primeiro",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Gravando...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Apagar marcação",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Visualização da Cena",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Selecione um objeto para criar uma camada ou toque no botão de adicionar camada diretamente",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Toque no botão de adicionar camada para criar uma nova camada",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Subcamada",
  T_49_XXJ_WS_TIMELINE_TRACK: "Camada",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Visualização de camada",
  T_49_XYL_WS_DAILYPROPS: "Básico",
  T_49_XYL_WS_STOREGAMPLAY: "Jogabilidade",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Criatura Sombria",
  T_50_H_MACHETE_VA_N: "Machete - Criatura Sombria",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Campos do Placar",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Ultrapassar",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Envolver",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Reduzir fonte",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Criar tupla",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Obter tupla",
  T_50_HJ_SEARCHKEY_TUPLESET: "Configurar tupla",
  T_50_HJ_TEXTOBGJ_H: "Altura",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Opções para Ultrapassar",
  T_50_HJ_TEXTOBGJ_W: "Largura",
  T_50_HZY_REVIEW_TEXTOBJ: "Conteúdo de objeto de texto",
  T_50_JH_WS_HIDEMAPERROR: "Não é possível ocultar o minimapa sem uma imagem de capa personalizada",
  T_50_JH_WS_HIDEMAPTIP: "Se o minimapa for ocultado, ele não será mais usado como imagem de capa",
  T_50_JH_WS_HIDEMINIMAP: "Esconder Minimapa",
  T_50_META_API_10073_P0: "Nome do Arquivo",
  T_50_META_API_10073_P0_D: "O nome do arquivo",
  T_50_META_API_10073_P1_D: "Resultado da execução. Verifique o código de status enum.",
  T_50_META_API_1102: "Ler Coluna da Planilha de Banco de Dados",
  T_50_META_API_1102_D: "Recupera o valor de uma coluna específica para uma chave definida de uma tabela padrão do banco de dados",
  T_50_META_API_1102_P3: "Índice da Coluna",
  T_50_META_API_1102_P3_D: "O índice da coluna da tabela de banco de dados (0 = primeira coluna)",
  T_50_META_API_1106: "Criar performance",
  T_50_META_API_1106_D: "Criar uma entidade de performance",
  T_50_META_API_1106_P0_D: "O item de performance",
  T_50_META_API_1111: "Ler valor da associação de placar do banco de dados",
  T_50_META_API_1111_D: "Ler a combinação de valores de um placar e da tabela associada no banco de dados",
  T_50_META_API_1111_P5: "Código de status da associação",
  T_50_META_API_1111_P5_D: "Código de erro de associação",
  T_50_META_API_1112: "Ler valores da associação de placar por intervalo no banco de dados",
  T_50_META_API_1112_D: "Ler valores do placar dentro de uma faixa de patente, ler os valores correspondentes pelas chaves recuperadas da tabela associada e combiná-los.",
  T_50_META_API_1112_P6: "Código de status da associação",
  T_50_META_API_1112_P6_D: "Código de erro de associação",
  T_50_META_API_1113: "Gravar valor da associação de placar no banco de dados",
  T_50_META_API_1113_D: "Gravar o valor de uma chave específica no placar e na tabela relacionada do banco de dados",
  T_50_META_API_1113_P5: "Código de status da associação",
  T_50_META_API_1113_P5_D: "Código de erro de associação",
  T_50_META_API_114_D: "Criar interface personalizada",
  T_50_META_API_114_P0_D: "O código é usado como nome de parâmetro para criar uma entidade de interface, e o valor da variável local correspondente representa a entidade criada.",
  T_50_META_API_114_P1_D: "A entidade jogador a que pertence, visível apenas para o jogador.",
  T_50_META_API_114_P2: "ID do item de interface",
  T_50_META_API_114_P2_D: "ID do item de interface personalizado",
  T_50_META_API_115_D: "Criar a interface personalizada especificada",
  T_50_META_API_116: "Definir destaque do objeto no nível",
  T_50_META_API_116_D: "Definir o status de destaque do objeto. Pode ser afetado por outras lógicas dentro do jogo.",
  T_50_META_API_116_P0_D: "Objeto alvo",
  T_50_META_API_116_P1_D: "Status de destaque",
  T_50_META_API_117: "Operação bit a bit comum",
  T_50_META_API_117_D: "Operações bit a bit: e/ou/xor/shift esquerdo/shift direito",
  T_50_META_API_117_P0_D: "Valor à esquerda",
  T_50_META_API_117_P1_D: "Valor à direita",
  T_50_META_API_117_P2_D: "Tipo de operação",
  T_50_META_API_118: "Operação bit a bit NOT",
  T_50_META_API_118_D: "Operação bit a bit NOT, também conhecida como complemento bit a bit.",
  T_50_META_API_118_P0_D: "Valor",
  T_50_META_API_119: "Lista para Int. bit a bit",
  T_50_META_API_119_D: "Executar bit a bit OU operação em todos os elementos da lista e transformar a saída em um valor inteiro.",
  T_50_META_API_119_P0: "Matriz de bit",
  T_50_META_API_119_P0_D: "Matriz bit a bit",
  T_50_META_API_120: "Int. para Lista bit a bit",
  T_50_META_API_120_D: "Converter os valores decimais representados pelos bits na posição 1 de um inteiro, em sua forma binária, para uma lista",
  T_50_META_API_120_P0_D: "Inteiro",
  T_50_META_API_121: "Ângulo de quaternário",
  T_50_META_API_121_D: "Calcular o ângulo entre dois quartenários",
  T_50_META_API_121_P0_D: "Quaternário 1",
  T_50_META_API_121_P1_D: "Quaternário 2",
  T_50_META_API_122: "Produto escalar de quaternário",
  T_50_META_API_122_D: "Calcular o produto escalar de dois quartenários",
  T_50_META_API_123: "Quaternário inverso",
  T_50_META_API_123_D: "Calcular o inverso de um quartenário",
  T_50_META_API_123_P0_D: "Quaternário",
  T_50_META_API_124: "Rotação de Quaternário: De → Para",
  T_50_META_API_124_D: 'Calcular o quartenário de rotação de "de" para "para"',
  T_50_META_API_124_P0_D: "O ponto inicial",
  T_50_META_API_124_P1_D: "O ponto final",
  T_50_META_API_125: "Girar Quaternário em Direção a",
  T_50_META_API_125_D: 'Calcular o quartenário de rotação de "de" para "para". Diferença máx. em graus é o ângulo máx. de rotação.',
  T_50_META_API_125_P0: "De",
  T_50_META_API_125_P0_D: "Quaternário inicial",
  T_50_META_API_125_P1: "Para",
  T_50_META_API_125_P1_D: "Quaternário de destino",
  T_50_META_API_125_P2: "Delta de Graus Máx.",
  T_50_META_API_125_P2_D: "O ângulo máx. de rotação",
  T_50_META_API_126: "Obter Orientação do Giroscópio",
  T_50_META_API_126_D: "Orientação do dispositivo no espaço 3D, representando os ângulos de rotação nos três eixos.",
  T_50_META_API_127: "Obter Gravidade do Giroscópio",
  T_50_META_API_127_D: "O componente de gravidade detectado pelo sensor do seu dispositivo",
  T_50_META_API_128: "Obter Taxa de Rotação do Giroscópio",
  T_50_META_API_128_D: "Isso se refere à taxa de rotação de um dispositivo. É um termo relacionado aos sensores giroscópicos que descreve a velocidade do movimento rotacional do dispositivo em um espaço tridimensional.",
  T_50_META_API_129: "Obter Rotação Sem Viés do Giroscópio",
  T_50_META_API_129_D: "Descreve a taxa de rotação do dispositivo e fornece um resultado mais preciso ao compensar o ruído ou o viés dos sensores.",
  T_50_META_API_130: "Obter Aceleração do Usuário pelo Giroscópio",
  T_50_META_API_130_D: "Parte da aceleração do dispositivo com o componente gravitacional removido, ou seja, a aceleração causada por ações do usuário ou forças externas.",
  T_50_META_API_131: "Obter Informações de Toque",
  T_50_META_API_131_D: "Obtém as informações de toque da tela para o índice especificado (incluindo posição, deslocamento e tempo da mudança).",
  T_50_META_API_131_P0_D: "Distribui os IDs dos pontos de toque, começando do 0",
  T_50_META_API_131_P1_D: "Posição de toque",
  T_50_META_API_131_P2: "Posição Delta",
  T_50_META_API_131_P2_D: "A mudança de posição em comparação com o último quadro",
  T_50_META_API_131_P3: "Tempo Delta",
  T_50_META_API_131_P3_D: "Tempo decorrido desde o último quadro",
  T_50_META_API_132: "Obter Contagem de Toques na Tela",
  T_50_META_API_132_D: "Obtém o número atual de pontos de toque na tela",
  T_50_META_API_133: "Vibrar Dispositivo",
  T_50_META_API_133_D: "Fazer o dispositivo vibrar uma vez",
  T_50_META_API_134_D: "Notificar o dispositivo do jogador alvo para tocar o áudio",
  T_50_META_API_134_P0_D: "O jogador alvo",
  T_50_META_API_134_P1_D: "O item de áudio",
  T_50_META_API_134_P2_D: "A velocidade de reprodução (intervalo válido: 0.1~3.0; 1 = normal, <1 = mais lento, >1 = mais rápido)",
  T_50_META_API_135_D: "Reproduz o arquivo de áudio uma única vez",
  T_50_META_API_135_P0_D: "Recursos de áudio",
  T_50_META_API_135_P1_D: "Velocidade de reprodução",
  T_50_META_API_136: "Formatar sentença",
  T_50_META_API_136_D: "Formatar as sentenças",
  T_50_META_API_136_P0_D: "Sentenças formatadas que usam comandos de formatação Go",
  T_50_META_API_136_P1: "Matriz de parâmetros",
  T_50_META_API_136_P1_D: "Lista de parâmetros",
  T_50_META_API_137: "Colar componente",
  T_50_META_API_137_D: "Copiar ou adicionar dados de componente",
  T_50_META_API_137_P0: "Fonte",
  T_50_META_API_137_P0_D: "A entidade de origem",
  T_50_META_API_137_P1_D: "Entidade alvo",
  T_50_META_API_137_P2: "Tipo de componente",
  T_50_META_API_137_P2_D: "Tipo de componente",
  T_50_META_API_137_P3: "É Sucesso",
  T_50_META_API_137_P3_D: "Se foi bem-sucedido ou não",
  T_50_META_API_138: "Reviver no próximo quadro",
  T_50_META_API_138_D: "Reviver no próximo quadro",
  T_50_META_API_139: "Eliminar no próximo quadro",
  T_50_META_API_139_D: "Eliminar a entidade batalha no próximo quadro",
  T_50_META_API_139_P0_D: "A entidade batalha",
  T_50_META_API_140: "Fechar jogo no próximo quadro",
  T_50_META_API_140_D: "Sair do jogo no próximo quadro",
  T_50_META_API_141: "Obter Volume do Microfone",
  T_50_META_API_141_D: "Obter o volume do microfone. Retorna o status quando o microfone do jogador está desligado ou sem acesso.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "O volume do microfone",
  T_50_META_API_141_P1_D: "Microfone está ligado ou desligado",
  T_50_META_API_142: "Obter qualidade de renderização",
  T_50_META_API_142_D: "Obter a qualidade de renderização atual (enum: Baixa/Média/Alta/Ultra)",
  T_50_META_API_143: "Obter resolução de renderização",
  T_50_META_API_143_D: "Obter a resolução de renderização atual",
  T_50_META_API_144: "Vincular Jogador personalizado",
  T_50_META_API_144_D: 'Define dinamicamente o alvo ao qual este jogador será vinculado, substituindo vínculos existentes. Retorna "falso" se falhar.',
  T_50_META_API_144_P0: "Jogador personalizado",
  T_50_META_API_144_P0_D: "Após vincular este Jogador Personalizado ao jogador, dados como posição e direção serão sincronizados automaticamente",
  T_50_META_API_144_P1_D: "Jogador alvo",
  T_50_META_API_145: "Desvincular Jogador personalizado",
  T_50_META_API_145_D: 'Cancelar o vínculo. Retorna "falso" se falhar.',
  T_50_META_API_145_P0: "Jogador personalizado",
  T_50_META_API_145_P0_D: "Limpar todos os vínculos deste alvo. Após desfazer o vínculo, dados como posição e direção não serão mais sincronizados automaticamente.",
  T_50_META_API_146_P0_D: "Um jogador personalizado",
  T_50_META_API_147: "Definir Estado do Jogador personalizado",
  T_50_META_API_147_D: 'Enviar automaticamente para o servidor e sincronizar com todos os clientes. Retorna "falso" se falhar.',
  T_50_META_API_147_P0: "Jogador personalizado",
  T_50_META_API_147_P1: "Estado",
  T_50_META_API_147_P1_D: "Geralmente usado para salvar os estados da animação. Obter o estado sincronizado com Obter Estado do Jogador personalizado.",
  T_50_META_API_148: "Obter Estado do Jogador personalizado",
  T_50_META_API_148_D: 'Os dados de estado são sincronizados automaticamente com o servidor. Retorna "falso" se falhar.',
  T_50_META_API_148_P0: "Jogador personalizado",
  T_50_META_API_148_P1: "Estado",
  T_50_META_API_148_P1_D: "Definir o estado com Definir Estado do Jogador personalizado",
  T_50_META_API_149: "Definir Volumes por distância",
  T_50_META_API_149_D: "Definir as faixas de distância entre jogadores para ajustar dinamicamente o volume de áudio.",
  T_50_META_API_149_P0: "Lista de distância",
  T_50_META_API_149_P0_D: "Uma lista de faixas de distância, cada uma correspondendo a um item na lista de volume.",
  T_50_META_API_149_P1: "Lista de volume",
  T_50_META_API_149_P1_D: "Uma lista de volumes, cada um correspondendo a um item na lista de distância.",
  T_50_META_API_150: "Obter Amigos",
  T_50_META_API_150_D: "Obter a lista de IDs de amigos do jogador",
  T_50_META_API_151: "Obter informações de interface padrão",
  T_50_META_API_151_D: "Obter a posição padrão da interface do jogador",
  T_50_META_API_151_P0_D: "A interface padrão",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "Posição da interface",
  T_50_META_API_151_P3: "Tamanho",
  T_50_META_API_151_P3_D: "Tamanho da interface",
  T_50_META_API_152: "Transmitir evento personalizado",
  T_50_META_API_152_D: "Transmitir um evento personalizado para qualquer entidade receber (ouvir) este evento",
  T_50_META_API_153: "Despachar evento para entidade",
  T_50_META_API_153_D: "Enviar o evento personalizado para a entidade de destino",
  T_50_META_EVT_17: "Ao Tocar na Tela: Início",
  T_50_META_EVT_17_D: "Iniciar o evento ao tocar na tela",
  T_50_META_EVT_17_P0: "Índice do toque",
  T_50_META_EVT_17_P0_D: "Índice do ponto de toque",
  T_50_META_EVT_17_P1_D: "Posição de toque",
  T_50_META_EVT_18: "Ao Tocar na Tela: Fim",
  T_50_META_EVT_18_D: "Finalizar o evento ao soltar o toque na tela",
  T_50_META_EVT_18_P0: "Índice do toque",
  T_50_META_EVT_18_P0_D: "Índice do ponto de toque",
  T_50_META_EVT_18_P1_D: "Posições dos toques na tela",
  T_50_META_EVT_19: "Ao receber resultado de criação de Sala de persona",
  T_50_META_EVT_19_D: "Receber o resultado ao falhar na criação de sala de chat com persona",
  T_50_META_EVT_19_P1: "ID da Sala",
  T_50_META_EVT_19_P1_D: "O ID da sala",
  T_50_META_EVT_20: "Ao Usuário Sair ou Partida do Usuário Terminar",
  T_50_META_EVT_20_D: "Aciona quando o jogador sai da partida ou quando ela termina",
  T_50_META_TYP_11_I44: "Volumes de Distância",
  T_50_META_TYP_11_I44_D: "Ajusta dinamicamente o volume de áudio com base na distância entre os jogadores",
  T_50_META_TYP_22_I9_D: "ID do item usado para criar a interface",
  T_50_META_TYP_244_I12_D: "Largura da caixa de texto",
  T_50_META_TYP_244_I13_D: "Altura da caixa de texto",
  T_50_META_TYP_244_I14_D: "Tipo de transbordamento",
  T_50_META_TYP_335_I10_D: "Velocidade de reprodução (valor válido > 0, padrão = 1)",
  T_50_META_TYP_409_I20: "IO_Criar_Arquivo_Falhou",
  T_50_META_TYP_409_I20_D: "Falha na operação de E/S: ocorreu um erro ao criar o arquivo.",
  T_50_META_TYP_409_I21: "IO_Nome_Arquivo_Inválido",
  T_50_META_TYP_409_I21_D: "Falha na operação de E/S. Nome de arquivo inválido.",
  T_50_META_TYP_448_I0_D: "A parte controlada do esqueleto",
  T_50_META_TYP_448_I1_D: "O alvo que a parte do esqueleto está olhando",
  T_50_META_TYP_451: "Tipo de Estouro",
  T_50_META_TYP_451_D: "O método para lidar com o transbordamento de texto.",
  T_50_META_TYP_452: "ID do item de interface personalizada",
  T_50_META_TYP_452_D: "O ID que descreve o item de HUD personalizada",
  T_50_META_TYP_453: "Tipo de qualidade de renderização",
  T_50_META_TYP_453_D: "Enum de qualidade de renderização",
  T_50_META_TYPE_448_D: "Essa entidade é usada para fazer a parte do esqueleto olhar para um alvo",
  T_50_SD_WS_MAPTAG_AI3DGEN: "Gerar Mapa com Objeto 3D",
  T_50_SD_WS_MAPTAG_AIRACING: "Gerar Mapa de Corrida com IA",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Enum de nome de estado de animação",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Desativar vibração dos passos",
  T_50_XXJ_WS_NOPERFORMANCE: "Nenhum arquivo de desempenho",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Versão beta",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "E aí, Criadores! O editor de desempenho ainda está em fase de testes. Pode faltar recursos essenciais ou conter falhas. Use com cautela.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Adicionar desempenho",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Adicionar clipe-chave",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Seguir Trilha",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animação",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Trilha de Animação",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Trilha de Áudio",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Segurar",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Repetir para Sempre",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duração: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Incompatibilidade entre animação e modelo",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Sobreposição de clipes-chave",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Falta entidade vinculada",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "O nome da trilha não pode estar vazio",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "Trilha de NPC",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Trilha de Propriedade",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Remover clipe-chave",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Limite de trilhas atingido",
  T_50_XYL_WS_AIGETERATESHOW: "Blocos de Construção",
  T_50_YU_F_B_VA_WITCH: "Bruxa Sombria (Pernas)",
  T_50_YU_F_H_VA_WITCH: "Bruxa Sombria (Cabeça)",
  T_50_YU_F_HA_VA_WITCH: "Bruxa Sombria (Pintura facial)",
  T_50_YU_F_S_VA_WITCH: "Bruxa Sombria (Calçado)",
  T_50_YU_F_T_VA_WITCH: "Bruxa Sombria (Torso)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Personalizar evento",
  T_51_GT_WS_BASIC: "Básico",
  T_51_GT_WS_GLOBALEVENT: "Evento global",
  T_51_GT_WS_PRIVATEEVENT: "Evento Privado",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "Interface",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Preparation time before game starts",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Propriedade Somente Leitura",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Jaqueta de Couro Preta (Fem)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Encanadora (Pernas)",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Black Activewear (Calçado)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Shorts de GW2018(Feminino)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Saia de GW2018 (Feminino)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Black Activewear (Moletom)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Top típico Songkran",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Encanadora (Torso)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Regata de GW2018 (Feminina)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Prosperidade Branca (Pernas)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Calças Pretas (Masculino)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Caçador",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Calças Sobrevivente",
  TXT_AVATAR_MALE_PANTS_MARIO: "Encanador (Pernas)",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Tênis Sobrevivente",
  TXT_AVATAR_MALE_SHOE_RED: "Botas Vermelhas(M)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Prosperidade Branca (Torso)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Camiseta de Beisebol",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Hoodie Preto",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Estilo esportivo (Torso)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Roupa Rei Caveira",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Camisa Sobrevivente",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Encanador (Torso)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Casaco do Patrocinador (F)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Palhaço Noturno (Cabeça)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Casaco do Patrocinador (M)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Jaqueta sem mangas (verde)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Mr. Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Samurai Zumbificado (Máscara)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Tatuagem Braço Cheio",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Abraço",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Calça Angelical (F)",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Calçado Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Sapato Esportivo",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Shorts Jeans",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Tunica Kitsune",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Calças de combate",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Calça Angelical (M)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Bushido",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Moletom Cinza",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Sapatos Hipster",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Calçado Bushido",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Sapatos Astro",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Shorts Jeans",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Colete de Combate",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Top Hipster",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Caminho do Bushido!",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Furacão branco",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseballer",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Jaqueta da Asus",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseballer",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Capitão Maneiro",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Mestre de Cerimônias",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Capitão Maneiro",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Jaqueta da Asus",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Capitão Maneiro",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Bota Prata",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Três leões",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Smoking (mascara)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Smoking (Cabeça)",
  TXT_AVATAR_PARACHUTE_8: "Paraquedas - Sorriso",
  TXT_AVATAR_SHIRT_PLAID_2: "Favorito dos programadores (Vermelho)",
  TXT_AVATAR_SHOES_1: "Tênis(branco)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Uniforme Escolar (Laranja)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Uniforme Escolar (Vermelho)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Uniforme Escolar (Amarelo)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Uniforme Escolar (Rosa)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Uniforme Escolar (Branco)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Uniforme Escolar (Azul escuro)",
  TXT_AVATAR_TSHIRT_WEEK_007: "Domingo Apaixonado",
  TXT_BANNER_NAME_MISHA: "Banner Velocidade",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Nome da Guilda",
  TXT_COLLECTION_DESCRIPTION: "Descrição",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Equipamento",
  TXT_ITEM_AK: "AK",
  TXT_ITEM_ARAMMO: "munição de AR",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Mochila Nv. 1",
  TXT_ITEM_BAG2: "Mochila Nv. 2",
  TXT_ITEM_BAG3: "Mochila Nv. 3",
  TXT_ITEM_BASEBALLPOLE: "Bastão",
  TXT_ITEM_BOWAMMO: "Flecha de Balestra",
  TXT_ITEM_CHANGUO: "Panela",
  TXT_ITEM_CROSSBOW: "Balestra",
  TXT_ITEM_DESC_FLASH: "Um dispositivo explosivo que pode temporariamente desorientar o sentido dos oponentes.",
  TXT_ITEM_EAGLE: "Águia do Deserto",
  TXT_ITEM_FAK: "Kit Médico",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Punhos",
  TXT_ITEM_FLASH: "Granada de Luz",
  TXT_ITEM_FOREGRIP1: "Empunhadura Nv. 1",
  TXT_ITEM_FOREGRIP2: "Empunhadura Nv. 2",
  TXT_ITEM_FOREGRIP3: "Empunhadura Nv. 3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Granada",
  TXT_ITEM_GROZA: "Groza",
  TXT_ITEM_HANDCANNON: "Canhão de Mão",
  TXT_ITEM_HEATSIGHT: "Mira Térmica",
  TXT_ITEM_HELMET1: "Capacete Nv. 1",
  TXT_ITEM_HELMET2: "Capacete Nv. 2",
  TXT_ITEM_HELMET3: "Capacete Nv. 3",
  TXT_ITEM_HGAMMO: "munição de HG",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Machete",
  TXT_ITEM_MAGEZINE1: "Cartucho Nv. 1",
  TXT_ITEM_MAGEZINE2: "Cartucho Nv. 2",
  TXT_ITEM_MAGEZINE3: "Cartucho Nv. 3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Bocal Nv. 1",
  TXT_ITEM_MUZZLE2: "Bocal Nv. 2",
  TXT_ITEM_MUZZLE3: "Bocal Nv. 3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "munição de SG",
  TXT_ITEM_SIGHT2: "Mira 2x",
  TXT_ITEM_SIGHT4: "Mira 4x",
  TXT_ITEM_SILENCER1: "Silenciador",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "Munição de SMG",
  TXT_ITEM_SNAMMO: "Munição: fuzil prec.",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Colete Nv. 1",
  TXT_ITEM_VEST2: "Colete Nv. 2",
  TXT_ITEM_VEST3: "Colete Nv. 3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Resultado",
  TXT_MESSAGEBOX_ERROR: "Erro",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipod",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Barril de Óleo",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Energia da Vila",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Bastão - Milho Grelhado Mexicano",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Areá de explosão",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Machete - O Carrasco",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Minas Terrestres",
  TXT_OB11_HQW_LANDMINE_DESC: "Uma mina que pode ser implantada no solo. Atenção, não pise você também!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Aplauso",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Galinha",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Olá!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provocar",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Ao segurar uma espingarda, a velocidade de movimento aumenta em [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Extremamente Ágil",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Chita: Presa",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Futurista",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Kit de Reparo",
  TXT_OB5_HISTORY_HEADSHOOT: "Capas",
  TXT_OB5_HISTORY_LIVE: "Sobrevivência",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Reduz o tempo para usar kits médicos e comer cogumelos em [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Glutonaria",
  TXT_OB7_ZC_CLAN_NICKNAME: "Nome da Guilda",
  TXT_OB7_ZJS_HISTORY_TIME: "Tempo",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Fogueira",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Paraquedas - Relâmpago",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Aumenta o dano do punho em [FFB300]{0}%[-].",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Prados Roxos",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Atom Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Marchito",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Trovão",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Leopardo da neve",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Senhora das Armas",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Prancha - Estrela verde",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Parede de Gel",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Camuflagem Digital",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Sangrenta",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Caçador do deserto",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Chama Azul",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Desfile Roxo",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Fluxo de vida",
  TXT_OB9_ZXR_M1873_NAME: "Mar Azul",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Machete - Peixe-Espada",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Segador",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Quartzo Roxo",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Terra arrasada",
  TXT_OPTION_HIGH_BRIGHTNESS: "Brilho",
  TXT_PLAYER_RANK: "PATENTE",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Botão para troca rápida de arma",
  TXT_SETTING_OB4_NOTREAL: "Escuro",
  TXT_SKILL_DESC_COP: "A perda de durabilidade da armadura diminui em [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "A velocidade de corrida aumenta em [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Especialista de armaduras",
  TXT_SKILL_NAME_NURSE: "Toque de cura",
  TXT_SKILL_NAME_RACERGIRL: "Acelerando",
  TXT_SKILL_NAME_RUNNER: "Corrida",
  TXT_SKILL_NAME_SEAMAN: "Vontade de Ferro",
  TXT_TUTORIAL_HUD: "Interface",
  TXT_TUTORIAL_HUD_LABEL10: "Correr",
  TXT_TUTORIAL_PICKUP_LABEL0: "Arma",
  T_34_M_WS_VFXTYPE: "Tipo de Efeito Visual",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Alvo de Ataque",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Tipo de Interface do Jogador",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Tipo de Habilidade de Monstro",
  T_45_META_WS_DESCRIPTIVECOLOR: "Cor Descritiva",
  T_45_META_WS_GAMETIME: "Hora do jogo",
  T_45_META_WS_PROPERTY: "Propriedade",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Interface do tipo de estilo de botão social",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Interface de tipo de botão social",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Gatilho",
  T_46_META_WS_A_ACCOUNTID: "ID da conta",
  T_46_META_WS_A_ACTIONTYPE: "Valor à Direita",
  T_46_META_WS_A_ACTIVE: "Posição",
  T_46_META_WS_A_ANGLE: "Ângulo",
  T_46_META_WS_A_ANY: "Qualquer",
  T_46_META_WS_A_APPEARANCEGROUP: "Posição Alvo",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Expressão de asserção",
  T_46_META_WS_A_ATTACHMENT: "Altura",
  T_46_META_WS_A_ATTACHMENTS: "Comprimento",
  T_46_META_WS_A_ATTACKABLE: "Item",
  T_46_META_WS_A_ATTACKER: "Atacante",
  T_46_META_WS_A_ATTACKTARGET: "Alvo de ataque",
  T_46_META_WS_A_AUTOPLAY: "Normal",
  T_46_META_WS_A_AXIS: "Qualquer",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Base",
  T_46_META_WS_A_BOUNDTARGET: "Alvo vinculado",
  T_46_META_WS_A_BTREE: "Árvore de comportamento",
  T_46_META_WS_A_BUFF: "Índice",
  T_46_META_WS_A_CAMERA: "ID de Missão",
  T_46_META_WS_A_CAPICITY: "Capacidade",
  T_46_META_WS_A_CENTER: "Centro",
  T_46_META_WS_A_CHANGEROTATION: "Encontrar Valor",
  T_46_META_WS_A_CHANNEL: "Canal",
  T_46_META_WS_A_CHASEENEMY: "Valor à Esquerda",
  T_46_META_WS_A_CHILD: "B",
  T_46_META_WS_A_COLOR: "Cor",
  T_46_META_WS_A_COLUMN: "Esquerda",
  T_46_META_WS_A_COLUMNNAME: "Direita",
  T_46_META_WS_A_COMEBACK: "Voltar",
  T_46_META_WS_A_COMPONENT: "Componente",
  T_46_META_WS_A_CONTENT: "Conteúdo",
  T_46_META_WS_A_COORDINATESYSTEM: "Tipo de Filtro",
  T_46_META_WS_A_COUNT: "Contagem",
  T_46_META_WS_A_COUNTS: "Contagens",
  T_46_META_WS_A_CREATEDENTITY: "Entidade criada",
  T_46_META_WS_A_CROSSPLATFORM: "Plataforma cruzada",
  T_46_META_WS_A_CULLINGMASK: "Máscara de recorte",
  T_46_META_WS_A_CURVE: "Direção",
  T_46_META_WS_A_CUSTOMTAG: "Quantidade",
  T_46_META_WS_A_CUTRADIUS: "Raio de corte",
  T_46_META_WS_A_DAMAGE: "Dano",
  T_46_META_WS_A_DAMAGESEGMENTS: "Segmentos de dano",
  T_46_META_WS_A_DEGREE: "Grau",
  T_46_META_WS_A_DELTA: "ValorB",
  T_46_META_WS_A_DEPTH: "Profundidade",
  T_46_META_WS_A_DESTVAL: "R",
  T_46_META_WS_A_DIFFICULTY: "Dificuldade",
  T_46_META_WS_A_DIRECTION: "Direção",
  T_46_META_WS_A_DISABLE: "Raio",
  T_46_META_WS_A_DISPLACEMENT: "Deslocamento",
  T_46_META_WS_A_DISTANCE: "Conteúdo",
  T_46_META_WS_A_DIVINGMAXSPEED: "Velocidade máxima de mergulho",
  T_46_META_WS_A_DOTWEEN: "Aplicar Transição",
  T_46_META_WS_A_DURATION: "Duração (s)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "Habilitar",
  T_46_META_WS_A_ENDAREACENTER: "Centro da área final",
  T_46_META_WS_A_ENDAREARANGE: "Faixa da área final",
  T_46_META_WS_A_ENDPOSITION: "Posição final",
  T_46_META_WS_A_ENDRANK: "Classificação final",
  T_46_META_WS_A_EQUIPMENTS: "Rotação",
  T_46_META_WS_A_EVENTID: "ID do evento",
  T_46_META_WS_A_EXPONENT: "Exponente",
  T_46_META_WS_A_FACTION: "Grupo",
  T_46_META_WS_A_FACTORTYPE: "Tipo de fator",
  T_46_META_WS_A_FILTERTYPE: "Tipo de filtro",
  T_46_META_WS_A_FINALRADIUS: "Raio final",
  T_46_META_WS_A_FINDVALUE: "Encontrar valor",
  T_46_META_WS_A_FIXEDRANGE: "Dicas",
  T_46_META_WS_A_FOLLOWTARGET: "Acompanhar o alvo",
  T_46_META_WS_A_FONTCOLOR: "Cor da fonte",
  T_46_META_WS_A_FONTSIZE: "Tamanho da fonte",
  T_46_META_WS_A_FOOTBALL: "Objeto de Nível",
  T_46_META_WS_A_FORCE: "Propriedade",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Altura do paraquedas forçada",
  T_46_META_WS_A_FORCEMODE: "Tipo de Modificação",
  T_46_META_WS_A_FORWARD: "Direção",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID de Widget",
  T_46_META_WS_A_HALFEXTENTS: "ID de Propriedade",
  T_46_META_WS_A_HEIGHT: "Altura",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Segmentos de altura",
  T_46_META_WS_A_HITDISTANCE: "Distância do impacto",
  T_46_META_WS_A_HITDISTANCES: "Componente",
  T_46_META_WS_A_HITENTITIES: "Estilo",
  T_46_META_WS_A_HITENTITY: "Entidade atingida",
  T_46_META_WS_A_HITNORMAL: "Normal do impacto",
  T_46_META_WS_A_HITNORMALS: "ID do Evento",
  T_46_META_WS_A_HITPOINTS: "Posições",
  T_46_META_WS_A_HITPOSITION: "Posição do impacto",
  T_46_META_WS_A_INCLUDETRIGGER: "Voltar",
  T_46_META_WS_A_INDEX: "Índice",
  T_46_META_WS_A_INDEXS: "Índices",
  T_46_META_WS_A_INITIALVELOCITY: "Deslocamento",
  T_46_META_WS_A_INITRADIUS: "Raio inicial",
  T_46_META_WS_A_INWALLET: "Carteira de entrada",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Carteira de Entrada",
  T_46_META_WS_A_ISEXIST: "Existência",
  T_46_META_WS_A_ISLOOP: "Loop",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Mapeado na tela",
  T_46_META_WS_A_ISPAUSE: "Pausa",
  T_46_META_WS_A_ISSIDECOLLIDING: "Carteira de Saída",
  T_46_META_WS_A_ISSUCCESS: "Sucesso",
  T_46_META_WS_A_ISTOPCOLLIDING: "Tipo de Moeda",
  T_46_META_WS_A_ITEM: "Item",
  T_46_META_WS_A_ITEMID: "Está Pausado",
  T_46_META_WS_A_ITEMS: "Itens",
  T_46_META_WS_A_ITEMTYPE: "Emote",
  T_46_META_WS_A_JERSEYTYPE: "Tipo de camiseta",
  T_46_META_WS_A_KEEPVELOCITY: "ID de Token",
  T_46_META_WS_A_KEY: "Chave",
  T_46_META_WS_A_KEYCOLUMN: "ValorA",
  T_46_META_WS_A_KEYS: "Largura",
  T_46_META_WS_A_LAYER: "Camada",
  T_46_META_WS_A_LAYERMASK: "Slot",
  T_46_META_WS_A_LEFT: "Esquerda",
  T_46_META_WS_A_LEFTVALUE: "Valor esquerdo",
  T_46_META_WS_A_LENGTH: "Comprimento",
  T_46_META_WS_A_LEVELOBJECT: "Objeto de nível",
  T_46_META_WS_A_LOG: "Ângulo",
  T_46_META_WS_A_LOOKATTARGET: "Itens",
  T_46_META_WS_A_LOOPTYPE: "Tipo de Loop",
  T_46_META_WS_A_MAINCOLOR1: "Índice de Fase",
  T_46_META_WS_A_MAINCOLOR2: "Status",
  T_46_META_WS_A_MAPCODE: "Cor",
  T_46_META_WS_A_MAPPEDPOSITION: "Posição mapeada",
  T_46_META_WS_A_MAX: "Máximo",
  T_46_META_WS_A_MAXDISPLACEMENT: "Deslocamento Máx.",
  T_46_META_WS_A_MAXDISTANCE: "Tipo de Fator",
  T_46_META_WS_A_MIN: "Mínimo",
  T_46_META_WS_A_MISSIONID: "ID da missão",
  T_46_META_WS_A_MISSIONPROGRESS: "Progresso da missão",
  T_46_META_WS_A_MODIFYTYPE: "Tipo de modificação",
  T_46_META_WS_A_MONEYTYPE: "Tipo de moeda",
  T_46_META_WS_A_MUST: "Obrigatório",
  T_46_META_WS_A_NAME: "Proprietário",
  T_46_META_WS_A_NEWVALUE: "Novo valor",
  T_46_META_WS_A_NODE: "Nó",
  T_46_META_WS_A_NORMAL: "Normal",
  T_46_META_WS_A_NOT: "Não",
  T_46_META_WS_A_OBSERVER: "Observador",
  T_46_META_WS_A_OFFSET: "Deslocamento",
  T_46_META_WS_A_OLDVALUE: "Valor antigo",
  T_46_META_WS_A_OPERATIOMETHOD: "Método de operação",
  T_46_META_WS_A_OPTIONS: "Opções",
  T_46_META_WS_A_OTHERCOLOR: "Entidade Criada",
  T_46_META_WS_A_OUTFIT: "Índice Inicial",
  T_46_META_WS_A_OUTFITS: "Separador",
  T_46_META_WS_A_OUTWALLET: "Carteira de saída",
  T_46_META_WS_A_OWNER: "Proprietário",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Velocidade máxima de paraquedismo",
  T_46_META_WS_A_PARAMS: "Parâmetros",
  T_46_META_WS_A_PARENT: "G",
  T_46_META_WS_A_PARENTWIDGET: "Alvo de Ataque",
  T_46_META_WS_A_PATH: "Raio Inicial",
  T_46_META_WS_A_PATHPOINTS: "Pontos do caminho",
  T_46_META_WS_A_PHASEINDEX: "Índice de fase",
  T_46_META_WS_A_PLATFORM: "Plataforma",
  T_46_META_WS_A_PLAYER: "Jogador",
  T_46_META_WS_A_PLAYSPEED: "Duração (s)",
  T_46_META_WS_A_POSITION: "Posição",
  T_46_META_WS_A_POSITIONS: "Posições",
  T_46_META_WS_A_POSTION: "Posição",
  T_46_META_WS_A_PREFAB: "ID da Cena",
  T_46_META_WS_A_PROPERTY: "Propriedade",
  T_46_META_WS_A_PROPERTYID: "ID da propriedade",
  T_46_META_WS_A_PURSUITTARGET: "Alvo de perseguição",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Raio",
  T_46_META_WS_A_RANDOMDECAY: "Chave",
  T_46_META_WS_A_RANDOMRANGE: "Faixa aleatória",
  T_46_META_WS_A_RANDOMRATIO: "Parâmetros",
  T_46_META_WS_A_RANGE: "Expressão de Afirmativa",
  T_46_META_WS_A_RANK: "Classificação",
  T_46_META_WS_A_REALCOIN: "ID de UI",
  T_46_META_WS_A_REALNUMBER: "Número real",
  T_46_META_WS_A_RESET: "Redefinir",
  T_46_META_WS_A_RESOURCE: "Recurso",
  T_46_META_WS_A_RESULT: "Deve",
  T_46_META_WS_A_RIGHT: "Direita",
  T_46_META_WS_A_RIGHTVALUE: "Valor direito",
  T_46_META_WS_A_ROTATION: "Rotação",
  T_46_META_WS_A_ROW: "Máximo",
  T_46_META_WS_A_SAMPLEPOINT: "Ponto de amostragem",
  T_46_META_WS_A_SCALE: "Escala",
  T_46_META_WS_A_SCENEID: "ID da cena",
  T_46_META_WS_A_SCORE: "Pontuação",
  T_46_META_WS_A_SCORENAME: "Nome da pontuação",
  T_46_META_WS_A_SCREENPOSITION: "Posição na tela",
  T_46_META_WS_A_SCRIPT: "Raio Final",
  T_46_META_WS_A_SEAT: "Assento",
  T_46_META_WS_A_SEP: "Separador",
  T_46_META_WS_A_SEPSTR: "Separador",
  T_46_META_WS_A_SHEETNAME: "Mínimo",
  T_46_META_WS_A_SHOPITEM: "É Sucesso",
  T_46_META_WS_A_SHOWBACKGROUND: "Mostrar fundo",
  T_46_META_WS_A_SHOWMATCHRESULT: "Contagens",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Exibir mensagem ao cancelar",
  T_46_META_WS_A_SKILL: "Habilidade",
  T_46_META_WS_A_SKILLS: "Valor",
  T_46_META_WS_A_SKILLTARGET: "Alvo da habilidade",
  T_46_META_WS_A_SKIN: "Skin de Mochila",
  T_46_META_WS_A_SLOT: "Slot",
  T_46_META_WS_A_SRCVAL: "Grau",
  T_46_META_WS_A_SRCVALUE: "Valor de origem",
  T_46_META_WS_A_STARTAREACENTER: "Centro da área de início",
  T_46_META_WS_A_STARTAREARANGE: "Faixa da área de início",
  T_46_META_WS_A_STARTINDEX: "Índice inicial",
  T_46_META_WS_A_STARTPOSITION: "Posição inicial",
  T_46_META_WS_A_STARTRANK: "Classificação inicial",
  T_46_META_WS_A_STATE: "Tempo de Espera (s)",
  T_46_META_WS_A_STATUS: "Status",
  T_46_META_WS_A_STATUSCODE: "Código de status",
  T_46_META_WS_A_STYLE: "Estilo",
  T_46_META_WS_A_SURFINGMAXSPEED: "Velocidade máxima de surfe",
  T_46_META_WS_A_TARGET: "Alvo",
  T_46_META_WS_A_TARGETPOSITION: "Posição alvo",
  T_46_META_WS_A_TEAMSEQ: "Frente",
  T_46_META_WS_A_THRESHOLD: "Canal",
  T_46_META_WS_A_TIMESTAMP: "Carimbo de data/hora",
  T_46_META_WS_A_TIPS: "Dicas",
  T_46_META_WS_A_TITLE: "Título",
  T_46_META_WS_A_TOKENCOUNT: "Contagem de tokens",
  T_46_META_WS_A_TOKENID: "ID do token",
  T_46_META_WS_A_TORQUE: "Existe",
  T_46_META_WS_A_TOUCHPOINT: "Ponto de contato",
  T_46_META_WS_A_TRANSITIONTIME: "Contagem de Tokens",
  T_46_META_WS_A_TRANSITIONTYPE: "Progresso da Missão",
  T_46_META_WS_A_TRIGGER: "Gatilho",
  T_46_META_WS_A_TYPE: "Tipo",
  T_46_META_WS_A_UI: "Alvo de Perseguição",
  T_46_META_WS_A_UIID: "ID da UI",
  T_46_META_WS_A_UPWARD: "Tipo de Camisa",
  T_46_META_WS_A_VALUE: "Valor",
  T_46_META_WS_A_VALUEA: "Valor A",
  T_46_META_WS_A_VALUEB: "Valor B",
  T_46_META_WS_A_VALUES: "Raio de Corte",
  T_46_META_WS_A_VALUET: "Não Deve",
  T_46_META_WS_A_VALUETYPE: "Tipo de valor",
  T_46_META_WS_A_VEHICLE: "Veículo",
  T_46_META_WS_A_VEHICLESKIN: "Pele do veículo",
  T_46_META_WS_A_VELOCITY: "Centro",
  T_46_META_WS_A_VELOCITYXZ: "Novo Valor",
  T_46_META_WS_A_VELOCITYY: "Valor Antigo",
  T_46_META_WS_A_VISIBLE: "Visível",
  T_46_META_WS_A_WAITTIME: "Tempo de espera (s)",
  T_46_META_WS_A_WALLET: "Carteira",
  T_46_META_WS_A_WEAPON: "Separador",
  T_46_META_WS_A_WEAPONSKIN: "Índices",
  T_46_META_WS_A_WIDGETID: "ID do widget",
  T_46_META_WS_A_WIDGETTYPE: "Ativar",
  T_46_META_WS_A_WIDTH: "Largura",
  T_46_META_WS_A_WORLDPOSITION: "Posição no mundo",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Tipo",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Valor Absoluto",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Adicionar Acompanhamento Especial AOI",
  T_46_META_WS_ADDATTACHMENTS: "Adicionar Acessórios",
  T_46_META_WS_ADDBUFF: "Adicionar Buff",
  T_46_META_WS_ADDCOMPONENT: "Adicionar Componente",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Adicionar Velocidade à Bola",
  T_46_META_WS_ADDFORCE: "Adicionar Força",
  T_46_META_WS_ADDFORCEATPOSITION: "Adicionar Força na Posição",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Adicionar Fator de Propriedade de Fórmula",
  T_46_META_WS_ADDGAMEEVENTLOG: "Adicionar Log de Evento de Jogo",
  T_46_META_WS_ADDHP: "Adicionar HP",
  T_46_META_WS_ADDITEM: "Adicionar Item",
  T_46_META_WS_ADDITEMINSCENE: "Criar Item na Cena",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Adicionar Item ao Item",
  T_46_META_WS_ADDMONEY: "Adicionar Dinheiro",
  T_46_META_WS_ADDSCRIPT: "Adicionar Script",
  T_46_META_WS_ADDTAG: "Adicionar Etiqueta",
  T_46_META_WS_ADDTOKEN: "Adicionar Token",
  T_46_META_WS_ADDTORQUE: "Adicionar Torque",
  T_46_META_WS_ADDUSEREVENTLOG: "Adicionar Log de Evento de Usuário",
  T_46_META_WS_ANGEL: "Ângulo",
  T_46_META_WS_APPEND: "Adicionar",
  T_46_META_WS_APPENDRANGE: "Adicionar Faixa",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Aplicar Configuração de Saída Interrompida",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "Afirmação",
  T_46_META_WS_ASSISTPLAYER: "Jogador assistente",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Atacante",
  T_46_META_WS_ATTACKTARGET: "Alvo de Ataque",
  T_46_META_WS_AXISANGLETOQUATERNION: "Ângulo de Eixo para Quaternion",
  T_46_META_WS_BOXCAST: "Detecção de Caixa",
  T_46_META_WS_BOXOVERLAP: "Sobreposição de Caixa",
  T_46_META_WS_BUTTONNAME: "Nome do botão",
  T_46_META_WS_C_ACTIONTYPE: "Tipo de ação",
  T_46_META_WS_C_AIMABLE: "Componente que pode ser mirado",
  T_46_META_WS_C_AIMASSISTABLE: "Componente assistido para mira",
  T_46_META_WS_C_AIMASSISTTYPE: "Tipo de Assistência ao Alvo",
  T_46_META_WS_C_AIRDROP: "Caça aérea",
  T_46_META_WS_C_AMMO: "Munição",
  T_46_META_WS_C_AMMOTYPE: "Tipo de Munição",
  T_46_META_WS_C_AMPHIBIAN: "Anfíbio",
  T_46_META_WS_C_ANIMATIONCLIP: "Clíper de Animação",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID de Clip de Animação",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Controlador de Animação",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Controlador de Animação Anexável",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID de Controlador de Animação",
  T_46_META_WS_C_ANIMATIONSTATE: "Estado de Animação",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Gatilho de Animação",
  T_46_META_WS_C_APPEARENCE: "Aparência",
  T_46_META_WS_C_ASSETCONFIGID: "ID de configuração do ativo",
  T_46_META_WS_C_ASSETID: "ID do ativo",
  T_46_META_WS_C_ATTACHMENT: "Acessório",
  T_46_META_WS_C_ATTACKABLETYPE: "Tipo Atacável",
  T_46_META_WS_C_AUDIOID: "ID de Áudio",
  T_46_META_WS_C_BACKPACK: "Mochila",
  T_46_META_WS_C_BACKPACKSKINID: "ID de skin de mochila",
  T_46_META_WS_C_BASEDATAALIAS: "Alias de Dados Básicos",
  T_46_META_WS_C_BASICAPPEARANCE: "Aparência básica",
  T_46_META_WS_C_BASICCYLINDER: "Cilindro Básico",
  T_46_META_WS_C_BASICSCALABLE: "Escalável Básico",
  T_46_META_WS_C_BASICSPHERE: "Esfera Básica",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Componente de combinação por lote",
  T_46_META_WS_C_BEVTREE: "Árvore de Comportamento",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Árvore de Comportamento Anexável",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Nó Personalizado da Árvore de Comportamento",
  T_46_META_WS_C_BEVTREEID: "ID da Árvore de Comportamento",
  T_46_META_WS_C_BEVTREENODESTATUS: "Status do Nó da Árvore de Comportamento",
  T_46_META_WS_C_BEVTREENODETYPE: "Tipo de Nó da Árvore de Comportamento",
  T_46_META_WS_C_BEZIERCURVE: "Curva de Bezier",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Tipo de Dificuldade do Bot",
  T_46_META_WS_C_BOUNCINGTIRE: "Pneu Saltitante",
  T_46_META_WS_C_BUFFABLE: "Buffável",
  T_46_META_WS_C_BUFFGENERATOR: "Gerador de Buff",
  T_46_META_WS_C_BUFFTYPE: "Tipo de Buff",
  T_46_META_WS_C_BUILTINRENDER: "Renderização Integrada",
  T_46_META_WS_C_BUILTINUI: "Interface Integrada",
  T_46_META_WS_C_BUILTINUITYPE: "Tipo de Interface Integrada",
  T_46_META_WS_C_CAMERA: "Câmera",
  T_46_META_WS_C_CAMERABLOCKMODE: "Modo de bloqueio da câmera",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Modo de projeção da câmera",
  T_46_META_WS_C_CAMERARAYCASTUI: "UI de RayCast da Câmera",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Tipo de transição de câmera",
  T_46_META_WS_C_CAMERATYPE: "Tipo de câmera",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Tipo de Restrição do Ângulo de Visão da Câmera",
  T_46_META_WS_C_CAPSULETRIGGER: "Gatilho em Cápsula",
  T_46_META_WS_C_CAR: "Carro",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Controlador de Personagem",
  T_46_META_WS_C_CHATCHANNEL: "Canal de Chat",
  T_46_META_WS_C_CHATCHANNELTYPE: "Tipo de Canal de Chat",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Gatilho de Ponto de Controle",
  T_46_META_WS_C_COINGENERATOR: "Gerador de Moedas",
  T_46_META_WS_C_COLLECTIONID: "ID de coleção",
  T_46_META_WS_C_COLLIDER: "Colisor",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Forma do Collider",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID de Coleção de Colisores",
  T_46_META_WS_C_COLORDRUM: "Tambor de Cor",
  T_46_META_WS_C_COMBATABLE: "Combatível",
  T_46_META_WS_C_COMPONENT: "Componente",
  T_46_META_WS_C_CONDITION: "Condição",
  T_46_META_WS_C_CONTAINER: "Contêiner",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Tipo de sistema de coordenadas",
  T_46_META_WS_C_CROSSBOW: "Granada de Arco",
  T_46_META_WS_C_CSVID: "ID de CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Personalizar Gatilho",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Objeto Personalizado",
  T_46_META_WS_C_CUSTOMPATH: "Caminho Personalizado",
  T_46_META_WS_C_CUSTOMUI: "UI Personalizado",
  T_46_META_WS_C_CUSTOMUIID: "ID de UI Personalizado",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI ou Widget Personalizado",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID de Widget de UI Personalizado",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Tipo de Parte do Corpo Danificado",
  T_46_META_WS_C_DAMAGETYPE: "Tipo de Dano",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Gatilho de Morte ou Invulnerabilidade",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Objeto Destrutível",
  T_46_META_WS_C_DICE: "Dados",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Sapatos de salto duplo",
  T_46_META_WS_C_DRUMMUSIC: "Música de Bateria",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Tipo de Arma de Dupla Empunhadura",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Objeto de Nível Comum",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Tipo de Objeto de Nível Criado Dinamicamente",
  T_46_META_WS_C_DYNAMICFENCE: "Cerca Dinâmica",
  T_46_META_WS_C_EFFECT: "Efeito",
  T_46_META_WS_C_EFFECTCONTAINER: "Contêiner de Efeitos",
  T_46_META_WS_C_EFFECTID: "ID de Efeito",
  T_46_META_WS_C_EMOTETYPE: "Tipo de emoção",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Gatilho de Ponto Final",
  T_46_META_WS_C_ENTITY: "Entidade",
  T_46_META_WS_C_ENTITYORPREFABID: "Entidade ou ID de prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Acessório de Equipamento",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Tipo de Slot de Equipamento",
  T_46_META_WS_C_EQUIPMENTTYPE: "Tipo de Equipamento",
  T_46_META_WS_C_EVENTID: "ID do Evento",
  T_46_META_WS_C_FACTION: "Grupo",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Tipo de Direção de Preenchimento",
  T_46_META_WS_C_FILLTYPE: "Tipo de Preenchimento",
  T_46_META_WS_C_FIRETYPE: "Tipo de Fogo",
  T_46_META_WS_C_FLOAT: "Flutuante",
  T_46_META_WS_C_FOLDWING: "Asas dobráveis",
  T_46_META_WS_C_FOLLOW: "Acompanhar",
  T_46_META_WS_C_FONTTYPE: "Tipo de fonte",
  T_46_META_WS_C_FOOTBALL: "Futebol",
  T_46_META_WS_C_FORCETYPE: "Tipo de Força",
  T_46_META_WS_C_FORMULABLE: "Formulável",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Auto-Relativo por Quadro",
  T_46_META_WS_C_GAMERESULTTYPE: "Tipo de resultado do jogo",
  T_46_META_WS_C_GENDERTYPE: "Tipo de Gênero",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Ponto de Spawn Geral",
  T_46_META_WS_C_GRENADEDEICEWALL: "Granada DeIce Wall",
  T_46_META_WS_C_GRENADEFLASHBANG: "Granada de Luz",
  T_46_META_WS_C_GRENADEFROZEN: "Granada congelante",
  T_46_META_WS_C_GRENADELAUNCHER: "Lançador de Granada",
  T_46_META_WS_C_GRENADESMOKE: "Granada de fumaça",
  T_46_META_WS_C_GRENADEWEAPON: "Base de Granada",
  T_46_META_WS_C_GRID: "Grade",
  T_46_META_WS_C_HANDCANNON: "Granada de Mão",
  T_46_META_WS_C_HELMET: "Capacete",
  T_46_META_WS_C_HIERARCHICAL: "Hierárquico",
  T_46_META_WS_C_HOOKGUN: "Arma com gancho",
  T_46_META_WS_C_HORIZALINE: "Linha Horizontal",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "Transformador UI",
  T_46_META_WS_C_HUMANMODELID: "ID de modelo humano",
  T_46_META_WS_C_ICEWALL: "Muro de gelo",
  T_46_META_WS_C_ICEWALLCREATED: "Muro de gelo criado",
  T_46_META_WS_C_ICEWALLMAKER: "Criador de Mural de Gelo",
  T_46_META_WS_C_ICON: "Entidade de ícone",
  T_46_META_WS_C_ICONTYPE: "Tipo de Ícone",
  T_46_META_WS_C_INHALER: "Inalador",
  T_46_META_WS_C_INT: "Inteiro",
  T_46_META_WS_C_INT64: "Inteiro 64 bits",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Modelo de Mapa Inteiro",
  T_46_META_WS_C_INTORINTLIST: "Inteiro ou Lista de Inteiros",
  T_46_META_WS_C_INVENTORYTYPE: "Tipo de Inventário",
  T_46_META_WS_C_ITEMBASE: "Base do item",
  T_46_META_WS_C_ITEMCONTAINER: "Contêiner de Itens",
  T_46_META_WS_C_ITEMID: "ID do item",
  T_46_META_WS_C_ITEMIDTYPE: "Tipo de ID do Item",
  "T_46_META_WS_C_JERSEY STYLE": "Estilo de Camiseta",
  T_46_META_WS_C_JERSEYMACHINE: "Máquina de Camisetas",
  T_46_META_WS_C_JETSHOES: "Sapatos com jato",
  T_46_META_WS_C_KEYBOARD: "Teclado",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Tipo de Derrubada",
  T_46_META_WS_C_LANDMINE: "Mina terrestre",
  T_46_META_WS_C_LANDMINECREATED: "Mina criada",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Objeto de Nível de Plataforma de Lançamento",
  T_46_META_WS_C_LAUNCHPAD: "Plataforma de Lançamento",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Tipo de Ordenação de Layout",
  T_46_META_WS_C_LEAD1MUSIC: "Música Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Música Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Música Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "ID do objeto de nível",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Tipo de Objeto de Nível",
  T_46_META_WS_C_LIST: "Lista",
  T_46_META_WS_C_LISTORMAP: "Lista ou Mapa",
  T_46_META_WS_C_LISTT: "Modelo de lista",
  T_46_META_WS_C_LISTT_BOOL: "Lista de Booleanos",
  T_46_META_WS_C_LISTT_CONDITION: "Lista de Condições",
  T_46_META_WS_C_LISTT_ENTITY: "Lista de Entidades",
  T_46_META_WS_C_LISTT_FLOAT: "Lista de números flutuantes",
  T_46_META_WS_C_LISTT_INT: "Lista de Inteiros",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Lista de Itens",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Lista de Objetos do Nível",
  T_46_META_WS_C_LISTT_LOCKEY: "Lista de chaves de localização",
  T_46_META_WS_C_LISTT_PLAYABLE: "Lista de itens jogáveis",
  T_46_META_WS_C_LISTT_PLAYER: "Lista de Jogadores",
  T_46_META_WS_C_LISTT_SKILLID: "Lista de ID de habilidades",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Lista de Efeitos Sonoros",
  T_46_META_WS_C_LISTT_STRING: "Lista de strings",
  T_46_META_WS_C_LISTT_TEAM: "Lista de Equipes",
  T_46_META_WS_C_LISTT_TYPE: "Lista de Tipos",
  T_46_META_WS_C_LISTT_VECTOR3: "Lista de Vector3",
  T_46_META_WS_C_LOCKEY: "Chave de Localização",
  T_46_META_WS_C_LOOKAT: "Olhar",
  T_46_META_WS_C_LOOPABLE: "Repetível",
  T_46_META_WS_C_LOOPTYPE: "Tipo de Loop",
  T_46_META_WS_C_LOOTAMMOTYPE: "Tipo de Item de Munição",
  T_46_META_WS_C_LOOTARMOR: "Item de Armadura",
  T_46_META_WS_C_LOOTARMORTYPE: "Tipo de Item de Armadura",
  T_46_META_WS_C_LOOTCONSUMABLE: "Item Consumível",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Tipo de Item Consumível",
  T_46_META_WS_C_LOOTIAMMO: "Item de Munição",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Pacote de Item de Futebol",
  T_46_META_WS_C_LOOTSCOPE: "Item de Mira",
  T_46_META_WS_C_LOOTSCOPETYPE: "Tipo de Item de Mira",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Tipo de Item de Futebol",
  T_46_META_WS_C_LOOTTHROWABLE: "Item Arremessável",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Tipo de Item Arremessável",
  T_46_META_WS_C_LOOTWEAPON: "Item de Arma",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Tipo de Item de Arma",
  T_46_META_WS_C_LOWGRAVITY: "Área de Baixa Gravidade",
  T_46_META_WS_C_MAP: "Mapa",
  T_46_META_WS_C_MAPT: "Modelo de mapa",
  T_46_META_WS_C_MATERIALID: "ID de Material",
  T_46_META_WS_C_MEDKIT: "Kit de Primeiros Socorros",
  T_46_META_WS_C_MESHID: "ID de Malha",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Configuração de Saída no Meio do Jogo",
  T_46_META_WS_C_MINIMAP: "Mini-Mapa",
  T_46_META_WS_C_MINIMAPICON: "Ícone de Mini-Mapa",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Renderizador de Pixel do Minimapa",
  T_46_META_WS_C_MINISENTRY: "Mini-Torre",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Tipo de Alcance de Ataque da Mini-Torre",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini-Torre Criada",
  T_46_META_WS_C_MONEY: "Dinheiro",
  T_46_META_WS_C_MONEYTYPE: "Tipo de Dinheiro",
  T_46_META_WS_C_MONSTER: "Monstro",
  T_46_META_WS_C_MONSTERSPAWN: "Spawn de Monstro",
  T_46_META_WS_C_MONSTERTYPE: "Tipo de Monstro",
  T_46_META_WS_C_MORPHABLEOBJECT: "Objeto Morphable",
  T_46_META_WS_C_MORPHOBJECT: "Objeto Morphable",
  T_46_META_WS_C_MOTOBIKE: "Motocicleta",
  T_46_META_WS_C_MOVEPLATFORM: "Plataforma Móvel",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Tipo de Plataforma Móvel",
  T_46_META_WS_C_MUSHROOM: "Cogumelo",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Constante Natural",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Número",
  T_46_META_WS_C_OBJECT: "Objeto",
  T_46_META_WS_C_OILDRUM: "Barril de Óleo",
  T_46_META_WS_C_OUTFITID: "ID de roupa",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Tipo de slot de roupa",
  T_46_META_WS_C_PATHPOINT: "Ponto de Caminho",
  T_46_META_WS_C_PATROLSTYLETYPE: "Tipo de Estilo de Patrulha",
  T_46_META_WS_C_PATROLTYPE: "Tipo de Patrulha",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Fase",
  T_46_META_WS_C_PHYSICALMOVER: "Mover Físico",
  T_46_META_WS_C_PHYSICALOBJECT: "Objeto Físico",
  T_46_META_WS_C_PLATFORMTYPE: "Tipo de Plataforma",
  T_46_META_WS_C_PLAYABLE: "Jogável",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Jogável ou Array de Jogáveis",
  T_46_META_WS_C_PLAYER: "Jogador",
  T_46_META_WS_C_PLAYERBACKPACK: "Mochila do jogador",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Tipo de status de comportamento do jogador",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Tipo de comportamento do jogador",
  T_46_META_WS_C_PLAYERCCT: "Controlador de Personagem para FF",
  T_46_META_WS_C_PLAYERDATAID: "Tipo de Personagem Predefinido",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Jogador ou Transformação",
  T_46_META_WS_C_PLAYERORVEHICLE: "Jogador ou Veículo",
  T_46_META_WS_C_PLAYEROUTFIT: "Traje do Jogador",
  T_46_META_WS_C_PLAYERPOSETYPE: "Tipo de Pose do Jogador",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Tipo de Fonte de Reviver do Jogador",
  T_46_META_WS_C_PLAYERSTATETYPE: "Tipo de Estado do Jogador",
  T_46_META_WS_C_POINTLIGHT: "Luz Pontual",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "ID de Prefab",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Gerador de Efeito de Apresentação",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Tipo de Textura de Efeito",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Widget de Foto de Perfil",
  T_46_META_WS_C_PROPERTY: "Propriedade",
  T_46_META_WS_C_PROPERTYFORMULA: "Fórmula de Propriedade",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Tipo de Fator de Fórmula de Propriedade",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Tipo de Modificação de Propriedade",
  T_46_META_WS_C_QUATERNION: "Quaternion",
  T_46_META_WS_C_RANKABLE: "Classificável",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Tipo de Camada de Raycast",
  T_46_META_WS_C_REPAIRKIT: "Kit de reparo",
  T_46_META_WS_C_RESETABLE: "Redefinível",
  T_46_META_WS_C_RIGIDBODY: "Corpo Rígido",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Tipo de Restrição de Corpo Rígido",
  T_46_META_WS_C_RIGIDBODYTYPE: "Tipo de Corpo Rígido",
  T_46_META_WS_C_ROUND: "Rodada",
  T_46_META_WS_C_SAFEZONE: "Zona Segura",
  T_46_META_WS_C_SCOREABLE: "Avaliável",
  T_46_META_WS_C_SCRIPTID: "ID de Script",
  T_46_META_WS_C_SEATTYPE: "Tipo de Assento",
  T_46_META_WS_C_SELFRELATIVE: "Auto-Relativo",
  T_46_META_WS_C_SHOP: "Loja",
  T_46_META_WS_C_SHOPITEM: "Item de Loja",
  T_46_META_WS_C_SHOPSHELF: "Prateleira de Loja",
  T_46_META_WS_C_SKATEBOARD: "Skate",
  T_46_META_WS_C_SKELETON: "Esqueleto",
  T_46_META_WS_C_SKELETONPART: "Parte do Esqueleto",
  T_46_META_WS_C_SKILLID: "ID de habilidade",
  T_46_META_WS_C_SKYBLASTER: "Frifacóptero",
  T_46_META_WS_C_SKYBOX: "Skybox",
  T_46_META_WS_C_SKYBOXTYPE: "Tipo de skybox",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Bola de Neve da Ilha Social",
  T_46_META_WS_C_SORTTYPE: "Tipo de Ordenação",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Tipo de Som de Bateria",
  T_46_META_WS_C_SOUNDEFFECT: "Efeito Sonoro",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Efeito Sonoro ou Lista de Efeitos Sonoros",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Tipo de Efeito Sonoro",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Tipo de Som de Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Tipo de Som de Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Tipo de Som de Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Tipo de Som de Piano",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Spawnable",
  T_46_META_WS_C_SPAWNBOX: "Zona de Surgimento",
  T_46_META_WS_C_SPAWNPOSITION: "Ponto de Spawn",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Tipo de ID de Item Especial",
  T_46_META_WS_C_SPHERETRIGGER: "Gatilho Esférico",
  T_46_META_WS_C_SPORTSCAR: "Carro Esportivo",
  T_46_META_WS_C_SPRAYCOLOR: "Cor de Spray",
  T_46_META_WS_C_SPRAYGUN: "Pistola de Spray",
  T_46_META_WS_C_SPRAYRESULTUI: "UI de Resultado de Spray",
  T_46_META_WS_C_SPRAYRIFLE: "Rifle de Spray",
  T_46_META_WS_C_SPRITEID: "ID de Sprite",
  T_46_META_WS_C_STATICSCRIPTID: "ID de Script Estático",
  T_46_META_WS_C_STRING: "Cadeia",
  T_46_META_WS_C_STRINGORLOCSTRING: "Cadeia ou Cadeia Localizada",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Gatilho de Caixa de Suprimento",
  T_46_META_WS_C_SWINGGUN: "Arma de balanço",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Trocar Espaço de Equipamento",
  T_46_META_WS_C_TEAM: "Equipe",
  T_46_META_WS_C_TERRAIN: "Terreno",
  T_46_META_WS_C_TEXT: "Entidade de texto",
  T_46_META_WS_C_TEXTUREID: "ID de Textura",
  T_46_META_WS_C_TEXTURETYPE: "Textura do Objeto",
  T_46_META_WS_C_TIMER: "Cronômetro",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Tipo de Estilo de Formatação de Timestamp",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Cadeia de localização de timestamp",
  T_46_META_WS_C_TRAJECTORY: "Trajetória",
  T_46_META_WS_C_TRANSFORM: "Transformar",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Torre",
  T_46_META_WS_C_TWEEN: "Transição",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Curva de Transição",
  T_46_META_WS_C_TWEENSTYLE: "Tipo de Estilo de Transição",
  T_46_META_WS_C_TYPE: "Tipo",
  T_46_META_WS_C_TYPEENUM: "Enumeração de Tipo",
  T_46_META_WS_C_TYPEORTYPELIST: "Tipo ou Lista de Tipos",
  T_46_META_WS_C_UIADDSCORE: "Interface de Adicionar Pontuação",
  T_46_META_WS_C_UIANITRIGGERHUD: "Interface de Acionar Animação no HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "Interface do Botão de ligar e desligar integrado",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "Interface de Controlador do Botão de Ligar e Desligar Integrado",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "Interface do Painel de Seleção de Cartões",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "Interface de Indicador de Ponto de Checagem",
  T_46_META_WS_C_UICOMPASS: "Interface de Bússola",
  T_46_META_WS_C_UICOUNTDOWN5: "Interface de Contagem Regressiva de 5s",
  T_46_META_WS_C_UICOUNTDOWNHINT: "Interface de Dica de Contagem Regressiva",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "Interface de Lembrete de Contagem Regressiva",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Interface de Barra de Vida de Acompanhamento",
  T_46_META_WS_C_UIHEALTHBAR: "Interface de Barra de Vida",
  T_46_META_WS_C_UIHEARTBEAT: "Interface de Pulsação",
  T_46_META_WS_C_UIICONNOTIFICATION: "Interface de Notificação de Ícone",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "Interface de Notificação de Identidade",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "Interface de Botão de Interação",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "Interface do Botão do Placar",
  T_46_META_WS_C_UIMATCHSUBTITLE: "Interface do Subtítulo da Partida",
  T_46_META_WS_C_UIMONSTERLEVEL: "Interface do Nível do Monstro",
  T_46_META_WS_C_UIMONSTERUI: "Interface de Monstro de Interface",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "Interface de Placar de Várias Equipes",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "Interface do Painel de Resultado de Várias Equipes",
  T_46_META_WS_C_UIOPENINGBANNER: "Interface de Banner de Abertura",
  T_46_META_WS_C_UIPANEL: "Interface do Painel",
  T_46_META_WS_C_UIPANELEMPTY: "Interface de Painel Vazio",
  T_46_META_WS_C_UIPHASETIMER: "Interface de Temporizador de Fase",
  T_46_META_WS_C_UIPROGRESSBAR: "Interface da Barra de Progresso",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "Interface do Círculo de Progresso",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "Interface do Botão de Progresso de Habilidade",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "Interface de Tipo de Solicitação de Compra",
  T_46_META_WS_C_UIROUNDINFOBANNER: "HUD de Informação da Rodada",
  T_46_META_WS_C_UIROUNDNUMBER: "Interface do Número da Rodada",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "Interface do Banner de Resultado da Rodada",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "Interface de Banner de Início de Rodada",
  T_46_META_WS_C_UIROUNDTRANSITION: "Interface de Transição de Rodada",
  T_46_META_WS_C_UISCOREBAR: "Interface de Barra de Pontuação",
  T_46_META_WS_C_UISCROLLPANEL: "Interface do Painel de Rolagem",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "Interface de Banner Simples de Pontuação da Rodada",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "Interface de Banner Simples de Início de Rodada",
  T_46_META_WS_C_UISIMPLETIP: "Interface de Dica Simples",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "Interface de Banner Simples de Versus",
  T_46_META_WS_C_UISKILLBUTTON: "Interface do Botão de Habilidade",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Interface do Dispositivo de Botão Social",
  T_46_META_WS_C_UISOLOLEADERBOARD: "Interface de Painel Solo",
  T_46_META_WS_C_UISTORE: "Interface da Loja de Interface",
  T_46_META_WS_C_UITEAMMATCHINFO: "Interface de Informações de Partida de Equipe",
  T_46_META_WS_C_UITEXTTIP: "Interface de Dica de Texto",
  T_46_META_WS_C_UITIMERINFO: "Interface de Informações do Temporizador",
  T_46_META_WS_C_UITIPBUTTON: "Interface de Botão de Dica",
  T_46_META_WS_C_UITITLEBANNER: "Interface do Banner do Título",
  T_46_META_WS_C_UITWEENTIP: "Interface de Dica de Transição",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "Interface de Informações Resumidas de Duas Equipes",
  T_46_META_WS_C_UITWOTEAMINFO: "Interface de Informações de Duas Equipes",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "Interface do Placar de Duas Equipes",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "Interface do Painel de Resultado de Duas Equipes",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "Interface do Banner de Pontos da Rodada de 2 Equipes",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "Interface do Painel de Pontuação de Duas Equipes",
  T_46_META_WS_C_UIVERSUSBANNER: "Interface do Banner de Versus",
  T_46_META_WS_C_UIWIDGET: "Interface de Dispositivo",
  T_46_META_WS_C_UIWIDGETBUTTON: "Botão do Dispositivo na Interface",
  T_46_META_WS_C_UIWIDGETCONTAINER: "Interface do Contêiner de Dispositivo",
  T_46_META_WS_C_UIWIDGETEMPTY: "Interface de Dispositivo Vazio",
  T_46_META_WS_C_UIWIDGETIMAGE: "Interface de Imagem de Dispositivo",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "Interface do Rótulo de Entrada de Dispositivo",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "Interface de Joystick de Dispositivo",
  T_46_META_WS_C_UIWIDGETLABEL: "Interface do Rótulo de Dispositivo",
  T_46_META_WS_C_UIWIDGETLAYOUT: "Interface de Layout de Dispositivo",
  T_46_META_WS_C_UIWIDGETPROFILE: "Interface de Perfil do Dispositivo",
  T_46_META_WS_C_UIWIDGETTEXTURE: "Interface de Textura de Dispositivo",
  T_46_META_WS_C_UIWIDGETTOGGLE: "Alternador de Interface de Dispositivo",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "Dispositivo de Interface do Painel Tátil",
  T_46_META_WS_C_UIWINORLOSEBANNER: "Interface de Banner de Vitória ou Derrota",
  T_46_META_WS_C_UNITSPAWN: "Geração de Unidade",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Objeto de Lógica de Escalada de Janela",
  T_46_META_WS_C_VECTOR2: "Vetor2",
  T_46_META_WS_C_VECTOR3: "Vetor3",
  T_46_META_WS_C_VEHICLE: "Veículo",
  T_46_META_WS_C_VEHICLEIDTYPE: "Tipo de ID de Veículo",
  T_46_META_WS_C_VEHICLESKINID: "ID de Pele de Veículo",
  T_46_META_WS_C_VENDINGMACHINE: "Máquina de Venda Automática",
  T_46_META_WS_C_VEST: "Colete",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Entidade de Textura Substituível de Efeito Visual",
  T_46_META_WS_C_VFXTEXTURE: "Textura de Efeito Visual",
  T_46_META_WS_C_VISIBILITY: "Visibilidade",
  T_46_META_WS_C_WALLET: "Carteira",
  T_46_META_WS_C_WALLETHUD: "UI de Carteira",
  T_46_META_WS_C_WATERZONE: "Zona de Água",
  T_46_META_WS_C_WAVECOUNTTYPE: "Tipo de Contagem de Ondas",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Tipo de Intervalo de Ondas",
  T_46_META_WS_C_WEAPON: "Arma",
  T_46_META_WS_C_WEAPONGENERATOR: "Gerador de Armas",
  T_46_META_WS_C_WEAPONSKINID: "ID de skin de arma",
  T_46_META_WS_C_WEAPONTYPE: "Tipo de Arma",
  T_46_META_WS_C_WIDGETTYPE: "Tipo de Widget",
  T_46_META_WS_C_ZIPLINE: "Linha de Zip",
  T_46_META_WS_CAMERADIRECTION: "Direção da câmera",
  T_46_META_WS_CAMERAPOSITION: "Posição da câmera",
  T_46_META_WS_CAPSULECAST: "Detecção de Cápsula",
  T_46_META_WS_CAPSULEOVERLAP: "Sobreposição de Cápsula",
  T_46_META_WS_CEIL: "Arredondar para Cima",
  T_46_META_WS_CHATCHANNEL: "Canal de bate-papo",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Verificar Gatilho por Ordem",
  T_46_META_WS_CLAMP: "Clamping",
  T_46_META_WS_CLEAR: "Limpar",
  T_46_META_WS_CLEARALLCHILDREN: "Limpar Todos os Filhos",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Limpar Acompanhamento Especial AOI",
  T_46_META_WS_CLEARBACKPACK: "Limpar Mochila",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Limpar Fator de Propriedade de Fórmula",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Limpar Objetos de Nível Restantes",
  T_46_META_WS_CLIPNAME: "Nome do clipe",
  T_46_META_WS_CLONE: "Clonar",
  T_46_META_WS_COLLIDEDENTITY: "Entidade colidida",
  T_46_META_WS_COLORGET: "Obter Cor",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Completar Missão Personalizada",
  T_46_META_WS_CONNECT: "Conectar",
  T_46_META_WS_CONSUMABLEID: "ID do item",
  T_46_META_WS_CONTAIN: "Contém",
  T_46_META_WS_CONTAINKEY: "Verificar Se a Chave Existe",
  T_46_META_WS_COPYTOMORPH: "Copiar Para Transformação",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Custo Dinheiro",
  T_46_META_WS_COSTTOKEN: "Gastar Token",
  T_46_META_WS_CREATEAIRDROP: "Criar Carga Aérea",
  T_46_META_WS_CREATEBOT: "Criar Bot",
  T_46_META_WS_CREATEBUILTINUI: "Criar UI Incorporada",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Criar UI Incorporada",
  T_46_META_WS_CREATECAMERA: "Criar Câmera",
  T_46_META_WS_CREATECURVE: "Criar Curva",
  T_46_META_WS_CREATECUSTOMUI: "Criar UI Personalizada",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Criar UI Personalizada",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Criar Widget UI Personalizado",
  T_46_META_WS_CREATEDAMAGENUM: "Criar Número de Dano",
  T_46_META_WS_CREATEEFFECT: "Criar Efeito",
  T_46_META_WS_CREATEEFFECTCLIENT: "Criar Efeito",
  T_46_META_WS_CREATEFACTION: "Criar Grupo",
  T_46_META_WS_CREATEFOLLOW: "Criar Acompanhamento",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Criar Relativo a Si Mesmo a Cada Quadro",
  T_46_META_WS_CREATEFROMPREFAB: "Criar a Partir do Prefab",
  T_46_META_WS_CREATELEVELOBJECT: "Criar Objeto de Nível",
  T_46_META_WS_CREATELOOKAT: "Criar Olhar",
  T_46_META_WS_CREATEMINIMAPICON: "Criar Ícone de Mini Mapa",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Criar Pixel de Mini Mapa",
  T_46_META_WS_CREATEMONSTER: "Criar Monstro",
  T_46_META_WS_CREATEMORPH: "Criar Transformação",
  T_46_META_WS_CREATESELFRELATIVE: "Criar Relativo a Si Mesmo",
  T_46_META_WS_CREATESHOP: "Criar Loja",
  T_46_META_WS_CREATESHOPITEM: "Criar Item",
  T_46_META_WS_CREATESHOPSHELF: "Criar Prateleira de Loja",
  T_46_META_WS_CREATESOUND: "Criar Som",
  T_46_META_WS_CREATESOUNDCLIENT: "Criar Som",
  T_46_META_WS_CREATETOKENINSCENE: "Criar Token na Cena",
  T_46_META_WS_CREATETRAJECTORY: "Criar Trajetória",
  T_46_META_WS_CREATETWEEN: "Criar Transição",
  T_46_META_WS_CREATEWALLET: "Criar Carteira",
  T_46_META_WS_CROSS: "Produto Vetorial",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Nome da Coluna CSV para Inteiro",
  T_46_META_WS_CURRENTAMMOCOUNT: "Contagem atual de munição",
  T_46_META_WS_DAMAGE: "Dano",
  T_46_META_WS_DAMAGEDBODYPART: "Parte do corpo danificada",
  T_46_META_WS_DAMAGEDPLAYERS: "Jogadores danificados",
  T_46_META_WS_DAMAGETYPE: "Tipo de dano",
  T_46_META_WS_DEALDAMAGE: "Causar Dano",
  T_46_META_WS_DELETE: "Excluir",
  T_46_META_WS_DELETEAT: "Excluir na Posição",
  T_46_META_WS_DELETECUSTOMUI: "Excluir UI Personalizada",
  T_46_META_WS_DELETEFROMDATABASE: "Excluir do Banco de Dados",
  T_46_META_WS_DELETEFROMDATASTORE: "Excluir do armazenamento de dados",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Excluir do Banco de Dados de Classificação por Chave",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Excluir do Banco de Dados de Classificação por Classificação",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Excluir do armazenamento de dados do ranking por chave",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Excluir do armazenamento de dados do ranking por classificação",
  T_46_META_WS_DELETETAG: "Remover Etiqueta",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Destruir",
  T_46_META_WS_DESTROYBOT: "Destruir Bot",
  T_46_META_WS_DESTROYBUILTINUI: "Destruir UI Incorporada",
  T_46_META_WS_DESTROYEQUIPMENT: "Destruir Equipamento",
  T_46_META_WS_DESTROYITEM: "Destruir Item",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Direção para Ângulo de Euler",
  T_46_META_WS_DISABLESAFEZONE: "Desativar Zona Segura",
  T_46_META_WS_DISPATCHEVENT: "Disparar Evento",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Enviar Evento com Plataforma",
  T_46_META_WS_DISTANCE: "Distância",
  T_46_META_WS_DOT: "Produto Escalar",
  T_46_META_WS_DROPITEM: "Descartar Item",
  T_46_META_WS_DYEATAREA: "Tingir na Área",
  T_46_META_WS_DYEATPLANE: "Tingir no Plano",
  T_46_META_WS_DYEATPOSITION: "Tingir na Posição",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Área de Baixa Gravidade",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Aceleração",
  T_46_META_WS_E_ACTIONNODE: "Nó de Ação",
  T_46_META_WS_E_ACTIVE: "Ativo",
  T_46_META_WS_E_ACTIVESKILL: "Habilidade Ativa",
  T_46_META_WS_E_ADBOARD: "Anúncio",
  T_46_META_WS_E_ADD: "Adicionar",
  T_46_META_WS_E_ADDFRIEND: "Adicionar amigo",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Mirar",
  T_46_META_WS_E_AIR: "Ar",
  T_46_META_WS_E_AIRCONDITIONERA: "Ar Condicionado",
  T_46_META_WS_E_AIRDROP: "Queda de Paraquedas, Suicídio de Zumbi",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Vivo",
  T_46_META_WS_E_AMMO: "Efeito Visual de Munição",
  T_46_META_WS_E_AMPHIBIANCAR: "Veículo anfíbio",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Crianças Brincando",
  T_46_META_WS_E_AR: "Rifle",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Munições AR",
  T_46_META_WS_E_ARMAGAZINE: "Carregador para AR",
  T_46_META_WS_E_ARMOR: "Armadura",
  T_46_META_WS_E_ARMORBUFF: "Buff Armadura",
  T_46_META_WS_E_ARMORLV1: "Armadura Lv1",
  T_46_META_WS_E_ARMORLV2: "Armadura Lv2",
  T_46_META_WS_E_ARMORLV3: "Armadura Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Quebrar Armadura",
  T_46_META_WS_E_ARMORSPECIALIST: "Habilidade 1",
  T_46_META_WS_E_ARROW: "Seta",
  T_46_META_WS_E_ASC: "Ordem Crescente",
  T_46_META_WS_E_ASCIGNOREZERO: "Ordem Crescente Ignora Zeros",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Explosão de Gás",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Acessório 1 para Compatibilidade",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Acessório4 para Compatibilidade",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Acessório 5 para Compatibilidade",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Acessório6 para Compatibilidade",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Acessório8 para Compatibilidade",
  T_46_META_WS_E_ATTACK: "Ataque",
  T_46_META_WS_E_ATTACKGRENADE: "Granada de Ataque",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Automático",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Retornar",
  T_46_META_WS_E_BACKANDFORTH: "Ida e Volta",
  T_46_META_WS_E_BAG: "Mochila",
  T_46_META_WS_E_BAG1: "Bolsa1",
  T_46_META_WS_E_BAG2: "Bolsa2",
  T_46_META_WS_E_BAG3: "Bolsa3",
  T_46_META_WS_E_BAMBOOA: "Bambu A",
  T_46_META_WS_E_BANANATREE: "Bananeira",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Coeficiente Base",
  T_46_META_WS_E_BASIC: "Básico",
  T_46_META_WS_E_BASICCONE: "Cone Básico",
  T_46_META_WS_E_BASICCYLINDER: "Cilindro Básico",
  T_46_META_WS_E_BASICSPHERE: "Esfera Básica",
  T_46_META_WS_E_BATTLEINSTYLE: "Sua Batalha, seu Estilo",
  T_46_META_WS_E_BELL: "Sino",
  T_46_META_WS_E_BENCH: "Banco",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "Tela Grande",
  T_46_META_WS_E_BIPOD: "Bipé",
  T_46_META_WS_E_BISGRAFFITIWALL: "Muro Temático BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Efeito Visual de Explosão de Buraco Negro",
  T_46_META_WS_E_BLACKHOLEBOOM: "Efeito Visual de Bola de Cristal",
  T_46_META_WS_E_BLAST: "Explosão",
  T_46_META_WS_E_BLOCK: "Quadrado",
  T_46_META_WS_E_BLOODBALL: "Efeito Visual de Buraco Negro",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Azul",
  T_46_META_WS_E_BLUEDOLL: "Boneca de Gelo",
  T_46_META_WS_E_BOARD: "Plataforma móvel",
  T_46_META_WS_E_BODY: "Corpo",
  T_46_META_WS_E_BOMBINDICATION: "Aviso de Bomba",
  T_46_META_WS_E_BOMBPLIERS: "Alicate de Bomba",
  T_46_META_WS_E_BONFIRE: "Fogo de Conselho Ardente",
  T_46_META_WS_E_BOOM: "Boom",
  T_46_META_WS_E_BOOYAH: "Vitória",
  T_46_META_WS_E_BOTH: "Ambos",
  T_46_META_WS_E_BOUNCETIRE: "Pneu",
  T_46_META_WS_E_BOWAMMO: "Munições Arco",
  T_46_META_WS_E_BREAKABLEBOX: "Caixa de Madeira Destrutível",
  T_46_META_WS_E_BREAKABLECONTAINER: "Contêiner destruível",
  T_46_META_WS_E_BREAKABLEFENCE: "Cerca destruível",
  T_46_META_WS_E_BRICKA: "Tijolo A",
  T_46_META_WS_E_BRICKB: "Tijolo B",
  T_46_META_WS_E_BRICKC: "Tijolo C",
  T_46_META_WS_E_BRICKHOUSEA: "Casa Pequena A",
  T_46_META_WS_E_BRIGHT: "Claro",
  T_46_META_WS_E_BUBBLE: "Bolha",
  T_46_META_WS_E_BUFFGENERATOR: "Gerador de Buff",
  T_46_META_WS_E_BULLETBUFF: "Buff Bala",
  T_46_META_WS_E_BULLETHITTING: "Impacto de Bala",
  T_46_META_WS_E_BUMPERCAR: "Carro de bate-bate",
  T_46_META_WS_E_BUMPERCARFACTORY: "Fabricante de Carros de Bumper",
  T_46_META_WS_E_BURNING: "Dano por Queima na Explosão de Veículo",
  T_46_META_WS_E_BUSHES: "Arbustos",
  T_46_META_WS_E_BUSSTOP: "Estação de Ônibus",
  T_46_META_WS_E_BUTTOM: "Pernas",
  T_46_META_WS_E_BUTTONWIDGET: "Widget de botão",
  T_46_META_WS_E_BYHIERARCHY: "Por hierarquia",
  T_46_META_WS_E_CABINET: "Armário",
  T_46_META_WS_E_CACTUS: "Cacto",
  T_46_META_WS_E_CAMOUFLAGE: "Habilidade 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Gatilho de Cápsula",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotônico",
  T_46_META_WS_E_CASUALGAMEBGM: "BGM de Jogo de Lazer",
  T_46_META_WS_E_CEMENTA: "Cimento A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Canal A",
  T_46_META_WS_E_CHANNELB: "Canal B",
  T_46_META_WS_E_CHANNELC: "Canal C",
  T_46_META_WS_E_CHANNELD: "Canal D",
  T_46_META_WS_E_CHANNELE: "Canal E",
  T_46_META_WS_E_CHANNELF: "Canal F",
  T_46_META_WS_E_CHARACTERSKILL: "Habilidade de Personagem",
  T_46_META_WS_E_CHARACTOR: "Personagem",
  T_46_META_WS_E_CHARGE: "Carga 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Ponto de Verificação",
  T_46_META_WS_E_CHEER: "Aplauso",
  T_46_META_WS_E_CHERRYBLOSSOM: "Árvore de cerejeira",
  T_46_META_WS_E_CIRCLE: "Círculo",
  T_46_META_WS_E_CIRCLEBACK: "Loop",
  T_46_META_WS_E_CIRCLEOFHEAT: "Feixe no Pé",
  T_46_META_WS_E_CITY: "Cidade",
  T_46_META_WS_E_CLAPS: "Palmas",
  T_46_META_WS_E_CLEAR: "Limpar",
  T_46_META_WS_E_CLIENT: "Cliente",
  T_46_META_WS_E_CLONE: "Mudança de Aparência",
  T_46_META_WS_E_CLONEKILL: "Morte de Clone",
  T_46_META_WS_E_CLOSE: "Fechar",
  T_46_META_WS_E_CLOTHES: "Roupas",
  T_46_META_WS_E_COINGENERATOR: "Gerador de Ouro",
  T_46_META_WS_E_COLDAIR: "Névoa",
  T_46_META_WS_E_COLORBLOCK: "Bloco Tingido",
  T_46_META_WS_E_COLOROILBARREL: "Barril de Óleo Tingido",
  T_46_META_WS_E_COMBINEALL: "Combinar Tudo",
  T_46_META_WS_E_COMBINESELF: "Combinar com si mesmo",
  T_46_META_WS_E_COMBOKEYA1: "Notas Musicais - Sintetizador A",
  T_46_META_WS_E_COMBOKEYA2: "Notas Musicais - Sintetizador A",
  T_46_META_WS_E_COMBOKEYB1: "Notas Musicais - Sintetizador B",
  T_46_META_WS_E_COMBOKEYB2: "Notas Musicais - Sintetizador B",
  T_46_META_WS_E_COMBOKEYC1: "Notas Musicais - Sintetizador C",
  T_46_META_WS_E_COMBOKEYC2: "Notas Musicais - Sintetizador C",
  T_46_META_WS_E_CONCRETEPILLAR: "Pilar de Concreto",
  T_46_META_WS_E_CONDITIONNODE: "Nó de Condição",
  T_46_META_WS_E_CONTAINERA: "Container A",
  T_46_META_WS_E_CONTAINERB: "Contentor B",
  T_46_META_WS_E_CONTAINERC: "Contentor C",
  T_46_META_WS_E_CONTAINERWIDGET: "Widget de contêiner",
  T_46_META_WS_E_CONTINUOUS: "Contínuo",
  T_46_META_WS_E_COUNTDOWN: "Contagem Regressiva",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Contagem Regressiva",
  T_46_META_WS_E_COUNTDOWNDIDI: "Bipe da Contagem Regressiva",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Contagem Regressiva",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Contagem Regressiva 3",
  T_46_META_WS_E_CROSS: "Cruz",
  T_46_META_WS_E_CROSSBOW: "Balestra",
  T_46_META_WS_E_CROSSHAIR: "Mira",
  T_46_META_WS_E_CROSSHAIRS: "Retículo",
  T_46_META_WS_E_CROUCH: "Agachar",
  T_46_META_WS_E_CROUCHING: "Abaixado",
  T_46_META_WS_E_CROWCAW: "Caw de Corvo",
  T_46_META_WS_E_CROWN: "Coroa",
  T_46_META_WS_E_CUBE: "Mecanismo de bloco",
  T_46_META_WS_E_CURSE: "Talismã",
  T_46_META_WS_E_CURSEEXPLOSION: "Explosão de Talismã",
  T_46_META_WS_E_CUSTOM: "Câmera Personalizada",
  T_46_META_WS_E_CUSTOMTRIGGER: "Gatilho Personalizado",
  T_46_META_WS_E_CUSTOMWATERZONE: "Corpo d'Água Personalizado",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Queima em Looping",
  T_46_META_WS_E_CYLIC: "Cíclico",
  T_46_META_WS_E_DAGGER: "Faca de Arremesso",
  T_46_META_WS_E_DAMAGEDTRUCK: "Caminhão Danificado",
  T_46_META_WS_E_DAMAGEZONE: "Zona de Dano",
  T_46_META_WS_E_DANGERALARM: "Perigo 2",
  T_46_META_WS_E_DANGERVIBRATING: "Perigo 1",
  T_46_META_WS_E_DARK: "Escuro",
  T_46_META_WS_E_DARKNESS: "Escuridão",
  T_46_META_WS_E_DASHATTACK: "Ataque em dash",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Limite de armazenamento de dados excedido",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Erro de parâmetro de armazenamento de dados",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Tempo limite de armazenamento de dados",
  T_46_META_WS_E_DATETIME: "Data e Hora",
  T_46_META_WS_E_DAY: "Dia",
  T_46_META_WS_E_DEAD: "Morto",
  T_46_META_WS_E_DEATH: "Morto",
  T_46_META_WS_E_DEFAULT: "Padrão",
  T_46_META_WS_E_DEFAULTFIST: "Punho",
  T_46_META_WS_E_DEFENCEGRENADE: "Granada de Defesa",
  T_46_META_WS_E_DESC: "Ordem Decrescente",
  T_46_META_WS_E_DIALOGUE: "Diálogo",
  T_46_META_WS_E_DIAMOND: "Diamante",
  T_46_META_WS_E_DIRECTIONSIGN: "Placa",
  T_46_META_WS_E_DIRVEVEHICLE: "Dirigir Veículo",
  T_46_META_WS_E_DISABLE: "Desativar",
  T_46_META_WS_E_DISABLED: "Desativado",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Mensagem de Desaparecimento",
  T_46_META_WS_E_DISCONNECT: "Desconectar",
  T_46_META_WS_E_DISGUISE: "Clone",
  T_46_META_WS_E_DOGHOUSE: "Casinha de Cachorro",
  T_46_META_WS_E_DOOR: "Porta",
  T_46_META_WS_E_DOUBLE: "Dobro",
  T_46_META_WS_E_DOUBLEDOOR: "Porta Dupla",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Calçado de Pulo Duplo",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Carregador Duplo",
  T_46_META_WS_E_DRAW: "Empate",
  T_46_META_WS_E_DRILLZOMBIE: "Zumbi Broca",
  T_46_META_WS_E_DRIVE: "Dirigir",
  T_46_META_WS_E_DRIVER: "Motorista",
  T_46_META_WS_E_DROPBEAT: "Habilidade 4",
  T_46_META_WS_E_DRUMKEY1: "Notas Musicais - Bateria",
  T_46_META_WS_E_DRUMKEY2: "Notas Musicais - Bateria",
  T_46_META_WS_E_DUEL: "Batalha",
  T_46_META_WS_E_DUMMY: "Manequim",
  T_46_META_WS_E_DUMMYGRENADE: "Granada Falsa",
  T_46_META_WS_E_DUMP: "Descarregar",
  T_46_META_WS_E_DUSK: "Crepúsculo",
  T_46_META_WS_E_DUST: "Fumaça e Poeira",
  T_46_META_WS_E_DYNAMIC: "Dinâmico",
  T_46_META_WS_E_E: "Constante natural",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Fácil",
  T_46_META_WS_E_ELECTRICSHOCK: "Choque Elétrico",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Prancha de Surfe Elétrica",
  T_46_META_WS_E_ELECTRICZONE: "Zona Elétrica",
  T_46_META_WS_E_ELECTRONICBGM: "BGM Fantasia Eletrônica Fofa",
  T_46_META_WS_E_ELIMINATEDBOSS: "Impeachment do Líder da Guilda",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Indicação de Morte",
  T_46_META_WS_E_EMOTE: "Emote",
  T_46_META_WS_E_ENABLE: "Habilitar",
  T_46_META_WS_E_ENERGETIC: "Energético",
  T_46_META_WS_E_ENTERVEHICLE: "Entrar no Veículo",
  T_46_META_WS_E_EP: "Energia (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "Ponto de Exclamação",
  T_46_META_WS_E_EXIT: "Saída",
  T_46_META_WS_E_EXITVEHICLE: "Sair do Veículo",
  T_46_META_WS_E_EXPLODE: "Auto-explosão",
  T_46_META_WS_E_EXPLOSION: "Efeito Visual de Explosão",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Chamas da Explosão",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Habilidade Orbe de Energia",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Zumbi Explosivo",
  T_46_META_WS_E_EYE: "Óculos",
  T_46_META_WS_E_FACEPAINT: "Pintura Facial",
  T_46_META_WS_E_FACTION: "Grupo",
  T_46_META_WS_E_FALLING: "Caindo",
  T_46_META_WS_E_FALLINGSTAR: "Obter Consumível",
  T_46_META_WS_E_FALSE: "Não",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Mecanismo de hélice",
  T_46_META_WS_E_FAR: "Longe",
  T_46_META_WS_E_FEATHER: "Pena",
  T_46_META_WS_E_FEMALE: "Feminino",
  T_46_META_WS_E_FENCE: "Cerca",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "EntidadeDeCombate",
  T_46_META_WS_E_FILLED: "Preenchido",
  T_46_META_WS_E_FINISH: "Finalizar",
  T_46_META_WS_E_FINISHINGPOINT: "Ponto de Fim",
  T_46_META_WS_E_FINISHLINEARCH: "Faixa de Chegada",
  T_46_META_WS_E_FIRE: "Fogo",
  T_46_META_WS_E_FIRECHARGE: "Bola de Fogo",
  T_46_META_WS_E_FIREWORK: "Fogos de Artifício",
  T_46_META_WS_E_FIRINGEFFECT: "Efeito Visual de Disparo",
  T_46_META_WS_E_FIRSTPERSON: "Primeira Pessoa",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Clássico em Primeira Pessoa",
  T_46_META_WS_E_FIST: "Punho",
  T_46_META_WS_E_FIT: "Ajustar",
  T_46_META_WS_E_FLAG: "Bandeira",
  T_46_META_WS_E_FLAME: "Fogo",
  T_46_META_WS_E_FLAMEGUN: "Lança-chamas",
  T_46_META_WS_E_FLAMETHROWER: "Lança-chamas",
  T_46_META_WS_E_FLASH: "Granada de Luz",
  T_46_META_WS_E_FLASHBANG: "Granada de Luz",
  T_46_META_WS_E_FLASHBANGSPARKS: "Fumaça de Granada de Luz",
  T_46_META_WS_E_FLASHFREEZE: "Bomba Congelante",
  T_46_META_WS_E_FLEXWALL: "Parede retrátil",
  T_46_META_WS_E_FLICKER: "Piscamento",
  T_46_META_WS_E_FLOWER: "Flor",
  T_46_META_WS_E_FLYBOMBBEE: "Abelha Bomba Voadora",
  T_46_META_WS_E_FLYPAN: "Mecanismo de frigideira",
  T_46_META_WS_E_FLYSHOE: "Sapato Voador",
  T_46_META_WS_E_FOLDER: "Pasta",
  T_46_META_WS_E_FOLDWINGS: "Asas Dobráveis",
  T_46_META_WS_E_FOODTRUCK: "Caminhão de Comida",
  T_46_META_WS_E_FOODTRUCKB: "Caminhão de Comida B",
  T_46_META_WS_E_FOOTBALL: "Futebol",
  T_46_META_WS_E_FOOTBALLGUN: "Arma de Futebol",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Atirador de futebol",
  T_46_META_WS_E_FORCE: "Força",
  T_46_META_WS_E_FOREGRIP_MR: "Empunhadura Frontal MR",
  T_46_META_WS_E_FOREGRIP1: "Empunhadura Frontal1",
  T_46_META_WS_E_FOREGRIP2: "Empunhadura Frontal2",
  T_46_META_WS_E_FOREGRIP3: "Empunhadura Frontal3",
  T_46_META_WS_E_FORWARD: "Avançar",
  T_46_META_WS_E_FOUNTAIN: "Fonte",
  T_46_META_WS_E_FREE: "Livre",
  T_46_META_WS_E_FREEZEALL: "Congelar Tudo",
  T_46_META_WS_E_FREEZEPOSITION: "Congelar Posição",
  T_46_META_WS_E_FREEZEPOSITIONX: "Congelar Posição X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Congelar Posição Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Congelar Posição Z",
  T_46_META_WS_E_FREEZEROTATION: "Congelar Rotação",
  T_46_META_WS_E_FREEZEROTATIONX: "Congelar Rotação X",
  T_46_META_WS_E_FREEZEROTATIONY: "Congelar Rotação Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Congelar Rotação Z",
  T_46_META_WS_E_FREEZEZONE: "Área Congelada",
  "T_46_META_WS_E_FROST GALAXY": "Galáxia Congelada",
  T_46_META_WS_E_FROZEN: "Congelamento",
  T_46_META_WS_E_FROZENGRENADE: "Granada Congelante",
  T_46_META_WS_E_FUNCTIONALITEMS: "Itens Funcionais",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Jogo",
  T_46_META_WS_E_GAMEOVER: "Fim de Jogo 2",
  T_46_META_WS_E_GAMESTART: "Início do Jogo",
  T_46_META_WS_E_GARAGE: "Garagem",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mecanismo Ativado",
  T_46_META_WS_E_GENTLETAP: "Toque Suave",
  T_46_META_WS_E_GETITEM: "Obter Consumível 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Fantasma",
  T_46_META_WS_E_GIANTDICE: "Dados",
  T_46_META_WS_E_GIANTLOLLIPOP: "Pirulito Gigante",
  T_46_META_WS_E_GIFT: "Presente",
  T_46_META_WS_E_GLOOWALL: "Parede de Gel",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Canteiro de Flores Temático BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Muro de Grafite",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Arma de Gancho",
  T_46_META_WS_E_GREATCONDUCTOR: "Grande Condutor",
  T_46_META_WS_E_GREEN: "Verde",
  T_46_META_WS_E_GRENADE: "Granada",
  T_46_META_WS_E_GRID: "Grade",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Torre de vigia",
  T_46_META_WS_E_GUILD: "Guilda",
  T_46_META_WS_E_GUN: "Arma",
  T_46_META_WS_E_GUNFIRE: "Tiros",
  T_46_META_WS_E_HALO: "Aura",
  T_46_META_WS_E_HAMMER: "Mecanismo de martelo gigante",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Secador de roupas",
  T_46_META_WS_E_HARD: "Difícil",
  T_46_META_WS_E_HATTRICK: "Habilidade 8",
  T_46_META_WS_E_HAYSTACK: "Moinho de feno",
  T_46_META_WS_E_HEAD: "Cabeça",
  T_46_META_WS_E_HEADSHOOT: "Acerto na Cabeça",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "Pistola de Cura_X",
  T_46_META_WS_E_HEALPISTOL: "Arma de Cura",
  T_46_META_WS_E_HEART: "Coração",
  T_46_META_WS_E_HEARTBEAT: "Batimento Cardíaco",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Arma Pesada",
  T_46_META_WS_E_HELL: "Muito difícil",
  T_46_META_WS_E_HELMET: "Capacete",
  T_46_META_WS_E_HELMET1: "Capacete1",
  T_46_META_WS_E_HELMET2: "Capacete2",
  T_46_META_WS_E_HELMET3: "Capacete3",
  T_46_META_WS_E_HEXAGON: "Hexágono",
  T_46_META_WS_E_HGAMMO: "Munições HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Lança-chamas de Esconde-esconde",
  T_46_META_WS_E_HIDERKILL: "Escondido Abatido",
  T_46_META_WS_E_HIHATS: "Hi-hat",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Golpe Sem Vida",
  T_46_META_WS_E_HITEFFECT: "Efeito Visual de Acerto de Projétil",
  T_46_META_WS_E_HITFEEDBACK: "Feedback de Tiro",
  T_46_META_WS_E_HOOK: "Gancho",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "Munição para Arma de Gancho",
  T_46_META_WS_E_HORIZALINE: "Horizonte",
  T_46_META_WS_E_HORIZONTAL: "Horizontal",
  T_46_META_WS_E_HORN: "Alto-Falante",
  T_46_META_WS_E_HORROR: "Terror",
  T_46_META_WS_E_HOURGLASS: "Ampulheta",
  T_46_META_WS_E_HOUSE: "Casa",
  T_46_META_WS_E_HOUSEA: "Casa térrea",
  T_46_META_WS_E_HOUSEB: "Casa de dois andares",
  T_46_META_WS_E_HOUSEC: "Casa de três andares",
  T_46_META_WS_E_HP: "Vida",
  T_46_META_WS_E_HPBUFF: "Buff HP",
  T_46_META_WS_E_HUT: "Cabine",
  T_46_META_WS_E_ICEA: "Gelo A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Criador de Parede de Gelo",
  T_46_META_WS_E_ICONOBJECT: "Ícone",
  T_46_META_WS_E_IMAGEWIDGET: "Widget de imagem",
  T_46_META_WS_E_IMPULSE: "Impulso",
  T_46_META_WS_E_INHALER: "Inalador",
  T_46_META_WS_E_INJUREDFEMALE: "Grito de Mulher ao Ser Atacado",
  T_46_META_WS_E_INJUREDMALE: "Grito de Homem ao Ser Atacado",
  T_46_META_WS_E_INK: "Efeito Visual de Tinta",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Widget de rótulo de entrada",
  T_46_META_WS_E_INSECTCHIRPING: "Zumbido de Insetos",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 Segundos",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 Segundos",
  T_46_META_WS_E_INTERVAL30SECONDS: "30s",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 Segundos",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 Segundos",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 Segundos",
  T_46_META_WS_E_INVISIBLE: "Invisível",
  T_46_META_WS_E_IPIPE: "Tubo I",
  T_46_META_WS_E_IRONFENCE: "Cerca",
  T_46_META_WS_E_IRONFENCEB: "Cerca B",
  T_46_META_WS_E_IRONPLATFORM: "Plataforma de ferro",
  T_46_META_WS_E_ITEMENTITY: "Gerador de Itens Consumíveis",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Tambor de Óleo",
  T_46_META_WS_E_JERSEYMACHINE: "Máquina de Camisetas",
  T_46_META_WS_E_JOINEDGAMEDULL: "Entrar na Luta",
  T_46_META_WS_E_JOINGAME: "Entrar no Jogo",
  T_46_META_WS_E_JOYSTICKWIDGET: "Widget de joystick",
  T_46_META_WS_E_JUMP: "Pular",
  T_46_META_WS_E_JUMPATTACK: "Ataque de salto",
  T_46_META_WS_E_JUSTPATROL: "Apenas Patrulha",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Chave",
  T_46_META_WS_E_KICK: "Bumbo",
  T_46_META_WS_E_KILLINGTIPS: "Dicas de Abate",
  T_46_META_WS_E_KILLZONE: "Zona de Morte",
  T_46_META_WS_E_KINEMATIC: "Cinemático",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Derrubado",
  T_46_META_WS_E_KNOCKEDDOWN: "Derrubado",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Widget de rótulo",
  T_46_META_WS_E_LANDINGA: "Pouso de Escada A",
  T_46_META_WS_E_LANDINGB: "Pouso de Escada B",
  T_46_META_WS_E_LANDINGC: "Pouso de Escada C",
  T_46_META_WS_E_LANDMINE: "Mina Terrestre",
  T_46_META_WS_E_LANUNCHERAMMO: "Munição de Lançador",
  T_46_META_WS_E_LASER: "Efeito Visual de Laser",
  T_46_META_WS_E_LASERSKILL: "Habilidade Laser",
  T_46_META_WS_E_LATTICESCREEN: "Tela",
  T_46_META_WS_E_LAWNA: "Relva A",
  T_46_META_WS_E_LAWNB: "Relva B",
  T_46_META_WS_E_LAYOUTWIDGET: "Widget de layout",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Madeira morta",
  T_46_META_WS_E_LEVELMAXED: "Nível Máx.",
  T_46_META_WS_E_LEVELUP: "Subir de Nível",
  T_46_META_WS_E_LEVELUPDISCARDED: "Subir de Nível",
  T_46_META_WS_E_LIGHTBEAM: "Feixe de Luz",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Feixe de Luz",
  T_46_META_WS_E_LIGHTEFFECT: "Efeito de Luz",
  T_46_META_WS_E_LIGHTNING: "Raio",
  T_46_META_WS_E_LIMB: "Membro",
  T_46_META_WS_E_LINE: "Linha",
  T_46_META_WS_E_LIQUID: "Líquido",
  T_46_META_WS_E_LOCAL: "Local",
  T_46_META_WS_E_LOCALPOSITION: "Posição Local",
  T_46_META_WS_E_LOCK: "Cadeado",
  T_46_META_WS_E_LONGBOX: "Caixa de madeira longa",
  T_46_META_WS_E_LOOP: "Loop",
  T_46_META_WS_E_LOOTITEMBOX: "Item de Arma",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Item de Munição",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Item de Armadura",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Item Consumível",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Item Arremessável",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Item de Mira",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Item de Futebol",
  T_46_META_WS_E_LOOTSOCCERICE: "Item de Granada de Gelo",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Item de Futebol Aleatório",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Item de Escudo de Futebol",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Item de Arma Aleatório",
  T_46_META_WS_E_LOSE: "Derrota",
  T_46_META_WS_E_LOUDSPEAKER: "Alto-falante",
  T_46_META_WS_E_LOWFALLING: "Queda Baixa",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Granada M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Granada Especializada M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Carregador1",
  T_46_META_WS_E_MAGEZINE2: "Carregador2",
  T_46_META_WS_E_MAGEZINE3: "Carregador3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Lupa",
  T_46_META_WS_E_MALE: "Masculino",
  T_46_META_WS_E_MARK: "Marca",
  T_46_META_WS_E_MARKER: "Marca",
  T_46_META_WS_E_MASK: "Pintura Facial",
  T_46_META_WS_E_MAXVALUE: "Valor Máximo",
  T_46_META_WS_E_MECHANICAL: "Cliquete Rápido 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Eco do Dispositivo Mecânico",
  T_46_META_WS_E_MEDICALPROPS: "Itens Médicos",
  T_46_META_WS_E_MEDICALTENT: "Tenda médica",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Batimento Cardíaco Médio",
  T_46_META_WS_E_MEDKIT: "Kit de Primeiros Socorros",
  T_46_META_WS_E_MELEE: "Arma de combate corpo a corpo",
  T_46_META_WS_E_MELEEWEAPONS: "Arma de Corpo a Corpo",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Microfone",
  T_46_META_WS_E_MIDDLE: "Meio",
  T_46_META_WS_E_MINIHANDLE: "Mini Empunhadura",
  T_46_META_WS_E_MINIMAP: "Minimapa",
  T_46_META_WS_E_MINISENTRY: "Mini sentinela",
  T_46_META_WS_E_MINVALUE: "Valor Mínimo",
  T_46_META_WS_E_MISSILEEXPLODE: "Arma do Tipo Míssil",
  T_46_META_WS_E_MISSIONCOMPLETE: "Sucesso na Missão 1",
  T_46_META_WS_E_MISTAKE: "Erro",
  T_46_META_WS_E_MODERATE: "Moderado",
  T_46_META_WS_E_MONEY: "Dinheiro",
  T_46_META_WS_E_MONSTER: "Zumbi",
  T_46_META_WS_E_MONSTERSPAWN: "Ponto de Surgimento do Monstro",
  T_46_META_WS_E_MONSTERTRUCK: "Caminhão Monstro",
  T_46_META_WS_E_MOON: "Lua",
  T_46_META_WS_E_MOSQUITO: "Mosquito",
  T_46_META_WS_E_MOTIONTRAIL: "Colisão Traseira",
  T_46_META_WS_E_MOTOBIKE: "Motocicleta",
  T_46_META_WS_E_MOTORBIKE: "Motocicleta",
  T_46_META_WS_E_MOVE: "Mover",
  T_46_META_WS_E_MOVEMENT: "Mover",
  T_46_META_WS_E_MOVINGJOYSTICK: "Joystick de Movimento",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Sr. V",
  T_46_META_WS_E_MULTIPLIER: "Multiplicador",
  T_46_META_WS_E_MULTIPLY: "Multiplicar",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Multiplicar e Acumular",
  T_46_META_WS_E_MUSHROOM1: "Cogumelo1",
  T_46_META_WS_E_MUSHROOM2: "Cogumelo2",
  T_46_META_WS_E_MUSHROOM3: "Cogumelo3",
  T_46_META_WS_E_MUSHROOM4: "Cogumelo4",
  T_46_META_WS_E_MUSHSHADE: "Agrupamento de cogumelos gigantes",
  T_46_META_WS_E_MUSIC: "Música",
  T_46_META_WS_E_MUZZLE1: "Muzzle1",
  T_46_META_WS_E_MUZZLE2: "Muzzle2",
  T_46_META_WS_E_MUZZLE3: "Muzzle3",
  T_46_META_WS_E_NEAR: "Perto",
  T_46_META_WS_E_NIGHT: "Noite",
  T_46_META_WS_E_NOATTACK: "Sem Ataque",
  T_46_META_WS_E_NODUALWIELDING: "Sem uso duplo",
  T_46_META_WS_E_NOERROR: "Sem erro",
  T_46_META_WS_E_NONE: "Nenhum",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Não Pular Derrubada",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Habilidade 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Obter Ouro Médio",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Obter Grande Ouro",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Obter Pequeno Ouro",
  T_46_META_WS_E_OILDRUMEXPLODE: "Explosão de Barril de Óleo",
  T_46_META_WS_E_ONCE: "Uma vez",
  T_46_META_WS_E_ONEWAY: "Só ida",
  T_46_META_WS_E_OPENFOLDER: "Pasta Aberta",
  T_46_META_WS_E_OPENHIHATS: "Hi-hat aberto",
  T_46_META_WS_E_OPENINGBOX: "Abrir Pacote",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Suprimento da Guilda",
  T_46_META_WS_E_OPENINGWARCHEST: "Salvar Armazém",
  T_46_META_WS_E_ORANGE: "Laranja",
  T_46_META_WS_E_ORTHOGONAL: "Ortogonal",
  T_46_META_WS_E_OUTPOST: "Posto de guarda",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Parede pintada",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Habilidade Piscina de Sangue",
  T_46_META_WS_E_PALM: "Papel",
  T_46_META_WS_E_PANEL: "Painel",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Passageiro A",
  T_46_META_WS_E_PASSENGERB: "Passageiro B",
  T_46_META_WS_E_PASSENGERC: "Passageiro C",
  T_46_META_WS_E_PASSIVE: "Passivo",
  T_46_META_WS_E_PASSIVESKILL: "Habilidade Passiva",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patrulha com Ataque",
  T_46_META_WS_E_PERSONALUAV: "Drone Pessoal",
  T_46_META_WS_E_PERSPECTIVE: "Perspectiva",
  T_46_META_WS_E_PETTABBG: "Animal de Estimação",
  T_46_META_WS_E_PHASESTART: "Início da Fase",
  T_46_META_WS_E_PHONEBOOTH: "Cabine Telefônica",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Notas Musicais - Piano",
  T_46_META_WS_E_PIANOKEY2: "Notas Musicais - Piano",
  T_46_META_WS_E_PICKUPS: "Coletas",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Coluna de concreto",
  T_46_META_WS_E_PIN: "Anotação",
  T_46_META_WS_E_PINGPONG: "Pingue-pong",
  T_46_META_WS_E_PIPECORNER: "Tubo de cotovelo",
  T_46_META_WS_E_PIPEINTERSECTION: "Tubo cruzado",
  T_46_META_WS_E_PISTOL: "Pistola",
  T_46_META_WS_E_PISTOLAMMO: "Munição de Pistola",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Bloco de Parque de Diversões Xadrez",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Jogador",
  T_46_META_WS_E_PLUS: "Mais",
  T_46_META_WS_E_PODIUM: "Palco",
  T_46_META_WS_E_POISONGAS: "Gás Tóxico",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Gás Tóxico",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Pós-acumulador",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Batimento Cardíaco Rápido",
  T_46_META_WS_E_PREACCUMULATOR: "Pré-acumulador",
  T_46_META_WS_E_PRIMARYWEAPONA: "Arma Primária A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Arma Primária B",
  T_46_META_WS_E_PRIOREXPLOSION: "Antes da Explosão da Bomba",
  T_46_META_WS_E_PROFILEWIDGET: "Widget de perfil",
  T_46_META_WS_E_PRONE: "Deitado",
  T_46_META_WS_E_PUMPKIN: "Abóbora",
  T_46_META_WS_E_PURPLE: "Roxo",
  T_46_META_WS_E_QUADRILATERAL: "Quadrilátero",
  T_46_META_WS_E_QUESTIONMARK: "Ponto de Interrogação",
  T_46_META_WS_E_QUICKCHAT: "Chat Rápido",
  T_46_META_WS_E_QUICKCHATSHOW: "Exibição do Chat Rápido",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Fúria",
  T_46_META_WS_E_RANDOM: "Aleatório",
  T_46_META_WS_E_RANDOMBUFF: "Buff aleatório",
  T_46_META_WS_E_RANKDOWN: "Baixar de Nível",
  T_46_META_WS_E_REACTION: "Responder",
  T_46_META_WS_E_RECOVER: "Recuperar",
  T_46_META_WS_E_RECYCLE: "Reciclar",
  T_46_META_WS_E_RED: "Vermelho",
  T_46_META_WS_E_REFINERYTANK: "Jarra de água",
  T_46_META_WS_E_REFLECTIVECUBE: "Bloco Básico de Cor Sólida Reflexiva 1",
  T_46_META_WS_E_REFRESH: "Atualizar",
  T_46_META_WS_E_RELEASINGSKILL: "Efeito Visual de Uso de Habilidade",
  T_46_META_WS_E_RELOAD: "Recarregar",
  T_46_META_WS_E_REMINDER: "Lembrete",
  T_46_META_WS_E_REPAIR: "Reparo",
  T_46_META_WS_E_REPAIREQUIP: "Kit de Reparo",
  T_46_META_WS_E_REPAIRKIT: "Kit de Reparação",
  T_46_META_WS_E_REPLACER: "Substituto",
  T_46_META_WS_E_REPORT: "Reportar",
  T_46_META_WS_E_REST: "Descanso",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Ride",
  T_46_META_WS_E_RIDICULE: "Ridicularizar",
  T_46_META_WS_E_RIDICULEFUNNY: "Ridículo Engraçado",
  T_46_META_WS_E_RIFLE: "Fuzil",
  T_46_META_WS_E_RIFLEAMMO: "Munição de Fuzil",
  T_46_META_WS_E_RIGHT: "Correto",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Trapézio Retângulo",
  T_46_META_WS_E_RING: "Mecanismo de anel",
  T_46_META_WS_E_RINGPREDISCARDED: "Anel",
  T_46_META_WS_E_RIPTIDERHYTHM: "Habilidade 9",
  T_46_META_WS_E_RISINGPARTICLE: "Partículas Ascendentes",
  T_46_META_WS_E_ROADBLOCK: "Barreira",
  T_46_META_WS_E_ROTATE: "Rotação",
  T_46_META_WS_E_RUNNING: "Correndo",
  T_46_META_WS_E_RUSHTIME: "Fúria",
  T_46_META_WS_E_SAMURAI: "Samurai",
  T_46_META_WS_E_SANDA: "Areia A",
  T_46_META_WS_E_SANDSTRUCTURE: "Escultura de areia",
  T_46_META_WS_E_SCALE: "Escala",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Espantalho",
  T_46_META_WS_E_SCISSORS: "Tesoura",
  T_46_META_WS_E_SCOPE2X: "Mira x2",
  T_46_META_WS_E_SCOPE4X: "Mira x4",
  T_46_META_WS_E_SCROLLPANEL: "Painel de rolagem",
  T_46_META_WS_E_SECONDARYWEAPON: "Arma Secundária",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Habilidade 10",
  T_46_META_WS_E_SERVER: "Servidor",
  T_46_META_WS_E_SET: "Macacão",
  T_46_META_WS_E_SETTING: "Configurações",
  T_46_META_WS_E_SETTINGS: "Configurações",
  T_46_META_WS_E_SG: "Espingarda",
  T_46_META_WS_E_SGAMMO: "Munições SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Cliquete Rápido 1",
  T_46_META_WS_E_SHIELD: "Defesa",
  T_46_META_WS_E_SHIELDBROKEN: "Escudo quebrado",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "Escudo levantado",
  T_46_META_WS_E_SHOCKWAVE: "Onda de choque",
  T_46_META_WS_E_SHOES: "Sapatos",
  T_46_META_WS_E_SHOOTINGTARGET: "Alvo em movimento",
  T_46_META_WS_E_SHORTDATE: "Data Curta",
  T_46_META_WS_E_SHORTDATETIME: "Data e Hora Curtas",
  T_46_META_WS_E_SHORTTIME: "Hora Curta",
  T_46_META_WS_E_SHOTGUN: "Espingarda",
  T_46_META_WS_E_SHOTGUNAMMO: "Munição de Espingarda",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Muzzle para Shotgun",
  T_46_META_WS_E_SHOW: "Mostrar",
  T_46_META_WS_E_SHRUB: "Caixa de madeira longa coberta por arbustos",
  T_46_META_WS_E_SICKLE: "Foice",
  T_46_META_WS_E_SIDESCROLLING: "Vista Lateral",
  T_46_META_WS_E_SIGNAL: "Sinal",
  T_46_META_WS_E_SIGNOUT: "Sair",
  T_46_META_WS_E_SILENCER: "Silenciador",
  T_46_META_WS_E_SIMPLE: "Simples",
  T_46_META_WS_E_SIMPLEWIDGET: "Widget simples",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Único",
  T_46_META_WS_E_SITEHUT: "Casa contêiner",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Carga de Habilidade Completa",
  T_46_META_WS_E_SKILLRECOVER: "Recuperação de Habilidades",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Pular Derrubada",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Fatiado",
  T_46_META_WS_E_SLOPE: "Declive",
  T_46_META_WS_E_SLOWHEARTBEAT: "Batimento Cardíaco Lento",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "Munições SMG",
  T_46_META_WS_E_SMGMUZZLE: "Muzzle para SMG",
  T_46_META_WS_E_SMILEY: "Rosto Sorridente",
  T_46_META_WS_E_SMOKE: "Fumaça",
  T_46_META_WS_E_SMOKEGRENADE: "Granada de Fumaça",
  T_46_META_WS_E_SMOKEY: "Fumaça",
  T_46_META_WS_E_SMOOTH: "Suave",
  T_46_META_WS_E_SNAMMO: "Munições SN",
  T_46_META_WS_E_SNARES: "Tarola",
  T_46_META_WS_E_SNEAKERS: "Efeito Visual de Sapatos de Corrida",
  T_46_META_WS_E_SNIPER: "Fuzil de Precisão",
  T_46_META_WS_E_SNIPERAMMO: "Munição de Fuzil de Precisão",
  T_46_META_WS_E_SNOWA: "Neve A",
  T_46_META_WS_E_SNOWFLAKE: "Floco de Neve",
  T_46_META_WS_E_SOCCER: "Futebol",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Widget de botão social",
  T_46_META_WS_E_SOLARPANEL: "Painel solar",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Por prioridade de alto para baixo",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Por prioridade de baixo para alto",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Efeito Visual de Ponto de Surgimento",
  T_46_META_WS_E_SPEAKER: "Alto-falante",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Som de Arma Especial",
  T_46_META_WS_E_SPECIALGUN: "Arma Especial",
  T_46_META_WS_E_SPHERE: "Esfera",
  T_46_META_WS_E_SPHERETRIGGER: "Gatilho de Colisão Esférica",
  T_46_META_WS_E_SPIDERWEB: "Efeito Visual de Habilidade",
  T_46_META_WS_E_SPORTSCAR: "Carro esportivo",
  T_46_META_WS_E_SPOTLIGHT: "Luz",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Difusão de Gás Tóxico",
  T_46_META_WS_E_SPRINT: "Correndo",
  T_46_META_WS_E_SQUARE: "Quadrado",
  T_46_META_WS_E_SQUAREBOX: "Caixa de madeira quadrada",
  T_46_META_WS_E_SR: "Rifle de precisão",
  T_46_META_WS_E_STABLE: "Cabana de palha",
  T_46_META_WS_E_STAIRS: "Escada",
  T_46_META_WS_E_STANDING: "Em Pé",
  T_46_META_WS_E_STAR: "Estrela",
  T_46_META_WS_E_STATIC: "Estático",
  T_46_META_WS_E_STATUSTRIGGER: "Gatilho de Morte ou Invencibilidade",
  T_46_META_WS_E_STEP: "Passos",
  T_46_META_WS_E_STEPTRIGGER: "Ativar Mecanismo",
  T_46_META_WS_E_STOCK_S: "CORONHA_S",
  T_46_META_WS_E_STOCK_SR: "CORONHA_SR",
  T_46_META_WS_E_STOCK1: "Coronha1",
  T_46_META_WS_E_STOCK2: "Coronha2",
  T_46_META_WS_E_STOCK3: "Coronha3",
  T_46_META_WS_E_STONE: "Pedra",
  T_46_META_WS_E_STONEBRIDGE: "Ponte de Arco de Pedra",
  T_46_META_WS_E_STONELANTERN: "Lanterna de palácio",
  T_46_META_WS_E_STONESPLASH: "Detritos Voadores",
  T_46_META_WS_E_STORE: "Loja",
  T_46_META_WS_E_STREETLAMP: "Poste de luz",
  T_46_META_WS_E_STYLEA: "Estilo A",
  T_46_META_WS_E_STYLEB: "Estilo B",
  T_46_META_WS_E_STYLEC: "Estilo C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Munição de SMG",
  T_46_META_WS_E_SUCCESSFULHIT: "Impacto",
  T_46_META_WS_E_SUN: "Sol",
  T_46_META_WS_E_SUNSHADE: "Conjunto de Pátio com Guarda-chuva",
  T_46_META_WS_E_SUPERCAR: "Carro Esportivo",
  T_46_META_WS_E_SUPERMARKET: "Supermarket",
  T_46_META_WS_E_SURPRISEFIND: "Descobrir Surpresa",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Troca Rápida de Arma",
  T_46_META_WS_E_SWIMRING: "Boia",
  T_46_META_WS_E_SWORD: "Espada",
  T_46_META_WS_E_SYMBOLIC: "Marcador no Solo",
  T_46_META_WS_E_TANKZOMBIE: "Zumbi Tanque",
  T_46_META_WS_E_TAP: "Toque",
  T_46_META_WS_E_TAPPINGBUTTON: "Botão de Toque",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Tocar Botão de Desativar",
  T_46_META_WS_E_TEAM: "Equipe",
  T_46_META_WS_E_TEAMMATESINFO: "Informações dos Companheiros",
  T_46_META_WS_E_TELEPORT: "Teletransporte",
  T_46_META_WS_E_TELEPORTCORRECT: "Baliza de Destino Correto",
  T_46_META_WS_E_TELEPORTWRONG: "Baliza de Destino Errado",
  T_46_META_WS_E_TEXT: "Texto",
  T_46_META_WS_E_TEXTOBJECT: "Texto",
  T_46_META_WS_E_TEXTUREWIDGET: "Widget de textura",
  T_46_META_WS_E_THERMALSCOPE: "Mira térmica",
  T_46_META_WS_E_THIRDPERSON: "Terceira Pessoa",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Câmera em Terceira Pessoa Clássica",
  T_46_META_WS_E_THIRDPERSONLOCK: "Câmera em Terceira Pessoa com Bloqueio",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Faca de Arremesso2 para Compatibilidade",
  T_46_META_WS_E_THRILLBATTLE: "Habilidade 5",
  T_46_META_WS_E_THROWATTACK: "Lançar Granada",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Zumbi Arremessador Vermelho",
  T_46_META_WS_E_THROWZOMBIE: "Zumbi Arremessador",
  T_46_META_WS_E_THUMBSUP: "Curtir",
  T_46_META_WS_E_THUNDER: "Choque Elétrico",
  T_46_META_WS_E_TILEA: "Azulejo A",
  T_46_META_WS_E_TILEB: "Azulejo B",
  T_46_META_WS_E_TILEC: "Azulejo C",
  T_46_META_WS_E_TILED: "Revestido",
  T_46_META_WS_E_TIPSSOUND: "Mostrar Dicas",
  T_46_META_WS_E_TOGGLEWIDGET: "Widget de alternância",
  T_46_META_WS_E_TOILETBOWL: "Vaso sanitário",
  T_46_META_WS_E_TONEA: "Tom A",
  T_46_META_WS_E_TOP: "Torso",
  T_46_META_WS_E_TOPDOWN: "Vista de Cima",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Widget de touchpad",
  T_46_META_WS_E_TOWER: "Fortaleza",
  T_46_META_WS_E_TPIPE: "Tubo T",
  T_46_META_WS_E_TRACINGSTEPS: "Habilidade 3",
  T_46_META_WS_E_TRAILER: "Reboque",
  T_46_META_WS_E_TRANSFORMATION: "Mudança de Aparência",
  T_46_META_WS_E_TRANSPARENT: "Transparente",
  T_46_META_WS_E_TRAPEZOID: "Trapézio",
  T_46_META_WS_E_TRASHCAN: "Lixeira",
  T_46_META_WS_E_TRIANGLE: "Triângulo",
  T_46_META_WS_E_TRIGGERS: "Disparador",
  T_46_META_WS_E_TRIPLE: "Triplo",
  T_46_META_WS_E_TROPHY: "Troféu",
  T_46_META_WS_E_TRUE: "Sim",
  T_46_META_WS_E_TUKTUK: "Tuc Tuc",
  T_46_META_WS_E_TUTUCAR: "Tuk-Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zumbi Tirano",
  T_46_META_WS_E_UAVLITE: "Mini drone",
  T_46_META_WS_E_UIFINISH: "Fim",
  T_46_META_WS_E_UITAP: "Toque na Interface",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Gerador de Unidades",
  T_46_META_WS_E_UPWARDTURBULENCE: "Corrente de Ar Ascendente",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Saltar por cima",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Veículo",
  T_46_META_WS_E_VEHICLEEXPLODE: "Explosão de Veículo",
  T_46_META_WS_E_VELOCITY: "Velocidade",
  T_46_META_WS_E_VENDINGMACHINE: "Máquina de Vendas",
  T_46_META_WS_E_VERTICAL: "Vertical",
  T_46_META_WS_E_VEST: "Colete",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Colete4",
  T_46_META_WS_E_VISUALEFFECTS: "Efeitos Visuais",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Parede A",
  T_46_META_WS_E_WALLBRAWL: "Habilidade 2",
  T_46_META_WS_E_WARNING: "Aviso",
  T_46_META_WS_E_WATERRING: "Espirro de Água",
  T_46_META_WS_E_WAVE1: "Onda1",
  T_46_META_WS_E_WAVE2: "Onda2",
  T_46_META_WS_E_WAVE3: "Onda3",
  T_46_META_WS_E_WEAPONGENERATOR: "Arma",
  T_46_META_WS_E_WEAPONSLOT: "Slot de Arma",
  T_46_META_WS_E_WHISTLE: "Derrotar Oponente",
  T_46_META_WS_E_WIDERANGE: "Ampla gama",
  T_46_META_WS_E_WIN: "Vitória",
  T_46_META_WS_E_WINDATTACK: "Ataque de vento",
  T_46_META_WS_E_WOODA: "Madeira A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Zumbi Cortador de Madeira",
  T_46_META_WS_E_WOODENPLANK: "Ponte de tábuas",
  T_46_META_WS_E_WORLDPOSITION: "Coordenadas Mundiais",
  T_46_META_WS_E_WRECKEDBUS: "Ônibus destruído",
  T_46_META_WS_E_WRECKEDCAR: "Carro destruído",
  T_46_META_WS_E_WRONG: "Incorreto",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zumbi",
  T_46_META_WS_E_ZOMBIES: "Zumbi",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Eliminar",
  T_46_META_WS_ELIMINATEDENTITY: "Entidade eliminada",
  T_46_META_WS_ELIMINATEDPLAYER: "Jogador eliminado",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Habilitar Árvore de Comportamento Padrão",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Habilitar Movimento da Zona Segura",
  T_46_META_WS_ENABLESAFEZONE: "Habilitar Zona Segura",
  T_46_META_WS_ENDCURRENTPHASE: "Encerrar Fase Atual",
  T_46_META_WS_ENDMORPH: "Encerrar Transformação",
  T_46_META_WS_ENDPOSITION: "Posição final",
  T_46_META_WS_ENTERVEHICLE: "Entrar no Veículo",
  T_46_META_WS_ENTITY: "Entidade",
  T_46_META_WS_EQUIPMENTID: "ID do equipamento",
  T_46_META_WS_EULERANGLETOQUATERNION: "Ângulo de Euler para Quaternion",
  T_46_META_WS_EXITVEHICLE: "Sair do Veículo",
  T_46_META_WS_EXPONENTIATION: "Exponenciação",
  T_46_META_WS_FILTERENTITY: "Filtrar Entidade",
  T_46_META_WS_FILTERLEVELOBJECTS: "Filtrar Objetos de Nível",
  T_46_META_WS_FIND: "Encontrar",
  T_46_META_WS_FINDAT: "Encontrar Em",
  T_46_META_WS_FINDPATH: "Encontrar Caminho",
  T_46_META_WS_FLOOR: "Arredondar para Baixo",
  T_46_META_WS_FOOTBALLGOAL: "Gol de futebol",
  T_46_META_WS_FORMAT: "Formatar",
  T_46_META_WS_GETALLKEYS: "Obter Todas as Chaves",
  T_46_META_WS_GETALLPLAYERS: "Obter Todos os Jogadores",
  T_46_META_WS_GETALLSHOPS: "Obter Todas as Lojas",
  T_46_META_WS_GETALLTEAMS: "Obter Todas as Equipes",
  T_46_META_WS_GETATTACKABLEENTITY: "Obter Entidade Atacável",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Obter Grupos Atacáveis",
  T_46_META_WS_GETBACKPACKSKIN: "Obter Pele da Mochila",
  T_46_META_WS_GETBLACKBOARDVALUE: "Obter Valor do Quadro Negro",
  T_46_META_WS_GETBUFFS: "Obter Buffs",
  T_46_META_WS_GETCHATCHANNEL: "Obter Canal de Bate-papo",
  T_46_META_WS_GETCHILDBYINDEX: "Obter Filho por Índice",
  T_46_META_WS_GETCHILDBYNAME: "Obter Filho por Nome",
  T_46_META_WS_GETCHILDREN: "Obter Filhos",
  T_46_META_WS_GETCOLORCHANNEL: "Obter Canal de Cor",
  T_46_META_WS_GETCONSUMABLES: "Obter Consumíveis",
  T_46_META_WS_GETCULLINGMASK: "Obter Máscara de Culling",
  T_46_META_WS_GETCURRENTCAMERA: "Obter Câmera Atual",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Obter Canal de Bate-papo Atual",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Obter Progresso da Missão Personalizada",
  T_46_META_WS_GETDYEDCOUNT: "Obter Contagem de Tingimentos",
  T_46_META_WS_GETDYEDSTATUS: "Obter Status de Tingimento",
  T_46_META_WS_GETEQUIPMENTS: "Obter Equipamentos",
  T_46_META_WS_GETFACTION: "Obter Grupo",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Obter Limite de Sono Global",
  T_46_META_WS_GETITEMCOUNT: "Obter Contagem de Itens",
  T_46_META_WS_GETLOADEDSCENES: "Obter Cenas Carregadas",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Obter Direção de Mira Local",
  T_46_META_WS_GETLOCALPLAYER: "Obter Jogador Local",
  T_46_META_WS_GETLOCALTIMESTAMP: "Obter Timestamp Local",
  T_46_META_WS_GETMAPID: "Obter ID do Mapa",
  T_46_META_WS_GETMINIMAP: "Obter Mini Mapa",
  T_46_META_WS_GETMONEY: "Obter Dinheiro",
  T_46_META_WS_GETMONEYCOUNT: "Obter Contagem de Dinheiro",
  T_46_META_WS_GETMORPH: "Obter Transformação",
  T_46_META_WS_GETNODEVARIABLE: "Obter Variável do Nó",
  T_46_META_WS_GETOUTFIT: "Obter Roupa",
  T_46_META_WS_GETOWNER: "Obter Proprietário",
  T_46_META_WS_GETPARENT: "Obter Pai",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Obter Posição Próxima ao Colega de Equipe",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Obter Posição de Spawn Aleatória",
  T_46_META_WS_GETRESULTFROMCURVE: "Obter Resultado da Curva",
  T_46_META_WS_GETSCENESKYBOX: "Obter Skybox da Cena",
  T_46_META_WS_GETSERVERREGION: "Obter Região do Servidor",
  T_46_META_WS_GETSERVERTIMESTAMP: "Obter Timestamp do Servidor",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Obter Parte do Esqueleto pelo Nome",
  T_46_META_WS_GETSKILLS: "Obter Habilidades",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Obter Limite de Sono",
  T_46_META_WS_GETTOKENCOUNT: "Obter Contagem de Tokens",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Obter Contagem de Tokens de Hoje",
  T_46_META_WS_GETTYPE: "Obter Tipo",
  T_46_META_WS_GETVEHICLESKIN: "Obter Pele do Veículo",
  T_46_META_WS_GETWALLET: "Obter Carteira",
  T_46_META_WS_GETWEAPONSKIN: "Obter Skin de Arma",
  T_46_META_WS_GETWIDGETBYPATH: "Obter Widget Pelo Caminho",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Obter Widget da UI Personalizada",
  T_46_META_WS_GIVEJAILBREAKITEM: "Dar Item de Fuga da Prisão",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Dar Recompensa de Fuga da Prisão",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Tem Acompanhamento Especial AOI",
  T_46_META_WS_HASCOMPONENT: "Tem Componente",
  T_46_META_WS_HASSCRIPT: "Tem Script",
  T_46_META_WS_HASTAG: "Tem Etiqueta",
  T_46_META_WS_HELPEDPLAYER: "Jogador assistido",
  T_46_META_WS_HELPPLAYER: "Jogador assistente",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Ocultar Grupo de Aparência",
  T_46_META_WS_HITENTITY: "Entidade atingida",
  T_46_META_WS_HITFLY: "Enviar Para o Ar",
  T_46_META_WS_HITNORMAL: "Normal do impacto",
  T_46_META_WS_HITOBJECT: "Objeto atingido",
  T_46_META_WS_HITPOSITION: "Posição do impacto",
  T_46_META_WS_INDEXOF: "Obter Posição da Primeira Ocorrência do Item",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Zumbi Infectado Cresce",
  T_46_META_WS_INSERT: "Inserir",
  T_46_META_WS_ISATTACKABLE: "É Atacável",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Canal de Bate-papo Está Vazio",
  T_46_META_WS_ISEQUAL: "É Igual",
  T_46_META_WS_ISFRIEND: "É Amigo",
  T_46_META_WS_ISHIT: "Foi atingido",
  T_46_META_WS_ISINSIDEBOX: "Dentro da Caixa",
  T_46_META_WS_ISINSIDECYLINDER: "Dentro do Cilindro",
  T_46_META_WS_ISINSIDESECTOR: "Dentro do Setor",
  T_46_META_WS_ISINSIDESPHERE: "Dentro da Esfera",
  T_46_META_WS_ISSLEEPING: "Está Dormindo",
  T_46_META_WS_ISSUBTYPEOF: "É Subtipo de",
  T_46_META_WS_ITEM: "Entidade",
  T_46_META_WS_ITEMID: "ID do item",
  T_46_META_WS_JOIN: "Unir",
  T_46_META_WS_JOINCHATCHANNEL: "Entrar no Canal de Bate-papo",
  T_46_META_WS_JOINFACTION: "Entrar no Grupo",
  T_46_META_WS_LASTINDEXOF: "Obter Posição da Última Ocorrência do Item",
  T_46_META_WS_LENGTH: "Comprimento",
  T_46_META_WS_LERP: "Interpolação",
  T_46_META_WS_LOADSCENE: "Carregar Cena",
  T_46_META_WS_LOGARITHM: "Logaritmo",
  T_46_META_WS_LOGERROR: "Registrar Erro",
  T_46_META_WS_LOGINFO: "Registrar Informações",
  T_46_META_WS_LOGWARNING: "Registrar Aviso",
  T_46_META_WS_LOOKROTATION: "Rotação de Olhar",
  T_46_META_WS_MAGNITUDE: "Magnitude",
  T_46_META_WS_MAKER: "Criador",
  T_46_META_WS_MAX: "Máx",
  T_46_META_WS_MECHANISM: "Mecanismo",
  T_46_META_WS_MIN: "Mín",
  T_46_META_WS_MONSTERUSESKILL: "Usar Habilidade",
  T_46_META_WS_MORPHOBJECT: "Objeto de morphing",
  T_46_META_WS_MORPHTO: "Transformar em",
  T_46_META_WS_MORPHTOBYITEMID: "Transformar por ID do Item",
  T_46_META_WS_MOVECCT: "Mover CCT",
  T_46_META_WS_MOVEPOSITION: "Mover Posição",
  T_46_META_WS_MOVEROTATION: "Mover Rotação",
  T_46_META_WS_MULTIPLYQUATERNION: "Multiplicar Quaternion",
  T_46_META_WS_MULTIRAYCAST: "Detecção de Raios Múltiplos",
  T_46_META_WS_NEGATE: "Negativo",
  T_46_META_WS_NEW: "Novo",
  T_46_META_WS_NODENAME: "Nome do nó",
  T_46_META_WS_NORMALIZE: "Normalizar",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Notificar Reprodução de Efeito",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Notificar Animação do Ícone de Reprodução",
  T_46_META_WS_NOTIFYPLAYSOUND: "Notificar Reprodução de Som",
  T_46_META_WS_NOTIFYSHOWTIPS: "Notificar Exibição de Dicas",
  T_46_META_WS_NUMTOSTRING: "Número para String",
  T_46_META_WS_ONACCESSEQUIPMENT: "Ao acessar equipamento",
  T_46_META_WS_ONACCESSITEM: "Ao acessar item",
  T_46_META_WS_ONACCESSWEAPON: "Ao acessar arma",
  T_46_META_WS_ONACE: "Ao jogar bem",
  T_46_META_WS_ONAIMED: "Ao ser alvo de mira",
  T_46_META_WS_ONAIMING: "Ao mirar",
  T_46_META_WS_ONASSIST: "Ao dar assistência",
  T_46_META_WS_ONATTACK: "Ao atacar",
  T_46_META_WS_ONATTACKSTOP: "Ao parar de atacar",
  T_46_META_WS_ONAWAKE: "Ao despertar",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Jogador derrubado",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Rebatido por pneu",
  T_46_META_WS_ONBOUNCEENTITY: "Rebote da entidade",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Botão da Interface Integrada Pressionado",
  T_46_META_WS_ONBULLETHIT: "Impacto da bala",
  T_46_META_WS_ONCAMERARAYCAST: "Raycast da câmera",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Impacto do controlador de personagem",
  T_46_META_WS_ONCHASE: "Perseguir",
  T_46_META_WS_ONCHASESTOP: "Parar de perseguir",
  T_46_META_WS_ONCLIPEND: "Fim do clipe",
  T_46_META_WS_ONCOLLISIONENTER: "Início da colisão",
  T_46_META_WS_ONCOLLISIONEXIT: "Fim da colisão",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Ao finalizar contagem regressiva",
  T_46_META_WS_ONCREEP: "Rastejar",
  T_46_META_WS_ONCROUCH: "Agachar",
  T_46_META_WS_ONDEALDAMAGE: "Causar dano",
  T_46_META_WS_ONDESTROY: "Destruir",
  T_46_META_WS_ONDISABLE: "Desabilitar",
  T_46_META_WS_ONDISCONNECT: "Desconectar",
  T_46_META_WS_ONDOUBLETAPPED: "Duplo toque",
  T_46_META_WS_ONDRAG: "Arrastar",
  T_46_META_WS_ONDRAGEND: "Fim do arrasto",
  T_46_META_WS_ONDRAGSTART: "Início do arrasto",
  T_46_META_WS_ONDRIVED: "Dirigido",
  T_46_META_WS_ONDRIVEVEHICLE: "Conduzir veículo",
  T_46_META_WS_ONDROPCONSUMABLE: "Soltar consumível",
  T_46_META_WS_ONDROPPED: "Largado",
  T_46_META_WS_ONDROPWEAPON: "Soltar arma",
  T_46_META_WS_ONEACHLOOP: "Em Cada Loop",
  T_46_META_WS_ONELIMINATE: "Eliminar",
  T_46_META_WS_ONELIMINATED: "Eliminado",
  T_46_META_WS_ONENABLE: "Ao habilitar",
  T_46_META_WS_ONEND: "Fim",
  T_46_META_WS_ONENTERED: "Entrou",
  T_46_META_WS_ONENTERVEHICLE: "Entrar no veículo",
  T_46_META_WS_ONENTITYENTER: "Ao acionar entrada",
  T_46_META_WS_ONENTITYEXIT: "Ao acionar saída",
  T_46_META_WS_ONEQUIPARMOR: "Equipar armadura",
  T_46_META_WS_ONEQUIPED: "Equipado",
  T_46_META_WS_ONEQUIPWEAPON: "Equipar arma",
  T_46_META_WS_ONEXPLODE: "Ao explodir",
  T_46_META_WS_ONFALL: "Ao cair",
  T_46_META_WS_ONFALLSTOP: "Ao parar a queda",
  T_46_META_WS_ONFIRE: "Disparar",
  T_46_META_WS_ONFIXEDUPDATE: "Atualização fixa",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Colisão com a bola de futebol",
  T_46_META_WS_ONFRIENDSUPDATE: "Atualização de status de amizade ",
  T_46_META_WS_ONGAMEEND: "Fim do jogo",
  T_46_META_WS_ONGAMEPAUSE: "Pausar jogo",
  T_46_META_WS_ONGAMERESUME: "Retomar jogo",
  T_46_META_WS_ONGAMESTART: "Início do jogo",
  T_46_META_WS_ONGOAL: "Gol",
  T_46_META_WS_ONHITBYBULLET: "Atingido por bala",
  T_46_META_WS_ONHITFLY: "Impacto em voo",
  T_46_META_WS_ONHITFLYENTITY: "Impacto em entidade em voo",
  T_46_META_WS_ONHOOKGUNFIRE: "Disparo com gancho",
  T_46_META_WS_ONIDLE: "Ocioso",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Início da área de fuga",
  T_46_META_WS_ONJAILBREAKAREAEND: "Fim da área de fuga",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Entrada do jogador na área de fuga",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Saída do jogador da área de fuga",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Entrou no canal de chat com sucesso",
  T_46_META_WS_ONJOYSTICKMOVE: "Movimento do joystick",
  T_46_META_WS_ONJOYSTICKPRESSED: "Pressionado",
  T_46_META_WS_ONJOYSTICKRELEASED: "Liberado",
  T_46_META_WS_ONJUMP: "Pular",
  T_46_META_WS_ONJUMPSTOP: "Ao parar o salto",
  T_46_META_WS_ONLANDMINEACTIVE: "Mina ativada",
  T_46_META_WS_ONLANDMINETRIGGER: "Mina acionada",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Sair do canal de chat",
  T_46_META_WS_ONLEAVEVEHICLE: "Sair do veículo",
  T_46_META_WS_ONLEFT: "Saiu",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Objeto do nível transformado",
  T_46_META_WS_ONMOVE: "Mover",
  T_46_META_WS_ONNODEENTER: "Entrada no nó",
  T_46_META_WS_ONNODEEXIT: "Saída do nó",
  T_46_META_WS_ONPAUSE: "Pausar",
  T_46_META_WS_ONPHASEEND: "Fim da fase",
  T_46_META_WS_ONPHASESTART: "Início da fase",
  T_46_META_WS_ONPICKEDUP: "Pegado",
  T_46_META_WS_ONPLAYERASSIST: "Ao ajudar jogador",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Na eliminação do jogador",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Ao derrubar o jogador",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "No dano causado pelo jogador",
  T_46_META_WS_ONPLAYERELIMINATE: "Ao eliminar jogador",
  T_46_META_WS_ONPLAYERENTER: "Na entrada do jogador",
  T_46_META_WS_ONPLAYERJOIN: "Na entrada do jogador",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Falha ao entrar no canal de chat",
  T_46_META_WS_ONPLAYERLEAVE: "Ao sair o jogador",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Na solicitação de compra do jogador",
  T_46_META_WS_ONPLAYERQUIT: "Na saída do jogador no meio da partida",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Na alteração da classificação do jogador",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Solicitação de compra atendida",
  T_46_META_WS_ONPLAYERREVIVED: "Ao reviver jogador",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Ao reviver jogador no ponto de surgimento",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Na alteração da pontuação do jogador",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Ao trocar a cena do jogador",
  T_46_META_WS_ONPREDEALDAMAGE: "Antes de causar dano",
  T_46_META_WS_ONPREPURCHASE: "Antes de comprar",
  T_46_META_WS_ONPRESSED: "Pressionado",
  T_46_META_WS_ONPRETAKEDAMAGE: "Antes de receber dano",
  T_46_META_WS_ONPURCHASE: "Comprar",
  T_46_META_WS_ONRANKCHANGED: "Alteração da classificação da entidade",
  T_46_META_WS_ONRECONNECT: "Reconectar",
  T_46_META_WS_ONRELEASED: "Liberado",
  T_46_META_WS_ONRELOAD: "Recarregar",
  T_46_META_WS_ONRESUME: "Retomar",
  T_46_META_WS_ONREVIVED: "Ressuscitado",
  T_46_META_WS_ONROUNDEND: "Fim da rodada",
  T_46_META_WS_ONROUNDSTART: "Início da rodada",
  T_46_META_WS_ONSCENELOAD: "Carregamento de cena",
  T_46_META_WS_ONSCENESWITCH: "Ao trocar de cena",
  T_46_META_WS_ONSCORECHANGE: "Alteração da pontuação da entidade",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Atirado pelo atirador de futebol",
  T_46_META_WS_ONSLEEP: "Dormir",
  T_46_META_WS_ONSPAWN: "Aparecer",
  T_46_META_WS_ONSPRAY: "Pulverizar",
  T_46_META_WS_ONSPRAYED: "Pulverizado",
  T_46_META_WS_ONSPRINT: "Ao dar investida",
  T_46_META_WS_ONSPRINTSTOP: "Ao parar investida",
  T_46_META_WS_ONSTANDUP: "Levantar",
  T_46_META_WS_ONSTART: "Início",
  T_46_META_WS_ONSTARTFIRE: "Ao atacar",
  T_46_META_WS_ONSTATEEND: "Fim do estado",
  T_46_META_WS_ONSURFING: "Surfar",
  T_46_META_WS_ONSURFINGSTOP: "Parar de surfar",
  T_46_META_WS_ONSWITCHHANDHELD: "Ao trocar para dispositivo portátil",
  T_46_META_WS_ONTAKEDAMAGE: "Receber dano",
  T_46_META_WS_ONTAPPED: "Pressionado",
  T_46_META_WS_ONTEAMACE: "Ao aniquilar equipe",
  T_46_META_WS_ONTEAMADD: "Adição à equipe",
  T_46_META_WS_ONTEAMREMOVE: "Remoção da equipe",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Alteração da classificação da equipe na rodada",
  T_46_META_WS_ONTEAMSCORECHANGE: "Alteração da pontuação da equipe",
  T_46_META_WS_ONTELEPORTENTITY: "Teletransportar entidade",
  T_46_META_WS_ONTEXTCHANGE: "Mudança de texto",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Na explosão de arremessável",
  T_46_META_WS_ONTOGGLE: "Alternar",
  T_46_META_WS_ONTOUCHDOWN: "Toque para baixo",
  T_46_META_WS_ONTOUCHUP: "Toque para cima",
  T_46_META_WS_ONUIHIDE: "Ocultar interface",
  T_46_META_WS_ONUISHOW: "Mostrar interface",
  T_46_META_WS_ONUPDATE: "Atualização",
  T_46_META_WS_ONUSEAVATARSKILL: "Usar habilidade de avatar",
  T_46_META_WS_ONUSECONSUMABLE: "Usar consumível",
  T_46_META_WS_ONUSED: "Usado",
  T_46_META_WS_ONUSEPORTAL: "Usar portal",
  T_46_META_WS_ONWAKEUP: "Acordar",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Arma equipada",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Causar dano com arma",
  T_46_META_WS_ONWEAPONELIMINATE: "Eliminação com arma",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Parar de disparar arma",
  T_46_META_WS_OWNER: "Proprietário",
  T_46_META_WS_P_ACCELERATE: "Acelerar",
  T_46_META_WS_P_ACCELERATION: "Aceleração",
  T_46_META_WS_P_ACCOUNTID: "ID da Conta",
  T_46_META_WS_P_ACCURACY: "Precisão",
  T_46_META_WS_P_ACTIONTYPE: "Tipo de Ação",
  T_46_META_WS_P_ACTIVATEDALPHA: "Alpha Ativado",
  T_46_META_WS_P_ACTIVE: "Ativo",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Ativo na Hierarquia",
  T_46_META_WS_P_ACTIVESELF: "Ativo",
  T_46_META_WS_P_ACTIVETEXT: "Texto Ativo",
  T_46_META_WS_P_ACTUALPOSITION: "Posição real",
  T_46_META_WS_P_AFTERACCUMULATOR: "Acumulador Posterior",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Deslocamento do Centro de Assistência à Mira",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Distância de Assistência à Mira",
  T_46_META_WS_P_AIMASSISTTYPE: "Assistência de Mira",
  T_46_META_WS_P_AIRDROPSTATE: "Estado do lançamento aéreo",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Alinhamento Horizontal",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Alinhamento Vertical",
  T_46_META_WS_P_ALLITEMS: "Todos os Itens",
  T_46_META_WS_P_ALLMEMBERS: "Todos os Membros",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Permitir Bloqueio por Assistência de Mira",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Permitir Pressionar Fora",
  T_46_META_WS_P_ALLPLAYERS: "Todos os Jogadores",
  T_46_META_WS_P_ALLTEAMMATES: "Todos os Aliados",
  T_46_META_WS_P_ALPHA: "Alfa",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Sempre mostrar marcação",
  T_46_META_WS_P_AMBIENTCOLOR: "Cor Ambiental",
  T_46_META_WS_P_AMMOCLIPSIZE: "Tamanho do Carregador",
  T_46_META_WS_P_AMMOMAGSIZE: "Tamanho do Carregador de Munição",
  T_46_META_WS_P_AMMOPERSHOT: "Munição por Disparo",
  T_46_META_WS_P_AMMOTYPE: "Tipo de Munição",
  T_46_META_WS_P_ANCHORMAX: "Âncora máxima",
  T_46_META_WS_P_ANCHORMIN: "Âncora mínima",
  T_46_META_WS_P_ANCHOROBJECT: "Ancorar Objeto",
  T_46_META_WS_P_ANCHORPOSITION: "Posição de ancoragem",
  T_46_META_WS_P_ANCHORTYPE: "Script UITweener Ativado",
  T_46_META_WS_P_ANGLE: "Ângulo",
  T_46_META_WS_P_ANGLEDOWN: "Ângulo para Baixo",
  T_46_META_WS_P_ANGLEUP: "Ângulo para Cima",
  T_46_META_WS_P_ANGULARDRAG: "Arrasto Angular",
  T_46_META_WS_P_ANGULARSPEED: "Velocidade Angular",
  T_46_META_WS_P_ANGULARVELOCITY: "Velocidade Angular (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Nome da animação",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Controlador de Animação",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "ID do Recurso do Controlador de Animação",
  T_46_META_WS_P_ARMORPENETRATION: "Penetração de Armadura",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Fator de Penetração de Armadura",
  T_46_META_WS_P_ARMORTYPE: "Tipo de Armadura",
  T_46_META_WS_P_ARROWOFFSET: "Deslocamento da Flecha",
  T_46_META_WS_P_ARROWSIZE: "Tamanho da Flecha",
  T_46_META_WS_P_ARROWSPRITE: "Sprite de Flecha",
  T_46_META_WS_P_ASKBUYTARGET: "Solicitar Compra do Alvo",
  T_46_META_WS_P_ATTACHTARGET: "Alvo de Anexação",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Grupos Atacáveis",
  T_46_META_WS_P_ATTACKDAMAGE: "Dano de Ataque",
  T_46_META_WS_P_ATTACKINTERVAL: "Intervalo de Ataque",
  T_46_META_WS_P_ATTACKRANGE: "Alcance de Ataque",
  T_46_META_WS_P_ATTACKTARGET: "Alvo de Ataque",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Alvos Atacáveis",
  T_46_META_WS_P_AUTOPLAY: "Status de Reprodução Automática",
  T_46_META_WS_P_AVAILABLEPOINT: "Ponto Disponível",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "ID do Avatar",
  T_46_META_WS_P_BACKGROUND: "Fundo",
  T_46_META_WS_P_BACKGROUNDALPHA: "Alpha de Fundo",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Cor de fundo",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Cor de fundo 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Cor de fundo 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Preenchimento de Fundo",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Nome do ícone de fundo",
  T_46_META_WS_P_BACKGROUNDNAME: "Nome de Fundo",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Deslocamento de Fundo",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Raio de Fundo",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Delta do Tamanho de Fundo",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Sprite de Fundo",
  T_46_META_WS_P_BACKPACK: "Mochila",
  T_46_META_WS_P_BACKPACKSKINID: "ID da Skin da Mochila",
  T_46_META_WS_P_BACKWARDSPEED: "Velocidade para trás",
  T_46_META_WS_P_BANNERID: "ID do Banner",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Velocidade Horizontal Base",
  T_46_META_WS_P_BASEMULTIPLIER: "Multiplicador Base",
  T_46_META_WS_P_BASETIME: "Tempo Base",
  T_46_META_WS_P_BASEVERTICALSPEED: "Velocidade Vertical Base",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Acumulador Anterior",
  T_46_META_WS_P_BEVTREEID: "ID da Árvore de Comportamento",
  T_46_META_WS_P_BINDPROPERTYID: "ID da Propriedade Vinculada",
  T_46_META_WS_P_BODY: "Tronco",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Fator de Dano no Corpo",
  T_46_META_WS_P_BONEPOSITION: "Posição de Osso",
  T_46_META_WS_P_BONESCALE: "Escala do Esqueleto",
  T_46_META_WS_P_BOOSTCD: "Tempo de Recarga de Impulso",
  T_46_META_WS_P_BOOSTDURATION: "Duração do Boost",
  T_46_META_WS_P_BOOSTSPEED: "Velocidade de Boost",
  T_46_META_WS_P_BORDERLR: "Borda Esquerda-Direita",
  T_46_META_WS_P_BORDERTB: "Borda Superior-Inferior",
  T_46_META_WS_P_BOTTOMALPHA: "Alpha Inferior",
  T_46_META_WS_P_BOUNDWALLET: "Tipo de Âncora HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Potência dos Freios",
  T_46_META_WS_P_BRAKETORQUE: "Potência dos Freios",
  T_46_META_WS_P_BRRANK: "Classificação no BR",
  T_46_META_WS_P_BUFFTYPE: "Tipo de Buff",
  T_46_META_WS_P_BURNDAMAGE: "Dano de Queima",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Intervalo de Dano de Queima",
  T_46_META_WS_P_BURNTIME: "Tempo de Queima",
  T_46_META_WS_P_BUTTOM: "Inferior",
  T_46_META_WS_P_BUTTONCOLORS: "Cores dos botões",
  T_46_META_WS_P_BUTTONNAMES: "Nomes dos botões",
  T_46_META_WS_P_BUTTONSTYLE: "Estilo de Botão",
  T_46_META_WS_P_CAMERABLOCKMODE: "Modo de Bloqueio da Câmera",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Modo de Projeção da Câmera",
  T_46_META_WS_P_CAMERATYPE: "Tipo de Câmera",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Cancelar Arrasto se Ajustar",
  T_46_META_WS_P_CANCOSTDURABILITY: "Pode Custar Durabilidade",
  T_46_META_WS_P_CANDAMAGED: "Pode Ser Danificado",
  T_46_META_WS_P_CANDESTROY: "Pode Destruir",
  T_46_META_WS_P_CANDESTROYED: "Pode ser destruído",
  T_46_META_WS_P_CANSELFTRIGGER: "Pode ser ativado por si mesmo",
  T_46_META_WS_P_CANTEAMTRIGGER: "Aliados podem acionar",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Pode ser acionado por si mesmo",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Pode Ser Acionado pela Equipe",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Pode ser acionado por Veículo",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Pode ser ativado por um veículo",
  T_46_META_WS_P_CELLSIZE: "Tamanho da Célula",
  T_46_META_WS_P_CELLSPACE: "Espaço entre Células",
  T_46_META_WS_P_CENTER: "Centro",
  T_46_META_WS_P_CENTERINVISIBLE: "Centro Invisível",
  T_46_META_WS_P_CENTEROFFSET: "Deslocamento do Centro",
  T_46_META_WS_P_CENTEROFMASS: "Centro de Massa",
  T_46_META_WS_P_CENTERRANGE: "Alcance Central",
  T_46_META_WS_P_CENTRALFLASHTIME: "Tempo da Luz Central",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Linha Central Ativa",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Posição da Linha Central",
  T_46_META_WS_P_CHANNELID: "ID do Canal de Chat",
  T_46_META_WS_P_CHARGEMAX: "Carga Máxima",
  T_46_META_WS_P_CHASETARGET: "Alvo de Perseguição",
  T_46_META_WS_P_CHATCHANNEL: "Canal de Chat",
  T_46_META_WS_P_CHECKPOINTID: "ID do Checkpoint",
  T_46_META_WS_P_CHILDINDEX: "Índice filho",
  T_46_META_WS_P_CHIPEXP: "EXP por Chip",
  T_46_META_WS_P_CLICKSIZE: "Tamanho do Clique",
  T_46_META_WS_P_CLIPLENGTH: "Comprimento do Clipe",
  T_46_META_WS_P_CLIPPINGTYPE: "Tipo de Recorte",
  T_46_META_WS_P_COLLIDERID: "ID do Collider",
  T_46_META_WS_P_CONSTRAIN: "Restrição",
  T_46_META_WS_P_CONSTRAINT: "Restrição",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Contagem de Restrições",
  T_46_META_WS_P_CONSUMABLETYPE: "Tipo de Consumível",
  T_46_META_WS_P_CONTENT: "Conteúdo",
  T_46_META_WS_P_CONTENTORIGIN: "Origem do Conteúdo",
  T_46_META_WS_P_CONTROLPOINTS: "Pontos de Controle",
  T_46_META_WS_P_COORDINATESYSTEM: "Sistema de Coordenadas",
  T_46_META_WS_P_COUNT: "Contagem",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Tempo de término da contagem regressiva (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Chave da contagem regressiva",
  T_46_META_WS_P_COUNTDOWNTIME: "Tempo da contagem regressiva",
  T_46_META_WS_P_COUNTPERWAVE: "Contagem por Onda",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Dano Máximo de Colisão",
  T_46_META_WS_P_CRASHMAXSPEED: "Velocidade Máxima de Colisão",
  T_46_META_WS_P_CRASHMESSFACTOR: "Fator de Qualidade de Colisão",
  T_46_META_WS_P_CRASHMINDAMAGE: "Dano Mínimo de Colisão",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Escala de velocidade de movimento ao rastejar",
  T_46_META_WS_P_CREATEDENTITY: "Entidade Criada",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Escala de velocidade de movimento ao agachar",
  T_46_META_WS_P_CSRANK: "Classificação no CS",
  "T_46_META_WS_P_CURRENT AMMO": "Munição Atual",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Recurso de Animação Atual",
  T_46_META_WS_P_CURRENTCLIP: "Clipe Atual",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Progresso do Clipe Atual",
  T_46_META_WS_P_CURRENTDURABILITY: "Durabilidade Atual",
  T_46_META_WS_P_CURRENTENERGY: "Energia Atual",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Item em Mão Atual",
  T_46_META_WS_P_CURRENTHP: "HP atual",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Índice da Fase Atual",
  T_46_META_WS_P_CURRENTPROGRESS: "Progresso Atual",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Índice da Rodada Atual",
  T_46_META_WS_P_CURRENTSTATE: "Estado Atual",
  T_46_META_WS_P_CURRENTVALUE: "Valor atual",
  T_46_META_WS_P_CURRENTWAVE: "Onda Atual",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Recurso de Personagem Personalizado",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Resultado do Jogo Personalizado",
  T_46_META_WS_P_CUSTOMGRAVITY: "Gravidade Personalizada",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Força de Empurrão",
  T_46_META_WS_P_CUSTOMXY: "XY Personalizado",
  T_46_META_WS_P_DAMAGE: "Dano",
  "T_46_META_WS_P_DAMAGE RANGE": "Alcance",
  T_46_META_WS_P_DAMAGEFACTOR: "Fator de Dano",
  T_46_META_WS_P_DAMAGEINTERVAL: "Intervalo de dano (s)",
  T_46_META_WS_P_DAMAGERADIUS: "Raio de Dano",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Coeficiente de Dano por Acerto na Cabeça",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Taxa de Dano nos Membros",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Fator de Redução de Dano",
  T_46_META_WS_P_DAMAGETAKENPCT: "Percentagem de Dano Recebido",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Percentual de Dano Recebido",
  T_46_META_WS_P_DAMAGEVALUE: "Valor de dano",
  T_46_META_WS_P_DARKNESS: "Escuridão",
  T_46_META_WS_P_DECELERATIONPERCENT: "Percentual de Desaceleração",
  T_46_META_WS_P_DEFAULTTEXT: "Texto Padrão",
  T_46_META_WS_P_DEFENSE: "Taxa de Defesa",
  T_46_META_WS_P_DEFENSERATE: "Taxa de Redução de Defesa",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Tempo Delta",
  T_46_META_WS_P_DELTAVALUE: "Valor Delta",
  T_46_META_WS_P_DEPTH: "Profundidade",
  T_46_META_WS_P_DESC: "Descrição",
  T_46_META_WS_P_DESCRIPTION: "Descrição",
  T_46_META_WS_P_DESCRIPTIONKEY: "Chave de descrição",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Parâmetros de dicas",
  T_46_META_WS_P_DESTVAL: "Valor Dest",
  T_46_META_WS_P_DETECTRANGE: "Alcance de Detecção",
  T_46_META_WS_P_DIFFUSEALPHA: "Alfa Difuso",
  T_46_META_WS_P_DIFFUSECOLOR: "Cor Difusa",
  T_46_META_WS_P_DIFFUSETEXTURE: "Textura Difusa",
  T_46_META_WS_P_DISABLECOLOR: "Cor Desativada",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Sem Dano de Queda",
  T_46_META_WS_P_DISABLEITEMDROP: "Desativar Soltar Itens",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Desabilitar Coleta de Itens",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Desativar Fechamento Manual",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Desativar Mensagens Rápidas",
  T_46_META_WS_P_DISABLERECIPROCATING: "Desativar Movimento Alternado",
  T_46_META_WS_P_DISABLEVOICECHAT: "Desativar Chat de Voz",
  T_46_META_WS_P_DISTANCE: "Distância",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Tipo Arma Dupla",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Escala de velocidade de movimento ao rastejar",
  T_46_META_WS_P_DOWNSPEED: "Velocidade para baixo",
  T_46_META_WS_P_DRAG: "Arrasto",
  T_46_META_WS_P_DRIVER: "Motorista",
  T_46_META_WS_P_DROPITEMS: "Itens de queda",
  T_46_META_WS_P_DURABILITY: "Durabilidade",
  T_46_META_WS_P_DURABILITYRECOVERY: "Recuperação de Durabilidade",
  T_46_META_WS_P_DURATION: "Duração",
  T_46_META_WS_P_EDGEFLASHTIME: "Tempo de Luz Periférica",
  T_46_META_WS_P_EFFECTACTIVE: "Efeito ativo",
  T_46_META_WS_P_EFFECTCOLOR: "Cor do efeito",
  T_46_META_WS_P_EFFECTDURATION: "Duração do Efeito",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Intervalo de Tempo Eficaz",
  T_46_META_WS_P_EFFECTRESID: "Caminho do Recurso de Efeito",
  T_46_META_WS_P_ENABLE: "Habilitar",
  T_46_META_WS_P_ENABLEATTACK: "Habilitar Ataque",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Habilitar Ressurgimento de NPC",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Habilitar Mapa de Profundidade",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Habilitar Queda na Morte",
  T_46_META_WS_P_ENABLELOCALIZATION: "Habilitar Localização",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Habilitar Movimento no Ar",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Habilitar Ressurgimento de Jogador",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Habilitar Visão do Jogador",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Habilitar Rotação com Gravidade",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Habilitar Atributos de Skin",
  T_46_META_WS_P_ENABLESWINGING: "Habilitar Balanço",
  T_46_META_WS_P_ENABLETRACTION: "Habilitar Tração",
  T_46_META_WS_P_ENDPOSITION: "Posição Final",
  T_46_META_WS_P_ENDRADIUS: "Raio final",
  T_46_META_WS_P_ENDTIME: "Tempo de término (s)",
  T_46_META_WS_P_ENDTIMES: "Tempo de Término",
  T_46_META_WS_P_ENDVALUE: "Valor Final",
  T_46_META_WS_P_ENERGY: "Energia",
  T_46_META_WS_P_ENERGYCOST: "Custo de Energia",
  T_46_META_WS_P_ENERGYRECOVERY: "Recuperação de Energia",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Potência do Motor",
  T_46_META_WS_P_ENGINETORQUE: "Potência do Motor",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "Máx. de Pontos de Energia",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Quantidade de Recuperação de Energia",
  T_46_META_WS_P_EVENTS: "Eventos",
  T_46_META_WS_P_EXPLODEDAMAGE: "Dano da Explosão",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Fator de Redução de Dano de Explosão",
  T_46_META_WS_P_EXPLODEDELAY: "Atraso da Explosão",
  T_46_META_WS_P_EXPLODERANGE: "Alcance da Explosão",
  T_46_META_WS_P_EXPLOSIONDELAY: "Atraso de Explosão",
  T_46_META_WS_P_EXPLOSIONRANGE: "Alcance da Explosão",
  T_46_META_WS_P_EXPLOSIONTIME: "Atraso de Explosão",
  T_46_META_WS_P_EXPPERDAMAGE: "EXP por Dano",
  T_46_META_WS_P_EXPPERMOVEMILE: "EXP por Milha Percorrida",
  T_46_META_WS_P_EXPPERSECOND: "EXP por Segundo",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Capacidade Extra da Mochila",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Espaço Extra para Mochila",
  T_46_META_WS_P_EXTRAHPRATIO: "Taxa de Vida Extra",
  T_46_META_WS_P_FACEPAINT: "Pintura Facial",
  T_46_META_WS_P_FACTION: "Grupo",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Taxa de Dano de Queda",
  T_46_META_WS_P_FALLSPEED: "Velocidade de Queda",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Velocidade de Recarga Automática",
  T_46_META_WS_P_FILEID: "ID interno",
  T_46_META_WS_P_FILL: "Preencher",
  T_46_META_WS_P_FILLAMOUNT: "Valor de Preenchimento",
  T_46_META_WS_P_FILLDIRECTION: "Direção de Preenchimento",
  T_46_META_WS_P_FILLTYPE: "Tipo de Preenchimento",
  T_46_META_WS_P_FIREANGLELIMIT: "Limite de Ângulo de Fogo",
  T_46_META_WS_P_FIRETYPE: "Tipo de Fogo",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Parâmetros do Primeiro Pontuação",
  T_46_META_WS_P_FIRSTSCORETITLE: "Título do Primeiro Pontuação",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Valor do Primeiro Pontuação",
  T_46_META_WS_P_FIXEDDELTATIME: "Tempo Delta Fixo",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Trocar Efeito do Impacto da Granada de Luz",
  T_46_META_WS_P_FLIP: "Inverter",
  T_46_META_WS_P_FLIPTYPE: "Tipo de Inversão",
  T_46_META_WS_P_FLYMAXHEIGHT: "Altura Máxima de Voo",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Velocidade Horizontal de Voo",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Velocidade Vertical de Voo",
  T_46_META_WS_P_FOGCOLOR: "Cor da Névoa",
  T_46_META_WS_P_FOLLOWTARGET: "Acompanhar alvo",
  T_46_META_WS_P_FONT: "Fonte",
  T_46_META_WS_P_FONTSIZE: "Tamanho da fonte",
  T_46_META_WS_P_FONTSTYLE: "Estilo de Fonte",
  T_46_META_WS_P_FONTTYPE: "Tipo de Fonte",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Forçar Sincronização com o Cliente",
  T_46_META_WS_P_FORWARD: "Frente",
  T_46_META_WS_P_FORWARDSPEED: "Velocidade para frente",
  T_46_META_WS_P_FOV: "Campo de Visão",
  T_46_META_WS_P_FREEZEDURATION: "Duração do Congelamento (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Grupos Amigáveis",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Jogadores Amigáveis",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Distância de Dano Total",
  T_46_META_WS_P_FUNCTIONTYPE: "Tipo de Função",
  T_46_META_WS_P_GAINHPCOLOR: "Cor de ganho de HP",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Contagem de Quadros",
  T_46_META_WS_P_GAMETIMECOUNT: "Tempo de Jogo",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Atraso na Mudança de Marcha",
  T_46_META_WS_P_GENDER: "Gênero",
  T_46_META_WS_P_GETONBOOSTCD: "Tempo de Recarga para Ativar Impulso",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Ativar Troca do Tempo de Recarga do Impulso",
  T_46_META_WS_P_GETONSKATEBOARDCD: "Tempo de Recarga para Subir no Skate",
  T_46_META_WS_P_GRADIENT: "Gradiente",
  T_46_META_WS_P_GRADIENTBOTTOM: "Gradiente Inferior",
  T_46_META_WS_P_GRADIENTTOP: "Gradiente Superior",
  T_46_META_WS_P_GRAVITY: "Gravidade",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Dano máximo de granada",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Dano mínimo de granada",
  T_46_META_WS_P_GRENADERANGE: "Alcance da granada",
  T_46_META_WS_P_GROUPID: "ID do Grupo",
  T_46_META_WS_P_HEAD: "Cabeça",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Fator de Dano na Cabeça",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Redução de Dano por Acerto na Cabeça",
  T_46_META_WS_P_HEIGHT: "Altura",
  T_46_META_WS_P_HELMET: "Capacete",
  T_46_META_WS_P_HIGHESTBRRANK: "Máxima Classificação no BR",
  T_46_META_WS_P_HIGHESTCSRANK: "Máxima Classificação no CS",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Ângulo de Elevação Mínimo",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Limite de Direção em Alta Velocidade",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Limite de Direção em Alta Velocidade à Velocidade",
  T_46_META_WS_P_HITPOINTEFFECT: "Efeito de Ponto de Impacto",
  T_46_META_WS_P_HORIZONTALBAR: "Barra Horizontal",
  T_46_META_WS_P_HORIZONTALOFFSET: "Deslocamento Horizontal",
  T_46_META_WS_P_HOSTILETEAMS: "Equipes Oponentes",
  T_46_META_WS_P_HOSTTEAM: "Time Host",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "Max. HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Quantidade de Recuperação de Vida",
  T_46_META_WS_P_HPRECOVERYSPEED: "Velocidade de Recuperação de Vida (ms)",
  T_46_META_WS_P_ICON: "Ícone",
  T_46_META_WS_P_ICONCOLOR: "Cor do ícone",
  T_46_META_WS_P_ICONNAME: "Nome do ícone",
  T_46_META_WS_P_ICONRESOURCE: "Recurso do ícone",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Intervalo de Dano (s)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Entrada de Freio em Marcha Lenta",
  T_46_META_WS_P_INACTIVATEDALPHA: "Alpha Desativado",
  T_46_META_WS_P_INDEX: "Índice",
  T_46_META_WS_P_INITIALMAGCOUNT: "Contagem Inicial de Carregadores",
  T_46_META_WS_P_INITIALSPEED: "Velocidade Inicial",
  T_46_META_WS_P_INITIALVALUE: "Valor inicial",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Posição Inicial do Mundo",
  T_46_META_WS_P_INSCENE: "Na Cena",
  T_46_META_WS_P_INSTANCEID: "ID de Instância",
  T_46_META_WS_P_INTENSITY: "Intensidade",
  T_46_META_WS_P_INVERTFILL: "Inverter Preenchimento",
  T_46_META_WS_P_INVINCIBLE: "Invencível",
  "T_46_META_WS_P_IS SHOW": "Mostrar",
  T_46_META_WS_P_IS3D: "3D",
  T_46_META_WS_P_ISACE: "Aniquilação de Equipe",
  T_46_META_WS_P_ISACED: "Eliminado",
  T_46_META_WS_P_ISAI: "IA",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Sempre na Tela",
  T_46_META_WS_P_ISAPPLYSHADOW: "Aplicar Sombra",
  T_46_META_WS_P_ISATTACKABLE: "Pode ser atacado",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Perseguição Automática de Oponente",
  T_46_META_WS_P_ISAUTOPLAY: "Reprodução automática",
  T_46_META_WS_P_ISAUTOTELEPORT: "É Teletransporte Automático",
  T_46_META_WS_P_ISBILLBOARD: "Anúncio",
  T_46_META_WS_P_ISBOLD: "Negrito",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Colisão Inferior",
  T_46_META_WS_P_ISCENTERPOS: "É posição central",
  T_46_META_WS_P_ISCONSUMEAMMO: "Consome Munição",
  T_46_META_WS_P_ISCONTINUOUS: "É Contínuo",
  T_46_META_WS_P_ISCOUNTDOWN: "É uma contagem regressiva",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Animação Atual em Looping",
  T_46_META_WS_P_ISDEADDROP: "Suporte à Morte",
  T_46_META_WS_P_ISDEATHTRIGGER: "Gatilho de Eliminação",
  T_46_META_WS_P_ISDEBUG: "Habilitar depuração BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "É Ponto de Spawn Padrão",
  T_46_META_WS_P_ISDROPONELIMINATED: "Perda de Equipamento ao Ser Eliminado",
  T_46_META_WS_P_ISEND: "Fim",
  T_46_META_WS_P_ISFEBUTTON: "É Botão FE",
  T_46_META_WS_P_ISGREY: "Está cinza",
  T_46_META_WS_P_ISGROUNDED: "No Solo",
  T_46_META_WS_P_ISIGNOREDEPTH: "Ignorar Profundidade",
  T_46_META_WS_P_ISINVINCIBLE: "Invencível",
  T_46_META_WS_P_ISITALIC: "Itálico",
  T_46_META_WS_P_ISLASTROUND: "Última rodada",
  T_46_META_WS_P_ISLOCALPOS: "Ativar sistema de coordenadas local",
  T_46_META_WS_P_ISLOOP: "Looping",
  T_46_META_WS_P_ISMATCHPOINT: "Ponto decisivo",
  T_46_META_WS_P_ISMOVEABLE: "Habilitar Movimento",
  T_46_META_WS_P_ISOCCUPIED: "Está Ocupado",
  T_46_META_WS_P_ISOPENTWEEN: "Ativar efeito de mudança de HP",
  T_46_META_WS_P_ISPLAYING: "Jogando",
  T_46_META_WS_P_ISPURCHASABLE: "Lista de Itens",
  T_46_META_WS_P_ISREVERSE: "Reverter",
  T_46_META_WS_P_ISSERVERDRIVEN: "Controlado pelo Servidor",
  T_46_META_WS_P_ISSHOW: "Mostrar",
  T_46_META_WS_P_ISSHOWHUDNAME: "Mostrar Nome HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "Mostrar Informações do Mapa",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Mostrar Mensagem Rápida",
  T_46_META_WS_P_ISSHOWSCAN: "Mostrar Scan",
  T_46_META_WS_P_ISSHOWTAG: "Mostrar Tag",
  T_46_META_WS_P_ISSIDECOLLIDING: "Colisão Lateral",
  T_46_META_WS_P_ISSILENCE: "Silenciado",
  T_46_META_WS_P_ISSINGLESHOT: "Único Disparo",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Pular Animação de Queda",
  T_46_META_WS_P_ISSLIDING: "Está Deslizando",
  T_46_META_WS_P_ISTOPCOLLIDING: "Colisão Superior",
  T_46_META_WS_P_ISUNDERLINE: "Sublinhado",
  T_46_META_WS_P_ISVISIBLE: "Visível",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Cores de fundo das cartas",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Fundos das cartas",
  T_46_META_WS_P_ITEMCOUNTS: "Contagem de Itens",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Descrições das cartas",
  T_46_META_WS_P_ITEMICONS: "Ícones das cartas",
  T_46_META_WS_P_ITEMID: "ID da Arma",
  T_46_META_WS_P_ITEMIDS: "IDs dos Itens",
  T_46_META_WS_P_ITEMNAMES: "Nomes das cartas",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Lista de Itens Proibidos",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Raio de Arrasto do Cap do Joystick",
  T_46_META_WS_P_JOYSTICKIMAGE: "Imagem do Cap do Joystick",
  T_46_META_WS_P_JOYSTICKRADIUS: "Raio do Cap do Joystick",
  T_46_META_WS_P_JUMPCD: "Tempo de Recarga para Pular",
  T_46_META_WS_P_JUMPHEIGHT: "Altura do Salto",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Escala de Altura de Salto",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Bônus de Dano por Derrubar",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Status de Derrubada",
  T_46_META_WS_P_LABEL: "Rótulo",
  T_46_META_WS_P_LABELCOLOR: "Cor do Rótulo",
  T_46_META_WS_P_LABELKEY: "Chave do rótulo",
  T_46_META_WS_P_LABELPARAMS: "Parâmetros do rótulo",
  T_46_META_WS_P_LASTCHECKPOINTID: "ID do Ponto de Checagem Atual",
  T_46_META_WS_P_LASTSURVIVALTIME: "Último Tempo de Sobrevivência",
  T_46_META_WS_P_LAYERTYPE: "Tipo de Camada",
  T_46_META_WS_P_LAYOUTTYPE: "Tipo de Layout",
  T_46_META_WS_P_LEFTARM: "Braço Esquerdo",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Cor de fundo à esquerda",
  T_46_META_WS_P_LEFTCOLOR: "Cor à Esquerda",
  T_46_META_WS_P_LEFTDESCRIPTION: "Descrição à Esquerda",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Efeito Esquerdo Ativo",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Ângulo de Tiro Esquerdo",
  T_46_META_WS_P_LEFTFOOT: "Pé Esquerdo",
  T_46_META_WS_P_LEFTHAND: "Mão Esquerda",
  T_46_META_WS_P_LEFTICON: "Ícone esquerdo",
  T_46_META_WS_P_LEFTICONNAME: "Nome do ícone à esquerda",
  T_46_META_WS_P_LEFTLEG: "Perna Esquerda",
  T_46_META_WS_P_LEFTPLAYERS: "Jogadores à esquerda",
  T_46_META_WS_P_LEFTSCORE: "Pontuação esquerda",
  T_46_META_WS_P_LEFTSCOREAFTER: "Pontuação final esquerda",
  T_46_META_WS_P_LEFTSCORETEXT: "Pontuação esquerda",
  T_46_META_WS_P_LEFTTEAM: "Equipe Direita",
  T_46_META_WS_P_LEFTTEAMINDEX: "Índice da equipe esquerda",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Número de colegas vivos à esquerda",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Contagem de Bandeiras à Esquerda",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Estados à Esquerda",
  T_46_META_WS_P_LEFTTEAMNAME: "Nome da Equipe à Esquerda",
  T_46_META_WS_P_LEFTTEAMSCORE: "Pontuação da Equipe à Esquerda",
  T_46_META_WS_P_LEFTTEXT: "Texto esquerdo",
  T_46_META_WS_P_LENGTH: "Comprimento",
  T_46_META_WS_P_LENSFLARE: "Efeito de Reflexo da Lente",
  T_46_META_WS_P_LEVEL: "Nível",
  T_46_META_WS_P_LIFETIME: "Tempo de Vida (s)",
  T_46_META_WS_P_LIGHTCOLOR: "Cor da Luz",
  T_46_META_WS_P_LIGHTINTENSITY: "Intensidade da Luz",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Fator de Dano nos Membros",
  T_46_META_WS_P_LINESPACING: "Espaçamento entre Linhas",
  T_46_META_WS_P_LOCALPOSITION: "Posição local",
  T_46_META_WS_P_LOCALROTATION: "Rotação Local",
  T_46_META_WS_P_LOCALROTATIONQ: "Quaternion de Rotação Local",
  T_46_META_WS_P_LOCALSCALE: "Escala Local",
  T_46_META_WS_P_LOCKEY: "Chave de Localização",
  T_46_META_WS_P_LOOPCOUNT: "Contagem de Loops",
  T_46_META_WS_P_LOOTSOCCER: "Item de Futebol",
  T_46_META_WS_P_LOSEHPCOLOR: "Cor de perda de HP",
  T_46_META_WS_P_LOSEMVPS: "MVP da Derrota",
  T_46_META_WS_P_LOSETEXT: "Texto de derrota",
  "T_46_META_WS_P_MAIN CAMERA": "Câmera Principal",
  T_46_META_WS_P_MAINCOLOR: "Cor principal",
  T_46_META_WS_P_MAINSCORELIST: "Pontuações Principais",
  T_46_META_WS_P_MAINSCORETITLE: "Título Principal da Pontuação",
  T_46_META_WS_P_MAINWEAPON: "Arma Principal",
  T_46_META_WS_P_MAPSIZE: "Tamanho do mapa",
  T_46_META_WS_P_MASK: "Máscara",
  T_46_META_WS_P_MASKNAME: "Nome da Máscara",
  T_46_META_WS_P_MASS: "Massa (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Título do Jogo Esquerda",
  T_46_META_WS_P_MATCHTITLERIGHT: "Título do Jogo Direita",
  T_46_META_WS_P_MAXCAPACITY: "Capacidade Máxima",
  T_46_META_WS_P_MAXCOUNT: "Contagem Máxima",
  T_46_META_WS_P_MAXDAMAGE: "Dano Máximo",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Ângulo Máximo de Depressão",
  T_46_META_WS_P_MAXDISPLACEMENT: "Deslocamento Máx.",
  T_46_META_WS_P_MAXDISTANCE: "Distância Máxima",
  T_46_META_WS_P_MAXDURABILITY: "Durabilidade Máx.",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Fator de Durabilidade Máxima",
  T_46_META_WS_P_MAXENERGY: "Energia Máxima",
  T_46_META_WS_P_MAXEP: "Máx. de Pontos de Energia",
  T_46_META_WS_P_MAXHP: "HP Máx.",
  T_46_META_WS_P_MAXJUMPCOUNT: "Contagem Máx. de Pulos",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Altura Máxima do Pulo",
  T_46_META_WS_P_MAXLENGTH: "Comprimento Máximo",
  T_46_META_WS_P_MAXPROGRESS: "Máximo de Progresso",
  T_46_META_WS_P_MAXSCATTERRATIO: "Taxa Máxima de Dispersão",
  T_46_META_WS_P_MAXSPEED: "Velocidade Máxima",
  T_46_META_WS_P_MAXTURRETCOUNT: "Contagem Máx. de Torretas",
  T_46_META_WS_P_MAXVALUE: "Valor máximo",
  T_46_META_WS_P_MAXWIDGETID: "ID Máximo do Widget",
  T_46_META_WS_P_MINDAMAGE: "Dano Mínimo",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Distância Mínima de Dano",
  T_46_META_WS_P_MINDISTANCE: "Distância Mínima",
  T_46_META_WS_P_MINELEVATIONANGLE: "Ângulo Mínimo de Elevação",
  T_46_META_WS_P_MINENDHEIGHT: "Altura Mínima de Fim",
  T_46_META_WS_P_MINFLYHEIGHT: "Altura Mínima de Voo",
  T_46_META_WS_P_MINMOVEDISTANCE: "Distância Mínima de Movimento",
  T_46_META_WS_P_MINVALUE: "Valor Mínimo",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Dano Máximo do Míssil",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Dano Mínimo do Míssil",
  T_46_META_WS_P_MISSILERANGE: "Alcance do Míssil",
  T_46_META_WS_P_MODEL: "Modelo",
  T_46_META_WS_P_MODELVISIBILITY: "Visibilidade do Modelo",
  T_46_META_WS_P_MODELVISIBLE: "Modelo Visível",
  T_46_META_WS_P_MONEY: "Dinheiro",
  T_46_META_WS_P_MONEYLIST: "Lista de Dinheiro",
  T_46_META_WS_P_MONEYS: "Carteira Vinculada",
  T_46_META_WS_P_MONEYTYPE: "Tipo de Moeda",
  T_46_META_WS_P_MONSTERTYPE: "Tipo de Monstro",
  T_46_META_WS_P_MOTIONTYPE: "Tipo de Movimento",
  T_46_META_WS_P_MOTIONVALUEX: "Valor do Movimento X",
  T_46_META_WS_P_MOTIONVALUEY: "Valor do Movimento Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Valor do Movimento Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Duração do Movimento",
  T_46_META_WS_P_MULTIPLIER: "Multiplicador",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Tipo de Elemento Musical",
  T_46_META_WS_P_MUZZLEVELOCITY: "Velocidade de Muzzle",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Nome",
  T_46_META_WS_P_NEXTROUNDINDEX: "Índice da próxima rodada",
  T_46_META_WS_P_NICKNAME: "Apelido",
  T_46_META_WS_P_NORMALCOLOR: "Cor Normal",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Posição Normalizada",
  T_46_META_WS_P_NUMBERINFACTION: "Número no Grupo",
  T_46_META_WS_P_OBJECTID: "ID do Objeto",
  T_46_META_WS_P_OFFSET: "Deslocamento",
  T_46_META_WS_P_OPTIONS: "Opções",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Outro Fator de Dano",
  T_46_META_WS_P_OUTFIT: "Traje",
  T_46_META_WS_P_OVERFLOW: "Transbordamento",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Velocidade de Queda Após Altura Máxima",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Priorizar Configuração do Jogador",
  T_46_META_WS_P_OWNER: "Proprietário",
  T_46_META_WS_P_PARAMS: "Parâmetros de descrição",
  T_46_META_WS_P_PARENT: "Pai",
  T_46_META_WS_P_PARENTID: "ID pai",
  T_46_META_WS_P_PARENTUI: "UI pai",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "ID da Entidade do Dispositivo Pai",
  T_46_META_WS_P_PARENTWIDGETFILEID: "FileID do Widget Pai",
  T_46_META_WS_P_PARTMASKA: "Máscara de Peça 1",
  T_46_META_WS_P_PASSENGERS: "Passageiros",
  T_46_META_WS_P_PATHID: "ID do Caminho",
  T_46_META_WS_P_PAUSEEVENT: "Pausar evento",
  T_46_META_WS_P_PERSONAID: "ID de persona",
  T_46_META_WS_P_PHASEDURATION: "Duração (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Hora de Término (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Camada Física",
  T_46_META_WS_P_PINID: "ID da Medalha",
  T_46_META_WS_P_PITCH: "Inclinação",
  T_46_META_WS_P_PIVOT: "Pivô",
  T_46_META_WS_P_PLAYER: "Jogador",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Fator de Velocidade de Mira do Jogador",
  T_46_META_WS_P_PLAYERLIST: "Lista de Jogadores",
  T_46_META_WS_P_PLAYERNAME: "Nome do jogador",
  T_46_META_WS_P_PLAYERRANK: "Classificação do Jogador",
  T_46_META_WS_P_PLAYERRANKS: "Classificação dos Jogadores",
  T_46_META_WS_P_PLAYERS: "Jogadores",
  T_46_META_WS_P_PLAYERSCORETYPES: "Tipos de pontuação dos jogadores",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Fator de Velocidade do Jogador",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Fator de Velocidade do Jogador ao Atirar",
  T_46_META_WS_P_PLAYERSTATUS: "Status do Jogador",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Velocidade de Tração do Jogador",
  T_46_META_WS_P_PLAYINGSTATUS: "Status de Reprodução",
  T_46_META_WS_P_PLAYSPEED: "Velocidade de reprodução",
  T_46_META_WS_P_POINTPOSITION: "Posição do Ponto",
  T_46_META_WS_P_POINTS: "Pontos",
  T_46_META_WS_P_POSITION: "Posição",
  T_46_META_WS_P_PREFABID: "ID do Prefab",
  T_46_META_WS_P_PRESSEDCOLOR: "Cor ao Pressionar",
  T_46_META_WS_P_PRESSEDSPRITE: "Sprite ao Pressionar",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Tipo de Sprite ao Pressionar",
  T_46_META_WS_P_PRICE: "Preço",
  T_46_META_WS_P_PRIORITY: "Prioridade",
  T_46_META_WS_P_PROFILEINFO: "Informações do Perfil",
  T_46_META_WS_P_PROGRESS: "Progresso [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Ícone de Progresso",
  T_46_META_WS_P_PROGRESSICONNAME: "Nome do Ícone de Progresso",
  T_46_META_WS_P_PROPID: "ID do Prop",
  T_46_META_WS_P_PURCHASELIMIT: "Limite de Compra",
  T_46_META_WS_P_RADIUS: "Raio",
  T_46_META_WS_P_RANGE: "Alcance",
  T_46_META_WS_P_RANK: "Classificação",
  T_46_META_WS_P_RATIOSELFFACTOR: "Fator de Dano em Si",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Fator de Dano para Aliado",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Fator de Dano para Veículos",
  T_46_META_WS_P_REFRESHTIME: "Tempo de Atualização do Buff (s)",
  T_46_META_WS_P_RELOADSPEED: "Velocidade de Recarga",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Fator de Velocidade de Recarregamento",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Contagem de Pulos Restantes",
  T_46_META_WS_P_REMAINQUANTITY: "Quantidade Restante",
  T_46_META_WS_P_RENDERTYPE: "Tipo de Renderização",
  T_46_META_WS_P_REPEATTIMES: "Repetições",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Prioridade de Substituição",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ID do Jogador Acionador",
  T_46_META_WS_P_REQUESTTYPE: "Lista de Itens Solicitados",
  T_46_META_WS_P_RESETPERROUND: "Redefinir por Rodada",
  T_46_META_WS_P_RESETPOSITION: "Posição de Redefinição",
  T_46_META_WS_P_RESETTIME: "Tempo de Redefinição",
  T_46_META_WS_P_RESOURCE: "Recurso",
  T_46_META_WS_P_RESOURCEID: "ID de Recurso",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Restringir Dentro do Painel",
  T_46_META_WS_P_RESULT: "Resultado",
  T_46_META_WS_P_RESULTTYPE: "Tipo de resultado",
  T_46_META_WS_P_REVIVALPOINT: "Ponto de Ressurgimento",
  T_46_META_WS_P_REVIVECD: "Tempo de Recarga para Reviver",
  T_46_META_WS_P_RIGHT: "Direita",
  T_46_META_WS_P_RIGHTARM: "Braço Direito",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Cor de fundo à direita",
  T_46_META_WS_P_RIGHTCOLOR: "Cor à Direita",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Descrição à Direita",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Efeito Direito Ativo",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Ângulo de Tiro Direito",
  T_46_META_WS_P_RIGHTFOOT: "Pé Direito",
  T_46_META_WS_P_RIGHTHAND: "Mão Direita",
  T_46_META_WS_P_RIGHTICON: "Ícone direito",
  T_46_META_WS_P_RIGHTICONNAME: "Nome do ícone à direita",
  T_46_META_WS_P_RIGHTLEG: "Perna Direita",
  T_46_META_WS_P_RIGHTPLAYERS: "Jogadores à direita",
  T_46_META_WS_P_RIGHTSCORE: "Pontuação direita",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Pontuação final direita",
  T_46_META_WS_P_RIGHTSCORETEXT: "Pontuação direita",
  T_46_META_WS_P_RIGHTTEAM: "Títulos",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Índice da equipe direita",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Número de colegas vivos à direita",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Contagem de bandeiras do aliado à direita",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Estados à Direita",
  T_46_META_WS_P_RIGHTTEAMNAME: "Nome da Equipe à Direita",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Pontuação da Equipe à Direita",
  T_46_META_WS_P_RIGHTTEXT: "Texto direito",
  T_46_META_WS_P_RIMALPHA: "Alfa da Borda",
  T_46_META_WS_P_RIMCOLOR: "Cor da Borda",
  T_46_META_WS_P_RIMTEXTURE: "Textura da Borda",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Coeficiente de Fricção de Rolamento",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Multiplicador de Fricção (Colisão)",
  T_46_META_WS_P_ROTATION: "Rotação",
  T_46_META_WS_P_ROTATIONANGLE: "Ângulo de Rotação",
  T_46_META_WS_P_ROTATIONQ: "Quaternion de Rotação",
  T_46_META_WS_P_ROUNDINCOME: "Renda da rodada",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Números de Detalhes de Renda da Rodada",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Títulos de Detalhes de Renda da Rodada",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Título da renda da rodada",
  T_46_META_WS_P_ROUNDNUM: "Número da Rodada",
  T_46_META_WS_P_ROUNDNUMKEY: "Chave de Rodada",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Parâmetros da Chave de Rodada",
  T_46_META_WS_P_RUNSPEED: "Velocidade de Corrida",
  T_46_META_WS_P_RUNSPEEDSCALE: "Escala de Velocidade de Corrida",
  T_46_META_WS_P_RUSHDISTANCE: "Distância da Investida",
  T_46_META_WS_P_RUSHENERGYCOST: "Custo de Energia para Corrida",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Velocidade Vertical para Corrida",
  T_46_META_WS_P_SCALE: "Escala",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Velocidade de Aumento de Dispersão",
  T_46_META_WS_P_SCATTERMAX: "Dispersão Máxima",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Multiplicador de Dispersão em Movimento",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Velocidade de Recuperação de Dispersão",
  T_46_META_WS_P_SCATTERSPEED: "Velocidade de Dispersão",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Velocidade de Dispersão ao Agachar ou Deitar",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Limite de Dispersão",
  T_46_META_WS_P_SCOPETYPE: "Tipo de Mira",
  T_46_META_WS_P_SCORE: "Pontuação",
  T_46_META_WS_P_SCORES1: "Lista de Pontuações 1",
  T_46_META_WS_P_SCORES2: "Lista de Pontuações 2",
  T_46_META_WS_P_SCORES3: "Lista de Pontuações 3",
  T_46_META_WS_P_SCORES4: "Lista de Pontuações 4",
  T_46_META_WS_P_SCORES5: "Lista de Pontuações 5",
  T_46_META_WS_P_SCORETEXTKEY: "Chave do texto de pontuação",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Parâmetros da chave do texto de pontuação",
  T_46_META_WS_P_SCROLLCONTINUITY: "Continuidade da Rolagem",
  T_46_META_WS_P_SCROLLDIRECTION: "Direção de Rolagem",
  T_46_META_WS_P_SCROLLEFFECT: "Efeito de Rolagem",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Velocidade da Roda de Rolagem",
  T_46_META_WS_P_SECONDSCORETITLE: "Título do Segundo Pontuação",
  T_46_META_WS_P_SECONDSCOREVALUE: "Valor do Segundo Pontuação",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Parâmetros do Segundo Pontuação",
  T_46_META_WS_P_SELECTEDCOLOR: "Cor Selecionada",
  T_46_META_WS_P_SELECTEDINDEX: "Índice do item selecionado",
  T_46_META_WS_P_SELECTEDSPRITE: "Sprite Selecionado",
  T_46_META_WS_P_SELECTEDTYPE: "Tipo Selecionado",
  T_46_META_WS_P_SELF: "Próprio",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Fator de Dano em Si",
  T_46_META_WS_P_SET: "Conjunto",
  T_46_META_WS_P_SHADERNAME: "Nome do Shader",
  T_46_META_WS_P_SHADOWCOLOR: "Cor da Sombra",
  T_46_META_WS_P_SHADOWOFFSET: "Deslocamento da Sombra",
  T_46_META_WS_P_SHADOWSTRENGTH: "Força da Sombra",
  T_46_META_WS_P_SHELFS: "Fechamento Manual Desativado",
  T_46_META_WS_P_SHOES: "Sapatos",
  T_46_META_WS_P_SHOOTANGLEMAX: "Ângulo Máximo de Disparo",
  T_46_META_WS_P_SHOOTANGLEMIN: "Ângulo Mínimo de Disparo",
  T_46_META_WS_P_SHOP: "Loja",
  T_46_META_WS_P_SHOPITEMS: "Lista de Prateleiras",
  T_46_META_WS_P_SHOWADDFRIEND: "Mostrar Adicionar Amigo",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Mostrar granada de ataque",
  T_46_META_WS_P_SHOWBACKGROUND: "Mostrar Fundo",
  T_46_META_WS_P_SHOWCROUCH: "Mostrar agachado",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Mostrar número de dano",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Mostrar granada de defesa",
  T_46_META_WS_P_SHOWECCONOMY: "Mostrar Economia",
  T_46_META_WS_P_SHOWECONOMY: "Mostrar Economia",
  T_46_META_WS_P_SHOWFIRE: "Mostrar tiro",
  T_46_META_WS_P_SHOWFRAME: "Mostrar quadro",
  T_46_META_WS_P_SHOWGIFT: "Mostrar Presente",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Mostrar Efeito de Ponto de Impacto",
  T_46_META_WS_P_SHOWJUMP: "Mostrar pulo",
  T_46_META_WS_P_SHOWLIKE: "Mostrar Curtidas",
  T_46_META_WS_P_SHOWLOBBY: "Mostrar Lobby",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Mostrar Avaliação do Mapa",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Mostrar Detalhes do Jogo",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Mostrar joystick",
  T_46_META_WS_P_SHOWNAME: "Mostrar Apelido",
  T_46_META_WS_P_SHOWPIN: "Mostrar Pin",
  T_46_META_WS_P_SHOWPRONE: "Mostrar deitado",
  T_46_META_WS_P_SHOWRANK: "Mostrar Classificação",
  T_46_META_WS_P_SHOWREPLAY: "Mostrar Replay",
  T_46_META_WS_P_SHOWREPORT: "Mostrar Relatório",
  T_46_META_WS_P_SHOWSHARE: "Mostrar Compartilhamento",
  T_46_META_WS_P_SHOWSPRINT: "Mostrar investida",
  T_46_META_WS_P_SHOWTAG: "Mostrar marcação",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Mostrar informações dos colegas",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Estado dos Companheiros",
  T_46_META_WS_P_SHOWTEAMSCORE: "Mostrar Pontuação da Equipe",
  T_46_META_WS_P_SHOWTIMETYPE: "Mostrar Tempo",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Pontuação das Duas Equipes",
  T_46_META_WS_P_SHRINKDURATION: "Duração de encolhimento (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Tempo de término do encolhimento (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Taxa de Convergência",
  T_46_META_WS_P_SHRINKSTARTTIME: "Tempo de início do encolhimento (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Permitir Assistência de Mira ao Mirar",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Coeficiente de Atenuação da Distância da Assistência de Mira (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Coeficiente de Impacto de Prioridade da Distância da Assistência de Mira (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Distância Máxima de Prioridade da Assistência de Mira",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Distância Mínima de Prioridade da Assistência de Mira",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Permitir Prioridade de Distância da Assistência de Mira",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Taxa de Atração da Mira Assistida na Tela (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Fator de Zoom da Mira",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Ampliação do Campo de Visão (FOV)",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Sensibilidade de Rotação ao Mirar",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Coeficiente X de Correção de Distância Mínima de Dano ao Mirar",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Tempo de Ampliação ao Mirar (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Ampliação ao Mirar",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Tempo de Recuperação ao Mirar (s)",
  T_46_META_WS_P_SIZE: "Tamanho",
  T_46_META_WS_P_SIZEDELTA: "Delta de tamanho",
  T_46_META_WS_P_SKELETON: "Esqueleto",
  T_46_META_WS_P_SKIN: "Skin",
  T_46_META_WS_P_SKINID: "ID da Skin",
  T_46_META_WS_P_SKINWIDTH: "Espessura da Pele",
  T_46_META_WS_P_SKYBOXENV: "Caixa do Céu",
  T_46_META_WS_P_SKYBOXRESOURCE: "Recurso de Céu",
  T_46_META_WS_P_SLOPELIMIT: "Limite de Inclinação",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Início de Rolagem Suave",
  T_46_META_WS_P_SOFTNESS: "Suavidade",
  T_46_META_WS_P_SORTTYPE: "Tipo de Ordenação",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Contagem de Surgimentos por Onda",
  T_46_META_WS_P_SPAWNPOINT: "Ponto de Surgimento",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Contagem de Pontos de Surgimento",
  T_46_META_WS_P_SPAWNPOSITION: "Posição de Surgimento",
  T_46_META_WS_P_SPEED: "Velocidade",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Taxa de Velocidade de Movimento ao Mirar",
  T_46_META_WS_P_SPRAYCOLOR: "Cor do Spray",
  T_46_META_WS_P_SPRINTENERGYCOST: "Custo de Energia da Investida",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Velocidade Horizontal da Investida",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Escala de velocidade de movimento da investida",
  T_46_META_WS_P_SPRITENAME: "Forma do sprite",
  T_46_META_WS_P_SPRITERESOURCE: "Recurso Sprite",
  T_46_META_WS_P_SRCVAL: "Valor Src",
  T_46_META_WS_P_STARTDROPTIME: "Tempo de início da queda (ms)",
  T_46_META_WS_P_STARTEVENT: "Iniciar evento",
  T_46_META_WS_P_STARTPOSITION: "Posição Inicial",
  T_46_META_WS_P_STARTRADIUS: "Raio inicial",
  T_46_META_WS_P_STARTSPAWNTIME: "Tempo de Início na Área de Espera (s)",
  T_46_META_WS_P_STARTTIME: "Tempo de início (s)",
  T_46_META_WS_P_STARTVALUE: "Valor Inicial",
  T_46_META_WS_P_STATICICONCOLORS: "Cores dos ícones estáticos",
  T_46_META_WS_P_STATICICONS: "Ícones estáticos",
  T_46_META_WS_P_STATUS: "Status da Mini Sentry",
  T_46_META_WS_P_STEPOFFSET: "Deslocamento do Passo",
  T_46_META_WS_P_STOPDURATION: "Duração de Parada",
  T_46_META_WS_P_STOPEVENT: "Parar evento",
  T_46_META_WS_P_STORE: "Loja",
  T_46_META_WS_P_STROPID: "ID do Strop",
  T_46_META_WS_P_STYLE: "Estilo",
  T_46_META_WS_P_SUBTITLE: "Legenda",
  T_46_META_WS_P_SUMMULTIPLIER: "Multiplicador de Soma",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Aceleração de Saída do Balanço",
  T_46_META_WS_P_SWINGINGSPEED: "Velocidade de Balanço",
  T_46_META_WS_P_TAGS: "Tags",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ID do Ponto de Checagem Alvo",
  T_46_META_WS_P_TARGETICONCOLORS: "Cores dos ícones-alvo",
  T_46_META_WS_P_TARGETICONS: "Ícones-alvo",
  T_46_META_WS_P_TARGETID: "ID do Alvo",
  T_46_META_WS_P_TARGETITEMID: "ID do Item Alvo",
  T_46_META_WS_P_TARGETROTATION: "Rotação Alvo",
  T_46_META_WS_P_TARGETSCALE: "Escala Alvo",
  T_46_META_WS_P_TEAMCOLOR: "Cor da equipe",
  T_46_META_WS_P_TEAMCOLORS: "Cores das equipes",
  T_46_META_WS_P_TEAMINDEXS: "Índices das equipes",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Fator de Dano ao Aliado",
  T_46_META_WS_P_TEAMMEMBERNUM: "Contagem de Membros da Equipe",
  T_46_META_WS_P_TEAMNUM: "Contagem de Equipe",
  T_46_META_WS_P_TEAMRANK: "Classificação da Equipe",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Exibição da Classificação da Equipe",
  T_46_META_WS_P_TEAMRANKS: "Classificação das equipes",
  T_46_META_WS_P_TEAMSCORES: "Pontuações das equipes",
  T_46_META_WS_P_TEAMSEQ: "Sequência da Equipe",
  T_46_META_WS_P_TEMPLATEENTITY: "Entidade Modelo",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Pontos de Escudo Temporários",
  T_46_META_WS_P_TERRAINWETNESS: "Umidade do Terreno",
  T_46_META_WS_P_TEXT: "Texto",
  T_46_META_WS_P_TEXTCOLOR: "Cor do texto",
  T_46_META_WS_P_TEXTKEY: "Chave de Texto",
  T_46_META_WS_P_TEXTKEYPARAMS: "Parâmetros da Chave de Texto",
  T_46_META_WS_P_TEXTURERESOURCE: "Recurso de Textura",
  T_46_META_WS_P_THEMECOLOR: "Cor do Tema",
  T_46_META_WS_P_THROWABLETYPE: "Tipo de Arremesso",
  T_46_META_WS_P_THROWINGSPEED: "Velocidade de Arremesso",
  T_46_META_WS_P_THROWSPEED: "Velocidade de Lançamento",
  T_46_META_WS_P_TICKINTERVAL: "Intervalo de tick",
  T_46_META_WS_P_TIMEREQUIRED: "Tempo Necessário (ms)",
  T_46_META_WS_P_TIPSTYPE: "Tipo de dica",
  T_46_META_WS_P_TITLE: "Título",
  T_46_META_WS_P_TITLELIST: "Títulos",
  T_46_META_WS_P_TITLES: "Pontuações 1",
  T_46_META_WS_P_TOP: "Torso",
  T_46_META_WS_P_TOPALPHA: "Alpha Superior",
  T_46_META_WS_P_TOTALHP: "HP total",
  T_46_META_WS_P_TOTALLEVEL: "Nível total",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Contagem Total de Rodadas",
  T_46_META_WS_P_TOWSPEED: "Velocidade de Reboque",
  T_46_META_WS_P_TRANSITIONSTAGE: "Estágio de transição",
  T_46_META_WS_P_TRANSITIONTYPE: "Tipo de Transição",
  T_46_META_WS_P_TRIGGERPLAYERID: "Dinheiro",
  T_46_META_WS_P_TRIGGERRADIUS: "Alcance do Gatilho",
  T_46_META_WS_P_TRIGGERRANGE: "Faixa de Gatilho",
  T_46_META_WS_P_TRIGGERTIME: "Tempo de ativação",
  T_46_META_WS_P_TURNSPEED: "Velocidade ao virar",
  T_46_META_WS_P_TWEENERENABLED: "Transição Habilitada",
  T_46_META_WS_P_TWEENSTYLE: "Estilo de Transição",
  T_46_META_WS_P_TYPE: "Tipo",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Cor Não Selecionada",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Sprite Não Selecionado",
  T_46_META_WS_P_UNSELECTEDTYPE: "Tipo Não Selecionado",
  T_46_META_WS_P_UP: "Cima",
  T_46_META_WS_P_UPDATETYPE: "Tipo de Atualização",
  T_46_META_WS_P_UPENERGYCOST: "Custo de Energia para cima",
  T_46_META_WS_P_UPSPEED: "Velocidade para cima",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Força de Empurrão Personalizada",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Usar recurso personalizado",
  T_46_META_WS_P_USEDCAPACITY: "Capacidade Utilizada",
  T_46_META_WS_P_USEGRAVITY: "Usar Gravidade",
  T_46_META_WS_P_USEPHYSICALCCT: "Usar CCT Física",
  T_46_META_WS_P_USERUID: "Interface de Usuário",
  T_46_META_WS_P_UVOFFSET: "Deslocamento UV",
  T_46_META_WS_P_UVSIZE: "Tamanho UV",
  T_46_META_WS_P_VALUE: "Valor",
  T_46_META_WS_P_VAULTDISTANCE: "Distância de salto",
  T_46_META_WS_P_VAULTHEIGHT: "Altura de salto",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Fator de Dano ao Veículo",
  T_46_META_WS_P_VEHICLESKINID: "ID da Pele do Veículo",
  T_46_META_WS_P_VEHICLESKINIDS: "ID de Skin de Veículo",
  T_46_META_WS_P_VELOCITY: "Velocidade (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Velocidade XZ",
  T_46_META_WS_P_VELOCITYY: "Velocidade Y",
  T_46_META_WS_P_VERTICALBAR: "Barra Vertical",
  T_46_META_WS_P_VERTICALOFFSET: "Deslocamento Vertical",
  T_46_META_WS_P_VEST: "Colete",
  T_46_META_WS_P_VFXTEXTURETYPE: "Tipo de Textura de Efeito Visual",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Restrição de Ângulo de Visão",
  T_46_META_WS_P_VISIBILITYLAYER: "Camada de Visibilidade",
  T_46_META_WS_P_VISIBLE: "Visível",
  T_46_META_WS_P_VISIBLEONBACK: "Visível nas Costas",
  T_46_META_WS_P_VISIBLEPLAYERS: "Jogadores visíveis",
  T_46_META_WS_P_VOLUME: "Volume",
  T_46_META_WS_P_WALLETID: "ID da Carteira",
  T_46_META_WS_P_WANDERRANGE: "Alcance de Perambulação",
  T_46_META_WS_P_WAVECOUNT: "Contagem de Ondas",
  T_46_META_WS_P_WAVEINTERVAL: "Intervalo de Onda",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Taxa de Dano de Arma",
  T_46_META_WS_P_WEAPONSKINIDS: "IDs de Skins de Arma",
  T_46_META_WS_P_WEAPONSUBTYPE: "Subtipo de Arma",
  T_46_META_WS_P_WEAPONTYPE: "Tipo de Arma",
  T_46_META_WS_P_WIDTH: "Largura",
  T_46_META_WS_P_WINMVPS: "MVP da Vitória",
  T_46_META_WS_P_WINTEXT: "Texto de vitória",
  T_46_META_WS_P_WORDWRAP: "Quebra de Linha",
  T_46_META_WS_P_WORLDPOSITION: "Posição no Mundo",
  T_46_META_WS_P_YAW: "Yaw",
  T_46_META_WS_PATROLALONG: "Patrulhar Ao Longo",
  T_46_META_WS_PATROLTO: "Patrulhar Até",
  T_46_META_WS_PAUSE: "Pausar",
  T_46_META_WS_PAUSEEMOTE: "Pausar Emote",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Pausar Atualização Fixa",
  T_46_META_WS_PHASE: "Fase",
  T_46_META_WS_PLAY: "Reproduzir",
  T_46_META_WS_PLAYANIMATION: "Reproduzir Animação",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Reproduzir Clipe de Animação do Personagem",
  T_46_META_WS_PLAYEMOTE: "Reproduzir Emote",
  T_46_META_WS_PLAYER: "Jogador",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Pose",
  T_46_META_WS_POSITION: "Posição",
  T_46_META_WS_PREPOSE: "Pré-pose ",
  T_46_META_WS_PROFANITYFILTER: "Filtro de Profanidades",
  T_46_META_WS_PURSUITTARGET: "Alvo de Perseguição",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion para Ângulo de Eixo",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion para Ângulo de Euler",
  T_46_META_WS_QUITCHATCHANNEL: "Sair do Canal de Bate-papo",
  T_46_META_WS_QUITFACTION: "Sair do Grupo",
  T_46_META_WS_QUITGAME: "Sair do Jogo",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Sair do Mini Jogo de Fuga da Prisão",
  T_46_META_WS_RANDOMFLOAT: "Flutuante Aleatório",
  T_46_META_WS_RANDOMINT: "Inteiro Aleatório",
  T_46_META_WS_RANK: "Classificação",
  T_46_META_WS_READCSV: "Ler CSV",
  T_46_META_WS_READCSVCELL: "Ler Célula CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Ler Célula CSV por Nome",
  T_46_META_WS_READCSVCELLFROMSERVER: "Ler Célula CSV do Servidor",
  T_46_META_WS_READCSVCOLUMN: "Ler Coluna CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Ler Coluna CSV do Servidor",
  T_46_META_WS_READCSVFROMSERVER: "Ler CSV do Servidor",
  T_46_META_WS_READCSVROW: "Ler Linha CSV",
  T_46_META_WS_READCSVROWBYKEY: "Ler Linha CSV por Chave",
  T_46_META_WS_READCSVROWFROMSERVER: "Ler Linha CSV do Servidor",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Ler do armazenamento de dados acumulado",
  T_46_META_WS_READFROMDATASTORE: "Ler do armazenamento de dados",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Ler do armazenamento de dados do ranking",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Ler do armazenamento de dados do ranking por classificação",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Remover Acompanhamento Especial AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Remover Pele da Mochila",
  T_46_META_WS_REMOVEBUFF: "Remover Buff",
  T_46_META_WS_REMOVECOMPONENT: "Remover Componente",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Remover Fator de Propriedade de Fórmula",
  T_46_META_WS_REMOVEOUTFIT: "Remover Roupa",
  T_46_META_WS_REMOVESCRIPT: "Remover Script",
  T_46_META_WS_REMOVEVEHICLESKIN: "Remover Pele do Veículo",
  T_46_META_WS_REMOVEWEAPONSKIN: "Remover Skin de Arma",
  T_46_META_WS_REPLACE: "Substituir",
  T_46_META_WS_REQUESTMATCHMAKING: "Solicitar Matchmaking",
  T_46_META_WS_RESET: "Redefinir",
  T_46_META_WS_RESETBACKPACKSKIN: "Redefinir Skin da Mochila",
  T_46_META_WS_RESETDYEING: "Redefinir Cor",
  T_46_META_WS_RESETJERSEY: "Redefinir Camisa",
  T_46_META_WS_RESETOUTFIT: "Redefinir Traje",
  T_46_META_WS_RESETVEHICLESKIN: "Redefinir Skin de Veículo",
  T_46_META_WS_RESETWEAPONSKIN: "Redefinir Skin de Arma",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Retomar Atualização Fixa",
  T_46_META_WS_REVERSE: "Inverter",
  T_46_META_WS_REVIVALSOURCE: "Fonte de ressureição",
  T_46_META_WS_REVIVE: "Reviver",
  T_46_META_WS_ROUND: "Arredondar",
  T_46_META_WS_ROUNDINDEX: "Index de rodada",
  T_46_META_WS_SAMPLEONCURVE: "Amostrar na Curva",
  T_46_META_WS_SCENENAME: "Nome da cena",
  T_46_META_WS_SCORE: "Pontuação",
  T_46_META_WS_SCORER: "Artilheiro",
  T_46_META_WS_SCORETYPE: "Tipo de pontuação",
  T_46_META_WS_SCREENMULTIRAYCAST: "Detecção de Raios Múltiplos na Tela",
  T_46_META_WS_SCREENSINGLERAYCAST: "Detecção de Raio Único na Tela",
  T_46_META_WS_SCREENTOUCHRAY: "Raio de Toque na Tela",
  T_46_META_WS_SCREENTOWORLDPOINT: "Tela para Mundo",
  T_46_META_WS_SENDEVENT: "Enviar Evento",
  T_46_META_WS_SETACTIVE: "Definir Ativo",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Definir Status de Movimento para Todos os Jogadores",
  T_46_META_WS_SETATTACKABLEENTITY: "Definir Entidade Atacável",
  T_46_META_WS_SETATTACKABLEFACTION: "Definir Grupo Atacável",
  T_46_META_WS_SETATTACKABLETEAM: "Definir Equipe Atacável",
  T_46_META_WS_SETBACKPACKSKIN: "Definir Pele da Mochila",
  T_46_META_WS_SETBEHAVIORSTATUS: "Definir Status de Comportamento",
  T_46_META_WS_SETBLACKBOARDVALUE: "Definir Valor do Quadro Negro",
  T_46_META_WS_SETBUNDLE: "Definir Pacote",
  T_46_META_WS_SETCAMERAFOCUS: "Definir Foco da Câmera",
  T_46_META_WS_SETCAMERAFOLLOW: "Definir Acompanhamento da Câmera",
  T_46_META_WS_SETCHARACTER: "Definir Personagem",
  T_46_META_WS_SETCULLINGMASK: "Definir Máscara de Culling",
  T_46_META_WS_SETCULLINGMASKLAYER: "Definir Máscara de Culling por Camada",
  T_46_META_WS_SETDEFAULTUISTATUS: "Definir Estado da UI Padrão",
  T_46_META_WS_SETDROPSTATUS: "Definir Status de Descarte",
  T_46_META_WS_SETFALLINGDAMAGE: "Definir Dano por Queda",
  T_46_META_WS_SETFOOTBALLPOSITION: "Definir Posição da Bola",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Definir Propriedade de Fórmula Absoluta",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Definir Propriedade de Fórmula Relativa",
  T_46_META_WS_SETFORWARD: "Definir Direção",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Definir Limite de Sono Global",
  T_46_META_WS_SETINVINCIBILITY: "Definir Status de Invulnerabilidade",
  T_46_META_WS_SETJERSEY: "Definir Camisa",
  T_46_META_WS_SETOUTFIT: "Definir Roupa",
  T_46_META_WS_SETPARENT: "Definir Pai",
  T_46_META_WS_SETPARENTCLIENT: "Definir Pai",
  T_46_META_WS_SETPICKUPSTATUS: "Definir Status de Pegagem",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Definir Status de Mensagem Rápida do Jogador",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Definir Status de Voz do Jogador",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Definir Propriedade Suavemente",
  T_46_META_WS_SETSKILLS: "Definir Habilidades",
  T_46_META_WS_SETSKYBOX: "Definir Skybox",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Definir Limite de Sono",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Definir Status de Item Especial",
  T_46_META_WS_SETVEHICLESKIN: "Definir Pele do Veículo",
  T_46_META_WS_SETWEAPONSKIN: "Definir Skin de Arma",
  T_46_META_WS_SETWIDGETPARENT: "Definir Pai do Widget",
  T_46_META_WS_SHOPITEM: "Item da loja",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Mostrar Grupo de Aparência",
  T_46_META_WS_SHUFFLE: "Embaralhar",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Detecção de Raio Único",
  T_46_META_WS_SKILL: "Habilidade",
  T_46_META_WS_SLEEP: "Dormir",
  T_46_META_WS_SLERPQUATERNION: "Interpolação de Quaternion",
  T_46_META_WS_SPAWNABLES: "Itens geráveis",
  T_46_META_WS_SPAWNEDITEM: "Item gerado",
  T_46_META_WS_SPAWNNEXTWAVE: "Gerar Próxima Onda",
  T_46_META_WS_SPHERECAST: "Detecção de Esfera",
  T_46_META_WS_SPHEREOVERLAP: "Sobreposição de Esfera",
  T_46_META_WS_SPLIT: "Dividir",
  T_46_META_WS_SQRT: "Raiz Quadrada",
  T_46_META_WS_STARTPARACHUTE: "Começar a Pular de Paraquedas",
  T_46_META_WS_STARTPOSITION: "Posição inicial",
  T_46_META_WS_STATENAME: "Nome do estado",
  T_46_META_WS_STATUS: "Status",
  T_46_META_WS_STRINGTOFLOAT: "String para Float",
  T_46_META_WS_STRINGTOINT: "String para Inteiro",
  T_46_META_WS_STRIP: "Remover Espaços",
  T_46_META_WS_SUB: "Subtrair",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Alternar observador intermediário AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Trocar Grupo de Aparência",
  T_46_META_WS_SWITCHAREA: "Trocar Área",
  T_46_META_WS_SWITCHCAMERA: "Trocar Câmera",
  T_46_META_WS_SWITCHPHASE: "Trocar Fase",
  T_46_META_WS_SWITCHSCENE: "Trocar Cena",
  T_46_META_WS_SWITCHWEAPON: "Trocar Arma",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Alvo",
  T_46_META_WS_TEAM: "Equipe",
  T_46_META_WS_TELEPORT: "Teleportar",
  T_46_META_WS_TELEPORTCCT: "Teleportar CCT",
  T_46_META_WS_TEXT: "Texto",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Timestamp para String de Localização",
  T_46_META_WS_TIRE: "Pneu",
  T_46_META_WS_TOLOWER: "Para Minúsculas",
  T_46_META_WS_TOSTRING: "Para String",
  T_46_META_WS_TOUPPER: "Para Maiúsculas",
  T_46_META_WS_TRANSFERMONEY: "Transferir Dinheiro",
  T_46_META_WS_TRIGGER: "Gatilho",
  T_46_META_WS_TYPEIS: "Tipo É",
  T_46_META_WS_UNLOADSCENE: "Descarregar Cena",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Atualizar Missão de Fuga da Prisão",
  T_46_META_WS_UPLOADGAMERESULT: "Enviar Resultado do Jogo",
  T_46_META_WS_VALUE: "Dano",
  T_46_META_WS_VECTOR2ANGLE: "Ângulo Vetorial 2D",
  T_46_META_WS_VECTOR2DISTANCE: "Distância Vetorial 2D",
  T_46_META_WS_VECTOR2DOT: "Produto Escalar Vetorial 2D",
  T_46_META_WS_VECTOR2MAGNITUDE: "Magnitude Vetorial 2D",
  T_46_META_WS_VECTOR2NORMALIZE: "Normalizar Vetorial 2D",
  T_46_META_WS_VECTOR2REFLECT: "Reflexão Vetorial 2D",
  T_46_META_WS_VECTOR2TOVECTOR3: "Converter Vetor 2D para Vetor 3D",
  T_46_META_WS_VECTOR3REFLECT: "Reflexão Vetorial 3D",
  T_46_META_WS_VECTOR3TOVECTOR2: "Converter Vetor 3D para Vetor 2D",
  T_46_META_WS_VEHICLE: "Veículo",
  T_46_META_WS_VELOCITY: "Velocidade",
  T_46_META_WS_WAITFORMILESECOND: "Aguardar Milissegundos",
  T_46_META_WS_WAITFORNEXTFRAME: "Aguardar o Próximo Quadro",
  T_46_META_WS_WAKEUP: "Acordar",
  T_46_META_WS_WAVES: "Ondas",
  T_46_META_WS_WEAPON: "Arma",
  T_46_META_WS_WORLDTOSCREENPOINT: "Mundo para Tela",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Escrever no armazenamento de dados acumulado",
  T_46_META_WS_WRITETODATASTORE: "Escrever no armazenamento de dados",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Escrever no armazenamento de dados do ranking",
  T_48_META_API_1_D: "Obtém todos os jogadores no jogo atual e devolve uma lista de jogadores.",
  T_48_META_API_1_R_D: "Lista de jogadores",
  T_48_META_API_10_D: "Obter objectos de cena",
  T_48_META_API_10_P0_D: "Que tipos de objectos de cena filtrar",
  T_48_META_API_10_R_D: "Lista de objectos de cena",
  T_48_META_API_100_D: "Carregar cenários sem descarregar automaticamente os cenários já carregados",
  T_48_META_API_100_P0_D: "ID da cena a ser carregada",
  T_48_META_API_10000_D: "Devolve a entidade à qual o script atual está ligado",
  T_48_META_API_10000_R_D: "A entidade à qual o script atual está ligado",
  T_48_META_API_10001_D: "Utilize o ID da entidade para encontrar a entidade correspondente. Esta API destina-se apenas aos editores; a utilização desta API pelo utilizador não garante a sua compatibilidade, tal como a remoção ou o ajuste do",
  T_48_META_API_10001_P0_D: "ID da entidade-alvo",
  T_48_META_API_10001_R_D: "coisa que tem uma existência material (por oposição a uma existência concetual, virtual ou em linha)",
  T_48_META_API_10002_D: "Obter a entidade global para o jogo",
  T_48_META_API_10002_R_D: "entidade global",
  T_48_META_API_10003_D: "Teleporta os jogadores para coordenadas específicas (obsoleto, use Teleport)",
  T_48_META_API_10003_P0_D: "Jogadores teletransportados",
  T_48_META_API_10003_P1_D: "Coordenadas do ponto transportado",
  T_48_META_API_10004_D: "Obtém a posição perto dos colegas de equipa, o que permite contornar a posição dos jogadores que não podem estar de pé (obsoleto, utilize GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "jogador-alvo",
  T_48_META_API_10004_R_D: "Coordenadas próximas dos colegas de equipa",
  T_48_META_API_10005_D: "obter o jogador ao qual a entidade pertence",
  T_48_META_API_10005_P0_D: "Entidade de destino, a entidade só se sincronizará com o jogador a que pertence",
  T_48_META_API_10005_R_D: "O jogador a que pertence a entidade-alvo",
  T_48_META_API_10006_D: "Tornar o jogador invencível",
  T_48_META_API_10006_P0_D: "jogador-alvo",
  T_48_META_API_10006_P1_D: "Duração do efeito de invulnerabilidade, em segundos",
  T_48_META_API_10007_D: "Clonar a entidade selecionada e todas as suas propriedades na posição original",
  T_48_META_API_10007_P0_D: "Entidades criadas",
  T_48_META_API_10007_P1_D: "entidade a ser clonada",
  T_48_META_API_10008_D: "Causa danos ao jogador; se não for selecionada nenhuma fonte de danos, o alvo recebe danos do sistema",
  T_48_META_API_10008_P0_D: "Entidades de jogo lesadas",
  T_48_META_API_10008_P1_D: "Entidades de jogo que causam danos",
  T_48_META_API_10008_P2_D: "Tipo de dano",
  T_48_META_API_10008_P3_D: "quantidade de danos",
  T_48_META_API_10009_D: "Ressuscitar um jogador designado",
  T_48_META_API_10009_P0_D: "Jogadores ressuscitados",
  T_48_META_API_1001_D: "Se a condição for satisfeita, o nó em IF é executado. Se a condição não for satisfeita, executa-se o nó sob ELSE se existir um ELSE, caso contrário termina-se a instrução IF.",
  T_48_META_API_1001_P0_D: "A lista de condições deve ser coerente com o número de listas de sub-procedimentos (listas de ramificações lógicas).",
  T_48_META_API_10010_D: "Cria um item ou uma lista de itens em um local especificado.",
  T_48_META_API_10010_P0_D: "Local de criação do item",
  T_48_META_API_10010_P1_D: "Itens criados ou listas de itens",
  T_48_META_API_10010_P2_D: "O número de itens a serem criados. Ao criar uma lista de itens, é necessário preencher uma lista com o número de itens correspondente à ordem da lista de itens.",
  T_48_META_API_10011_D: "Entidades de IA a patrulhar pontos-alvo",
  T_48_META_API_10011_P0_D: "Entidades de IA direcionadas",
  T_48_META_API_10011_P1_D: "Ponto de mira móvel",
  T_48_META_API_10011_P2_D: "Se deve regressar ao ponto de partida",
  T_48_META_API_10011_P3_D: "Se os alvos hostis são detectados e atacados durante as patrulhas",
  T_48_META_API_10012_D: "Patrulha de entidades IA por ordem da lista de coordenadas",
  T_48_META_API_10012_P0_D: "Entidades de IA direcionadas",
  T_48_META_API_10012_P1_D: "Lista de pontos de coordenadas móveis",
  T_48_META_API_10012_P2_D: "Tipo de patrulha, com opção de circuito simples, de ida e volta ou de ciclo",
  T_48_META_API_10012_P3_D: "Se os alvos hostis são detectados e atacados durante as patrulhas",
  T_48_META_API_10013_D: "O gerador actualiza imediatamente a próxima vaga de entidades de unidade",
  T_48_META_API_10013_P0_D: "entidade geradora",
  T_48_META_API_10014_D: "Adicionar um fator para calcular atributos computáveis, que serão calculados por uma fórmula composta por factores para produzir o resultado final.",
  T_48_META_API_10014_P0_D: "entidade-alvo",
  T_48_META_API_10014_P1_D: "Tipos de atributos calculáveis",
  T_48_META_API_10014_P2_D: "Tipo de fator de cálculo",
  T_48_META_API_10014_P3_D: "Cálculo dos valores dos factores",
  T_48_META_API_10015_D: "Limpar o fator de cálculo para atributos computáveis",
  T_48_META_API_10015_P0_D: "entidade-alvo",
  T_48_META_API_10015_P1_D: "Tipos de atributos calculáveis",
  T_48_META_API_10016_D: "Limpar todos os factores computacionais para todos os atributos computáveis da entidade-alvo",
  T_48_META_API_10016_P0_D: "entidade-alvo",
  T_48_META_API_10017_D: "Modificar atributos",
  T_48_META_API_10017_P0_D: "entidade-alvo",
  T_48_META_API_10017_P1_D: "Tipo de atributo",
  T_48_META_API_10017_P2_D: "Método de modificação",
  T_48_META_API_10017_P3_D: "estar em serviço",
  T_48_META_API_10018_D: "Definir o valor de uma propriedade computável",
  T_48_META_API_10018_P0_D: "entidade-alvo",
  T_48_META_API_10018_P1_D: "Tipo de atributo",
  T_48_META_API_10018_P2_D: "estar em serviço",
  T_48_META_API_10019_D: "Compensação de modificações individuais de atributos computáveis",
  T_48_META_API_10019_P0_D: "entidade-alvo",
  T_48_META_API_10019_P1_D: "Tipo de atributo",
  T_48_META_API_1002_D: "O parâmetro i começa com o valor mínimo e, sempre que o nó abaixo é executado, i aumenta o valor do passo até que i seja maior ou igual ao valor máximo.",
  T_48_META_API_1002_P0_D: "O nome do índice cíclico, que pode ser utilizado para obter o valor do índice cíclico numa variável local.",
  T_48_META_API_1002_P1_D: "Valor inicial cíclico",
  T_48_META_API_1002_P2_D: "valor de fim de ciclo",
  T_48_META_API_1002_P3_D: "Tamanho do passo do ciclo, quando o valor inicial é inferior ao valor final, o tamanho do passo deve ser superior a 0; quando o valor inicial é superior ao valor final, o tamanho do passo deve ser inferior a 0",
  T_48_META_API_10020_D: "Obtém todas as entidades do jogo que satisfazem os critérios de filtragem",
  T_48_META_API_10020_P0_D: "O resultado do filtro deve conter o tipo introduzido neste parâmetro",
  T_48_META_API_10020_P1_D: "O resultado do filtro não deve conter o tipo introduzido neste parâmetro",
  T_48_META_API_10020_P2_D: "Os resultados do filtro contêm pelo menos um dos tipos introduzidos neste parâmetro",
  T_48_META_API_10020_R_D: "Filtrar a lista de entidades resultantes",
  T_48_META_API_10021_D: "Se adicionarmos uma velocidade à bola de futebol, a velocidade será alterada pela aceleração na mesma direção",
  T_48_META_API_10021_P0_D: "Futebol de golos",
  T_48_META_API_10021_P1_D: "Velocidade do espaço 3D adicionada",
  T_48_META_API_10022_D: "Destruição de entidades designadas",
  T_48_META_API_10022_P0_D: "Entidades-alvo a destruir",
  T_48_META_API_10023_D: "Adicionar etiquetas a entidades",
  T_48_META_API_10023_P0_D: "entidade-alvo",
  T_48_META_API_10023_P1_D: "Etiquetas personalizadas",
  T_48_META_API_10024_D: "Remoção de etiquetas para entidades",
  T_48_META_API_10024_P0_D: "entidade-alvo",
  T_48_META_API_10024_P1_D: "Etiquetas personalizadas",
  T_48_META_API_10025_D: "Determinar se a entidade de destino contém a etiqueta especificada",
  T_48_META_API_10025_P0_D: "entidade-alvo",
  T_48_META_API_10025_P1_D: "Etiquetas personalizadas",
  T_48_META_API_10025_R_D: "Se deve ou não incluir a etiqueta especificada",
  T_48_META_API_10026_D: "Definir a posição da bola de futebol",
  T_48_META_API_10026_P0_D: "entidade futebolística",
  T_48_META_API_10026_P1_D: "colocação",
  T_48_META_API_10026_P2_D: "Manter a velocidade",
  T_48_META_API_10027_D: "Obter a entidade da câmara atualmente utilizada pelo jogador alvo",
  T_48_META_API_10027_P0_D: "jogador-alvo",
  T_48_META_API_10027_R_D: "A entidade da câmara atualmente utilizada",
  T_48_META_API_10028_D: "Ao mudar a câmara do jogador alvo para a câmara alvo, o",
  T_48_META_API_10028_P0_D: "jogador-alvo",
  T_48_META_API_10028_P1_D: "câmara alvo",
  T_48_META_API_10028_P2_D: "Método de comutação, pode optar por manter a lógica original ou progressiva",
  T_48_META_API_10028_P3_D: "O tempo de comutação é o tempo necessário para mudar de câmara no modo progressivo",
  T_48_META_API_10029_D: "Criar uma câmara",
  T_48_META_API_10029_P0_D: "Tipo de câmara criada",
  T_48_META_API_10029_P1_D: "Entidade da câmara criada",
  T_48_META_API_1003_D: "Implementar uma travessia de um contentor de dados para chegar a cada sub-elemento, contendo sub-procedimentos, o corpo do ciclo é o sub-procedimento",
  T_48_META_API_1003_P0_D: "Iterar sobre o nome do elemento filho, que pode ser utilizado para obter o valor do elemento filho na variável local",
  T_48_META_API_1003_P1_D: "O nome do índice cíclico, que pode ser utilizado para obter o valor do índice cíclico numa variável local.",
  T_48_META_API_1003_P2_D: "O contentor de dados a percorrer, sendo atualmente suportados os seguintes tipos: tipo de matriz",
  T_48_META_API_10030_D: "Matar entidades combatíveis",
  T_48_META_API_10030_P0_D: "Entidade-alvo, que deve estar pronta para o combate",
  T_48_META_API_10031_D: "Define o estado ativo da entidade alvo e dos seus nós filhos; a disponibilidade, visibilidade, colisões, etc. são desactivadas para objectos inactivos",
  T_48_META_API_10031_P0_D: "entidade-alvo",
  T_48_META_API_10031_P1_D: "Ativo ou inativo",
  T_48_META_API_10032_D: "Definir a posição da entidade câmara para seguir sempre a entidade alvo",
  T_48_META_API_10032_P0_D: "entidade da câmara alvo",
  T_48_META_API_10032_P1_D: "Entidade-alvo a seguir",
  T_48_META_API_10032_P2_D: "Desvio das coordenadas da entidade de destino",
  T_48_META_API_10032_P3_D: "Sistema de coordenadas para desvios",
  T_48_META_API_10033_D: "Definir a entidade câmara para estar sempre virada para a entidade alvo",
  T_48_META_API_10033_P0_D: "entidade da câmara alvo",
  T_48_META_API_10033_P1_D: "entidade-alvo",
  T_48_META_API_10033_P2_D: "Deslocação do ponto de observação em relação às coordenadas do alvo",
  T_48_META_API_10033_P3_D: "Sistema de coordenadas para desvios",
  T_48_META_API_10034_D: "Criar Tween",
  T_48_META_API_10034_P0_D: "entidade-alvo",
  T_48_META_API_10034_P1_D: "ID do imóvel",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Estilo",
  T_48_META_API_10034_P5_D: "Curva",
  T_48_META_API_10034_P6_D: "Duração",
  T_48_META_API_10034_P7_D: "entre entidades",
  T_48_META_API_10035_D: "A definição do nó pai requer que tanto o pai como o filho tenham o componente Transformar",
  T_48_META_API_10035_P0_D: "nó pai",
  T_48_META_API_10035_P1_D: "nó filho",
  T_48_META_API_10035_P2_D: "Se deve manter a posição atual do mundo, a rotação e a escala dos nós filhos, este item é inválido quando se define a IU.",
  T_48_META_API_10036_D: "NewCurve (obsoleto, utilize CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Pontos de controlo",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Tenta reproduzir a entidade de destino, que deve ter um componente jogável",
  T_48_META_API_10037_P0_D: "Entidade Jogável Alvo",
  T_48_META_API_10037_P1_D: `Reprodução ou não 
verdadeiro: reproduzir 
falso: continuar a reproduzir`,
  T_48_META_API_10038_D: "Pausa nas entidades jogáveis",
  T_48_META_API_10038_P0_D: "Entidade Jogável Alvo",
  T_48_META_API_10039_D: "Cria um movimento balístico que dá à entidade-alvo uma velocidade inicial e uma aceleração com direção",
  T_48_META_API_10039_P0_D: "entidade-alvo",
  T_48_META_API_10039_P1_D: "velocidade inicial",
  T_48_META_API_10039_P2_D: "aceleração do movimento",
  T_48_META_API_10039_P3_D: "Distância máxima de deslocação",
  T_48_META_API_10039_P4_D: "Entidades de movimento balístico criadas",
  T_48_META_API_10039_P5_D: "Se a reprodução começa automaticamente após a criação",
  T_48_META_API_1004_D: "Interrompe o processo do ciclo atual e sai do ciclo",
  T_48_META_API_10040_D: "Cria um movimento de seguimento de posição em que a entidade alvo segue o objeto especificado.",
  T_48_META_API_10040_P0_D: "entidade-alvo",
  T_48_META_API_10040_P1_D: "Entidades-objeto que seguem o movimento",
  T_48_META_API_10040_P2_D: "A distância segue o deslocamento das coordenadas do alvo",
  T_48_META_API_10040_P3_D: "Sistema de coordenadas utilizado",
  T_48_META_API_10040_P4_D: "Criado Entidade de acompanhamento",
  T_48_META_API_10040_P5_D: "Se a reprodução começa automaticamente após a criação",
  T_48_META_API_10041_D: "Cria um movimento de seguimento do olhar em que a entidade alvo permanece orientada para o objeto especificado.",
  T_48_META_API_10041_P0_D: "entidade-alvo",
  T_48_META_API_10041_P1_D: "entidade considerada",
  T_48_META_API_10041_P2_D: "Desvio do ponto de observação em relação à entidade do objeto",
  T_48_META_API_10041_P3_D: "Sistema de coordenadas utilizado",
  T_48_META_API_10041_P4_D: "Criação de entidades de movimento que seguem o olhar",
  T_48_META_API_10041_P5_D: "Se a reprodução começa automaticamente após a criação",
  T_48_META_API_10042_D: "abandonado",
  T_48_META_API_10042_P0_D: "entidade jogadora",
  T_48_META_API_10042_P1_D: "resultados de um concurso",
  T_48_META_API_10042_P2_D: "abandonado",
  T_48_META_API_10042_P3_D: "abandonado",
  T_48_META_API_10042_P4_D: "abandonado",
  T_48_META_API_10043_D: "A suavização define as propriedades da entidade de destino, as propriedades mudam imediatamente, mas o cliente apresenta um desempenho de transição suave",
  T_48_META_API_10043_P0_D: "entidade-alvo",
  T_48_META_API_10043_P1_D: "Um atributo da entidade de destino",
  T_48_META_API_10043_P2_D: "O valor de destino, que tem de corresponder ao tipo exigido quando a propriedade foi definida",
  T_48_META_API_10044_D: "Execute uma detecção de raio e retorne a primeira entidade atingida na direção do raio. A entidade atingida precisa de um componente de colisão. Se o parâmetro de nível for preenchido no espaço em branco, o terreno poderá ser detectado.",
  T_48_META_API_10044_P0_D: "Coordenadas da posição inicial",
  T_48_META_API_10044_P1_D: "Direção de deteção da radiação",
  T_48_META_API_10044_P2_D: "Distância de deteção de radiação, só são aceites valores positivos",
  T_48_META_API_10044_P3_D: "Máscara de camada de deteção de raios, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_10044_P4_D: "É possível procurar accionadores",
  T_48_META_API_10044_P5_D: "entidade atingida",
  T_48_META_API_10044_P6_D: "coordenadas do ponto de impacto",
  T_48_META_API_10044_P7_D: "Distância do ponto de acerto ao ponto de partida",
  T_48_META_API_10044_P8_D: "atingir a normal de superfície",
  T_48_META_API_10045_D: "Execute uma detecção de raio e retorne todas as entidades atingidas na direção do raio, de perto para longe. Se o parâmetro de nível for preenchido no espaço em branco, o terreno poderá ser detectado.",
  T_48_META_API_10045_P0_D: "Coordenadas da posição inicial",
  T_48_META_API_10045_P1_D: "Direção de deteção da radiação",
  T_48_META_API_10045_P2_D: "Distância de deteção de radiação, só são aceites valores positivos",
  T_48_META_API_10045_P3_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_10045_P4_D: "Se o acionamento pode ser detectado",
  T_48_META_API_10045_P5_D: "Lista de entidades atingidas",
  T_48_META_API_10045_P6_D: "Lista de Pontos de Vida",
  T_48_META_API_10045_P7_D: "Lista das distâncias dos pontos de acerto aos pontos de partida",
  T_48_META_API_10045_P8_D: "atingir a normal de superfície",
  T_48_META_API_10046_D: "Criar sólidos para modelos utilizando corpos pré-fabricados",
  T_48_META_API_10046_P0_D: "Entidades criadas",
  T_48_META_API_10046_P1_D: "ID do corpo pré-fabricado",
  T_48_META_API_10047_D: "descolorir",
  T_48_META_API_10047_P0_D: "Definir normais de objectos",
  T_48_META_API_10047_P1_D: "Definir o ponto de coloração",
  T_48_META_API_10047_P2_D: "cor",
  T_48_META_API_10048_D: "Estado da cor",
  T_48_META_API_10048_P0_D: "Definir o ponto de coloração",
  T_48_META_API_10048_P1_D: "Definir a direção",
  T_48_META_API_10048_P2_D: "Definição da distância",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Estatísticas para colorir",
  T_48_META_API_10049_P0_D: "cor",
  T_48_META_API_10049_R_D: "Número de cores",
  T_48_META_API_1005_D: "Saltar o resto do corpo do laço e passar diretamente para o laço seguinte.",
  T_48_META_API_10050_D: "Coloração da gama plana",
  T_48_META_API_10050_P0_D: "Definir normais de objectos",
  T_48_META_API_10050_P1_D: "Definir o ponto de coloração",
  T_48_META_API_10050_P2_D: "Definir o intervalo de coloração",
  T_48_META_API_10050_P3_D: "cor",
  T_48_META_API_10050_P4_D: "Número de cores",
  T_48_META_API_10051_D: "mancha regional",
  T_48_META_API_10051_P0_D: "Definir normais de objectos",
  T_48_META_API_10051_P1_D: "Definir o ponto de coloração",
  T_48_META_API_10051_P2_D: "Definir o intervalo de coloração",
  T_48_META_API_10051_P3_D: "cor",
  T_48_META_API_10051_P4_D: "Área de coloração fixa",
  T_48_META_API_10051_P5_D: "coeficiente aleatório (matemática)",
  T_48_META_API_10051_P6_D: "coeficiente de atenuação aleatória",
  T_48_META_API_10051_P7_D: "Número de cores",
  T_48_META_API_10052_D: "Obter todos os filhos da entidade-mãe de destino",
  T_48_META_API_10052_P0_D: "entidade-mãe",
  T_48_META_API_10052_R_D: "lista de nós filhos",
  T_48_META_API_10053_D: "Obtém o nó filho especificado da entidade pai de destino com base no índice",
  T_48_META_API_10053_P0_D: "entidade-mãe",
  T_48_META_API_10053_P1_D: "Índice de subnó",
  T_48_META_API_10053_R_D: "entidade filha",
  T_48_META_API_10054_D: "Obter o pai da entidade filha de destino",
  T_48_META_API_10054_P0_D: "entidade filha",
  T_48_META_API_10054_R_D: "entidade-mãe",
  T_48_META_API_10055_D: "Elimina todos os nós filhos da entidade de nó pai especificada; os nós devem ter o componente Transform",
  T_48_META_API_10055_P0_D: "entidade-mãe",
  T_48_META_API_10056_D: "Teletransporta o alvo para o local especificado",
  T_48_META_API_10056_P0_D: "unidade de transporte (por exemplo, militar)",
  T_48_META_API_10056_P1_D: "coordenadas do ponto de transmissão",
  T_48_META_API_10056_P2_D: "orientação da unidade pós-transferência",
  T_48_META_API_10057_D: "Obter a localização próxima de um colega de equipa aleatório e regressar às suas próprias coordenadas próximas quando não tiver um colega de equipa, o que evitará a localização de jogadores que não se conseguem levantar",
  T_48_META_API_10057_P0_D: "jogador-alvo",
  T_48_META_API_10057_R_D: "Coordenadas próximas dos colegas de equipa do jogador alvo",
  T_48_META_API_10058_D: "Estado da coloração clara",
  T_48_META_API_10059_D: "Reproduz o efeito sonoro especificado e, se houver mais atributos a definir, define os seus atributos de entidade através da função de entidade",
  T_48_META_API_10059_P0_D: "No código é o nome do parâmetro formal utilizado para representar a entidade que cria o efeito sonoro, e o valor da variável local correspondente é a entidade que cria o efeito sonoro",
  T_48_META_API_10059_P1_D: "A entidade do jogador a que pertence, visível apenas para esse jogador",
  T_48_META_API_10059_P2_D: "Tipos de som, os tipos de efeitos sonoros que o jogador pode escolher",
  T_48_META_API_1006_D: "Terminar o processo de execução atual, regressar diretamente ao local de chamada, é possível transportar os dados juntamente com o regresso",
  T_48_META_API_1006_P0_D: "Dados para regressar ao local de chamada",
  T_48_META_API_10060_D: "Expulsar o jogador alvo do jogo",
  T_48_META_API_10060_P0_D: "jogador-alvo",
  T_48_META_API_10060_P1_D: "Se deve ser exibida informação sobre a liquidação",
  T_48_META_API_10061_D: "O jogador alvo pede uma partida para um mapa específico",
  T_48_META_API_10061_P0_D: "jogador-alvo",
  T_48_META_API_10061_P1_D: "código do campo de batalha",
  T_48_META_API_10061_P2_D: "Se uma janela pop-up pede ou não para voltar ao jogo original ao cancelar uma partida.",
  T_48_META_API_10062_D: "Interromper a entidade sonora durante a reprodução",
  T_48_META_API_10062_P0_D: "Entidades sonoras que precisam de ser suspensas",
  T_48_META_API_10063_D: "Reprodução contínua de efeitos sonoros, opcionalmente desde o início",
  T_48_META_API_10063_P0_D: "Entidades sonoras que precisam de continuar a tocar depois de serem colocadas em pausa",
  T_48_META_API_10063_P1_D: "Se deve começar do zero",
  T_48_META_API_10064_D: "Criar uma gota, a gota tem três fases: 1. pronta, 2. a cair, 3. aterrada, apenas no estado 1 pode modificar as propriedades da gota",
  T_48_META_API_10064_P0_D: "Entidades da caixa de depósito criadas",
  T_48_META_API_1007_D: "Implemente um ciclo que continua a ser executado com base no facto de a condição ser verdadeira ou não, até que a condição seja falsa e o ciclo termine.",
  T_48_META_API_1007_P0_D: "Quando a condição é verdadeira, o ciclo continua, e quando a condição é falsa, o ciclo termina.",
  T_48_META_API_1008_D: `Aguardar até ao início da próxima moldura lógica
No servidor, ativar o modo de baixa velocidade de fotogramas, aguardará mais tempo
No cliente, o tempo de espera é afetado pelo desempenho do dispositivo e pela complexidade da lógica da moldura atual
As`,
  T_48_META_API_1009_D: "Após um determinado período de tempo, as funções que utilizam esta API têm de ser declaradas assíncronas.",
  T_48_META_API_1009_P0_D: "Tempo de espera em milissegundos",
  T_48_META_API_101_D: "Desinstalação de uma cena especificada",
  T_48_META_API_101_P0_D: "ID da cena a ser desinstalada",
  T_48_META_API_1010: "Retorno de chamada do evento",
  T_48_META_API_1010_D: "Acções desencadeadas quando ocorre um evento",
  T_48_META_API_1010_P0: "Nomes de parâmetros de eventos",
  T_48_META_API_1010_P0_D: "O nome do parâmetro formal do parâmetro do acontecimento, através do qual o valor do parâmetro real pode ser obtido na variável local",
  T_48_META_API_1011: "Bloco de código",
  T_48_META_API_1011_D: "Um bloco de código para alojar uma combinação de APIs",
  T_48_META_API_1011_P0: "Nomes de parâmetros",
  T_48_META_API_1011_P0_D: "Nomes formais de parâmetros quando o bloco de código é uma função personalizada",
  T_48_META_API_1012: "Encontre e invoque API personalizada com serial",
  T_48_META_API_1012_D: "Chama funções personalizadas em série e, se houver uma espera na função personalizada, o local de chamada também espera",
  T_48_META_API_1012_P0_D: "A entidade onde reside a função personalizada",
  T_48_META_API_1012_P1: "ID do gráfico",
  T_48_META_API_1012_P1_D: "ID do script onde reside a função personalizada",
  T_48_META_API_1012_P2: "ID da função",
  T_48_META_API_1012_P2_D: "ID da função da chamada de destino",
  T_48_META_API_1012_P3_D: "Lista dos parâmetros reais transmitidos à função personalizada",
  T_48_META_API_1013: "Encontre e invoque API personalizada com Parallel",
  T_48_META_API_1013_D: "Chama as funções personalizadas de forma paralela, regressando imediatamente à posição de chamada para continuar na linha, independentemente de haver ou não uma espera na função personalizada",
  T_48_META_API_1013_P0_D: "A entidade onde reside a função personalizada",
  T_48_META_API_1013_P1: "ID do gráfico",
  T_48_META_API_1013_P1_D: "ID do script onde reside a função personalizada",
  T_48_META_API_1013_P2: "ID da função",
  T_48_META_API_1013_P2_D: "ID da função da chamada de destino",
  T_48_META_API_1013_P3_D: "Lista dos parâmetros reais transmitidos à função personalizada",
  T_48_META_API_1014: "Encontre e invoque a API personalizada com serial",
  T_48_META_API_1014_D: "Chama uma função personalizada no script atual de forma serial e, se houver uma espera na função personalizada, a localização da chamada também espera",
  T_48_META_API_1014_P0: "ID da função",
  T_48_META_API_1014_P0_D: "ID da função da chamada de destino",
  T_48_META_API_1014_P1_D: "Lista dos parâmetros reais transmitidos à função personalizada",
  T_48_META_API_1015: "Encontre e invoque a API personalizada com o Parallel",
  T_48_META_API_1015_D: "Chama as funções personalizadas de forma paralela, regressando imediatamente à posição de chamada para continuar na linha, independentemente de haver ou não uma espera na função personalizada",
  T_48_META_API_1015_P0: "Definir variável local por índice",
  T_48_META_API_1015_P0_D: "ID da função da chamada de destino",
  T_48_META_API_1015_P1_D: "Lista dos parâmetros reais transmitidos à função personalizada",
  T_48_META_API_1016_D: "Obter o tipo do alvo ao chamar esta API",
  T_48_META_API_1016_P0_D: "objetivo consultado",
  T_48_META_API_1016_R_D: "Tipo de variável",
  T_48_META_API_1017_D: "Determinar se a variável de destino é do tipo especificado",
  T_48_META_API_1017_P0_D: "objetivo consultado",
  T_48_META_API_1017_P1_D: "Tipo de comparação",
  T_48_META_API_1017_R_D: "consistência",
  T_48_META_API_1018_D: "Determina se a variável de destino é uma subclasse de um determinado tipo; o valor de retorno é um valor booleano",
  T_48_META_API_1018_P0_D: "Variável-alvo que está a ser consultada",
  T_48_META_API_1018_P1_D: "Tipo de comparação",
  T_48_META_API_1018_R_D: "Se é ou não uma subclasse",
  T_48_META_API_1019_D: "Faz com que a entidade de destino accione o evento personalizado especificado",
  T_48_META_API_1019_P0_D: "IDs de eventos personalizados enviados",
  T_48_META_API_1019_P1_D: "entidade-alvo",
  T_48_META_API_1019_P2_D: "lista de parâmetros",
  T_48_META_API_102_D: "A mudança para uma cena específica descarrega as outras cenas carregadas.",
  T_48_META_API_102_P0_D: "ID da cena para mudar para",
  T_48_META_API_1020_D: "A implementação de percorrer um contentor para chegar a cada par chave-valor contém sub-procedimentos, o corpo do ciclo é o sub-procedimento",
  T_48_META_API_1020_P0_D: "Itere sobre o nome da chave e pode utilizá-lo para obter o valor da chave na variável local",
  T_48_META_API_1020_P1_D: "Iterar sobre o nome do valor, que pode ser utilizado para obter o valor na variável local",
  T_48_META_API_1020_P2_D: "Contentores a percorrer",
  T_48_META_API_1021_D: "Destruir o Bot especificado",
  T_48_META_API_1021_P0_D: "Jogadores bot que precisam ser destruídos",
  T_48_META_API_1022_D: "Forçar o jogador alvo a abandonar o transportador",
  T_48_META_API_1022_P0_D: "jogador-alvo",
  T_48_META_API_1023_D: "Criação de jumpers de lesão",
  T_48_META_API_1023_P0_D: "conteúdo sem palavras",
  T_48_META_API_1023_P1_D: "tamanho da letra",
  T_48_META_API_1023_P2_D: "cor do tipo de letra",
  T_48_META_API_1023_P3_D: "Tempo de espera em milissegundos",
  T_48_META_API_1023_P4_D: "entidade lesada",
  T_48_META_API_1023_P5_D: "Deslocamento da palavra de salto de dano em relação às coordenadas mundiais da entidade alvo",
  T_48_META_API_1023_P6_D: "O tamanho do intervalo da correção de posição aleatória no local do salto de danos novamente",
  T_48_META_API_1023_P7_D: "Se deve ser executada a animação de preenchimento",
  T_48_META_API_1024_D: "abandonado",
  T_48_META_API_1024_P0_D: "abandonado",
  T_48_META_API_1024_P1_D: "entidade-alvo",
  T_48_META_API_1024_P2_D: "Quando selecionada, se for chamada no servidor, é enviada para o cliente, e se for chamada no cliente, é enviada para o servidor.",
  T_48_META_API_1024_P3_D: "lista de parâmetros",
  T_48_META_API_1025_D: "Consultar o progresso de uma tarefa personalizada",
  T_48_META_API_1025_P0_D: "jogador-alvo",
  T_48_META_API_1025_P1_D: "ID de tarefa personalizada",
  T_48_META_API_1025_R_D: "Progresso da missão",
  T_48_META_API_1026_D: "Obter a skin da mochila do jogador alvo",
  T_48_META_API_1026_P0_D: "jogador-alvo",
  T_48_META_API_1026_R_D: "Identificação da pele da mochila",
  T_48_META_API_1027_D: "Definir o aspeto da mochila do jogador alvo",
  T_48_META_API_1027_P0_D: "jogador-alvo",
  T_48_META_API_1027_P1_D: "Identificação da pele da mochila",
  T_48_META_API_1028_D: "Restaura a skin da mochila do jogador alvo para a configuração padrão fora do escritório",
  T_48_META_API_1028_P0_D: "jogador-alvo",
  T_48_META_API_1029_D: "Esvazia a skin da mochila do jogador alvo",
  T_48_META_API_1029_P0_D: "jogador-alvo",
  T_48_META_API_103_D: "Substituir o estilo de ambiente skybox do jogo por uma opção de dia, crepúsculo, noite, etc.",
  T_48_META_API_103_P0_D: "Tipo de Skybox",
  T_48_META_API_1030_D: "Obter a parte do esqueleto por nome",
  T_48_META_API_1030_P0_D: "entidade-alvo",
  T_48_META_API_1030_P1_D: "Nome do ponto de suspensão esquelético",
  T_48_META_API_1030_R_D: "Ponto de Rig",
  T_48_META_API_1031_D: "Define o nó pai de uma entidade objeto que suporta entidades que têm componentes Transform, SkeletonPart, Player, MountPoint montados nelas.",
  T_48_META_API_1031_P0_D: "nó pai",
  T_48_META_API_1031_P1_D: "nó filho",
  T_48_META_API_1031_P2_D: "Se deve manter a posição atual do mundo, a rotação e a escala dos nós filhos, a definição de IU deste item é inválida",
  T_48_META_API_1032_D: "Reproduz um efeito de ícone animado em que o ícone se desloca da posição inicial para a posição final à velocidade de reprodução.",
  T_48_META_API_1032_P0_D: "Ícone ID do recurso",
  T_48_META_API_1032_P1_D: "cor",
  T_48_META_API_1032_P2_D: "Ícone Zoom",
  T_48_META_API_1032_P3_D: "Posição inicial centro",
  T_48_META_API_1032_P4_D: "Início do âmbito regional",
  T_48_META_API_1032_P5_D: "Centro da posição final",
  T_48_META_API_1032_P6_D: "Gama de posições finais",
  T_48_META_API_1032_P7_D: "A velocidade de reprodução, que é a distância por segundo que o ícone percorre",
  T_48_META_API_1033_D: "Efetuar uma operação de tangente inversa para obter o ângulo",
  T_48_META_API_1033_P0_D: "Coordenadas do eixo Y",
  T_48_META_API_1033_P1_D: "Coordenadas do eixo X",
  T_48_META_API_1033_R_D: "Ângulo, intervalo (-180, 180]",
  T_48_META_API_1034_D: "Adição de componentes a entidades, apenas são suportados componentes personalizados criados pelo utilizador",
  T_48_META_API_1034_P0_D: "entidade-alvo",
  T_48_META_API_1034_P1_D: "ID do tipo de componente, apenas são suportados componentes personalizados criados pelo utilizador",
  T_48_META_API_1034_P2_D: "Quer seja ou não adicionado com êxito, os componentes existentes ou os componentes não personalizados não serão adicionados.",
  T_48_META_API_1035_D: "Remover componentes de entidades, apenas são suportados componentes personalizados",
  T_48_META_API_1035_P0_D: "entidade-alvo",
  T_48_META_API_1035_P1_D: "ID do tipo de componente, apenas são suportados componentes personalizados criados pelo utilizador",
  T_48_META_API_1035_P2_D: "Quer a remoção tenha sido bem sucedida ou não, os componentes não existentes ou não personalizados não serão removidos.",
  T_48_META_API_1036_D: "Personalizar o ecrã de saída do jogador",
  T_48_META_API_1036_P0_D: "legenda",
  T_48_META_API_1036_P1_D: "elemento",
  T_48_META_API_1036_P2_D: "opções",
  T_48_META_API_1036_P3_D: "Se deve mostrar o fundo",
  T_48_META_API_1037_D: "Obter todas as cenas atualmente carregadas",
  T_48_META_API_1037_R_D: "Lista de cenas",
  T_48_META_API_1038_D: "Obter a direção de mira local do jogador",
  T_48_META_API_1038_R_D: "apontar na direção certa",
  T_48_META_API_1039_D: "Obter o carimbo de data/hora local",
  T_48_META_API_1039_R_D: "carimbo de data/hora",
  T_48_META_API_104_D: "Muda o jogador para um local especificado numa cena especificada; as cenas não carregadas serão carregadas automaticamente e não descarregarão automaticamente as cenas já carregadas",
  T_48_META_API_104_P0_D: "jogador",
  T_48_META_API_104_P1_D: "ID da cena a ser carregada",
  T_48_META_API_104_P2_D: "Posição do jogador no novo cenário",
  T_48_META_API_104_P3_D: "Orientação do jogador no novo cenário",
  T_48_META_API_1040_D: "Pausa a atualização de fotogramas fixos para a plataforma atual, e o evento de atualização de fotogramas fixos para essa plataforma não será acionado após a pausa.",
  T_48_META_API_1041_D: "Retomar a atualização da moldura fixa para a plataforma atual, e o evento de atualização da moldura fixa para essa plataforma começa a ser ativado novamente após o reinício",
  T_48_META_API_1042_D: "Determinar a relação de amizade do jogador alvo com o jogador cliente atual, o cliente atual não é amigo do cliente atual",
  T_48_META_API_1042_P0_D: "jogador-alvo",
  T_48_META_API_1042_R_D: "Se é ou não amigo do cliente atual",
  T_48_META_API_1043_D: "Ativação de eventos personalizados",
  T_48_META_API_1043_P0_D: "ID de evento personalizado",
  T_48_META_API_1043_P1_D: "entidade-alvo",
  T_48_META_API_1043_P2_D: "Funciona em plataformas do lado do servidor ou do lado do cliente",
  T_48_META_API_1043_P3_D: "lista de parâmetros",
  T_48_META_API_1044_D: "Open Skydive",
  T_48_META_API_1044_P0_D: "jogador-alvo",
  T_48_META_API_1044_P1_D: "Abaixo desta altitude, o para-quedas será forçado a abrir-se.",
  T_48_META_API_1044_P2_D: "Velocidade durante o deslizamento, a componente X representa a velocidade horizontal, a componente Y representa a velocidade vertical; o jogador aterra para baixo quando a componente Y é negativa",
  T_48_META_API_1044_P3_D: "Velocidade num mergulho, a componente X representa a velocidade horizontal, a componente Y representa a velocidade vertical; o jogador desce para baixo quando a componente Y é negativa",
  T_48_META_API_1044_P4_D: "Velocidade ao abrir o para-quedas; a componente X representa a velocidade horizontal, a componente Y representa a velocidade vertical; quando a componente Y é negativa, o jogador aterra para baixo",
  T_48_META_API_1045_D: "Lê o valor correspondente ao identificador especificado na tabela de dados.",
  T_48_META_API_1045_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_1045_P1_D: "ID único do jogador",
  T_48_META_API_1045_P2_D: "identificador especificado",
  T_48_META_API_1045_P3_D: "Os resultados das leituras",
  T_48_META_API_1045_P4_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1045_P5_D: "código de erro",
  T_48_META_API_1046_D: "Recupera o valor correspondente ao identificador especificado na tabela de dados do gráfico.",
  T_48_META_API_1046_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_1046_P1_D: "identificador especificado",
  T_48_META_API_1046_P2_D: "Os resultados das leituras",
  T_48_META_API_1046_P3_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1046_P4_D: "código de erro",
  T_48_META_API_1047_D: "Recupera o valor do intervalo de classificação especificado na tabela de dados das tabelas de classificação",
  T_48_META_API_1047_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_1047_P1_D: "A classificação inicial deve ser menor ou igual à classificação final e a classificação começa em 1",
  T_48_META_API_1047_P2_D: "posição final",
  T_48_META_API_1047_P3_D: "Os resultados das leituras",
  T_48_META_API_1047_P4_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1047_P5_D: "código de erro",
  T_48_META_API_1048_D: "Lê o valor correspondente ao identificador especificado na tabela de dados cumulativos.",
  T_48_META_API_1048_P0_D: "Nome da tabela de dados cumulativos na base de dados",
  T_48_META_API_1048_P1_D: "identificador especificado",
  T_48_META_API_1048_P2_D: "Os resultados das leituras",
  T_48_META_API_1048_P3_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1048_P4_D: "código de erro",
  T_48_META_API_1049_D: "Escreve o valor correspondente ao identificador especificado na tabela de dados.",
  T_48_META_API_1049_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_1049_P1_D: "ID único do jogador",
  T_48_META_API_1049_P2_D: "identificador especificado",
  T_48_META_API_1049_P3_D: "Valor escrito",
  T_48_META_API_1049_P4_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1049_P5_D: "código de erro",
  T_48_META_API_105_D: "Obter o skybox da cena",
  T_48_META_API_105_P0_D: "ID da cena",
  T_48_META_API_105_R_D: "caixa de correio",
  T_48_META_API_1050_D: "Obter o número de elementos da lista",
  T_48_META_API_1050_P0_D: "lista de objectivos",
  T_48_META_API_1050_R_D: "Número de elementos",
  T_48_META_API_1051_D: "Obtém o valor do elemento no índice especificado na lista",
  T_48_META_API_1051_P0_D: "lista de objectivos",
  T_48_META_API_1051_P1_D: "Valores do índice, a partir de 0",
  T_48_META_API_1051_R_D: "valor elementar",
  T_48_META_API_1052_D: "Define o valor do elemento correspondente ao índice especificado na lista",
  T_48_META_API_1052_P0_D: "lista de objectivos",
  T_48_META_API_1052_P1_D: "Valores do índice, a partir de 0",
  T_48_META_API_1052_P2_D: "valor elementar",
  T_48_META_API_1053_D: "Acrescentar elementos ao fim da lista",
  T_48_META_API_1053_P0_D: "lista de objectivos",
  T_48_META_API_1053_P1_D: "Elementos a acrescentar",
  T_48_META_API_1054_D: "Remove o elemento no índice especificado da lista",
  T_48_META_API_1054_P0_D: "lista de objectivos",
  T_48_META_API_1054_P1_D: "Valores do índice, a partir de 0",
  T_48_META_API_1055_D: "Esvaziar a lista de todos os elementos",
  T_48_META_API_1055_P0_D: "lista de objectivos",
  T_48_META_API_1056_D: "Inverte a ordem dos elementos da lista especificada.",
  T_48_META_API_1056_P0_D: "lista de objectivos",
  T_48_META_API_1057_D: "Copiar uma lista",
  T_48_META_API_1057_P0_D: "lista de objectivos",
  T_48_META_API_1057_R_D: "Nova lista copiada",
  T_48_META_API_1058_D: "Insere um novo elemento na posição de índice especificada na lista, e os elementos nessa posição de índice e nas seguintes são recuados um lugar em sequência.",
  T_48_META_API_1058_P0_D: "lista de objectivos",
  T_48_META_API_1058_P1_D: "Posição do índice a ser inserido, índice contado a partir de 0",
  T_48_META_API_1058_P2_D: "O valor do novo elemento a inserir",
  T_48_META_API_1059_D: "Re-aleatorizar os elementos da lista",
  T_48_META_API_1059_P0_D: "lista de objectivos",
  T_48_META_API_1060_D: "Compara ambos os lados do argumento e devolve verdadeiro ou falso.",
  T_48_META_API_1060_P0_D: "O valor à esquerda utilizado para comparação",
  T_48_META_API_1060_P1_D: "Métodos de comparação, são suportados os seguintes: >,>=,==,! =,<=,<,And(tipo bool qualificado),Or(tipo bool qualificado)",
  T_48_META_API_1060_P2_D: "O valor à esquerda utilizado para comparação",
  T_48_META_API_1060_R_D: "Resultados comparativos",
  T_48_META_API_1061_D: "As quatro operações básicas, incluindo a adição, a subtração, a multiplicação, a divisão e o resto. A operação de resto suporta apenas números inteiros, e as restantes operações suportam números inteiros ou decimais.",
  T_48_META_API_1061_P0_D: "valor à esquerda de uma operação",
  T_48_META_API_1061_P1_D: "Tipos das quatro operações, incluindo a adição, a subtração, a multiplicação, a divisão e o resto, que não suporta decimais",
  T_48_META_API_1061_P2_D: "valor correto de uma operação",
  T_48_META_API_1061_R_D: "resultado do cálculo",
  T_48_META_API_1062_D: "Gerar um número inteiro aleatório entre o número inteiro de valor mínimo (incluído) e o número inteiro de valor máximo (não incluído)",
  T_48_META_API_1062_P0_D: "Intervalo de esquerda aleatório com possibilidade de aleatoriedade para o valor preenchido",
  T_48_META_API_1062_P1_D: "Intervalo aleatório do intervalo direito, não será aleatório para o valor preenchido",
  T_48_META_API_1062_R_D: "Resultado aleatório, número inteiro",
  T_48_META_API_1063_D: "Gerar um decimal aleatório entre o valor decimal mínimo (incluído) e o valor decimal máximo (não incluído)",
  T_48_META_API_1063_P0_D: "Intervalo de esquerda aleatório, com uma pequena hipótese de aleatoriedade para o valor preenchido",
  T_48_META_API_1063_P1_D: "Intervalo aleatório do intervalo direito, não será aleatório para o valor preenchido",
  T_48_META_API_1063_R_D: "Resultados aleatórios, decimais, com 7 casas decimais",
  T_48_META_API_1064_D: "Determinar se um objeto está vazio",
  T_48_META_API_1064_P0_D: "objeto vazio a ser julgado",
  T_48_META_API_1064_R_D: "Está vazio",
  T_48_META_API_1065_D: "Inverso lógico, valor de entrada: verdadeiro ou falso, valor de retorno: falso ou verdadeiro",
  T_48_META_API_1065_P0_D: "Os valores que têm de ser solicitados para os valores não",
  T_48_META_API_1065_R_D: "O resultado da não soma",
  T_48_META_API_1066_D: "Aceita valores absolutos e suporta números inteiros e decimais.",
  T_48_META_API_1066_P0_D: "Valores para os quais são necessários valores absolutos",
  T_48_META_API_1066_R_D: "O resultado de tomar valores absolutos",
  T_48_META_API_1067_D: "cálculo da raiz quadrada",
  T_48_META_API_1067_P0_D: "Necessidade de pedir o valor da raiz quadrada",
  T_48_META_API_1067_R_D: "O resultado de encontrar a raiz quadrada",
  T_48_META_API_1068_D: "Cálculo de valores negativos",
  T_48_META_API_1068_P0_D: "Valores negativos a solicitar",
  T_48_META_API_1068_R_D: "Resultados negativos",
  T_48_META_API_1069_D: "Juntar duas cordas",
  T_48_META_API_1069_P0_D: "valor à esquerda de uma cadeia",
  T_48_META_API_1069_P1_D: "valor correto de uma cadeia",
  T_48_META_API_1069_R_D: "resultado da concatenação de strings",
  T_48_META_API_1070_D: "Obter o comprimento da cadeia",
  T_48_META_API_1070_P0_D: "string",
  T_48_META_API_1070_R_D: "comprimento da cadeia",
  T_48_META_API_1071_D: "Arredonda o valor especificado para o número inteiro mais próximo.",
  T_48_META_API_1071_P0_D: "Valor a arredondar para baixo",
  T_48_META_API_1071_R_D: "arredondamento por defeito",
  T_48_META_API_1072_D: "Arredonda o valor especificado para o número inteiro mais próximo.",
  T_48_META_API_1072_P0_D: "Valores a arredondar para cima",
  T_48_META_API_1072_R_D: "Resultados do arredondamento",
  T_48_META_API_1073_D: "Arredonda o valor especificado para o número inteiro mais próximo.",
  T_48_META_API_1073_P0_D: "Número de valores a arredondar",
  T_48_META_API_1073_R_D: "resultado arredondado",
  T_48_META_API_1074_D: "Produz uma nova cadeia de caracteres depois de substituir todas as cadeias de caracteres especificadas na cadeia de caracteres de destino",
  T_48_META_API_1074_P0_D: "cadeia de destino",
  T_48_META_API_1074_P1_D: "A cadeia antiga a ser substituída",
  T_48_META_API_1074_P2_D: "Nova cadeia de caracteres a substituir por",
  T_48_META_API_1074_R_D: "Substituição da cadeia preenchida",
  T_48_META_API_1075_D: "Encontra a primeira ocorrência de uma cadeia de caracteres especificada na cadeia de caracteres de destino.",
  T_48_META_API_1075_P0_D: "cadeia de destino",
  T_48_META_API_1075_P1_D: "A cadeia especificada a procurar",
  T_48_META_API_1075_P2_D: "Encontra a cadeia a partir da posição inicial, a posição da cadeia é contada a partir de 0",
  T_48_META_API_1075_R_D: "Especifica a posição da primeira ocorrência da cadeia na cadeia de destino, a posição da cadeia é contada a partir de 0.",
  T_48_META_API_1076_D: "Produz uma nova cadeia de caracteres depois de intercetar uma cadeia de um comprimento especificado a partir de uma posição especificada.",
  T_48_META_API_1076_P0_D: "cadeia de destino",
  T_48_META_API_1076_P1_D: "Posição em que se inicia a interceção, a posição da cadeia é contada a partir de 0",
  T_48_META_API_1076_P2_D: "Comprimento da interceção, por defeito é até ao fim da cadeia.",
  T_48_META_API_1076_R_D: "Cadeia de caracteres interceptada",
  T_48_META_API_1077_D: "Compara duas listas com elementos idênticos, o tamanho da lista não afecta o resultado.",
  T_48_META_API_1077_P0_D: "O valor à esquerda da lista utilizada para comparação",
  T_48_META_API_1077_P1_D: "O valor correto da lista utilizada para comparação",
  T_48_META_API_1077_R_D: "Compare os resultados: a consistência do conteúdo é verdadeira e a inconsistência do conteúdo é falsa.",
  T_48_META_API_1078_D: "Toma a cadeia de caracteres especificada como separador, corta a cadeia de caracteres de destino num determinado número de fatias e produz a nova cadeia de caracteres; os N separadores consecutivos serão cortados em N-1 espaços de meia largura como saída ",
  T_48_META_API_1078_P0_D: "cadeia de destino",
  T_48_META_API_1078_P1_D: "cadeia de delimitadores",
  T_48_META_API_1078_R_D: "Produz uma lista de cadeias de caracteres, terminando sempre com um elemento de espaço de meia largura",
  T_48_META_API_1079_D: "Extrair caracteres da lista de posições da cadeia e combiná-los numa nova saída de cadeia",
  T_48_META_API_1079_P0_D: "cadeia de destino",
  T_48_META_API_1079_P1_D: "Lista de posições de cadeia, posições de cadeia contadas a partir de 0",
  T_48_META_API_1079_R_D: "Cadeia de saída",
  T_48_META_API_1080_D: "Converte todos os caracteres da cadeia de destino em maiúsculas",
  T_48_META_API_1080_P0_D: "cadeia de destino",
  T_48_META_API_1080_R_D: "Cadeia de saída",
  T_48_META_API_1081_D: "Converte todos os caracteres da cadeia de destino em minúsculas",
  T_48_META_API_1081_P0_D: "cadeia de destino",
  T_48_META_API_1081_R_D: "Cadeia de saída",
  T_48_META_API_1082_D: "Remove todos os espaços antes do primeiro caractere sem espaço em branco e depois do último caractere sem espaço em branco da string de destino.",
  T_48_META_API_1082_P0_D: "cadeia de destino",
  T_48_META_API_1082_R_D: "Cadeia de saída",
  T_48_META_API_1083_D: "Produz uma nova cadeia de caracteres após a ligação com um identificador especificado.",
  T_48_META_API_1083_P0_D: "Lista de cadeias de caracteres de destino",
  T_48_META_API_1083_P1_D: "Identificador especificado utilizado para concatenar cadeias de caracteres",
  T_48_META_API_1083_R_D: "Cadeia de saída",
  T_48_META_API_1084_D: "Escreve o valor correspondente ao identificador especificado na tabela de dados da tabela de classificação",
  T_48_META_API_1084_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_1084_P1_D: "identificador especificado",
  T_48_META_API_1084_P2_D: "Valor escrito",
  T_48_META_API_1084_P3_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1084_P4_D: "código de erro",
  T_48_META_API_1085_D: "Escrever o valor de desvio correspondente ao identificador especificado na tabela de dados cumulativos",
  T_48_META_API_1085_P0_D: "Nome da tabela de dados cumulativos na base de dados",
  T_48_META_API_1085_P1_D: "identificador especificado",
  T_48_META_API_1085_P2_D: "Tipos de operações quadráticas",
  T_48_META_API_1085_P3_D: "Valor de desvio escrito",
  T_48_META_API_1085_P4_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1085_P5_D: "código de erro",
  T_48_META_API_1086_D: "Elimina o valor correspondente ao identificador especificado na tabela de dados.",
  T_48_META_API_1086_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_1086_P1_D: "ID único do jogador",
  T_48_META_API_1086_P2_D: "identificador especificado",
  T_48_META_API_1086_P3_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1086_P4_D: "código de erro",
  T_48_META_API_1087_D: "Elimina o valor correspondente ao identificador especificado na tabela de dados do gráfico.",
  T_48_META_API_1087_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_1087_P1_D: "identificador especificado",
  T_48_META_API_1087_P2_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1087_P3_D: "código de erro",
  T_48_META_API_1088_D: "Elimina o valor correspondente à classificação especificada na tabela da Tabela de classificação.",
  T_48_META_API_1088_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_1088_P1_D: "um cargo de prestígio",
  T_48_META_API_1088_P2_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_1088_P3_D: "código de erro",
  T_48_META_API_1089_D: "Enviar uma mensagem de utilizador a Persona",
  T_48_META_API_1089_P0_D: "PersonaID de destino",
  T_48_META_API_1089_P1_D: "Mensagem",
  T_48_META_API_1090_D: "Enviar uma mensagem de sistema para Persona",
  T_48_META_API_1090_P0_D: "PersonaID de destino",
  T_48_META_API_1090_P1_D: "Mensagem",
  T_48_META_API_1091_D: "Limpar a memória da Persona",
  T_48_META_API_1091_P0_D: "código de erro",
  T_48_META_API_1092_D: "Centro de Membros Evoke",
  T_48_META_API_1092_P0_D: "código de erro",
  T_48_META_API_1093_D: "Obter o carimbo de data/hora de expiração do membro",
  T_48_META_API_1093_P0_D: "jogador-alvo",
  T_48_META_API_1093_P1_D: "carimbo de data/hora",
  T_48_META_API_1093_P2_D: "código de erro",
  T_48_META_API_1094_D: "Determinar se um jogador é membro",
  T_48_META_API_1094_P0_D: "código de erro",
  T_48_META_API_1094_P1_D: "Quer seja membro",
  T_48_META_API_1095_D: "Obter o carimbo de data/hora de expiração do membro",
  T_48_META_API_1095_P0_D: "carimbo de data/hora",
  T_48_META_API_1095_P1_D: "código de erro",
  T_48_META_API_1096_D: "Determinar se um jogador é membro",
  T_48_META_API_1096_P0_D: "jogador-alvo",
  T_48_META_API_1096_P1_D: "código de erro",
  T_48_META_API_1096_P2_D: "Quer seja membro",
  T_48_META_API_1097_D: "Centro de Membros Evoke",
  T_48_META_API_1097_P0_D: "jogador-alvo",
  T_48_META_API_1097_P1_D: "código de erro",
  T_48_META_API_1099_D: "Configuração de observadores do Persona, após o que as conversas com o Persona são também enviadas para o observador",
  T_48_META_API_1099_P0_D: "PersonaID de destino",
  T_48_META_API_1099_P1_D: "lista de observação",
  T_48_META_API_11_D: "Terminar a fase atual e passar à fase seguinte",
  T_48_META_API_1100_D: "Envio de mensagens de utilizador para a Persona utilizando Streaming",
  T_48_META_API_1100_P0_D: "PersonaID de destino",
  T_48_META_API_1100_P1_D: "Mensagem",
  T_48_META_API_1101_D: "Envio de mensagens do sistema para a Persona utilizando streaming",
  T_48_META_API_1101_P0_D: "PersonaID de destino",
  T_48_META_API_1101_P1_D: "Mensagem",
  T_48_META_API_1101_P2_D: "Se vai responder ou não",
  T_48_META_API_1103_D: "Criar sementes aleatórias",
  T_48_META_API_1103_P0_D: "torrent",
  T_48_META_API_1103_R_D: "Gerador de números aleatórios",
  T_48_META_API_1104_D: "Obtém o próximo número aleatório do gerador de números aleatórios especificado, valor máximo 32767",
  T_48_META_API_1104_P0_D: "Gerador de números aleatórios",
  T_48_META_API_1104_P1_D: "Intervalo Mínimo",
  T_48_META_API_1104_P2_D: "Alcance Máximo",
  T_48_META_API_1104_R_D: "número aleatório",
  T_48_META_API_1108_D: "Obtenha o idioma do cliente usado pelo jogador",
  T_48_META_API_12_D: "Imprimir registos na consola",
  T_48_META_API_12_P0_D: "O que imprimir",
  T_48_META_API_13_D: "Produz uma cadeia de caracteres com parâmetros",
  T_48_META_API_13_P0_D: "Utilizar o marcador de posição %v para um parâmetro, o número de %v e o número de parâmetros têm de ser iguais.",
  T_48_META_API_13_P1_D: "A lista de parâmetros que participam na saída tem de ser coerente com o número de %v na descrição do formato",
  T_48_META_API_13_R_D: "Cadeia de saída",
  T_48_META_API_14_D: "Limpar os restos de objectos do mapa, incluindo caixas de morte, objectos criados, objectos colocados, restos de projécteis, etc.",
  T_48_META_API_15_D: "Registos de enterro de concursos personalizados para análise de dados da experiência do utilizador",
  T_48_META_API_15_P0_D: "Lista de nomes de campos a comunicar",
  T_48_META_API_15_P1_D: "Lista de valores de campo a reportar",
  T_48_META_API_1500_D: "Obter o componente x do vetor 3D",
  T_48_META_API_1500_P0_D: "Vetor 3D",
  T_48_META_API_1500_R_D: "Componente x do vetor 3D",
  T_48_META_API_1501_D: "Obter o componente y do vetor 3D",
  T_48_META_API_1501_P0_D: "Vetor 3D",
  T_48_META_API_1501_R_D: "Componente Y do vetor 3D",
  T_48_META_API_1502_D: "Obter o componente z do vetor 3D",
  T_48_META_API_1502_P0_D: "Vetor 3D",
  T_48_META_API_1502_R_D: "Componente z do vetor tridimensional",
  T_48_META_API_1503_D: "Definir o componente x do vetor 3D",
  T_48_META_API_1503_P0_D: "Vetor 3D",
  T_48_META_API_1503_P1_D: "Componente X",
  T_48_META_API_1504_D: "Definir o componente Y do vetor 3D",
  T_48_META_API_1504_P0_D: "Vetor 3D",
  T_48_META_API_1504_P1_D: "Componente Y",
  T_48_META_API_1505_D: "Definir o componente z do vetor 3D",
  T_48_META_API_1505_P0_D: "Vetor 3D",
  T_48_META_API_1505_P1_D: "Componente Z",
  T_48_META_API_1506_D: "Adicionar dois vectores 3D",
  T_48_META_API_1506_P0_D: "Valor esquerdo",
  T_48_META_API_1506_P1_D: "Valor direito",
  T_48_META_API_1506_R_D: "Resultado da soma vetorial 3D",
  T_48_META_API_1507_D: "Subtrair dois vectores 3D",
  T_48_META_API_1507_P0_D: "Valor esquerdo",
  T_48_META_API_1507_P1_D: "Valor direito",
  T_48_META_API_1507_R_D: "O resultado da subtração do valor da direita ao valor da esquerda do vetor 3D",
  T_48_META_API_1508_D: "Dimensionamento de vectores 3D",
  T_48_META_API_1508_P0_D: "Vectores 3D a escalar",
  T_48_META_API_1508_P1_D: "Deflação vetorial 3D",
  T_48_META_API_1508_R_D: "Resultados do escalonamento de vectores 3D",
  T_48_META_API_1509_D: "Multiplicação por pontos de dois vectores 3D, o resultado da multiplicação por pontos é um escalar",
  T_48_META_API_1509_P0_D: "Valor esquerdo",
  T_48_META_API_1509_P1_D: "Valor direito",
  T_48_META_API_1509_R_D: "Resultado do produto escalar",
  T_48_META_API_1510_D: "Multiplicação cruzada de dois vectores 3D, o resultado da multiplicação cruzada é um vetor, perpendicular ao plano onde os dois vectores estão localizados",
  T_48_META_API_1510_P0_D: "Valor esquerdo",
  T_48_META_API_1510_P1_D: "Valor direito",
  T_48_META_API_1510_R_D: "O resultado do produto vetorial, orientado perpendicularmente ao plano em que se encontram os dois vetores envolvidos na operação",
  T_48_META_API_1511_D: "Normalização de vectores 3D",
  T_48_META_API_1511_P0_D: "Vetor 3D",
  T_48_META_API_1511_R_D: "Devolve um novo vetor normalizado. O comprimento do módulo é 1",
  T_48_META_API_1512_D: "Modelação de vectores 3D",
  T_48_META_API_1512_P0_D: "Vetor 3D",
  T_48_META_API_1512_R_D: "O resultado da modelação, o comprimento do módulo do vetor",
  T_48_META_API_1513_D: "Calcular a distância euclidiana entre dois vectores 3D",
  T_48_META_API_1513_P0_D: "Valor esquerdo",
  T_48_META_API_1513_P1_D: "Valor direito",
  T_48_META_API_1513_R_D: "Após a subtração de dois vectores, o módulo do vetor resultante",
  T_48_META_API_1514_D: "Calcular o ângulo entre dois vectores 3D",
  T_48_META_API_1514_P0_D: "Valor esquerdo",
  T_48_META_API_1514_P1_D: "Valor direito",
  T_48_META_API_1514_R_D: "Ângulo vetorial, gama de ângulos 0-180",
  T_48_META_API_1515_D: "Criar um vetor 3D",
  T_48_META_API_1515_P0_D: "Componente X de um vetor 3D",
  T_48_META_API_1515_P1_D: "Componente Y de um vetor 3D",
  T_48_META_API_1515_P2_D: "Componente Z de um vetor 3D",
  T_48_META_API_1515_R_D: "Vectores 3D criados",
  T_48_META_API_1516_D: "Obtém o ponto de orientação de uma nova construção (obsoleto, por favor não o utilize)",
  T_48_META_API_1516_P0_D: "colocação",
  T_48_META_API_1516_P1_D: "virar para",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Tomar a posição do ponto de direção (obsoleto, não utilizar)",
  T_48_META_API_1517_P0_D: "ponto de orientação",
  T_48_META_API_1517_R_D: "Posição",
  T_48_META_API_1518_D: "Tomar a orientação do ponto de direção (obsoleto, não utilizar)",
  T_48_META_API_1518_P0_D: "ponto de orientação",
  T_48_META_API_1518_R_D: "Avançar",
  T_48_META_API_1519_D: "Criar uma lista",
  T_48_META_API_1519_P0_D: "O comprimento inicial da lista, que deve ser inferior ou igual à capacidade inicial",
  T_48_META_API_1519_P1_D: "A capacidade inicial da lista deve ser maior ou igual ao comprimento inicial. A capacidade pode ser expandida dinamicamente, mas irá consumir algum desempenho, pelo que se recomenda a definição de um valor adequado aquando da construção.",
  T_48_META_API_1519_R_D: "Criar uma lista",
  T_48_META_API_1520_D: "Verifica se a lista contém o elemento especificado",
  T_48_META_API_1520_P0_D: "lista de objectivos",
  T_48_META_API_1520_P1_D: "O elemento especificado a ser verificado",
  T_48_META_API_1520_R_D: "Se contém ou não o elemento especificado",
  T_48_META_API_1521_D: "Acrescentar vários elementos ao final da lista de destino",
  T_48_META_API_1521_P0_D: "lista de objectivos",
  T_48_META_API_1521_P1_D: "Lista suplementar",
  T_48_META_API_1522_D: "Remove o elemento especificado da lista",
  T_48_META_API_1522_P0_D: "lista de objectivos",
  T_48_META_API_1522_P1_D: "O valor do elemento a ser removido",
  T_48_META_API_1523_D: "Obtém o índice da primeira posição do elemento na lista; se não houver nenhum elemento de destino na lista, é devolvido -1.",
  T_48_META_API_1523_P0_D: "lista de objectivos",
  T_48_META_API_1523_P1_D: "valor elementar",
  T_48_META_API_1523_R_D: "índice de localização",
  T_48_META_API_1524_D: "Obtém o índice da última posição do elemento na lista; se não houver nenhum elemento de destino na lista, devolve -1.",
  T_48_META_API_1524_P0_D: "lista de objectivos",
  T_48_META_API_1524_P1_D: "valor elementar",
  T_48_META_API_1524_R_D: "índice de localização",
  T_48_META_API_1525_D: "Encontrar o seno do ângulo",
  T_48_META_API_1525_P0_D: "Ângulo, 360 para 360 graus",
  T_48_META_API_1525_R_D: "seno",
  T_48_META_API_1526_D: "Determinar o cosseno de um ângulo",
  T_48_META_API_1526_P0_D: "Ângulo, 360 para 360 graus",
  T_48_META_API_1526_R_D: "cosseno",
  T_48_META_API_1527_D: "Determinar a tangente de um ângulo",
  T_48_META_API_1527_P0_D: "Ângulo, 360 para 360 graus",
  T_48_META_API_1527_R_D: "tangente",
  T_48_META_API_1528_D: "Constrói um valor de cor com transparência fixada em 255 decimal, primeiro converte o canal num número binário, com cada 8 bits a representar um canal, emendado de acordo com R, G, B e transparência, e depois converte esse número binário para o tipo Int32",
  T_48_META_API_1528_P0_D: "O valor do canal vermelho da cor, no intervalo [0,255], se exceder o intervalo, será fixado no valor legal.",
  T_48_META_API_1528_P1_D: "O valor do canal verde da cor, no intervalo [0,255], se exceder o intervalo, será fixado no valor legal.",
  T_48_META_API_1528_P2_D: "O valor do canal azul da cor, no intervalo [0,255], se exceder o intervalo, será fixado no valor legal.",
  T_48_META_API_1528_R_D: "Valores de cor construídos",
  T_48_META_API_1529_D: "Efetuar uma operação inversa do seno para obter o ângulo",
  T_48_META_API_1529_P0_D: "O valor para o qual é efectuada a operação inversa do seno, no intervalo [-1,1].",
  T_48_META_API_1529_R_D: "perspectivas",
  T_48_META_API_1530_D: "Efetuar a operação inversa do cosseno para obter o ângulo",
  T_48_META_API_1530_P0_D: "O valor da operação do cosseno inverso, no intervalo [-1,1].",
  T_48_META_API_1530_R_D: "perspectivas",
  T_48_META_API_1531_D: "Efetuar uma operação de tangente inversa para obter o ângulo",
  T_48_META_API_1531_P0_D: "O valor para o qual é efectuada a operação de arctangente",
  T_48_META_API_1531_R_D: "perspectivas",
  T_48_META_API_1532_D: "Determina se a entidade alvo está dentro da esfera especificada; se a entidade não tiver atributos posicionais, devolve falso",
  T_48_META_API_1532_P0_D: "entidade-alvo",
  T_48_META_API_1532_P1_D: "Especificar o centro da esfera",
  T_48_META_API_1532_P2_D: "Especificar o raio da esfera",
  T_48_META_API_1532_R_D: "Conclusões",
  T_48_META_API_1533_D: "Determina se a entidade alvo está dentro do intervalo de cilindros especificado; se a entidade não tiver um atributo de localização, devolve false",
  T_48_META_API_1533_P0_D: "entidade-alvo",
  T_48_META_API_1533_P1_D: "Especificar o centro do cilindro",
  T_48_META_API_1533_P2_D: "Especificar o raio da secção transversal do cilindro",
  T_48_META_API_1533_P3_D: "Especificar a altura do cilindro",
  T_48_META_API_1533_P4_D: "Especificar o ângulo de Euler de um cilindro que gira em três dimensões em torno do seu ponto central",
  T_48_META_API_1533_R_D: "Conclusões",
  T_48_META_API_1534_D: "Determinar se a entidade alvo está dentro do intervalo de cubos especificado",
  T_48_META_API_1534_P0_D: "entidade-alvo",
  T_48_META_API_1534_P1_D: "Especificar o centro do cubo",
  T_48_META_API_1534_P2_D: "Especificar o comprimento do cubo",
  T_48_META_API_1534_P3_D: "Especificar a largura do cubo",
  T_48_META_API_1534_P4_D: "Especificar a altura do cubo",
  T_48_META_API_1534_P5_D: "Especificar os ângulos de Euler para a rotação tridimensional do cubo em torno do seu ponto central",
  T_48_META_API_1534_R_D: "Conclusões",
  T_48_META_API_1535_D: "Determinar se a entidade alvo está dentro das colunas do sector especificado",
  T_48_META_API_1535_P0_D: "entidade-alvo",
  T_48_META_API_1535_P1_D: "Especificar o centro do círculo da secção central de uma coluna setorial",
  T_48_META_API_1535_P2_D: "Especificar o raio da secção central de um pilar com forma de sector",
  T_48_META_API_1535_P3_D: "O raio da secção transversal da coluna em forma de leque que não será detectado, com o ponto central como um círculo, não será detectado nesta região da pequena coluna em forma de leque, apenas a diferença entre a coluna em forma de leque prescrita e o pe",
  T_48_META_API_1535_P4_D: "Especificar a altura da coluna em forma de leque",
  T_48_META_API_1535_P5_D: "Deteção da secção transversal cilíndrica em forma de leque do ângulo do centróide, superior a 360 quando a deteção é cilíndrica, inferior a 0 quando o tamanho da área de deteção é 0",
  T_48_META_API_1535_P6_D: "Especificar o ângulo de rotação de Euler da coluna em forma de leque em torno do ponto central em três posições",
  T_48_META_API_1535_R_D: "Conclusões",
  T_48_META_API_1536_D: "Compara o valor de dois números e devolve o maior",
  T_48_META_API_1536_P0_D: "Valor esquerdo",
  T_48_META_API_1536_P1_D: "Valor direito",
  T_48_META_API_1536_R_D: "figura maior",
  T_48_META_API_1537_D: "Devolve o valor máximo da lista",
  T_48_META_API_1537_P0_D: "Lista de destino, só aceita elementos de lista do tipo numérico",
  T_48_META_API_1537_P1_D: "Compara os resultados; se houver números diferentes na lista, etc., a comparação falha e devolve falso.",
  T_48_META_API_1537_P2_D: "Devolve o maior valor da lista se a comparação for bem sucedida, ou 0 se a comparação falhar.",
  T_48_META_API_1538_D: "Compara o valor de dois números e devolve o menor",
  T_48_META_API_1538_P0_D: "Valor esquerdo",
  T_48_META_API_1538_P1_D: "Valor direito",
  T_48_META_API_1538_R_D: "Números mais pequenos",
  T_48_META_API_1539_D: "Devolve o valor mais pequeno da lista.",
  T_48_META_API_1539_P0_D: "Lista de destino, só aceita elementos de lista do tipo numérico",
  T_48_META_API_1539_P1_D: "Compara os resultados; se houver números diferentes na lista, etc., a comparação falha e devolve falso.",
  T_48_META_API_1539_P2_D: "Devolve o valor mais pequeno da lista se a comparação for bem sucedida, ou 0 se a comparação falhar.",
  T_48_META_API_1540_D: "Interpolação linear, devolvendo o valor correspondente ao progresso da interpolação entre o valor inicial e o valor alvo, coeficientes de interpolação [0,1]",
  T_48_META_API_1540_P0_D: "Valor de início da interpolação linear, que é devolvido quando o progresso da interpolação é 0.",
  T_48_META_API_1540_P1_D: "Valor-alvo da interpolação linear, que é devolvido quando o progresso da interpolação é 1",
  T_48_META_API_1540_P2_D: "Progresso da interpolação, o intervalo de valores [0,1], o valor de 0 para regressar ao valor inicial, o valor de 1 para regressar ao valor alvo, o valor de 0,5 para regressar à média do valor inicial e do valor alvo",
  T_48_META_API_1540_R_D: "Valor de retorno da interpolação linear",
  T_48_META_API_1541_D: "Limitar o intervalo do valor-alvo, obter o valor no meio das três entradas; o seu papel é limitar o valor-alvo ao intervalo especificado, o valor-alvo é mais pequeno do que o valor mínimo para regressar ao valor mais pequeno, maior do que o valor máximo p",
  T_48_META_API_1541_P0_D: "valor-alvo",
  T_48_META_API_1541_P1_D: "Valor mínimo do intervalo limite",
  T_48_META_API_1541_P2_D: "Valor máximo do intervalo limite",
  T_48_META_API_1541_R_D: "Valor de retorno após restrição",
  T_48_META_API_1542_D: "Obter os valores dos canais da cor alvo",
  T_48_META_API_1542_P0_D: "cor alvo",
  T_48_META_API_1542_P1_D: "Valor R da cor, no intervalo [0 , 255].",
  T_48_META_API_1542_P2_D: "Valor G da cor, intervalo [0 , 255].",
  T_48_META_API_1542_P3_D: "Valor B da cor, intervalo [0 , 255].",
  T_48_META_API_1542_P4_D: "Valor A da cor, no intervalo [0 , 255].",
  T_48_META_API_1543_D: "a operação de potência",
  T_48_META_API_1543_P0_D: "base",
  T_48_META_API_1543_P1_D: "expoentes",
  T_48_META_API_1543_R_D: "resultado do cálculo",
  T_48_META_API_1544_D: "operação logarítmica",
  T_48_META_API_1544_P0_D: "base",
  T_48_META_API_1544_P1_D: "logaritmo",
  T_48_META_API_1544_R_D: "resultado do cálculo",
  T_48_META_API_1545_D: "Vetor de direção para o ângulo de Euler",
  T_48_META_API_1545_P0_D: "vetor de direção",
  T_48_META_API_1545_R_D: "Ângulo de Euler",
  T_48_META_API_1546_D: "Vetor de direção de viragem do ângulo de Euler",
  T_48_META_API_1546_P0_D: "Ângulo de Euler",
  T_48_META_API_1546_R_D: "vetor de direção",
  T_48_META_API_1547_D: "número inteiro para número de vírgula flutuante",
  T_48_META_API_1547_P0_D: "número inteiro",
  T_48_META_API_1547_R_D: "ponto flutuante",
  T_48_META_API_1548_D: "Rodar o vetor alvo de acordo com o quaternário",
  T_48_META_API_1548_P0_D: "vetor alvo",
  T_48_META_API_1548_P1_D: "quaternião rotativo",
  T_48_META_API_1548_R_D: "vetor rodado",
  T_48_META_API_1549_D: "Converter número alvo em string",
  T_48_META_API_1549_P0_D: "Número de destino da cadeia a converter",
  T_48_META_API_1549_P1_D: "Formato da cadeia numérica de saída",
  T_48_META_API_1549_R_D: "string",
  T_48_META_API_1598_D: "Obter o carimbo de data/hora do servidor",
  T_48_META_API_1598_R_D: "Devolve o número de segundos a partir das 0:0:0 de 1 de janeiro de 1970",
  T_48_META_API_1599_D: "Obter área do servidor",
  T_48_META_API_1599_R_D: "Regressar às abreviaturas regionais (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Registos personalizados do enterro do utilizador para análise de dados da experiência do utilizador",
  T_48_META_API_16_P0_D: "Para manter o registo dos jogadores comunicados",
  T_48_META_API_16_P1_D: "Lista de nomes de campos a comunicar",
  T_48_META_API_16_P2_D: "Lista de valores de campo a reportar",
  T_48_META_API_1601_D: "Criar um dicionário",
  T_48_META_API_1601_R_D: "Dicionário criado",
  T_48_META_API_1602_D: "Obtém o valor correspondente à chave especificada no dicionário",
  T_48_META_API_1602_P0_D: "Dicionário de alvos",
  T_48_META_API_1602_P1_D: "Chave",
  T_48_META_API_1602_R_D: "Valor",
  T_48_META_API_1603_D: "Define o valor correspondente à chave especificada no dicionário",
  T_48_META_API_1603_P0_D: "Dicionário de alvos",
  T_48_META_API_1603_P1_D: "Chave",
  T_48_META_API_1603_P2_D: "Valor",
  T_48_META_API_1604_D: "Remove o par chave-valor especificado do dicionário",
  T_48_META_API_1604_P0_D: "Dicionário de alvos",
  T_48_META_API_1604_P1_D: "Chave",
  T_48_META_API_1605_D: "Limpa todos os pares de valores chave no dicionário",
  T_48_META_API_1605_P0_D: "Dicionário de alvos",
  T_48_META_API_1606_D: "Obtém o número de pares chave-valor no dicionário",
  T_48_META_API_1606_P0_D: "Dicionário de alvos",
  T_48_META_API_1606_R_D: "Comprimento do dicionário",
  T_48_META_API_1607_D: "Determinar se uma chave existe num dicionário",
  T_48_META_API_1607_P0_D: "Dicionário de alvos",
  T_48_META_API_1607_P1_D: "Chave",
  T_48_META_API_1607_R_D: "Existe?",
  T_48_META_API_1608_D: "Obtém todas as chaves do dicionário e devolve-as como uma lista.",
  T_48_META_API_1608_P0_D: "Dicionário de alvos",
  T_48_META_API_1608_R_D: "Lista de todos os valores-chave",
  T_48_META_API_17_D: "Use uma área de movimento linear em forma de caixa para detecção e retorne todas as entidades encontradas na rota da área em forma de caixa de perto para longe. Se estiverem inicialmente dentro do intervalo em forma de caixa, elas não serão detectadas; se os parâmetros hierárquicos forem preenchidos nos espaços em branco, eles poderão ser detectados no terreno.",
  T_48_META_API_17_P0_D: "Metade do comprimento dos três lados da região encaixotada, só são aceites valores positivos",
  T_48_META_API_17_P1_D: "Ponto central da área encaixotada",
  T_48_META_API_17_P2_D: "Rotação da área da caixa",
  T_48_META_API_17_P3_D: "Sentido da deslocação na área marcada",
  T_48_META_API_17_P4_D: "Distância percorrida na área em caixa, só são aceites valores positivos",
  T_48_META_API_17_P5_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_17_P6_D: "Se o acionamento pode ser detectado",
  T_48_META_API_17_P7_D: "Lista de entidades atingidas",
  T_48_META_API_1700_D: "Converter uma cadeia de caracteres num número inteiro",
  T_48_META_API_1700_P0_D: "cadeia de destino",
  T_48_META_API_1700_P1_D: "número inteiro resultante",
  T_48_META_API_1700_P2_D: "Se a conversão foi ou não bem sucedida",
  T_48_META_API_1701_D: "Converter uma cadeia de caracteres num número de vírgula flutuante",
  T_48_META_API_1701_P0_D: "cadeia de destino",
  T_48_META_API_1701_P1_D: "flutuador resultante",
  T_48_META_API_1701_P2_D: "Se a conversão foi ou não bem sucedida",
  T_48_META_API_18_D: "Use uma área esférica móvel em linha reta para detecção e retorne todas as entidades encontradas na rota da área esférica de perto para longe. Se elas estiverem inicialmente na área esférica, elas não serão detectadas se o parâmetro de nível for preenchido no espaço em branco; , o terreno pode ser detectado",
  T_48_META_API_18_P0_D: "Raio da região esférica, só são aceites valores positivos",
  T_48_META_API_18_P1_D: "ponto central da área esférica",
  T_48_META_API_18_P2_D: "Direção da viagem na área esférica",
  T_48_META_API_18_P3_D: "Distância de deslocação da área esférica, só são aceites valores positivos",
  T_48_META_API_18_P4_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_18_P5_D: "Se o acionamento pode ser detectado",
  T_48_META_API_18_P6_D: "Lista de entidades atingidas",
  T_48_META_API_19_D: "Use uma área de cápsula em movimento linear para detecção e retorne todas as entidades encontradas na rota da área da cápsula de perto para longe. Se elas estiverem inicialmente dentro da área da cápsula, elas não serão detectadas se o parâmetro de nível for preenchido; terreno pode ser detectado.",
  T_48_META_API_19_P0_D: "Raio do hemisfério em cada extremidade da região do corpo da cápsula, só são aceites valores positivos",
  T_48_META_API_19_P1_D: "A distância entre os centros esféricos dos hemisférios em cada extremidade da região do corpo da cápsula, que deve ser superior a duas vezes o raio dos hemisférios em cada extremidade",
  T_48_META_API_19_P2_D: "Ponto central da região do corpo da cápsula",
  T_48_META_API_19_P3_D: "Rotação da região do corpo da cápsula",
  T_48_META_API_19_P4_D: "Direção da viagem na região do corpo da cápsula",
  T_48_META_API_19_P5_D: "A distância percorrida na área da cápsula, apenas valores positivos são aceitos.",
  T_48_META_API_19_P6_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_19_P7_D: "Se o acionamento pode ser detectado",
  T_48_META_API_19_P8_D: "Lista de entidades atingidas",
  T_48_META_API_2_D: "Obtém todas as equipas no jogo atual e devolve a lista de equipas.",
  T_48_META_API_2_R_D: "Lista de equipas",
  T_48_META_API_20_D: "Use uma área estática em forma de caixa para detecção e retorne todas as entidades dentro da área em forma de caixa. Se o parâmetro de nível for preenchido nos espaços em branco, o terreno poderá ser detectado.",
  T_48_META_API_20_P0_D: "Metade do comprimento dos três lados da região encaixotada, só são aceites valores positivos",
  T_48_META_API_20_P1_D: "Ponto central da área encaixotada",
  T_48_META_API_20_P2_D: "Rotação da área da caixa",
  T_48_META_API_20_P3_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_20_P4_D: "Se o acionamento pode ser detectado",
  T_48_META_API_20_P5_D: "Lista de entidades atingidas",
  T_48_META_API_2000_D: "A definição do valor de um atributo da entidade de destino requer que o atributo já tenha sido definido.",
  T_48_META_API_2000_P0_D: "entidade-alvo",
  T_48_META_API_2000_P1_D: "Um atributo da entidade de destino",
  T_48_META_API_2000_P2_D: "O valor de destino, que tem de corresponder ao tipo exigido quando a propriedade foi definida",
  T_48_META_API_2000_P3_D: "Todos os tipos suportam atribuição, e os tipos numéricos suportam auto-adição, auto-menos, auto-multiplicação, auto-divisão e auto-restante.",
  T_48_META_API_2001_D: "Obter o valor de um atributo de uma entidade",
  T_48_META_API_2001_P0_D: "entidade-alvo",
  T_48_META_API_2001_P1_D: "O ID de um atributo desta entidade",
  T_48_META_API_2001_R_D: "valor de um atributo",
  T_48_META_API_2002: "Definir propriedade do gráfico",
  T_48_META_API_2002_D: "Definir variáveis de script",
  T_48_META_API_2002_P0_D: "entidade-alvo",
  T_48_META_API_2002_P1: "ID do gráfico",
  T_48_META_API_2002_P1_D: "ID do script de destino",
  T_48_META_API_2002_P2: "ID da propriedade",
  T_48_META_API_2002_P2_D: "ID da propriedade membro definida no script",
  T_48_META_API_2002_P3: "Valor da propriedade",
  T_48_META_API_2002_P3_D: "O valor de destino, que tem de corresponder ao tipo exigido quando a propriedade foi definida",
  T_48_META_API_2002_P4_D: "Todos os tipos suportam atribuição, e os tipos numéricos suportam auto-adição, auto-menos, auto-multiplicação, auto-divisão e auto-restante.",
  T_48_META_API_2003: "Obter Propriedade do Gráfico",
  T_48_META_API_2003_D: "Obter variáveis de script",
  T_48_META_API_2003_P0_D: "entidade-alvo",
  T_48_META_API_2003_P1: "ID do gráfico",
  T_48_META_API_2003_P1_D: "ID do script de destino",
  T_48_META_API_2003_P2: "ID da propriedade",
  T_48_META_API_2003_P2_D: "ID do atributo de destino",
  T_48_META_API_2003_R_D: "valor de um atributo",
  T_48_META_API_2004_D: "Definir e inicializar uma variável local, cujo âmbito vai desde a posição de declaração até ao fim do bloco de instruções em que se encontra.",
  T_48_META_API_2004_P0_D: "nome da variável",
  T_48_META_API_2004_P1_D: "valor inicial da variável",
  T_48_META_API_2004_P2_D: "Tipo de declaração de variável, a atribuição tem de corresponder ao tipo declarado",
  T_48_META_API_2005_D: "Define o valor de uma variável local, cujo âmbito vai desde a posição de declaração até ao fim do bloco de expressões em que está localizada.",
  T_48_META_API_2005_P0_D: "nome da variável",
  T_48_META_API_2005_P1: "Valor Variável",
  T_48_META_API_2005_P1_D: "valor variável",
  T_48_META_API_2005_P2_D: "Todos os tipos suportam atribuição, e os tipos numéricos suportam auto-adição, auto-menos, auto-multiplicação, auto-divisão e auto-restante.",
  T_48_META_API_2006: "Obter variável local",
  T_48_META_API_2006_D: "Obtém o valor de uma variável local, cujo âmbito vai desde a posição de declaração até ao fim do bloco de instruções.",
  T_48_META_API_2006_P0: "Nome da Variável",
  T_48_META_API_2006_P0_D: "nome da variável",
  T_48_META_API_2006_R_D: "valor variável",
  T_48_META_API_2009: "Encontre e invoque a API personalizada global com serial",
  T_48_META_API_2009_D: "Chama funções personalizadas globais de forma serial e, se houver uma espera na função personalizada, o local de chamada também espera",
  T_48_META_API_2009_P0: "ID do gráfico",
  T_48_META_API_2009_P0_D: "ID do script onde reside a função personalizada",
  T_48_META_API_2009_P1: "ID da função",
  T_48_META_API_2009_P1_D: "ID da função personalizada chamada",
  T_48_META_API_2009_P2_D: "Lista de argumentos passados para a função personalizada",
  T_48_META_API_2010: "Encontre e invoque a API personalizada global com o Parallel",
  T_48_META_API_2010_D: "Chama as funções personalizadas globais de forma paralela, regressando imediatamente ao local de chamada para continuar na linha, independentemente de haver ou não uma espera na função personalizada",
  T_48_META_API_2010_P0: "ID do gráfico",
  T_48_META_API_2010_P0_D: "ID do script onde reside a função personalizada",
  T_48_META_API_2010_P1: "ID da função",
  T_48_META_API_2010_P1_D: "ID da função personalizada chamada",
  T_48_META_API_2010_P2_D: "Lista de argumentos passados para a função personalizada",
  T_48_META_API_2013: "Definir Propriedade do Autográfico",
  T_48_META_API_2013_D: "Definir variáveis para o script atual",
  T_48_META_API_2013_P0: "ID da propriedade",
  T_48_META_API_2013_P0_D: "ID do atributo de destino",
  T_48_META_API_2013_P1: "Valor da propriedade",
  T_48_META_API_2013_P1_D: "valor-alvo",
  T_48_META_API_2013_P2_D: "Todos os tipos suportam atribuição, e os tipos numéricos suportam auto-adição, auto-menos, auto-multiplicação, auto-divisão e auto-restante.",
  T_48_META_API_2014: "Obter Propriedade Self Graph",
  T_48_META_API_2014_D: "Obter variáveis para o script atual",
  T_48_META_API_2014_P0: "ID da propriedade",
  T_48_META_API_2014_P0_D: "ID do atributo de destino",
  T_48_META_API_2014_R_D: "valor de um atributo",
  T_48_META_API_21_D: "Use uma área esférica estática para detecção e retorne todas as entidades dentro da área esférica. Se o parâmetro de nível for preenchido nos espaços em branco, o terreno poderá ser detectado.",
  T_48_META_API_21_P0_D: "Raio da região esférica, só são aceites valores positivos",
  T_48_META_API_21_P1_D: "ponto central da área esférica",
  T_48_META_API_21_P2_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_21_P3_D: "Se o acionamento pode ser detectado",
  T_48_META_API_21_P4_D: "Lista de entidades atingidas",
  T_48_META_API_22_D: "Use uma área de cápsula estática para detecção e retorne todas as entidades dentro da área de cápsula. Se o parâmetro de nível for preenchido, o terreno poderá ser detectado.",
  T_48_META_API_22_P0_D: "Raio do hemisfério em cada extremidade da região do corpo da cápsula, só são aceites valores positivos",
  T_48_META_API_22_P1_D: "A distância entre os centros esféricos dos hemisférios em cada extremidade da região do corpo da cápsula, que deve ser superior a duas vezes o raio dos hemisférios em cada extremidade",
  T_48_META_API_22_P2_D: "Ponto central da região do corpo da cápsula",
  T_48_META_API_22_P3_D: "Rotação da região do corpo da cápsula",
  T_48_META_API_22_P4_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_22_P5_D: "Se o acionamento pode ser detectado",
  T_48_META_API_22_P6_D: "Lista de entidades atingidas",
  T_48_META_API_23_D: "Definir o estado do item especial para o jogador, os itens especiais só podem ter um",
  T_48_META_API_23_P0_D: "jogador",
  T_48_META_API_23_P1_D: "ID do item",
  T_48_META_API_23_P2_D: "Se o item deve ser ativado",
  T_48_META_API_23_P3_D: "substância especial",
  T_48_META_API_24_D: "Aplicar uma força ao alvo, que deve ser um objeto físico.",
  T_48_META_API_24_P0_D: "objeto físico alvo",
  T_48_META_API_24_P1_D: "vetor de força",
  T_48_META_API_24_P2_D: "Tipo de força",
  T_48_META_API_25_D: "Aplicar uma força uma vez num ponto, o alvo deve ser um corpo rígido",
  T_48_META_API_25_P0_D: "corpo rígido de destino",
  T_48_META_API_25_P1_D: "vetor de força",
  T_48_META_API_25_P2_D: "Posição de aplicação da força",
  T_48_META_API_25_P3_D: "Tipo de força",
  T_48_META_API_26_D: "Aplicar um binário ao alvo, que deve ser rígido.",
  T_48_META_API_26_P0_D: "corpo rígido de destino",
  T_48_META_API_26_P1_D: "torção",
  T_48_META_API_26_P2_D: "Tipo de força aplicada",
  T_48_META_API_27_D: "Mover o corpo rígido de destino para a posição especificada",
  T_48_META_API_27_P0_D: "corpo rígido de destino",
  T_48_META_API_27_P1_D: "local designado",
  T_48_META_API_28_D: "Rodar o corpo rígido de destino",
  T_48_META_API_28_P0_D: "corpo rígido de destino",
  T_48_META_API_28_P1_D: "quaternião rotativo",
  T_48_META_API_29_D: "Cria um movimento interpolado onde as propriedades especificadas da entidade alvo são suavizadas de acordo com as configurações.",
  T_48_META_API_29_P0_D: "entidade-alvo",
  T_48_META_API_29_P1_D: "IDs de atributos que requerem alterações de movimento",
  T_48_META_API_29_P2_D: "Valor inicial do atributo",
  T_48_META_API_29_P3_D: "Valor final do atributo",
  T_48_META_API_29_P4_D: "Você pode escolher entre simples, loop e reciprocante. Loop significa que, após a conclusão de cada movimento, a entidade se moverá novamente a partir do valor inicial. Reciprocante significa que, após a conclusão do movimento do valor inicial para o valor alvo, a entidade se moverá do valor alvo para o valor inicial novamente e, em seguida, repetirá o processo.",
  T_48_META_API_29_P5_D: "Ponto de controlo da curva de Bessel",
  T_48_META_API_29_P6_D: "Duração de uma alteração em milissegundos",
  T_48_META_API_29_P7_D: "Criação de entidades de movimento interpoladas",
  T_48_META_API_29_P8_D: "Se a reprodução começa automaticamente após a criação",
  T_48_META_API_3_D: "Ao mudar o jogo para a fase de destino, o turno é também uma fase especial. Ao mudar para uma fase numa ronda, a contagem da ronda é 0.",
  T_48_META_API_3_P0_D: "Índice de rondas ou fases alvo",
  T_48_META_API_30_D: "Força o jogador alvo a entrar no veículo especificado",
  T_48_META_API_30_P0_D: "jogador-alvo",
  T_48_META_API_30_P1_D: "entidade transportadora",
  T_48_META_API_30_P2_D: "Número do lugar",
  T_48_META_API_30_P3_D: "O facto de conseguir ou não levar o jogador para o transportador",
  T_48_META_API_3001_D: "Fazer o jogador alvo descartar um item",
  T_48_META_API_3001_P0_D: "jogador-alvo",
  T_48_META_API_3001_P1_D: "entidade física",
  T_48_META_API_3002_D: "Obtém as coordenadas disponíveis dentro do ponto de nascimento aleatório atualmente disponível que não está totalmente ocupado (obsoleto, por favor use GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "Jogadores a quem deve ser atribuída uma área de ponto de nascimento",
  T_48_META_API_3002_R_D: "Coordenadas de pontos aleatórios atribuídas aleatoriamente",
  T_48_META_API_3003_D: "Obtém a pontuação total do jogador para o tipo de ponto especificado",
  T_48_META_API_3003_P0_D: "jogador",
  T_48_META_API_3003_P1_D: "Tipo de pontos",
  T_48_META_API_3003_R_D: "valor do ponto",
  T_48_META_API_3004_D: "Definir a pontuação da ronda para o tipo de ponto especificado de um jogador",
  T_48_META_API_3004_P0_D: "entidade jogadora",
  T_48_META_API_3004_P1_D: "Tipo de pontos",
  T_48_META_API_3004_P2_D: "valor do ponto",
  T_48_META_API_3005_D: "Obter a pontuação total da equipa para o tipo de ponto especificado",
  T_48_META_API_3005_P0_D: "entidade da equipa",
  T_48_META_API_3005_P1_D: "Tipo de pontos",
  T_48_META_API_3005_R_D: "valor do ponto",
  T_48_META_API_3006_D: "Definir a pontuação da ronda para o tipo de ponto especificado de uma equipa",
  T_48_META_API_3006_P0_D: "entidade da equipa",
  T_48_META_API_3006_P1_D: "Tipo de pontos",
  T_48_META_API_3006_P2_D: "valor do ponto",
  T_48_META_API_3007_D: "Obter a pontuação do jogador para a ronda e o tipo de ponto especificados",
  T_48_META_API_3007_P0_D: "entidade jogadora",
  T_48_META_API_3007_P1_D: "Índice redondo",
  T_48_META_API_3007_P2_D: "Tipo de pontos",
  T_48_META_API_3007_R_D: "valor do ponto",
  T_48_META_API_3008_D: "Obter a pontuação da equipa para a ronda especificada, tipo de ponto",
  T_48_META_API_3008_P0_D: "entidade da equipa",
  T_48_META_API_3008_P1_D: "Índice redondo",
  T_48_META_API_3008_P2_D: "Tipo de pontos",
  T_48_META_API_3008_R_D: "valor do ponto",
  T_48_META_API_3009_D: "Obter a classificação geral do jogo do jogador",
  T_48_META_API_3009_P0_D: "entidade jogadora",
  T_48_META_API_3009_R_D: "posição numa classificação de nomes",
  T_48_META_API_3011_D: "Obter a classificação geral do jogo da equipa",
  T_48_META_API_3011_P0_D: "abandonado",
  T_48_META_API_3011_R_D: "posição numa classificação de nomes",
  T_48_META_API_3013_D: "Obter a classificação do jogador para uma determinada ronda",
  T_48_META_API_3013_P0_D: "entidade jogadora",
  T_48_META_API_3013_P1_D: "Índice redondo",
  T_48_META_API_3013_R_D: "posição numa classificação de nomes",
  T_48_META_API_3014_D: "Obter classificações das equipas para uma determinada ronda",
  T_48_META_API_3014_P0_D: "abandonado",
  T_48_META_API_3014_P1_D: "Índice redondo",
  T_48_META_API_3014_R_D: "posição numa classificação de nomes",
  T_48_META_API_3015_D: "Obter a carteira da entidade de destino",
  T_48_META_API_3015_P0_D: "entidade-alvo",
  T_48_META_API_3015_P1_D: "Presença de uma carteira",
  T_48_META_API_3015_P2_D: "Entidades de carteira adquiridas",
  T_48_META_API_3016_D: "Cria uma carteira para o jogador alvo, não é válido se o jogador já tiver uma carteira.",
  T_48_META_API_3016_P0_D: "jogador-alvo",
  T_48_META_API_3016_P1_D: "Entidade vinculada à carteira, proprietário da carteira",
  T_48_META_API_3016_P2_D: "entidade de carteira",
  T_48_META_API_3017_D: "Adicionar moeda a uma carteira específica",
  T_48_META_API_3017_P0_D: "Carteira de destino",
  T_48_META_API_3017_P1_D: "Tipo de moeda adicionada",
  T_48_META_API_3017_P2_D: "Aumento do número de moedas",
  T_48_META_API_3018_D: "Redução da moeda para uma determinada carteira",
  T_48_META_API_3018_P0_D: "Carteira de destino",
  T_48_META_API_3018_P1_D: "Tipo de moeda reduzida",
  T_48_META_API_3018_P2_D: "Redução do número de moedas",
  T_48_META_API_3019_D: "Transferir moeda de uma carteira para outra carteira",
  T_48_META_API_3019_P0_D: "Carteira para transferência de moeda",
  T_48_META_API_3019_P1_D: "Tipos de dinheiro transferidos",
  T_48_META_API_3019_P2_D: "Número de moedas transferidas",
  T_48_META_API_3019_P3_D: "Carteira para a qual a moeda é transferida",
  T_48_META_API_3020_D: "Obter o número de moedas de um determinado tipo numa determinada carteira",
  T_48_META_API_3020_P0_D: "Carteira de destino",
  T_48_META_API_3020_P1_D: "Tipo de moeda do pedido de informação",
  T_48_META_API_3020_R_D: "Montante da moeda",
  T_48_META_API_3021_D: "Obtém as entidades do tipo de moeda especificado na carteira especificada",
  T_48_META_API_3021_P0_D: "Carteira de destino",
  T_48_META_API_3021_P1_D: "Tipo de moeda do pedido de informação",
  T_48_META_API_3021_R_D: "Entidades monetárias",
  T_48_META_API_3022_D: "Obtém todas as lojas do jogo e devolve-as como uma lista",
  T_48_META_API_3022_R_D: "Lista de entidades da loja",
  T_48_META_API_3023_D: "Substitui a forma do jogador alvo pela forma de um objeto de cena especificado.",
  T_48_META_API_3023_P0_D: "jogador-alvo",
  T_48_META_API_3023_P1_D: "Objetos de cena de destino para substituição",
  T_48_META_API_3023_P2_D: "Substituição do componente de camuflagem de transformação do jogador criado após o",
  T_48_META_API_3024_D: "Cancela o estado de camuflagem do jogador",
  T_48_META_API_3024_P0_D: "jogador-alvo",
  T_48_META_API_3025_D: "Criar um alter ego com a forma de uma entidade de cena no jogador alvo",
  T_48_META_API_3025_P0_D: "jogador-alvo",
  T_48_META_API_3025_P1_D: "Entidades de cena para imagens divididas",
  T_48_META_API_3025_P2_D: "Entidades de bilocação criadas",
  T_48_META_API_3026_D: "Obter a entidade camuflada do jogador",
  T_48_META_API_3026_P0_D: "jogador",
  T_48_META_API_3026_R_D: "Entidade de disfarce de jogador",
  T_48_META_API_3027_D: "Obter a entidade do canal de conversação por índice",
  T_48_META_API_3027_P0_D: "Índice do canal de conversação, intervalo [1,8]",
  T_48_META_API_3027_R_D: "Entidades do canal de conversação",
  T_48_META_API_3028_D: "Obtém a entidade do canal de chat em que o jogador especificado está atualmente",
  T_48_META_API_3028_P0_D: "jogador-alvo",
  T_48_META_API_3028_R_D: "Entidades do canal de conversação",
  T_48_META_API_3029_D: "Permite que os jogadores entrem no canal de conversação designado e mudem para o canal alvo quando os jogadores já estão noutros canais de conversação.",
  T_48_META_API_3029_P0_D: "jogador-alvo",
  T_48_META_API_3029_P1_D: "Entidades do canal de conversação",
  T_48_META_API_3030_D: "Faz com que o jogador saia do canal em que está atualmente, e fica num estado em que não está em nenhum canal de conversação depois disso",
  T_48_META_API_3030_P0_D: "jogador-alvo",
  T_48_META_API_3031_D: "abandonado",
  T_48_META_API_3031_P0_D: "Entidade do canal de conversação, vazia quando não há nenhum jogador no canal",
  T_48_META_API_3032_D: "Definir o estado comportamental do jogador",
  T_48_META_API_3032_P0_D: "jogador-alvo",
  T_48_META_API_3032_P1_D: "Tipos de comportamento do jogador",
  T_48_META_API_3032_P2_D: `Ativar: o botão do HUD está disponível, normalmente utilizável
 Desativar: o botão do HUD está desativado, não é possível aceder ao estado comportamental ativa ou passivamente
 Mascarado: o botão do HUD está oculto, não é possível aceder ao estado compo`,
  T_48_META_API_3033_D: "O jogador transforma-se num objeto num determinado cenário",
  T_48_META_API_3033_P0_D: "jogador-alvo",
  T_48_META_API_3033_P1_D: "objeto a ser transformado em",
  T_48_META_API_3033_P2_D: "Entidades criadas após a transformação",
  T_48_META_API_3034_D: "O jogador cria um alter ego com a sua própria aparência",
  T_48_META_API_3034_P0_D: "jogador-alvo",
  T_48_META_API_3034_P1_D: "Criação de entidades de alter ego",
  T_48_META_API_3035_D: "Criar uma loja personalizada com prateleiras como o nível seguinte da loja",
  T_48_META_API_3035_P0_D: "Entidades de loja criadas",
  T_48_META_API_3036_D: "Criar uma prateleira personalizada em que o nível superior da prateleira é a loja e o nível inferior são os produtos",
  T_48_META_API_3036_P0_D: "Entidades de prateleira criadas",
  T_48_META_API_3037_D: "Criar um produto personalizado, o produto pode adicionar itens",
  T_48_META_API_3037_P0_D: "Entidades de produtos de base criadas",
  T_48_META_API_3038_D: "A adição de itens a um produto permite-lhe adicionar vários itens a um produto utilizando o elemento várias vezes.",
  T_48_META_API_3038_P0_D: "Entidades de produtos de base",
  T_48_META_API_3038_P1_D: "Itens a acrescentar",
  T_48_META_API_3038_P2_D: "Número de itens",
  T_48_META_API_3039_D: "Dar recompensas pelo Jailbreak",
  T_48_META_API_3039_P0_D: "entidade jogadora",
  T_48_META_API_3039_P1_D: "quantidades",
  T_48_META_API_3039_P2_D: "dinheiro real",
  T_48_META_API_3040_D: "Tarefas de jailbreak actualizadas",
  T_48_META_API_3040_P0_D: "entidade jogadora",
  T_48_META_API_3040_P1_D: "ID da tarefa",
  T_48_META_API_3040_P2_D: "estar em serviço",
  T_48_META_API_3041_D: "Obtém as coordenadas de um ponto de nascimento aleatório, apenas a partir dos pontos de nascimento disponíveis que não estejam totalmente ocupados.",
  T_48_META_API_3041_P0_D: "jogador-alvo",
  T_48_META_API_3041_R_D: "Randomiza as coordenadas do ponto de nascimento; se não houver nenhum ponto de nascimento que corresponda aos critérios, devolverá uma localização próxima de (0, 0, 0).",
  T_48_META_API_3042_D: "Sair do jogo Jailbreak",
  T_48_META_API_3042_P0_D: "entidade jogadora",
  T_48_META_API_3042_P1_D: "ID da tarefa",
  T_48_META_API_3043_D: "Baseado em adereços de jailbreak",
  T_48_META_API_3043_P0_D: "entidade jogadora",
  T_48_META_API_3043_P1_D: "Tipo de adereços",
  T_48_META_API_3043_P2_D: "ID dos adereços",
  T_48_META_API_31_D: "Cria um movimento relativo a si próprio, em que a entidade alvo muda de cada vez em relação aos seus valores de atributos actuais",
  T_48_META_API_31_P0_D: "entidade-alvo",
  T_48_META_API_31_P1_D: "Propriedades que requerem alterações de movimento",
  T_48_META_API_31_P2_D: "Montante da alteração por movimento",
  T_48_META_API_31_P3_D: "Ponto de controlo da curva de Bessel",
  T_48_META_API_31_P4_D: `Simples: o movimento pára quando o atributo muda o valor Delta 
 Cíclico: o movimento é repetido, de cada vez que o atributo muda o valor Delta`,
  T_48_META_API_31_P5_D: "Duração de uma alteração em milissegundos",
  T_48_META_API_31_P6_D: "Entidades criadas que se deslocam relativamente a si próprias",
  T_48_META_API_31_P7_D: "Se a reprodução começa automaticamente após a criação",
  T_48_META_API_3100_D: "O alvo reproduz a animação no estado especificado",
  T_48_META_API_3100_P0_D: "Componentes de entidades que reproduzem animações com controladores de animação montáveis",
  T_48_META_API_3100_P1_D: "O estado especificado do controlador de animação",
  T_48_META_API_3100_P2_D: "Escalonamento da velocidade de reprodução de animações",
  T_48_META_API_3100_P3_D: "Tipo de loop, pode manter a lógica original da animação, reproduzi-la apenas uma vez ou repeti-la.",
  T_48_META_API_3101_D: "Reproduzir animação de personagens, suportar recursos de animação personalizados",
  T_48_META_API_3101_P0_D: "jogador-alvo",
  T_48_META_API_3101_P1_D: "ID do recurso de animação personalizada",
  T_48_META_API_3101_P2_D: "Se deve ou não efetuar um loop",
  T_48_META_API_3102_D: "Definir os recursos de personagem para um determinado jogador",
  T_48_META_API_3102_P0_D: "jogador-alvo",
  T_48_META_API_3102_P1_D: "ID de recurso de função personalizada",
  T_48_META_API_3109_D: "A ligação suaviza o movimento até ao fim da zona de segurança",
  T_48_META_API_3109_P0_D: "Posição inicial da zona de segurança",
  T_48_META_API_3109_P1_D: "Localização do fim da zona de segurança",
  T_48_META_API_3109_P2_D: "Raio inicial da zona de segurança",
  T_48_META_API_3109_P3_D: "Raio final da zona de segurança",
  T_48_META_API_3109_P4_D: "Tempo em segundos para que a zona de segurança atinja o seu estado final",
  T_48_META_API_3109_P5_D: "Quantidade de danos por segundo sofridos fora da zona de segurança",
  T_48_META_API_3110_D: "Mudança de grupos de aparência de caracteres",
  T_48_META_API_3110_P0_D: "objectivos",
  T_48_META_API_3110_P1_D: "Grupo de Aparência",
  T_48_META_API_3111_D: "Grupo de Aparência de Funções de Espetáculo",
  T_48_META_API_3111_P0_D: "objectivos",
  T_48_META_API_3111_P1_D: "Grupo de Aparência",
  T_48_META_API_3112_D: "Grupo de aparência de caracteres ocultos",
  T_48_META_API_3112_P0_D: "objectivos",
  T_48_META_API_3112_P1_D: "Grupo de Aparência",
  T_48_META_API_3121_D: "Envio de resultados de asserção para o Craftland Studio PC para uso estatístico",
  T_48_META_API_3121_P0_D: "expressão de afirmação",
  T_48_META_API_3121_P1_D: "chamar a atenção para algo",
  T_48_META_API_32_D: "Obter os dados do token de hoje do jogador",
  T_48_META_API_32_P0_D: "jogador-alvo",
  T_48_META_API_32_P1_D: "ID da ficha",
  T_48_META_API_32_P2_D: "Número de fichas",
  T_48_META_API_32_P3_D: "Se a tupla foi ou não invocada com êxito",
  T_48_META_API_3200_D: "Adiciona itens ao jogador e devolve uma lista de itens emitidos",
  T_48_META_API_3200_P0_D: "jogador",
  T_48_META_API_3200_P1_D: "ID do item",
  T_48_META_API_3200_P2_D: "Número de itens",
  T_48_META_API_3200_P3_D: "Uma lista de itens adicionados para o jogador, mesmo que apenas um item seja adicionado, é devolvido como uma lista.",
  T_48_META_API_3201_D: "Restaura o sangue do jogador designado sem exceder o limite de sangue",
  T_48_META_API_3201_P0_D: "jogador-alvo",
  T_48_META_API_3201_P1_D: "Um valor que adiciona sangue ao jogador, só são aceites números positivos",
  T_48_META_API_3202_D: "Definir a lista de habilidades do jogador alvo",
  T_48_META_API_3202_P0_D: "jogador-alvo",
  T_48_META_API_3202_P1_D: "Lista de competências",
  T_48_META_API_3203_D: "Obter uma lista das habilidades do jogador alvo",
  T_48_META_API_3203_P0_D: "jogador-alvo",
  T_48_META_API_3203_R_D: "Lista de competências",
  T_48_META_API_3205_D: "Eliminar um determinado número de itens do jogador",
  T_48_META_API_3205_P0_D: "jogador-alvo",
  T_48_META_API_3205_P1_D: "Tipo de item a ser eliminado",
  T_48_META_API_3205_P2_D: "O número de objectos a eliminar; se exceder o número de objectos na posse do jogador, apenas os objectos na posse serão eliminados.",
  T_48_META_API_3206_D: "Obter o número especificado de itens de um jogador",
  T_48_META_API_3206_P0_D: "jogador-alvo",
  T_48_META_API_3206_P1_D: "Tipo de artigo",
  T_48_META_API_3206_R_D: "Número de participações de jogadores",
  T_48_META_API_3207_D: "Detetar se o jogador pode ativar o ponto de controlo atual",
  T_48_META_API_3207_P0_D: "jogador-alvo",
  T_48_META_API_3207_P1_D: "Gatilho",
  T_48_META_API_3207_R_D: "Verdadeiro: pode ser acionado, Falso: não pode ser acionado",
  T_48_META_API_3208_D: "Modo de Infeção Zombie Evolution",
  T_48_META_API_3208_P0_D: "jogador-alvo",
  T_48_META_API_3209_D: "A entidade de IA pára/força a árvore de comportamento padrão",
  T_48_META_API_3209_P0_D: "Para permitir o objetivo da árvore comportamental",
  T_48_META_API_3209_P1_D: "Se deve ser implementada a árvore de comportamento por defeito",
  T_48_META_API_3210_D: "Entidade de IA que persegue um alvo designado",
  T_48_META_API_3210_P0_D: "Entidades de IA que realizam actividades",
  T_48_META_API_3210_P1_D: "objetivo",
  T_48_META_API_3211_D: "Destruir objectos do jogador (obsoleto, utilizar DeleteEquipment)",
  T_48_META_API_3211_P0_D: "O jogador cujo objeto foi destruído",
  T_48_META_API_3211_P1_D: "Tipo de objeto destruído",
  T_48_META_API_3211_P2_D: "Ranhura para arma, apenas para arma.",
  T_48_META_API_3212_D: "Mudar de camisola",
  T_48_META_API_3212_P0_D: "jogador-alvo",
  T_48_META_API_3212_P1_D: "Estilo de vestuário",
  T_48_META_API_3212_P2_D: "Cores principais I",
  T_48_META_API_3212_P3_D: "Cor principal II",
  T_48_META_API_3212_P4_D: "configurar",
  T_48_META_API_3213_D: "Repor a camisola do jogador no seu estado original",
  T_48_META_API_3213_P0_D: "jogador-alvo",
  T_48_META_API_3214_D: "Bate-papo por voz do jogador do Switch",
  T_48_META_API_3214_P0_D: "jogador-alvo",
  T_48_META_API_3214_P1_D: "Se deve fechar a conversação por voz, Verdadeiro:Fechar Falso:Abrir",
  T_48_META_API_3215_D: "Bate-papo rápido com o jogador de troca",
  T_48_META_API_3215_P0_D: "jogador-alvo",
  T_48_META_API_3215_P1_D: "Se deve fechar a Conversa rápida, Verdadeiro:Fechar Falso:Abrir",
  T_48_META_API_3216_D: "Definir se o jogador alvo pode apanhar objectos",
  T_48_META_API_3216_P0_D: "jogador-alvo",
  T_48_META_API_3216_P1_D: "Se é ou não proibido apanhar objectos, true: é proibido apanhar false: é permitido apanhar",
  T_48_META_API_3217_D: "Definir se o jogador alvo pode descartar itens",
  T_48_META_API_3217_P0_D: "jogador-alvo",
  T_48_META_API_3217_P1_D: "Se é ou não proibido deixar cair objectos, verdadeiro: apanhar é proibido falso: apanhar é possível",
  T_48_META_API_3218_D: "Destrói uma arma no espaço designado pelo jogador",
  T_48_META_API_3218_P0_D: "jogador-alvo",
  T_48_META_API_3218_P1_D: "Slots de armas a destruir",
  T_48_META_API_3218_P2_D: "Número a destruir",
  T_48_META_API_3218_P3_D: "Destruição bem sucedida ou não, a destruição falha se nenhuma arma estiver equipada na ranhura da arma",
  T_48_META_API_3219_D: "Esvazia a mochila do jogador alvo de todos os itens, incluindo itens equipados.",
  T_48_META_API_3219_P0_D: "jogador-alvo",
  T_48_META_API_3220_D: "Definir a orientação do jogador",
  T_48_META_API_3220_P0_D: "jogador-alvo",
  T_48_META_API_3220_P1_D: "Orientação do jogador",
  T_48_META_API_3221_D: "<Player>(obsoleto, não utilizar, ver atributo :Skeleton para informações)",
  T_48_META_API_3221_P0_D: "entidade jogadora",
  T_48_META_API_3221_P1_D: "área de zoom",
  T_48_META_API_3221_P2_D: "valor de zoom",
  T_48_META_API_3222_D: "Conferir um efeito de empurrão a um jogador, o jogador alvo vai cair com uma aceleração fixa e o empurrão será parado forçosamente após uma colisão no ar",
  T_48_META_API_3222_P0_D: "jogador-alvo",
  T_48_META_API_3222_P1_D: "Direção de eliminação",
  T_48_META_API_3222_P2_D: "tempo de atropelamento e fuga",
  T_48_META_API_3222_P3_D: "Velocidade inicial do eixo Y no momento do impacto",
  T_48_META_API_3222_P4_D: "Velocidade inicial no plano XZ no momento do impacto",
  T_48_META_API_3222_P5_D: "Alterar ou não a orientação do jogador",
  T_48_META_API_3223_D: "Obter o ID do traje do jogador ou NPC alvo",
  T_48_META_API_3223_P0_D: "Jogador ou NPC alvo",
  T_48_META_API_3223_P1_D: "Tipo de vestuário",
  T_48_META_API_3223_R_D: "ID do vestuário",
  T_48_META_API_3224_D: "Definir o ID do traje do jogador ou NPC alvo",
  T_48_META_API_3224_P0_D: "Jogador ou NPC alvo",
  T_48_META_API_3224_P1_D: "ID do vestuário",
  T_48_META_API_3225_D: "Restaura a roupa padrão do jogador alvo, não pode ser aplicada a NPCs.",
  T_48_META_API_3225_P0_D: "jogador-alvo",
  T_48_META_API_3226_D: "Entidade de IA ataca alvo designado",
  T_48_META_API_3226_P0_D: "A entidade de IA que efectua o ataque",
  T_48_META_API_3226_P1_D: "objetivo",
  T_48_META_API_3227_D: "Troca a arma do jogador para a arma no espaço especificado",
  T_48_META_API_3227_P0_D: "jogador-alvo",
  T_48_META_API_3227_P1_D: "Ranhura da arma a ser trocada",
  T_48_META_API_3227_P2_D: "Quer a troca seja bem sucedida ou não, a troca falhará se não houver nenhuma arma equipada na ranhura da arma.",
  T_48_META_API_3228_D: "Obter skins de armas para jogadores ou NPCs alvo",
  T_48_META_API_3228_P0_D: "Jogador ou NPC alvo",
  T_48_META_API_3228_P1_D: "ID da pele da arma",
  T_48_META_API_3228_R_D: "ID da pele da arma",
  T_48_META_API_3229_D: "Definir a skin da arma do jogador ou NPC alvo",
  T_48_META_API_3229_P0_D: "Jogador ou NPC alvo",
  T_48_META_API_3229_P1_D: "ID da pele da arma",
  T_48_META_API_3230_D: "Restaura a skin de arma padrão do jogador alvo, que não pode ser aplicada a NPCs.",
  T_48_META_API_3230_P0_D: "jogador-alvo",
  T_48_META_API_3230_P1_D: "ID da arma",
  T_48_META_API_3231_D: "Configurar o fato do jogador",
  T_48_META_API_3231_P0_D: "jogador-alvo",
  T_48_META_API_3231_P1_D: "Lista de vestuário",
  T_48_META_API_3232_D: "Remove todos os trajes do tipo de traje especificado do jogador ou NPC alvo",
  T_48_META_API_3232_P0_D: "Jogador ou NPC alvo",
  T_48_META_API_3232_P1_D: "Tipo de vestuário",
  T_48_META_API_3233_D: "Remover a pele da arma designada de um jogador ou NPC",
  T_48_META_API_3233_P0_D: "Jogador ou NPC alvo",
  T_48_META_API_3233_P1_D: "ID da arma",
  T_48_META_API_3234_D: "Adiciona buffs ao alvo",
  T_48_META_API_3234_P0_D: "Entidade-alvo, deve ser uma entidade à qual podem ser adicionados buffs",
  T_48_META_API_3234_P1_D: "ID do búfalo",
  T_48_META_API_3235_D: "Remover os catalisadores do alvo",
  T_48_META_API_3235_P0_D: "Entidade-alvo, deve ser uma entidade à qual podem ser adicionados buffs",
  T_48_META_API_3235_P1_D: "ID do búfalo",
  T_48_META_API_3236_D: "Obter o buff atual do alvo",
  T_48_META_API_3236_P0_D: "Entidade-alvo, deve ser uma entidade à qual podem ser adicionados buffs",
  T_48_META_API_3236_R_D: "Lista de buffs",
  T_48_META_API_3237_D: "Obtém os itens na barra de adereços da mochila do jogador alvo.",
  T_48_META_API_3237_P0_D: "jogador-alvo",
  T_48_META_API_3237_P1_D: "Lista de adereços",
  T_48_META_API_3238_D: "Adiciona acessórios ao slot especificado da arma, os acessórios que não corresponderem ao slot falharão; os acessórios correspondentes mas duplicados substituirão os acessórios originais, os acessórios originais serão enviados para a mochila do jogador e,",
  T_48_META_API_3238_P0_D: "jogador-alvo",
  T_48_META_API_3238_P1_D: "ranhura da barra de equipamento",
  T_48_META_API_3238_P2_D: "substituição (peças)",
  T_48_META_API_3238_P3_D: `Se o acessório foi ou não adicionado com sucesso
 Verdadeiro: o acessório foi equipado com a arma na ranhura correspondente
 Falso: o acessório não foi adicionado e não aparecerá na mochila do jogador`,
  T_48_META_API_3238_P4_D: "Acessórios adicionados, nulos em caso de falha",
  T_48_META_API_3239_D: "Obter o equipamento na coluna do equipamento da mochila",
  T_48_META_API_3239_P0_D: "jogador-alvo",
  T_48_META_API_3239_P1_D: "ranhura da barra de equipamento",
  T_48_META_API_3239_P2_D: "Equipamento na ranhura especificada, vazio se não estiver equipado",
  T_48_META_API_3239_P3_D: "Todos os acessórios para este equipamento",
  T_48_META_API_3240_D: "Um vetor 2D tem a componente x",
  T_48_META_API_3240_P0_D: "vetor bidimensional",
  T_48_META_API_3240_R_D: "Componente x do vetor 2D",
  T_48_META_API_3241_D: "Os vectores bidimensionais tomam a componente y",
  T_48_META_API_3241_P0_D: "vetor bidimensional",
  T_48_META_API_3241_R_D: "Componente Y de um vetor 2D",
  T_48_META_API_3242_D: "Definição do vetor 2D componente x",
  T_48_META_API_3242_P0_D: "vetor bidimensional",
  T_48_META_API_3242_P1_D: "Componente x do vetor 2D",
  T_48_META_API_3243_D: "Definição do vetor 2D componente y",
  T_48_META_API_3243_P0_D: "vetor bidimensional",
  T_48_META_API_3243_P1_D: "Componente Y de um vetor 2D",
  T_48_META_API_3244_D: "Adicionar dois vectores 2D",
  T_48_META_API_3244_P0_D: "Valor esquerdo",
  T_48_META_API_3244_P1_D: "Valor direito",
  T_48_META_API_3244_R_D: "Resultado da soma vetorial 2D",
  T_48_META_API_3245_D: "Subtrair dois vectores 2D",
  T_48_META_API_3245_P0_D: "Valor esquerdo",
  T_48_META_API_3245_P1_D: "Valor direito",
  T_48_META_API_3245_R_D: "Resultado da subtração do vetor 2D",
  T_48_META_API_3246_D: "Multiplicar os vectores bidimensionais por",
  T_48_META_API_3246_P0_D: "vetor bidimensional",
  T_48_META_API_3246_P1_D: "Valores de escala do vetor 2D",
  T_48_META_API_3246_R_D: "Resultado da multiplicação de vectores 2D",
  T_48_META_API_3247_D: "Multiplicação por pontos de dois vectores 2D, o resultado da multiplicação por pontos é um escalar que caracteriza o ângulo entre os dois vectores",
  T_48_META_API_3247_P0_D: "Valor esquerdo",
  T_48_META_API_3247_P1_D: "Valor direito",
  T_48_META_API_3247_R_D: "Resultado do produto escalar",
  T_48_META_API_3248_D: "Calcular a distância euclidiana entre dois vectores 2D",
  T_48_META_API_3248_P0_D: "Valor esquerdo",
  T_48_META_API_3248_P1_D: "Valor direito",
  T_48_META_API_3248_R_D: "Após a subtração de dois vectores, o módulo do vetor resultante",
  T_48_META_API_3249_D: "Calcular o ângulo entre dois vectores 2D",
  T_48_META_API_3249_P0_D: "Valor esquerdo",
  T_48_META_API_3249_P1_D: "Valor direito",
  T_48_META_API_3249_R_D: "Ângulo vetorial, gama de ângulos 0-180",
  T_48_META_API_3250_D: "Normalizar o vetor 2D",
  T_48_META_API_3250_P0_D: "vetor bidimensional",
  T_48_META_API_3250_R_D: "Resultado normalizado para vectores com comprimento de 1 m na mesma direção que o vetor",
  T_48_META_API_3251_D: "Modelação de um vetor 2D",
  T_48_META_API_3251_P0_D: "vetor bidimensional",
  T_48_META_API_3251_R_D: "O resultado da modelação, como um vetor de comprimento",
  T_48_META_API_3252_D: "Calcular o vetor de um vetor 2D após reflexão por uma reta normal vertical",
  T_48_META_API_3252_P0_D: "vetor 2D incidente",
  T_48_META_API_3252_P1_D: "Vetor normal 2D",
  T_48_META_API_3252_R_D: "Vetor 2D refletor",
  T_48_META_API_3253_D: "Cálculo de vectores 3D após reflexão por um plano vertical normal",
  T_48_META_API_3253_P0_D: "vetor 3D incidente",
  T_48_META_API_3253_P1_D: "Vetor 3D normal",
  T_48_META_API_3253_R_D: "vetor 3D refletor",
  T_48_META_API_3254_D: "Converter um vetor 3D num vetor 2D, remover o componente Z do vetor 3D",
  T_48_META_API_3254_P0_D: "Vetor 3D alvo",
  T_48_META_API_3254_R_D: "Vetor 2D convertido",
  T_48_META_API_3255_D: "Vetor 2D para vetor 3D, o componente Z do vetor 3D é definido como 0",
  T_48_META_API_3255_P0_D: "Vetor 2D alvo",
  T_48_META_API_3255_R_D: "Vetor 3D convertido",
  T_48_META_API_3256_D: "Criar um vetor 2D",
  T_48_META_API_3256_P0_D: "A componente x de um vetor 2D",
  T_48_META_API_3256_P1_D: "Componente Y de um vetor 2D",
  T_48_META_API_3256_R_D: "O vetor 2D criado",
  T_48_META_API_3257_D: "Registos de enterro de concursos personalizados para análise de dados da experiência do utilizador",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Registos de enterro de concursos personalizados para análise de dados da experiência do utilizador",
  T_48_META_API_3258_P0_D: "Para manter o registo dos jogadores comunicados",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "filtros para palavrões",
  T_48_META_API_33_P0_D: "Texto original que requer filtragem de palavrões",
  T_48_META_API_33_R_D: "Texto filtrado",
  T_48_META_API_3301_D: "Criar uma entidade de acampamento",
  T_48_META_API_3301_P0_D: "Entidades formadoras",
  T_48_META_API_3302_D: "A entidade-alvo junta-se ao campo designado",
  T_48_META_API_3302_P0_D: "entidade-alvo",
  T_48_META_API_3302_P1_D: "Entidades formadoras",
  T_48_META_API_3303_D: "Obter campos para campos atacáveis",
  T_48_META_API_3303_P0_D: "campo de ataque",
  T_48_META_API_3303_R_D: "Lista de entidades do campo",
  T_48_META_API_3304_D: "Campos atacáveis para montar acampamentos",
  T_48_META_API_3304_P0_D: "campo de ataque",
  T_48_META_API_3304_P1_D: "campo alvo",
  T_48_META_API_3304_P2_D: "Capacidade de ataque",
  T_48_META_API_3305_D: "Definir jogadores atacáveis",
  T_48_META_API_3305_P0_D: "jogador",
  T_48_META_API_3305_P1_D: "Jogadores atacáveis",
  T_48_META_API_3305_P2_D: "Capacidade de ataque",
  T_48_META_API_3306_D: "Definir a equipa atacável da equipa",
  T_48_META_API_3306_P0_D: "equipa de ataque",
  T_48_META_API_3306_P1_D: "grupo-alvo",
  T_48_META_API_3306_P2_D: "Capacidade de ataque",
  T_48_META_API_3307_D: "abandonado",
  T_48_META_API_3307_P0_D: "abandonado",
  T_48_META_API_3307_R_D: "Lista de entidades de jogadores",
  T_48_META_API_3308_D: "Retirada da entidade designada do campo atual",
  T_48_META_API_3308_P0_D: "entidade-alvo",
  T_48_META_API_3309_D: "Campo de aquisição do objetivo",
  T_48_META_API_3309_P0_D: "entidade-alvo",
  T_48_META_API_3309_R_D: "Entidades formadoras",
  T_48_META_API_3310_D: "Determinar se o alvo pode ser atacado",
  T_48_META_API_3310_P0_D: "agressores",
  T_48_META_API_3310_P1_D: "entidade-alvo",
  T_48_META_API_3310_R_D: "Capacidade de ataque",
  T_48_META_API_3311_D: "Definição dos alvos atacáveis de uma entidade",
  T_48_META_API_3311_P0_D: "agressores",
  T_48_META_API_3311_P1_D: "entidade-alvo",
  T_48_META_API_3311_P2_D: "Capacidade de ataque",
  T_48_META_API_3312_D: "Aquisição de alvos atacáveis de uma entidade",
  T_48_META_API_3312_P0_D: "agressores",
  T_48_META_API_3312_R_D: "Lista de entidades atacáveis",
  T_48_META_API_34_D: "Determinar se existe um componente para a entidade de destino",
  T_48_META_API_34_P0_D: "entidade-alvo",
  T_48_META_API_34_P1_D: "Tipo de componente",
  T_48_META_API_34_R_D: "Existe?",
  T_48_META_API_35_D: "Adicionar bot",
  T_48_META_API_35_P0_D: "Nível de dificuldade do bot",
  T_48_META_API_35_P1_D: "A equipa do Bot",
  T_48_META_API_35_P2_D: "Entidade de jogador bot criada",
  T_48_META_API_3500_D: "Obter dados do token de jogador",
  T_48_META_API_3500_P0_D: "jogador-alvo",
  T_48_META_API_3500_P1_D: "ID da ficha",
  T_48_META_API_3500_P2_D: "Número de fichas",
  T_48_META_API_3500_P3_D: "sucesso ou fracasso",
  T_48_META_API_3501_D: "Adicionar dados de fichas ao leitor",
  T_48_META_API_3501_P0_D: "jogador-alvo",
  T_48_META_API_3501_P1_D: "ID da ficha",
  T_48_META_API_3501_P2_D: "Número de fichas",
  T_48_META_API_3501_P3_D: "Se a tupla foi ou não invocada com êxito",
  T_48_META_API_3502_D: "Consumir ficha de jogador alvo",
  T_48_META_API_3502_P0_D: "jogador-alvo",
  T_48_META_API_3502_P1_D: "ID da ficha",
  T_48_META_API_3502_P2_D: "Número de fichas",
  T_48_META_API_3502_P3_D: "Se a tupla foi ou não invocada com êxito",
  T_48_META_API_3503_D: "Adicionar um token à localização especificada",
  T_48_META_API_3503_P0_D: "colocação",
  T_48_META_API_3503_P1_D: "ID da ficha",
  T_48_META_API_3503_P2_D: "Número de fichas",
  T_48_META_API_3503_P3_D: "Se a tupla foi ou não invocada com êxito",
  T_48_META_API_3504_D: "A IA alvo liberta a habilidade especificada",
  T_48_META_API_3504_P0_D: "Alvo IA",
  T_48_META_API_3504_P1_D: "técnica",
  T_48_META_API_3504_P2_D: "alvo de competências",
  T_48_META_API_3504_P3_D: "Se a competência foi ou não libertada com êxito",
  T_48_META_API_3505_D: "Cria percursos de orientação do início ao fim que contornam os blocos e podem ser utilizados para a orientação da IA",
  T_48_META_API_3505_P0_D: "coordenadas do ponto de partida",
  T_48_META_API_3505_P1_D: "coordenadas do destino",
  T_48_META_API_3505_P2_D: "Se o percurso de determinação do trajeto foi ou não estabelecido com êxito",
  T_48_META_API_3505_P3_D: "Conjunto de pontos de controlo de trajetória",
  T_48_META_API_3506_D: "Definição da variável do quadro da árvore comportamental",
  T_48_META_API_3506_P0_D: "Árvore de comportamentos-alvo",
  T_48_META_API_3506_P1_D: "nome da variável",
  T_48_META_API_3506_P2_D: "valor variável",
  T_48_META_API_3507_D: "Obter variáveis do quadro da árvore comportamental",
  T_48_META_API_3507_P0_D: "Árvore de comportamentos-alvo",
  T_48_META_API_3507_P1_D: "nome da variável",
  T_48_META_API_3507_P2_D: "valor variável",
  T_48_META_API_3508_D: "Obter parâmetros de nós de árvores comportamentais",
  T_48_META_API_3508_P0_D: "Nós da árvore de comportamento alvo",
  T_48_META_API_3508_P1_D: "nome do parâmetro",
  T_48_META_API_3508_P2_D: "valor do parâmetro",
  T_48_META_API_3509_D: "Obter a skin de transporte do jogador alvo",
  T_48_META_API_3509_P0_D: "jogador-alvo",
  T_48_META_API_3509_P1_D: "Identificação da transportadora",
  T_48_META_API_3509_R_D: "Pele de suporte",
  T_48_META_API_3510_D: "Definir a skin de transporte do jogador alvo",
  T_48_META_API_3510_P0_D: "jogador-alvo",
  T_48_META_API_3510_P1_D: "Identificação da pele do portador",
  T_48_META_API_3511_D: "Limpar a pele do veículo especificado do jogador alvo",
  T_48_META_API_3511_P0_D: "jogador-alvo",
  T_48_META_API_3511_P1_D: "Identificação da transportadora",
  T_48_META_API_3512_D: "Restaurar a skin de transporte predefinida do jogador alvo",
  T_48_META_API_3512_P0_D: "jogador-alvo",
  T_48_META_API_3512_P1_D: "Identificação da transportadora",
  T_48_META_API_36_D: "Alvo dormente, só pode ser utilizado para corpos rígidos do tipo Dinâmico.",
  T_48_META_API_36_P0_D: "corpo rígido de destino",
  T_48_META_API_37_D: "Alvo de despertar, só pode ser utilizado em corpos rígidos do tipo Dinâmico.",
  T_48_META_API_37_P0_D: "corpo rígido de destino",
  T_48_META_API_38_D: "Verificar se o corpo rígido de destino está inativo",
  T_48_META_API_38_P0_D: "corpo rígido de destino",
  T_48_META_API_38_R_D: "Se está ou não a hibernar",
  T_48_META_API_39_D: "Definir o limiar de hibernação",
  T_48_META_API_39_P0_D: "corpo rígido de destino",
  T_48_META_API_39_P1_D: "Limiar de dormência, o movimento e a rotação do corpo rígido são inferiores a este valor durante um período de tempo para entrar no estado de dormência, o estado de dormência do corpo rígido deixará de efetuar cálculos físicos",
  T_48_META_API_4_D: "Definir se todos os jogadores podem mover-se",
  T_48_META_API_4_P0_D: `Verdadeiro: pode ser deslocado 
 Falso: não pode ser deslocado`,
  T_48_META_API_40_D: "Obter o limiar de hibernação",
  T_48_META_API_40_P0_D: "corpo rígido de destino",
  T_48_META_API_40_R_D: "Limiar de dormência, o movimento e a rotação do corpo rígido são inferiores a este valor durante um período de tempo para entrar no estado de dormência, o estado de dormência do corpo rígido deixará de efetuar cálculos físicos",
  T_48_META_API_4000_D: "Lê o conteúdo de toda a tabela e devolve uma matriz bidimensional por ordem de linha",
  T_48_META_API_4000_P0_D: "nome da tabela",
  T_48_META_API_4000_R_D: "Conteúdo do quadro",
  T_48_META_API_4001_D: "Lê uma linha de uma tabela e devolve uma matriz",
  T_48_META_API_4001_P0_D: "nome da tabela",
  T_48_META_API_4001_P1_D: "Número de linhas a ler, a contar de 1",
  T_48_META_API_4001_R_D: "Tabela especifica o conteúdo de uma linha",
  T_48_META_API_4002_D: "Lê o conteúdo de uma coluna de uma tabela e devolve uma matriz",
  T_48_META_API_4002_P0_D: "nome da tabela",
  T_48_META_API_4002_P1_D: "Número de colunas a ler, a contar de 1",
  T_48_META_API_4002_R_D: "A tabela especifica o conteúdo de uma coluna",
  T_48_META_API_4003_D: "Ler o conteúdo de uma célula numa tabela",
  T_48_META_API_4003_P0_D: "nome da tabela",
  T_48_META_API_4003_P1_D: "Número de linhas a ler, a contar de 1",
  T_48_META_API_4003_P2_D: "Número de colunas a ler, a contar de 1",
  T_48_META_API_4003_R_D: "O conteúdo da célula especificada da tabela",
  T_48_META_API_4004_D: "Ler o conteúdo de uma célula numa tabela por nome de linha e coluna",
  T_48_META_API_4004_P0_D: "nome da tabela",
  T_48_META_API_4004_P1_D: "Número de linhas a ler, a contar de 1",
  T_48_META_API_4004_P2_D: "O nome da coluna a ler",
  T_48_META_API_4004_R_D: "O conteúdo da célula especificada da tabela",
  T_48_META_API_4005_D: "Lê o conteúdo de toda a tabela e devolve uma matriz bidimensional",
  T_48_META_API_4005_P0_D: "nome da tabela",
  T_48_META_API_4005_R_D: "O conteúdo da tabela, uma matriz bidimensional",
  T_48_META_API_4006_D: "Lê uma linha de uma tabela e devolve uma matriz.",
  T_48_META_API_4006_P0_D: "nome da tabela",
  T_48_META_API_4006_P1_D: "Número de linhas a ler, a contar de 1",
  T_48_META_API_4006_R_D: "A tabela especifica o conteúdo de uma linha, uma matriz",
  T_48_META_API_4007_D: "Lê o conteúdo de uma coluna de toda a tabela e devolve a matriz",
  T_48_META_API_4007_P0_D: "nome da tabela",
  T_48_META_API_4007_P1_D: "Número de colunas a ler, a contar de 1",
  T_48_META_API_4007_R_D: "A tabela especifica o conteúdo de uma coluna, matriz",
  T_48_META_API_4008_D: "Ler o conteúdo de uma célula numa tabela",
  T_48_META_API_4008_P0_D: "nome da tabela",
  T_48_META_API_4008_P1_D: "Número de linhas a ler, a contar de 1",
  T_48_META_API_4008_P2_D: "Número de colunas a ler, a contar de 1",
  T_48_META_API_4008_R_D: "O conteúdo da célula especificada da tabela",
  T_48_META_API_4009_D: "Localiza a linha especificada pelo número de colunas e o valor da célula.",
  T_48_META_API_4009_P0_D: "nome da tabela",
  T_48_META_API_4009_P1_D: "Número de colunas a ler",
  T_48_META_API_4009_P2_D: "Valor da célula a procurar",
  T_48_META_API_4009_R_D: "Conteúdo das linhas encontradas, matriz",
  T_48_META_API_4010_D: "Obter o número da coluna pelo nome da coluna",
  T_48_META_API_4010_P0_D: "nome da tabela",
  T_48_META_API_4010_P1_D: "Nome da coluna para procurar o número de série",
  T_48_META_API_4010_R_D: "Colunas, a contar de 1",
  T_48_META_API_41_D: "Define o limiar de suspensão global, válido apenas para corpos rígidos do tipo Dinâmico gerados recentemente.",
  T_48_META_API_41_P0_D: "Limiar de dormência, o movimento e a rotação do corpo rígido são inferiores a este valor durante um período de tempo para entrar no estado de dormência, o estado de dormência do corpo rígido deixará de efetuar cálculos físicos",
  T_48_META_API_42_D: "Obter o limiar de hibernação global",
  T_48_META_API_42_R_D: "Limiar de dormência, a predefinição é 0,005, o movimento e a rotação do corpo rígido é inferior a este valor durante um período de tempo para entrar no estado de dormência, o corpo rígido dormente deixará de efetuar cálculos físicos",
  T_48_META_API_43_D: "Converte o quaternion dado num ângulo de Euler, a ordem de rotação do ângulo de Euler é YXZ, se o quaternion de entrada não for legal, devolve (0,0,0)",
  T_48_META_API_43_P0_D: "O quaternário de entrada",
  T_48_META_API_43_R_D: "Ângulos de Euler devolvidos",
  T_48_META_API_44_D: "Conversão de um determinado ângulo de Euler num quaternião",
  T_48_META_API_44_P0_D: "Ângulos de Euler de entrada",
  T_48_META_API_44_R_D: "Quaternião devolvido",
  T_48_META_API_45_D: "Conversão de rotações de representações de ângulos axiais em quaterniões",
  T_48_META_API_45_P0_D: "eixo de rotação",
  T_48_META_API_45_P1_D: "Ângulo de rotação no sentido dos ponteiros do relógio em torno do eixo de rotação",
  T_48_META_API_45_R_D: "Quaternião devolvido",
  T_48_META_API_46_D: "Conversão de quaterniões em representações de ângulos axiais",
  T_48_META_API_46_P0_D: "O quaternário de entrada",
  T_48_META_API_46_P1_D: "eixo de rotação",
  T_48_META_API_46_P2_D: "Ângulo de rotação no sentido dos ponteiros do relógio em torno do eixo de rotação",
  T_48_META_API_47_D: "Configurar o progresso personalizado da conclusão da tarefa",
  T_48_META_API_47_P0_D: "jogador-alvo",
  T_48_META_API_47_P1_D: "ID da tarefa",
  T_48_META_API_47_P2_D: "Progresso em direção à conclusão, não são permitidos números negativos",
  T_48_META_API_48_D: "Cria uma curva de Bezier que pode ser utilizada para interpolar o movimento",
  T_48_META_API_48_P0_D: "ponto de controlo da curva",
  T_48_META_API_48_R_D: "Curva de Bessel",
  T_48_META_API_49_D: "Obter ID do mapa de cena",
  T_48_META_API_49_P0_D: "ID da cena",
  T_48_META_API_49_R_D: "ID do mapa",
  T_48_META_API_5_D: "Eliminar objectos colocados na cena (obsoleto, utilizar DeleteEntity)",
  T_48_META_API_5_P0_D: "Entidades de objeto a eliminar",
  T_48_META_API_50_D: "Cria movimento relativo a si mesmo a cada quadro, com a entidade alvo alterando seus próprios atributos uma vez por quadro, cada vez relativo aos seus valores de atributos atuais",
  T_48_META_API_50_P0_D: "entidade-alvo",
  T_48_META_API_50_P1_D: "Propriedades que requerem alterações de movimento",
  T_48_META_API_50_P2_D: "Montante da alteração por movimento",
  T_48_META_API_50_P3_D: `Configuração quando utilizado em combinação com outros modos de movimento
 Verdadeiro: pode ser utilizado em combinação com movimento relativo
 Falso: pode ser utilizado em combinação com movimento absoluto`,
  T_48_META_API_50_P4_D: "Criação de entidades de movimento por fotograma relativamente a si próprias",
  T_48_META_API_50_P5_D: "Se a reprodução começa automaticamente após a criação",
  T_48_META_API_5000_D: "Ler o valor correspondente a uma chave numa tabela da base de dados.",
  T_48_META_API_5000_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5000_P1_D: "Marcação de jogadores, gestão da concorrência",
  T_48_META_API_5000_P2_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5000_P3_D: "Devolve o resultado da leitura",
  T_48_META_API_5000_P4_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5001_D: "Escrever o valor correspondente a uma chave numa tabela da base de dados.",
  T_48_META_API_5001_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5001_P1_D: "Marcação de jogadores, gestão da concorrência",
  T_48_META_API_5001_P2_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5001_P3_D: "Valor escrito",
  T_48_META_API_5001_P4_D: "O código do campo de batalha correspondente ao banco de dados, que pode ser preenchido em branco, representa o código do campo de batalha do mapa atual",
  T_48_META_API_5002_D: "Eliminar o valor correspondente a uma chave numa tabela da base de dados.",
  T_48_META_API_5002_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5002_P1_D: "Marcação de jogadores, gestão da concorrência",
  T_48_META_API_5002_P2_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5002_P3_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5003_D: "Recuperar o valor de uma chave numa tabela da base de dados.",
  T_48_META_API_5003_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_5003_P1_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5003_P2_D: "Devolve o resultado da leitura",
  T_48_META_API_5003_P3_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5004_D: "Escreva o valor correspondente a uma chave numa das tabelas de gráficos da base de dados.",
  T_48_META_API_5004_P0_D: "Nome da tabela de classificação na base de dados",
  T_48_META_API_5004_P1_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5004_P2_D: "Valor escrito",
  T_48_META_API_5004_P3_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5005_D: "Eliminar o valor correspondente a uma chave numa tabela de gráficos na base de dados.",
  T_48_META_API_5005_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5005_P1_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5005_P2_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5006_D: "Eliminar o valor correspondente a uma classificação numa tabela de classificação na base de dados.",
  T_48_META_API_5006_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5006_P1_D: "Classificação na tabela de classificação",
  T_48_META_API_5006_P2_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5007_D: "Ler os valores de uma determinada classificação para uma determinada classificação numa tabela de gráficos na base de dados.",
  T_48_META_API_5007_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5007_P1_D: "posição inicial",
  T_48_META_API_5007_P2_D: "posição final",
  T_48_META_API_5007_P3_D: "Devolve o resultado da leitura",
  T_48_META_API_5007_P4_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5008_D: "Ler o valor correspondente a uma chave numa tabela da base de dados cumulativa.",
  T_48_META_API_5008_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5008_P1_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5008_P2_D: "Devolve o resultado da leitura",
  T_48_META_API_5008_P3_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_5009_D: "Escrever o valor de desvio correspondente a uma chave numa tabela da base de dados cumulativa",
  T_48_META_API_5009_P0_D: "Nomes de tabelas na base de dados",
  T_48_META_API_5009_P1_D: "Nome personalizado utilizado para identificar os dados",
  T_48_META_API_5009_P2_D: "Os tipos das quatro operações suportam atualmente os seguintes tipos: o tipo Int suporta a adição, a subtração, a multiplicação, a divisão e o resto; o tipo Float suporta a adição, a subtração, a multiplicação e a divisão",
  T_48_META_API_5009_P3_D: "Valor de desvio escrito",
  T_48_META_API_5009_P4_D: "Código de campo de batalha correspondente à base de dados",
  T_48_META_API_51_D: "Repor entidade reproduzível, repõe a entidade reproduzível na sua forma inicial sem alterar o estado de reprodução",
  T_48_META_API_51_P0_D: "Entidade Jogável Alvo",
  T_48_META_API_52_D: "Multiplicar dois quaterniões, A*B, significa rodar A e depois B. Uma ordem de rotação diferente conduzirá a um resultado diferente.",
  T_48_META_API_52_P0_D: "quaternião com valor à esquerda",
  T_48_META_API_52_P1_D: "quaternião com valor correto",
  T_48_META_API_52_R_D: "Quaternião resultante",
  T_48_META_API_53_D: "Cria um quaternário rotativo voltado para uma direção especificada",
  T_48_META_API_53_P0_D: "indicar a direção",
  T_48_META_API_53_P1_D: "para cima",
  T_48_META_API_53_R_D: "A quantidade de rotação necessária para alinhar na direção especificada.",
  T_48_META_API_54_D: "Interpolação esférica quaterniónica de A para B",
  T_48_META_API_54_P0_D: "Valor A",
  T_48_META_API_54_P1_D: "Valor B",
  T_48_META_API_54_P2_D: "Progresso da interpolação, o intervalo de valores [0,1], o valor de 0 para regressar ao início do valor, o valor de 1 para regressar ao valor-alvo",
  T_48_META_API_54_R_D: "Quaternião resultante",
  T_48_META_API_57_D: "Imprime os dados do alvo como um aviso na consola",
  T_48_META_API_57_P0_D: "O que imprimir",
  T_48_META_API_58_D: "Imprime os dados de destino na consola como uma mensagem de erro.",
  T_48_META_API_58_P0_D: "O que imprimir",
  T_48_META_API_59_D: "Obter o valor na curva",
  T_48_META_API_59_P0_D: "de uma forma indireta",
  T_48_META_API_59_P1_D: "Ponto de amostragem, intervalo de valores [0,1]",
  T_48_META_API_59_R_D: "no final",
  T_48_META_API_6_D: "Cria objectos de cena nas coordenadas especificadas",
  T_48_META_API_6_P0_D: "Entidades de objectos de cena criadas",
  T_48_META_API_6_P1_D: "Localização da geração de objectos",
  T_48_META_API_6_P2_D: "O ID do tipo de objeto criado, que tem de ser previamente registado no registo de activos para utilização em scripts de código.",
  T_48_META_API_60_D: "Interpolação baseada em curvas",
  T_48_META_API_60_P0_D: "tipo de valor",
  T_48_META_API_60_P1_D: "valor inicial",
  T_48_META_API_60_P2_D: "valor-alvo",
  T_48_META_API_60_P3_D: "de uma forma indireta",
  T_48_META_API_60_P4_D: "Ponto de amostragem, intervalo de valores [0,1]",
  T_48_META_API_60_R_D: "no final",
  T_48_META_API_6000_D: "Adicionar scripts a entidades de destino",
  T_48_META_API_6000_P0_D: "entidade-alvo",
  T_48_META_API_6000_P1_D: "ID do guião",
  T_48_META_API_6001_D: "Descarregamento de scripts para entidades de destino",
  T_48_META_API_6001_P0_D: "entidade-alvo",
  T_48_META_API_6001_P1_D: "ID do guião",
  T_48_META_API_6002_D: "Verifica se o script especificado existe para a entidade de destino",
  T_48_META_API_6002_P0_D: "entidade-alvo",
  T_48_META_API_6002_P1_D: "ID do guião",
  T_48_META_API_6002_R_D: "Existência do guião especificado",
  T_48_META_API_61_D: "Definir o nó pai de um controlo da IU",
  T_48_META_API_61_P0_D: "Nó parente, pode especificar o controlo da IU ou a IU personalizada",
  T_48_META_API_61_P1_D: "nó filho",
  T_48_META_API_62_D: "abandonado",
  T_48_META_API_62_P0_D: "abandonado",
  T_48_META_API_62_P1_D: "abandonado",
  T_48_META_API_62_P2_D: "abandonado",
  T_48_META_API_62_P3_D: "abandonado",
  T_48_META_API_62_P4_D: "abandonado",
  T_48_META_API_63_D: "Criar um raio da câmara atual para o ponto de toque do ecrã",
  T_48_META_API_63_P0_D: "contacto do ecrã",
  T_48_META_API_63_P1_D: "limiar",
  T_48_META_API_63_P2_D: "direção do raio",
  T_48_META_API_64_D: "Carregar informações de faturação personalizadas",
  T_48_META_API_64_P0_D: "entidade jogadora",
  T_48_META_API_64_P1_D: "resultados de um concurso",
  T_48_META_API_64_P2_D: "título integral (informática)",
  T_48_META_API_64_P3_D: "valor do ponto",
  T_48_META_API_65_D: "Reproduz o efeito sonoro especificado e define as suas propriedades de entidade se tiver mais propriedades para definir.",
  T_48_META_API_65_P0_D: "Entidades sonoras criadas",
  T_48_META_API_65_P1_D: "Jogador alvo, apenas o jogador alvo pode ouvir os efeitos sonoros",
  T_48_META_API_65_P2_D: "Tipo de efeito sonoro",
  T_48_META_API_65_P3_D: "Tipo de laço",
  T_48_META_API_65_P4_D: "Jogar ou não jogar imediatamente",
  T_48_META_API_66_D: "Cria o efeito visual especificado e define seus atributos de entidade se houver mais atributos a serem definidos.",
  T_48_META_API_66_P0_D: "Entidades de efeitos especiais criadas",
  T_48_META_API_66_P1_D: "Jogadores visados, visíveis apenas para os jogadores visados",
  T_48_META_API_66_P2_D: "Tipo de efeito especial",
  T_48_META_API_66_P3_D: "Tipo de laço",
  T_48_META_API_66_P4_D: "Jogar ou não jogar imediatamente",
  T_48_META_API_67_D: "Cria o efeito sonoro especificado e define suas propriedades de entidade se houver mais propriedades a serem definidas.",
  T_48_META_API_67_P0_D: "Entidades sonoras criadas",
  T_48_META_API_67_P1_D: "Tipo de efeito sonoro",
  T_48_META_API_67_P2_D: "Tipo de laço",
  T_48_META_API_67_P3_D: "Jogar ou não jogar imediatamente",
  T_48_META_API_68_D: "Coordenadas do mundo convertidas em coordenadas do ecrã",
  T_48_META_API_68_P0_D: "coordenada mundial",
  T_48_META_API_68_P1_D: "Se está ou não mapeado no ecrã",
  T_48_META_API_68_P2_D: "posição cartográfica",
  T_48_META_API_69_D: "Coordenadas do ecrã para coordenadas do mundo",
  T_48_META_API_69_P0_D: "coordenada do ecrã",
  T_48_META_API_69_P1_D: "Distância do ecrã",
  T_48_META_API_69_P2_D: "coordenada mundial",
  T_48_META_API_7_D: "Converter o valor alvo em string",
  T_48_META_API_7_P0_D: "O valor de destino da cadeia a converter",
  T_48_META_API_7_R_D: "string",
  T_48_META_API_70_D: "A deteção de raios por toque no ecrã devolve a primeira entidade atingida",
  T_48_META_API_70_P0_D: "Ecrã inicial Contactos",
  T_48_META_API_70_P1_D: "Distância de deteção",
  T_48_META_API_70_P2_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_70_P3_D: "Se o acionamento pode ser detectado",
  T_48_META_API_70_P4_D: "entidade atingida",
  T_48_META_API_70_P5_D: "coordenadas do ponto de impacto",
  T_48_META_API_70_P6_D: "Distância do ponto de acerto ao ponto de partida",
  T_48_META_API_70_P7_D: "atingir a normal de superfície",
  T_48_META_API_71_D: "Deteção de raios por toque no ecrã, devolve todas as entidades atingidas",
  T_48_META_API_71_P0_D: "Ecrã inicial Contactos",
  T_48_META_API_71_P1_D: "Distância de deteção",
  T_48_META_API_71_P2_D: "Máscara de camada, apenas as camadas preenchidas participarão na digitalização; deixá-la em branco significa que todas as camadas participam na digitalização",
  T_48_META_API_71_P3_D: "Se o acionamento pode ser detectado",
  T_48_META_API_71_P4_D: "Lista de entidades atingidas",
  T_48_META_API_71_P5_D: "Lista de coordenadas de pontos de impacto",
  T_48_META_API_71_P6_D: "Lista de distâncias entre o ponto de ataque e o ponto inicial",
  T_48_META_API_71_P7_D: "Lista de normais de superfície atingidas",
  T_48_META_API_72_D: "Cria o efeito visual especificado e define seus atributos de entidade se houver mais atributos a serem definidos.",
  T_48_META_API_72_P0_D: "Entidades de efeitos especiais criadas",
  T_48_META_API_72_P1_D: "Tipo de efeito especial",
  T_48_META_API_72_P2_D: "Tipo de laço",
  T_48_META_API_72_P3_D: "Jogar ou não jogar imediatamente",
  T_48_META_API_73_D: "Criar uma IU incorporada que não seja sincronizada com outros clientes",
  T_48_META_API_73_P0_D: "Entidades de IU incorporadas criadas",
  T_48_META_API_73_P1_D: "Tipos de IU incorporados",
  T_48_META_API_74_D: "Criar uma IU personalizada que não seja sincronizada com outros clientes",
  T_48_META_API_74_P0_D: "Criação de entidades de IU personalizadas",
  T_48_META_API_74_P1_D: "Índice da IU personalizada",
  T_48_META_API_75_D: "Obter o jogador correspondente do cliente atual",
  T_48_META_API_75_R_D: "entidade jogadora",
  T_48_META_API_76_D: "Criar monstros de IA",
  T_48_META_API_76_P0_D: "Alvo IA",
  T_48_META_API_76_P1_D: "Criar localização",
  T_48_META_API_76_P2_D: "Tipo de IA",
  T_48_META_API_76_P3_D: "equipa afiliada",
  T_48_META_API_76_P4_D: "se deve ou não reivindicar automaticamente o inimigo",
  T_48_META_API_76_P5_D: "modo de ataque",
  T_48_META_API_76_P6_D: "Itinerário de viagem",
  T_48_META_API_77_D: "Definir o primeiro componente do vetor",
  T_48_META_API_77_P0_D: "vectores",
  T_48_META_API_77_P1_D: "Valor do primeiro componente",
  T_48_META_API_77_R_D: "Vetor depois de modificar o primeiro componente",
  T_48_META_API_78_D: "Definir o segundo componente do vetor",
  T_48_META_API_78_P0_D: "vectores",
  T_48_META_API_78_P1_D: "Valor do segundo componente",
  T_48_META_API_78_R_D: "Vetor depois de modificar o segundo componente",
  T_48_META_API_79_D: "Definir o terceiro componente do vetor",
  T_48_META_API_79_P0_D: "vectores",
  T_48_META_API_79_P1_D: "Valor do terceiro componente",
  T_48_META_API_79_R_D: "Vetor depois de modificar o terceiro componente",
  T_48_META_API_8_D: "Abrir a zona de segurança que se reduz ao ponto de coordenadas central.",
  T_48_META_API_8_P0_D: "Ponto central da zona de segurança",
  T_48_META_API_8_P1_D: "Raio da zona de segurança",
  T_48_META_API_8_P2_D: "Tempo de espera em segundos, no fim do qual a zona de segurança começará a diminuir em direção ao ponto central",
  T_48_META_API_8_P3_D: "Tempo necessário para que a zona de segurança diminua até ao ponto central, em segundos",
  T_48_META_API_8_P4_D: "Quantidade de danos por segundo sofridos fora da zona de segurança",
  T_48_META_API_80_D: "Definir o primeiro componente do vetor 2D",
  T_48_META_API_80_P0_D: "vetor bidimensional",
  T_48_META_API_80_P1_D: "Valor do primeiro componente",
  T_48_META_API_80_R_D: "O vetor 2D depois de modificar o primeiro componente",
  T_48_META_API_81_D: "Definir o segundo componente do vetor 2D",
  T_48_META_API_81_P0_D: "vetor bidimensional",
  T_48_META_API_81_P1_D: "Valor do segundo componente",
  T_48_META_API_81_R_D: "O vetor 2D depois de modificar o segundo componente",
  T_48_META_API_82_D: "Mover o controlador de personagem para o local especificado; se atuar sobre o jogador, este deve ligar o controlador de jogador que utiliza o efeito de física para que este tenha efeito",
  T_48_META_API_82_P0_D: "Controlador de função de destino",
  T_48_META_API_82_P1_D: "local designado",
  T_48_META_API_83_D: "Obtém o nó filho especificado da entidade pai de destino por nome",
  T_48_META_API_83_P0_D: "entidade-mãe",
  T_48_META_API_83_P1_D: "Nome do sub-nó",
  T_48_META_API_83_R_D: "entidade filha",
  T_48_META_API_84_D: "Acrescentar atenção especial à AOI e sincronizar sempre, independentemente da distância",
  T_48_META_API_84_P0_D: "Alvos de atenção especial",
  T_48_META_API_84_P1_D: "observador",
  T_48_META_API_85_D: "Remover a atenção especial da AOI e cancelar a sincronização da AOI fora de vista",
  T_48_META_API_85_P0_D: "Alvos de atenção especial",
  T_48_META_API_85_P1_D: "observador",
  T_48_META_API_86_D: "Limpa todas as preocupações especiais da AOI para o alvo especificado.",
  T_48_META_API_86_P0_D: "Alvos de atenção especial",
  T_48_META_API_87_D: "Determinar se existe uma preocupação especial da IOA",
  T_48_META_API_87_P0_D: "Alvos de atenção especial",
  T_48_META_API_87_P1_D: "abandonado",
  T_48_META_API_87_R_D: "Existe?",
  T_48_META_API_88_D: "Mudar o observador proxy do jogador",
  T_48_META_API_88_P0_D: "jogador",
  T_48_META_API_88_P1_D: "observador proxy",
  T_48_META_API_89_D: "Desloca o controlador de personagem uma vez e, se atuar sobre o jogador, este tem de ligar o controlador de jogador que utiliza o efeito de física para que este tenha efeito",
  T_48_META_API_89_P0_D: "O objeto alvo ou, no caso de um jogador, o jogador tem de ter um controlador de jogador que utilize efeitos físicos ativado para que o efeito tenha efeito",
  T_48_META_API_89_P1_D: "vetor de deslocação",
  T_48_META_API_9_D: "Desligar o mecanismo da zona de segurança, quando a zona de segurança é reduzida ao mínimo, os jogadores fora da zona de segurança continuarão a sofrer danos, depois de o mecanismo da zona de segurança ser desligado os jogadores regressam à segurança",
  T_48_META_API_90_D: "Definir se o jogador pode desistir livremente",
  T_48_META_API_90_P0_D: "jogador-alvo",
  T_48_META_API_90_P1_D: "Liberdade de retirada",
  T_48_META_API_9000_D: "Criar uma IU incorporada que só pode ser vista por jogadores específicos",
  T_48_META_API_9000_P0_D: "Entidades de IU incorporadas criadas",
  T_48_META_API_9000_P1_D: "A entidade do jogador a que pertence a IU, visível apenas para esse jogador",
  T_48_META_API_9000_P2_D: "Tipos de IU incorporados",
  T_48_META_API_9001_D: "Remover a IU de jogo incorporada",
  T_48_META_API_9001_P0_D: "Entidades de IU incorporadas a serem removidas",
  T_48_META_API_9002_D: "Cria um ícone com o tipo de ícone especificado e, quando há mais propriedades a serem definidas, define ainda as propriedades da entidade através da entidade (obsoleto, use CreateLevelObject)",
  T_48_META_API_9002_P0_D: "No código é o nome do parâmetro formal utilizado para representar a entidade que cria o ícone, e o valor da variável local correspondente é a entidade que cria o ícone",
  T_48_META_API_9002_P1_D: "A entidade do jogador a que pertence, visível apenas para esse jogador",
  T_48_META_API_9002_P2_D: "Caminho de recurso, o caminho de recurso correspondente ao ícone selecionado pelo jogador",
  T_48_META_API_9003_D: "Remover o ícone especificado (obsoleto, utilizar DeleteEntity)",
  T_48_META_API_9003_P0_D: "A entidade ícone a ser removida",
  T_48_META_API_9004_D: "Cria um texto com o conteúdo de texto especificado e, quando há mais atributos a serem definidos, define ainda mais seus atributos de entidade através da entidade (obsoleto, use CreateLevelObject)",
  T_48_META_API_9004_P0_D: "No código é o nome do parâmetro formal utilizado para representar a entidade que cria o texto, e o valor da variável local correspondente é a entidade que cria o texto",
  T_48_META_API_9004_P1_D: "A entidade do jogador a que pertence, visível apenas para esse jogador",
  T_48_META_API_9004_P2_D: "Conteúdo do texto a apresentar",
  T_48_META_API_9005_D: "Remover o texto especificado (obsoleto, utilizar DeleteEntity)",
  T_48_META_API_9005_P0_D: "Entidades de texto a remover",
  T_48_META_API_9006_D: "Cria um ícone com o tipo de efeito especificado e, quando há mais propriedades que precisam de ser definidas, define as propriedades da entidade através da entidade (obsoleto, utilize CreateEffect)",
  T_48_META_API_9006_P0_D: "No código é o nome do parâmetro formal utilizado para representar a entidade que cria o efeito, e o valor da sua variável local correspondente é a entidade que cria o efeito.",
  T_48_META_API_9006_P1_D: "A entidade do jogador a que pertence, visível apenas para esse jogador",
  T_48_META_API_9006_P2_D: "Tipos de efeitos especiais, os tipos de efeitos que os jogadores podem escolher",
  T_48_META_API_9007_D: "Remover o efeito especificado (obsoleto, utilizar DeleteEntity)",
  T_48_META_API_9007_P0_D: "A entidade de efeitos a ser removida",
  T_48_META_API_9008_D: "Criar uma IU personalizada que só pode ser vista por jogadores específicos",
  T_48_META_API_9008_P0_D: "Criação de entidades de IU personalizadas",
  T_48_META_API_9008_P1_D: "A entidade do jogador a que pertence a IU, visível apenas para esse jogador",
  T_48_META_API_9008_P2_D: "Índice da IU personalizada",
  T_48_META_API_9009_D: "Remover a IU personalizada do jogo",
  T_48_META_API_9009_P0_D: "Entidades de IU personalizadas a remover",
  T_48_META_API_9010_D: "Obter controlos de IU a partir de uma IU personalizada",
  T_48_META_API_9010_P0_D: "Entidade de jogador à qual pertence o IU",
  T_48_META_API_9010_P1_D: "Entidades IU personalizadas",
  T_48_META_API_9010_P2_D: "Índice único de controlo",
  T_48_META_API_9010_R_D: "Entidade de controlo da IU",
  T_48_META_API_9011_D: "Reproduz o som especificado e, se houver mais propriedades que precisem de ser definidas, define as propriedades da entidade através da entidade (obsoleto, utilize CreateSound)",
  T_48_META_API_9011_P0_D: "No código é o nome do parâmetro formal utilizado para representar a entidade que cria o efeito sonoro, e o valor da variável local correspondente é a entidade que cria o efeito sonoro",
  T_48_META_API_9011_P1_D: "A entidade do jogador a que pertence, visível apenas para esse jogador",
  T_48_META_API_9011_P2_D: "Tipos de som, os tipos de efeitos sonoros que o jogador pode escolher",
  T_48_META_API_9012_D: "Remover o efeito sonoro especificado (obsoleto, utilizar DeleteEntity)",
  T_48_META_API_9012_P0_D: "Entidades sonoras a remover",
  T_48_META_API_9013_D: "Obter um controlo de IU a partir de uma IU personalizada utilizando um caminho",
  T_48_META_API_9013_P0_D: "Entidade de jogador à qual pertence o IU",
  T_48_META_API_9013_P1_D: "IU personalizada",
  T_48_META_API_9013_P2_D: "Trajetória de controlo",
  T_48_META_API_9013_R_D: "Entidade de controlo da IU",
  T_48_META_API_9014_D: "Entidade de som na reprodução interrompida (obsoleto, utilizar PauseSound)",
  T_48_META_API_9014_P0_D: "Entidades sonoras que precisam de ser suspensas",
  T_48_META_API_9015_D: "Retomar o som, opcionalmente desde o início (obsoleto, utilize ResumeSound)",
  T_48_META_API_9015_P0_D: "Entidades sonoras que precisam de continuar a tocar depois de serem colocadas em pausa",
  T_48_META_API_9015_P1_D: "Se deve começar do zero",
  T_48_META_API_9016_D: "Criar controlos de IU personalizados",
  T_48_META_API_9016_P0_D: "Entidades de controlo personalizadas criadas",
  T_48_META_API_9016_P1_D: "Tipo de controlo criado",
  T_48_META_API_9016_P2_D: "Entidades afiliadas da IU",
  T_48_META_API_9016_P3_D: "Controlo pai, se não for preenchido, então a entidade IU será o nó pai.",
  T_48_META_API_9017_D: "Definir a máscara da camada da câmara de destino",
  T_48_META_API_9017_P0_D: "entidade da câmara alvo",
  T_48_META_API_9017_P1_D: "Máscara de camada, apenas as camadas preenchidas serão mostradas na câmara de destino, se deixar em branco significa que todas as camadas são mostradas.",
  T_48_META_API_9018_D: "Obter a máscara da camada da câmara alvo",
  T_48_META_API_9018_P0_D: "entidade da câmara alvo",
  T_48_META_API_9018_R_D: "Máscara de camada, apenas as camadas dentro da máscara de camada são mostradas na câmara de destino",
  T_48_META_API_9019_D: "Define se o nível especificado é visível para a câmara de destino",
  T_48_META_API_9019_P0_D: "entidade da câmara alvo",
  T_48_META_API_9019_P1_D: "Hierarquia de visibilidade",
  T_48_META_API_9019_P2_D: "visibilidade",
  T_48_META_API_9020_D: "Definir o estado da interface predefinida do jogador alvo",
  T_48_META_API_9020_P0_D: "jogador-alvo",
  T_48_META_API_9020_P1_D: "Tipos de interface do jogador, que são elementos da interface do utilizador utilizados para manipular o jogador e o conteúdo relacionado com o jogador",
  T_48_META_API_9020_P2_D: "Valor de comutação, determina a visibilidade da interface do jogador",
  T_48_META_API_9021_D: "Criar uma cadeia de localização de carimbo de data/hora",
  T_48_META_API_9021_P0_D: "carimbo de data/hora",
  T_48_META_API_9021_P1_D: "Estilos de formatação",
  T_48_META_API_9021_R_D: "Cadeia de localização do carimbo de data/hora",
  T_48_META_API_9022_D: "Criar um ícone de mini-mapa",
  T_48_META_API_9022_P0_D: "Criação de entidades de ícones de mapas mentais",
  T_48_META_API_9022_P1_D: "O jogador a que pertence cria um ícone de mini-mapa que só é visível para esse jogador.",
  T_48_META_API_9022_P2_D: "Caminho do recurso do ícone do mapa mental",
  T_48_META_API_9023_D: "Cria um ícone com o tipo de efeito especificado e define ainda as suas propriedades de entidade através da entidade, se houver mais propriedades a definir.",
  T_48_META_API_9023_P0_D: "No código é o nome do parâmetro formal utilizado para representar a entidade que cria o efeito, e o valor da sua variável local correspondente é a entidade que cria o efeito.",
  T_48_META_API_9023_P1_D: "A entidade do jogador a que pertence, visível apenas para esse jogador",
  T_48_META_API_9023_P2_D: "Tipos de efeitos especiais, os tipos de efeitos que os jogadores podem escolher",
  T_48_META_API_9024_D: "Remover o efeito especificado (obsoleto, utilizar DeleteEntity)",
  T_48_META_API_9024_P0_D: "A entidade de efeitos a ser removida",
  T_48_META_API_9025_D: "Gera pixels estáticos no mapa para o objeto alvo, que não se movem com o objeto alvo.",
  T_48_META_API_9025_P0_D: "Entidades de píxeis estáticos criadas",
  T_48_META_API_9025_P1_D: "O jogador a que pertence, criando pixéis estáticos que são visíveis apenas para esse jogador",
  T_48_META_API_9025_P2_D: "entidade objeto de destino",
  T_48_META_API_9026_D: "Obter a entidade do mini-mapa do jogador alvo",
  T_48_META_API_9026_P0_D: "jogador-alvo",
  T_48_META_API_9026_R_D: "Mini mapa do jogador atual",
  T_48_META_API_9027_D: "Definir o dano de queda do jogador, pode definir danos diferentes de acordo com os segmentos de altura",
  T_48_META_API_9027_P0_D: "jogador-alvo",
  T_48_META_API_9027_P1_D: "Lista segmentada em altura",
  T_48_META_API_9027_P2_D: "Lista de segmentos de danos",
  T_48_META_API_91_D: "Adicionar um alvo a uma equipa específica fará com que o alvo deixe a equipa de que era membro anteriormente.",
  T_48_META_API_91_P0_D: "Objectivos que devem ser acrescentados à equipa",
  T_48_META_API_91_P1_D: "Junte-se à equipa",
  T_48_META_API_91_P2_D: "sucesso ou fracasso",
  T_48_META_API_92_D: "A adição de um alvo a uma equipa recém-criada fará com que o alvo saia da equipa em que se encontrava anteriormente.",
  T_48_META_API_92_P0_D: "Objectivos que devem ser acrescentados à equipa",
  T_48_META_API_92_P1_D: "Nome da nova equipa",
  T_48_META_API_92_P2_D: "sucesso ou fracasso",
  T_48_META_API_94_D: "Define o valor de uma variável local pelo índice; antes de definir, a variável deve ser definida no processo de chamada atual",
  T_48_META_API_94_P0: "Índice",
  T_48_META_API_94_P0_D: "Obter uma variável por índice",
  T_48_META_API_94_P1: "Valor Variável",
  T_48_META_API_94_P1_D: "Valor da variável de destino",
  T_48_META_API_94_P2: "Tipo Aritmético",
  T_48_META_API_94_P2_D: "Método de operação; todos os tipos suportam atribuição, e os tipos numéricos também suportam operações de incremento, decremento, multiplicação, divisão e módulo",
  T_48_META_API_94_P3: "Nome da Variável",
  T_48_META_API_94_P3_D: "Nome da variável de destino. Usado somente para saída de erro",
  T_48_META_API_95: "Obter variável local por índice",
  T_48_META_API_95_D: "Obter o valor de uma variável local; antes de obter, a variável deve ser definida no processo de chamada atual",
  T_48_META_API_95_P0: "Índice",
  T_48_META_API_95_P0_D: "Índice variável",
  T_48_META_API_95_P1: "Nome da Variável",
  T_48_META_API_95_P1_D: "Nome da variável de destino. Usado somente para saída de erro",
  T_48_META_API_9500_D: "Efeitos de reprodução do lado do cliente que notificam o leitor de destino",
  T_48_META_API_9500_P0_D: "jogador-alvo",
  T_48_META_API_9500_P1_D: "Caminho de recursos de efeitos especiais",
  T_48_META_API_9500_P2_D: "cor",
  T_48_META_API_9500_P3_D: "Tamanho do zoom, a predefinição é 1",
  T_48_META_API_9500_P4_D: "Objeto ligado ao qual são anexados efeitos como nós filhos",
  T_48_META_API_9500_P5_D: "Deslocamento em coordenadas mundiais relativamente ao objeto ligado",
  T_48_META_API_9501_D: "Notificar o cliente do jogador alvo para reproduzir um efeito sonoro",
  T_48_META_API_9501_P0_D: "jogador-alvo",
  T_48_META_API_9501_P1_D: "Tipo de efeito sonoro",
  T_48_META_API_9502_D: "Notificar o cliente do jogador alvo para apresentar caracteres flutuantes",
  T_48_META_API_9502_P0_D: "jogador-alvo",
  T_48_META_API_9502_P1_D: 'O conteúdo da palavra "float',
  T_48_META_API_9502_P2_D: "Cor do carácter flutuante, Cor do tipo",
  T_48_META_API_9502_P3_D: "Duração da palavra flutuante em milissegundos",
  T_48_META_API_9503_D: "Faz com que a unidade alvo jogue uma expressão de ação Emote uma vez",
  T_48_META_API_9503_P0_D: "Jogar os objectivos do Emote",
  T_48_META_API_9503_P1_D: "Tipo de ditado",
  T_48_META_API_9504_D: "Pausa/retoma a expressão do movimento Emote da unidade",
  T_48_META_API_9504_P0_D: "Suspender/retomar os objectivos do Emote",
  T_48_META_API_9504_P1_D: "Verdadeiro: Colocar a reprodução em pausa, Falso: Retomar a reprodução",
  T_48_META_EVT_1_D: "Ativado no início do jogo, o servidor estará pronto algum tempo antes do cliente",
  T_48_META_EVT_10_D: "É ativado antes de a entidade atual sofrer danos",
  T_48_META_EVT_10_P0_D: "Entidade atacante, possivelmente nula",
  T_48_META_EVT_10_P1_D: "Tipo de dano",
  T_48_META_EVT_10_P2_D: "Quantidade de danos causados",
  T_48_META_EVT_10_P3_D: "parte ferida",
  T_48_META_EVT_1000_D: "Acionado quando os pontos do jogador mudam",
  T_48_META_EVT_1000_P0_D: "Jogadores com alterações nos pontos",
  T_48_META_EVT_1000_P1_D: "Tipos de pontos de modificação",
  T_48_META_EVT_1000_P2_D: "Valor integral após alteração integral",
  T_48_META_EVT_1001_D: "Acionado quando os pontos da equipa mudam",
  T_48_META_EVT_1001_P0_D: "Equipas com alterações nos pontos",
  T_48_META_EVT_1001_P1_D: "Tipos de pontos de modificação",
  T_48_META_EVT_1001_P2_D: "Valor integral após alteração integral",
  T_48_META_EVT_1002_D: "Acionado quando a classificação do jogador muda",
  T_48_META_EVT_1002_P0_D: "Jogadores com alterações na classificação",
  T_48_META_EVT_1002_P1_D: "Classificação após alteração da classificação",
  T_48_META_EVT_1003_D: "abandonado",
  T_48_META_EVT_1003_P0_D: "abandonado",
  T_48_META_EVT_1003_P1_D: "Classificação após alteração da classificação",
  T_48_META_EVT_11_D: "Acionado quando o jogador sai no meio da partida",
  T_48_META_EVT_11_P0_D: "Jogador que saiu no meio da partida",
  T_48_META_EVT_12_D: "Ativado quando o controlador do jogador toca numa entidade e só é ativado quando o controlador se move ativamente",
  T_48_META_EVT_12_P0_D: "Entidades encontradas",
  T_48_META_EVT_13_D: "É ativado antes de a entidade atual causar danos",
  T_48_META_EVT_13_P0_D: "Entidades que sofreram danos",
  T_48_META_EVT_13_P1_D: "Tipo de dano",
  T_48_META_EVT_13_P2_D: "Quantidade de danos causados",
  T_48_META_EVT_13_P3_D: "parte ferida",
  T_48_META_EVT_14_D: "Despoletado sempre que uma entidade jogável faz um ciclo, este evento só funciona no lado do cliente se a entidade jogável for uma entidade de som, efeito, etc.",
  T_48_META_EVT_2_D: "Acionado quando o quadro lógico é atualizado. Dependendo da plataforma e das definições, a frequência deste evento pode variar.",
  T_48_META_EVT_2002_D: "Ativado com a morte do jogador",
  T_48_META_EVT_2002_P0_D: "Jogadores mortos",
  T_48_META_EVT_2003_D: "Acionado com assistências de jogadores",
  T_48_META_EVT_2003_P0_D: "Jogadores com assistências",
  T_48_META_EVT_2003_P1_D: "Jogadores mortos",
  T_48_META_EVT_2004_D: "É ativado quando o jogador causa danos",
  T_48_META_EVT_2004_P0_D: "O jogador que causou o dano",
  T_48_META_EVT_2004_P1_D: "leitor danificado",
  T_48_META_EVT_2004_P2_D: "Tipo de dano",
  T_48_META_EVT_2004_P3_D: "quantidade de danos",
  T_48_META_EVT_2004_P4_D: "parte ferida",
  T_48_META_EVT_2005_D: "Ativado quando um jogador inflige uma morte",
  T_48_META_EVT_2005_P0_D: "jogador que causou uma pancada",
  T_48_META_EVT_2005_P1_D: "Jogadores mortos",
  T_48_META_EVT_2005_P2_D: "Tipo de dano",
  T_48_META_EVT_2006_D: "Acionado quando um jogador entra no jogo",
  T_48_META_EVT_2006_P0_D: "Jogadores que entram no jogo",
  T_48_META_EVT_2007_D: "Ativado quando o jogador é reanimado",
  T_48_META_EVT_2007_P0_D: "Jogadores ressuscitados",
  T_48_META_EVT_2007_P1_D: "Fontes da ressurreição",
  T_48_META_EVT_2008_D: "Ativado quando um jogador é derrubado",
  T_48_META_EVT_2008_P0_D: "Jogador nocauteado",
  T_48_META_EVT_2008_P1_D: "agressor",
  T_48_META_EVT_2009_D: "Acionado quando o jogador se desliga",
  T_48_META_EVT_2009_P0_D: "Jogadores desligados",
  T_48_META_EVT_2010_D: "Acionado quando o jogador volta a ligar-se",
  T_48_META_EVT_2010_P0_D: "Jogadores ligados novamente",
  T_48_META_EVT_2100_D: "Acionado quando a equipa é removida",
  T_48_META_EVT_2100_P0_D: "Equipas removidas",
  T_48_META_EVT_2101_D: "Acionado ao adicionar uma equipa",
  T_48_META_EVT_2101_P0_D: "Equipas adicionadas",
  T_48_META_EVT_2102_D: "Ativado quando a equipa é destruída pelo grupo",
  T_48_META_EVT_2102_P0_D: "A equipa que foi destruída pelo regimento",
  T_48_META_EVT_3_D: "Acionado no final do jogo e antes de o jogo terminar no servidor",
  T_48_META_EVT_30_D: "Acionado quando o cenário é carregado com êxito",
  T_48_META_EVT_30_P0_D: "nome da cena",
  T_48_META_EVT_3000_D: "Acionado depois de a entidade atual ser criada",
  T_48_META_EVT_3001_D: "Acionado antes de a entidade atual ser destruída",
  T_48_META_EVT_3002_D: "Acionado quando o jogador entra no gatilho",
  T_48_META_EVT_3002_P0_D: "Jogadores que entram no gatilho",
  T_48_META_EVT_3003_D: "Dispara quando o jogador deixa o gatilho",
  T_48_META_EVT_3003_P0_D: "Jogadores que abandonam o gatilho",
  T_48_META_EVT_3004_D: "Acionado depois de clicar no controlo do botão da IU",
  T_48_META_EVT_3004_P0_D: "Clicar nos jogadores",
  T_48_META_EVT_3005_D: "Acionado ao clicar num botão na IU incorporada",
  T_48_META_EVT_3005_P0_D: "Nome do controlo do botão para clicar",
  T_48_META_EVT_3006_D: "Ativado quando o jogador usa esquis aquáticos",
  T_48_META_EVT_3007_D: "Acionado depois de a entidade atual estar disponível",
  T_48_META_EVT_3008_D: "Acionado depois de a entidade atual estar indisponível",
  T_48_META_EVT_3009_D: "Acionado quando uma entidade entra em um gatilho. Quando um evento de gatilho é acionado, ambas as partes recebem o evento. Uma parte deve ser um corpo rígido e a outra parte deve ser um gatilho. Em particular, quando o gatilho é um objeto de gatilho personalizado, apenas o gatilho receberá o evento.",
  T_48_META_EVT_3009_P0_D: "Entidade oponente no momento do facto gerador",
  T_48_META_EVT_3010_D: "Disparado quando a entidade sai do gatilho. Quando o evento é disparado, ambas as partes recebem o evento. Uma parte deve ser um corpo rígido e a outra parte deve ser um gatilho. Em particular, quando o gatilho é um objeto de gatilho personalizado, apenas o gatilho receberá o evento.",
  T_48_META_EVT_3010_P0_D: "Entidade oponente no momento do facto gerador",
  T_48_META_EVT_3011_D: "Acionado quando a entidade atual é destruída",
  T_48_META_EVT_3011_P0_D: "Entidade atacante, possivelmente nula",
  T_48_META_EVT_3011_P1_D: "Tipo de dano",
  T_48_META_EVT_3011_P2_D: "parte ferida",
  T_48_META_EVT_3012_D: "Acionado depois de a entidade atual ser atacada",
  T_48_META_EVT_3012_P0_D: "Entidade atacante, possivelmente nula",
  T_48_META_EVT_3012_P1_D: "Tipo de dano",
  T_48_META_EVT_3012_P2_D: "Quantidade de danos causados",
  T_48_META_EVT_3012_P3_D: "parte ferida",
  T_48_META_EVT_3013_D: "É ativado depois de a entidade atual causar danos",
  T_48_META_EVT_3013_P0_D: "Entidades que sofreram danos",
  T_48_META_EVT_3013_P1_D: "Tipo de dano",
  T_48_META_EVT_3013_P2_D: "Quantidade de danos causados",
  T_48_META_EVT_3013_P3_D: "parte ferida",
  T_48_META_EVT_3014_D: "Acionado depois de a entidade atual destruir outra entidade",
  T_48_META_EVT_3014_P0_D: "Entidades eliminadas",
  T_48_META_EVT_3014_P1_D: "parte ferida",
  T_48_META_EVT_3015_D: "Ativado quando este jogador é ressuscitado",
  T_48_META_EVT_3015_P0_D: "Tipo de jogador fonte de ressurreição",
  T_48_META_EVT_3016_D: "Acionado quando o gerador gera uma entidade",
  T_48_META_EVT_3016_P0_D: "Lista de entidades geradas",
  T_48_META_EVT_3016_P1_D: "número de onda",
  T_48_META_EVT_3017_D: "Chamado quando o jogador entra na posição de ajoelhado por nocaute",
  T_48_META_EVT_3018_D: "Despoletado quando todos os membros da equipa estão mortos",
  T_48_META_EVT_3019_D: "Ativado quando equipado com um capacete, um colete à prova de bala ou uma mochila",
  T_48_META_EVT_3019_P0_D: "ID do equipamento",
  T_48_META_EVT_3020_D: "Ativado quando se segura uma arma primária, secundária ou corpo a corpo, incluindo quando se muda para um punho",
  T_48_META_EVT_3020_P0_D: "Entidade de arma equipada no momento do acionamento",
  T_48_META_EVT_3021_D: "Desencadeado após a utilização de adereços, os adereços que requerem tempo para serem utilizados desencadearão este evento após a conclusão da utilização",
  T_48_META_EVT_3021_P0_D: "ID dos adereços",
  T_48_META_EVT_3021_P1_D: "Entidade de adereços, possivelmente nula",
  T_48_META_EVT_3021_P2_D: "Nova entidade prop criada utilizando props, pode estar vazia",
  T_48_META_EVT_3022_D: "Acionado quando se adquire um item",
  T_48_META_EVT_3022_P0_D: "Tipo de artigo",
  T_48_META_EVT_3022_P1_D: "Entidade objeto, possivelmente nula",
  T_48_META_EVT_3023_D: "Acionado quando os pontos de entidade mudam",
  T_48_META_EVT_3023_P0_D: "Tipos de pontos de modificação",
  T_48_META_EVT_3023_P1_D: "Valor integral após alteração integral",
  T_48_META_EVT_3024_D: "Acionado quando a classificação da entidade é alterada",
  T_48_META_EVT_3024_P0_D: "Classificação após alteração da classificação",
  T_48_META_EVT_3025_D: "Acionado com uma assistência",
  T_48_META_EVT_3025_P0_D: "atingido",
  T_48_META_EVT_3026_D: "Acionado quando uma entidade entra num veículo, incluindo como condutor e passageiro",
  T_48_META_EVT_3026_P0_D: "Entidades que entram na transportadora",
  T_48_META_EVT_3026_P1_D: "Transportadoras inscritas",
  T_48_META_EVT_3027_D: "Acionado quando a entidade deixa o transportador",
  T_48_META_EVT_3027_P0_D: "Entidades que abandonam a transportadora",
  T_48_META_EVT_3027_P1_D: "Transportadoras que partem",
  T_48_META_EVT_3028_D: "Acionado quando se conduz fisicamente um transportador, quando se está num automóvel como condutor",
  T_48_META_EVT_3028_P0_D: "Entidade que conduz o transportador",
  T_48_META_EVT_3028_P1_D: "Veículos acionados",
  T_48_META_EVT_3029_D: "Acionado quando o transportador é fisicamente introduzido",
  T_48_META_EVT_3029_P0_D: "entidade accionadora",
  T_48_META_EVT_3030_D: "Acionado quando o transportador sai",
  T_48_META_EVT_3030_P0_D: "entidade accionadora",
  T_48_META_EVT_3031_D: "Acionado quando o veículo está a ser conduzido por uma entidade",
  T_48_META_EVT_3031_P0_D: "entidade accionadora",
  T_48_META_EVT_3032_D: "Acionado depois de ocorrer um teletransporte quando uma entidade utiliza um portal (obsoleto, utilizar OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Entidades que utilizam o portal",
  T_48_META_EVT_3032_P1_D: "Portal utilizado",
  T_48_META_EVT_3033_D: "Acionado quando a entidade salta",
  T_48_META_EVT_3033_P0_D: "entidade accionadora",
  T_48_META_EVT_3033_P1_D: "Utilização de objectos saltitantes",
  T_48_META_EVT_3034_D: "Acionado depois de o portal permitir que a entidade se teletransporte",
  T_48_META_EVT_3034_P0_D: "entidade transmissora",
  T_48_META_EVT_3035_D: "Acionado depois de o pneu fazer saltar a entidade",
  T_48_META_EVT_3035_P0_D: "entidade pop-up",
  T_48_META_EVT_3036_D: "Acionado quando uma máquina envia uma entidade que voa",
  T_48_META_EVT_3036_P0_D: "entidade que é derrubada",
  T_48_META_EVT_3036_P1_D: "objeto gerado por máquina",
  T_48_META_EVT_3037_D: "É ativado quando a entidade entra no acionador",
  T_48_META_EVT_3037_P0_D: "Acionamento da entrada",
  T_48_META_EVT_3038_D: "Dispara quando a entidade deixa o acionador",
  T_48_META_EVT_3038_P0_D: "Desencadear a saída",
  T_48_META_EVT_3039_D: "Ativado quando se adquire uma entidade de arma",
  T_48_META_EVT_3039_P0_D: "entidade de armamento",
  T_48_META_EVT_3040_D: "Acionado quando uma entidade é derrubada por uma máquina",
  T_48_META_EVT_3040_P0_D: "entidade que é derrubada",
  T_48_META_EVT_3040_P1_D: "objeto gerado por máquina",
  T_48_META_EVT_3041_D: "Acionado ao visar uma entidade visável",
  T_48_META_EVT_3041_P0_D: "Entidades visadas",
  T_48_META_EVT_3042_D: "Acionado quando um jogador é o alvo",
  T_48_META_EVT_3042_P0_D: "Apontar jogadores",
  T_48_META_EVT_3043_D: "Ativado quando a bala atinge o alvo",
  T_48_META_EVT_3043_P0_D: "atingido",
  T_48_META_EVT_3043_P1_D: "Coordenadas mundiais dos locais de impacto das balas",
  T_48_META_EVT_3044_D: "Ativado quando atingido por uma arma",
  T_48_META_EVT_3044_P0_D: "armamento",
  T_48_META_EVT_3044_P1_D: "Coordenadas mundiais da zona atingida",
  T_48_META_EVT_3045_D: "Acionado quando o jogador escolhe transformar-se num objeto para esse nível",
  T_48_META_EVT_3045_P0_D: "O jogador transforma-se numa entidade, não no objeto de cena em si",
  T_48_META_EVT_3046_D: "Ativado quando um jogador é ressuscitado nesse ponto de ressurreição",
  T_48_META_EVT_3046_P0_D: "Jogadores ressuscitados neste ponto de ressurreição",
  T_48_META_EVT_3047_D: "Ativado quando um jogador descarta uma arma",
  T_48_META_EVT_3047_P0_D: "Entidades de armas caídas",
  T_48_META_EVT_3048_D: "Ativado quando um jogador descarta um item que não seja uma arma",
  T_48_META_EVT_3048_P0_D: "Tipo de artigo",
  T_48_META_EVT_3048_P1_D: "Entidade objeto, possivelmente nula",
  T_48_META_EVT_3049_D: "Ativado quando atingido por uma bola de futebol",
  T_48_META_EVT_3049_P0_D: "jogador",
  T_48_META_EVT_3049_P1_D: "Velocidade após ser atingido",
  T_48_META_EVT_3050_D: "Acionado em caso de colisão entre a bola de futebol e o sólido",
  T_48_META_EVT_3050_P0_D: "objeto de colisão",
  T_48_META_EVT_3050_P1_D: "Velocidade pós-colisão",
  T_48_META_EVT_3051_D: "Acionado quando um jogador entra com êxito num canal de voz",
  T_48_META_EVT_3051_P0_D: "entidade de canal de voz",
  T_48_META_EVT_3052_D: "Acionado quando um jogador não consegue entrar num canal de voz",
  T_48_META_EVT_3052_P0_D: "entidade de canal de voz",
  T_48_META_EVT_3053_D: "Acionado quando um jogador sai de um canal de voz",
  T_48_META_EVT_3053_P0_D: "entidade de canal de voz",
  T_48_META_EVT_3054_D: "Acionado quando a bola entra na baliza",
  T_48_META_EVT_3054_P0_D: "boca de baliza",
  T_48_META_EVT_3054_P1_D: "Marcador, o último jogador a tocar na bola antes de entrar na baliza",
  T_48_META_EVT_3054_P2_D: "Assistentes, penúltimo jogador a tocar na bola antes de o golo ser marcado",
  T_48_META_EVT_3055_D: "Acionado quando o jogador carrega no botão de disparo",
  T_48_META_EVT_3056_D: "Acionado quando o jogador salta",
  T_48_META_EVT_3057_D: "Acionado quando o jogador se agacha",
  T_48_META_EVT_3058_D: "Acionado quando o jogador se baixa",
  T_48_META_EVT_3059_D: "Acionado quando o jogador faz sprints",
  T_48_META_EVT_3060_D: "Acionado quando um artigo é comprado com sucesso na loja",
  T_48_META_EVT_3060_P0_D: "Jogadores que compram mercadorias",
  T_48_META_EVT_3060_P1_D: "mercadoria",
  T_48_META_EVT_3061_D: "Acionado quando a arma é equipada pelo jogador",
  T_48_META_EVT_3061_P0_D: "Jogadores equipados com armas",
  T_48_META_EVT_3062_D: "Ativado quando uma unidade é morta com esta arma",
  T_48_META_EVT_3062_P0_D: "Entidades mortas",
  T_48_META_EVT_3063_D: "Ativado quando se usa esta arma para causar dano a uma unidade",
  T_48_META_EVT_3063_P0_D: "entidade lesada",
  T_48_META_EVT_3063_P1_D: "quantidade de danos",
  T_48_META_EVT_3064_D: "Acionado quando a arma muda de bala",
  T_48_META_EVT_3065_D: "Acionado quando uma entidade entra no transportador, quer como condutor quer como passageiro",
  T_48_META_EVT_3065_P0_D: "Transportadoras inscritas",
  T_48_META_EVT_3066_D: "Acionado quando a entidade deixa o transportador",
  T_48_META_EVT_3066_P0_D: "Transportadoras que partem",
  T_48_META_EVT_3067_D: "Acionado durante a condução física do transportador",
  T_48_META_EVT_3067_P0_D: "Veículos acionados",
  T_48_META_EVT_3068_D: "Acionado após um teletransporte, quando uma entidade utiliza um portal",
  T_48_META_EVT_3068_P0_D: "Portal utilizado",
  T_48_META_EVT_3069_D: "Acionado quando uma entidade é atingida por um pneu",
  T_48_META_EVT_3069_P0_D: "Pneus utilizados",
  T_48_META_EVT_3070_D: "Acionado quando uma entidade é derrubada por uma máquina",
  T_48_META_EVT_3070_P0_D: "objeto gerado por máquina",
  T_48_META_EVT_3071_D: "Acionado depois de um botão de controlo da IU ser premido pelo jogador",
  T_48_META_EVT_3071_P0_D: "leitor de gatilho",
  T_48_META_EVT_3072_D: "Acionado quando o controlo do botão da IU é levantado",
  T_48_META_EVT_3072_P0_D: "leitor de gatilho",
  T_48_META_EVT_3073_D: "Acionado depois de um botão de controlo da IU ser clicado duas vezes pelo jogador",
  T_48_META_EVT_3073_P0_D: "leitor de gatilho",
  T_48_META_EVT_3074_D: "Início da área do Jailbreak",
  T_48_META_EVT_3075_D: "Zona de fuga à prisão encerrada",
  T_48_META_EVT_3076_D: "Acionado quando o jogador deixa de utilizar os esquis aquáticos",
  T_48_META_EVT_3077_D: "Acionado quando o conteúdo do texto do controlo da caixa de entrada da IU é alterado pelo jogador",
  T_48_META_EVT_3077_P0_D: "leitor de gatilho",
  T_48_META_EVT_3077_P1_D: "Conteúdo do texto alterado",
  T_48_META_EVT_3078_D: "Acionado quando a entidade jogável começa a jogar",
  T_48_META_EVT_3078_P0_D: "entidade jogável",
  T_48_META_EVT_3079_D: "Despoletado quando uma entidade jogável termina a sua reprodução, este evento só funciona no lado do cliente se a entidade jogável for uma entidade de som, efeito, etc.",
  T_48_META_EVT_3079_P0_D: "entidade jogável",
  T_48_META_EVT_3080_D: "Acionado quando a entidade jogável continua a jogar",
  T_48_META_EVT_3080_P0_D: "entidade jogável",
  T_48_META_EVT_3081_D: "Acionado quando uma entidade jogável faz uma pausa na reprodução",
  T_48_META_EVT_3081_P0_D: "entidade jogável",
  T_48_META_EVT_3082_D: "Jogadores do Jailbreak aderem",
  T_48_META_EVT_3082_P0_D: "leitor de gatilho",
  T_48_META_EVT_3083_D: "Os jogadores do Jailbreak desistem",
  T_48_META_EVT_3083_P0_D: "leitor de gatilho",
  T_48_META_EVT_3084_D: "Acionado no final da contagem decrescente",
  T_48_META_EVT_3084_P0_D: "entidade afiliada",
  T_48_META_EVT_3085_D: "Acionado quando um item é recolhido",
  T_48_META_EVT_3085_P0_D: "Jogadores que apanham objectos",
  T_48_META_EVT_3086_D: "Acionado quando um item é eliminado",
  T_48_META_EVT_3086_P0_D: "O jogador que deixou cair o objeto",
  T_48_META_EVT_3087_D: "Ativado quando este item está equipado",
  T_48_META_EVT_3088_D: "Acionado quando o objeto é iniciado após a criação da mina",
  T_48_META_EVT_3089_D: "Acionado quando o objeto é acionado após a criação da mina",
  T_48_META_EVT_3089_P0_D: "Direcionamento de objectos após a criação da mina ser acionada",
  T_48_META_EVT_3090_D: "Ativado antes de comprar um artigo numa loja",
  T_48_META_EVT_3090_P0_D: "Jogadores que compram mercadorias",
  T_48_META_EVT_3090_P1_D: "mercadoria",
  T_48_META_EVT_3091_D: "Acionado quando este dispositivo é utilizado",
  T_48_META_EVT_3092_D: "Acionado quando a pistola de bloqueio do gancho é disparada",
  T_48_META_EVT_3093_D: "Ativado quando o projétil explode depois de ser lançado.",
  T_48_META_EVT_3093_P0_D: "ponto de explosão",
  T_48_META_EVT_3094_D: "Ativado quando atingido por uma arma de paintball",
  T_48_META_EVT_3094_P0_D: "Entidades de pistolas de pintura",
  T_48_META_EVT_3094_P1_D: "ponto de vida",
  T_48_META_EVT_3094_P2_D: "atingir a linha de meta",
  T_48_META_EVT_3095_D: "Despoletado ao ser atingido por uma pistola de pintura",
  T_48_META_EVT_3095_P0_D: "objeto atingido",
  T_48_META_EVT_3095_P1_D: "ponto de vida",
  T_48_META_EVT_3095_P2_D: "atingir a linha de meta",
  T_48_META_EVT_3096_D: "Acionado quando um transportador ou um balde de tinta explode",
  T_48_META_EVT_3096_P0_D: "O jogador que provocou a explosão",
  T_48_META_EVT_3096_P1_D: "Lista dos jogadores afectados pela explosão",
  T_48_META_EVT_3097_D: "Acionado quando a arma pára de disparar",
  T_48_META_EVT_3097_P0_D: "Capacidade atual dos paióis no momento do cessar-fogo",
  T_48_META_EVT_3098_D: "Acionado quando o alvo perseguido entra na área de perseguição",
  T_48_META_EVT_3099_D: "Acionado quando o alvo perseguido sai do alcance da perseguição",
  T_48_META_EVT_31_D: "Acionado quando a mudança de cenário é bem sucedida",
  T_48_META_EVT_31_P0_D: "nome da cena",
  T_48_META_EVT_3100_D: "Ativado quando o alvo do ataque entra no alcance do ataque",
  T_48_META_EVT_3101_D: "Ativado quando o alvo do ataque está fora do alcance",
  T_48_META_EVT_3102_D: "Acionado quando a deteção de raios da câmara é acionada por um evento de clique do cliente",
  T_48_META_EVT_3102_P0_D: "leitor de gatilho",
  T_48_META_EVT_3102_P1_D: "Se o raio da câmara atinge o objeto",
  T_48_META_EVT_3102_P2_D: "Posição de acerto do raio da câmara",
  T_48_META_EVT_3102_P3_D: "Orientação da câmara do cliente",
  T_48_META_EVT_3102_P4_D: "Posição da câmara do cliente",
  T_48_META_EVT_3102_P5_D: "atingir o objetivo",
  T_48_META_EVT_3103_D: "Acionado quando o ecrã da loja é aberto",
  T_48_META_EVT_3103_P0_D: "leitor de gatilho",
  T_48_META_EVT_3104_D: "Acionado quando o ecrã da loja é fechado",
  T_48_META_EVT_3104_P0_D: "leitor de gatilho",
  T_48_META_EVT_3105_D: "Acionado quando a lógica da árvore de comportamento entra no nó",
  T_48_META_EVT_3105_P0_D: "Nome do nó",
  T_48_META_EVT_3105_P1_D: "entidade afiliada",
  T_48_META_EVT_3106_D: "Acionado quando a lógica da árvore de comportamento sai do nó",
  T_48_META_EVT_3106_P0_D: "Nome do nó",
  T_48_META_EVT_3106_P1_D: "entidade afiliada",
  T_48_META_EVT_3107_D: "Acionado quando um corpo rígido é acordado",
  T_48_META_EVT_3108_D: "Acionado quando o corpo rígido entra em suspensão",
  T_48_META_EVT_3109_D: "Acionado quando o jogador se move",
  T_48_META_EVT_3109_P0_D: "aberturas",
  T_48_META_EVT_3110_D: "Acionado quando o leitor está no modo de espera",
  T_48_META_EVT_3110_P0_D: "aberturas",
  T_48_META_EVT_3111_D: "Acionado quando o jogador utiliza uma habilidade",
  T_48_META_EVT_3111_P0_D: "Competências utilizadas",
  T_48_META_EVT_3112_D: "Acionado quando o jogador termina a corrida",
  T_48_META_EVT_3113_D: "Acionado quando o item correspondente à ranhura na enumeração SwitchEquipSlot é adquirido.",
  T_48_META_EVT_3113_P0_D: "Entidades de itens adquiridos",
  T_48_META_EVT_3114_D: "Acciona quando se muda de objeto de mão, incluindo quando se muda para os punhos",
  T_48_META_EVT_3114_P0_D: "Item entidades detidas após a mudança",
  T_48_META_EVT_3115_D: "Acionado quando um jogador na loja pede a alguém para comprar um item",
  T_48_META_EVT_3115_P0_D: "Jogadores que solicitam mercadoria",
  T_48_META_EVT_3115_P1_D: "mercadoria",
  T_48_META_EVT_3116_D: "Ativado quando um jogador numa loja pede um item a outra pessoa e o pedido é aceite.",
  T_48_META_EVT_3116_P0_D: "Ajuda para jogadores comprados",
  T_48_META_EVT_3116_P1_D: "Jogadores que solicitam ajuda para as suas compras",
  T_48_META_EVT_3116_P2_D: "mercadoria",
  T_48_META_EVT_3117_D: "Acionado em actualizações de fotogramas fixos a uma frequência fixa de 30 vezes por segundo",
  T_48_META_EVT_3118_D: "Acionado após uma chamada à API Pausa do jogo",
  T_48_META_EVT_3119_D: "Acionado após uma chamada à API Restore Game",
  T_48_META_EVT_3120_D: "Ativado quando um jogador adiciona ou elimina um amigo",
  T_48_META_EVT_3121_D: "Acionado na receção de uma mensagem Persona",
  T_48_META_EVT_3121_P0_D: "Conteúdo informativo",
  T_48_META_EVT_3121_P1_D: "Persona do remetente",
  T_48_META_EVT_3122_D: "Acionado no final do salto de um jogador",
  T_48_META_EVT_3123_D: "Acionado quando o jogador cai",
  T_48_META_EVT_3124_D: "Acionado no final da queda de um jogador",
  T_48_META_EVT_3125_D: "Acionado na receção do comportamento da Persona",
  T_48_META_EVT_3125_P0_D: "comportamento",
  T_48_META_EVT_3125_P1_D: "Persona do remetente",
  T_48_META_EVT_3126_D: "Acionado quando as informações dos membros são alteradas",
  T_48_META_EVT_3126_P0_D: "Alteração do estatuto do membro",
  T_48_META_EVT_3127_D: "Acionado ao entrar no Centro de Membros",
  T_48_META_EVT_3128_D: "Acionado ao sair do Centro de Membros",
  T_48_META_EVT_3129_D: "Acionado quando um jogador entra no estado de knockdown",
  T_48_META_EVT_3129_P0_D: "Entidade atacante, possivelmente nula",
  T_48_META_EVT_3130_D: "Acionado quando o estatuto de Persona é recebido",
  T_48_META_EVT_3130_P0_D: "Persona do remetente",
  T_48_META_EVT_3130_P1_D: "código de erro",
  T_48_META_EVT_3131_D: "Despoletado quando se envia uma mensagem para a Persona através da IU",
  T_48_META_EVT_3131_P0_D: "Conteúdo informativo",
  T_48_META_EVT_3131_P1_D: "Persona do remetente",
  T_48_META_EVT_3132_D: "Acionado no final da receção da Persona",
  T_48_META_EVT_3132_P0_D: "Persona do remetente",
  T_48_META_EVT_3132_P1_D: "código de erro",
  T_48_META_EVT_32_D: "Acionado quando o jogador muda de cenário",
  T_48_META_EVT_32_P0_D: "nome da cena",
  T_48_META_EVT_3200_D: "Acionado quando o clip de animação termina de ser reproduzido",
  T_48_META_EVT_3200_P0_D: "Nome do segmento animado",
  T_48_META_EVT_3201_D: "Acionado quando o estado da animação termina a reprodução",
  T_48_META_EVT_3201_P0_D: "Nome do estado da animação",
  T_48_META_EVT_3204_D: "Acionado quando o estado do controlo de alternância muda.",
  T_48_META_EVT_3204_P0_D: "leitor de gatilho",
  T_48_META_EVT_3204_P1_D: "estado das coisas",
  T_48_META_EVT_3260_D: "Acionado quando o touchpad é premido pelo jogador",
  T_48_META_EVT_3260_P0_D: "leitor de gatilho",
  T_48_META_EVT_3260_P1_D: "Posição de imprensa",
  T_48_META_EVT_3261_D: "Acionado quando o touchpad é levantado",
  T_48_META_EVT_3261_P0_D: "leitor de gatilho",
  T_48_META_EVT_3261_P1_D: "Posição de elevação",
  T_48_META_EVT_3262_D: "Acionado quando o touchpad começa a deslizar",
  T_48_META_EVT_3262_P0_D: "leitor de gatilho",
  T_48_META_EVT_3262_P1_D: "Posição inicial de deslizamento",
  T_48_META_EVT_3263_D: "Acionado num deslizamento do touchpad, este evento é acionado uma vez por fotograma durante o deslizamento",
  T_48_META_EVT_3263_P0_D: "leitor de gatilho",
  T_48_META_EVT_3263_P1_D: "Posição inicial de deslizamento",
  T_48_META_EVT_3263_P2_D: "deslocamento",
  T_48_META_EVT_3264_D: "Acionado no final de um deslizamento do touchpad",
  T_48_META_EVT_3264_P0_D: "leitor de gatilho",
  T_48_META_EVT_3264_P1_D: "Posição do deslizamento final",
  T_48_META_EVT_3265_D: "Acionado quando o JoyStick é premido",
  T_48_META_EVT_3265_P0_D: "leitor de gatilho",
  T_48_META_EVT_3266_D: "Acionado quando o JoyStick é levantado",
  T_48_META_EVT_3266_P0_D: "leitor de gatilho",
  T_48_META_EVT_3267_D: "Acionado quando se utiliza o joystick JoyStick",
  T_48_META_EVT_3267_P0_D: "leitor de gatilho",
  T_48_META_EVT_3267_P1_D: "Deslocamento de saída",
  T_48_META_EVT_3268_D: "Ativado quando o jogador se levanta de outra posição",
  T_48_META_EVT_3268_P0_D: "A postura do jogador antes de se levantar",
  T_48_META_EVT_3269_D: "Acionado quando a arma é disparada",
  T_48_META_EVT_4_D: "Acionado no início de cada turno",
  T_48_META_EVT_4_P0_D: "Índice redondo, a contar de 0",
  T_48_META_EVT_5_D: "Acionado no final de cada turno",
  T_48_META_EVT_5_P0_D: "Índice redondo, a contar de 0",
  T_48_META_EVT_6_D: "Acionado quando uma entidade colide, apenas suportado por entidades que tenham um componente Corpo Rígido montado.",
  T_48_META_EVT_6_P0_D: "Entidades encontradas",
  T_48_META_EVT_7_D: "Acionado no início de cada fase",
  T_48_META_EVT_7_P0_D: "entidade escalonada",
  T_48_META_EVT_8_D: "Acionado no final de cada fase",
  T_48_META_EVT_8_P0_D: "entidade escalonada",
  T_48_META_EVT_9_D: "Acionado no final da colisão de uma entidade, apenas suportado por entidades que tenham um componente de Corpo Rígido montado nelas.",
  T_48_META_EVT_9_P0_D: "Entidades encontradas",
  T_49_META_TYP_10_I1_D: "Lista de Tags",
  T_49_META_TYP_10_I2_D: "Está disponível?",
  T_49_META_TYP_10_I3_D: "Todos os nós pais estão disponíveis?",
  T_49_META_TYP_10_I4_D: "Está disponível na cena?",
  T_49_META_TYP_10_I5_D: "Se deve habilitar a atualização lógica. Quando desabilitado, o script na entidade parará de atualizar cada quadro.",
  T_49_META_TYP_10_I6_D: "Nome da Entidade",
  T_49_META_TYP_10_I7_D: "Opção de filtro de área, 0 significa se o cálculo automático é controlado, 1 significa que não é controlado e sempre sincronizado, 2 significa que é controlado",
  T_49_META_TYP_100_I0_D: "Defina o intervalo de disparo",
  T_49_META_TYP_100_I1_D: "Visibilidade do Modelo",
  T_49_META_TYP_101_I0_D: "Jogador",
  T_49_META_TYP_101_I1_D: "ID do Item Alvo",
  T_49_META_TYP_101_I2_D: "Rotação Alvo",
  T_49_META_TYP_101_I3_D: "Escala Alvo",
  T_49_META_TYP_1010_I1_D: "A duração do tempo, em segundos",
  T_49_META_TYP_1010_I2_D: "O tempo de início da contagem regressiva, em segundos do jogo",
  T_49_META_TYP_1010_I3_D: "tipo de atualização do tempo, veja `EUITimeUpdateType`, opcional: estático, tempo, contagem regressiva",
  T_49_META_TYP_1010_I4_D: "Posição de exibição, quando há um alvo a seguir, é o deslocamento relativo à origem do alvo, quando não há alvo a seguir, é a coordenada da tela",
  T_49_META_TYP_1011_I10_D: "Nome do Ícone de Progresso",
  T_49_META_TYP_1011_I2_D: "Cor do Tema",
  T_49_META_TYP_1011_I3_D: "Se deve habilitar a exibição localizada",
  T_49_META_TYP_1011_I4_D: "Título",
  T_49_META_TYP_1011_I5_D: "Descrição",
  T_49_META_TYP_1011_I6_D: "Nome do recurso do ícone",
  T_49_META_TYP_1011_I7_D: "Máximo de Progresso",
  T_49_META_TYP_1011_I8_D: "Progresso Atual",
  T_49_META_TYP_1011_I9_D: "Ícone de Progresso",
  T_49_META_TYP_1012_I1_D: "Se deve habilitar a localização",
  T_49_META_TYP_1012_I2_D: "Texto do número redondo",
  T_49_META_TYP_1012_I3_D: "Parâmetros da Chave de Rodada",
  T_49_META_TYP_1012_I5_D: "Cor à Esquerda",
  T_49_META_TYP_1012_I6_D: "Cor à Direita",
  T_49_META_TYP_1013_I2_D: "Texto do número redondo",
  T_49_META_TYP_1013_I3_D: "Parâmetros da Chave de Rodada",
  T_49_META_TYP_1014_I2_D: "Texto do título da primeira pontuação",
  T_49_META_TYP_1014_I3_D: "O primeiro valor de pontuação",
  T_49_META_TYP_1014_I4_D: "Parâmetros do Primeiro Pontuação",
  T_49_META_TYP_1014_I5_D: "Texto do título da segunda pontuação",
  T_49_META_TYP_1014_I6_D: "O segundo valor da pontuação",
  T_49_META_TYP_1014_I7_D: "Parâmetros do Segundo Pontuação",
  T_49_META_TYP_1016_I1_D: "Exibir o status correspondente de acordo com o valor, vitória (1), derrota (2), empate (3), booyah (4)",
  T_49_META_TYP_1016_I2_D: "Mostrar as pontuações de 2 equipes. Se verdadeiro, será exibido, caso contrário, será oculto.",
  T_49_META_TYP_1016_I3_D: "Pontuação da Equipe à Esquerda",
  T_49_META_TYP_1016_I4_D: "Pontuação da Equipe à Direita",
  T_49_META_TYP_1016_I5_D: "Carimbo de data e hora do fim da fase",
  T_49_META_TYP_1017_I1_D: "Nome da Equipe à Esquerda",
  T_49_META_TYP_1017_I2_D: "Descrição à Esquerda",
  T_49_META_TYP_1017_I3_D: "Nome da Equipe à Direita",
  T_49_META_TYP_1017_I4_D: "Descrição à Direita",
  T_49_META_TYP_1018_I1_D: "Número da Rodada",
  T_49_META_TYP_1018_I4_D: "Pontuação do time esquerdo",
  T_49_META_TYP_1018_I6_D: "Pontuação do time certo",
  T_49_META_TYP_1019_I1_D: "Ganhar, perder e empatar correspondem a 1 2 3 respectivamente",
  T_49_META_TYP_102_I0_D: "Tipo de fonte de ressurreição, jogador ressuscitado da morte",
  T_49_META_TYP_102_I1_D: "Tipo de fonte de ressurreição, o jogador ressuscita de um estado derrubado",
  T_49_META_TYP_1020_I2_D: "A chave de texto a ser exibida",
  T_49_META_TYP_1020_I3_D: "Matriz de parâmetros correspondente à chave de texto",
  T_49_META_TYP_1021_I1_D: "Tempo base em segundos",
  T_49_META_TYP_1021_I2_D: "Duração em segundos",
  T_49_META_TYP_1021_I3_D: "Posição de exibição. Quando há um alvo a seguir, é o deslocamento relativo à origem do alvo. Quando não há alvo a seguir, é a coordenada da tela. O valor padrão é Vector3(0)",
  T_49_META_TYP_1022_I2_D: "A chave de texto a ser exibida",
  T_49_META_TYP_1022_I3_D: "Matriz de parâmetros correspondente à chave de texto",
  T_49_META_TYP_1023_I1_D: "Mostrar pontuações da equipe é exibido quando verdadeiro, caso contrário fechado",
  T_49_META_TYP_1023_I4_D: "Exibir quando o status do jogador for verdadeiro, caso contrário, fechar",
  T_49_META_TYP_1023_I5_D: "A matriz de status do jogador esquerdo, 0: número de jogadores vivos, 1: número de jogadores mortos, 2: número de jogadores mortos",
  T_49_META_TYP_1023_I6_D: "A matriz de status do jogador certo, 0: número de jogadores vivos, 1: número de jogadores mortos, 2: número de jogadores mortos",
  T_49_META_TYP_1023_I7_D: "Contagem de Bandeiras à Esquerda",
  T_49_META_TYP_1023_I8_D: "Contagem de bandeiras do aliado à direita",
  T_49_META_TYP_1024_I2_D: "Desvio",
  T_49_META_TYP_1024_I3_D: "Classificação",
  T_49_META_TYP_1024_I4_D: "Cor da equipe",
  T_49_META_TYP_1024_I5_D: "Nome do ícone",
  T_49_META_TYP_1024_I6_D: "Se a borda for verdadeira, ela será exibida, caso contrário, será fechada.",
  T_49_META_TYP_1024_I7_D: "Chave do texto de pontuação",
  T_49_META_TYP_1024_I8_D: "Parâmetros da chave do texto de pontuação",
  T_49_META_TYP_1028_I1_D: "Número de colegas vivos à esquerda",
  T_49_META_TYP_1028_I2_D: "Número de colegas vivos à direita",
  T_49_META_TYP_1028_I3_D: "Cor de fundo à esquerda",
  T_49_META_TYP_1028_I4_D: "Cor de fundo à direita",
  T_49_META_TYP_1028_I5_D: "Nome do ícone à esquerda",
  T_49_META_TYP_1028_I6_D: "Nome do ícone à direita",
  T_49_META_TYP_1029_I1_D: "Nome do ícone",
  T_49_META_TYP_1029_I2_D: "Nome do ícone de fundo",
  T_49_META_TYP_103_I0_D: "Arma Primária A",
  T_49_META_TYP_103_I1_D: "Arma Primária B",
  T_49_META_TYP_103_I10_D: "Bomba congelante",
  T_49_META_TYP_103_I11_D: "Muro de Gelo",
  T_49_META_TYP_103_I12_D: "Mina terrestre",
  T_49_META_TYP_103_I13_D: "Torre automática",
  T_49_META_TYP_103_I14_D: "Granada Falsa",
  T_49_META_TYP_103_I16_D: "Skate, camuflagem...",
  T_49_META_TYP_103_I2_D: "Arma Secundária",
  T_49_META_TYP_103_I3_D: "Armas explosivas",
  T_49_META_TYP_103_I5_D: "Arma Pesada",
  T_49_META_TYP_1030_I3_D: "Número de colegas vivos à esquerda",
  T_49_META_TYP_1030_I4_D: "Número de colegas vivos à direita",
  T_49_META_TYP_1030_I5_D: "Nome do ícone da equipe à esquerda",
  T_49_META_TYP_1030_I6_D: "Nome do ícone da equipe à direita",
  T_49_META_TYP_1031_I2_D: "Descrição da informação rápida",
  T_49_META_TYP_1031_I3_D: "Carimbo de data/hora de início da contagem regressiva em segundos",
  T_49_META_TYP_1031_I4_D: "Parâmetros de dicas",
  T_49_META_TYP_1032_I1_D: "Tipo de dica",
  T_49_META_TYP_1032_I3_D: "Parâmetros de descrição",
  T_49_META_TYP_1033_I1_D: "Fase de troca, 0 significa que a rodada atual foi resolvida, 1 significa que a próxima rodada começa",
  T_49_META_TYP_1033_I10_D: "Texto do prompt de falha, deixe em branco para o padrão",
  T_49_META_TYP_1033_I11_D: "Título da renda da rodada",
  T_49_META_TYP_1033_I12_D: "Renda da rodada",
  T_49_META_TYP_1033_I13_D: "Títulos de Detalhes de Renda da Rodada",
  T_49_META_TYP_1033_I14_D: "A lista detalhada dos valores de renda redonda corresponde à lista detalhada do título acima.",
  T_49_META_TYP_1033_I15_D: "Apelido do jogador MVP",
  T_49_META_TYP_1033_I16_D: "Índice da próxima rodada",
  T_49_META_TYP_1033_I17_D: "Ponto decisivo",
  T_49_META_TYP_1033_I18_D: "Última rodada",
  T_49_META_TYP_1033_I6_D: "Nome do ícone da equipe à esquerda",
  T_49_META_TYP_1033_I7_D: "Nome do ícone da equipe à direita",
  T_49_META_TYP_1033_I8_D: "Exibir o status correspondente de acordo com o valor, vitória (1), fracasso (2)",
  T_49_META_TYP_1033_I9_D: "Texto do prompt de vitória, deixe em branco para o padrão",
  T_49_META_TYP_1036_I1_D: "Indica quantos níveis existem",
  T_49_META_TYP_1036_I2_D: "Indica o nível atual do zumbi",
  T_49_META_TYP_1037_I1_D: "Indica quantos pontos são exibidos",
  T_49_META_TYP_1039_I3_D: "Carimbo de data/hora de início da contagem regressiva em segundos",
  T_49_META_TYP_104_I0_D: "Estilo A",
  T_49_META_TYP_104_I1_D: "Estilo B",
  T_49_META_TYP_104_I2_D: "Estilo C",
  T_49_META_TYP_1040_I10_D: "Descrições das cartas",
  T_49_META_TYP_1040_I11_D: "O índice do item selecionado, começando em 0. Se for menor que 0, significa desseleção.",
  T_49_META_TYP_1040_I12_D: "Nomes dos botões",
  T_49_META_TYP_1040_I13_D: "Cores dos botões",
  T_49_META_TYP_1040_I2_D: "Chave da contagem regressiva",
  T_49_META_TYP_1040_I3_D: "Tempo da contagem regressiva",
  T_49_META_TYP_1040_I4_D: "Chave de descrição",
  T_49_META_TYP_1040_I5_D: "Descrição da matriz de parâmetros de informação",
  T_49_META_TYP_1040_I6_D: "Fundos das cartas",
  T_49_META_TYP_1040_I7_D: "Cores de fundo das cartas",
  T_49_META_TYP_1040_I8_D: "Ícones das cartas",
  T_49_META_TYP_1040_I9_D: "Nomes das cartas",
  T_49_META_TYP_1041_I2_D: "Posição",
  T_49_META_TYP_1041_I3_D: "Imagem do ícone",
  T_49_META_TYP_1041_I4_D: "Rótulo",
  T_49_META_TYP_1041_I5_D: "Cor de fundo",
  T_49_META_TYP_1042_I1_D: "Posição local",
  T_49_META_TYP_1043_I4_D: "Cor",
  T_49_META_TYP_1043_I5_D: "Chave do rótulo",
  T_49_META_TYP_1043_I6_D: "Parâmetros do rótulo",
  T_49_META_TYP_1045_I2_D: "Ícone de botão",
  T_49_META_TYP_1045_I3_D: "Cor do ícone",
  T_49_META_TYP_1045_I4_D: "Tamanho, largura e altura são os mesmos",
  T_49_META_TYP_1045_I5_D: "Posição relativa ao ponto de ancoragem inferior direito",
  T_49_META_TYP_1045_I6_D: "Quantidade de carga, oculta se for menor que 0",
  T_49_META_TYP_1045_I7_D: "Tempo de início do CD, em milissegundos",
  T_49_META_TYP_1045_I8_D: "Duração do CD em milissegundos",
  T_49_META_TYP_1045_I9_D: "Se for Verdadeiro, o botão ficará acinzentado e, se for Falso, ele será restaurado.",
  T_49_META_TYP_106_I1_D: "Habilitar",
  T_49_META_TYP_106_I2_D: "Desativar",
  T_49_META_TYP_109_I0_D: "ID do Canal de Chat",
  T_49_META_TYP_109_I1_D: "Lista de Jogadores",
  T_49_META_TYP_11_I0_D: "O jogo atual está em um estado ilegal? Se estiver em um estado ilegal, significa que o jogo perdeu seu valor para confronto. É recomendado terminar o jogo diretamente.",
  T_49_META_TYP_11_I1_D: "A duração do jogo atual, em milissegundos",
  T_49_META_TYP_11_I10_D: "Se deve reiniciar o equipamento a cada rodada",
  T_49_META_TYP_11_I11_D: "Se deve habilitar o mecanismo do círculo de veneno",
  T_49_META_TYP_11_I12_D: "Tamanho da Zona Segura",
  T_49_META_TYP_11_I13_D: "Início da diminuição da zona",
  T_49_META_TYP_11_I14_D: "Duração da diminuição da zona",
  T_49_META_TYP_11_I15_D: "Dano fora da zona",
  T_49_META_TYP_11_I18_D: "Tipo de Ressurgimento",
  T_49_META_TYP_11_I2_D: "O índice da rodada atual, através do qual a entidade da rodada atual pode ser obtida",
  T_49_META_TYP_11_I27_D: "Contagem total de rodadas",
  T_49_META_TYP_11_I3_D: "O índice do estágio atual, por meio do qual a entidade do estágio atual pode ser obtida",
  T_49_META_TYP_11_I32_D: "A quantidade de moedas de ouro obtidas no início da rodada",
  T_49_META_TYP_11_I33_D: "Quantidade de moedas de ouro ganhas ao matar",
  T_49_META_TYP_11_I34_D: "Quantidade de moedas de ouro ganhas ao vencer",
  T_49_META_TYP_11_I35_D: "Se deve exibir a interface da carteira",
  T_49_META_TYP_11_I36_D: "Entidade Skybox",
  T_49_META_TYP_11_I37_D: "Quadros de execução acumulados desde o início do jogo",
  T_49_META_TYP_11_I38_D: "Habilitar Movimento",
  T_49_META_TYP_11_I39_D: "Se deve personalizar a liquidação",
  T_49_META_TYP_11_I4_D: "ID do modelo do modo UGC predefinido",
  T_49_META_TYP_11_I40_D: "É permitido entrar no meio do caminho?",
  T_49_META_TYP_11_I41_D: "Ative o modo de baixa taxa de quadros, o jogo rodará a 15 FPS, caso contrário, 30 FPS",
  T_49_META_TYP_11_I42_D: "O intervalo entre duas atualizações de quadro lógico do servidor de jogo",
  T_49_META_TYP_11_I43_D: "Intervalo de atualização de quadro fixo em milissegundos",
  T_49_META_TYP_11_I5_D: "Se desativado, as ressurreições dos jogadores serão desabilitadas.",
  T_49_META_TYP_11_I6_D: "Se fechado, a ressurreição do bot é desabilitada",
  T_49_META_TYP_11_I7_D: "Tempo de ressurreição, em segundos",
  T_49_META_TYP_11_I8_D: "Número total de equipes no jogo",
  T_49_META_TYP_11_I9_D: "Número de membros por equipe",
  T_49_META_TYP_110_I0_D: "Canal A",
  T_49_META_TYP_110_I1_D: "Canal B",
  T_49_META_TYP_110_I2_D: "Canal C",
  T_49_META_TYP_110_I3_D: "Canal D",
  T_49_META_TYP_110_I4_D: "Canal E",
  T_49_META_TYP_110_I5_D: "Canal F",
  T_49_META_TYP_111_I1_D: "Corrida",
  T_49_META_TYP_111_I2_D: "Ataque",
  T_49_META_TYP_111_I3_D: "Pular",
  T_49_META_TYP_111_I4_D: "Saltar por cima",
  T_49_META_TYP_111_I5_D: "Dirigir",
  T_49_META_TYP_111_I6_D: "Entrar no Veículo",
  T_49_META_TYP_111_I7_D: "Sair do Veículo",
  T_49_META_TYP_111_I8_D: "Dirigir Veículo",
  T_49_META_TYP_112_I0_D: "Habilitar",
  T_49_META_TYP_112_I1_D: "Desativar",
  T_49_META_TYP_112_I2_D: "Invisível",
  T_49_META_TYP_117_I0_D: "Palmas",
  T_49_META_TYP_117_I1_D: "Hi-hat",
  T_49_META_TYP_117_I2_D: "Bumbo",
  T_49_META_TYP_117_I3_D: "Hi-hat aberto",
  T_49_META_TYP_117_I4_D: "Ride",
  T_49_META_TYP_117_I5_D: "Tarola",
  T_49_META_TYP_118_I0_D: "Se todos os membros do acampamento estão mortos",
  T_49_META_TYP_118_I1_D: "Lista de todos os jogadores",
  T_49_META_TYP_118_I2_D: "Grupos Aliados",
  T_49_META_TYP_118_I3_D: "Grupos Atacáveis",
  T_49_META_TYP_118_I4_D: "Se deve exibir o nome da IU",
  T_49_META_TYP_118_I5_D: "Se deve exibir informações do mapa",
  T_49_META_TYP_118_I6_D: "Se deve exibir",
  T_49_META_TYP_118_I7_D: "Se deve exibir",
  T_49_META_TYP_118_I8_D: "Todos os Membros",
  T_49_META_TYP_118_I9_D: "Mostrar Mensagem Rápida",
  T_49_META_TYP_119_I0_D: "Sim",
  T_49_META_TYP_119_I1_D: "Não",
  T_49_META_TYP_120_I1_D: "A entidade alvo a seguir, o padrão é vazio",
  T_49_META_TYP_120_I2_D: "Cor da interface do usuário",
  T_49_META_TYP_120_I3_D: "Comprimento da interface do usuário",
  T_49_META_TYP_120_I4_D: "Valor de progresso atual, 0 a 1,0",
  T_49_META_TYP_120_I5_D: "Posição de exibição. Quando há um alvo a seguir, é o deslocamento relativo à origem do alvo. Quando não há alvo a seguir, é a coordenada da tela. O valor padrão é Vector3(0)",
  T_49_META_TYP_121_I0_D: "3 Segundos",
  T_49_META_TYP_121_I1_D: "5 Segundos",
  T_49_META_TYP_121_I2_D: "10 Segundos",
  T_49_META_TYP_121_I3_D: "15 Segundos",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999 Segundos",
  T_49_META_TYP_122_I0_D: "Recurso de Céu",
  T_49_META_TYP_122_I1_D: "Cor clara",
  T_49_META_TYP_122_I10_D: "O GUID da subcena",
  T_49_META_TYP_122_I11_D: "Interruptor de efeito de névoa",
  T_49_META_TYP_122_I12_D: "Modo de efeito de neblina",
  T_49_META_TYP_122_I13_D: "Densidade exponencial de neblina",
  T_49_META_TYP_122_I14_D: "A distância inicial da névoa linear",
  T_49_META_TYP_122_I15_D: "Distância final da névoa linear",
  T_49_META_TYP_122_I16_D: "Habilitar o recurso de efeito de neblina",
  T_49_META_TYP_122_I17_D: "Ângulo de rotação da fonte de luz principal",
  T_49_META_TYP_122_I18_D: "Habilitar o recurso de ângulo de rotação da fonte de luz principal",
  T_49_META_TYP_122_I2_D: "Intensidade da luz",
  T_49_META_TYP_122_I3_D: "Escuridão",
  T_49_META_TYP_122_I4_D: "Intensidade da sombra",
  T_49_META_TYP_122_I5_D: "Umidade do Terreno",
  T_49_META_TYP_122_I6_D: "Reflexo da Lente",
  T_49_META_TYP_122_I7_D: "Cor da Neblina",
  T_49_META_TYP_122_I8_D: "Cor do ambiente",
  T_49_META_TYP_123_I0_D: "Dia",
  T_49_META_TYP_123_I1_D: "Noite",
  T_49_META_TYP_123_I2_D: "Crepúsculo",
  T_49_META_TYP_123_I3_D: "Vista da Cidade",
  T_49_META_TYP_123_I4_D: "Céu Colorido",
  T_49_META_TYP_123_I5_D: "Lua de Gelo",
  T_49_META_TYP_124_I0_D: "Curto Alcance",
  T_49_META_TYP_124_I1_D: "Distância média",
  T_49_META_TYP_124_I2_D: "Longa distância",
  T_49_META_TYP_125_I0_D: "Cor Difusa",
  T_49_META_TYP_125_I2_D: "Textura Difusa",
  T_49_META_TYP_125_I4_D: "Alfa Difuso",
  T_49_META_TYP_126_I1_D: "Nome",
  T_49_META_TYP_126_I2_D: "Valor do progresso atual",
  T_49_META_TYP_126_I3_D: "Valor máximo de progresso",
  T_49_META_TYP_126_I4_D: "Coordenadas da tela, o padrão é Vector3(0)",
  T_49_META_TYP_126_I5_D: "comprimento da barra de progresso. O valor padrão atual é o comprimento da UI no prefab.",
  T_49_META_TYP_127_I0_D: "Translação ao longo de um determinado eixo, três eixos podem ser combinados",
  T_49_META_TYP_127_I1_D: "Girar ao longo de um determinado eixo, três eixos podem ser combinados",
  T_49_META_TYP_127_I2_D: "Amplie ao longo de um determinado eixo, você pode combinar três eixos",
  T_49_META_TYP_128_I0_D: "Arbustos",
  T_49_META_TYP_128_I1_D: "Abóbora",
  T_49_META_TYP_128_I2_D: "Espantalho",
  T_49_META_TYP_128_I3_D: "Armário",
  T_49_META_TYP_129_I0_D: "Saque aleatório",
  T_49_META_TYP_129_I1_D: "Munições AR",
  T_49_META_TYP_129_I2_D: "Munições SMG",
  T_49_META_TYP_129_I3_D: "Munições SN",
  T_49_META_TYP_129_I4_D: "Munições HG",
  T_49_META_TYP_129_I5_D: "Bala SG",
  T_49_META_TYP_129_I6_D: "Munições Arco",
  T_49_META_TYP_13_I1_D: "Coordenadas de âncora relativas ao nó pai",
  T_49_META_TYP_13_I10_D: "Diferença de tamanho entre widget e caixa de âncora",
  T_49_META_TYP_13_I11_D: "Pivô",
  T_49_META_TYP_13_I12_D: "profundidade",
  T_49_META_TYP_13_I14_D: "A ordem de todos os nós filhos sob o mesmo nó pai",
  T_49_META_TYP_13_I15_D: "ID pai",
  T_49_META_TYP_13_I16_D: "ID Único",
  T_49_META_TYP_13_I17_D: "Prioridade",
  T_49_META_TYP_13_I18_D: "Posição real",
  T_49_META_TYP_13_I2_D: "Largura",
  T_49_META_TYP_13_I4_D: "Ângulo de rotação do eixo Z",
  T_49_META_TYP_13_I6_D: "O ID interno do controle no Prefab",
  T_49_META_TYP_13_I7_D: "Entidade de IU",
  T_49_META_TYP_13_I8_D: "Âncora mínima",
  T_49_META_TYP_13_I9_D: "Âncora máxima",
  T_49_META_TYP_130_I0_D: "Consumíveis aleatórios Saque",
  T_49_META_TYP_130_I1_D: "Kit de Primeiros Socorros",
  T_49_META_TYP_130_I2_D: "Kit de reparo",
  T_49_META_TYP_130_I3_D: "Horizonte",
  T_49_META_TYP_130_I4_D: "Inalador",
  T_49_META_TYP_131_I0_D: "Saque de armadura aleatório",
  T_49_META_TYP_131_I1_D: "Armadura de nível 1",
  T_49_META_TYP_131_I2_D: "Armadura de segundo nível",
  T_49_META_TYP_131_I3_D: "Armadura de nível 3",
  T_49_META_TYP_132_I0_D: "Lançamentos aleatórios de itens",
  T_49_META_TYP_132_I1_D: "Granada",
  T_49_META_TYP_132_I4_D: "Bomba Congelante",
  T_49_META_TYP_133_I0_D: "Saque de escopo aleatório",
  T_49_META_TYP_133_I1_D: "Mira x2",
  T_49_META_TYP_133_I2_D: "Mira x4",
  T_49_META_TYP_133_I3_D: "Mira térmica",
  T_49_META_TYP_134_I0_D: "Item de Arma Aleatório",
  T_49_META_TYP_134_I5_D: "Espingarda",
  T_49_META_TYP_134_I8_D: "Arma de Futebol",
  T_49_META_TYP_135_I0_D: "Pontos de bala de saque",
  T_49_META_TYP_136_I0_D: "Pontos de itens consumíveis de saque",
  T_49_META_TYP_137_I0_D: "Pontos de itens consumíveis de saque",
  T_49_META_TYP_138_I0_D: "Ponto de zoom do saque",
  T_49_META_TYP_139_I0_D: "Pontos de armadura de saque",
  T_49_META_TYP_14_I0_D: "A saúde atual do jogador",
  T_49_META_TYP_14_I1_D: "A saúde máxima atual do jogador",
  T_49_META_TYP_14_I11_D: "Facção do jogador",
  T_49_META_TYP_14_I12_D: "O multiplicador de dano do jogador, como 2x, é 2,0",
  T_49_META_TYP_14_I13_D: "Use exatamente o mesmo esqueleto do personagem masculino ou feminino. 0 significa não substituir o modelo",
  T_49_META_TYP_14_I14_D: "Não entrará em conflito com a escala de velocidade existente",
  T_49_META_TYP_14_I15_D: "Não entrará em conflito com a escala de altura de salto existente",
  T_49_META_TYP_14_I16_D: "Identidade, 0 Jogador Normal, 1 Caçador, 2 Zumbi Mãe, 3 Zumbi Normal, 4 Zumbi Evoluído Tipo 1, 5 Zumbi Evoluído Tipo 2, 6 Zumbi Evoluído Tipo 3",
  T_49_META_TYP_14_I17_D: "Nível zumbi, 1~3",
  T_49_META_TYP_14_I19_D: "Apelido do jogador",
  T_49_META_TYP_14_I2_D: "Determine se o jogador atual é um jogador de IA. A IA geralmente é um NPC ou um monstro PVE.",
  T_49_META_TYP_14_I20_D: "Ao receber dano, a porcentagem de dano pode ser reduzida ou aumentada.",
  T_49_META_TYP_14_I21_D: "EP atual do jogador",
  T_49_META_TYP_14_I22_D: "EP máximo do jogador",
  T_49_META_TYP_14_I23_D: "A principal arma atualmente em mãos",
  T_49_META_TYP_14_I24_D: "Perda de Equipamento ao Ser Eliminado",
  T_49_META_TYP_14_I26_D: "Tipo de Assistência ao Alvo",
  T_49_META_TYP_14_I27_D: "Permitir Bloqueio por Assistência de Mira",
  T_49_META_TYP_14_I28_D: "Alternar bate-papo por voz: verdadeiro desativa a voz, falso ativa a voz",
  T_49_META_TYP_14_I29_D: "Alternar bate-papo rápido: verdadeiro desativa a voz, falso ativa a voz",
  T_49_META_TYP_14_I3_D: "Status do Jogador",
  T_49_META_TYP_14_I30_D: "Canal",
  T_49_META_TYP_14_I35_D: "Alternar coleta de itens: verdadeiro para desabilitar a coleta, falso para habilitar a coleta",
  T_49_META_TYP_14_I36_D: "Alternar descarte de itens: verdadeiro para evitar que itens sejam descartados, falso para permitir que itens sejam descartados",
  T_49_META_TYP_14_I37_D: "Alvos Atacáveis",
  T_49_META_TYP_14_I38_D: "Jogadores Amigáveis",
  T_49_META_TYP_14_I39_D: "Grupo",
  T_49_META_TYP_14_I4_D: "O tempo de sobrevivência do jogador. Se o jogador morrer, o tempo é recalculado.",
  T_49_META_TYP_14_I40_D: "Número no Grupo",
  T_49_META_TYP_14_I41_D: "A câmera que o jogador está usando",
  T_49_META_TYP_14_I42_D: "Gravidade Personalizada",
  T_49_META_TYP_14_I43_D: "Capacete",
  T_49_META_TYP_14_I44_D: "Colete",
  T_49_META_TYP_14_I5_D: "A invencibilidade do jogador",
  T_49_META_TYP_14_I52_D: "UID do usuário",
  T_49_META_TYP_14_I53_D: "Redução de Dano por Acerto na Cabeça",
  T_49_META_TYP_14_I54_D: "AVATAR vinculado ao jogador",
  T_49_META_TYP_14_I55_D: "Gênero",
  T_49_META_TYP_14_I56_D: "IDs de Skins de Arma",
  T_49_META_TYP_14_I57_D: "Ponto de spawn do jogador",
  T_49_META_TYP_14_I58_D: "ponto de ressurreição do jogador. Se não houver registro de ponto de verificação, o ponto de nascimento é usado, caso contrário, o ponto de verificação é usado.",
  T_49_META_TYP_14_I59_D: "Posição atual do jogador",
  T_49_META_TYP_14_I6_D: "entidade à qual o jogador pertence",
  T_49_META_TYP_14_I60_D: "A direção atual do jogador",
  T_49_META_TYP_14_I61_D: "Nó usado para acessar ossos da pele",
  T_49_META_TYP_14_I62_D: "Mochila",
  T_49_META_TYP_14_I63_D: "Pontos de Escudo Temporários",
  T_49_META_TYP_14_I64_D: "ID da Pele do Veículo",
  T_49_META_TYP_14_I65_D: "Pular Animação de Queda",
  T_49_META_TYP_14_I66_D: "Sem Dano de Queda",
  T_49_META_TYP_14_I67_D: "Item em Mão Atual",
  T_49_META_TYP_14_I68_D: "Lista de Itens Proibidos",
  T_49_META_TYP_14_I69_D: "ID do recurso do jogador",
  T_49_META_TYP_14_I7_D: "O ID do ponto de verificação atual",
  T_49_META_TYP_14_I70_D: "Alvo para enviar mensagem de solicitação de compra para",
  T_49_META_TYP_14_I71_D: "O ID do recurso Emote que está sendo reproduzido no momento",
  T_49_META_TYP_14_I72_D: "Se o Emote que está sendo reproduzido no momento está em loop",
  T_49_META_TYP_14_I73_D: "Lidando com o estado de knockdown",
  T_49_META_TYP_14_I74_D: "Se deve habilitar o salto de dano, o padrão é Verdadeiro, o que significa que está habilitado",
  T_49_META_TYP_14_I76_D: "Posso desistir no meio do caminho?",
  T_49_META_TYP_14_I77_D: "As informações do traje que o jogador precisa manter ao se transformar em outro personagem",
  T_49_META_TYP_14_I8_D: "O ID do ponto de verificação para o qual o alvo está indo",
  T_49_META_TYP_140_I0_D: "Onda 1",
  T_49_META_TYP_140_I1_D: "Onda 2",
  T_49_META_TYP_140_I2_D: "Onda 3",
  T_49_META_TYP_140_I3_D: "Contínuo",
  T_49_META_TYP_141_I0_D: "Item de Futebol Aleatório",
  T_49_META_TYP_141_I1_D: "Item de Escudo de Futebol",
  T_49_META_TYP_141_I2_D: "Granada Congelante",
  T_49_META_TYP_142_I0_D: "Item de Futebol",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (tiro)",
  T_49_META_TYP_147_I1_D: "Terceira pessoa",
  T_49_META_TYP_147_I2_D: "Primeira Pessoa (Tiro)",
  T_49_META_TYP_147_I3_D: "Vista superior",
  T_49_META_TYP_147_I4_D: "Rolagem horizontal",
  T_49_META_TYP_147_I5_D: "Câmera Personalizada",
  T_49_META_TYP_147_I6_D: "Perseguir",
  T_49_META_TYP_147_I7_D: "Câmera controlada pelo jogador, com movimento livre",
  T_49_META_TYP_147_I8_D: "Nova câmera em primeira pessoa",
  T_49_META_TYP_148_I0_D: "Fornece uma variedade de tipos de câmeras predefinidos, bem como tipos de câmeras personalizados",
  T_49_META_TYP_148_I1_D: "O campo de visão é o ângulo de visão da câmera",
  T_49_META_TYP_148_I10_D: "Tipo de animação de troca de câmera",
  T_49_META_TYP_148_I11_D: "Só entra em vigor quando o tipo de troca é suave. O tempo de transição para alternar para esta câmera é em milissegundos.",
  T_49_META_TYP_148_I12_D: "Quando há uma obstrução entre a câmera e o objeto que está sendo seguido, o modo de movimento da câmera",
  T_49_META_TYP_148_I13_D: "Como a câmera renderiza a imagem",
  T_49_META_TYP_148_I14_D: "Siga o sistema de coordenadas de referência de deslocamento do objeto",
  T_49_META_TYP_148_I15_D: "Observe o sistema de coordenadas de referência de deslocamento do objeto",
  T_49_META_TYP_148_I16_D: "A máscara de camada de renderização da câmera pode filtrar os objetos renderizados da câmera por nível de visibilidade",
  T_49_META_TYP_148_I17_D: "Restrição de Ângulo de Visão",
  T_49_META_TYP_148_I2_D: "Geralmente se refere ao deslocamento da posição da câmera em relação à posição de origem do jogador. O significado específico varia para diferentes tipos de câmera.",
  T_49_META_TYP_148_I3_D: "Geralmente se refere ao deslocamento do ponto de foco da câmera em relação à posição de origem do jogador. O significado específico varia para diferentes tipos de câmera.",
  T_49_META_TYP_148_I4_D: "O ângulo de rotação vertical da câmera",
  T_49_META_TYP_148_I5_D: "O ângulo de rotação horizontal da câmera",
  T_49_META_TYP_148_I7_D: "O alvo que a câmera segue",
  T_49_META_TYP_148_I8_D: "O que a câmera está olhando",
  T_49_META_TYP_148_I9_D: "O jogador que está usando a câmera no momento",
  T_49_META_TYP_15_I0_D: "Se todos os membros da equipe estão mortos no momento",
  T_49_META_TYP_15_I1_D: "Lista de todos os membros da equipe",
  T_49_META_TYP_15_I3_D: "Lista de times inimigos",
  T_49_META_TYP_15_I4_D: "Lista de Equipes Amigáveis",
  T_49_META_TYP_15_I5_D: "Equipe No.",
  T_49_META_TYP_150_I0_D: "Durabilidade",
  T_49_META_TYP_150_I1_D: "O raio dos hemisférios em ambas as extremidades da cápsula",
  T_49_META_TYP_150_I2_D: "Fator de Dano",
  T_49_META_TYP_152_I1_D: "Gravidade Personalizada",
  T_49_META_TYP_152_I2_D: "Se deve exibir o gatilho, Verdadeiro significa exibir",
  T_49_META_TYP_154_I0_D: "Não pode usar duas armas",
  T_49_META_TYP_154_I1_D: "Só pode ser empunhado duas vezes com o mesmo tipo de arma",
  T_49_META_TYP_154_I2_D: "Pode ser empunhado com outra arma ou com você mesmo",
  T_49_META_TYP_155_I0_D: "nota",
  T_49_META_TYP_155_I1_D: "Durabilidade Máx.",
  T_49_META_TYP_155_I2_D: "Durabilidade Atual",
  T_49_META_TYP_155_I3_D: "Fator de Redução de Dano",
  T_49_META_TYP_155_I4_D: "Fator de Redução de Dano de Explosão",
  T_49_META_TYP_155_I5_D: "Pode Custar Durabilidade",
  T_49_META_TYP_155_I6_D: "Pode Destruir",
  T_49_META_TYP_156_I1_D: "Durabilidade Máx.",
  T_49_META_TYP_156_I2_D: "Durabilidade Atual",
  T_49_META_TYP_156_I3_D: "Fator de Redução de Dano",
  T_49_META_TYP_156_I4_D: "Fator de Redução de Dano de Explosão",
  T_49_META_TYP_156_I5_D: "Pode Custar Durabilidade",
  T_49_META_TYP_156_I6_D: "Pode Destruir",
  T_49_META_TYP_157_I0_D: "Sem animação",
  T_49_META_TYP_157_I1_D: "Suave",
  T_49_META_TYP_158_I2_D: "Enumeração do tipo de âncora da IU, o valor padrão é 9 (Centro)",
  T_49_META_TYP_158_I6_D: "Chave do rótulo",
  T_49_META_TYP_158_I7_D: "Parâmetros do rótulo",
  T_49_META_TYP_158_I8_D: "Transição Habilitada",
  T_49_META_TYP_16_I1_D: "O ID do item correspondente à entidade",
  T_49_META_TYP_16_I2_D: "Usado somente ao carregar objetos estaticamente para determinar se o NavMesh é gerado estaticamente",
  T_49_META_TYP_16_I3_D: "Se é bloqueio dinâmico do NavMesh",
  T_49_META_TYP_16_I4_D: "Carregamento assíncrono",
  T_49_META_TYP_160_I0_D: "Tijolo A",
  T_49_META_TYP_160_I1_D: "Azulejo A",
  T_49_META_TYP_160_I10_D: "Areia A",
  T_49_META_TYP_160_I11_D: "Neve A",
  T_49_META_TYP_160_I12_D: "Madeira A",
  T_49_META_TYP_160_I13_D: "Tom A",
  T_49_META_TYP_160_I14_D: "Relva B",
  T_49_META_TYP_160_I15_D: "Tijolo B",
  T_49_META_TYP_160_I16_D: "Tijolo C",
  T_49_META_TYP_160_I17_D: "Limpar",
  T_49_META_TYP_160_I2_D: "Azulejo B",
  T_49_META_TYP_160_I3_D: "Azulejo C",
  T_49_META_TYP_160_I4_D: "Bambu A",
  T_49_META_TYP_160_I5_D: "Cimento A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Relva A",
  T_49_META_TYP_160_I8_D: "Gelo A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Se deve habilitar a colisão",
  T_49_META_TYP_165_I1_D: "Se deve atuar como um gatilho",
  T_49_META_TYP_165_I2_D: "Nível físico, configure o nível no módulo físico, até 16",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "Tipo de Textura de Efeito Visual",
  T_49_META_TYP_170_I0_D: "Está visível? Se não estiver visível, o cliente para de renderizar o alvo.",
  T_49_META_TYP_170_I1_D: "Nível visível, intervalo de valores [0,15], afeta a visibilidade na câmera",
  T_49_META_TYP_171_I0_D: "Energia",
  T_49_META_TYP_172_I0_D: "Número de balas",
  T_49_META_TYP_173_I0_D: "Capacidade Extra da Mochila",
  T_49_META_TYP_173_I1_D: "A configuração da pele dos jogadores fora do jogo tem prioridade",
  T_49_META_TYP_173_I2_D: "ID da skin da mochila, configuração da skin da mochila",
  T_49_META_TYP_174_I2_D: "Dano Máximo",
  T_49_META_TYP_174_I4_D: "Velocidade de Arremesso",
  T_49_META_TYP_174_I5_D: "Atraso de explosão, em segundos",
  T_49_META_TYP_174_I6_D: "Fator de Dano em Si",
  T_49_META_TYP_174_I7_D: "Fator de Dano para Aliado",
  T_49_META_TYP_174_I8_D: "Fator de Dano para Veículos",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Raio da Área Congelada",
  T_49_META_TYP_175_I1_D: "Duração da área congelada, em segundos",
  T_49_META_TYP_176_I0_D: "O principal tipo de arma",
  T_49_META_TYP_176_I1_D: "Subtipo de Arma",
  T_49_META_TYP_177_I0_D: "Quando há uma obstrução entre a câmera e o objeto que está sendo seguido, a câmera não faz nenhuma alteração.",
  T_49_META_TYP_177_I1_D: "Quando houver uma obstrução entre a câmera e o objeto que está sendo seguido, a câmera se moverá para mais perto do objeto que está sendo seguido.",
  T_49_META_TYP_177_I2_D: "Quando há um oclusor entre a câmera e o objeto a seguir, o oclusor se tornará semitransparente",
  T_49_META_TYP_178_I0_D: "Quando a câmera observa um objeto, os objetos mais próximos parecem maiores e os mais distantes parecem menores.",
  T_49_META_TYP_178_I1_D: "Quando a câmera observa um objeto, os objetos próximos e distantes têm o mesmo tamanho",
  T_49_META_TYP_184_I0_D: "Especifique o UUID do recurso a ser renderizado.",
  T_49_META_TYP_185_I0_D: "Renderize a malha do modelo para usar",
  T_49_META_TYP_185_I1_D: "Lista de materiais a serem usados para renderização",
  T_49_META_TYP_187_I0_D: "ID do item",
  T_49_META_TYP_190_I0_D: "Estado aberto",
  T_49_META_TYP_190_I1_D: "Resultados do jogo",
  T_49_META_TYP_190_I10_D: "Lista de Pontuações 1",
  T_49_META_TYP_190_I11_D: "Lista de Pontuações 2",
  T_49_META_TYP_190_I12_D: "Lista de Pontuações 3",
  T_49_META_TYP_190_I13_D: "MVP da Vitória",
  T_49_META_TYP_190_I14_D: "MVP da Derrota",
  T_49_META_TYP_190_I15_D: "Mostrar Detalhes do Jogo",
  T_49_META_TYP_190_I16_D: "Mostrar Avaliação do Mapa",
  T_49_META_TYP_190_I17_D: "Mostrar Presente",
  T_49_META_TYP_190_I18_D: "Mostrar Relatório",
  T_49_META_TYP_190_I19_D: "Mostrar Replay",
  T_49_META_TYP_190_I20_D: "Mostrar Compartilhamento",
  T_49_META_TYP_190_I21_D: "Mostrar Lobby",
  T_49_META_TYP_190_I22_D: "Mostrar Curtidas",
  T_49_META_TYP_190_I23_D: "Mostrar Adicionar Amigo",
  T_49_META_TYP_190_I24_D: "Mostrar Economia",
  T_49_META_TYP_190_I4_D: "Equipe Direita",
  T_49_META_TYP_190_I5_D: "Títulos",
  T_49_META_TYP_190_I6_D: "Classificação do Jogador",
  T_49_META_TYP_190_I9_D: "Títulos",
  T_49_META_TYP_191_I0_D: "Alcance Central",
  T_49_META_TYP_191_I4_D: "Tempo de flash central, em milissegundos",
  T_49_META_TYP_191_I5_D: "Tempo de flash de borda, em milissegundos",
  T_49_META_TYP_191_I6_D: "Trocar Efeito do Impacto da Granada de Luz",
  T_49_META_TYP_192_I3_D: "Duração do efeito especial, em segundos",
  T_49_META_TYP_193_I1_D: "Título do Jogo Esquerda",
  T_49_META_TYP_193_I10_D: "Lista de Pontuações 1",
  T_49_META_TYP_193_I11_D: "Lista de Pontuações 2",
  T_49_META_TYP_193_I12_D: "Lista de Pontuações 3",
  T_49_META_TYP_193_I13_D: "Lista de Pontuações 4",
  T_49_META_TYP_193_I14_D: "Lista de Pontuações 5",
  T_49_META_TYP_193_I15_D: "MVP da Vitória",
  T_49_META_TYP_193_I16_D: "MVP da Derrota",
  T_49_META_TYP_193_I17_D: "Mostrar Detalhes do Jogo",
  T_49_META_TYP_193_I18_D: "Mostrar Avaliação do Mapa",
  T_49_META_TYP_193_I19_D: "Mostrar Presente",
  T_49_META_TYP_193_I2_D: "Título do Jogo Direita",
  T_49_META_TYP_193_I20_D: "Mostrar Relatório",
  T_49_META_TYP_193_I21_D: "Mostrar Replay",
  T_49_META_TYP_193_I22_D: "Mostrar Compartilhamento",
  T_49_META_TYP_193_I23_D: "Mostrar Lobby",
  T_49_META_TYP_193_I24_D: "Mostrar Curtidas",
  T_49_META_TYP_193_I25_D: "Mostrar Adicionar Amigo",
  T_49_META_TYP_193_I26_D: "Mostrar Economia",
  T_49_META_TYP_193_I3_D: "Resultados do jogo",
  T_49_META_TYP_193_I4_D: "Classificação da Equipe",
  T_49_META_TYP_193_I5_D: "Classificação do Jogador",
  T_49_META_TYP_193_I6_D: "Classificação da equipe",
  T_49_META_TYP_193_I7_D: "Título Principal da Pontuação",
  T_49_META_TYP_193_I8_D: "Pontuações Principais",
  T_49_META_TYP_193_I9_D: "Títulos",
  T_49_META_TYP_194_I0_D: "O tempo em segundos em que a mina entrará em vigor",
  T_49_META_TYP_194_I1_D: "Raio de disparo",
  T_49_META_TYP_194_I2_D: "O tempo necessário para detonar uma mina dentro do alcance da mina, em segundos",
  T_49_META_TYP_194_I3_D: "Pode ser ativado por si mesmo",
  T_49_META_TYP_194_I4_D: "Aliados podem acionar",
  T_49_META_TYP_194_I5_D: "Pode ser acionado por Veículo",
  T_49_META_TYP_194_I6_D: "O tempo de existência da mina, que explodirá automaticamente após o término. O tempo começa a partir do momento em que a mina é colocada, em segundos",
  T_49_META_TYP_194_I7_D: "Pode ser atacado",
  T_49_META_TYP_194_I8_D: "Saúde",
  T_49_META_TYP_195_I0_D: "Uma vez",
  T_49_META_TYP_195_I2_D: "Reciprocando",
  T_49_META_TYP_197_I0_D: "Está tocando?",
  T_49_META_TYP_197_I1_D: "Marca mordeu",
  T_49_META_TYP_197_I2_D: "Marque para reproduzir automaticamente ao criar",
  T_49_META_TYP_198_I0_D: "O ID do suporte correspondente ao anexo",
  T_49_META_TYP_199_I0_D: "Máx. de Pontos de Energia",
  T_49_META_TYP_199_I1_D: "Custo de Energia",
  T_49_META_TYP_199_I10_D: "Taxa de Dano de Queda",
  T_49_META_TYP_199_I11_D: "Energia Atual",
  T_49_META_TYP_199_I2_D: "Custo de Energia para cima",
  T_49_META_TYP_199_I3_D: "Custo de Energia da Investida",
  T_49_META_TYP_199_I4_D: "Custo de Energia para Corrida",
  T_49_META_TYP_199_I5_D: "Velocidade Horizontal Base",
  T_49_META_TYP_199_I6_D: "Velocidade Horizontal da Investida",
  T_49_META_TYP_199_I7_D: "Velocidade Vertical Base",
  T_49_META_TYP_199_I8_D: "Velocidade vertical de sprint",
  T_49_META_TYP_199_I9_D: "Distância da Investida",
  T_49_META_TYP_200_I0_D: "ID da região",
  T_49_META_TYP_200_I1_D: "ID do jogo",
  T_49_META_TYP_201_I0_D: "Porcentagem de desaceleração: A porcentagem pela qual a velocidade dos objetos aquáticos em águas abertas é reduzida",
  T_49_META_TYP_203_I0_D: "entidade-alvo",
  T_49_META_TYP_203_I1_D: "ID do Prop",
  T_49_META_TYP_203_I10_D: "O momento em que o servidor do jogo começa a funcionar",
  T_49_META_TYP_203_I11_D: "Valor Inicial",
  T_49_META_TYP_203_I12_D: "Valor Final",
  T_49_META_TYP_203_I13_D: "Porcentagem aprovada",
  T_49_META_TYP_203_I4_D: "Estilo de Transição",
  T_49_META_TYP_203_I6_D: "Duração(ões)",
  T_49_META_TYP_203_I7_D: "Reverter",
  T_49_META_TYP_203_I8_D: "Pontos de controle",
  T_49_META_TYP_203_I9_D: "Forçar sincronização do status do servidor do jogo",
  T_49_META_TYP_204_I0_D: "Altura Máxima do Pulo",
  T_49_META_TYP_204_I1_D: "Porcentagem de dano por queda",
  T_49_META_TYP_204_I2_D: "Recuperação de Energia",
  T_49_META_TYP_204_I3_D: "Consumir energia",
  T_49_META_TYP_204_I4_D: "Energia Máxima",
  T_49_META_TYP_205_I0_D: "Altura Mínima de Voo",
  T_49_META_TYP_205_I1_D: "Altura Mínima de Fim",
  T_49_META_TYP_205_I2_D: "Velocidade Horizontal de Voo",
  T_49_META_TYP_205_I3_D: "Velocidade Vertical de Voo",
  T_49_META_TYP_205_I4_D: "Velocidade de Queda",
  T_49_META_TYP_205_I5_D: "Velocidade ao virar",
  T_49_META_TYP_205_I6_D: "Altura Máxima de Voo",
  T_49_META_TYP_205_I7_D: "Velocidade de Queda Após Altura Máxima",
  T_49_META_TYP_205_I8_D: "Aceleração de velocidade variável",
  T_49_META_TYP_206_I0_D: "Centro",
  T_49_META_TYP_206_I1_D: "Gatilho",
  T_49_META_TYP_206_I10_D: "Em alta velocidade, o ângulo máximo de direção",
  T_49_META_TYP_206_I11_D: "Taxa base de interpolação de ângulo de direção de alta velocidade",
  T_49_META_TYP_206_I2_D: "Velocidade de Boost",
  T_49_META_TYP_206_I3_D: "Duração do sprint em segundos",
  T_49_META_TYP_206_I4_D: "Tempo de espera do sprint, em segundos",
  T_49_META_TYP_206_I6_D: "Jump CD, em segundos",
  T_49_META_TYP_206_I7_D: "Sprint CD após subir no skate, unidade: segundos",
  T_49_META_TYP_206_I8_D: "Ativar Troca do Tempo de Recarga do Impulso",
  T_49_META_TYP_206_I9_D: "CD de deslizar no skate, em segundos",
  T_49_META_TYP_207_I1_D: "Índice inicial",
  T_49_META_TYP_207_I2_D: "Posição Final",
  T_49_META_TYP_207_I3_D: "Identificação da tirolesa",
  T_49_META_TYP_207_I4_D: "ID do grupo",
  T_49_META_TYP_207_I5_D: "Acabou?",
  T_49_META_TYP_21_I0_D: "O nível básico da IU",
  T_49_META_TYP_210_I1_D: "Deslocamento",
  T_49_META_TYP_210_I2_D: "Gatilho",
  T_49_META_TYP_210_I3_D: "Deslocamento Máx.",
  T_49_META_TYP_210_I4_D: "Posição Inicial do Mundo",
  T_49_META_TYP_210_I5_D: "O servidor do jogo forçou a sincronização das informações de localização",
  T_49_META_TYP_211_I0_D: "Posição Local",
  T_49_META_TYP_211_I1_D: "Posição no mundo",
  T_49_META_TYP_212_I0_D: "Próprio",
  T_49_META_TYP_212_I2_D: "Coordenadas de deslocamento",
  T_49_META_TYP_213_I0_D: "Próprio",
  T_49_META_TYP_213_I2_D: "Coordenadas de deslocamento",
  T_49_META_TYP_215_I0_D: "Vitória",
  T_49_META_TYP_215_I1_D: "Derrota",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Empate",
  T_49_META_TYP_218_I0_D: "Intensidade",
  T_49_META_TYP_218_I1_D: "Alcance",
  T_49_META_TYP_218_I2_D: "Cor clara",
  T_49_META_TYP_22_I0_D: "Se o estado aberto for verdadeiro, ele será exibido, caso contrário, será fechado.",
  T_49_META_TYP_22_I1_D: "ID do Prefab",
  T_49_META_TYP_22_I2_D: "ID de controle máximo atual",
  T_49_META_TYP_22_I3_D: "O nível básico da IU",
  T_49_META_TYP_22_I4_D: "Habilitar Visão do Jogador",
  T_49_META_TYP_22_I5_D: "Posição no mundo",
  T_49_META_TYP_22_I6_D: "Está na cena?",
  T_49_META_TYP_22_I7_D: "Rotação em coordenadas mundiais",
  T_49_META_TYP_22_I8_D: "Escala em coordenadas mundiais",
  T_49_META_TYP_221_I0_D: "Atraso na troca de marchas, quanto maior o valor, mais lenta será a velocidade de troca de marchas",
  T_49_META_TYP_222_I0_D: "Atraso na troca de marchas, quanto maior o valor, mais lenta será a velocidade de troca de marchas",
  T_49_META_TYP_225_I0_D: "Danos na torre",
  T_49_META_TYP_225_I1_D: "Intervalo de Dano (s)",
  T_49_META_TYP_225_I10_D: "Fogo dentro do ângulo",
  T_49_META_TYP_225_I11_D: "Taxa de redução de danos",
  T_49_META_TYP_225_I12_D: "Penetração de Armadura",
  T_49_META_TYP_225_I2_D: "Precisão",
  T_49_META_TYP_225_I3_D: "Alcance",
  T_49_META_TYP_225_I4_D: "Velocidade Angular",
  T_49_META_TYP_225_I5_D: "Ângulo para Cima",
  T_49_META_TYP_225_I6_D: "Ângulo para Baixo",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Tempo de Vida (s)",
  T_49_META_TYP_225_I9_D: "Contagem Máx. de Torretas",
  T_49_META_TYP_226_I0_D: "Saúde atual da torre",
  T_49_META_TYP_226_I1_D: "Habilitar Ataque",
  T_49_META_TYP_227_I0_D: "Widget Simples",
  T_49_META_TYP_227_I1_D: "Widget de Imagem",
  T_49_META_TYP_227_I10_D: "Widget de Textura",
  T_49_META_TYP_227_I11_D: "Widget de Perfil",
  T_49_META_TYP_227_I12_D: "Widget de Alternância",
  T_49_META_TYP_227_I13_D: "Widget de Touch Pad",
  T_49_META_TYP_227_I14_D: "Widget de Joystick",
  T_49_META_TYP_227_I15_D: "Widget de botão social",
  T_49_META_TYP_227_I2_D: "Widget de Rótulo",
  T_49_META_TYP_227_I3_D: "Widget de Botão",
  T_49_META_TYP_227_I4_D: "Widget de Rótulo de Entrada",
  T_49_META_TYP_227_I5_D: "Painel",
  T_49_META_TYP_227_I6_D: "Painel de Rolagem",
  T_49_META_TYP_227_I7_D: "Grade",
  T_49_META_TYP_227_I8_D: "Widget de Layout",
  T_49_META_TYP_227_I9_D: "Widget de Contêiner",
  T_49_META_TYP_231_I0_D: "Recuperação de Durabilidade",
  T_49_META_TYP_231_I1_D: "Intervalo de tempo para fazer efeito, em segundos",
  T_49_META_TYP_233_I2_D: "O tempo final da cronometragem, em segundos",
  T_49_META_TYP_233_I4_D: "Nome do recurso do ícone",
  T_49_META_TYP_234_I0_D: "Tempo de disparo, em segundos",
  T_49_META_TYP_234_I1_D: "Pode ser ativado por si mesmo",
  T_49_META_TYP_234_I10_D: "Saúde atual",
  T_49_META_TYP_234_I2_D: "Aliados podem acionar",
  T_49_META_TYP_234_I3_D: "Pode ser acionado por Veículo",
  T_49_META_TYP_234_I4_D: "Duração, em segundos",
  T_49_META_TYP_234_I5_D: "Pode ser atacado",
  T_49_META_TYP_234_I6_D: "Saúde",
  T_49_META_TYP_235_I0_D: "Saúde Máxima",
  T_49_META_TYP_235_I2_D: "Contagem Máxima",
  T_49_META_TYP_237_I0_D: "Velocidade de Lançamento",
  T_49_META_TYP_237_I1_D: "Velocidade de Tração do Jogador",
  T_49_META_TYP_238_I0_D: "Cor de Spray",
  T_49_META_TYP_239_I0_D: "Velocidade inicial",
  T_49_META_TYP_239_I1_D: "Aceleração (como a gravidade)",
  T_49_META_TYP_24_I0_D: "Corpo a corpo",
  T_49_META_TYP_24_I1_D: "Arma",
  T_49_META_TYP_24_I10_D: "Dano de queda aérea, dano de suicídio de monstros",
  T_49_META_TYP_24_I11_D: "Dano por Queima na Explosão de Veículo",
  T_49_META_TYP_24_I12_D: "Explosão de Barril de Óleo",
  T_49_META_TYP_24_I13_D: "Arma do Tipo Míssil",
  T_49_META_TYP_24_I14_D: "Monstro",
  T_49_META_TYP_24_I15_D: "Zona de Dano",
  T_49_META_TYP_24_I17_D: "Habilidade de Personagem",
  T_49_META_TYP_24_I2_D: "Lançar Granada",
  T_49_META_TYP_24_I3_D: "Zona Segura",
  T_49_META_TYP_24_I4_D: "Veículo",
  T_49_META_TYP_24_I5_D: "Caindo",
  T_49_META_TYP_24_I6_D: "Zona de Morte",
  T_49_META_TYP_24_I7_D: "Saída",
  T_49_META_TYP_24_I8_D: "Desconectar",
  T_49_META_TYP_24_I9_D: "Explosão de Veículo",
  T_49_META_TYP_241_I0_D: "Velocidade de tração",
  T_49_META_TYP_241_I1_D: "Velocidade do swing",
  T_49_META_TYP_241_I2_D: "Ligue o botão de tração",
  T_49_META_TYP_241_I3_D: "Ligue o botão de balanço",
  T_49_META_TYP_241_I4_D: "Âncora de movimento",
  T_49_META_TYP_241_I5_D: "Aceleração de Saída do Balanço",
  T_49_META_TYP_242_I2_D: "Efeito Esquerdo Ativo",
  T_49_META_TYP_242_I3_D: "Efeito Direito Ativo",
  T_49_META_TYP_242_I4_D: "Linha Central Ativa",
  T_49_META_TYP_242_I5_D: "Valor",
  T_49_META_TYP_242_I7_D: "Posição da IU, apenas componentes XY são válidos",
  T_49_META_TYP_242_I8_D: "Posição da linha média [0,1]",
  T_49_META_TYP_243_I0_D: "Torso",
  T_49_META_TYP_243_I1_D: "Pernas",
  T_49_META_TYP_243_I2_D: "Sapatos",
  T_49_META_TYP_243_I3_D: "Pintura Facial",
  T_49_META_TYP_243_I4_D: "Cabeça",
  T_49_META_TYP_243_I5_D: "Macacão",
  T_49_META_TYP_243_I6_D: "Pintura Facial",
  T_49_META_TYP_244_I0_D: "O texto a ser exibido",
  T_49_META_TYP_244_I10_D: "Lista de jogadores que podem ver esta entidade",
  T_49_META_TYP_244_I11_D: "Hierarquia de exibição",
  T_49_META_TYP_244_I2_D: "Acompanhar alvo",
  T_49_META_TYP_244_I3_D: "Quando a profundidade é ignorada, ela pode ser exibida através da parede, caso contrário, não pode ser exibida",
  T_49_META_TYP_244_I4_D: "Anúncio",
  T_49_META_TYP_244_I5_D: "Quando definido como verdadeiro, a posição será exibida na tela quando estiver fora da tela",
  T_49_META_TYP_244_I6_D: "Estilo de Fonte",
  T_49_META_TYP_244_I7_D: "Tipo de fonte",
  T_49_META_TYP_244_I8_D: "Tamanho da fonte",
  T_49_META_TYP_245_I0_D: "Caminho do Recurso de Efeito",
  T_49_META_TYP_245_I11_D: "Hierarquia de exibição",
  T_49_META_TYP_245_I3_D: "Quando a profundidade é ignorada, ela pode ser exibida através da parede, caso contrário, não pode ser exibida",
  T_49_META_TYP_245_I4_D: "Quando definido como verdadeiro, a posição será exibida na tela quando estiver fora da tela",
  T_49_META_TYP_245_I5_D: "Anúncio",
  T_49_META_TYP_245_I6_D: "Tipo de Renderização",
  T_49_META_TYP_245_I7_D: "Largura",
  T_49_META_TYP_246_I0_D: "Laranja",
  T_49_META_TYP_246_I1_D: "Roxo",
  T_49_META_TYP_246_I2_D: "Vermelho",
  T_49_META_TYP_246_I3_D: "Verde",
  T_49_META_TYP_246_I4_D: "Azul",
  T_49_META_TYP_247_I1_D: "Corrida",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Chat Rápido",
  T_49_META_TYP_247_I16_D: "Coletas",
  T_49_META_TYP_247_I17_D: "Exibição do Chat Rápido",
  T_49_META_TYP_247_I18_D: "Vida",
  T_49_META_TYP_247_I19_D: "Energia (EP)",
  T_49_META_TYP_247_I2_D: "Ataque",
  T_49_META_TYP_247_I20_D: "Armadura",
  T_49_META_TYP_247_I21_D: "Recarregar",
  T_49_META_TYP_247_I22_D: "Botão de troca rápida de arma",
  T_49_META_TYP_247_I23_D: "O botão da buzina do veículo pode ser ligado/desligado",
  T_49_META_TYP_247_I24_D: "Botão de voz (microfone) para ligar/desligar",
  T_49_META_TYP_247_I25_D: "Botão de marca de alternância ligado/desligado",
  T_49_META_TYP_247_I27_D: "O botão de sinal de rede pode ser ligado/desligado",
  T_49_META_TYP_247_I28_D: "Habilidade Ativa",
  T_49_META_TYP_247_I29_D: "Retículo",
  T_49_META_TYP_247_I3_D: "Pular",
  T_49_META_TYP_247_I30_D: "Habilidade Passiva",
  T_49_META_TYP_247_I4_D: "Dicas de Abate",
  T_49_META_TYP_247_I5_D: "Slot de Arma",
  T_49_META_TYP_247_I6_D: "Minimapa",
  T_49_META_TYP_247_I7_D: "Mochila UI",
  T_49_META_TYP_247_I8_D: "Itens Médicos",
  T_49_META_TYP_247_I9_D: "Se verdadeiro, será exibido, caso contrário, será fechado.",
  T_49_META_TYP_249_I3_D: "Armas explosivas",
  T_49_META_TYP_249_I5_D: "Arma Pesada",
  T_49_META_TYP_249_I8_D: "Bomba congelante",
  T_49_META_TYP_249_I9_D: "Granada Falsa",
  T_49_META_TYP_25_I0_D: "O índice do estágio atual, correspondente ao índice no editor de processos",
  T_49_META_TYP_25_I1_D: "A hora de início do estágio atual, em ms",
  T_49_META_TYP_25_I2_D: "Hora de término do estágio atual, em ms",
  T_49_META_TYP_25_I3_D: "A duração da fase atual, em ms",
  T_49_META_TYP_250_I1_D: "Cor de efeito especial, quatro canais RGBA, intervalo de valor de canal único 0~255, armazenado em um Int32",
  T_49_META_TYP_250_I3_D: "Tipo de Textura de Efeito Visual",
  T_49_META_TYP_250_I4_D: "Alfa Difuso",
  T_49_META_TYP_2500_I1_D: "É Ponto de Spawn Padrão",
  T_49_META_TYP_2500_I3_D: "Já existe algum jogador nascido nesta área de spawn?",
  T_49_META_TYP_2500_I4_D: "As coordenadas do ponto de nascimento atualmente atribuível",
  T_49_META_TYP_2502_I0_D: "Seja um gatilho de morte, se não for um gatilho de morte, é um gatilho de invencibilidade. (Este é um problema herdado do OB32, por favor, divida a funcionalidade no futuro!)",
  T_49_META_TYP_2502_I1_D: "Se deve exibir a borda do gatilho, verdadeiro significa exibir",
  T_49_META_TYP_2503_I0_D: "ID do Checkpoint",
  T_49_META_TYP_2503_I2_D: "Localização do ponto de verificação",
  T_49_META_TYP_2507_I0_D: "A qual acampamento a torre de defesa pertence? Se for o mesmo acampamento do jogador, ela não atacará o jogador.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "ID do Objeto",
  T_49_META_TYP_2507_I2_D: "HP Máx.",
  T_49_META_TYP_2507_I3_D: "Dano de ataque, o dano que um único ataque pode causar ao jogador",
  T_49_META_TYP_2507_I4_D: "O intervalo entre dois ataques, em segundos",
  T_49_META_TYP_2507_I5_D: "A área com o centro como centro e um raio de qualquer tamanho pode ser atacada",
  T_49_META_TYP_2507_I6_D: "Taxa de redução de dano, um decimal menor que 1. O dano final é o dano multiplicado por (1-taxa de redução de dano)",
  T_49_META_TYP_2507_I7_D: "Alvo de ataque",
  T_49_META_TYP_2507_I8_D: "Ângulo",
  T_49_META_TYP_2507_I9_D: "Status da Mini Sentry",
  T_49_META_TYP_2508_I0_D: "O número de zumbis que surgirão em cada onda",
  T_49_META_TYP_2508_I1_D: "Quantas ondas de zumbis serão geradas?",
  T_49_META_TYP_2508_I2_D: "Se deve gerar continuamente, mas haverá um limite na mesma tela",
  T_49_META_TYP_2508_I3_D: "Qual onda está sendo gerada atualmente?",
  T_49_META_TYP_2508_I5_D: "Que tipo de zumbis são gerados na onda atual",
  T_49_META_TYP_2508_I6_D: "A IA derrubará equipamentos ou itens quando morrer?",
  T_49_META_TYP_2508_I7_D: "Tempo de Spawn Inicial (s)",
  T_49_META_TYP_2508_I8_D: "O intervalo de tempo entre a próxima onda e a onda anterior",
  T_49_META_TYP_2509_I0_D: "O número de unidades que serão geradas em cada onda",
  T_49_META_TYP_2509_I1_D: "Quantas ondas de geradores unitários serão geradas no total",
  T_49_META_TYP_2509_I2_D: "Qual onda está sendo gerada atualmente?",
  T_49_META_TYP_2509_I4_D: "Qual entidade será usada como modelo para cada onda a ser gerada?",
  T_49_META_TYP_2509_I5_D: "Tempo de geração da unidade",
  T_49_META_TYP_2509_I6_D: "Se deve gerar continuamente, mas haverá um limite na mesma tela",
  T_49_META_TYP_2509_I7_D: "O intervalo de tempo entre a próxima onda e a onda anterior",
  T_49_META_TYP_2509_I8_D: "O prefabID do modelo",
  T_49_META_TYP_2510_I0_D: "Contagem de Pontos de Surgimento",
  T_49_META_TYP_252_I1_D: "Ícone esquerdo",
  T_49_META_TYP_252_I2_D: "Texto esquerdo",
  T_49_META_TYP_252_I3_D: "Pontuação esquerda",
  T_49_META_TYP_252_I5_D: "Ícone direito",
  T_49_META_TYP_252_I6_D: "Texto direito",
  T_49_META_TYP_252_I7_D: "Pontuação direita",
  T_49_META_TYP_252_I8_D: "Progresso [0,1]",
  T_49_META_TYP_253_I0_D: "Selecionar ícone",
  T_49_META_TYP_253_I1_D: "Texto",
  T_49_META_TYP_253_I2_D: "Efeito ativo",
  T_49_META_TYP_253_I3_D: "Localização da IU",
  T_49_META_TYP_254_I1_D: "Por exemplo, 1,25 significa 1,25 vezes a velocidade normal",
  T_49_META_TYP_254_I2_D: "Cor",
  T_49_META_TYP_256_I0_D: "Completamente imóvel. O desempenho mais econômico",
  T_49_META_TYP_256_I1_D: "Aplique força normalmente. Maior consumo de desempenho",
  T_49_META_TYP_256_I2_D: "O movimento pode ser controlado por scripts, e a massa pode ser considerada infinita",
  T_49_META_TYP_257_I0_D: "Diferentes tipos de corpos rígidos têm funções diferentes",
  T_49_META_TYP_257_I1_D: "Gravidade usada",
  T_49_META_TYP_257_I2_D: "Massa (kg), a massa efetiva mínima é 0,001kg. Se for 0, significa massa infinita e não se moverá sob força",
  T_49_META_TYP_257_I3_D: "Posição do centro de gravidade, sistema de coordenadas local",
  T_49_META_TYP_257_I4_D: "Velocidade linear do movimento do corpo rígido",
  T_49_META_TYP_257_I5_D: "Velocidade angular de um corpo rígido",
  T_49_META_TYP_257_I6_D: "O coeficiente de atenuação natural da velocidade linear. Quanto maior o coeficiente, mais rápido a velocidade do movimento decai.",
  T_49_META_TYP_257_I7_D: "O coeficiente de atenuação natural da velocidade angular. Quanto maior o coeficiente, mais rápido a velocidade do movimento decai.",
  T_49_META_TYP_257_I8_D: "As restrições impostas ao corpo rígido são uma coleção de RigidbodyConstrainType",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Fundo",
  T_49_META_TYP_259_I1_D: "Texto",
  T_49_META_TYP_259_I2_D: "Localização da IU",
  T_49_META_TYP_259_I4_D: "Cor do texto",
  T_49_META_TYP_260_I0_D: "Selecionar ícone",
  T_49_META_TYP_260_I1_D: "Cor da barra de progresso",
  T_49_META_TYP_260_I2_D: "Valor",
  T_49_META_TYP_260_I3_D: "Velocidade, m/s",
  T_49_META_TYP_260_I4_D: "Se deve exibir efeitos especiais",
  T_49_META_TYP_260_I5_D: "Posição da IU [0,1]",
  T_49_META_TYP_260_I6_D: "O progresso inicial da habilidade, o valor é [0, 1]. Após a criação da IU, o progresso será imediatamente sincronizado com o progresso atual",
  T_49_META_TYP_260_I7_D: "Cor do efeito",
  T_49_META_TYP_260_I8_D: "Defina o valor de escala do objeto",
  T_49_META_TYP_265_I1_D: "Se deve executar o preenchimento de fundo",
  T_49_META_TYP_265_I2_D: "Nome de Fundo",
  T_49_META_TYP_265_I3_D: "Cor de fundo",
  T_49_META_TYP_265_I5_D: "BgAlfa",
  T_49_META_TYP_265_I6_D: "Tipo de corte",
  T_49_META_TYP_265_I7_D: "O tipo de máscara é o nome da imagem selecionada ao mascarar",
  T_49_META_TYP_265_I8_D: "Unidade de suavização de bordas",
  T_49_META_TYP_267_I0_D: "Ponto de partida da rolagem, o padrão é o canto superior esquerdo",
  T_49_META_TYP_267_I1_D: "Suporta múltiplas direções de rolagem",
  T_49_META_TYP_267_I10_D: "Barra Horizontal",
  T_49_META_TYP_267_I11_D: "Localização de exibição",
  T_49_META_TYP_267_I2_D: "Arraste o componente na direção XY",
  T_49_META_TYP_267_I3_D: "Suporta múltiplos efeitos de arrastar",
  T_49_META_TYP_267_I4_D: "Fator de rolagem, quanto maior o valor, mais rápida será a rolagem",
  T_49_META_TYP_267_I5_D: "Fator de inércia, quanto maior o valor, maior a inércia ao rolar.",
  T_49_META_TYP_267_I6_D: "Se o arrasto é limitado à janela de visualização, selecionado por padrão",
  T_49_META_TYP_267_I7_D: "Quando marcada, o arrasto começará em câmera lenta; se não marcada, o arrasto começará na velocidade do movimento do mouse.",
  T_49_META_TYP_267_I8_D: "Quando ele se encaixar na janela de visualização, saia arrastando",
  T_49_META_TYP_267_I9_D: "Barra Vertical",
  T_49_META_TYP_268_I0_D: "Padrão",
  T_49_META_TYP_268_I1_D: "Fechar",
  T_49_META_TYP_268_I2_D: "Mostrar",
  T_49_META_TYP_269_I0_D: "Proprietário",
  T_49_META_TYP_269_I1_D: "Definir ID",
  T_49_META_TYP_269_I2_D: "ID do cocar",
  T_49_META_TYP_269_I3_D: "Identificação facial",
  T_49_META_TYP_269_I4_D: "ID de maquiagem",
  T_49_META_TYP_269_I5_D: "ID da parte superior do corpo",
  T_49_META_TYP_269_I6_D: "ID da parte inferior do corpo",
  T_49_META_TYP_269_I7_D: "Identificação do sapato",
  T_49_META_TYP_272_I0_D: "Feminino",
  T_49_META_TYP_272_I1_D: "Masculino",
  T_49_META_TYP_273_I0_D: "Coordenadas mundiais correspondentes ao centro do pequeno mapa",
  T_49_META_TYP_273_I1_D: "O tamanho, a largura e a altura do mapa pequeno são os mesmos",
  T_49_META_TYP_273_I2_D: "Se deve habilitar o modo de exibição do mapa de profundidade do minimapa",
  T_49_META_TYP_274_I1_D: "Escala",
  T_49_META_TYP_274_I4_D: "Nível de exibição do ícone",
  T_49_META_TYP_275_I0_D: "Escala do Esqueleto",
  T_49_META_TYP_275_I1_D: "As coordenadas mundiais do nó ósseo",
  T_49_META_TYP_276_I0_D: "cabeça",
  T_49_META_TYP_276_I1_D: "Braço Esquerdo",
  T_49_META_TYP_276_I2_D: "Mão Esquerda",
  T_49_META_TYP_276_I3_D: "Braço Direito",
  T_49_META_TYP_276_I4_D: "Mão Direita",
  T_49_META_TYP_276_I5_D: "Tronco",
  T_49_META_TYP_276_I6_D: "Perna Esquerda",
  T_49_META_TYP_276_I7_D: "Pé Esquerdo",
  T_49_META_TYP_276_I8_D: "Perna Direita",
  T_49_META_TYP_276_I9_D: "Pé Direito",
  T_49_META_TYP_277_I1_D: "A distância de detecção do raio da câmera",
  T_49_META_TYP_277_I2_D: "Máscara de camada de colisão para detecção de raios de câmera",
  T_49_META_TYP_277_I3_D: "Deslocamento da posição do botão",
  T_49_META_TYP_277_I4_D: "Ícone ID do recurso",
  T_49_META_TYP_277_I5_D: "Tamanho da área de clique",
  T_49_META_TYP_277_I6_D: "Se deve exibir o objeto no ponto de destino",
  T_49_META_TYP_277_I7_D: "Objeto de exibição de ponto de destino",
  T_49_META_TYP_278_I0_D: "A entidade alvo para gerar pixels de mapa",
  T_49_META_TYP_28_I0_D: "Pode ser reiniciado a cada rodada?",
  T_49_META_TYP_280_I0_D: "Raio da esfera",
  T_49_META_TYP_281_I0_D: "O raio dos hemisférios em ambas as extremidades da cápsula",
  T_49_META_TYP_29_I0_D: "Esfera",
  T_49_META_TYP_29_I1_D: "Feixe de Luz",
  T_49_META_TYP_29_I10_D: "A coluna de luz na planta do pé agora é usada para feedback ao entrar na linha de chegada",
  T_49_META_TYP_29_I11_D: "Congelamento",
  T_49_META_TYP_29_I12_D: "Luz",
  T_49_META_TYP_29_I13_D: "Corrente de Ar Ascendente",
  T_49_META_TYP_29_I14_D: "Explosão de Gás",
  T_49_META_TYP_29_I15_D: "Escondido Abatido",
  T_49_META_TYP_29_I16_D: "Fúria",
  T_49_META_TYP_29_I17_D: "Morte de Clone",
  T_49_META_TYP_29_I18_D: "Feedback de Tiro",
  T_49_META_TYP_29_I19_D: "Morte de Clone",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Fumaça de Granada de Luz",
  T_49_META_TYP_29_I23_D: "Bola de Fogo",
  T_49_META_TYP_29_I24_D: "Queima em Looping",
  T_49_META_TYP_29_I25_D: "Gás Tóxico",
  T_49_META_TYP_29_I26_D: "Coração",
  T_49_META_TYP_29_I29_D: "Porta",
  T_49_META_TYP_29_I30_D: "Fogos de Artifício",
  T_49_META_TYP_29_I31_D: "Efeito Visual de Sapatos de Corrida",
  T_49_META_TYP_29_I32_D: "Efeito Visual de Explosão",
  T_49_META_TYP_29_I33_D: "Efeito Visual de Ponto de Surgimento",
  T_49_META_TYP_29_I34_D: "Efeito Visual de Laser",
  T_49_META_TYP_29_I35_D: "Efeito Visual de Uso de Habilidade",
  T_49_META_TYP_29_I36_D: "Efeito Visual de Munição",
  T_49_META_TYP_29_I37_D: "Efeito Visual de Acerto de Projétil",
  T_49_META_TYP_29_I38_D: "Efeito Visual de Disparo",
  T_49_META_TYP_29_I39_D: "Efeito Visual de Habilidade",
  T_49_META_TYP_29_I40_D: "Aura",
  T_49_META_TYP_29_I41_D: "bolha",
  T_49_META_TYP_29_I42_D: "Fumaça e Poeira",
  T_49_META_TYP_29_I43_D: "Detritos Voadores",
  T_49_META_TYP_29_I44_D: "linha",
  T_49_META_TYP_29_I45_D: "Piscamento",
  T_49_META_TYP_29_I47_D: "Partículas Ascendentes",
  T_49_META_TYP_29_I48_D: "Fumaça",
  T_49_META_TYP_29_I49_D: "Talismã",
  T_49_META_TYP_29_I50_D: "Área Congelada",
  T_49_META_TYP_29_I51_D: "Névoa",
  T_49_META_TYP_29_I52_D: "Floco de Neve",
  T_49_META_TYP_29_I53_D: "Fogo",
  T_49_META_TYP_29_I54_D: "Feixe de Luz",
  T_49_META_TYP_29_I55_D: "Difusão de Gás Tóxico",
  T_49_META_TYP_29_I56_D: "Gás Tóxico",
  T_49_META_TYP_29_I57_D: "Chamas da Explosão",
  T_49_META_TYP_29_I58_D: "Efeito de Luz",
  T_49_META_TYP_29_I59_D: "Estrela",
  T_49_META_TYP_29_I6_D: "Halo sob seus pés",
  T_49_META_TYP_29_I60_D: "Fogo de Conselho Ardente",
  T_49_META_TYP_29_I61_D: "Espirro de Água",
  T_49_META_TYP_29_I62_D: "Choque Elétrico",
  T_49_META_TYP_29_I63_D: "Efeito Visual de Tinta",
  T_49_META_TYP_29_I64_D: "Efeito Visual de Buraco Negro",
  T_49_META_TYP_29_I65_D: "Efeito Visual de Explosão de Buraco Negro",
  T_49_META_TYP_29_I66_D: "Efeito Visual de Bola de Cristal",
  T_49_META_TYP_29_I67_D: "Efeitos especiais de balas de laser",
  T_49_META_TYP_29_I68_D: "Efeito de trilha",
  T_49_META_TYP_29_I69_D: "Efeitos de nuvem",
  T_49_META_TYP_29_I7_D: "Marcador no Solo",
  T_49_META_TYP_29_I8_D: "Fumaça",
  T_49_META_TYP_29_I9_D: "Explosão de Talismã",
  T_49_META_TYP_290_I0_D: "Intervalo de atualização, quanto maior o número, mais lenta será a atualização, em milissegundos",
  T_49_META_TYP_290_I1_D: "Se deve habilitar a depuração",
  T_49_META_TYP_291_I0_D: "Nó de Condição",
  T_49_META_TYP_291_I1_D: "Nó de Ação",
  T_49_META_TYP_293_I0_D: "ID da árvore de comportamento",
  T_49_META_TYP_293_I1_D: "Alvo de Anexação",
  T_49_META_TYP_294_I1_D: "Tipo de layout",
  T_49_META_TYP_294_I10_D: "Tipo de Ordenação",
  T_49_META_TYP_294_I2_D: "Origem do Conteúdo",
  T_49_META_TYP_294_I3_D: "Direção do arranjo",
  T_49_META_TYP_294_I4_D: "Largura e altura da grade de subitens",
  T_49_META_TYP_294_I5_D: "Espaço entre Células",
  T_49_META_TYP_294_I6_D: "Restrição",
  T_49_META_TYP_294_I7_D: "Contagem de Restrições",
  T_49_META_TYP_294_I8_D: "Deslocamento vertical",
  T_49_META_TYP_294_I9_D: "Deslocamento horizontal",
  T_49_META_TYP_295_I2_D: "Duração (s)",
  T_49_META_TYP_296_I1_D: "Comprimento do Clipe",
  T_49_META_TYP_297_I0_D: "Objeto vinculado",
  T_49_META_TYP_297_I4_D: "ID do recurso",
  T_49_META_TYP_298_I0_D: "Padrão",
  T_49_META_TYP_298_I2_D: "Uma vez",
  T_49_META_TYP_30_I0_D: "Quadrado",
  T_49_META_TYP_30_I1_D: "Quadrilátero",
  T_49_META_TYP_30_I10_D: "Seta",
  T_49_META_TYP_30_I11_D: "Anotação",
  T_49_META_TYP_30_I12_D: "Pedra",
  T_49_META_TYP_30_I13_D: "Tesoura",
  T_49_META_TYP_30_I14_D: "Papel",
  T_49_META_TYP_30_I15_D: "Curtir",
  T_49_META_TYP_30_I16_D: "Correto",
  T_49_META_TYP_30_I17_D: "Incorreto",
  T_49_META_TYP_30_I18_D: "Mais",
  T_49_META_TYP_30_I19_D: "raio",
  T_49_META_TYP_30_I2_D: "Trapézio Retângulo",
  T_49_META_TYP_30_I20_D: "Coração",
  T_49_META_TYP_30_I21_D: "estrela",
  T_49_META_TYP_30_I22_D: "Lua",
  T_49_META_TYP_30_I23_D: "Sol",
  T_49_META_TYP_30_I24_D: "Óculos",
  T_49_META_TYP_30_I25_D: "Chave",
  T_49_META_TYP_30_I26_D: "Troféu",
  T_49_META_TYP_30_I27_D: "Bandeira",
  T_49_META_TYP_30_I28_D: "Ampulheta",
  T_49_META_TYP_30_I29_D: "Pasta",
  T_49_META_TYP_30_I3_D: "Trapézio",
  T_49_META_TYP_30_I30_D: "Pasta Aberta",
  T_49_META_TYP_30_I31_D: "Casa",
  T_49_META_TYP_30_I32_D: "Descanso",
  T_49_META_TYP_30_I33_D: "Atualizar",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Lupa",
  T_49_META_TYP_30_I36_D: "Lixeira",
  T_49_META_TYP_30_I37_D: "Retornar",
  T_49_META_TYP_30_I38_D: "Diamante",
  T_49_META_TYP_30_I39_D: "Boia",
  T_49_META_TYP_30_I4_D: "Hexágono",
  T_49_META_TYP_30_I40_D: "Dinheiro",
  T_49_META_TYP_30_I41_D: "Cadeado",
  T_49_META_TYP_30_I42_D: "Configurações",
  T_49_META_TYP_30_I43_D: "Saída",
  T_49_META_TYP_30_I44_D: "Diálogo",
  T_49_META_TYP_30_I45_D: "Mira",
  T_49_META_TYP_30_I46_D: "pistola",
  T_49_META_TYP_30_I47_D: "Espada",
  T_49_META_TYP_30_I48_D: "Explosão",
  T_49_META_TYP_30_I49_D: "Mirar",
  T_49_META_TYP_30_I5_D: "Redondo",
  T_49_META_TYP_30_I50_D: "Cruz",
  T_49_META_TYP_30_I51_D: "Defesa",
  T_49_META_TYP_30_I52_D: "Zumbi",
  T_49_META_TYP_30_I53_D: "Reciclar",
  T_49_META_TYP_30_I54_D: "Presente",
  T_49_META_TYP_30_I55_D: "Roupas",
  T_49_META_TYP_30_I56_D: "Jogo",
  T_49_META_TYP_30_I57_D: "Jogador",
  T_49_META_TYP_30_I58_D: "Loja",
  T_49_META_TYP_30_I59_D: "saída",
  T_49_META_TYP_30_I6_D: "Triângulo",
  T_49_META_TYP_30_I60_D: "Aviso",
  T_49_META_TYP_30_I61_D: "Texto",
  T_49_META_TYP_30_I62_D: "Objeto Temporizador",
  T_49_META_TYP_30_I63_D: "Sino",
  T_49_META_TYP_30_I64_D: "Animal de Estimação",
  T_49_META_TYP_30_I65_D: "bomba",
  T_49_META_TYP_30_I66_D: "Reparo",
  T_49_META_TYP_30_I67_D: "Rosto Sorridente",
  T_49_META_TYP_30_I68_D: "Alto-Falante",
  T_49_META_TYP_30_I7_D: "Ponto de Exclamação",
  T_49_META_TYP_30_I70_D: "Coroa",
  T_49_META_TYP_30_I71_D: "Batalha",
  T_49_META_TYP_30_I72_D: "Guilda",
  T_49_META_TYP_30_I73_D: "Batimento Cardíaco",
  T_49_META_TYP_30_I74_D: "Música",
  T_49_META_TYP_30_I75_D: "Veículo",
  T_49_META_TYP_30_I76_D: "Arma de combate corpo a corpo",
  T_49_META_TYP_30_I77_D: "Pistola",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Fuzil de Precisão",
  T_49_META_TYP_30_I8_D: "Ponto de Interrogação",
  T_49_META_TYP_30_I80_D: "Espingarda",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Arma de Cura",
  T_49_META_TYP_30_I83_D: "Quebrar Armadura",
  T_49_META_TYP_30_I84_D: "Acerto na Cabeça",
  T_49_META_TYP_30_I85_D: "Habilidade 1",
  T_49_META_TYP_30_I86_D: "Habilidade 2",
  T_49_META_TYP_30_I87_D: "Habilidade 3",
  T_49_META_TYP_30_I88_D: "Habilidade 4",
  T_49_META_TYP_30_I89_D: "Habilidade 5",
  T_49_META_TYP_30_I9_D: "Marca",
  T_49_META_TYP_30_I90_D: "Habilidade 6",
  T_49_META_TYP_30_I91_D: "Habilidade 7",
  T_49_META_TYP_30_I92_D: "Habilidade 8",
  T_49_META_TYP_30_I93_D: "Habilidade 9",
  T_49_META_TYP_30_I94_D: "Habilidade 10",
  T_49_META_TYP_300_I0_D: "ID do recurso",
  T_49_META_TYP_300_I2_D: "Rotação",
  T_49_META_TYP_300_I3_D: "Entidade criada",
  T_49_META_TYP_301_I1_D: "Auto-explosão",
  T_49_META_TYP_301_I2_D: "Ataque em dash",
  T_49_META_TYP_301_I3_D: "Onda de choque",
  T_49_META_TYP_301_I4_D: "Ataque de vento",
  T_49_META_TYP_301_I5_D: "Ataque de salto",
  T_49_META_TYP_301_I6_D: "Escudo levantado",
  T_49_META_TYP_301_I7_D: "Escudo quebrado",
  T_49_META_TYP_302_I5_D: "Mochila",
  T_49_META_TYP_302_I7_D: "Skate, camuflagem...",
  T_49_META_TYP_303_I0_D: "Adicionar Máx. Vida do Jogador",
  T_49_META_TYP_303_I1_D: "Restaurar vida do jogador continuamente",
  T_49_META_TYP_305_I0_D: "Finalizar",
  T_49_META_TYP_305_I1_D: "Correndo",
  T_49_META_TYP_307_I0_D: "EXP por Dano",
  T_49_META_TYP_307_I1_D: "EXP por Milha Percorrida",
  T_49_META_TYP_307_I2_D: "EXP por Segundo",
  T_49_META_TYP_307_I3_D: "EXP por Chip",
  T_49_META_TYP_307_I4_D: "Carga Máxima",
  T_49_META_TYP_308_I0_D: "Fabricante de gel",
  T_49_META_TYP_31_I0_D: "Explosão de granada",
  T_49_META_TYP_31_I1_D: "Tiro",
  T_49_META_TYP_31_I10_D: "Efeito sonoro de dano causado por golpe",
  T_49_META_TYP_31_I11_D: "Efeitos sonoros atualizados",
  T_49_META_TYP_31_I12_D: "Efeito sonoro de clique fraco",
  T_49_META_TYP_31_I13_D: "Efeito sonoro do jogador pisando no mecanismo",
  T_49_META_TYP_31_I14_D: "Efeito sonoro de reparo de equipamento",
  T_49_META_TYP_31_I15_D: "Efeito sonoro de reparo de equipamento",
  T_49_META_TYP_31_I16_D: "Efeitos sonoros defeituosos ou ausentes",
  T_49_META_TYP_31_I17_D: "Efeito sonoro de lembrete",
  T_49_META_TYP_31_I18_D: "Efeito sonoro de aterrissagem de futebol",
  T_49_META_TYP_31_I19_D: "Efeito sonoro de torcida",
  T_49_META_TYP_31_I2_D: "Bipe da Contagem Regressiva",
  T_49_META_TYP_31_I20_D: "Efeito sonoro de alerta de bomba",
  T_49_META_TYP_31_I21_D: "Efeito sonoro de explosão de bomba",
  T_49_META_TYP_31_I22_D: "Efeito sonoro de caçador aparece",
  T_49_META_TYP_31_I23_D: "Efeito sonoro de fundo final",
  T_49_META_TYP_31_I24_D: "Efeito sonoro de atualização da caixa de suprimentos",
  T_49_META_TYP_31_I25_D: "Efeitos sonoros do acelerador",
  T_49_META_TYP_31_I26_D: "Efeito sonoro de lembrete de desaparecimento",
  T_49_META_TYP_31_I27_D: "Efeitos visuais e sonoros",
  T_49_META_TYP_31_I28_D: "Efeitos sonoros de insetos noturnos",
  T_49_META_TYP_31_I29_D: "Efeito sonoro de batida fraca",
  T_49_META_TYP_31_I3_D: "Toque na Interface",
  T_49_META_TYP_31_I30_D: "Efeitos sonoros responsivos",
  T_49_META_TYP_31_I31_D: "Descubra efeitos sonoros surpreendentes",
  T_49_META_TYP_31_I32_D: "Fantasminha tocando efeito sonoro",
  T_49_META_TYP_31_I33_D: "Efeito sonoro de início de fase",
  T_49_META_TYP_31_I34_D: "Efeitos sonoros de zumbi",
  T_49_META_TYP_31_I35_D: "Efeitos sonoros de terror",
  T_49_META_TYP_31_I36_D: "Efeitos sonoros de transformação",
  T_49_META_TYP_31_I37_D: "Efeito sonoro de batimento cardíaco rápido",
  T_49_META_TYP_31_I38_D: "Efeito sonoro de batimento cardíaco em velocidade média",
  T_49_META_TYP_31_I39_D: "Efeito sonoro de batimento cardíaco lento",
  T_49_META_TYP_31_I4_D: "Grito de Mulher ao Ser Atacado",
  T_49_META_TYP_31_I40_D: "Efeitos sonoros de raiva",
  T_49_META_TYP_31_I41_D: "Efeito sonoro de clique",
  T_49_META_TYP_31_I42_D: "Efeito sonoro de recuperação de habilidade",
  T_49_META_TYP_31_I43_D: "Adicionados efeitos sonoros do jogo",
  T_49_META_TYP_31_I44_D: "Efeito sonoro de eco mecânico",
  T_49_META_TYP_31_I45_D: "Efeito sonoro de mosquito",
  T_49_META_TYP_31_I46_D: "Efeito sonoro intensivo Ding Ding Ding 1",
  T_49_META_TYP_31_I47_D: "Efeitos sonoros intensivos de Ding Ding Ding 2",
  T_49_META_TYP_31_I48_D: "Efeito sonoro de abertura do mecanismo",
  T_49_META_TYP_31_I49_D: "Efeito sonoro de carregamento 1",
  T_49_META_TYP_31_I5_D: "Grito de Homem ao Ser Atacado",
  T_49_META_TYP_31_I50_D: "Efeito sonoro de passos",
  T_49_META_TYP_31_I51_D: "Prompt de sucesso da missão 1 efeito sonoro",
  T_49_META_TYP_31_I52_D: "Som de aviso de perigo 1 efeito sonoro",
  T_49_META_TYP_31_I53_D: "Efeito sonoro de aviso de perigo 2",
  T_49_META_TYP_31_I54_D: "Efeito sonoro de contagem regressiva 3",
  T_49_META_TYP_31_I55_D: "Mostrar dicas efeito sonoro",
  T_49_META_TYP_31_I56_D: "Efeito sonoro ambiente de corvos chamando",
  T_49_META_TYP_31_I57_D: "Efeito sonoro de teletransporte para a área errada usando o teletransportador",
  T_49_META_TYP_31_I58_D: "O efeito sonoro de teletransporte para a área correta usando o ponto de teletransporte",
  T_49_META_TYP_31_I59_D: "Transmitir som",
  T_49_META_TYP_31_I6_D: "Efeito sonoro de captação de moeda de ouro",
  T_49_META_TYP_31_I60_D: "Efeito sonoro de choque elétrico",
  T_49_META_TYP_31_I61_D: "Obtenha efeitos sonoros de adereços",
  T_49_META_TYP_31_I62_D: "Efeitos sonoros de fundo musical eletrônico, fofo e sonhador",
  T_49_META_TYP_31_I63_D: "Efeitos sonoros de fundo de música de jogo casual",
  T_49_META_TYP_31_I64_D: "Abrir Pacote",
  T_49_META_TYP_31_I65_D: "Subir de Nível",
  T_49_META_TYP_31_I66_D: "Nível Máx.",
  T_49_META_TYP_31_I67_D: "Botão de Toque",
  T_49_META_TYP_31_I68_D: "Contagem Regressiva",
  T_49_META_TYP_31_I69_D: "Derrotar Oponente",
  T_49_META_TYP_31_I7_D: "Efeito sonoro de gatilho para passar a linha de chegada em uma corrida",
  T_49_META_TYP_31_I70_D: "Fim",
  T_49_META_TYP_31_I71_D: "Avançar",
  T_49_META_TYP_31_I72_D: "Vitória",
  T_49_META_TYP_31_I73_D: "Ponto de verificação da base de treinamento",
  T_49_META_TYP_31_I74_D: "Contagem Regressiva",
  T_49_META_TYP_31_I75_D: "Início do Jogo",
  T_49_META_TYP_31_I76_D: "Obter Grande Ouro",
  T_49_META_TYP_31_I77_D: "Obter Ouro Médio",
  T_49_META_TYP_31_I78_D: "Obter Pequeno Ouro",
  T_49_META_TYP_31_I79_D: "Entrar na Luta",
  T_49_META_TYP_31_I8_D: "Efeito sonoro de gatilho",
  T_49_META_TYP_31_I80_D: "Suprimento da Guilda",
  T_49_META_TYP_31_I81_D: "Alto-Falante",
  T_49_META_TYP_31_I82_D: "Impeachment do Líder da Guilda",
  T_49_META_TYP_31_I83_D: "Salvar Armazém",
  T_49_META_TYP_31_I84_D: "Som de Arma Especial",
  T_49_META_TYP_31_I85_D: "Impacto de Bala",
  T_49_META_TYP_31_I86_D: "Mover",
  T_49_META_TYP_31_I87_D: "Tocar Botão de Desativar",
  T_49_META_TYP_31_I88_D: "Carga de Habilidade Completa",
  T_49_META_TYP_31_I89_D: "Habilidade Laser",
  T_49_META_TYP_31_I9_D: "Efeitos sonoros degradados",
  T_49_META_TYP_31_I90_D: "Obter Consumível 2",
  T_49_META_TYP_31_I91_D: "Contagem Regressiva 3",
  T_49_META_TYP_31_I92_D: "Fim de Jogo 2",
  T_49_META_TYP_31_I93_D: "Indicação de Morte",
  T_49_META_TYP_31_I94_D: "Explosão",
  T_49_META_TYP_31_I95_D: "Habilidade Orbe de Energia",
  T_49_META_TYP_31_I96_D: "Habilidade Piscina de Sangue",
  T_49_META_TYP_311_I1_D: "Dano Máximo",
  T_49_META_TYP_311_I3_D: "A velocidade de voo do objeto arremessado após deixar a mão, em m/s",
  T_49_META_TYP_311_I4_D: "O intervalo de tempo entre o momento em que o objeto lançado é liberado e o momento em que ele faz efeito, em segundos",
  T_49_META_TYP_313_I0_D: "Raio da Zona",
  T_49_META_TYP_313_I1_D: "A duração da zona de contra-ataque, em segundos",
  T_49_META_TYP_314_I0_D: "ID do recurso do controlador de animação",
  T_49_META_TYP_314_I1_D: "Controle de animação",
  T_49_META_TYP_315_I0_D: "Proprietário da mochila",
  T_49_META_TYP_315_I1_D: "Espaço para mochila",
  T_49_META_TYP_315_I2_D: "Capacidade usada",
  T_49_META_TYP_315_I3_D: "Todos os Recursos",
  T_49_META_TYP_316_I0_D: "Recurso de Textura",
  T_49_META_TYP_316_I1_D: "Nome do Shader",
  T_49_META_TYP_316_I11_D: "Método Flip",
  T_49_META_TYP_316_I2_D: "Deslocamento UV",
  T_49_META_TYP_316_I3_D: "Tamanho UV",
  T_49_META_TYP_316_I4_D: "Tipo de Preenchimento",
  T_49_META_TYP_316_I5_D: "Borda Esquerda-Direita",
  T_49_META_TYP_316_I6_D: "Borda Superior-Inferior",
  T_49_META_TYP_317_I0_D: "Nenhum",
  T_49_META_TYP_317_I1_D: "Posição X do congelamento",
  T_49_META_TYP_317_I2_D: "Posição Y do congelamento",
  T_49_META_TYP_317_I3_D: "Posição Z do congelamento",
  T_49_META_TYP_317_I4_D: "Limitar a rotação em torno do eixo X",
  T_49_META_TYP_317_I5_D: "Limitar a rotação em torno do eixo Y",
  T_49_META_TYP_317_I6_D: "Limitar a rotação em torno do eixo Z",
  T_49_META_TYP_317_I7_D: "Posição do congelamento",
  T_49_META_TYP_317_I8_D: "Rotação do congelamento",
  T_49_META_TYP_317_I9_D: "Congelar Tudo",
  T_49_META_TYP_318_I0_D: "Faixa",
  T_49_META_TYP_318_I1_D: "Distância de Dano Total",
  T_49_META_TYP_318_I10_D: "Fator de Velocidade de Mira do Jogador",
  T_49_META_TYP_318_I11_D: "Fator de Zoom da Mira",
  T_49_META_TYP_318_I12_D: "Ampliação do Campo de Visão (FOV)",
  T_49_META_TYP_318_I13_D: "Ampliação ao Mirar",
  T_49_META_TYP_318_I14_D: "Tempo de Ampliação ao Mirar (s)",
  T_49_META_TYP_318_I15_D: "Tempo de Recuperação ao Mirar (s)",
  T_49_META_TYP_318_I16_D: "Fator de correção de distância de dano mínimo para escopo",
  T_49_META_TYP_318_I17_D: "Permitir Assistência de Mira ao Mirar",
  T_49_META_TYP_318_I18_D: "Taxa de Atração da Mira Assistida na Tela (0-1)",
  T_49_META_TYP_318_I19_D: "Coeficiente de Atenuação da Distância da Assistência de Mira (0-1)",
  T_49_META_TYP_318_I2_D: "Distância Mínima de Dano",
  T_49_META_TYP_318_I20_D: "Permitir Prioridade de Distância da Assistência de Mira",
  T_49_META_TYP_318_I21_D: "Distância Mínima de Prioridade da Assistência de Mira",
  T_49_META_TYP_318_I22_D: "Distância Máxima de Prioridade da Assistência de Mira",
  T_49_META_TYP_318_I23_D: "Coeficiente de Impacto de Prioridade da Distância da Assistência de Mira (>=1)",
  T_49_META_TYP_318_I24_D: "Sensibilidade de Rotação ao Mirar",
  T_49_META_TYP_318_I25_D: "Taxa de Convergência",
  T_49_META_TYP_318_I3_D: "Tamanho do Carregador",
  T_49_META_TYP_318_I4_D: "Intervalo de Ataque",
  T_49_META_TYP_318_I5_D: "Velocidade de Recarga",
  T_49_META_TYP_318_I6_D: "Velocidade de Recarga Automática",
  T_49_META_TYP_318_I7_D: "Velocidade de Dispersão",
  T_49_META_TYP_318_I8_D: "A taxa de dispersão ao agachar ou deitar. Cada 0,1 significa que o alcance da mira aumenta em 10% para cada bala.",
  T_49_META_TYP_318_I9_D: "Dispersão Máxima",
  T_49_META_TYP_319_I0_D: "Simples",
  T_49_META_TYP_319_I1_D: "Fatiado",
  T_49_META_TYP_319_I2_D: "Revestido",
  T_49_META_TYP_319_I3_D: "Preenchido",
  T_49_META_TYP_319_I4_D: "Ajustar",
  T_49_META_TYP_32_I0_D: "O jogador está em estado ativo normal",
  T_49_META_TYP_32_I1_D: "O jogador está em um estado derrubado",
  T_49_META_TYP_32_I2_D: "O jogador está em um estado morto",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "Distância máxima para acionar a assistência de mira",
  T_49_META_TYP_321_I1_D: "O deslocamento da mira quando a mira assistida é acionada. Se o ponto de deslocamento não estiver na entidade, a mira assistida falhará.",
  T_49_META_TYP_322_I0_D: "nenhum",
  T_49_META_TYP_322_I1_D: "cabeça",
  T_49_META_TYP_322_I2_D: "Corpo",
  T_49_META_TYP_322_I3_D: "Membro",
  T_49_META_TYP_323_I0_D: "Escala",
  T_49_META_TYP_323_I1_D: "ID da Conta",
  T_49_META_TYP_323_I2_D: "Informações do perfil do jogador",
  T_49_META_TYP_323_I3_D: "Estilo",
  T_49_META_TYP_323_I4_D: "Mostrar Classificação",
  T_49_META_TYP_323_I5_D: "Mostrar Pin",
  T_49_META_TYP_323_I6_D: "Mostrar Apelido",
  T_49_META_TYP_324_I0_D: "Gera uma força de magnitude especificada",
  T_49_META_TYP_324_I1_D: "Gera aceleração de magnitude especificada",
  T_49_META_TYP_324_I2_D: "Gera um impulso de um tamanho especificado",
  T_49_META_TYP_324_I3_D: "Gera a velocidade do tamanho especificado",
  T_49_META_TYP_326_I0_D: "ID da conta",
  T_49_META_TYP_326_I1_D: "ID do Avatar",
  T_49_META_TYP_326_I2_D: "ID do Banner",
  T_49_META_TYP_326_I3_D: "ID da Medalha",
  T_49_META_TYP_326_I4_D: "Apelido do jogador",
  T_49_META_TYP_326_I5_D: "Classificação no BR",
  T_49_META_TYP_326_I6_D: "Máxima Classificação no BR",
  T_49_META_TYP_326_I7_D: "Classificação no CS",
  T_49_META_TYP_326_I8_D: "Máxima Classificação no CS",
  T_49_META_TYP_327_I0_D: "ID do recurso",
  T_49_META_TYP_327_I1_D: "Máscara da Parte 1",
  T_49_META_TYP_327_I2_D: "Máscara da Parte 2",
  T_49_META_TYP_327_I3_D: "Máscara da Parte 3",
  T_49_META_TYP_327_I4_D: "Máscara da Parte 4",
  T_49_META_TYP_329_I0_D: "Motorista",
  T_49_META_TYP_329_I1_D: "Passageiro A",
  T_49_META_TYP_329_I2_D: "Passageiro B",
  T_49_META_TYP_329_I3_D: "Passageiro C",
  T_49_META_TYP_33_I0_D: "Em ordem crescente, os valores zero são ignorados e classificados por último.",
  T_49_META_TYP_33_I1_D: "Decrescente, do grande para o pequeno",
  T_49_META_TYP_33_I2_D: "Ascendente, pequeno para grande",
  T_49_META_TYP_330_I4_D: "Duração do efeito de invencibilidade (unidade: s)",
  T_49_META_TYP_330_I5_D: "Pontos de controle",
  T_49_META_TYP_330_I8_D: "Valor Delta",
  T_49_META_TYP_332_I0_D: "Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Caminho do recurso, vazio por padrão",
  T_49_META_TYP_335_I1_D: "Número de reproduções, o padrão é 1",
  T_49_META_TYP_335_I2_D: "Volume, o padrão é 50",
  T_49_META_TYP_335_I3_D: "Distância Máxima",
  T_49_META_TYP_335_I4_D: "Distância Mínima",
  T_49_META_TYP_335_I5_D: "É música 3D?",
  T_49_META_TYP_335_I6_D: "Prioridade",
  T_49_META_TYP_335_I7_D: "Tempo de espera antes de iniciar, em segundos",
  T_49_META_TYP_335_I8_D: "Jogando",
  T_49_META_TYP_338_I0_D: "Status do celular",
  T_49_META_TYP_338_I1_D: "Status do sprint",
  T_49_META_TYP_338_I2_D: "Status de ataque",
  T_49_META_TYP_338_I3_D: "Estado de salto",
  T_49_META_TYP_338_I4_D: "Estado de escalada",
  T_49_META_TYP_338_I5_D: "Entrar no veículo (motorista)",
  T_49_META_TYP_338_I6_D: "Entrando no veículo (passageiro)",
  T_49_META_TYP_338_I7_D: "Sair do Veículo",
  T_49_META_TYP_338_I8_D: "Dirigir",
  T_49_META_TYP_339_I0_D: "Taxa de Dano nos Membros",
  T_49_META_TYP_339_I1_D: "Coeficiente de Dano por Acerto na Cabeça",
  T_49_META_TYP_339_I2_D: "Fator de Durabilidade Máxima",
  T_49_META_TYP_339_I3_D: "Taxa de Vida Extra",
  T_49_META_TYP_339_I4_D: "Fator de redução de dano de explosão adicional (%)",
  T_49_META_TYP_339_I5_D: "Capacidade Extra da Mochila",
  T_49_META_TYP_339_I6_D: "Prioridade de Substituição",
  T_49_META_TYP_34_I0_D: "Punho Padrão",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Espingarda Carregada",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Canhão de mão",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Arma de Escudo",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Famas-II",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Granada de Chamas",
  T_49_META_TYP_34_I133_D: "Granada de Luz",
  T_49_META_TYP_34_I134_D: "Granada de fumaça",
  T_49_META_TYP_34_I135_D: "Granada Congelante",
  T_49_META_TYP_34_I136_D: "Colete à prova de balas Lv1",
  T_49_META_TYP_34_I137_D: "Colete à prova de balas Lv2",
  T_49_META_TYP_34_I138_D: "Colete à prova de balas Lv3",
  T_49_META_TYP_34_I139_D: "Capacete Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Capacete Lv2",
  T_49_META_TYP_34_I141_D: "Capacete Lv3",
  T_49_META_TYP_34_I142_D: "Armadura à prova de explosão",
  T_49_META_TYP_34_I143_D: "Mochila Lv1",
  T_49_META_TYP_34_I144_D: "Mochila Lv2",
  T_49_META_TYP_34_I145_D: "Mochila Lv3",
  T_49_META_TYP_34_I146_D: "Focinho Lv1",
  T_49_META_TYP_34_I147_D: "Focinho Lv2",
  T_49_META_TYP_34_I148_D: "Focinho Lv3",
  T_49_META_TYP_34_I149_D: "Silencioso",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Focinho de assalto",
  T_49_META_TYP_34_I151_D: "focinho largo",
  T_49_META_TYP_34_I152_D: "Revista Lv1",
  T_49_META_TYP_34_I153_D: "Revista Lv2",
  T_49_META_TYP_34_I154_D: "Revista Lv3",
  T_49_META_TYP_34_I155_D: "Revista de pacote duplo",
  T_49_META_TYP_34_I156_D: "Revista Chain",
  T_49_META_TYP_34_I157_D: "Pegada Lv1",
  T_49_META_TYP_34_I158_D: "Pegada Lv2",
  T_49_META_TYP_34_I159_D: "Pegada Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Suporte dobrável",
  T_49_META_TYP_34_I161_D: "Punho de rifle de atirador",
  T_49_META_TYP_34_I162_D: "Coronha de espingarda",
  T_49_META_TYP_34_I163_D: "Coronha de rifle de precisão",
  T_49_META_TYP_34_I164_D: "Escopo de imagem térmica",
  T_49_META_TYP_34_I165_D: "Estoque Lv1",
  T_49_META_TYP_34_I166_D: "Estoque Lv2",
  T_49_META_TYP_34_I167_D: "Estoque Lv3",
  T_49_META_TYP_34_I168_D: "Extensor de Escudo",
  T_49_META_TYP_34_I169_D: "Armadura corporal completa",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Intercamada excessiva",
  T_49_META_TYP_34_I171_D: "Camada intermediária à prova de explosão",
  T_49_META_TYP_34_I172_D: "Expansão da mochila",
  T_49_META_TYP_34_I173_D: "Respirador de tratamento",
  T_49_META_TYP_34_I174_D: "Horizonte",
  T_49_META_TYP_34_I175_D: "Kit de Primeiros Socorros",
  T_49_META_TYP_34_I176_D: "Kit de reparo de armadura",
  T_49_META_TYP_34_I177_D: "A torre de sentinela de inteligência artificial feita de materiais de alta tecnologia irá procurar e atacar ativamente os inimigos dentro de um determinado alcance.",
  T_49_META_TYP_34_I178_D: "Nível 1 Cogumelo",
  T_49_META_TYP_34_I179_D: "Nível 2 Cogumelo",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Nível 3 Cogumelo",
  T_49_META_TYP_34_I181_D: "Nível 4 Cogumelo",
  T_49_META_TYP_34_I182_D: "Drone Pessoal",
  T_49_META_TYP_34_I184_D: "Mina de Proximidade",
  T_49_META_TYP_34_I185_D: "Sapatos de voo a jato",
  T_49_META_TYP_34_I186_D: "Botas Bounce Power",
  T_49_META_TYP_34_I187_D: "ASA delta",
  T_49_META_TYP_34_I188_D: "Granada chamariz",
  T_49_META_TYP_34_I189_D: "Hoverboard magnético",
  T_49_META_TYP_34_I19_D: "Águia do deserto",
  T_49_META_TYP_34_I190_D: "Alicate para desarmamento de bombas",
  T_49_META_TYP_34_I191_D: "Melhorador de armas",
  T_49_META_TYP_34_I192_D: "Munição de Fuzil",
  T_49_META_TYP_34_I193_D: "Munição de Pistola",
  T_49_META_TYP_34_I194_D: "Munição de Fuzil de Precisão",
  T_49_META_TYP_34_I195_D: "Munição de Espingarda",
  T_49_META_TYP_34_I196_D: "Munição de SMG",
  T_49_META_TYP_34_I197_D: "Setas",
  T_49_META_TYP_34_I198_D: "Granada M79",
  T_49_META_TYP_34_I199_D: "Bala de lança-chamas",
  T_49_META_TYP_34_I2_D: "BESTA",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "FACA DE ARREMESSO2",
  T_49_META_TYP_34_I201_D: "Gancho",
  T_49_META_TYP_34_I202_D: "Arma de Futebol",
  T_49_META_TYP_34_I203_D: "boxe",
  T_49_META_TYP_34_I204_D: "Lança-chamas",
  T_49_META_TYP_34_I205_D: "Cartão de Deus Macaco",
  T_49_META_TYP_34_I206_D: "Cartão MadeManACard",
  T_49_META_TYP_34_I207_D: "Cartão Djmale",
  T_49_META_TYP_34_I208_D: "Cartão de Grafitista",
  T_49_META_TYP_34_I209_D: "Cartão de detetive",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "Cartão de Professor",
  T_49_META_TYP_34_I211_D: "Cartão BountyHunter",
  T_49_META_TYP_34_I212_D: "Cartão Superstar",
  T_49_META_TYP_34_I213_D: "Cartão Xtreme",
  T_49_META_TYP_34_I214_D: "Cartão MusicBro",
  T_49_META_TYP_34_I215_D: "Cartão Kenta",
  T_49_META_TYP_34_I216_D: "Cartão TRACKER",
  T_49_META_TYP_34_I217_D: "Cartão de menina louca",
  T_49_META_TYP_34_I218_D: "Cartão RunSpeedUp",
  T_49_META_TYP_34_I219_D: "Cartão Santino",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "Cartão de Vilão",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "CICATRIZ-I",
  T_49_META_TYP_34_I25_D: "CICATRIZ-II",
  T_49_META_TYP_34_I26_D: "CICATRIZ-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Item de Escudo de Futebol",
  T_49_META_TYP_34_I30_D: "Pistola de energia superaquecida",
  T_49_META_TYP_34_I31_D: "Pistola de superaquecimento-I",
  T_49_META_TYP_34_I32_D: "Pistola de superaquecimento II",
  T_49_META_TYP_34_I33_D: "Pistola de superaquecimento III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Pistola de Cura-Y",
  T_49_META_TYP_34_I36_D: "Curar Sniper",
  T_49_META_TYP_34_I37_D: "Pistola de Cura",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "frigideira",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Taco de beisebol",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Catana",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Pistola de gancho potente",
  T_49_META_TYP_34_I71_D: "Faca FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 balas 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Pica-pau",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Foice",
  T_49_META_TYP_34_I87_D: "Martelo",
  T_49_META_TYP_34_I88_D: "Faca de arremesso (retirada)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Martim-pescador",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Fácil",
  T_49_META_TYP_340_I1_D: "Simples",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderado",
  T_49_META_TYP_340_I4_D: "Difícil",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Iniciar evento",
  T_49_META_TYP_342_I1_D: "Parar evento",
  T_49_META_TYP_342_I2_D: "Pausar evento",
  T_49_META_TYP_342_I3_D: "Quanto tempo esperar após ser criado para iniciar a cronometragem, em milissegundos",
  T_49_META_TYP_342_I4_D: "Contagem de Loops",
  T_49_META_TYP_342_I5_D: "Eventos",
  T_49_META_TYP_342_I6_D: "Contagem regressiva ou contagem regressiva",
  T_49_META_TYP_342_I7_D: "Status do Jogador",
  T_49_META_TYP_342_I8_D: "O tempo final da cronometragem, em segundos",
  T_49_META_TYP_345_I10_D: "Canhão de mão",
  T_49_META_TYP_345_I12_D: "Arma de parede de gelo",
  T_49_META_TYP_345_I13_D: "Lança-chamas",
  T_49_META_TYP_345_I4_D: "Espingarda",
  T_49_META_TYP_345_I6_D: "Arma Especial",
  T_49_META_TYP_345_I8_D: "Arma de carga",
  T_49_META_TYP_346_I0_D: "Munição de Fuzil",
  T_49_META_TYP_346_I1_D: "Munição de Pistola",
  T_49_META_TYP_346_I2_D: "Munição de Fuzil de Precisão",
  T_49_META_TYP_346_I3_D: "Munição de Espingarda",
  T_49_META_TYP_346_I4_D: "Munição de SMG",
  T_49_META_TYP_346_I5_D: "Setas",
  T_49_META_TYP_346_I6_D: "Granada M79",
  T_49_META_TYP_346_I7_D: "Gancho",
  T_49_META_TYP_346_I8_D: "Granada Especializada M79",
  T_49_META_TYP_347_I3_D: "Quando true, pode ser combinado com movimento relativo. Quando false, deve ser combinado com movimento absoluto, caso contrário a propriedade não terá efeito corretamente.",
  T_49_META_TYP_347_I6_D: "Valor Delta",
  T_49_META_TYP_350_I0_D: "Carro esportivo",
  T_49_META_TYP_350_I1_D: "Motocicleta",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Caminhões Monstros",
  T_49_META_TYP_350_I5_D: "Tuk Tuk",
  T_49_META_TYP_352_I1_D: "Sprite Não Selecionado",
  T_49_META_TYP_352_I2_D: "Nenhum tipo de imagem selecionado",
  T_49_META_TYP_352_I3_D: "Cor Não Selecionada",
  T_49_META_TYP_352_I4_D: "Sprite Selecionado",
  T_49_META_TYP_352_I5_D: "Selecione o tipo de imagem",
  T_49_META_TYP_352_I6_D: "Cor Selecionada",
  T_49_META_TYP_353_I0_D: "Quantidade de Recuperação de Vida",
  T_49_META_TYP_353_I1_D: "Velocidade de Recuperação de Vida (ms)",
  T_49_META_TYP_353_I2_D: "Tempo Necessário (ms)",
  T_49_META_TYP_354_I0_D: "Quantidade de Recuperação de Energia",
  T_49_META_TYP_355_I0_D: "Quantidade de Recuperação de Vida",
  T_49_META_TYP_355_I1_D: "Quantidade de Recuperação de Energia",
  T_49_META_TYP_355_I2_D: "Tempo Necessário (ms)",
  T_49_META_TYP_356_I0_D: "Itens de queda",
  T_49_META_TYP_356_I1_D: "Tempo de entrega da caixa de airdrop ms",
  T_49_META_TYP_356_I2_D: "Estado do lançamento aéreo",
  T_49_META_TYP_357_I0_D: "Superfície",
  T_49_META_TYP_357_I1_D: "limite",
  T_49_META_TYP_359_I0_D: "Se deve usar o controlador do jogador com física",
  T_49_META_TYP_359_I1_D: "Se colocado em um declive que exceda esse ângulo, ele deslizará para baixo",
  T_49_META_TYP_359_I10_D: "Essa aceleração da gravidade se aplica somente ao controle do jogador.",
  T_49_META_TYP_359_I11_D: "Massa, kg",
  T_49_META_TYP_359_I12_D: "Se a inclinação exceder o ângulo máximo de subida, ele deslizará para baixo.",
  T_49_META_TYP_359_I16_D: "Após a abertura, os primitivos ou scripts do lado do servidor controlam o movimento",
  T_49_META_TYP_359_I17_D: "Quando habilitado, a força aplicada pelo personagem ao empurrar o corpo rígido pode ser personalizada",
  T_49_META_TYP_359_I18_D: "A quantidade de força aplicada quando o personagem empurra o corpo rígido",
  T_49_META_TYP_359_I19_D: "Verdadeiro quando a parte inferior toca o colisor, geralmente usado para determinar se o jogador está no chão",
  T_49_META_TYP_359_I2_D: "Somente obstáculos que excedam essa altura terão efeito de bloqueio. O intervalo de valores é [0, Altura]",
  T_49_META_TYP_359_I20_D: "Nível físico personalizado, valor [0,15]",
  T_49_META_TYP_359_I21_D: "Habilitar Rotação com Gravidade",
  T_49_META_TYP_359_I3_D: "A profundidade da cápsula que pode ser incorporada. Pode evitar que o personagem fique preso ou tremendo. Não é recomendado modificá-lo, a menos que haja uma necessidade especial. Intervalo de valores (0, Raio]",
  T_49_META_TYP_359_I4_D: "Distância mínima de movimentação. Movimentos menores que esse valor não serão executados. Se não houver necessidade especial, é recomendável mantê-lo como 0",
  T_49_META_TYP_359_I5_D: "O deslocamento do centro da caixa de colisão da origem da coordenada local",
  T_49_META_TYP_359_I6_D: "O raio da cápsula, valor mínimo é 0,01",
  T_49_META_TYP_359_I7_D: "A altura total da cápsula, incluindo os hemisférios superior e inferior, com um valor mínimo de 2*Raio",
  T_49_META_TYP_359_I8_D: "Velocidade linear atual, em m/s",
  T_49_META_TYP_360_I0_D: "Ângulo de Tiro Esquerdo",
  T_49_META_TYP_360_I1_D: "Ângulo de Tiro Direito",
  T_49_META_TYP_360_I2_D: "Ângulo Mínimo de Elevação",
  T_49_META_TYP_360_I3_D: "Ângulo Máximo de Depressão",
  T_49_META_TYP_360_I4_D: "Velocidade de Muzzle",
  T_49_META_TYP_362_I0_D: "O tempo de congelamento após atingir o jogador, em segundos",
  T_49_META_TYP_363_I0_D: "Desativar solicitação de compra do HUD",
  T_49_META_TYP_363_I1_D: "Peça ajuda à equipe na compra",
  T_49_META_TYP_363_I2_D: "Peça ajuda à facção para comprar",
  T_49_META_TYP_364_I0_D: "É posição central",
  T_49_META_TYP_364_I1_D: "Se deve ou não efetuar um loop",
  T_49_META_TYP_364_I2_D: "Nome da animação",
  T_49_META_TYP_364_I3_D: "Se deve reproduzir automaticamente",
  T_49_META_TYP_364_I4_D: "Usar recurso personalizado",
  T_49_META_TYP_366_I0_D: "Especifique o UUID do recurso Batch a ser renderizado",
  T_49_META_TYP_367_I1_D: "Mostrar marcação",
  T_49_META_TYP_367_I2_D: "O estilo de ícone para marcar alvos",
  T_49_META_TYP_367_I3_D: "A cor de sobreposição do ícone exibido ao marcar um alvo",
  T_49_META_TYP_367_I4_D: "O estilo do ícone exibido em uma escala",
  T_49_META_TYP_367_I5_D: "A cor da sobreposição do ícone exibida em uma escala",
  T_49_META_TYP_367_I6_D: "Sempre mostrar marcação",
  T_49_META_TYP_370_I0_D: "Título principal",
  T_49_META_TYP_370_I1_D: "Legenda",
  T_49_META_TYP_370_I2_D: "Cor de fundo superior",
  T_49_META_TYP_370_I3_D: "Cor de fundo abaixo",
  T_49_META_TYP_371_I2_D: "Pontuação esquerda",
  T_49_META_TYP_371_I3_D: "Pontuação direita",
  T_49_META_TYP_371_I4_D: "A última partitura à esquerda, usada para reproduzir a animação de troca de partitura",
  T_49_META_TYP_371_I5_D: "A última partitura à direita é usada para reproduzir a animação de troca de partitura",
  T_49_META_TYP_372_I0_D: "Em Pé",
  T_49_META_TYP_372_I1_D: "Mostrar agachado",
  T_49_META_TYP_372_I10_D: "Queda de alta altitude",
  T_49_META_TYP_372_I11_D: "Cair de uma altura baixa, como pular",
  T_49_META_TYP_372_I12_D: "Sapatos voadores",
  T_49_META_TYP_372_I13_D: "Salto duplo",
  T_49_META_TYP_372_I14_D: "Sente-se em uma cadeira",
  T_49_META_TYP_372_I15_D: "Sendo ejetado por uma catapulta",
  T_49_META_TYP_372_I16_D: "Fase de preparação da catapulta",
  T_49_META_TYP_372_I17_D: "Hélices de planagem",
  T_49_META_TYP_372_I18_D: "Queda de hélice planadora",
  T_49_META_TYP_372_I19_D: "Quicado por pneus",
  T_49_META_TYP_372_I2_D: "correndo",
  T_49_META_TYP_372_I20_D: "Quicado por pneu humano",
  T_49_META_TYP_372_I21_D: "Uma ação na área da festa",
  T_49_META_TYP_372_I22_D: "Pegue uma aeronave",
  T_49_META_TYP_372_I23_D: "Entre no Canhão",
  T_49_META_TYP_372_I24_D: "Ao sair de um canhão, veículo, etc., se o objeto que você está montando estiver voando, este é o estado",
  T_49_META_TYP_372_I25_D: "Depois de pular do trampolim",
  T_49_META_TYP_372_I26_D: "Saia da tirolesa",
  T_49_META_TYP_372_I27_D: "Não usado",
  T_49_META_TYP_372_I3_D: "Arrastar",
  T_49_META_TYP_372_I4_D: "Natação rápida",
  T_49_META_TYP_372_I5_D: "Queda vertical",
  T_49_META_TYP_372_I6_D: "Por cima do muro",
  T_49_META_TYP_372_I7_D: "Não usado",
  T_49_META_TYP_372_I8_D: "Derrubado mas não morto",
  T_49_META_TYP_372_I9_D: "Use uma prancha de água",
  T_49_META_TYP_374_I0_D: "Saúde, nível e cor do traço",
  T_49_META_TYP_374_I1_D: "À medida que a saúde diminui, a parte faltante exibe brevemente esta cor",
  T_49_META_TYP_374_I10_D: "Deslocamento em relação ao alvo a seguir",
  T_49_META_TYP_374_I11_D: "O valor de saúde entre cada duas linhas divisórias não será exibido se for menor ou igual a 0",
  T_49_META_TYP_374_I12_D: "HP total",
  T_49_META_TYP_374_I13_D: "HP atual",
  T_49_META_TYP_374_I14_D: "Quando ativado, as alterações de saúde serão exibidas em cores diferentes",
  T_49_META_TYP_374_I15_D: "Quando ativadas, as propriedades de deslocamento são convertidas em coordenadas mundiais usando o sistema de coordenadas local.",
  T_49_META_TYP_374_I2_D: "Quando a saúde aumenta, a porção aumentada exibe brevemente esta cor",
  T_49_META_TYP_374_I3_D: "A cor da borda de saúde e do fundo desfocado",
  T_49_META_TYP_374_I4_D: "Intervalo 0~1, a transparência da IU geral",
  T_49_META_TYP_374_I5_D: "Determina o dimensionamento geral da IU e as fontes são dimensionadas juntas",
  T_49_META_TYP_374_I6_D: "Indica o nome do atual proprietário da barra de saúde",
  T_49_META_TYP_374_I8_D: "O comprimento da barra de saúde exibida na tela",
  T_49_META_TYP_374_I9_D: "Deve seguir uma entidade com um componente Transform",
  T_49_META_TYP_375_I1_D: "Entidade de Combate",
  T_49_META_TYP_376_I1_D: "Entidade de Combate",
  T_49_META_TYP_38_I0_D: "Alfa",
  T_49_META_TYP_382_I0_D: "padrão",
  T_49_META_TYP_382_I1_D: "Pule o estado de knockdown e morra diretamente",
  T_49_META_TYP_382_I2_D: "Não Pular Derrubada",
  T_49_META_TYP_387_I1_D: "Permitir Pressionar Fora",
  T_49_META_TYP_389_I0_D: "Deslocamento padrão da base",
  T_49_META_TYP_389_I1_D: "Sprite de Fundo",
  T_49_META_TYP_389_I10_D: "Alpha Desativado",
  T_49_META_TYP_389_I2_D: "Raio de Fundo",
  T_49_META_TYP_389_I3_D: "Imagem do Cap do Joystick",
  T_49_META_TYP_389_I4_D: "Raio do Cap do Joystick",
  T_49_META_TYP_389_I5_D: "Raio de Arrasto do Cap do Joystick",
  T_49_META_TYP_389_I6_D: "Sprite de Flecha",
  T_49_META_TYP_389_I7_D: "Tamanho da Flecha",
  T_49_META_TYP_389_I8_D: "Deslocamento da Flecha",
  T_49_META_TYP_389_I9_D: "Alpha Ativado",
  T_49_META_TYP_39_I1_D: "Forma do sprite",
  T_49_META_TYP_39_I10_D: "Gradiente Superior",
  T_49_META_TYP_39_I11_D: "Gradiente Inferior",
  T_49_META_TYP_39_I12_D: "Alpha Superior",
  T_49_META_TYP_39_I13_D: "Alpha Inferior",
  T_49_META_TYP_39_I3_D: "Inverter",
  T_49_META_TYP_39_I4_D: "Preenchido",
  T_49_META_TYP_39_I5_D: "Centro Invisível",
  T_49_META_TYP_39_I6_D: "Direção de Preenchimento",
  T_49_META_TYP_39_I7_D: "Valor de Preenchimento",
  T_49_META_TYP_39_I8_D: "Inverter Preenchimento",
  T_49_META_TYP_39_I9_D: "Gradiente",
  T_49_META_TYP_392_I0_D: "O tempo que a zona segura aparece em cada rodada do jogo, o valor padrão é 0, a unidade é ms",
  T_49_META_TYP_392_I1_D: "O tempo que leva para encolher o círculo, em ms",
  T_49_META_TYP_392_I10_D: "O tempo final do círculo de encolhimento, em ms",
  T_49_META_TYP_392_I12_D: "Raio final do círculo de veneno",
  T_49_META_TYP_392_I13_D: "Início da diminuição da zona",
  T_49_META_TYP_392_I14_D: "Intervalo de dano (ms)",
  T_49_META_TYP_392_I3_D: "A quantidade de dano causado aos jogadores no círculo de veneno.",
  T_49_META_TYP_392_I4_D: "Lista de jogadores na zona segura",
  T_49_META_TYP_392_I5_D: "O tempo de desaparecimento da zona segura. Se o tempo de desaparecimento da zona segura for menor que o tempo efetivo, nenhuma zona segura será gerada.",
  T_49_META_TYP_392_I6_D: "ID do Grupo",
  T_49_META_TYP_392_I7_D: "Raio inicial do círculo de veneno",
  T_49_META_TYP_392_I8_D: "Estado final",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "O valor é cerca de 3,1416",
  T_49_META_TYP_394_I1_D: "O valor é cerca de 2,7183",
  T_49_META_TYP_396_I0_D: "Título",
  T_49_META_TYP_396_I1_D: "Conteúdo",
  T_49_META_TYP_396_I2_D: "Opções",
  T_49_META_TYP_396_I3_D: "Mostrar fundo",
  T_49_META_TYP_399_I0_D: "Altura do Salto",
  T_49_META_TYP_399_I1_D: "O número de saltos consecutivos que você pode realizar antes de pousar",
  T_49_META_TYP_399_I2_D: "Você pode realizar vários saltos antes de pousar.",
  T_49_META_TYP_399_I3_D: "Habilitar Movimento no Ar",
  T_49_META_TYP_40_I1_D: "Rótulo",
  T_49_META_TYP_40_I10_D: "Espaçamento entre Linhas",
  T_49_META_TYP_40_I11_D: "Método de estouro",
  T_49_META_TYP_40_I12_D: "Estilo de Fonte",
  T_49_META_TYP_40_I13_D: "Aplicar Sombra",
  T_49_META_TYP_40_I14_D: "Cor da Sombra",
  T_49_META_TYP_40_I15_D: "Deslocamento da Sombra",
  T_49_META_TYP_40_I3_D: "Chave de localização, pode ser usada em vários idiomas",
  T_49_META_TYP_40_I5_D: "Alinhamento",
  T_49_META_TYP_40_I6_D: "Alinhamento Vertical",
  T_49_META_TYP_40_I7_D: "Negrito",
  T_49_META_TYP_40_I8_D: "Itálico",
  T_49_META_TYP_40_I9_D: "Sublinhado",
  T_49_META_TYP_400_I0_D: "Ativo",
  T_49_META_TYP_400_I1_D: "Passivo",
  T_49_META_TYP_400_I2_D: "Sem Ataque",
  T_49_META_TYP_401_I0_D: "Não pode disparar",
  T_49_META_TYP_401_I1_D: "Pode disparar continuamente",
  T_49_META_TYP_401_I2_D: "Dispara uma vez por comando de ataque",
  T_49_META_TYP_401_I3_D: "Cada comando de ataque dispara três vezes",
  T_49_META_TYP_401_I4_D: "Cada comando de ataque dispara duas vezes",
  T_49_META_TYP_401_I5_D: "Projétil",
  T_49_META_TYP_402_I0_D: "Alvo para adicionar como amigo",
  T_49_META_TYP_402_I1_D: "Tipo de Função",
  T_49_META_TYP_402_I2_D: "Estilo",
  T_49_META_TYP_403_I0_D: "Adicionar amigo",
  T_49_META_TYP_403_I1_D: "Reportar",
  T_49_META_TYP_404_I0_D: "Claro",
  T_49_META_TYP_404_I1_D: "Escuro",
  T_49_META_TYP_405_I0_D: "Por hierarquia",
  T_49_META_TYP_405_I1_D: "Por prioridade de alto para baixo",
  T_49_META_TYP_405_I2_D: "Por prioridade de baixo para alto",
  T_49_META_TYP_406_I0_D: "Controla a distância da ação de salto do jogador",
  T_49_META_TYP_406_I1_D: "Controla a altura do corpo do jogador ao subir e descer",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Cliente",
  T_49_META_TYP_407_I2_D: "Servidor",
  T_49_META_TYP_407_I3_D: "Ambos",
  T_49_META_TYP_409_I0_D: "Nenhum erro",
  T_49_META_TYP_409_I1_D: "Tempo limite de armazenamento de dados, principalmente para operações de leitura",
  T_49_META_TYP_409_I10_D: "Falha na mudança de equipe - Equipe alvo inválida",
  T_49_META_TYP_409_I11_D: "Falha na troca de equipe - Jogadores mortos não podem trocar de equipe",
  T_49_META_TYP_409_I12_D: "Falha na mudança de equipe - Mudanças de equipe não são permitidas em veículos",
  T_49_META_TYP_409_I2_D: "A frequência de leitura e gravação do armazenamento de dados excede o limite",
  T_49_META_TYP_409_I3_D: "Anormalidade de parâmetro",
  T_49_META_TYP_409_I4_D: "Falha ao criar sala: Nenhum PersonaID válido",
  T_49_META_TYP_409_I5_D: "Status de erro indefinido",
  T_49_META_TYP_409_I6_D: "Os serviços comerciais estão fechados e os usuários não podem mais usar os serviços do desenvolvedor",
  T_49_META_TYP_409_I7_D: "Falha na mudança de equipe - modo não suportado",
  T_49_META_TYP_409_I8_D: "Falha na mudança de equipe - atualmente já está na equipe alvo",
  T_49_META_TYP_409_I9_D: "Falha na alteração da equipe - objeto inválido",
  T_49_META_TYP_41_I0_D: "Forma do sprite",
  T_49_META_TYP_41_I19_D: "Desativar caixa de colisão",
  T_49_META_TYP_41_I3_D: "Cor Desativada",
  T_49_META_TYP_41_I4_D: "Cor ao Pressionar",
  T_49_META_TYP_41_I5_D: "Tipo de Preenchimento",
  T_49_META_TYP_41_I6_D: "É Botão FE",
  T_49_META_TYP_41_I7_D: "Sprite ao Pressionar",
  T_49_META_TYP_41_I8_D: "Tipo de Sprite ao Pressionar",
  T_49_META_TYP_41_I9_D: "Tipo de Inversão",
  T_49_META_TYP_411_I0_D: "Velocidade para frente",
  T_49_META_TYP_411_I1_D: "Velocidade para trás",
  T_49_META_TYP_411_I2_D: "Velocidade para cima",
  T_49_META_TYP_411_I3_D: "Velocidade para baixo",
  T_49_META_TYP_411_I4_D: "Dano mínimo de granada",
  T_49_META_TYP_411_I5_D: "Dano máximo de granada",
  T_49_META_TYP_411_I6_D: "Alcance da granada",
  T_49_META_TYP_412_I0_D: "A quantidade de potência que o veículo ganha quando o botão do acelerador é usado",
  T_49_META_TYP_412_I1_D: "A quantidade de potência que o veículo ganha quando o botão de ré/freio é usado",
  T_49_META_TYP_412_I2_D: "Em alta velocidade, o ângulo máximo de direção",
  T_49_META_TYP_412_I3_D: "Limite de velocidade para aplicação de ângulo máximo de direção em alta velocidade",
  T_49_META_TYP_412_I4_D: "Após atingir a velocidade máxima, o veículo não fornecerá mais potência, mas poderá exceder essa velocidade máxima (por exemplo, descendo uma ladeira)",
  T_49_META_TYP_412_I5_D: "Quando o veículo não está sendo controlado, o veículo é desacelerado multiplicando IdleBrakeInput por BrakeTorque",
  T_49_META_TYP_412_I6_D: "Usado para calcular o dano de bater em pessoas, usando os parâmetros da fórmula de dano",
  T_49_META_TYP_412_I7_D: "Usado para calcular o dano de bater em pessoas. Após exceder essa velocidade, o dano não aumentará.",
  T_49_META_TYP_412_I8_D: "Usado para cálculo de danos de colisão, danos mínimos",
  T_49_META_TYP_412_I9_D: "Usado para cálculo de danos de colisão, dano máximo",
  T_49_META_TYP_413_I0_D: "Roupa transformada do jogador (NPC)",
  T_49_META_TYP_414_I1_D: "Ampla gama",
  T_49_META_TYP_415_I0_D: "ID de persona",
  T_49_META_TYP_415_I1_D: "Apelido",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "Persona vinculado",
  T_49_META_TYP_416_I2_D: "Desvio",
  T_49_META_TYP_416_I3_D: "Altura",
  T_49_META_TYP_416_I4_D: "Se deve responder a mensagens do sistema",
  T_49_META_TYP_416_I5_D: "Apelido da Persona",
  T_49_META_TYP_416_I6_D: "Persona Avatar",
  T_49_META_TYP_416_I7_D: "Apelido de usuário",
  T_49_META_TYP_416_I8_D: "Avatar do usuário",
  T_49_META_TYP_417_I0_D: "ID do recurso",
  T_49_META_TYP_418_I0_D: "Expiração da Associação",
  T_49_META_TYP_418_I1_D: "Torne-se um membro",
  T_49_META_TYP_418_I2_D: "Renovação de Associação",
  T_49_META_TYP_42_I0_D: "Texto Padrão",
  T_49_META_TYP_42_I1_D: "Texto Ativo",
  T_49_META_TYP_42_I10_D: "Comprimento Máximo",
  T_49_META_TYP_42_I14_D: "Cor ao Pressionar",
  T_49_META_TYP_42_I16_D: "Chave de localização, pode ser usada em vários idiomas",
  T_49_META_TYP_42_I3_D: "Alinhamento",
  T_49_META_TYP_42_I4_D: "Alinhamento Vertical",
  T_49_META_TYP_42_I5_D: "Negrito",
  T_49_META_TYP_42_I6_D: "Itálico",
  T_49_META_TYP_42_I7_D: "Sublinhado",
  T_49_META_TYP_42_I8_D: "Espaçamento entre Linhas",
  T_49_META_TYP_42_I9_D: "Quebra de Linha",
  T_49_META_TYP_424_I0_D: "Efeito de neblina linear",
  T_49_META_TYP_424_I1_D: "Efeito de neblina de índice",
  T_49_META_TYP_424_I2_D: "Efeito de neblina quadrada exponencial",
  T_49_META_TYP_426_I0_D: "Intensidade",
  T_49_META_TYP_426_I1_D: "Alcance",
  T_49_META_TYP_426_I2_D: "O ângulo do cone do holofote em graus",
  T_49_META_TYP_426_I3_D: "Cor clara",
  T_49_META_TYP_428_I0_D: "IDs de Skins de Arma",
  T_49_META_TYP_428_I2_D: "Definir ID",
  T_49_META_TYP_428_I3_D: "ID do cocar",
  T_49_META_TYP_428_I4_D: "Identificação facial",
  T_49_META_TYP_428_I5_D: "ID de maquiagem",
  T_49_META_TYP_428_I6_D: "ID da parte superior do corpo",
  T_49_META_TYP_428_I7_D: "ID da parte inferior do corpo",
  T_49_META_TYP_428_I8_D: "Identificação do sapato",
  T_49_META_TYP_431_I1_D: "Trajetória da entidade alvo",
  T_49_META_TYP_431_I3_D: "Velocidade de movimento, unidade: m/s",
  T_49_META_TYP_431_I4_D: `Se deve mover-se em direção à tangente do caminho
O valor padrão é Falso, o que significa que a direção do objeto em movimento permanece inalterada.
Quando Verdadeiro, o objeto em movimento ficará voltado para a direção do caminho.
`,
  T_49_META_TYP_431_I5_D: "Porcentagem jogada",
  T_49_META_TYP_432_I0_D: "Ângulo de rotação, que afeta a rotação radial do caminho em ambos os lados deste ponto",
  T_49_META_TYP_432_I1_D: "A posição relativa do ponto de controle tangente e do waypoint determina a tangente do caminho",
  T_49_META_TYP_433_I0_D: "Interpolar linhas retas entre pontos do caminho",
  T_49_META_TYP_433_I1_D: "Interpolação curva entre pontos de caminho para movimento suave",
  T_49_META_TYP_433_I2_D: "Suporte ao ajuste manual da tangente do ponto da curva",
  T_49_META_TYP_434_I0_D: "Tipo de caminho",
  T_49_META_TYP_434_I1_D: "O comprimento total do caminho",
  T_49_META_TYP_434_I2_D: "Se o começo e o fim estão conectados",
  T_49_META_TYP_434_I3_D: "Coleção de pontos de passagem",
  T_49_META_TYP_437_I3_D: "Jogadores à esquerda",
  T_49_META_TYP_437_I4_D: "Jogadores à direita",
  T_49_META_TYP_437_I5_D: "Matriz de nomes de tipos integrais",
  T_49_META_TYP_437_I6_D: "A matriz de pontos à esquerda (Liste uma dimensão: jogadores; Liste duas dimensões: dados de pontos preenchidos de acordo com o tipo de pontos personalizados)",
  T_49_META_TYP_437_I7_D: "A matriz de pontos à direita (Liste uma dimensão: jogadores; Liste duas dimensões: dados de pontos preenchidos de acordo com o tipo de pontos personalizados)",
  T_49_META_TYP_438_I1_D: "Agrupamento de jogadores",
  T_49_META_TYP_438_I2_D: "Matriz de classificação de grupo",
  T_49_META_TYP_438_I3_D: "Matriz de pontuação de grupo",
  T_49_META_TYP_438_I4_D: "Matriz de nomes de tipos integrais",
  T_49_META_TYP_438_I5_D: "Matriz de cores agrupadas",
  T_49_META_TYP_438_I6_D: "Matriz de pontos do jogador (correspondente à ordem quando não agrupados)",
  T_49_META_TYP_442_I1_D: "Pontuação esquerda",
  T_49_META_TYP_442_I10_D: "Ícone da morte à direita",
  T_49_META_TYP_442_I2_D: "Pontuação direita",
  T_49_META_TYP_442_I3_D: "Número de sobreviventes à esquerda",
  T_49_META_TYP_442_I4_D: "Número de sobreviventes à direita",
  T_49_META_TYP_442_I5_D: "Número de mortos à esquerda",
  T_49_META_TYP_442_I6_D: "Número de mortos à direita",
  T_49_META_TYP_442_I7_D: "Ícone de sobrevivência à esquerda",
  T_49_META_TYP_442_I8_D: "Ícone de sobrevivência à direita",
  T_49_META_TYP_442_I9_D: "Ícone da morte à esquerda",
  T_49_META_TYP_444_I0_D: "Inglês",
  T_49_META_TYP_444_I1_D: "Chinês simplificado",
  T_49_META_TYP_444_I10_D: "Francês",
  T_49_META_TYP_444_I11_D: "Alemão",
  T_49_META_TYP_444_I12_D: "turco",
  T_49_META_TYP_444_I13_D: "hindi",
  T_49_META_TYP_444_I14_D: "japonês",
  T_49_META_TYP_444_I15_D: "romeno",
  T_49_META_TYP_444_I16_D: "árabe",
  T_49_META_TYP_444_I17_D: "birmanês",
  T_49_META_TYP_444_I18_D: "urdu",
  T_49_META_TYP_444_I19_D: "bengali",
  T_49_META_TYP_444_I2_D: "Chinês tradicional",
  T_49_META_TYP_444_I3_D: "tailandês",
  T_49_META_TYP_444_I4_D: "vietnamita",
  T_49_META_TYP_444_I5_D: "indonésio",
  T_49_META_TYP_444_I6_D: "Português",
  T_49_META_TYP_444_I7_D: "Espanhol",
  T_49_META_TYP_444_I8_D: "russo",
  T_49_META_TYP_444_I9_D: "coreano",
  T_49_META_TYP_51_I0_D: "Zumbi normal",
  T_49_META_TYP_51_I1_D: "Zumbi Cortador de Madeira",
  T_49_META_TYP_51_I10_D: "Abelha Bomba Voadora",
  T_49_META_TYP_51_I11_D: "Dragão Zumbi",
  T_49_META_TYP_51_I2_D: "Zumbi Arremessador",
  T_49_META_TYP_51_I3_D: "Zumbi Explosivo",
  T_49_META_TYP_51_I4_D: "Zumbi Tirano",
  T_49_META_TYP_51_I5_D: "Zumbi Arremessador Vermelho",
  T_49_META_TYP_51_I6_D: "Sr. V",
  T_49_META_TYP_51_I7_D: "Zumbi Tanque",
  T_49_META_TYP_51_I8_D: "Zumbi Broca",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Atraso da Explosão",
  T_49_META_TYP_56_I11_D: "Alcance da Explosão",
  T_49_META_TYP_56_I12_D: "Dano da Explosão",
  T_49_META_TYP_56_I13_D: "Tempo de Queima",
  T_49_META_TYP_56_I14_D: "Dano de Queima",
  T_49_META_TYP_56_I15_D: "Intervalo de Dano de Queima",
  T_49_META_TYP_56_I17_D: "Motorista de veículo",
  T_49_META_TYP_56_I18_D: "Todos os passageiros a bordo",
  T_49_META_TYP_56_I19_D: "ID da Pele do Veículo",
  T_49_META_TYP_56_I20_D: "Priorizar Configuração do Jogador",
  T_49_META_TYP_56_I21_D: "HP Máx.",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Se deve transferir manualmente ou automaticamente (manual por padrão)",
  T_49_META_TYP_58_I0_D: "Tipo BUFF gerado",
  T_49_META_TYP_58_I1_D: "O tempo desde quando um BUFF é escolhido até quando o próximo BUFF é gerado, em segundos",
  T_49_META_TYP_59_I0_D: "Tipo de Movimento",
  T_49_META_TYP_59_I1_D: "Valor do Movimento X",
  T_49_META_TYP_59_I2_D: "Valor do Movimento Y",
  T_49_META_TYP_59_I3_D: "Valor do Movimento Z",
  T_49_META_TYP_59_I4_D: "Duração do Movimento",
  T_49_META_TYP_59_I5_D: "Duração de Parada",
  T_49_META_TYP_59_I6_D: "Desativar Movimento Alternado",
  T_49_META_TYP_60_I0_D: "Pontos de Saque de Arma",
  T_49_META_TYP_61_I0_D: "Moeda Vinculada",
  T_49_META_TYP_61_I1_D: "Defina o intervalo de disparo",
  T_49_META_TYP_61_I2_D: "Visibilidade do Modelo",
  T_49_META_TYP_62_I0_D: "Velocidade XZ",
  T_49_META_TYP_62_I1_D: "Velocidade Y",
  T_49_META_TYP_64_I0_D: "Tipo de componente musical",
  T_49_META_TYP_66_I0_D: "ID da instância",
  T_49_META_TYP_66_I1_D: "Ponto de Caminho",
  T_49_META_TYP_68_I0_D: "Saúde atual da IA",
  T_49_META_TYP_68_I1_D: "A saúde máxima atual da IA",
  T_49_META_TYP_68_I10_D: "A IA derrubará equipamentos ou itens quando morrer?",
  T_49_META_TYP_68_I11_D: "Se a IA está atualmente em um estado invencível",
  T_49_META_TYP_68_I12_D: "Ao receber dano, a porcentagem de dano pode ser reduzida ou aumentada.",
  T_49_META_TYP_68_I13_D: "Tipos de IA",
  T_49_META_TYP_68_I14_D: "se deve ou não reivindicar automaticamente o inimigo",
  T_49_META_TYP_68_I15_D: "0 significa ataque automático, 1 significa ataque defensivo, 2 significa nenhum ataque",
  T_49_META_TYP_68_I16_D: "ID do Caminho",
  T_49_META_TYP_68_I17_D: "Alvo de Perseguição",
  T_49_META_TYP_68_I18_D: "Alvo de Ataque",
  T_49_META_TYP_68_I19_D: "Coordenadas do ponto de spawn da IA",
  T_49_META_TYP_68_I2_D: "Obtenha a entidade da equipe à qual a IA pertence",
  T_49_META_TYP_68_I20_D: "Número da facção da equipe",
  T_49_META_TYP_68_I4_D: "Somente o poder de ataque dos ataques normais pode ser modificado, e o poder de ataque das habilidades não é contado.",
  T_49_META_TYP_68_I7_D: "O alcance do movimento livre da IA. Você só pode modificar o valor básico. Se houver um bônus adicional, ele será adicionado com base no valor.",
  T_49_META_TYP_68_I8_D: "A IA detecta o alcance do inimigo e pode modificar apenas o valor básico. Se houver um bônus adicional, ele será adicionado com base no valor.",
  T_49_META_TYP_68_I9_D: "A velocidade real do movimento. Se houver uma aceleração de habilidade, ela será multiplicada por ela.",
  T_49_META_TYP_70_I0_D: "O ID da entidade de destino da fórmula, usado internamente e não visível para o jogador.",
  T_49_META_TYP_70_I1_D: "O ID do atributo da entidade de destino da fórmula, usado internamente e não visível para o jogador.",
  T_49_META_TYP_70_I2_D: "O valor mínimo permitido",
  T_49_META_TYP_70_I3_D: "O valor máximo permitido",
  T_49_META_TYP_70_I4_D: "Coeficiente Base",
  T_49_META_TYP_70_I5_D: "Pré-acumulador",
  T_49_META_TYP_70_I6_D: "Multiplicador",
  T_49_META_TYP_70_I7_D: "Multiplicar e Acumular",
  T_49_META_TYP_70_I8_D: "Pós-acumulador",
  T_49_META_TYP_71_I0_D: "Número do produto",
  T_49_META_TYP_71_I1_D: "Preço",
  T_49_META_TYP_71_I10_D: "Lista de Itens",
  T_49_META_TYP_71_I2_D: "Tipo de moeda",
  T_49_META_TYP_71_I3_D: "Limite geral de compra",
  T_49_META_TYP_71_I4_D: "Restrições gerais de compra atuais",
  T_49_META_TYP_71_I5_D: "Nome do produto",
  T_49_META_TYP_71_I6_D: "Descrição do produto",
  T_49_META_TYP_71_I7_D: "Lista de itens do produto",
  T_49_META_TYP_71_I8_D: "Contagem de Itens",
  T_49_META_TYP_71_I9_D: "Caminho do recurso, vazio por padrão",
  T_49_META_TYP_72_I1_D: "Lista de Prateleiras",
  T_49_META_TYP_73_I1_D: "Fechamento Manual Desativado",
  T_49_META_TYP_74_I0_D: "Separador",
  T_49_META_TYP_74_I1_D: "Capacete",
  T_49_META_TYP_74_I2_D: "Colete",
  T_49_META_TYP_74_I3_D: "Granada",
  T_49_META_TYP_75_I0_D: "Só ida",
  T_49_META_TYP_75_I1_D: "Ida e Volta",
  T_49_META_TYP_76_I0_D: "Apenas patrulhe, não ataque alvos ao longo do caminho",
  T_49_META_TYP_76_I1_D: "Patrulha com Ataque",
  T_49_META_TYP_79_I0_D: "Poder de ataque da arma",
  T_49_META_TYP_79_I1_D: "Alcance de Ataque",
  T_49_META_TYP_79_I10_D: "Contagem Inicial de Dispersão de Munição",
  T_49_META_TYP_79_I11_D: "ID da Arma",
  T_49_META_TYP_79_I12_D: "O tempo mínimo de espera entre dois tiros, em segundos. Cada tiro pode disparar várias balas, dependendo do tipo de disparo.",
  T_49_META_TYP_79_I13_D: "Jogadores que possuem esta arma",
  T_49_META_TYP_79_I14_D: "Consome Munição",
  T_49_META_TYP_79_I15_D: "Tipo de empunhadura dupla (0: sem empunhadura dupla, 1: próprio, 2: qualquer arma)",
  T_49_META_TYP_79_I16_D: "Coeficiente de dano de armadura",
  T_49_META_TYP_79_I17_D: "Velocidade de movimento do jogador",
  T_49_META_TYP_79_I18_D: "Taxa de dano para golpes no tronco",
  T_49_META_TYP_79_I19_D: "Taxa de dano para tiros na cabeça",
  T_49_META_TYP_79_I2_D: "O tempo mínimo de espera entre duas balas, em segundos",
  T_49_META_TYP_79_I20_D: "Taxa de dano para membros",
  T_49_META_TYP_79_I21_D: "Taxa de dano adicional (carro, parede de gelo do barril de óleo)",
  T_49_META_TYP_79_I22_D: "Visível nas Costas",
  T_49_META_TYP_79_I23_D: "Bata no chão para dano extra",
  T_49_META_TYP_79_I24_D: "Munição por Disparo",
  T_49_META_TYP_79_I25_D: "Velocidade de recarga (velocidade base * coeficiente)",
  T_49_META_TYP_79_I26_D: "Contagem atual de munição",
  T_49_META_TYP_79_I27_D: "Identificação da pele da arma",
  T_49_META_TYP_79_I28_D: "Quando a configuração do jogador é priorizada, a configuração da skin da arma do jogador substituirá os atributos da skin da arma.",
  T_49_META_TYP_79_I29_D: "Ao escrever as propriedades de uma skin de arma em uma arma, o valor básico da arma será afetado pela skin da arma",
  T_49_META_TYP_79_I3_D: "Tamanho do Carregador de Munição",
  T_49_META_TYP_79_I30_D: "Taxa de aumento de dispersão (0,1 = cada rajada adicional de tiros aumenta a mira em 10%)",
  T_49_META_TYP_79_I31_D: "Velocidade de recuperação de dispersão",
  T_49_META_TYP_79_I32_D: "A velocidade do jogador ao atirar afeta",
  T_49_META_TYP_79_I33_D: "Tamanho de dispersão ao mover (1,5 = 1,5 * tamanho da mira base)",
  T_49_META_TYP_79_I34_D: "Tipo de Arma",
  T_49_META_TYP_79_I36_D: "Tipo de Fogo",
  T_49_META_TYP_79_I37_D: "Único Disparo",
  T_49_META_TYP_79_I38_D: "Silenciado",
  T_49_META_TYP_79_I39_D: "Taxa de Velocidade de Movimento ao Mirar",
  T_49_META_TYP_79_I4_D: "Contagem Inicial de Carregadores",
  T_49_META_TYP_79_I5_D: "Penetração de Armadura",
  T_49_META_TYP_79_I6_D: "Distância de Dano Total",
  T_49_META_TYP_79_I7_D: "Distância Mínima de Dano",
  T_49_META_TYP_79_I8_D: "Dano Mínimo",
  T_49_META_TYP_79_I9_D: "O número de balas que podem ser disparadas antes que a dispersão comece",
  T_49_META_TYP_80_I1_D: "Quando verdadeiro, o fechamento manual é proibido",
  T_49_META_TYP_80_I2_D: "Entidade de loja vinculada",
  T_49_META_TYP_80_I4_D: "ID do Carteira Vinculada",
  T_49_META_TYP_80_I5_D: "Tipo de Solicitação",
  T_49_META_TYP_80_I6_D: "O tipo de alvo solicitado pelo player de IU atual",
  T_49_META_TYP_80_I7_D: "ID do Jogador Acionador",
  T_49_META_TYP_81_I0_D: "Buff aleatório",
  T_49_META_TYP_81_I1_D: "Buff HP",
  T_49_META_TYP_81_I2_D: "Buff Bala",
  T_49_META_TYP_81_I3_D: "Buff Armadura",
  T_49_META_TYP_82_I1_D: "Ícone de botão",
  T_49_META_TYP_82_I3_D: "Posição relativa ao ponto de ancoragem",
  T_49_META_TYP_83_I1_D: "Dinheiro",
  T_49_META_TYP_83_I2_D: "Parâmetros de passagem",
  T_49_META_TYP_86_I0_D: "Mínimo",
  T_49_META_TYP_86_I1_D: "Máximo",
  T_49_META_TYP_86_I2_D: "Coeficiente base, multiplicado pelo valor original antes de todos os cálculos",
  T_49_META_TYP_86_I3_D: "Pré-acumulador, acumula antes da multiplicação e participa do cálculo da multiplicação",
  T_49_META_TYP_86_I4_D: "Multiplicador contínuo, multiplicação contínua, por exemplo (reduzir para 90%, fortalecer para 110%) o efeito é Valor*90%*110%",
  T_49_META_TYP_86_I5_D: "Acumulador de multiplicação, por exemplo (adicionar 10%, adicionar 5%) tem o efeito de Valor*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Pós-acumulador, não participa do cálculo da multiplicação e é adicionado no final",
  T_49_META_TYP_88_I0_D: "Tipo básico, a moeda mais básica do jogo, o tipo de preço de commodities gerais na versão atual",
  T_49_META_TYP_89_I0_D: "Atualmente, só existe moeda base na versão",
  T_49_META_TYP_89_I1_D: "Montante da moeda",
  T_49_META_TYP_89_I2_D: "Ícones de moeda",
  T_49_META_TYP_89_I3_D: "Cor do ícone da moeda",
  T_49_META_TYP_90_I0_D: "O conteúdo da carteira é um monte de moedas",
  T_49_META_TYP_92_I0_D: "Caixa de madeira quadrada",
  T_49_META_TYP_92_I1_D: "Caixa de madeira longa",
  T_49_META_TYP_92_I10_D: "Torre de vigia",
  T_49_META_TYP_92_I100_D: "Escada",
  T_49_META_TYP_92_I101_D: "Pouso de Escada B",
  T_49_META_TYP_92_I102_D: "Pouso de Escada A",
  T_49_META_TYP_92_I103_D: "Cabine Telefônica",
  T_49_META_TYP_92_I104_D: "Muro Temático BIS",
  T_49_META_TYP_92_I105_D: "Canteiro de Flores Temático BIS",
  T_49_META_TYP_92_I106_D: "Máquina de Vendas",
  T_49_META_TYP_92_I107_D: "Entidade Monstro",
  T_49_META_TYP_92_I108_D: "Gerador de Unidades",
  T_49_META_TYP_92_I109_D: "Carro esportivo",
  T_49_META_TYP_92_I11_D: "Posto de guarda",
  T_49_META_TYP_92_I110_D: "Tuk-Tuk",
  T_49_META_TYP_92_I111_D: "Caixa de Madeira Destrutível",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motocicleta",
  T_49_META_TYP_92_I114_D: "Caminhões Monstros",
  T_49_META_TYP_92_I115_D: "Gerador de Ouro",
  T_49_META_TYP_92_I116_D: "Pouso de Escada C",
  T_49_META_TYP_92_I117_D: "Placa",
  T_49_META_TYP_92_I118_D: "Cerca",
  T_49_META_TYP_92_I119_D: "Máquina de Camisetas",
  T_49_META_TYP_92_I12_D: "Casa de dois andares",
  T_49_META_TYP_92_I121_D: "Pilar de Concreto",
  T_49_META_TYP_92_I122_D: "Pacote de Item de Futebol",
  T_49_META_TYP_92_I123_D: "Barril de Óleo",
  T_49_META_TYP_92_I124_D: "Área de Baixa Gravidade",
  T_49_META_TYP_92_I125_D: "Arma",
  T_49_META_TYP_92_I126_D: "Cerca B",
  T_49_META_TYP_92_I127_D: "Casa Pequena A",
  T_49_META_TYP_92_I128_D: "Caminhão Danificado",
  T_49_META_TYP_92_I129_D: "Esfera Básica",
  T_49_META_TYP_92_I13_D: "Escultura de areia",
  T_49_META_TYP_92_I130_D: "Cone Básico",
  T_49_META_TYP_92_I131_D: "Cilindro Básico",
  T_49_META_TYP_92_I132_D: "Gerador de Itens Consumíveis",
  T_49_META_TYP_92_I133_D: "Corpo d'Água Personalizado",
  T_49_META_TYP_92_I134_D: "Seta",
  T_49_META_TYP_92_I135_D: "Bloco Tingido",
  T_49_META_TYP_92_I136_D: "Barril de Óleo Tingido",
  T_49_META_TYP_92_I137_D: "Texto",
  T_49_META_TYP_92_I138_D: "Ícone",
  T_49_META_TYP_92_I139_D: "Boneca de Gelo",
  T_49_META_TYP_92_I14_D: "Fonte",
  T_49_META_TYP_92_I140_D: "Gatilho em Cápsula",
  T_49_META_TYP_92_I141_D: "Gatilho de Colisão Esférica",
  T_49_META_TYP_92_I142_D: "Bloco Básico de Cor Sólida Reflexiva 1",
  T_49_META_TYP_92_I143_D: "Fabricante de Carros de Bumper",
  T_49_META_TYP_92_I144_D: "Bloco de Parque de Diversões Xadrez",
  T_49_META_TYP_92_I145_D: "Tela Grande",
  T_49_META_TYP_92_I146_D: "Palco",
  T_49_META_TYP_92_I147_D: "Pirulito Gigante",
  T_49_META_TYP_92_I148_D: "Caminhão de Comida B",
  T_49_META_TYP_92_I15_D: "Árvore de cerejeira",
  T_49_META_TYP_92_I16_D: "Casa térrea",
  T_49_META_TYP_92_I17_D: "Casa de três andares",
  T_49_META_TYP_92_I18_D: "Bananeira",
  T_49_META_TYP_92_I19_D: "Vaso sanitário",
  T_49_META_TYP_92_I2_D: "Caixa de madeira longa coberta por arbustos",
  T_49_META_TYP_92_I20_D: "Cerca",
  T_49_META_TYP_92_I21_D: "Contêiner destruível",
  T_49_META_TYP_92_I22_D: "Cerca destruível",
  T_49_META_TYP_92_I23_D: "Pneu",
  T_49_META_TYP_92_I24_D: "Carro de bate-bate",
  T_49_META_TYP_92_I25_D: "Veículo anfíbio",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Lixeira",
  T_49_META_TYP_92_I28_D: "Tenda médica",
  T_49_META_TYP_92_I29_D: "Garagem",
  T_49_META_TYP_92_I3_D: "Moinho de feno",
  T_49_META_TYP_92_I30_D: "Parede pintada",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Plataforma de ferro",
  T_49_META_TYP_92_I33_D: "Casa contêiner",
  T_49_META_TYP_92_I34_D: "Reboque",
  T_49_META_TYP_92_I35_D: "Parede A",
  T_49_META_TYP_92_I36_D: "Notas Musicais - Piano",
  T_49_META_TYP_92_I37_D: "Notas Musicais - Piano",
  T_49_META_TYP_92_I38_D: "Notas Musicais - Bateria",
  T_49_META_TYP_92_I39_D: "Notas Musicais - Bateria",
  T_49_META_TYP_92_I4_D: "Carro destruído",
  T_49_META_TYP_92_I40_D: "Notas Musicais - Sintetizador A",
  T_49_META_TYP_92_I41_D: "Notas Musicais - Sintetizador A",
  T_49_META_TYP_92_I42_D: "Notas Musicais - Sintetizador B",
  T_49_META_TYP_92_I43_D: "Notas Musicais - Sintetizador B",
  T_49_META_TYP_92_I44_D: "Notas Musicais - Sintetizador C",
  T_49_META_TYP_92_I45_D: "Notas Musicais - Sintetizador C",
  T_49_META_TYP_92_I46_D: "Gerador de Buff",
  T_49_META_TYP_92_I47_D: "Mecanismo de hélice",
  T_49_META_TYP_92_I48_D: "Mecanismo de frigideira",
  T_49_META_TYP_92_I49_D: "Armadilha de bloco",
  T_49_META_TYP_92_I5_D: "Ônibus destruído",
  T_49_META_TYP_92_I50_D: "Mecanismo de anel",
  T_49_META_TYP_92_I51_D: "Armadilha de martelo gigante",
  T_49_META_TYP_92_I52_D: "Placa móvel",
  T_49_META_TYP_92_I53_D: "Alvo em movimento",
  T_49_META_TYP_92_I54_D: "Parede Telescópica",
  T_49_META_TYP_92_I55_D: "Componentes de armas de pontos de saque",
  T_49_META_TYP_92_I56_D: "Componente de marcador de ponto de saque",
  T_49_META_TYP_92_I57_D: "Componentes de itens consumíveis de pontos de saque",
  T_49_META_TYP_92_I58_D: "Componente de item de lançamento de ponto de saque",
  T_49_META_TYP_92_I59_D: "Componente de zoom do ponto de saque",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Componentes de armadura de ponto de saque",
  T_49_META_TYP_92_I61_D: "Tubo I",
  T_49_META_TYP_92_I62_D: "Tubo T",
  T_49_META_TYP_92_I63_D: "Tubo cruzado",
  T_49_META_TYP_92_I64_D: "Tubo de cotovelo",
  T_49_META_TYP_92_I65_D: "Agrupamento de cogumelos gigantes",
  T_49_META_TYP_92_I66_D: "Secador de roupas",
  T_49_META_TYP_92_I67_D: "Ponte de tábuas",
  T_49_META_TYP_92_I68_D: "Tela",
  T_49_META_TYP_92_I69_D: "Coluna de concreto",
  T_49_META_TYP_92_I7_D: "Contentor B",
  T_49_META_TYP_92_I70_D: "Cacto",
  T_49_META_TYP_92_I71_D: "Madeira morta",
  T_49_META_TYP_92_I72_D: "Lanterna de palácio",
  T_49_META_TYP_92_I73_D: "Poste de luz",
  T_49_META_TYP_92_I74_D: "Painel solar",
  T_49_META_TYP_92_I75_D: "Ar Condicionado",
  T_49_META_TYP_92_I76_D: "Quadrado",
  T_49_META_TYP_92_I77_D: "Declive",
  T_49_META_TYP_92_I78_D: "Caminhão de Comida",
  T_49_META_TYP_92_I79_D: "Gatilho de Morte ou Invencibilidade",
  T_49_META_TYP_92_I8_D: "Contentor C",
  T_49_META_TYP_92_I80_D: "Ponto de Verificação",
  T_49_META_TYP_92_I81_D: "Posição final",
  T_49_META_TYP_92_I82_D: "Dados",
  T_49_META_TYP_92_I83_D: "Banco",
  T_49_META_TYP_92_I84_D: "Estação de Ônibus",
  T_49_META_TYP_92_I85_D: "Casinha de Cachorro",
  T_49_META_TYP_92_I86_D: "Anúncio",
  T_49_META_TYP_92_I87_D: "Jarra de água",
  T_49_META_TYP_92_I88_D: "Muro de Grafite",
  T_49_META_TYP_92_I89_D: "Cabana de palha",
  T_49_META_TYP_92_I9_D: "Cabine",
  T_49_META_TYP_92_I90_D: "Ponte de Arco de Pedra",
  T_49_META_TYP_92_I91_D: "Conjunto de Pátio com Guarda-chuva",
  T_49_META_TYP_92_I92_D: "Faixa de Chegada",
  T_49_META_TYP_92_I93_D: "Fortaleza",
  T_49_META_TYP_92_I94_D: "Ponto de Surgimento do Monstro",
  T_49_META_TYP_92_I95_D: "Marca",
  T_49_META_TYP_92_I97_D: "Gatilho Personalizado",
  T_49_META_TYP_92_I98_D: "Porta Dupla",
  T_49_META_TYP_92_I99_D: "Barreira",
  T_49_META_TYP_94_I0_D: "Adicionar",
  T_49_META_TYP_94_I1_D: "Multiplicar",
  T_49_META_TYP_95_I0_D: "Tipo de moeda",
  T_49_META_TYP_95_I1_D: "Montante da moeda",
  T_49_META_TYP_96_I0_D: "Obter Carteira",
  T_49_META_TYP_96_I1_D: "Posição de exibição (o ponto de ancoragem é o canto superior direito)",
  T_49_META_TYP_97_I0_D: "Posição em coordenadas mundiais",
  T_49_META_TYP_97_I1_D: "O ângulo de rotação no sistema de coordenadas mundial, os componentes XYZ são ângulo de inclinação, ângulo de guinada e ângulo de rolagem, e a ordem de rotação é YXZ.",
  T_49_META_TYP_97_I10_D: "A direção do eixo de coordenadas local x",
  T_49_META_TYP_97_I11_D: "A direção do eixo de coordenadas local z",
  T_49_META_TYP_97_I2_D: "Escala em coordenadas mundiais",
  T_49_META_TYP_97_I3_D: "O nó pai deste nó",
  T_49_META_TYP_97_I4_D: "Rotação em coordenadas mundiais, expressa em quaternions",
  T_49_META_TYP_97_I5_D: "Posição no sistema de coordenadas local",
  T_49_META_TYP_97_I6_D: "Rotação no sistema de coordenadas local, expressa como um quaternion",
  T_49_META_TYP_97_I7_D: "O ângulo de rotação no sistema de coordenadas local, os componentes XYZ são ângulo de inclinação, ângulo de guinada e ângulo de rolagem, e a ordem de rotação é YXZ.",
  T_49_META_TYP_97_I8_D: "Dimensionamento de tamanho no sistema de coordenadas local",
  T_49_META_TYP_97_I9_D: "A direção do eixo de coordenadas local y",
  T_49_META_TYP_99_I0_D: "Raio de Futebol",
  T_49_META_TYP_99_I1_D: "Coeficiente de atrito em condições normais",
  T_49_META_TYP_99_I2_D: "Coeficiente de atrito sob impacto",
  T_49_META_TYP_99_I3_D: "Ângulo Mínimo de Disparo",
  T_49_META_TYP_99_I4_D: "Ângulo de Elevação Mínimo",
  T_49_META_TYP_99_I5_D: "Tempo de Redefinição",
  T_49_META_TYP_99_I6_D: "Ângulo Máximo de Disparo",
  T_49_META_TYP_99_I7_D: "Posição de Redefinição",
  T_49_META_TYPE_0_D: "Objeto, a raiz da hierarquia de tipos",
  T_49_META_TYPE_1_D: "Lista é um contêiner para um conjunto de dados",
  T_49_META_TYPE_10_D: "Componente base da entidade, todos os componentes combinarão este componente",
  T_49_META_TYPE_100_D: "Máquina de Camisetas",
  T_49_META_TYPE_101_D: "Objeto Morphable",
  T_49_META_TYPE_1010_D: "Informações do Temporizador",
  T_49_META_TYPE_1011_D: "Banner de Abertura",
  T_49_META_TYPE_1012_D: "A entidade banner no início da rodada das duas equipes. Modificar as propriedades da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1013_D: "Geralmente, a entidade do banner no início da rodada, modificando as propriedades da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1014_D: "Entidade de banner de pontuação da rodada da equipe. Modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1015_D: "Entidade do Checkpoint Manager. Modificar atributos de entidade afetará o conteúdo de exibição na UI correspondente.",
  T_49_META_TYPE_1016_D: "A entidade é exibida no final da rodada. Modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1017_D: "Se houver duas equipes no início, exiba a faixa de duas equipes lutando uma contra a outra",
  T_49_META_TYPE_1018_D: "A pontuação de ambas as equipes",
  T_49_META_TYPE_1019_D: "Resultado final: vitória, derrota, empate",
  T_49_META_TYPE_102_D: "Tipo de fonte de ressurreição: Morte, Queda",
  T_49_META_TYPE_1020_D: "Ao transformar a entidade em número, modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1021_D: "Entidade de contagem regressiva de fase. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente.",
  T_49_META_TYPE_1022_D: "Entidade de legenda de informações do jogo. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente.",
  T_49_META_TYPE_1023_D: "Entidades de informações de jogo de duas equipes. Modificar atributos de entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1024_D: "Entidade de UI de informações de partida de equipe. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente.",
  T_49_META_TYPE_1027_D: "Descreve o tipo de um tipo, que é retornado quando Typeof é usado",
  T_49_META_TYPE_1028_D: "Entidade de informações de facção. Modificar atributos de entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1029_D: "O ícone solicita informações sobre a entidade, a modificação dos atributos da entidade afetará o conteúdo exibido na IU correspondente",
  T_49_META_TYPE_103_D: "Enumeração do tipo de slot do item",
  T_49_META_TYPE_1030_D: "Uma entidade simplificada das informações do jogo dos dois times. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente",
  T_49_META_TYPE_1031_D: "Entidade de interface de prompt de tempo, modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1032_D: "O texto flutuante solicita a entidade. Modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1033_D: "A entidade de troca de turno inclui a liquidação do turno atual e as informações do próximo início do turno. Modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_1035_D: "Abra a entidade UI do botão do placar. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente.",
  T_49_META_TYPE_1036_D: "Modo de infecção, IU mostrando o nível atual do zumbi",
  T_49_META_TYPE_1037_D: "Adicione uma entidade de UI de efeito dinâmico de pontos. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente",
  T_49_META_TYPE_1038_D: "Efeitos da interface do usuário do modo de infecção zumbi",
  T_49_META_TYPE_1039_D: "A entidade de prompt de texto flutuante de contagem regressiva, modificando os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_104_D: "Estilo de Camiseta",
  T_49_META_TYPE_1040_D: "Interface do Painel de Seleção de Cartões",
  T_49_META_TYPE_1041_D: "Interface de Notificação de Identidade",
  T_49_META_TYPE_1042_D: "Interface de Contagem Regressiva de 5s",
  T_49_META_TYPE_1043_D: "Interface do Banner do Título",
  T_49_META_TYPE_1044_D: "Interface do Botão de ligar e desligar integrado",
  T_49_META_TYPE_1045_D: "Interface do Botão de Habilidade",
  T_49_META_TYPE_105_D: "Gol de futebol",
  T_49_META_TYPE_106_D: "Tipo de assistência de mira",
  T_49_META_TYPE_107_D: "Pode ser alvo e atingido, mas não necessariamente sofrerá dano",
  T_49_META_TYPE_108_D: "Tipo inteiro, inteiro assinado de 64 bits",
  T_49_META_TYPE_109_D: "A entidade do canal de bate-papo é um contêiner que contém seu próprio ID de canal e jogadores.",
  T_49_META_TYPE_11_D: "Entidade global, única em todo o jogo",
  T_49_META_TYPE_110_D: "Canal de voz ocioso",
  T_49_META_TYPE_111_D: "Tipo de comportamento",
  T_49_META_TYPE_112_D: "Tipo de status de comportamento do jogador",
  T_49_META_TYPE_113_D: "Música de Bateria",
  T_49_META_TYPE_114_D: "Música Lead1",
  T_49_META_TYPE_115_D: "Música Lead2",
  T_49_META_TYPE_116_D: "Música Lead3",
  T_49_META_TYPE_117_D: "Tipo de componente de música de bateria",
  T_49_META_TYPE_118_D: "Grupo",
  T_49_META_TYPE_119_D: "Opções de ataque",
  T_49_META_TYPE_12_D: "Uma entidade de combate que pode atacar, ser atacada, matar, etc.",
  T_49_META_TYPE_120_D: "Interface da Barra de Progresso",
  T_49_META_TYPE_121_D: "Cada intervalo de tempo de onda",
  T_49_META_TYPE_122_D: "Caixa de céu",
  T_49_META_TYPE_123_D: "Enumeração do tipo base Skybox",
  T_49_META_TYPE_124_D: "Intervalo de pesquisa",
  T_49_META_TYPE_125_D: "Você pode modificar a aparência básica dos objetos, como texturas e transparência",
  T_49_META_TYPE_126_D: "Barra de Saúde",
  T_49_META_TYPE_127_D: "Como mover objetos",
  T_49_META_TYPE_128_D: "Objeto Morphable",
  T_49_META_TYPE_129_D: "Tipo de Item de Munição",
  T_49_META_TYPE_13_D: "Entidade de controlo da IU",
  T_49_META_TYPE_130_D: "Tipo de Item Consumível",
  T_49_META_TYPE_131_D: "Tipo de Item de Armadura",
  T_49_META_TYPE_132_D: "Tipo de Item Arremessável",
  T_49_META_TYPE_133_D: "Tipo de Item de Mira",
  T_49_META_TYPE_134_D: "Tipo de Item de Arma",
  T_49_META_TYPE_135_D: "Fará com que o tipo de munição selecionado caia",
  T_49_META_TYPE_136_D: "Produzirá o tipo selecionado de queda de adereços",
  T_49_META_TYPE_137_D: "Fará com que um projétil do tipo selecionado caia",
  T_49_META_TYPE_138_D: "Fará com que um escopo do tipo selecionado seja descartado",
  T_49_META_TYPE_139_D: "Fará com que a armadura do tipo selecionado caia",
  T_49_META_TYPE_14_D: "Entidades do jogador no jogo, uma por usuário",
  T_49_META_TYPE_140_D: "Aceno",
  T_49_META_TYPE_141_D: "Tipo de Item de Futebol",
  T_49_META_TYPE_142_D: "Pacote de Item de Futebol",
  T_49_META_TYPE_143_D: "Tipo de componente de música Lead1",
  T_49_META_TYPE_144_D: "Tipo de componente de música Lead2",
  T_49_META_TYPE_145_D: "Tipo de componente de música Lead3",
  T_49_META_TYPE_146_D: "Tipo de componente de música de teclado",
  T_49_META_TYPE_147_D: "Fornece uma variedade de tipos de câmeras predefinidos, bem como tipos de câmeras personalizados",
  T_49_META_TYPE_148_D: "Componentes da câmera",
  T_49_META_TYPE_149_D: "Chave de localização",
  T_49_META_TYPE_15_D: "As entidades da equipe no jogo, uma para cada equipe",
  T_49_META_TYPE_150_D: "Barril de Óleo",
  T_49_META_TYPE_151_D: "Um quaternion é um vetor especial de quatro dimensões que é usado apenas para representar a rotação.",
  T_49_META_TYPE_152_D: "Área de Baixa Gravidade",
  T_49_META_TYPE_153_D: "Contêiner de entidades, que irá gerar entidades do tipo correspondente no local",
  T_49_META_TYPE_154_D: "Tipo de Arma de Dupla Empunhadura",
  T_49_META_TYPE_155_D: "Entidade Capacete",
  T_49_META_TYPE_156_D: "Entidade de armadura corporal",
  T_49_META_TYPE_157_D: "Tipo de transição de câmera",
  T_49_META_TYPE_158_D: "Interface de prompt de texto",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Entidade de objeto de nível",
  T_49_META_TYPE_160_D: "Tipo de mapa",
  T_49_META_TYPE_161_D: "Efeito Visual de Textura Não Substituível",
  T_49_META_TYPE_162_D: "Lista de tipos",
  T_49_META_TYPE_163_D: "Tipo ou Lista de tipos",
  T_49_META_TYPE_164_D: "Componente é a classe base de todos os componentes de entidade ou classes de componentes específicas",
  T_49_META_TYPE_165_D: "Componente da caixa de colisão",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "A entidade de efeito especial representa um efeito especial exibido (excluído, reciclável e reutilizável)",
  T_49_META_TYPE_17_D: "Lista de Objetos do Nível",
  T_49_META_TYPE_170_D: "Indica se a visibilidade pode ser definida",
  T_49_META_TYPE_171_D: "Cogumelo",
  T_49_META_TYPE_172_D: "Munição",
  T_49_META_TYPE_173_D: "Mochila",
  T_49_META_TYPE_174_D: "Componentes de granadas",
  T_49_META_TYPE_175_D: "Granada congelante",
  T_49_META_TYPE_176_D: "Gerador de Armas",
  T_49_META_TYPE_177_D: "Quando há uma obstrução entre a câmera e o objeto que está sendo seguido, o modo de movimento da câmera",
  T_49_META_TYPE_178_D: "Como a câmera renderiza a imagem",
  T_49_META_TYPE_179_D: "Esfera Básica",
  T_49_META_TYPE_18_D: "(Obsoleto, não utilizar)",
  T_49_META_TYPE_180_D: "Refere-se a uma propriedade de um componente",
  T_49_META_TYPE_181_D: "Usado para descrever o tipo de ativo de malha",
  T_49_META_TYPE_182_D: "Usado para descrever o tipo de ativo material",
  T_49_META_TYPE_183_D: "Usado para descrever o tipo de ativo de textura",
  T_49_META_TYPE_184_D: "Um componente de renderização de ponte para renderização usando recursos de modelo integrados",
  T_49_META_TYPE_185_D: "Componente de renderização personalizado para renderização com recursos de modelo personalizados",
  T_49_META_TYPE_186_D: "Um componente de objeto em branco que pode ser usado com componentes de renderização, componentes de colisão, etc.",
  T_49_META_TYPE_187_D: "Contêiner",
  T_49_META_TYPE_188_D: "Cilindro Básico",
  T_49_META_TYPE_189_D: "Lista de strings localizadas",
  T_49_META_TYPE_19_D: "Modelo de lista, você pode especificar o tipo de conteúdo por meio de T",
  T_49_META_TYPE_190_D: "Painel de Pontuação para Duas Equipes",
  T_49_META_TYPE_191_D: "Uma arma tática de arremesso que pode cegar temporariamente inimigos dentro de um certo alcance.",
  T_49_META_TYPE_192_D: "Após o uso, ele pode produzir fumaça que oculta o evento, o que é uma arma poderosa para interromper o ataque do inimigo.",
  T_49_META_TYPE_193_D: "Painel de Resultados para Múltiplas Equipes",
  T_49_META_TYPE_194_D: "As minas de indução podem ser colocadas no chão. Elas explodirão quando o inimigo se aproximar. Tenha cuidado para não pisar nelas.",
  T_49_META_TYPE_195_D: "Como o movimento interpolado é reproduzido",
  T_49_META_TYPE_197_D: "Componentes jogáveis",
  T_49_META_TYPE_198_D: "Base do item",
  T_49_META_TYPE_199_D: "Equipamento auxiliar para combate aéreo, mas é preciso estar sempre atento ao consumo de energia",
  T_49_META_TYPE_2_D: "Tipo booleano, usado para representar verdadeiro, falso ou sim ou não",
  T_49_META_TYPE_20_D: "Enumeração de tipo de interface integrada, que é gerada automaticamente com base no sistema de tipos",
  T_49_META_TYPE_200_D: "Área de fuga da prisão",
  T_49_META_TYPE_201_D: "Áreas onde você pode nadar depois de entrar",
  T_49_META_TYPE_202_D: "ID do Collider",
  T_49_META_TYPE_203_D: "Movimento de Interpolação",
  T_49_META_TYPE_204_D: "Sapatos equipados com um dispositivo de potência tecnológica que permite dar um salto duplo no ar",
  T_49_META_TYPE_205_D: "Uma asa delta que pode voar no céu. Pode ser usada para pousar de uma altitude alta e se mover para um lugar mais distante.",
  T_49_META_TYPE_206_D: "Skate",
  T_49_META_TYPE_207_D: "Tirolesa",
  T_49_META_TYPE_208_D: "Lista de jogáveis",
  T_49_META_TYPE_209_D: "Jogável ou uma lista de jogáveis",
  T_49_META_TYPE_21_D: "Entidade de interface integrada, encapsulando a interface de funções específicas",
  T_49_META_TYPE_210_D: "Animação balística é uma simulação de movimento balístico.",
  T_49_META_TYPE_211_D: "Tipo de Filtro",
  T_49_META_TYPE_212_D: "Um objeto segue outro",
  T_49_META_TYPE_213_D: "A frente de um objeto sempre fica de frente para o outro objeto",
  T_49_META_TYPE_214_D: "O ID usado para descrever o ativo do sprite do atlas",
  T_49_META_TYPE_215_D: "resultados de um concurso",
  T_49_META_TYPE_216_D: "Recipiente de dados do dicionário, elemento de dados é um par de Chave, Valor",
  T_49_META_TYPE_217_D: "Modelo de dados do dicionário, o tipo de conteúdo pode ser especificado por T1 e T2",
  T_49_META_TYPE_218_D: "Um tipo de fonte de luz que emite luz de igual intensidade em todas as direções a partir de sua localização",
  T_49_META_TYPE_219_D: "Veículos de motocicleta",
  T_49_META_TYPE_22_D: "Interface personalizada, a interface criada pelo jogador através do editor de interface",
  T_49_META_TYPE_220_D: "Veículo tuk-tuk (triciclo)",
  T_49_META_TYPE_221_D: "Veículo de motocicleta anfíbio/metralhadora",
  T_49_META_TYPE_222_D: "Veículo de quatro rodas",
  T_49_META_TYPE_224_D: "Lista de tipos de habilidades",
  T_49_META_TYPE_225_D: "A torre de inteligência artificial feita de materiais de alta tecnologia irá procurar e atacar ativamente os inimigos dentro de um determinado alcance.",
  T_49_META_TYPE_226_D: "A torre gerada após usar o suporte da torre",
  T_49_META_TYPE_227_D: "Enumeração de tipo de controle de IU personalizado",
  T_49_META_TYPE_23_D: "Enumeração de tipo de objeto de nível, que será gerada automaticamente com base no sistema de tipos",
  T_49_META_TYPE_231_D: "Kit de reparo",
  T_49_META_TYPE_233_D: "Círculo de Progresso",
  T_49_META_TYPE_234_D: "Mina criada",
  T_49_META_TYPE_235_D: "Parede de Gel",
  T_49_META_TYPE_236_D: "Muro de gelo criado",
  T_49_META_TYPE_237_D: "Arma com gancho",
  T_49_META_TYPE_238_D: "Pistola de pulverização arco-íris",
  T_49_META_TYPE_239_D: "Rifle de Spray",
  T_49_META_TYPE_24_D: "Tipos de danos atualmente definidos pelo sistema",
  T_49_META_TYPE_240_D: "A entidade é a portadora de todos os componentes. Os componentes devem ser anexados à entidade para gerar instâncias.",
  T_49_META_TYPE_241_D: "Pistola de gancho potente",
  T_49_META_TYPE_242_D: "Barra de Pontuação",
  T_49_META_TYPE_243_D: "Slots de roupas",
  T_49_META_TYPE_244_D: "Uma entidade de texto representa um texto exibido.",
  T_49_META_TYPE_245_D: "A entidade Ícone representa um ícone exibido",
  T_49_META_TYPE_246_D: "Cor de Spray",
  T_49_META_TYPE_247_D: "Tipo de Interface do Jogador",
  T_49_META_TYPE_248_D: "Entidade de troca de interface de usuário genérica",
  T_49_META_TYPE_249_D: "Trocar Espaço de Equipamento",
  T_49_META_TYPE_25_D: "As etapas do processo do jogo, como início do jogo, preparação do jogo, fim do jogo, etc.",
  T_49_META_TYPE_250_D: "A entidade de efeito representa um efeito exibido",
  T_49_META_TYPE_2500_D: "Ponto de spawn do jogador",
  T_49_META_TYPE_2501_D: "Os gatilhos são usados para disparar eventos de entrada e saída de jogadores (ou outros objetos)",
  T_49_META_TYPE_2502_D: "Gatilho de morte ou invencibilidade, quando o jogador entra, ele controla se é efeito de morte ou invencibilidade de acordo com o atributo",
  T_49_META_TYPE_2503_D: "Pontos de verificação do modo de corrida",
  T_49_META_TYPE_2504_D: "Geralmente usado no modo de corrida para identificar o jogador entrando na linha de chegada designada. Este é um gatilho específico. Os gatilhos personalizados serão abertos mais tarde. Este endpoint é apenas um wrapper do gatilho personalizado.",
  T_49_META_TYPE_2505_D: "A cerca ao redor do ponto de spawn, depois de fechá-la, você pode sair do ponto de spawn",
  T_49_META_TYPE_2507_D: "Torre",
  T_49_META_TYPE_2508_D: "Spawn de Monstro",
  T_49_META_TYPE_2509_D: "Instâncias do tipo correspondente podem ser geradas sob demanda",
  T_49_META_TYPE_251_D: "Contêiner de Efeitos",
  T_49_META_TYPE_2510_D: "Área de spawn do jogador (retângulo)",
  T_49_META_TYPE_252_D: "UI de Resultado de Spray",
  T_49_META_TYPE_253_D: "Botão de Dica",
  T_49_META_TYPE_254_D: "Efeito de Batimento Cardíaco",
  T_49_META_TYPE_255_D: "Cadeia de localização de timestamp",
  T_49_META_TYPE_256_D: "Tipo de corpo rígido",
  T_49_META_TYPE_257_D: "Componente de corpo rígido",
  T_49_META_TYPE_258_D: "Tipo de Estilo de Formatação de Timestamp",
  T_49_META_TYPE_259_D: "Dicas",
  T_49_META_TYPE_26_D: "Uma rodada no jogo geralmente é uma rodada pequena, composta de várias etapas.",
  T_49_META_TYPE_260_D: "Botão de Habilidade de Progresso",
  T_49_META_TYPE_261_D: "ID único",
  T_49_META_TYPE_262_D: "ID da skin de arma",
  T_49_META_TYPE_263_D: "ID do vestuário",
  T_49_META_TYPE_264_D: "ID do item, quando a versão só tem ID da arma",
  T_49_META_TYPE_265_D: "Entidade do painel de interface do usuário",
  T_49_META_TYPE_267_D: "Entidade de visualização de rolagem da IU, a IU que o jogador edita por meio do editor de IU",
  T_49_META_TYPE_268_D: "Um interruptor com três estados, além de ligado e desligado, você pode optar por manter a lógica original",
  T_49_META_TYPE_269_D: "Equipamento do jogador",
  T_49_META_TYPE_270_D: "Entidade ou ID pré-fabricado",
  T_49_META_TYPE_271_D: "Entidade do painel da IU, a IU que o jogador edita por meio do editor da IU",
  T_49_META_TYPE_272_D: "Enumeração de gênero",
  T_49_META_TYPE_273_D: "Mini-Mapa",
  T_49_META_TYPE_274_D: "O ícone exibido no minimapa pode seguir o alvo",
  T_49_META_TYPE_275_D: "Nós de partes individuais em um esqueleto",
  T_49_META_TYPE_276_D: "Nó usado para acessar ossos da pele",
  T_49_META_TYPE_277_D: "Detecção de raios de câmera do lado do cliente",
  T_49_META_TYPE_278_D: "O bloco de pixels exibido no pequeno mapa representa o tamanho da colisão do objeto naquele local",
  T_49_META_TYPE_279_D: "Tambor de Cor",
  T_49_META_TYPE_28_D: "No início de cada rodada, o status será redefinido",
  T_49_META_TYPE_280_D: "Gatilho Esférico",
  T_49_META_TYPE_281_D: "Gatilho em Cápsula",
  T_49_META_TYPE_282_D: "Descreve o tipo de ID de configuração de ativo, usado para indicar o ID de configuração de ativo que vem com o pacote pai, que precisa ser analisado por meio da tabela de configuração antes do carregamento",
  T_49_META_TYPE_283_D: "Descreve o tipo de ativo, usado para representar o identificador do ativo e pode ser carregado diretamente",
  T_49_META_TYPE_284_D: "Representa um recurso de modelo humanoide que pode ser substituído por um personagem do jogador",
  T_49_META_TYPE_285_D: "Lista ou dicionário, pode ser repetido",
  T_49_META_TYPE_286_D: "Um ID que descreve o ativo do script.",
  T_49_META_TYPE_287_D: "Um ID que descreve um ativo de script estático.",
  T_49_META_TYPE_288_D: "Um ID que descreve um ativo de interface de usuário personalizado.",
  T_49_META_TYPE_289_D: "ID usado para descrever o ativo predefinido",
  T_49_META_TYPE_29_D: "Efeitos especiais",
  T_49_META_TYPE_290_D: "Árvore de comportamento",
  T_49_META_TYPE_291_D: "Tipo de Nó da Árvore de Comportamento",
  T_49_META_TYPE_292_D: "Nó Personalizado da Árvore de Comportamento",
  T_49_META_TYPE_293_D: "Árvore de Comportamento Anexável",
  T_49_META_TYPE_294_D: "Entidade de layout de IU, a IU que os jogadores editam por meio do editor de IU",
  T_49_META_TYPE_295_D: "Tempo de Espera (s)",
  T_49_META_TYPE_296_D: "Clíper de Animação",
  T_49_META_TYPE_297_D: "Controle de animação",
  T_49_META_TYPE_298_D: "Tipo de Loop",
  T_49_META_TYPE_3_D: "Tipo inteiro, inteiro assinado de 32 bits",
  T_49_META_TYPE_30_D: "Ícone",
  T_49_META_TYPE_300_D: "Entidade UI3DContainer, a IU que os jogadores editam por meio do editor de IU",
  T_49_META_TYPE_301_D: "Tipo de Habilidade de IA",
  T_49_META_TYPE_302_D: "Enumeração de slots de equipamento",
  T_49_META_TYPE_303_D: "Correspondente à coluna Id em BuffData.csv, confirme com o GPP se é aplicável antes de adicionar novos itens",
  T_49_META_TYPE_304_D: "Lista de Tipos de Bônus",
  T_49_META_TYPE_305_D: "Status do Nó da Árvore de Comportamento",
  T_49_META_TYPE_306_D: "Você pode adicionar buffs, remover buffs e obter uma lista de buffs adicionados",
  T_49_META_TYPE_307_D: "Criador de Mural de Gelo",
  T_49_META_TYPE_308_D: "Tipo de ID de Item Especial",
  T_49_META_TYPE_309_D: "Adereços de arremesso",
  T_49_META_TYPE_31_D: "Som",
  T_49_META_TYPE_310_D: "Balestra",
  T_49_META_TYPE_311_D: "Base de Granada",
  T_49_META_TYPE_312_D: "Adereços de arremesso",
  T_49_META_TYPE_313_D: "Granada DeIce Wall",
  T_49_META_TYPE_314_D: "Gerenciando controladores e recursos de animação",
  T_49_META_TYPE_315_D: "Mochila do jogador",
  T_49_META_TYPE_316_D: "Entidade UITexture, UI editada pelo jogador através do editor de UI",
  T_49_META_TYPE_317_D: "Restrições de movimento do corpo rígido, cada restrição pode ser usada em combinação",
  T_49_META_TYPE_318_D: "Acessório",
  T_49_META_TYPE_319_D: "Enumeração do tipo de preenchimento",
  T_49_META_TYPE_32_D: "Tipo de status do jogador",
  T_49_META_TYPE_320_D: "Enumeração de direção de preenchimento",
  T_49_META_TYPE_321_D: "Entidades que podem ser alvo",
  T_49_META_TYPE_322_D: "Tipo de Parte do Corpo Danificado",
  T_49_META_TYPE_323_D: "Entidade UIProfileInfo, a IU que os jogadores editam por meio do editor de IU",
  T_49_META_TYPE_324_D: "Vários efeitos diferentes de forças em corpos rígidos. Observe que isso só é válido para corpos rígidos dinâmicos.",
  T_49_META_TYPE_325_D: "O ID usado para descrever o controle no ativo de interface personalizado",
  T_49_META_TYPE_326_D: "Informações do perfil do jogador",
  T_49_META_TYPE_327_D: "Substituição de acordo com a configuração de cada componente",
  T_49_META_TYPE_328_D: "ID da Árvore de Comportamento",
  T_49_META_TYPE_329_D: "Tipo de Assento",
  T_49_META_TYPE_33_D: "Classificar por: Crescente Ignorar valores zero, Decrescente, Crescente",
  T_49_META_TYPE_330_D: "Movimento em relação a si mesmo",
  T_49_META_TYPE_331_D: "Curva de Bezier",
  T_49_META_TYPE_332_D: "Componentes recicláveis",
  T_49_META_TYPE_333_D: "Tipo de fonte",
  T_49_META_TYPE_334_D: "ID da skin de veículo",
  T_49_META_TYPE_335_D: "A entidade de efeito sonoro representa um efeito sonoro sendo reproduzido.",
  T_49_META_TYPE_336_D: "Lista de Efeitos Sonoros",
  T_49_META_TYPE_337_D: "Efeito Sonoro ou Lista de Efeitos Sonoros",
  T_49_META_TYPE_338_D: "Entidade de sincronização de atributos de comportamento do jogador",
  T_49_META_TYPE_339_D: "Acessório de Equipamento",
  T_49_META_TYPE_34_D: "ID do item",
  T_49_META_TYPE_340_D: "Tipo de Dificuldade do Bot",
  T_49_META_TYPE_341_D: "Dicionário de inteiros",
  T_49_META_TYPE_342_D: "Objeto Temporizador",
  T_49_META_TYPE_343_D: "Faca de arremesso (retirada)",
  T_49_META_TYPE_344_D: "Faca de Arremesso",
  T_49_META_TYPE_345_D: "Tipo de Arma",
  T_49_META_TYPE_346_D: "Tipo de Munição",
  T_49_META_TYPE_347_D: "Auto-Relativo por Quadro",
  T_49_META_TYPE_348_D: "O ponteiro de função aponta para uma instância de função para implementar uma função virtual ou mecanismo de delegação.",
  T_49_META_TYPE_349_D: "Refere-se ao identificador de uma corrotina e pode executar algumas operações de identificador",
  T_49_META_TYPE_350_D: "Enumeração de veículos",
  T_49_META_TYPE_351_D: "Descreve o tipo de objeto",
  T_49_META_TYPE_352_D: "Entidade UIToggle, a IU que o jogador edita por meio do editor de IU",
  T_49_META_TYPE_353_D: "Kit de Primeiros Socorros",
  T_49_META_TYPE_354_D: "Inalador",
  T_49_META_TYPE_355_D: "Linha Horizontal",
  T_49_META_TYPE_356_D: "Airdrop, após o término do tempo de preparação, ele começará a cair de um lugar alto",
  T_49_META_TYPE_357_D: "Cor descritiva de objetos, como bordas, superfícies, etc. (excluir, reciclável)",
  T_49_META_TYPE_358_D: "Refere-se a um evento",
  T_49_META_TYPE_359_D: "Controlador de jogador com efeitos físicos, pode aplicar força e receber força",
  T_49_META_TYPE_360_D: "Plataforma de Lançamento",
  T_49_META_TYPE_361_D: "O canhão dobrado pode ser usado para lançar pessoas quando desdobrado. Tenha cuidado para não se lançar para fora da zona segura!",
  T_49_META_TYPE_362_D: "Guerra de bolas de neve! Cobrar!",
  T_49_META_TYPE_363_D: "Solicitação de compra na loja",
  T_49_META_TYPE_364_D: "Gatilho de Animação",
  T_49_META_TYPE_365_D: "Componente de interface de gatilho de animação",
  T_49_META_TYPE_366_D: "Renderizador da Combinação Múltipla",
  T_49_META_TYPE_367_D: "Bússola superior",
  T_49_META_TYPE_368_D: "ID de recurso de função personalizada",
  T_49_META_TYPE_369_D: "ID do recurso de animação personalizada",
  T_49_META_TYPE_370_D: "Informações exibidas no início da rodada",
  T_49_META_TYPE_371_D: "No final de cada rodada, exiba os resultados",
  T_49_META_TYPE_372_D: "Tipo de postura do jogador",
  T_49_META_TYPE_373_D: "ID da coleção, usada para coleta de informações de recursos",
  T_49_META_TYPE_374_D: "Barra de Saúde de Acompanhamento",
  T_49_META_TYPE_375_D: "Enumeração do tipo de alvo de ataque do monstro",
  T_49_META_TYPE_376_D: "Enumeração do tipo de alvo de ataque da torre de defesa",
  T_49_META_TYPE_377_D: "Aliases para entidades de jogadores e tipos de entidades de veículos",
  T_49_META_TYPE_378_D: "Um ID que descreve o ativo de áudio.",
  T_49_META_TYPE_379_D: "O ID usado para descrever o ativo da tabela de configuração",
  T_49_META_TYPE_38_D: "Entidade de widget vazia da IU, IU editada pelo jogador por meio do editor de IU",
  T_49_META_TYPE_380_D: "Uma ID que descreve o recurso de efeito especial.",
  T_49_META_TYPE_381_D: "Um ID que descreve o ativo do controlador de animação.",
  T_49_META_TYPE_382_D: "Método de tratamento de status de knockdown",
  T_49_META_TYPE_383_D: "A superfície ou decorações do mapa",
  T_49_META_TYPE_384_D: "Itens",
  T_49_META_TYPE_385_D: "ID da habilidade do personagem",
  T_49_META_TYPE_386_D: "Lista de ID de habilidades",
  T_49_META_TYPE_387_D: "Entidade UITouchPad, a IU que o jogador edita por meio do editor de IU",
  T_49_META_TYPE_388_D: "ID da skin de Mochila",
  T_49_META_TYPE_389_D: "Entidade de joystick, UI editada pelo jogador através do editor de UI",
  T_49_META_TYPE_39_D: "Entidade de imagem da IU, IU editada pelo jogador por meio do editor de IU",
  T_49_META_TYPE_390_D: "Hierárquico",
  T_49_META_TYPE_391_D: "UI ou Widget Personalizado",
  T_49_META_TYPE_392_D: "Círculo de Veneno Objetos que podem ser colocados",
  T_49_META_TYPE_393_D: "Entidades com componentes PhysicalCCT ou Rigidbody",
  T_49_META_TYPE_394_D: "Constantes matemáticas",
  T_49_META_TYPE_395_D: "Entidades com componentes PhysicalCCT ou PlayerCCT podem se mover com eles",
  T_49_META_TYPE_396_D: "Configuração de Saída no Meio do Jogo",
  T_49_META_TYPE_397_D: "Componente usado para descrever a forma da colisão",
  T_49_META_TYPE_398_D: "Cadeia ou Cadeia Localizada",
  T_49_META_TYPE_399_D: "Controlador de personagem com efeitos físicos, apenas para personagens FF",
  T_49_META_TYPE_4_D: "Tipo de ponto flutuante, número de ponto flutuante de precisão simples de 32 bits",
  T_49_META_TYPE_40_D: "Entidade de texto da IU, IU editada pelo jogador por meio do editor de IU",
  T_49_META_TYPE_400_D: "Como se envolver em comportamento agressivo",
  T_49_META_TYPE_401_D: "Tipo de Fogo",
  T_49_META_TYPE_402_D: "Widget de Botão Social",
  T_49_META_TYPE_403_D: "Tipos de botões sociais",
  T_49_META_TYPE_404_D: "Estilos de botões sociais",
  T_49_META_TYPE_405_D: "Tipo de Ordenação de Layout",
  T_49_META_TYPE_406_D: "Pode disparar sobre obstáculos",
  T_49_META_TYPE_407_D: "Tipo de Plataforma",
  T_49_META_TYPE_408_D: "Alias de Dados Básicos",
  T_49_META_TYPE_409_D: "Enumeração de código de erro",
  T_49_META_TYPE_41_D: "Entidade de botão da IU, a IU que o jogador edita por meio do editor de IU",
  T_49_META_TYPE_410_D: "Alias para uma entidade de jogador ou tipo de entidade de transformação.",
  T_49_META_TYPE_411_D: "Veículo Helicóptero",
  T_49_META_TYPE_412_D: "O componente automóvel é a expansão funcional do componente veicular",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limite o ângulo de rotação da câmera",
  T_49_META_TYPE_415_D: "Pessoa",
  T_49_META_TYPE_416_D: "Interface da janela de bate-papo do Persona",
  T_49_META_TYPE_417_D: "Componente de entidade de partícula",
  T_49_META_TYPE_418_D: "Enumeração de status de membro",
  T_49_META_TYPE_419_D: "Tipo de pele de arma",
  T_49_META_TYPE_42_D: "Entidade de entrada da IU, a IU que o jogador edita por meio do editor de IU",
  T_49_META_TYPE_420_D: "Tipos de pele de veículos",
  T_49_META_TYPE_421_D: "Tipo de pele",
  T_49_META_TYPE_422_D: "Tipo de pele da mochila",
  T_49_META_TYPE_423_D: "ID de persona",
  T_49_META_TYPE_424_D: "Efeito de neblina tipo básico",
  T_49_META_TYPE_425_D: "ID do ativo de partícula",
  T_49_META_TYPE_426_D: "Um tipo de fonte de luz que emite luz cônica da fonte de luz para o eixo Y negativo da fonte de luz, iluminando o solo por padrão",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "As informações do traje que o jogador precisa manter ao se transformar em outro personagem",
  T_49_META_TYPE_429_D: "Entidade jogadora ou NPC",
  T_49_META_TYPE_43_D: "O tipo de elemento deve ser uma lista de entidades do jogador",
  T_49_META_TYPE_430_D: "Gerador de números aleatórios",
  T_49_META_TYPE_431_D: "O objeto em movimento se move ao longo de um caminho personalizado",
  T_49_META_TYPE_432_D: "Personalize os pontos de passagem do caminho da curva",
  T_49_META_TYPE_433_D: "Personalizar o tipo de ponto de passagem do caminho da curva",
  T_49_META_TYPE_434_D: "Caminho de curva personalizado",
  T_49_META_TYPE_435_D: "Lista de identificadores exclusivos do jogador",
  T_49_META_TYPE_436_D: "Lista de códigos de erro",
  T_49_META_TYPE_437_D: "Entidade UI de detalhes da partida para ambos os times. Modificar os atributos da entidade afetará o conteúdo de exibição na UI correspondente.",
  T_49_META_TYPE_438_D: "Entidade de IU com vários detalhes da partida da equipe, modificar os atributos da entidade afetará o conteúdo de exibição na IU correspondente",
  T_49_META_TYPE_439_D: "Capacidade",
  T_49_META_TYPE_44_D: "O tipo de elemento deve ser uma lista de entidades de equipe",
  T_49_META_TYPE_440_D: "Linha do tempo",
  T_49_META_TYPE_441_D: "ID do recurso da linha do tempo",
  T_49_META_TYPE_442_D: "Novo componente de entidade simplificado para informações de partidas entre duas equipes, suporta exibição de números totalmente personalizada",
  T_49_META_TYPE_443_D: "ID do ativo do fluxo de diálogo",
  T_49_META_TYPE_444_D: "Tipo de idioma",
  T_49_META_TYPE_45_D: "Lista de Bool",
  T_49_META_TYPE_46_D: "Lista Int",
  T_49_META_TYPE_47_D: "Lista de Flutuação",
  T_49_META_TYPE_48_D: "Lista de sentenças",
  T_49_META_TYPE_49_D: "Lista de Vetores3",
  T_49_META_TYPE_5_D: "Tipo de string, o valor é conteúdo de texto",
  T_49_META_TYPE_50_D: "O tipo de elemento deve ser uma lista de entidades",
  T_49_META_TYPE_51_D: "Tipo Zumbi",
  T_49_META_TYPE_53_D: "Objeto de Nível Comum",
  T_49_META_TYPE_54_D: "Objeto Destrutível",
  T_49_META_TYPE_55_D: "Ponto de Spawn Geral",
  T_49_META_TYPE_56_D: "Veículo",
  T_49_META_TYPE_57_D: "Os jogadores podem ser teletransportados para um local designado ao entrar",
  T_49_META_TYPE_58_D: "Buffs podem ser gerados sob demanda",
  T_49_META_TYPE_59_D: "Plataforma Móvel",
  T_49_META_TYPE_6_D: "Vetor tridimensional, que pode representar coordenadas espaciais ou direções espaciais",
  T_49_META_TYPE_60_D: "Causará a queda de uma arma do tipo selecionado",
  T_49_META_TYPE_61_D: "Entrar no intervalo de gatilho abrirá o armazenamento vinculado",
  T_49_META_TYPE_62_D: "Dados com excelente salto",
  T_49_META_TYPE_63_D: "Os jogadores serão impulsionados para o local designado quando pisarem nele",
  T_49_META_TYPE_64_D: "Quando o jogador pisa nele, ele emite um som",
  T_49_META_TYPE_65_D: "Escalável Básico",
  T_49_META_TYPE_66_D: "Caminho Personalizado",
  T_49_META_TYPE_67_D: "Ponto de Caminho",
  T_49_META_TYPE_68_D: "Entidades monstruosas de IA, como zumbis",
  T_49_META_TYPE_69_D: "Números grandes são números de ponto flutuante de alta precisão",
  T_49_META_TYPE_7_D: "Número é um alias de tipo para inteiro, inteiro de 64 bits ou tipo de ponto flutuante",
  T_49_META_TYPE_70_D: "Fórmulas de atributos são usadas para calcular valores de atributos de entidade. Atualmente, apenas alguns atributos de jogador e atributos de arma são suportados.",
  T_49_META_TYPE_71_D: "Usado somente para entidades vendidas em lojas. Bens são diferentes do conceito de itens obtidos pela compra de bens.",
  T_49_META_TYPE_72_D: "Contém vários produtos",
  T_49_META_TYPE_73_D: "Contém várias prateleiras",
  T_49_META_TYPE_74_D: "ID do item",
  T_49_META_TYPE_75_D: "Voltar",
  T_49_META_TYPE_76_D: "Estilo Patrulha",
  T_49_META_TYPE_77_D: "Uma entidade geradora que pode gerar e atualizar objetos",
  T_49_META_TYPE_78_D: "Uma entidade unitária que pode ser absorvida por geradores de unidades e gerada em lotes",
  T_49_META_TYPE_79_D: "Arma",
  T_49_META_TYPE_8_D: "As condições são do tipo Bool especial",
  T_49_META_TYPE_80_D: "Interface da loja",
  T_49_META_TYPE_81_D: "Tipo de Buff",
  T_49_META_TYPE_82_D: "Interface de Pulsação",
  T_49_META_TYPE_83_D: "Botão de Interação",
  T_49_META_TYPE_84_D: "Entidades classificáveis, capazes de serem classificadas",
  T_49_META_TYPE_85_D: "Entidades integráveis têm seus próprios integrais",
  T_49_META_TYPE_86_D: "Tipo de fator de fórmula de atributo",
  T_49_META_TYPE_87_D: "Descreve o tipo de cor RGBA, cada intervalo de valor do canal é de 0 a 255",
  T_49_META_TYPE_88_D: "Tipo de moeda, atualmente apenas o tipo de moeda base",
  T_49_META_TYPE_89_D: "Entidade monetária, usada para descrever o tipo e a quantidade de moeda",
  T_49_META_TYPE_9_D: "Um conjunto de condições",
  T_49_META_TYPE_90_D: "A entidade carteira é um contêiner para um conjunto de entidades de moeda",
  T_49_META_TYPE_91_D: "Refere-se ao tipo inteiro ou matriz de inteiros",
  T_49_META_TYPE_92_D: "Tipo de Objeto de Nível Criado Dinamicamente",
  T_49_META_TYPE_93_D: "Entidades com propriedades formuláveis",
  T_49_META_TYPE_94_D: "Método de modificação de atributo",
  T_49_META_TYPE_95_D: "Gerador de Ouro",
  T_49_META_TYPE_96_D: "Carteira",
  T_49_META_TYPE_97_D: "Posição, rotação e escala, suporte à estrutura pai-filho",
  T_49_META_TYPE_98_D: "Listar todos os tipos disponíveis",
  T_49_META_TYPE_99_D: "Objeto de Nível"
};
export {
  _ as default
};
